window.diamondData = {
  "Princess": {
    "I1": {
      "D": {
        "0.4": {
          "rap": "1,200",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "2,400",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "2,700",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "1.0": {
          "rap": "3,300",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "3,300",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "3,300",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "3,300",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "3,300",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "5,300",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.6": {
          "rap": "5,300",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.7": {
          "rap": "5,300",
          "low_price": "5,200",
          "high_price": "11,270"
        },
        "1.8": {
          "rap": "5,300",
          "low_price": "5,510",
          "high_price": "11,935"
        },
        "1.9": {
          "rap": "5,300",
          "low_price": "5,815",
          "high_price": "12,595"
        },
        "2.0": {
          "rap": "6,900",
          "low_price": "8,280",
          "high_price": "17,940"
        },
        "2.1": {
          "rap": "6,900",
          "low_price": "8,695",
          "high_price": "18,835"
        },
        "2.2": {
          "rap": "6,900",
          "low_price": "9,110",
          "high_price": "19,735"
        },
        "2.3": {
          "rap": "6,900",
          "low_price": "9,520",
          "high_price": "20,630"
        },
        "2.4": {
          "rap": "6,900",
          "low_price": "9,935",
          "high_price": "21,530"
        },
        "2.5": {
          "rap": "6,900",
          "low_price": "10,350",
          "high_price": "22,425"
        },
        "2.6": {
          "rap": "6,900",
          "low_price": "10,765",
          "high_price": "23,320"
        },
        "2.7": {
          "rap": "6,900",
          "low_price": "11,180",
          "high_price": "24,220"
        },
        "2.8": {
          "rap": "6,900",
          "low_price": "11,590",
          "high_price": "25,115"
        },
        "2.9": {
          "rap": "6,900",
          "low_price": "12,005",
          "high_price": "26,015"
        },
        "3.0": {
          "rap": "8,600",
          "low_price": "15,480",
          "high_price": "33,540"
        },
        "3.1": {
          "rap": "8,600",
          "low_price": "15,995",
          "high_price": "34,660"
        },
        "3.2": {
          "rap": "8,600",
          "low_price": "16,510",
          "high_price": "35,775"
        },
        "3.3": {
          "rap": "8,600",
          "low_price": "17,030",
          "high_price": "36,895"
        },
        "3.4": {
          "rap": "8,600",
          "low_price": "17,545",
          "high_price": "38,010"
        },
        "3.5": {
          "rap": "8,600",
          "low_price": "18,060",
          "high_price": "39,130"
        },
        "3.6": {
          "rap": "8,600",
          "low_price": "18,575",
          "high_price": "40,250"
        },
        "3.7": {
          "rap": "8,600",
          "low_price": "19,090",
          "high_price": "41,365"
        },
        "3.8": {
          "rap": "8,600",
          "low_price": "19,610",
          "high_price": "42,485"
        },
        "3.9": {
          "rap": "8,600",
          "low_price": "20,125",
          "high_price": "43,600"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,100",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "2,600",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "3,200",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "3,200",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "3,200",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "3,200",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "3,200",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "5,000",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "5,000",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "5,000",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "5,000",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "5,000",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "6,400",
          "low_price": "7,680",
          "high_price": "16,640"
        },
        "2.1": {
          "rap": "6,400",
          "low_price": "8,065",
          "high_price": "17,470"
        },
        "2.2": {
          "rap": "6,400",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "2.3": {
          "rap": "6,400",
          "low_price": "8,830",
          "high_price": "19,135"
        },
        "2.4": {
          "rap": "6,400",
          "low_price": "9,215",
          "high_price": "19,970"
        },
        "2.5": {
          "rap": "6,400",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "2.6": {
          "rap": "6,400",
          "low_price": "9,985",
          "high_price": "21,630"
        },
        "2.7": {
          "rap": "6,400",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "2.8": {
          "rap": "6,400",
          "low_price": "10,750",
          "high_price": "23,295"
        },
        "2.9": {
          "rap": "6,400",
          "low_price": "11,135",
          "high_price": "24,130"
        },
        "3.0": {
          "rap": "8,000",
          "low_price": "14,400",
          "high_price": "31,200"
        },
        "3.1": {
          "rap": "8,000",
          "low_price": "14,880",
          "high_price": "32,240"
        },
        "3.2": {
          "rap": "8,000",
          "low_price": "15,360",
          "high_price": "33,280"
        },
        "3.3": {
          "rap": "8,000",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "3.4": {
          "rap": "8,000",
          "low_price": "16,320",
          "high_price": "35,360"
        },
        "3.5": {
          "rap": "8,000",
          "low_price": "16,800",
          "high_price": "36,400"
        },
        "3.6": {
          "rap": "8,000",
          "low_price": "17,280",
          "high_price": "37,440"
        },
        "3.7": {
          "rap": "8,000",
          "low_price": "17,760",
          "high_price": "38,480"
        },
        "3.8": {
          "rap": "8,000",
          "low_price": "18,240",
          "high_price": "39,520"
        },
        "3.9": {
          "rap": "8,000",
          "low_price": "18,720",
          "high_price": "40,560"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,000",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,500",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,200",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,200",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,500",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "1.0": {
          "rap": "3,100",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "1.1": {
          "rap": "3,100",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.2": {
          "rap": "3,100",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.3": {
          "rap": "3,100",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.4": {
          "rap": "3,100",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "1.5": {
          "rap": "4,700",
          "low_price": "4,050",
          "high_price": "8,775"
        },
        "1.6": {
          "rap": "4,700",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.7": {
          "rap": "4,700",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.8": {
          "rap": "4,700",
          "low_price": "4,860",
          "high_price": "10,530"
        },
        "1.9": {
          "rap": "4,700",
          "low_price": "5,130",
          "high_price": "11,115"
        },
        "2.0": {
          "rap": "5,900",
          "low_price": "7,080",
          "high_price": "15,340"
        },
        "2.1": {
          "rap": "5,900",
          "low_price": "7,435",
          "high_price": "16,105"
        },
        "2.2": {
          "rap": "5,900",
          "low_price": "7,790",
          "high_price": "16,875"
        },
        "2.3": {
          "rap": "5,900",
          "low_price": "8,140",
          "high_price": "17,640"
        },
        "2.4": {
          "rap": "5,900",
          "low_price": "8,495",
          "high_price": "18,410"
        },
        "2.5": {
          "rap": "5,900",
          "low_price": "8,850",
          "high_price": "19,175"
        },
        "2.6": {
          "rap": "5,900",
          "low_price": "9,205",
          "high_price": "19,940"
        },
        "2.7": {
          "rap": "5,900",
          "low_price": "9,560",
          "high_price": "20,710"
        },
        "2.8": {
          "rap": "5,900",
          "low_price": "9,910",
          "high_price": "21,475"
        },
        "2.9": {
          "rap": "5,900",
          "low_price": "10,265",
          "high_price": "22,245"
        },
        "3.0": {
          "rap": "7,400",
          "low_price": "13,320",
          "high_price": "28,860"
        },
        "3.1": {
          "rap": "7,400",
          "low_price": "13,765",
          "high_price": "29,820"
        },
        "3.2": {
          "rap": "7,400",
          "low_price": "14,210",
          "high_price": "30,785"
        },
        "3.3": {
          "rap": "7,400",
          "low_price": "14,650",
          "high_price": "31,745"
        },
        "3.4": {
          "rap": "7,400",
          "low_price": "15,095",
          "high_price": "32,710"
        },
        "3.5": {
          "rap": "7,400",
          "low_price": "15,540",
          "high_price": "33,670"
        },
        "3.6": {
          "rap": "7,400",
          "low_price": "15,985",
          "high_price": "34,630"
        },
        "3.7": {
          "rap": "7,400",
          "low_price": "16,430",
          "high_price": "35,595"
        },
        "3.8": {
          "rap": "7,400",
          "low_price": "16,870",
          "high_price": "36,555"
        },
        "3.9": {
          "rap": "7,400",
          "low_price": "17,315",
          "high_price": "37,520"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,000",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,400",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "2,900",
          "low_price": "1,560",
          "high_price": "3,380"
        },
        "1.1": {
          "rap": "2,900",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.2": {
          "rap": "2,900",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.3": {
          "rap": "2,900",
          "low_price": "2,030",
          "high_price": "4,395"
        },
        "1.4": {
          "rap": "2,900",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.5": {
          "rap": "4,400",
          "low_price": "3,780",
          "high_price": "8,190"
        },
        "1.6": {
          "rap": "4,400",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.7": {
          "rap": "4,400",
          "low_price": "4,285",
          "high_price": "9,280"
        },
        "1.8": {
          "rap": "4,400",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.9": {
          "rap": "4,400",
          "low_price": "4,790",
          "high_price": "10,375"
        },
        "2.0": {
          "rap": "5,500",
          "low_price": "6,600",
          "high_price": "14,300"
        },
        "2.1": {
          "rap": "5,500",
          "low_price": "6,930",
          "high_price": "15,015"
        },
        "2.2": {
          "rap": "5,500",
          "low_price": "7,260",
          "high_price": "15,730"
        },
        "2.3": {
          "rap": "5,500",
          "low_price": "7,590",
          "high_price": "16,445"
        },
        "2.4": {
          "rap": "5,500",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.5": {
          "rap": "5,500",
          "low_price": "8,250",
          "high_price": "17,875"
        },
        "2.6": {
          "rap": "5,500",
          "low_price": "8,580",
          "high_price": "18,590"
        },
        "2.7": {
          "rap": "5,500",
          "low_price": "8,910",
          "high_price": "19,305"
        },
        "2.8": {
          "rap": "5,500",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.9": {
          "rap": "5,500",
          "low_price": "9,570",
          "high_price": "20,735"
        },
        "3.0": {
          "rap": "6,700",
          "low_price": "12,060",
          "high_price": "26,130"
        },
        "3.1": {
          "rap": "6,700",
          "low_price": "12,460",
          "high_price": "27,000"
        },
        "3.2": {
          "rap": "6,700",
          "low_price": "12,865",
          "high_price": "27,870"
        },
        "3.3": {
          "rap": "6,700",
          "low_price": "13,265",
          "high_price": "28,745"
        },
        "3.4": {
          "rap": "6,700",
          "low_price": "13,670",
          "high_price": "29,615"
        },
        "3.5": {
          "rap": "6,700",
          "low_price": "14,070",
          "high_price": "30,485"
        },
        "3.6": {
          "rap": "6,700",
          "low_price": "14,470",
          "high_price": "31,355"
        },
        "3.7": {
          "rap": "6,700",
          "low_price": "14,875",
          "high_price": "32,225"
        },
        "3.8": {
          "rap": "6,700",
          "low_price": "15,275",
          "high_price": "33,100"
        },
        "3.9": {
          "rap": "6,700",
          "low_price": "15,680",
          "high_price": "33,970"
        }
      },
      "H": {
        "0.4": {
          "rap": "900",
          "low_price": "215",
          "high_price": "470"
        },
        "0.5": {
          "rap": "1,300",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,300",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "2,000",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.8": {
          "rap": "2,000",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.9": {
          "rap": "2,300",
          "low_price": "1,080",
          "high_price": "2,340"
        },
        "1.0": {
          "rap": "2,700",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "1.1": {
          "rap": "2,700",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.2": {
          "rap": "2,700",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.3": {
          "rap": "2,700",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.4": {
          "rap": "2,700",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.5": {
          "rap": "4,100",
          "low_price": "3,510",
          "high_price": "7,605"
        },
        "1.6": {
          "rap": "4,100",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.7": {
          "rap": "4,100",
          "low_price": "3,980",
          "high_price": "8,620"
        },
        "1.8": {
          "rap": "4,100",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.9": {
          "rap": "4,100",
          "low_price": "4,445",
          "high_price": "9,635"
        },
        "2.0": {
          "rap": "5,100",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "2.1": {
          "rap": "5,100",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "2.2": {
          "rap": "5,100",
          "low_price": "6,730",
          "high_price": "14,585"
        },
        "2.3": {
          "rap": "5,100",
          "low_price": "7,040",
          "high_price": "15,250"
        },
        "2.4": {
          "rap": "5,100",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "2.5": {
          "rap": "5,100",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "2.6": {
          "rap": "5,100",
          "low_price": "7,955",
          "high_price": "17,240"
        },
        "2.7": {
          "rap": "5,100",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "2.8": {
          "rap": "5,100",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "2.9": {
          "rap": "5,100",
          "low_price": "8,875",
          "high_price": "19,225"
        },
        "3.0": {
          "rap": "6,200",
          "low_price": "11,160",
          "high_price": "24,180"
        },
        "3.1": {
          "rap": "6,200",
          "low_price": "11,530",
          "high_price": "24,985"
        },
        "3.2": {
          "rap": "6,200",
          "low_price": "11,905",
          "high_price": "25,790"
        },
        "3.3": {
          "rap": "6,200",
          "low_price": "12,275",
          "high_price": "26,600"
        },
        "3.4": {
          "rap": "6,200",
          "low_price": "12,650",
          "high_price": "27,405"
        },
        "3.5": {
          "rap": "6,200",
          "low_price": "13,020",
          "high_price": "28,210"
        },
        "3.6": {
          "rap": "6,200",
          "low_price": "13,390",
          "high_price": "29,015"
        },
        "3.7": {
          "rap": "6,200",
          "low_price": "13,765",
          "high_price": "29,820"
        },
        "3.8": {
          "rap": "6,200",
          "low_price": "14,135",
          "high_price": "30,630"
        },
        "3.9": {
          "rap": "6,200",
          "low_price": "14,510",
          "high_price": "31,435"
        }
      },
      "I": {
        "0.4": {
          "rap": "800",
          "low_price": "190",
          "high_price": "415"
        },
        "0.5": {
          "rap": "1,200",
          "low_price": "330",
          "high_price": "715"
        },
        "0.6": {
          "rap": "1,200",
          "low_price": "395",
          "high_price": "860"
        },
        "0.7": {
          "rap": "1,800",
          "low_price": "590",
          "high_price": "1,275"
        },
        "0.8": {
          "rap": "1,800",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.9": {
          "rap": "2,100",
          "low_price": "1,025",
          "high_price": "2,225"
        },
        "1.0": {
          "rap": "2,500",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "1.1": {
          "rap": "2,500",
          "low_price": "1,450",
          "high_price": "3,145"
        },
        "1.2": {
          "rap": "2,500",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.3": {
          "rap": "2,500",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.4": {
          "rap": "2,500",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.5": {
          "rap": "3,800",
          "low_price": "3,240",
          "high_price": "7,020"
        },
        "1.6": {
          "rap": "3,800",
          "low_price": "3,455",
          "high_price": "7,490"
        },
        "1.7": {
          "rap": "3,800",
          "low_price": "3,670",
          "high_price": "7,955"
        },
        "1.8": {
          "rap": "3,800",
          "low_price": "3,890",
          "high_price": "8,425"
        },
        "1.9": {
          "rap": "3,800",
          "low_price": "4,105",
          "high_price": "8,890"
        },
        "2.0": {
          "rap": "4,800",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "2.1": {
          "rap": "4,800",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "2.2": {
          "rap": "4,800",
          "low_price": "6,335",
          "high_price": "13,730"
        },
        "2.3": {
          "rap": "4,800",
          "low_price": "6,625",
          "high_price": "14,350"
        },
        "2.4": {
          "rap": "4,800",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "2.5": {
          "rap": "4,800",
          "low_price": "7,200",
          "high_price": "15,600"
        },
        "2.6": {
          "rap": "4,800",
          "low_price": "7,490",
          "high_price": "16,225"
        },
        "2.7": {
          "rap": "4,800",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "2.8": {
          "rap": "4,800",
          "low_price": "8,065",
          "high_price": "17,470"
        },
        "2.9": {
          "rap": "4,800",
          "low_price": "8,350",
          "high_price": "18,095"
        },
        "3.0": {
          "rap": "5,700",
          "low_price": "10,260",
          "high_price": "22,230"
        },
        "3.1": {
          "rap": "5,700",
          "low_price": "10,600",
          "high_price": "22,970"
        },
        "3.2": {
          "rap": "5,700",
          "low_price": "10,945",
          "high_price": "23,710"
        },
        "3.3": {
          "rap": "5,700",
          "low_price": "11,285",
          "high_price": "24,455"
        },
        "3.4": {
          "rap": "5,700",
          "low_price": "11,630",
          "high_price": "25,195"
        },
        "3.5": {
          "rap": "5,700",
          "low_price": "11,970",
          "high_price": "25,935"
        },
        "3.6": {
          "rap": "5,700",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "3.7": {
          "rap": "5,700",
          "low_price": "12,655",
          "high_price": "27,415"
        },
        "3.8": {
          "rap": "5,700",
          "low_price": "12,995",
          "high_price": "28,160"
        },
        "3.9": {
          "rap": "5,700",
          "low_price": "13,340",
          "high_price": "28,900"
        }
      },
      "J": {
        "0.4": {
          "rap": "700",
          "low_price": "170",
          "high_price": "365"
        },
        "0.5": {
          "rap": "1,100",
          "low_price": "300",
          "high_price": "650"
        },
        "0.6": {
          "rap": "1,100",
          "low_price": "360",
          "high_price": "780"
        },
        "0.7": {
          "rap": "1,500",
          "low_price": "545",
          "high_price": "1,185"
        },
        "0.8": {
          "rap": "1,500",
          "low_price": "625",
          "high_price": "1,350"
        },
        "0.9": {
          "rap": "1,900",
          "low_price": "920",
          "high_price": "1,990"
        },
        "1.0": {
          "rap": "2,200",
          "low_price": "1,140",
          "high_price": "2,470"
        },
        "1.1": {
          "rap": "2,200",
          "low_price": "1,255",
          "high_price": "2,715"
        },
        "1.2": {
          "rap": "2,200",
          "low_price": "1,370",
          "high_price": "2,965"
        },
        "1.3": {
          "rap": "2,200",
          "low_price": "1,480",
          "high_price": "3,210"
        },
        "1.4": {
          "rap": "2,200",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "1.5": {
          "rap": "3,500",
          "low_price": "2,970",
          "high_price": "6,435"
        },
        "1.6": {
          "rap": "3,500",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.7": {
          "rap": "3,500",
          "low_price": "3,365",
          "high_price": "7,295"
        },
        "1.8": {
          "rap": "3,500",
          "low_price": "3,565",
          "high_price": "7,720"
        },
        "1.9": {
          "rap": "3,500",
          "low_price": "3,760",
          "high_price": "8,150"
        },
        "2.0": {
          "rap": "4,500",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "2.1": {
          "rap": "4,500",
          "low_price": "5,670",
          "high_price": "12,285"
        },
        "2.2": {
          "rap": "4,500",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "2.3": {
          "rap": "4,500",
          "low_price": "6,210",
          "high_price": "13,455"
        },
        "2.4": {
          "rap": "4,500",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "2.5": {
          "rap": "4,500",
          "low_price": "6,750",
          "high_price": "14,625"
        },
        "2.6": {
          "rap": "4,500",
          "low_price": "7,020",
          "high_price": "15,210"
        },
        "2.7": {
          "rap": "4,500",
          "low_price": "7,290",
          "high_price": "15,795"
        },
        "2.8": {
          "rap": "4,500",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.9": {
          "rap": "4,500",
          "low_price": "7,830",
          "high_price": "16,965"
        },
        "3.0": {
          "rap": "5,400",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "3.1": {
          "rap": "5,400",
          "low_price": "10,045",
          "high_price": "21,760"
        },
        "3.2": {
          "rap": "5,400",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "3.3": {
          "rap": "5,400",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "3.4": {
          "rap": "5,400",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "3.5": {
          "rap": "5,400",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "3.6": {
          "rap": "5,400",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "3.7": {
          "rap": "5,400",
          "low_price": "11,990",
          "high_price": "25,975"
        },
        "3.8": {
          "rap": "5,400",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "3.9": {
          "rap": "5,400",
          "low_price": "12,635",
          "high_price": "27,380"
        }
      },
      "K": {
        "0.4": {
          "rap": "700",
          "low_price": "170",
          "high_price": "365"
        },
        "0.5": {
          "rap": "900",
          "low_price": "270",
          "high_price": "585"
        },
        "0.6": {
          "rap": "900",
          "low_price": "325",
          "high_price": "700"
        },
        "0.7": {
          "rap": "1,400",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.8": {
          "rap": "1,400",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.9": {
          "rap": "1,600",
          "low_price": "810",
          "high_price": "1,755"
        },
        "1.0": {
          "rap": "1,900",
          "low_price": "1,020",
          "high_price": "2,210"
        },
        "1.1": {
          "rap": "1,900",
          "low_price": "1,120",
          "high_price": "2,430"
        },
        "1.2": {
          "rap": "1,900",
          "low_price": "1,225",
          "high_price": "2,650"
        },
        "1.3": {
          "rap": "1,900",
          "low_price": "1,325",
          "high_price": "2,875"
        },
        "1.4": {
          "rap": "1,900",
          "low_price": "1,430",
          "high_price": "3,095"
        },
        "1.5": {
          "rap": "3,200",
          "low_price": "2,610",
          "high_price": "5,655"
        },
        "1.6": {
          "rap": "3,200",
          "low_price": "2,785",
          "high_price": "6,030"
        },
        "1.7": {
          "rap": "3,200",
          "low_price": "2,960",
          "high_price": "6,410"
        },
        "1.8": {
          "rap": "3,200",
          "low_price": "3,130",
          "high_price": "6,785"
        },
        "1.9": {
          "rap": "3,200",
          "low_price": "3,305",
          "high_price": "7,165"
        },
        "2.0": {
          "rap": "3,900",
          "low_price": "4,440",
          "high_price": "9,620"
        },
        "2.1": {
          "rap": "3,900",
          "low_price": "4,660",
          "high_price": "10,100"
        },
        "2.2": {
          "rap": "3,900",
          "low_price": "4,885",
          "high_price": "10,580"
        },
        "2.3": {
          "rap": "3,900",
          "low_price": "5,105",
          "high_price": "11,065"
        },
        "2.4": {
          "rap": "3,900",
          "low_price": "5,330",
          "high_price": "11,545"
        },
        "2.5": {
          "rap": "3,900",
          "low_price": "5,550",
          "high_price": "12,025"
        },
        "2.6": {
          "rap": "3,900",
          "low_price": "5,770",
          "high_price": "12,505"
        },
        "2.7": {
          "rap": "3,900",
          "low_price": "5,995",
          "high_price": "12,985"
        },
        "2.8": {
          "rap": "3,900",
          "low_price": "6,215",
          "high_price": "13,470"
        },
        "2.9": {
          "rap": "3,900",
          "low_price": "6,440",
          "high_price": "13,950"
        },
        "3.0": {
          "rap": "5,000",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "3.1": {
          "rap": "5,000",
          "low_price": "9,300",
          "high_price": "20,150"
        },
        "3.2": {
          "rap": "5,000",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "3.3": {
          "rap": "5,000",
          "low_price": "9,900",
          "high_price": "21,450"
        },
        "3.4": {
          "rap": "5,000",
          "low_price": "10,200",
          "high_price": "22,100"
        },
        "3.5": {
          "rap": "5,000",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "3.6": {
          "rap": "5,000",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "3.7": {
          "rap": "5,000",
          "low_price": "11,100",
          "high_price": "24,050"
        },
        "3.8": {
          "rap": "5,000",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "3.9": {
          "rap": "5,000",
          "low_price": "11,700",
          "high_price": "25,350"
        }
      }
    },
    "IF": {
      "D": {
        "0.4": {
          "rap": "3,300",
          "low_price": "695",
          "high_price": "1,510"
        },
        "0.5": {
          "rap": "4,100",
          "low_price": "990",
          "high_price": "2,145"
        },
        "0.6": {
          "rap": "4,100",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "0.7": {
          "rap": "6,200",
          "low_price": "1,975",
          "high_price": "4,275"
        },
        "0.8": {
          "rap": "6,200",
          "low_price": "2,255",
          "high_price": "4,890"
        },
        "0.9": {
          "rap": "9,200",
          "low_price": "3,620",
          "high_price": "7,840"
        },
        "1.0": {
          "rap": "12,500",
          "low_price": "5,580",
          "high_price": "12,090"
        },
        "1.1": {
          "rap": "12,500",
          "low_price": "6,140",
          "high_price": "13,300"
        },
        "1.2": {
          "rap": "12,500",
          "low_price": "6,695",
          "high_price": "14,510"
        },
        "1.3": {
          "rap": "12,500",
          "low_price": "7,255",
          "high_price": "15,715"
        },
        "1.4": {
          "rap": "12,500",
          "low_price": "7,810",
          "high_price": "16,925"
        },
        "1.5": {
          "rap": "18,200",
          "low_price": "12,690",
          "high_price": "27,495"
        },
        "1.6": {
          "rap": "18,200",
          "low_price": "13,535",
          "high_price": "29,330"
        },
        "1.7": {
          "rap": "18,200",
          "low_price": "14,380",
          "high_price": "31,160"
        },
        "1.8": {
          "rap": "18,200",
          "low_price": "15,230",
          "high_price": "32,995"
        },
        "1.9": {
          "rap": "18,200",
          "low_price": "16,075",
          "high_price": "34,825"
        },
        "2.0": {
          "rap": "25,500",
          "low_price": "25,800",
          "high_price": "55,900"
        },
        "2.1": {
          "rap": "25,500",
          "low_price": "27,090",
          "high_price": "58,695"
        },
        "2.2": {
          "rap": "25,500",
          "low_price": "28,380",
          "high_price": "61,490"
        },
        "2.3": {
          "rap": "25,500",
          "low_price": "29,670",
          "high_price": "64,285"
        },
        "2.4": {
          "rap": "25,500",
          "low_price": "30,960",
          "high_price": "67,080"
        },
        "2.5": {
          "rap": "25,500",
          "low_price": "32,250",
          "high_price": "69,875"
        },
        "2.6": {
          "rap": "25,500",
          "low_price": "33,540",
          "high_price": "72,670"
        },
        "2.7": {
          "rap": "25,500",
          "low_price": "34,830",
          "high_price": "75,465"
        },
        "2.8": {
          "rap": "25,500",
          "low_price": "36,120",
          "high_price": "78,260"
        },
        "2.9": {
          "rap": "25,500",
          "low_price": "37,410",
          "high_price": "81,055"
        },
        "3.0": {
          "rap": "46,000",
          "low_price": "75,600",
          "high_price": "163,800"
        },
        "3.1": {
          "rap": "46,000",
          "low_price": "78,120",
          "high_price": "169,260"
        },
        "3.2": {
          "rap": "46,000",
          "low_price": "80,640",
          "high_price": "174,720"
        },
        "3.3": {
          "rap": "46,000",
          "low_price": "83,160",
          "high_price": "180,180"
        },
        "3.4": {
          "rap": "46,000",
          "low_price": "85,680",
          "high_price": "185,640"
        },
        "3.5": {
          "rap": "46,000",
          "low_price": "88,200",
          "high_price": "191,100"
        },
        "3.6": {
          "rap": "46,000",
          "low_price": "90,720",
          "high_price": "196,560"
        },
        "3.7": {
          "rap": "46,000",
          "low_price": "93,240",
          "high_price": "202,020"
        },
        "3.8": {
          "rap": "46,000",
          "low_price": "95,760",
          "high_price": "207,480"
        },
        "3.9": {
          "rap": "46,000",
          "low_price": "98,280",
          "high_price": "212,940"
        }
      },
      "E": {
        "0.4": {
          "rap": "3,100",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.5": {
          "rap": "3,600",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.6": {
          "rap": "3,600",
          "low_price": "1,080",
          "high_price": "2,340"
        },
        "0.7": {
          "rap": "5,600",
          "low_price": "1,805",
          "high_price": "3,915"
        },
        "0.8": {
          "rap": "5,600",
          "low_price": "2,065",
          "high_price": "4,470"
        },
        "0.9": {
          "rap": "7,700",
          "low_price": "3,350",
          "high_price": "7,255"
        },
        "1.0": {
          "rap": "10,400",
          "low_price": "4,920",
          "high_price": "10,660"
        },
        "1.1": {
          "rap": "10,400",
          "low_price": "5,410",
          "high_price": "11,725"
        },
        "1.2": {
          "rap": "10,400",
          "low_price": "5,905",
          "high_price": "12,790"
        },
        "1.3": {
          "rap": "10,400",
          "low_price": "6,395",
          "high_price": "13,860"
        },
        "1.4": {
          "rap": "10,400",
          "low_price": "6,890",
          "high_price": "14,925"
        },
        "1.5": {
          "rap": "16,400",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "1.6": {
          "rap": "16,400",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "1.7": {
          "rap": "16,400",
          "low_price": "13,465",
          "high_price": "29,170"
        },
        "1.8": {
          "rap": "16,400",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "1.9": {
          "rap": "16,400",
          "low_price": "15,050",
          "high_price": "32,605"
        },
        "2.0": {
          "rap": "23,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.1": {
          "rap": "23,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.2": {
          "rap": "23,000",
          "low_price": "26,400",
          "high_price": "57,200"
        },
        "2.3": {
          "rap": "23,000",
          "low_price": "27,600",
          "high_price": "59,800"
        },
        "2.4": {
          "rap": "23,000",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "2.5": {
          "rap": "23,000",
          "low_price": "30,000",
          "high_price": "65,000"
        },
        "2.6": {
          "rap": "23,000",
          "low_price": "31,200",
          "high_price": "67,600"
        },
        "2.7": {
          "rap": "23,000",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "2.8": {
          "rap": "23,000",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "2.9": {
          "rap": "23,000",
          "low_price": "34,800",
          "high_price": "75,400"
        },
        "3.0": {
          "rap": "37,500",
          "low_price": "65,700",
          "high_price": "142,350"
        },
        "3.1": {
          "rap": "37,500",
          "low_price": "67,890",
          "high_price": "147,095"
        },
        "3.2": {
          "rap": "37,500",
          "low_price": "70,080",
          "high_price": "151,840"
        },
        "3.3": {
          "rap": "37,500",
          "low_price": "72,270",
          "high_price": "156,585"
        },
        "3.4": {
          "rap": "37,500",
          "low_price": "74,460",
          "high_price": "161,330"
        },
        "3.5": {
          "rap": "37,500",
          "low_price": "76,650",
          "high_price": "166,075"
        },
        "3.6": {
          "rap": "37,500",
          "low_price": "78,840",
          "high_price": "170,820"
        },
        "3.7": {
          "rap": "37,500",
          "low_price": "81,030",
          "high_price": "175,565"
        },
        "3.8": {
          "rap": "37,500",
          "low_price": "83,220",
          "high_price": "180,310"
        },
        "3.9": {
          "rap": "37,500",
          "low_price": "85,410",
          "high_price": "185,055"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,900",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.5": {
          "rap": "3,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.6": {
          "rap": "3,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.7": {
          "rap": "5,300",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.8": {
          "rap": "5,300",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "0.9": {
          "rap": "6,900",
          "low_price": "2,970",
          "high_price": "6,435"
        },
        "1.0": {
          "rap": "9,400",
          "low_price": "4,440",
          "high_price": "9,620"
        },
        "1.1": {
          "rap": "9,400",
          "low_price": "4,885",
          "high_price": "10,580"
        },
        "1.2": {
          "rap": "9,400",
          "low_price": "5,330",
          "high_price": "11,545"
        },
        "1.3": {
          "rap": "9,400",
          "low_price": "5,770",
          "high_price": "12,505"
        },
        "1.4": {
          "rap": "9,400",
          "low_price": "6,215",
          "high_price": "13,470"
        },
        "1.5": {
          "rap": "14,300",
          "low_price": "11,070",
          "high_price": "23,985"
        },
        "1.6": {
          "rap": "14,300",
          "low_price": "11,810",
          "high_price": "25,585"
        },
        "1.7": {
          "rap": "14,300",
          "low_price": "12,545",
          "high_price": "27,185"
        },
        "1.8": {
          "rap": "14,300",
          "low_price": "13,285",
          "high_price": "28,780"
        },
        "1.9": {
          "rap": "14,300",
          "low_price": "14,020",
          "high_price": "30,380"
        },
        "2.0": {
          "rap": "20,500",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "2.1": {
          "rap": "20,500",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "2.2": {
          "rap": "20,500",
          "low_price": "24,420",
          "high_price": "52,910"
        },
        "2.3": {
          "rap": "20,500",
          "low_price": "25,530",
          "high_price": "55,315"
        },
        "2.4": {
          "rap": "20,500",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "2.5": {
          "rap": "20,500",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "2.6": {
          "rap": "20,500",
          "low_price": "28,860",
          "high_price": "62,530"
        },
        "2.7": {
          "rap": "20,500",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "2.8": {
          "rap": "20,500",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "2.9": {
          "rap": "20,500",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.0": {
          "rap": "33,500",
          "low_price": "58,500",
          "high_price": "126,750"
        },
        "3.1": {
          "rap": "33,500",
          "low_price": "60,450",
          "high_price": "130,975"
        },
        "3.2": {
          "rap": "33,500",
          "low_price": "62,400",
          "high_price": "135,200"
        },
        "3.3": {
          "rap": "33,500",
          "low_price": "64,350",
          "high_price": "139,425"
        },
        "3.4": {
          "rap": "33,500",
          "low_price": "66,300",
          "high_price": "143,650"
        },
        "3.5": {
          "rap": "33,500",
          "low_price": "68,250",
          "high_price": "147,875"
        },
        "3.6": {
          "rap": "33,500",
          "low_price": "70,200",
          "high_price": "152,100"
        },
        "3.7": {
          "rap": "33,500",
          "low_price": "72,150",
          "high_price": "156,325"
        },
        "3.8": {
          "rap": "33,500",
          "low_price": "74,100",
          "high_price": "160,550"
        },
        "3.9": {
          "rap": "33,500",
          "low_price": "76,050",
          "high_price": "164,775"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,700",
          "low_price": "550",
          "high_price": "1,195"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,555",
          "high_price": "3,365"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,775",
          "high_price": "3,850"
        },
        "0.9": {
          "rap": "6,200",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "8,100",
          "low_price": "3,960",
          "high_price": "8,580"
        },
        "1.1": {
          "rap": "8,100",
          "low_price": "4,355",
          "high_price": "9,440"
        },
        "1.2": {
          "rap": "8,100",
          "low_price": "4,750",
          "high_price": "10,295"
        },
        "1.3": {
          "rap": "8,100",
          "low_price": "5,150",
          "high_price": "11,155"
        },
        "1.4": {
          "rap": "8,100",
          "low_price": "5,545",
          "high_price": "12,010"
        },
        "1.5": {
          "rap": "12,700",
          "low_price": "9,810",
          "high_price": "21,255"
        },
        "1.6": {
          "rap": "12,700",
          "low_price": "10,465",
          "high_price": "22,670"
        },
        "1.7": {
          "rap": "12,700",
          "low_price": "11,120",
          "high_price": "24,090"
        },
        "1.8": {
          "rap": "12,700",
          "low_price": "11,770",
          "high_price": "25,505"
        },
        "1.9": {
          "rap": "12,700",
          "low_price": "12,425",
          "high_price": "26,925"
        },
        "2.0": {
          "rap": "18,500",
          "low_price": "20,400",
          "high_price": "44,200"
        },
        "2.1": {
          "rap": "18,500",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "2.2": {
          "rap": "18,500",
          "low_price": "22,440",
          "high_price": "48,620"
        },
        "2.3": {
          "rap": "18,500",
          "low_price": "23,460",
          "high_price": "50,830"
        },
        "2.4": {
          "rap": "18,500",
          "low_price": "24,480",
          "high_price": "53,040"
        },
        "2.5": {
          "rap": "18,500",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "2.6": {
          "rap": "18,500",
          "low_price": "26,520",
          "high_price": "57,460"
        },
        "2.7": {
          "rap": "18,500",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "2.8": {
          "rap": "18,500",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "2.9": {
          "rap": "18,500",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.0": {
          "rap": "30,000",
          "low_price": "52,200",
          "high_price": "113,100"
        },
        "3.1": {
          "rap": "30,000",
          "low_price": "53,940",
          "high_price": "116,870"
        },
        "3.2": {
          "rap": "30,000",
          "low_price": "55,680",
          "high_price": "120,640"
        },
        "3.3": {
          "rap": "30,000",
          "low_price": "57,420",
          "high_price": "124,410"
        },
        "3.4": {
          "rap": "30,000",
          "low_price": "59,160",
          "high_price": "128,180"
        },
        "3.5": {
          "rap": "30,000",
          "low_price": "60,900",
          "high_price": "131,950"
        },
        "3.6": {
          "rap": "30,000",
          "low_price": "62,640",
          "high_price": "135,720"
        },
        "3.7": {
          "rap": "30,000",
          "low_price": "64,380",
          "high_price": "139,490"
        },
        "3.8": {
          "rap": "30,000",
          "low_price": "66,120",
          "high_price": "143,260"
        },
        "3.9": {
          "rap": "30,000",
          "low_price": "67,860",
          "high_price": "147,030"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,400",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.5": {
          "rap": "2,900",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "2,900",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "4,600",
          "low_price": "1,430",
          "high_price": "3,095"
        },
        "0.8": {
          "rap": "4,600",
          "low_price": "1,630",
          "high_price": "3,535"
        },
        "0.9": {
          "rap": "5,600",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.0": {
          "rap": "6,900",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "1.1": {
          "rap": "6,900",
          "low_price": "3,695",
          "high_price": "8,010"
        },
        "1.2": {
          "rap": "6,900",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.3": {
          "rap": "6,900",
          "low_price": "4,370",
          "high_price": "9,465"
        },
        "1.4": {
          "rap": "6,900",
          "low_price": "4,705",
          "high_price": "10,190"
        },
        "1.5": {
          "rap": "10,700",
          "low_price": "8,280",
          "high_price": "17,940"
        },
        "1.6": {
          "rap": "10,700",
          "low_price": "8,830",
          "high_price": "19,135"
        },
        "1.7": {
          "rap": "10,700",
          "low_price": "9,385",
          "high_price": "20,330"
        },
        "1.8": {
          "rap": "10,700",
          "low_price": "9,935",
          "high_price": "21,530"
        },
        "1.9": {
          "rap": "10,700",
          "low_price": "10,490",
          "high_price": "22,725"
        },
        "2.0": {
          "rap": "15,000",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.1": {
          "rap": "15,000",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "2.2": {
          "rap": "15,000",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.3": {
          "rap": "15,000",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.4": {
          "rap": "15,000",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.5": {
          "rap": "15,000",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.6": {
          "rap": "15,000",
          "low_price": "21,060",
          "high_price": "45,630"
        },
        "2.7": {
          "rap": "15,000",
          "low_price": "21,870",
          "high_price": "47,385"
        },
        "2.8": {
          "rap": "15,000",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.9": {
          "rap": "15,000",
          "low_price": "23,490",
          "high_price": "50,895"
        },
        "3.0": {
          "rap": "24,500",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.1": {
          "rap": "24,500",
          "low_price": "44,640",
          "high_price": "96,720"
        },
        "3.2": {
          "rap": "24,500",
          "low_price": "46,080",
          "high_price": "99,840"
        },
        "3.3": {
          "rap": "24,500",
          "low_price": "47,520",
          "high_price": "102,960"
        },
        "3.4": {
          "rap": "24,500",
          "low_price": "48,960",
          "high_price": "106,080"
        },
        "3.5": {
          "rap": "24,500",
          "low_price": "50,400",
          "high_price": "109,200"
        },
        "3.6": {
          "rap": "24,500",
          "low_price": "51,840",
          "high_price": "112,320"
        },
        "3.7": {
          "rap": "24,500",
          "low_price": "53,280",
          "high_price": "115,440"
        },
        "3.8": {
          "rap": "24,500",
          "low_price": "54,720",
          "high_price": "118,560"
        },
        "3.9": {
          "rap": "24,500",
          "low_price": "56,160",
          "high_price": "121,680"
        }
      },
      "I": {
        "0.4": {
          "rap": "2,100",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,600",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,600",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "3,800",
          "low_price": "1,300",
          "high_price": "2,820"
        },
        "0.8": {
          "rap": "3,800",
          "low_price": "1,490",
          "high_price": "3,225"
        },
        "0.9": {
          "rap": "4,800",
          "low_price": "2,215",
          "high_price": "4,795"
        },
        "1.0": {
          "rap": "5,900",
          "low_price": "2,820",
          "high_price": "6,110"
        },
        "1.1": {
          "rap": "5,900",
          "low_price": "3,100",
          "high_price": "6,720"
        },
        "1.2": {
          "rap": "5,900",
          "low_price": "3,385",
          "high_price": "7,330"
        },
        "1.3": {
          "rap": "5,900",
          "low_price": "3,665",
          "high_price": "7,945"
        },
        "1.4": {
          "rap": "5,900",
          "low_price": "3,950",
          "high_price": "8,555"
        },
        "1.5": {
          "rap": "8,900",
          "low_price": "7,110",
          "high_price": "15,405"
        },
        "1.6": {
          "rap": "8,900",
          "low_price": "7,585",
          "high_price": "16,430"
        },
        "1.7": {
          "rap": "8,900",
          "low_price": "8,060",
          "high_price": "17,460"
        },
        "1.8": {
          "rap": "8,900",
          "low_price": "8,530",
          "high_price": "18,485"
        },
        "1.9": {
          "rap": "8,900",
          "low_price": "9,005",
          "high_price": "19,515"
        },
        "2.0": {
          "rap": "11,800",
          "low_price": "12,960",
          "high_price": "28,080"
        },
        "2.1": {
          "rap": "11,800",
          "low_price": "13,610",
          "high_price": "29,485"
        },
        "2.2": {
          "rap": "11,800",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.3": {
          "rap": "11,800",
          "low_price": "14,905",
          "high_price": "32,290"
        },
        "2.4": {
          "rap": "11,800",
          "low_price": "15,550",
          "high_price": "33,695"
        },
        "2.5": {
          "rap": "11,800",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.6": {
          "rap": "11,800",
          "low_price": "16,850",
          "high_price": "36,505"
        },
        "2.7": {
          "rap": "11,800",
          "low_price": "17,495",
          "high_price": "37,910"
        },
        "2.8": {
          "rap": "11,800",
          "low_price": "18,145",
          "high_price": "39,310"
        },
        "2.9": {
          "rap": "11,800",
          "low_price": "18,790",
          "high_price": "40,715"
        },
        "3.0": {
          "rap": "20,000",
          "low_price": "35,100",
          "high_price": "76,050"
        },
        "3.1": {
          "rap": "20,000",
          "low_price": "36,270",
          "high_price": "78,585"
        },
        "3.2": {
          "rap": "20,000",
          "low_price": "37,440",
          "high_price": "81,120"
        },
        "3.3": {
          "rap": "20,000",
          "low_price": "38,610",
          "high_price": "83,655"
        },
        "3.4": {
          "rap": "20,000",
          "low_price": "39,780",
          "high_price": "86,190"
        },
        "3.5": {
          "rap": "20,000",
          "low_price": "40,950",
          "high_price": "88,725"
        },
        "3.6": {
          "rap": "20,000",
          "low_price": "42,120",
          "high_price": "91,260"
        },
        "3.7": {
          "rap": "20,000",
          "low_price": "43,290",
          "high_price": "93,795"
        },
        "3.8": {
          "rap": "20,000",
          "low_price": "44,460",
          "high_price": "96,330"
        },
        "3.9": {
          "rap": "20,000",
          "low_price": "45,630",
          "high_price": "98,865"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,800",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,200",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,200",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "1,090",
          "high_price": "2,365"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "1,250",
          "high_price": "2,705"
        },
        "0.9": {
          "rap": "3,900",
          "low_price": "1,945",
          "high_price": "4,210"
        },
        "1.0": {
          "rap": "4,800",
          "low_price": "2,400",
          "high_price": "5,200"
        },
        "1.1": {
          "rap": "4,800",
          "low_price": "2,640",
          "high_price": "5,720"
        },
        "1.2": {
          "rap": "4,800",
          "low_price": "2,880",
          "high_price": "6,240"
        },
        "1.3": {
          "rap": "4,800",
          "low_price": "3,120",
          "high_price": "6,760"
        },
        "1.4": {
          "rap": "4,800",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "1.5": {
          "rap": "7,200",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "1.6": {
          "rap": "7,200",
          "low_price": "6,145",
          "high_price": "13,310"
        },
        "1.7": {
          "rap": "7,200",
          "low_price": "6,530",
          "high_price": "14,145"
        },
        "1.8": {
          "rap": "7,200",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "1.9": {
          "rap": "7,200",
          "low_price": "7,295",
          "high_price": "15,810"
        },
        "2.0": {
          "rap": "9,400",
          "low_price": "10,560",
          "high_price": "22,880"
        },
        "2.1": {
          "rap": "9,400",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.2": {
          "rap": "9,400",
          "low_price": "11,615",
          "high_price": "25,170"
        },
        "2.3": {
          "rap": "9,400",
          "low_price": "12,145",
          "high_price": "26,310"
        },
        "2.4": {
          "rap": "9,400",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "2.5": {
          "rap": "9,400",
          "low_price": "13,200",
          "high_price": "28,600"
        },
        "2.6": {
          "rap": "9,400",
          "low_price": "13,730",
          "high_price": "29,745"
        },
        "2.7": {
          "rap": "9,400",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.8": {
          "rap": "9,400",
          "low_price": "14,785",
          "high_price": "32,030"
        },
        "2.9": {
          "rap": "9,400",
          "low_price": "15,310",
          "high_price": "33,175"
        },
        "3.0": {
          "rap": "15,900",
          "low_price": "27,720",
          "high_price": "60,060"
        },
        "3.1": {
          "rap": "15,900",
          "low_price": "28,645",
          "high_price": "62,060"
        },
        "3.2": {
          "rap": "15,900",
          "low_price": "29,570",
          "high_price": "64,065"
        },
        "3.3": {
          "rap": "15,900",
          "low_price": "30,490",
          "high_price": "66,065"
        },
        "3.4": {
          "rap": "15,900",
          "low_price": "31,415",
          "high_price": "68,070"
        },
        "3.5": {
          "rap": "15,900",
          "low_price": "32,340",
          "high_price": "70,070"
        },
        "3.6": {
          "rap": "15,900",
          "low_price": "33,265",
          "high_price": "72,070"
        },
        "3.7": {
          "rap": "15,900",
          "low_price": "34,190",
          "high_price": "74,075"
        },
        "3.8": {
          "rap": "15,900",
          "low_price": "35,110",
          "high_price": "76,075"
        },
        "3.9": {
          "rap": "15,900",
          "low_price": "36,035",
          "high_price": "78,080"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,500",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "2,500",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "2,500",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "3,200",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "3,900",
          "low_price": "2,040",
          "high_price": "4,420"
        },
        "1.1": {
          "rap": "3,900",
          "low_price": "2,245",
          "high_price": "4,860"
        },
        "1.2": {
          "rap": "3,900",
          "low_price": "2,450",
          "high_price": "5,305"
        },
        "1.3": {
          "rap": "3,900",
          "low_price": "2,650",
          "high_price": "5,745"
        },
        "1.4": {
          "rap": "3,900",
          "low_price": "2,855",
          "high_price": "6,190"
        },
        "1.5": {
          "rap": "5,700",
          "low_price": "4,410",
          "high_price": "9,555"
        },
        "1.6": {
          "rap": "5,700",
          "low_price": "4,705",
          "high_price": "10,190"
        },
        "1.7": {
          "rap": "5,700",
          "low_price": "5,000",
          "high_price": "10,830"
        },
        "1.8": {
          "rap": "5,700",
          "low_price": "5,290",
          "high_price": "11,465"
        },
        "1.9": {
          "rap": "5,700",
          "low_price": "5,585",
          "high_price": "12,105"
        },
        "2.0": {
          "rap": "7,600",
          "low_price": "8,400",
          "high_price": "18,200"
        },
        "2.1": {
          "rap": "7,600",
          "low_price": "8,820",
          "high_price": "19,110"
        },
        "2.2": {
          "rap": "7,600",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.3": {
          "rap": "7,600",
          "low_price": "9,660",
          "high_price": "20,930"
        },
        "2.4": {
          "rap": "7,600",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.5": {
          "rap": "7,600",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "2.6": {
          "rap": "7,600",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.7": {
          "rap": "7,600",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.8": {
          "rap": "7,600",
          "low_price": "11,760",
          "high_price": "25,480"
        },
        "2.9": {
          "rap": "7,600",
          "low_price": "12,180",
          "high_price": "26,390"
        },
        "3.0": {
          "rap": "12,300",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "3.1": {
          "rap": "12,300",
          "low_price": "22,135",
          "high_price": "47,955"
        },
        "3.2": {
          "rap": "12,300",
          "low_price": "22,850",
          "high_price": "49,505"
        },
        "3.3": {
          "rap": "12,300",
          "low_price": "23,560",
          "high_price": "51,050"
        },
        "3.4": {
          "rap": "12,300",
          "low_price": "24,275",
          "high_price": "52,600"
        },
        "3.5": {
          "rap": "12,300",
          "low_price": "24,990",
          "high_price": "54,145"
        },
        "3.6": {
          "rap": "12,300",
          "low_price": "25,705",
          "high_price": "55,690"
        },
        "3.7": {
          "rap": "12,300",
          "low_price": "26,420",
          "high_price": "57,240"
        },
        "3.8": {
          "rap": "12,300",
          "low_price": "27,130",
          "high_price": "58,785"
        },
        "3.9": {
          "rap": "12,300",
          "low_price": "27,845",
          "high_price": "60,335"
        }
      }
    },
    "SI1": {
      "D": {
        "0.4": {
          "rap": "2,000",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "2,500",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,500",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,000",
          "low_price": "1,175",
          "high_price": "2,550"
        },
        "0.8": {
          "rap": "4,000",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.9": {
          "rap": "5,000",
          "low_price": "2,000",
          "high_price": "4,330"
        },
        "1.0": {
          "rap": "6,300",
          "low_price": "2,760",
          "high_price": "5,980"
        },
        "1.1": {
          "rap": "6,300",
          "low_price": "3,035",
          "high_price": "6,580"
        },
        "1.2": {
          "rap": "6,300",
          "low_price": "3,310",
          "high_price": "7,175"
        },
        "1.3": {
          "rap": "6,300",
          "low_price": "3,590",
          "high_price": "7,775"
        },
        "1.4": {
          "rap": "6,300",
          "low_price": "3,865",
          "high_price": "8,370"
        },
        "1.5": {
          "rap": "11,000",
          "low_price": "7,290",
          "high_price": "15,795"
        },
        "1.6": {
          "rap": "11,000",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "1.7": {
          "rap": "11,000",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "1.8": {
          "rap": "11,000",
          "low_price": "8,750",
          "high_price": "18,955"
        },
        "1.9": {
          "rap": "11,000",
          "low_price": "9,235",
          "high_price": "20,005"
        },
        "2.0": {
          "rap": "15,100",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.1": {
          "rap": "15,100",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "2.2": {
          "rap": "15,100",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.3": {
          "rap": "15,100",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.4": {
          "rap": "15,100",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.5": {
          "rap": "15,100",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.6": {
          "rap": "15,100",
          "low_price": "21,060",
          "high_price": "45,630"
        },
        "2.7": {
          "rap": "15,100",
          "low_price": "21,870",
          "high_price": "47,385"
        },
        "2.8": {
          "rap": "15,100",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.9": {
          "rap": "15,100",
          "low_price": "23,490",
          "high_price": "50,895"
        },
        "3.0": {
          "rap": "23,000",
          "low_price": "41,400",
          "high_price": "89,700"
        },
        "3.1": {
          "rap": "23,000",
          "low_price": "42,780",
          "high_price": "92,690"
        },
        "3.2": {
          "rap": "23,000",
          "low_price": "44,160",
          "high_price": "95,680"
        },
        "3.3": {
          "rap": "23,000",
          "low_price": "45,540",
          "high_price": "98,670"
        },
        "3.4": {
          "rap": "23,000",
          "low_price": "46,920",
          "high_price": "101,660"
        },
        "3.5": {
          "rap": "23,000",
          "low_price": "48,300",
          "high_price": "104,650"
        },
        "3.6": {
          "rap": "23,000",
          "low_price": "49,680",
          "high_price": "107,640"
        },
        "3.7": {
          "rap": "23,000",
          "low_price": "51,060",
          "high_price": "110,630"
        },
        "3.8": {
          "rap": "23,000",
          "low_price": "52,440",
          "high_price": "113,620"
        },
        "3.9": {
          "rap": "23,000",
          "low_price": "53,820",
          "high_price": "116,610"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,900",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "2,300",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.6": {
          "rap": "2,300",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.7": {
          "rap": "3,800",
          "low_price": "1,090",
          "high_price": "2,365"
        },
        "0.8": {
          "rap": "3,800",
          "low_price": "1,250",
          "high_price": "2,705"
        },
        "0.9": {
          "rap": "4,800",
          "low_price": "1,890",
          "high_price": "4,095"
        },
        "1.0": {
          "rap": "6,000",
          "low_price": "2,580",
          "high_price": "5,590"
        },
        "1.1": {
          "rap": "6,000",
          "low_price": "2,840",
          "high_price": "6,150"
        },
        "1.2": {
          "rap": "6,000",
          "low_price": "3,095",
          "high_price": "6,710"
        },
        "1.3": {
          "rap": "6,000",
          "low_price": "3,355",
          "high_price": "7,265"
        },
        "1.4": {
          "rap": "6,000",
          "low_price": "3,610",
          "high_price": "7,825"
        },
        "1.5": {
          "rap": "10,500",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "1.6": {
          "rap": "10,500",
          "low_price": "7,295",
          "high_price": "15,810"
        },
        "1.7": {
          "rap": "10,500",
          "low_price": "7,750",
          "high_price": "16,795"
        },
        "1.8": {
          "rap": "10,500",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "1.9": {
          "rap": "10,500",
          "low_price": "8,665",
          "high_price": "18,770"
        },
        "2.0": {
          "rap": "14,100",
          "low_price": "15,000",
          "high_price": "32,500"
        },
        "2.1": {
          "rap": "14,100",
          "low_price": "15,750",
          "high_price": "34,125"
        },
        "2.2": {
          "rap": "14,100",
          "low_price": "16,500",
          "high_price": "35,750"
        },
        "2.3": {
          "rap": "14,100",
          "low_price": "17,250",
          "high_price": "37,375"
        },
        "2.4": {
          "rap": "14,100",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.5": {
          "rap": "14,100",
          "low_price": "18,750",
          "high_price": "40,625"
        },
        "2.6": {
          "rap": "14,100",
          "low_price": "19,500",
          "high_price": "42,250"
        },
        "2.7": {
          "rap": "14,100",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.8": {
          "rap": "14,100",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.9": {
          "rap": "14,100",
          "low_price": "21,750",
          "high_price": "47,125"
        },
        "3.0": {
          "rap": "21,500",
          "low_price": "38,700",
          "high_price": "83,850"
        },
        "3.1": {
          "rap": "21,500",
          "low_price": "39,990",
          "high_price": "86,645"
        },
        "3.2": {
          "rap": "21,500",
          "low_price": "41,280",
          "high_price": "89,440"
        },
        "3.3": {
          "rap": "21,500",
          "low_price": "42,570",
          "high_price": "92,235"
        },
        "3.4": {
          "rap": "21,500",
          "low_price": "43,860",
          "high_price": "95,030"
        },
        "3.5": {
          "rap": "21,500",
          "low_price": "45,150",
          "high_price": "97,825"
        },
        "3.6": {
          "rap": "21,500",
          "low_price": "46,440",
          "high_price": "100,620"
        },
        "3.7": {
          "rap": "21,500",
          "low_price": "47,730",
          "high_price": "103,415"
        },
        "3.8": {
          "rap": "21,500",
          "low_price": "49,020",
          "high_price": "106,210"
        },
        "3.9": {
          "rap": "21,500",
          "low_price": "50,310",
          "high_price": "109,005"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,800",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,200",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "2,200",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "3,600",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.8": {
          "rap": "3,600",
          "low_price": "1,150",
          "high_price": "2,495"
        },
        "0.9": {
          "rap": "4,600",
          "low_price": "1,780",
          "high_price": "3,860"
        },
        "1.0": {
          "rap": "5,700",
          "low_price": "2,400",
          "high_price": "5,200"
        },
        "1.1": {
          "rap": "5,700",
          "low_price": "2,640",
          "high_price": "5,720"
        },
        "1.2": {
          "rap": "5,700",
          "low_price": "2,880",
          "high_price": "6,240"
        },
        "1.3": {
          "rap": "5,700",
          "low_price": "3,120",
          "high_price": "6,760"
        },
        "1.4": {
          "rap": "5,700",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "1.5": {
          "rap": "9,900",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "1.6": {
          "rap": "9,900",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "1.7": {
          "rap": "9,900",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "1.8": {
          "rap": "9,900",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "1.9": {
          "rap": "9,900",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "2.0": {
          "rap": "13,200",
          "low_price": "14,040",
          "high_price": "30,420"
        },
        "2.1": {
          "rap": "13,200",
          "low_price": "14,740",
          "high_price": "31,940"
        },
        "2.2": {
          "rap": "13,200",
          "low_price": "15,445",
          "high_price": "33,460"
        },
        "2.3": {
          "rap": "13,200",
          "low_price": "16,145",
          "high_price": "34,985"
        },
        "2.4": {
          "rap": "13,200",
          "low_price": "16,850",
          "high_price": "36,505"
        },
        "2.5": {
          "rap": "13,200",
          "low_price": "17,550",
          "high_price": "38,025"
        },
        "2.6": {
          "rap": "13,200",
          "low_price": "18,250",
          "high_price": "39,545"
        },
        "2.7": {
          "rap": "13,200",
          "low_price": "18,955",
          "high_price": "41,065"
        },
        "2.8": {
          "rap": "13,200",
          "low_price": "19,655",
          "high_price": "42,590"
        },
        "2.9": {
          "rap": "13,200",
          "low_price": "20,360",
          "high_price": "44,110"
        },
        "3.0": {
          "rap": "19,500",
          "low_price": "36,000",
          "high_price": "78,000"
        },
        "3.1": {
          "rap": "19,500",
          "low_price": "37,200",
          "high_price": "80,600"
        },
        "3.2": {
          "rap": "19,500",
          "low_price": "38,400",
          "high_price": "83,200"
        },
        "3.3": {
          "rap": "19,500",
          "low_price": "39,600",
          "high_price": "85,800"
        },
        "3.4": {
          "rap": "19,500",
          "low_price": "40,800",
          "high_price": "88,400"
        },
        "3.5": {
          "rap": "19,500",
          "low_price": "42,000",
          "high_price": "91,000"
        },
        "3.6": {
          "rap": "19,500",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.7": {
          "rap": "19,500",
          "low_price": "44,400",
          "high_price": "96,200"
        },
        "3.8": {
          "rap": "19,500",
          "low_price": "45,600",
          "high_price": "98,800"
        },
        "3.9": {
          "rap": "19,500",
          "low_price": "46,800",
          "high_price": "101,400"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,700",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,300",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,300",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "4,400",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.0": {
          "rap": "5,400",
          "low_price": "2,280",
          "high_price": "4,940"
        },
        "1.1": {
          "rap": "5,400",
          "low_price": "2,510",
          "high_price": "5,435"
        },
        "1.2": {
          "rap": "5,400",
          "low_price": "2,735",
          "high_price": "5,930"
        },
        "1.3": {
          "rap": "5,400",
          "low_price": "2,965",
          "high_price": "6,420"
        },
        "1.4": {
          "rap": "5,400",
          "low_price": "3,190",
          "high_price": "6,915"
        },
        "1.5": {
          "rap": "9,200",
          "low_price": "6,030",
          "high_price": "13,065"
        },
        "1.6": {
          "rap": "9,200",
          "low_price": "6,430",
          "high_price": "13,935"
        },
        "1.7": {
          "rap": "9,200",
          "low_price": "6,835",
          "high_price": "14,805"
        },
        "1.8": {
          "rap": "9,200",
          "low_price": "7,235",
          "high_price": "15,680"
        },
        "1.9": {
          "rap": "9,200",
          "low_price": "7,640",
          "high_price": "16,550"
        },
        "2.0": {
          "rap": "12,200",
          "low_price": "12,840",
          "high_price": "27,820"
        },
        "2.1": {
          "rap": "12,200",
          "low_price": "13,480",
          "high_price": "29,210"
        },
        "2.2": {
          "rap": "12,200",
          "low_price": "14,125",
          "high_price": "30,600"
        },
        "2.3": {
          "rap": "12,200",
          "low_price": "14,765",
          "high_price": "31,995"
        },
        "2.4": {
          "rap": "12,200",
          "low_price": "15,410",
          "high_price": "33,385"
        },
        "2.5": {
          "rap": "12,200",
          "low_price": "16,050",
          "high_price": "34,775"
        },
        "2.6": {
          "rap": "12,200",
          "low_price": "16,690",
          "high_price": "36,165"
        },
        "2.7": {
          "rap": "12,200",
          "low_price": "17,335",
          "high_price": "37,555"
        },
        "2.8": {
          "rap": "12,200",
          "low_price": "17,975",
          "high_price": "38,950"
        },
        "2.9": {
          "rap": "12,200",
          "low_price": "18,620",
          "high_price": "40,340"
        },
        "3.0": {
          "rap": "18,000",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.1": {
          "rap": "18,000",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.2": {
          "rap": "18,000",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.3": {
          "rap": "18,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.4": {
          "rap": "18,000",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.5": {
          "rap": "18,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.6": {
          "rap": "18,000",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.7": {
          "rap": "18,000",
          "low_price": "41,070",
          "high_price": "88,985"
        },
        "3.8": {
          "rap": "18,000",
          "low_price": "42,180",
          "high_price": "91,390"
        },
        "3.9": {
          "rap": "18,000",
          "low_price": "43,290",
          "high_price": "93,795"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,600",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,000",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "2,000",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "4,000",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "5,000",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.1": {
          "rap": "5,000",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.2": {
          "rap": "5,000",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.3": {
          "rap": "5,000",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.4": {
          "rap": "5,000",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.5": {
          "rap": "8,500",
          "low_price": "5,580",
          "high_price": "12,090"
        },
        "1.6": {
          "rap": "8,500",
          "low_price": "5,950",
          "high_price": "12,895"
        },
        "1.7": {
          "rap": "8,500",
          "low_price": "6,325",
          "high_price": "13,700"
        },
        "1.8": {
          "rap": "8,500",
          "low_price": "6,695",
          "high_price": "14,510"
        },
        "1.9": {
          "rap": "8,500",
          "low_price": "7,070",
          "high_price": "15,315"
        },
        "2.0": {
          "rap": "11,100",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "2.1": {
          "rap": "11,100",
          "low_price": "12,475",
          "high_price": "27,025"
        },
        "2.2": {
          "rap": "11,100",
          "low_price": "13,070",
          "high_price": "28,315"
        },
        "2.3": {
          "rap": "11,100",
          "low_price": "13,660",
          "high_price": "29,600"
        },
        "2.4": {
          "rap": "11,100",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.5": {
          "rap": "11,100",
          "low_price": "14,850",
          "high_price": "32,175"
        },
        "2.6": {
          "rap": "11,100",
          "low_price": "15,445",
          "high_price": "33,460"
        },
        "2.7": {
          "rap": "11,100",
          "low_price": "16,040",
          "high_price": "34,750"
        },
        "2.8": {
          "rap": "11,100",
          "low_price": "16,630",
          "high_price": "36,035"
        },
        "2.9": {
          "rap": "11,100",
          "low_price": "17,225",
          "high_price": "37,325"
        },
        "3.0": {
          "rap": "16,000",
          "low_price": "29,700",
          "high_price": "64,350"
        },
        "3.1": {
          "rap": "16,000",
          "low_price": "30,690",
          "high_price": "66,495"
        },
        "3.2": {
          "rap": "16,000",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "3.3": {
          "rap": "16,000",
          "low_price": "32,670",
          "high_price": "70,785"
        },
        "3.4": {
          "rap": "16,000",
          "low_price": "33,660",
          "high_price": "72,930"
        },
        "3.5": {
          "rap": "16,000",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "3.6": {
          "rap": "16,000",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "3.7": {
          "rap": "16,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.8": {
          "rap": "16,000",
          "low_price": "37,620",
          "high_price": "81,510"
        },
        "3.9": {
          "rap": "16,000",
          "low_price": "38,610",
          "high_price": "83,655"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,700",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "2,700",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,460",
          "high_price": "3,160"
        },
        "1.0": {
          "rap": "4,400",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "1.1": {
          "rap": "4,400",
          "low_price": "2,110",
          "high_price": "4,575"
        },
        "1.2": {
          "rap": "4,400",
          "low_price": "2,305",
          "high_price": "4,990"
        },
        "1.3": {
          "rap": "4,400",
          "low_price": "2,495",
          "high_price": "5,410"
        },
        "1.4": {
          "rap": "4,400",
          "low_price": "2,690",
          "high_price": "5,825"
        },
        "1.5": {
          "rap": "7,300",
          "low_price": "5,040",
          "high_price": "10,920"
        },
        "1.6": {
          "rap": "7,300",
          "low_price": "5,375",
          "high_price": "11,650"
        },
        "1.7": {
          "rap": "7,300",
          "low_price": "5,710",
          "high_price": "12,375"
        },
        "1.8": {
          "rap": "7,300",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.9": {
          "rap": "7,300",
          "low_price": "6,385",
          "high_price": "13,830"
        },
        "2.0": {
          "rap": "9,300",
          "low_price": "10,200",
          "high_price": "22,100"
        },
        "2.1": {
          "rap": "9,300",
          "low_price": "10,710",
          "high_price": "23,205"
        },
        "2.2": {
          "rap": "9,300",
          "low_price": "11,220",
          "high_price": "24,310"
        },
        "2.3": {
          "rap": "9,300",
          "low_price": "11,730",
          "high_price": "25,415"
        },
        "2.4": {
          "rap": "9,300",
          "low_price": "12,240",
          "high_price": "26,520"
        },
        "2.5": {
          "rap": "9,300",
          "low_price": "12,750",
          "high_price": "27,625"
        },
        "2.6": {
          "rap": "9,300",
          "low_price": "13,260",
          "high_price": "28,730"
        },
        "2.7": {
          "rap": "9,300",
          "low_price": "13,770",
          "high_price": "29,835"
        },
        "2.8": {
          "rap": "9,300",
          "low_price": "14,280",
          "high_price": "30,940"
        },
        "2.9": {
          "rap": "9,300",
          "low_price": "14,790",
          "high_price": "32,045"
        },
        "3.0": {
          "rap": "14,000",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.1": {
          "rap": "14,000",
          "low_price": "26,970",
          "high_price": "58,435"
        },
        "3.2": {
          "rap": "14,000",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.3": {
          "rap": "14,000",
          "low_price": "28,710",
          "high_price": "62,205"
        },
        "3.4": {
          "rap": "14,000",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.5": {
          "rap": "14,000",
          "low_price": "30,450",
          "high_price": "65,975"
        },
        "3.6": {
          "rap": "14,000",
          "low_price": "31,320",
          "high_price": "67,860"
        },
        "3.7": {
          "rap": "14,000",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.8": {
          "rap": "14,000",
          "low_price": "33,060",
          "high_price": "71,630"
        },
        "3.9": {
          "rap": "14,000",
          "low_price": "33,930",
          "high_price": "73,515"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,200",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "3,000",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "1.0": {
          "rap": "3,600",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "3,600",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "3,600",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "3,600",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "3,600",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "5,800",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "5,800",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "5,800",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "5,800",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "5,800",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "7,700",
          "low_price": "8,400",
          "high_price": "18,200"
        },
        "2.1": {
          "rap": "7,700",
          "low_price": "8,820",
          "high_price": "19,110"
        },
        "2.2": {
          "rap": "7,700",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.3": {
          "rap": "7,700",
          "low_price": "9,660",
          "high_price": "20,930"
        },
        "2.4": {
          "rap": "7,700",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.5": {
          "rap": "7,700",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "2.6": {
          "rap": "7,700",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.7": {
          "rap": "7,700",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.8": {
          "rap": "7,700",
          "low_price": "11,760",
          "high_price": "25,480"
        },
        "2.9": {
          "rap": "7,700",
          "low_price": "12,180",
          "high_price": "26,390"
        },
        "3.0": {
          "rap": "11,100",
          "low_price": "19,980",
          "high_price": "43,290"
        },
        "3.1": {
          "rap": "11,100",
          "low_price": "20,645",
          "high_price": "44,735"
        },
        "3.2": {
          "rap": "11,100",
          "low_price": "21,310",
          "high_price": "46,175"
        },
        "3.3": {
          "rap": "11,100",
          "low_price": "21,980",
          "high_price": "47,620"
        },
        "3.4": {
          "rap": "11,100",
          "low_price": "22,645",
          "high_price": "49,060"
        },
        "3.5": {
          "rap": "11,100",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "3.6": {
          "rap": "11,100",
          "low_price": "23,975",
          "high_price": "51,950"
        },
        "3.7": {
          "rap": "11,100",
          "low_price": "24,640",
          "high_price": "53,390"
        },
        "3.8": {
          "rap": "11,100",
          "low_price": "25,310",
          "high_price": "54,835"
        },
        "3.9": {
          "rap": "11,100",
          "low_price": "25,975",
          "high_price": "56,275"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,000",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "2,000",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,000",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,500",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "2,900",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "1.1": {
          "rap": "2,900",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.2": {
          "rap": "2,900",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.3": {
          "rap": "2,900",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.4": {
          "rap": "2,900",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.5": {
          "rap": "4,700",
          "low_price": "3,510",
          "high_price": "7,605"
        },
        "1.6": {
          "rap": "4,700",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.7": {
          "rap": "4,700",
          "low_price": "3,980",
          "high_price": "8,620"
        },
        "1.8": {
          "rap": "4,700",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.9": {
          "rap": "4,700",
          "low_price": "4,445",
          "high_price": "9,635"
        },
        "2.0": {
          "rap": "6,300",
          "low_price": "6,600",
          "high_price": "14,300"
        },
        "2.1": {
          "rap": "6,300",
          "low_price": "6,930",
          "high_price": "15,015"
        },
        "2.2": {
          "rap": "6,300",
          "low_price": "7,260",
          "high_price": "15,730"
        },
        "2.3": {
          "rap": "6,300",
          "low_price": "7,590",
          "high_price": "16,445"
        },
        "2.4": {
          "rap": "6,300",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.5": {
          "rap": "6,300",
          "low_price": "8,250",
          "high_price": "17,875"
        },
        "2.6": {
          "rap": "6,300",
          "low_price": "8,580",
          "high_price": "18,590"
        },
        "2.7": {
          "rap": "6,300",
          "low_price": "8,910",
          "high_price": "19,305"
        },
        "2.8": {
          "rap": "6,300",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.9": {
          "rap": "6,300",
          "low_price": "9,570",
          "high_price": "20,735"
        },
        "3.0": {
          "rap": "8,800",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "3.1": {
          "rap": "8,800",
          "low_price": "16,370",
          "high_price": "35,465"
        },
        "3.2": {
          "rap": "8,800",
          "low_price": "16,895",
          "high_price": "36,610"
        },
        "3.3": {
          "rap": "8,800",
          "low_price": "17,425",
          "high_price": "37,750"
        },
        "3.4": {
          "rap": "8,800",
          "low_price": "17,950",
          "high_price": "38,895"
        },
        "3.5": {
          "rap": "8,800",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "3.6": {
          "rap": "8,800",
          "low_price": "19,010",
          "high_price": "41,185"
        },
        "3.7": {
          "rap": "8,800",
          "low_price": "19,535",
          "high_price": "42,330"
        },
        "3.8": {
          "rap": "8,800",
          "low_price": "20,065",
          "high_price": "43,470"
        },
        "3.9": {
          "rap": "8,800",
          "low_price": "20,590",
          "high_price": "44,615"
        }
      }
    },
    "SI2": {
      "D": {
        "0.4": {
          "rap": "1,700",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "3,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.8": {
          "rap": "3,400",
          "low_price": "1,150",
          "high_price": "2,495"
        },
        "0.9": {
          "rap": "4,400",
          "low_price": "1,780",
          "high_price": "3,860"
        },
        "1.0": {
          "rap": "5,300",
          "low_price": "2,340",
          "high_price": "5,070"
        },
        "1.1": {
          "rap": "5,300",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.2": {
          "rap": "5,300",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.3": {
          "rap": "5,300",
          "low_price": "3,040",
          "high_price": "6,590"
        },
        "1.4": {
          "rap": "5,300",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.5": {
          "rap": "9,100",
          "low_price": "6,030",
          "high_price": "13,065"
        },
        "1.6": {
          "rap": "9,100",
          "low_price": "6,430",
          "high_price": "13,935"
        },
        "1.7": {
          "rap": "9,100",
          "low_price": "6,835",
          "high_price": "14,805"
        },
        "1.8": {
          "rap": "9,100",
          "low_price": "7,235",
          "high_price": "15,680"
        },
        "1.9": {
          "rap": "9,100",
          "low_price": "7,640",
          "high_price": "16,550"
        },
        "2.0": {
          "rap": "12,100",
          "low_price": "12,360",
          "high_price": "26,780"
        },
        "2.1": {
          "rap": "12,100",
          "low_price": "12,980",
          "high_price": "28,120"
        },
        "2.2": {
          "rap": "12,100",
          "low_price": "13,595",
          "high_price": "29,460"
        },
        "2.3": {
          "rap": "12,100",
          "low_price": "14,215",
          "high_price": "30,795"
        },
        "2.4": {
          "rap": "12,100",
          "low_price": "14,830",
          "high_price": "32,135"
        },
        "2.5": {
          "rap": "12,100",
          "low_price": "15,450",
          "high_price": "33,475"
        },
        "2.6": {
          "rap": "12,100",
          "low_price": "16,070",
          "high_price": "34,815"
        },
        "2.7": {
          "rap": "12,100",
          "low_price": "16,685",
          "high_price": "36,155"
        },
        "2.8": {
          "rap": "12,100",
          "low_price": "17,305",
          "high_price": "37,490"
        },
        "2.9": {
          "rap": "12,100",
          "low_price": "17,920",
          "high_price": "38,830"
        },
        "3.0": {
          "rap": "17,500",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "3.1": {
          "rap": "17,500",
          "low_price": "33,480",
          "high_price": "72,540"
        },
        "3.2": {
          "rap": "17,500",
          "low_price": "34,560",
          "high_price": "74,880"
        },
        "3.3": {
          "rap": "17,500",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "3.4": {
          "rap": "17,500",
          "low_price": "36,720",
          "high_price": "79,560"
        },
        "3.5": {
          "rap": "17,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.6": {
          "rap": "17,500",
          "low_price": "38,880",
          "high_price": "84,240"
        },
        "3.7": {
          "rap": "17,500",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.8": {
          "rap": "17,500",
          "low_price": "41,040",
          "high_price": "88,920"
        },
        "3.9": {
          "rap": "17,500",
          "low_price": "42,120",
          "high_price": "91,260"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,600",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,200",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,200",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "4,200",
          "low_price": "1,675",
          "high_price": "3,625"
        },
        "1.0": {
          "rap": "5,100",
          "low_price": "2,220",
          "high_price": "4,810"
        },
        "1.1": {
          "rap": "5,100",
          "low_price": "2,440",
          "high_price": "5,290"
        },
        "1.2": {
          "rap": "5,100",
          "low_price": "2,665",
          "high_price": "5,770"
        },
        "1.3": {
          "rap": "5,100",
          "low_price": "2,885",
          "high_price": "6,255"
        },
        "1.4": {
          "rap": "5,100",
          "low_price": "3,110",
          "high_price": "6,735"
        },
        "1.5": {
          "rap": "8,600",
          "low_price": "5,670",
          "high_price": "12,285"
        },
        "1.6": {
          "rap": "8,600",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.7": {
          "rap": "8,600",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "1.8": {
          "rap": "8,600",
          "low_price": "6,805",
          "high_price": "14,740"
        },
        "1.9": {
          "rap": "8,600",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.0": {
          "rap": "11,400",
          "low_price": "11,520",
          "high_price": "24,960"
        },
        "2.1": {
          "rap": "11,400",
          "low_price": "12,095",
          "high_price": "26,210"
        },
        "2.2": {
          "rap": "11,400",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "2.3": {
          "rap": "11,400",
          "low_price": "13,250",
          "high_price": "28,705"
        },
        "2.4": {
          "rap": "11,400",
          "low_price": "13,825",
          "high_price": "29,950"
        },
        "2.5": {
          "rap": "11,400",
          "low_price": "14,400",
          "high_price": "31,200"
        },
        "2.6": {
          "rap": "11,400",
          "low_price": "14,975",
          "high_price": "32,450"
        },
        "2.7": {
          "rap": "11,400",
          "low_price": "15,550",
          "high_price": "33,695"
        },
        "2.8": {
          "rap": "11,400",
          "low_price": "16,130",
          "high_price": "34,945"
        },
        "2.9": {
          "rap": "11,400",
          "low_price": "16,705",
          "high_price": "36,190"
        },
        "3.0": {
          "rap": "16,500",
          "low_price": "30,600",
          "high_price": "66,300"
        },
        "3.1": {
          "rap": "16,500",
          "low_price": "31,620",
          "high_price": "68,510"
        },
        "3.2": {
          "rap": "16,500",
          "low_price": "32,640",
          "high_price": "70,720"
        },
        "3.3": {
          "rap": "16,500",
          "low_price": "33,660",
          "high_price": "72,930"
        },
        "3.4": {
          "rap": "16,500",
          "low_price": "34,680",
          "high_price": "75,140"
        },
        "3.5": {
          "rap": "16,500",
          "low_price": "35,700",
          "high_price": "77,350"
        },
        "3.6": {
          "rap": "16,500",
          "low_price": "36,720",
          "high_price": "79,560"
        },
        "3.7": {
          "rap": "16,500",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.8": {
          "rap": "16,500",
          "low_price": "38,760",
          "high_price": "83,980"
        },
        "3.9": {
          "rap": "16,500",
          "low_price": "39,780",
          "high_price": "86,190"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,500",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "4,000",
          "low_price": "1,565",
          "high_price": "3,395"
        },
        "1.0": {
          "rap": "4,900",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "1.1": {
          "rap": "4,900",
          "low_price": "2,310",
          "high_price": "5,005"
        },
        "1.2": {
          "rap": "4,900",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.3": {
          "rap": "4,900",
          "low_price": "2,730",
          "high_price": "5,915"
        },
        "1.4": {
          "rap": "4,900",
          "low_price": "2,940",
          "high_price": "6,370"
        },
        "1.5": {
          "rap": "8,200",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "1.6": {
          "rap": "8,200",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "1.7": {
          "rap": "8,200",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "1.8": {
          "rap": "8,200",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "1.9": {
          "rap": "8,200",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "2.0": {
          "rap": "10,800",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.1": {
          "rap": "10,800",
          "low_price": "11,465",
          "high_price": "24,845"
        },
        "2.2": {
          "rap": "10,800",
          "low_price": "12,010",
          "high_price": "26,025"
        },
        "2.3": {
          "rap": "10,800",
          "low_price": "12,560",
          "high_price": "27,210"
        },
        "2.4": {
          "rap": "10,800",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.5": {
          "rap": "10,800",
          "low_price": "13,650",
          "high_price": "29,575"
        },
        "2.6": {
          "rap": "10,800",
          "low_price": "14,195",
          "high_price": "30,760"
        },
        "2.7": {
          "rap": "10,800",
          "low_price": "14,740",
          "high_price": "31,940"
        },
        "2.8": {
          "rap": "10,800",
          "low_price": "15,290",
          "high_price": "33,125"
        },
        "2.9": {
          "rap": "10,800",
          "low_price": "15,835",
          "high_price": "34,305"
        },
        "3.0": {
          "rap": "15,500",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "3.1": {
          "rap": "15,500",
          "low_price": "29,760",
          "high_price": "64,480"
        },
        "3.2": {
          "rap": "15,500",
          "low_price": "30,720",
          "high_price": "66,560"
        },
        "3.3": {
          "rap": "15,500",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "3.4": {
          "rap": "15,500",
          "low_price": "32,640",
          "high_price": "70,720"
        },
        "3.5": {
          "rap": "15,500",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "3.6": {
          "rap": "15,500",
          "low_price": "34,560",
          "high_price": "74,880"
        },
        "3.7": {
          "rap": "15,500",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.8": {
          "rap": "15,500",
          "low_price": "36,480",
          "high_price": "79,040"
        },
        "3.9": {
          "rap": "15,500",
          "low_price": "37,440",
          "high_price": "81,120"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,800",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,800",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "3,800",
          "low_price": "1,460",
          "high_price": "3,160"
        },
        "1.0": {
          "rap": "4,700",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.1": {
          "rap": "4,700",
          "low_price": "2,180",
          "high_price": "4,720"
        },
        "1.2": {
          "rap": "4,700",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.3": {
          "rap": "4,700",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.4": {
          "rap": "4,700",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.5": {
          "rap": "7,800",
          "low_price": "5,040",
          "high_price": "10,920"
        },
        "1.6": {
          "rap": "7,800",
          "low_price": "5,375",
          "high_price": "11,650"
        },
        "1.7": {
          "rap": "7,800",
          "low_price": "5,710",
          "high_price": "12,375"
        },
        "1.8": {
          "rap": "7,800",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.9": {
          "rap": "7,800",
          "low_price": "6,385",
          "high_price": "13,830"
        },
        "2.0": {
          "rap": "10,300",
          "low_price": "10,320",
          "high_price": "22,360"
        },
        "2.1": {
          "rap": "10,300",
          "low_price": "10,835",
          "high_price": "23,480"
        },
        "2.2": {
          "rap": "10,300",
          "low_price": "11,350",
          "high_price": "24,595"
        },
        "2.3": {
          "rap": "10,300",
          "low_price": "11,870",
          "high_price": "25,715"
        },
        "2.4": {
          "rap": "10,300",
          "low_price": "12,385",
          "high_price": "26,830"
        },
        "2.5": {
          "rap": "10,300",
          "low_price": "12,900",
          "high_price": "27,950"
        },
        "2.6": {
          "rap": "10,300",
          "low_price": "13,415",
          "high_price": "29,070"
        },
        "2.7": {
          "rap": "10,300",
          "low_price": "13,930",
          "high_price": "30,185"
        },
        "2.8": {
          "rap": "10,300",
          "low_price": "14,450",
          "high_price": "31,305"
        },
        "2.9": {
          "rap": "10,300",
          "low_price": "14,965",
          "high_price": "32,420"
        },
        "3.0": {
          "rap": "14,500",
          "low_price": "27,000",
          "high_price": "58,500"
        },
        "3.1": {
          "rap": "14,500",
          "low_price": "27,900",
          "high_price": "60,450"
        },
        "3.2": {
          "rap": "14,500",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "3.3": {
          "rap": "14,500",
          "low_price": "29,700",
          "high_price": "64,350"
        },
        "3.4": {
          "rap": "14,500",
          "low_price": "30,600",
          "high_price": "66,300"
        },
        "3.5": {
          "rap": "14,500",
          "low_price": "31,500",
          "high_price": "68,250"
        },
        "3.6": {
          "rap": "14,500",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "3.7": {
          "rap": "14,500",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.8": {
          "rap": "14,500",
          "low_price": "34,200",
          "high_price": "74,100"
        },
        "3.9": {
          "rap": "14,500",
          "low_price": "35,100",
          "high_price": "76,050"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,300",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,600",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,600",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,350",
          "high_price": "2,925"
        },
        "1.0": {
          "rap": "4,400",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "4,400",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "4,400",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "4,400",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "4,400",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "7,400",
          "low_price": "4,680",
          "high_price": "10,140"
        },
        "1.6": {
          "rap": "7,400",
          "low_price": "4,990",
          "high_price": "10,815"
        },
        "1.7": {
          "rap": "7,400",
          "low_price": "5,305",
          "high_price": "11,490"
        },
        "1.8": {
          "rap": "7,400",
          "low_price": "5,615",
          "high_price": "12,170"
        },
        "1.9": {
          "rap": "7,400",
          "low_price": "5,930",
          "high_price": "12,845"
        },
        "2.0": {
          "rap": "9,600",
          "low_price": "9,840",
          "high_price": "21,320"
        },
        "2.1": {
          "rap": "9,600",
          "low_price": "10,330",
          "high_price": "22,385"
        },
        "2.2": {
          "rap": "9,600",
          "low_price": "10,825",
          "high_price": "23,450"
        },
        "2.3": {
          "rap": "9,600",
          "low_price": "11,315",
          "high_price": "24,520"
        },
        "2.4": {
          "rap": "9,600",
          "low_price": "11,810",
          "high_price": "25,585"
        },
        "2.5": {
          "rap": "9,600",
          "low_price": "12,300",
          "high_price": "26,650"
        },
        "2.6": {
          "rap": "9,600",
          "low_price": "12,790",
          "high_price": "27,715"
        },
        "2.7": {
          "rap": "9,600",
          "low_price": "13,285",
          "high_price": "28,780"
        },
        "2.8": {
          "rap": "9,600",
          "low_price": "13,775",
          "high_price": "29,850"
        },
        "2.9": {
          "rap": "9,600",
          "low_price": "14,270",
          "high_price": "30,915"
        },
        "3.0": {
          "rap": "13,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "3.1": {
          "rap": "13,500",
          "low_price": "26,040",
          "high_price": "56,420"
        },
        "3.2": {
          "rap": "13,500",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "3.3": {
          "rap": "13,500",
          "low_price": "27,720",
          "high_price": "60,060"
        },
        "3.4": {
          "rap": "13,500",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "3.5": {
          "rap": "13,500",
          "low_price": "29,400",
          "high_price": "63,700"
        },
        "3.6": {
          "rap": "13,500",
          "low_price": "30,240",
          "high_price": "65,520"
        },
        "3.7": {
          "rap": "13,500",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "3.8": {
          "rap": "13,500",
          "low_price": "31,920",
          "high_price": "69,160"
        },
        "3.9": {
          "rap": "13,500",
          "low_price": "32,760",
          "high_price": "70,980"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,200",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,500",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,400",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,400",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "3,200",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "4,000",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "1.1": {
          "rap": "4,000",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.2": {
          "rap": "4,000",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.3": {
          "rap": "4,000",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.4": {
          "rap": "4,000",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "1.5": {
          "rap": "6,700",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "6,700",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "6,700",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "6,700",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "6,700",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "8,900",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "2.1": {
          "rap": "8,900",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "2.2": {
          "rap": "8,900",
          "low_price": "9,900",
          "high_price": "21,450"
        },
        "2.3": {
          "rap": "8,900",
          "low_price": "10,350",
          "high_price": "22,425"
        },
        "2.4": {
          "rap": "8,900",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "2.5": {
          "rap": "8,900",
          "low_price": "11,250",
          "high_price": "24,375"
        },
        "2.6": {
          "rap": "8,900",
          "low_price": "11,700",
          "high_price": "25,350"
        },
        "2.7": {
          "rap": "8,900",
          "low_price": "12,150",
          "high_price": "26,325"
        },
        "2.8": {
          "rap": "8,900",
          "low_price": "12,600",
          "high_price": "27,300"
        },
        "2.9": {
          "rap": "8,900",
          "low_price": "13,050",
          "high_price": "28,275"
        },
        "3.0": {
          "rap": "12,000",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "3.1": {
          "rap": "12,000",
          "low_price": "23,250",
          "high_price": "50,375"
        },
        "3.2": {
          "rap": "12,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "3.3": {
          "rap": "12,000",
          "low_price": "24,750",
          "high_price": "53,625"
        },
        "3.4": {
          "rap": "12,000",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "3.5": {
          "rap": "12,000",
          "low_price": "26,250",
          "high_price": "56,875"
        },
        "3.6": {
          "rap": "12,000",
          "low_price": "27,000",
          "high_price": "58,500"
        },
        "3.7": {
          "rap": "12,000",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "3.8": {
          "rap": "12,000",
          "low_price": "28,500",
          "high_price": "61,750"
        },
        "3.9": {
          "rap": "12,000",
          "low_price": "29,250",
          "high_price": "63,375"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,100",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,700",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "3,300",
          "low_price": "1,500",
          "high_price": "3,250"
        },
        "1.1": {
          "rap": "3,300",
          "low_price": "1,650",
          "high_price": "3,575"
        },
        "1.2": {
          "rap": "3,300",
          "low_price": "1,800",
          "high_price": "3,900"
        },
        "1.3": {
          "rap": "3,300",
          "low_price": "1,950",
          "high_price": "4,225"
        },
        "1.4": {
          "rap": "3,300",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "1.5": {
          "rap": "5,500",
          "low_price": "3,960",
          "high_price": "8,580"
        },
        "1.6": {
          "rap": "5,500",
          "low_price": "4,225",
          "high_price": "9,150"
        },
        "1.7": {
          "rap": "5,500",
          "low_price": "4,490",
          "high_price": "9,725"
        },
        "1.8": {
          "rap": "5,500",
          "low_price": "4,750",
          "high_price": "10,295"
        },
        "1.9": {
          "rap": "5,500",
          "low_price": "5,015",
          "high_price": "10,870"
        },
        "2.0": {
          "rap": "7,400",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.1": {
          "rap": "7,400",
          "low_price": "7,940",
          "high_price": "17,200"
        },
        "2.2": {
          "rap": "7,400",
          "low_price": "8,315",
          "high_price": "18,020"
        },
        "2.3": {
          "rap": "7,400",
          "low_price": "8,695",
          "high_price": "18,835"
        },
        "2.4": {
          "rap": "7,400",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "2.5": {
          "rap": "7,400",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "2.6": {
          "rap": "7,400",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "2.7": {
          "rap": "7,400",
          "low_price": "10,205",
          "high_price": "22,115"
        },
        "2.8": {
          "rap": "7,400",
          "low_price": "10,585",
          "high_price": "22,930"
        },
        "2.9": {
          "rap": "7,400",
          "low_price": "10,960",
          "high_price": "23,750"
        },
        "3.0": {
          "rap": "10,200",
          "low_price": "18,360",
          "high_price": "39,780"
        },
        "3.1": {
          "rap": "10,200",
          "low_price": "18,970",
          "high_price": "41,105"
        },
        "3.2": {
          "rap": "10,200",
          "low_price": "19,585",
          "high_price": "42,430"
        },
        "3.3": {
          "rap": "10,200",
          "low_price": "20,195",
          "high_price": "43,760"
        },
        "3.4": {
          "rap": "10,200",
          "low_price": "20,810",
          "high_price": "45,085"
        },
        "3.5": {
          "rap": "10,200",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "3.6": {
          "rap": "10,200",
          "low_price": "22,030",
          "high_price": "47,735"
        },
        "3.7": {
          "rap": "10,200",
          "low_price": "22,645",
          "high_price": "49,060"
        },
        "3.8": {
          "rap": "10,200",
          "low_price": "23,255",
          "high_price": "50,390"
        },
        "3.9": {
          "rap": "10,200",
          "low_price": "23,870",
          "high_price": "51,715"
        }
      },
      "K": {
        "0.4": {
          "rap": "900",
          "low_price": "215",
          "high_price": "470"
        },
        "0.5": {
          "rap": "1,300",
          "low_price": "330",
          "high_price": "715"
        },
        "0.6": {
          "rap": "1,300",
          "low_price": "395",
          "high_price": "860"
        },
        "0.7": {
          "rap": "1,900",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.8": {
          "rap": "1,900",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.9": {
          "rap": "2,300",
          "low_price": "1,025",
          "high_price": "2,225"
        },
        "1.0": {
          "rap": "2,700",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "1.1": {
          "rap": "2,700",
          "low_price": "1,450",
          "high_price": "3,145"
        },
        "1.2": {
          "rap": "2,700",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.3": {
          "rap": "2,700",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.4": {
          "rap": "2,700",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.5": {
          "rap": "4,400",
          "low_price": "3,330",
          "high_price": "7,215"
        },
        "1.6": {
          "rap": "4,400",
          "low_price": "3,550",
          "high_price": "7,695"
        },
        "1.7": {
          "rap": "4,400",
          "low_price": "3,775",
          "high_price": "8,175"
        },
        "1.8": {
          "rap": "4,400",
          "low_price": "3,995",
          "high_price": "8,660"
        },
        "1.9": {
          "rap": "4,400",
          "low_price": "4,220",
          "high_price": "9,140"
        },
        "2.0": {
          "rap": "6,000",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "2.1": {
          "rap": "6,000",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "2.2": {
          "rap": "6,000",
          "low_price": "6,730",
          "high_price": "14,585"
        },
        "2.3": {
          "rap": "6,000",
          "low_price": "7,040",
          "high_price": "15,250"
        },
        "2.4": {
          "rap": "6,000",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "2.5": {
          "rap": "6,000",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "2.6": {
          "rap": "6,000",
          "low_price": "7,955",
          "high_price": "17,240"
        },
        "2.7": {
          "rap": "6,000",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "2.8": {
          "rap": "6,000",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "2.9": {
          "rap": "6,000",
          "low_price": "8,875",
          "high_price": "19,225"
        },
        "3.0": {
          "rap": "8,200",
          "low_price": "14,760",
          "high_price": "31,980"
        },
        "3.1": {
          "rap": "8,200",
          "low_price": "15,250",
          "high_price": "33,045"
        },
        "3.2": {
          "rap": "8,200",
          "low_price": "15,745",
          "high_price": "34,110"
        },
        "3.3": {
          "rap": "8,200",
          "low_price": "16,235",
          "high_price": "35,180"
        },
        "3.4": {
          "rap": "8,200",
          "low_price": "16,730",
          "high_price": "36,245"
        },
        "3.5": {
          "rap": "8,200",
          "low_price": "17,220",
          "high_price": "37,310"
        },
        "3.6": {
          "rap": "8,200",
          "low_price": "17,710",
          "high_price": "38,375"
        },
        "3.7": {
          "rap": "8,200",
          "low_price": "18,205",
          "high_price": "39,440"
        },
        "3.8": {
          "rap": "8,200",
          "low_price": "18,695",
          "high_price": "40,510"
        },
        "3.9": {
          "rap": "8,200",
          "low_price": "19,190",
          "high_price": "41,575"
        }
      }
    },
    "SI3": {
      "D": {
        "0.4": {
          "rap": "1,500",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,100",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,100",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "3,700",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "4,300",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "1.1": {
          "rap": "4,300",
          "low_price": "2,310",
          "high_price": "5,005"
        },
        "1.2": {
          "rap": "4,300",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.3": {
          "rap": "4,300",
          "low_price": "2,730",
          "high_price": "5,915"
        },
        "1.4": {
          "rap": "4,300",
          "low_price": "2,940",
          "high_price": "6,370"
        },
        "1.5": {
          "rap": "7,100",
          "low_price": "5,310",
          "high_price": "11,505"
        },
        "1.6": {
          "rap": "7,100",
          "low_price": "5,665",
          "high_price": "12,270"
        },
        "1.7": {
          "rap": "7,100",
          "low_price": "6,020",
          "high_price": "13,040"
        },
        "1.8": {
          "rap": "7,100",
          "low_price": "6,370",
          "high_price": "13,805"
        },
        "1.9": {
          "rap": "7,100",
          "low_price": "6,725",
          "high_price": "14,575"
        },
        "2.0": {
          "rap": "8,800",
          "low_price": "9,840",
          "high_price": "21,320"
        },
        "2.1": {
          "rap": "8,800",
          "low_price": "10,330",
          "high_price": "22,385"
        },
        "2.2": {
          "rap": "8,800",
          "low_price": "10,825",
          "high_price": "23,450"
        },
        "2.3": {
          "rap": "8,800",
          "low_price": "11,315",
          "high_price": "24,520"
        },
        "2.4": {
          "rap": "8,800",
          "low_price": "11,810",
          "high_price": "25,585"
        },
        "2.5": {
          "rap": "8,800",
          "low_price": "12,300",
          "high_price": "26,650"
        },
        "2.6": {
          "rap": "8,800",
          "low_price": "12,790",
          "high_price": "27,715"
        },
        "2.7": {
          "rap": "8,800",
          "low_price": "13,285",
          "high_price": "28,780"
        },
        "2.8": {
          "rap": "8,800",
          "low_price": "13,775",
          "high_price": "29,850"
        },
        "2.9": {
          "rap": "8,800",
          "low_price": "14,270",
          "high_price": "30,915"
        },
        "3.0": {
          "rap": "11,800",
          "low_price": "21,960",
          "high_price": "47,580"
        },
        "3.1": {
          "rap": "11,800",
          "low_price": "22,690",
          "high_price": "49,165"
        },
        "3.2": {
          "rap": "11,800",
          "low_price": "23,425",
          "high_price": "50,750"
        },
        "3.3": {
          "rap": "11,800",
          "low_price": "24,155",
          "high_price": "52,340"
        },
        "3.4": {
          "rap": "11,800",
          "low_price": "24,890",
          "high_price": "53,925"
        },
        "3.5": {
          "rap": "11,800",
          "low_price": "25,620",
          "high_price": "55,510"
        },
        "3.6": {
          "rap": "11,800",
          "low_price": "26,350",
          "high_price": "57,095"
        },
        "3.7": {
          "rap": "11,800",
          "low_price": "27,085",
          "high_price": "58,680"
        },
        "3.8": {
          "rap": "11,800",
          "low_price": "27,815",
          "high_price": "60,270"
        },
        "3.9": {
          "rap": "11,800",
          "low_price": "28,550",
          "high_price": "61,855"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "2,900",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "2,900",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "1.0": {
          "rap": "4,100",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.1": {
          "rap": "4,100",
          "low_price": "2,180",
          "high_price": "4,720"
        },
        "1.2": {
          "rap": "4,100",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.3": {
          "rap": "4,100",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.4": {
          "rap": "4,100",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.5": {
          "rap": "6,600",
          "low_price": "4,950",
          "high_price": "10,725"
        },
        "1.6": {
          "rap": "6,600",
          "low_price": "5,280",
          "high_price": "11,440"
        },
        "1.7": {
          "rap": "6,600",
          "low_price": "5,610",
          "high_price": "12,155"
        },
        "1.8": {
          "rap": "6,600",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "1.9": {
          "rap": "6,600",
          "low_price": "6,270",
          "high_price": "13,585"
        },
        "2.0": {
          "rap": "8,400",
          "low_price": "9,360",
          "high_price": "20,280"
        },
        "2.1": {
          "rap": "8,400",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "2.2": {
          "rap": "8,400",
          "low_price": "10,295",
          "high_price": "22,310"
        },
        "2.3": {
          "rap": "8,400",
          "low_price": "10,765",
          "high_price": "23,320"
        },
        "2.4": {
          "rap": "8,400",
          "low_price": "11,230",
          "high_price": "24,335"
        },
        "2.5": {
          "rap": "8,400",
          "low_price": "11,700",
          "high_price": "25,350"
        },
        "2.6": {
          "rap": "8,400",
          "low_price": "12,170",
          "high_price": "26,365"
        },
        "2.7": {
          "rap": "8,400",
          "low_price": "12,635",
          "high_price": "27,380"
        },
        "2.8": {
          "rap": "8,400",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.9": {
          "rap": "8,400",
          "low_price": "13,570",
          "high_price": "29,405"
        },
        "3.0": {
          "rap": "10,900",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "3.1": {
          "rap": "10,900",
          "low_price": "20,830",
          "high_price": "45,135"
        },
        "3.2": {
          "rap": "10,900",
          "low_price": "21,505",
          "high_price": "46,590"
        },
        "3.3": {
          "rap": "10,900",
          "low_price": "22,175",
          "high_price": "48,050"
        },
        "3.4": {
          "rap": "10,900",
          "low_price": "22,850",
          "high_price": "49,505"
        },
        "3.5": {
          "rap": "10,900",
          "low_price": "23,520",
          "high_price": "50,960"
        },
        "3.6": {
          "rap": "10,900",
          "low_price": "24,190",
          "high_price": "52,415"
        },
        "3.7": {
          "rap": "10,900",
          "low_price": "24,865",
          "high_price": "53,870"
        },
        "3.8": {
          "rap": "10,900",
          "low_price": "25,535",
          "high_price": "55,330"
        },
        "3.9": {
          "rap": "10,900",
          "low_price": "26,210",
          "high_price": "56,785"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,300",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,700",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,700",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "3,300",
          "low_price": "1,405",
          "high_price": "3,040"
        },
        "1.0": {
          "rap": "3,900",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "3,900",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "3,900",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "3,900",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "3,900",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "6,100",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.6": {
          "rap": "6,100",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.7": {
          "rap": "6,100",
          "low_price": "5,200",
          "high_price": "11,270"
        },
        "1.8": {
          "rap": "6,100",
          "low_price": "5,510",
          "high_price": "11,935"
        },
        "1.9": {
          "rap": "6,100",
          "low_price": "5,815",
          "high_price": "12,595"
        },
        "2.0": {
          "rap": "8,000",
          "low_price": "8,880",
          "high_price": "19,240"
        },
        "2.1": {
          "rap": "8,000",
          "low_price": "9,325",
          "high_price": "20,200"
        },
        "2.2": {
          "rap": "8,000",
          "low_price": "9,770",
          "high_price": "21,165"
        },
        "2.3": {
          "rap": "8,000",
          "low_price": "10,210",
          "high_price": "22,125"
        },
        "2.4": {
          "rap": "8,000",
          "low_price": "10,655",
          "high_price": "23,090"
        },
        "2.5": {
          "rap": "8,000",
          "low_price": "11,100",
          "high_price": "24,050"
        },
        "2.6": {
          "rap": "8,000",
          "low_price": "11,545",
          "high_price": "25,010"
        },
        "2.7": {
          "rap": "8,000",
          "low_price": "11,990",
          "high_price": "25,975"
        },
        "2.8": {
          "rap": "8,000",
          "low_price": "12,430",
          "high_price": "26,935"
        },
        "2.9": {
          "rap": "8,000",
          "low_price": "12,875",
          "high_price": "27,900"
        },
        "3.0": {
          "rap": "10,100",
          "low_price": "18,720",
          "high_price": "40,560"
        },
        "3.1": {
          "rap": "10,100",
          "low_price": "19,345",
          "high_price": "41,910"
        },
        "3.2": {
          "rap": "10,100",
          "low_price": "19,970",
          "high_price": "43,265"
        },
        "3.3": {
          "rap": "10,100",
          "low_price": "20,590",
          "high_price": "44,615"
        },
        "3.4": {
          "rap": "10,100",
          "low_price": "21,215",
          "high_price": "45,970"
        },
        "3.5": {
          "rap": "10,100",
          "low_price": "21,840",
          "high_price": "47,320"
        },
        "3.6": {
          "rap": "10,100",
          "low_price": "22,465",
          "high_price": "48,670"
        },
        "3.7": {
          "rap": "10,100",
          "low_price": "23,090",
          "high_price": "50,025"
        },
        "3.8": {
          "rap": "10,100",
          "low_price": "23,710",
          "high_price": "51,375"
        },
        "3.9": {
          "rap": "10,100",
          "low_price": "24,335",
          "high_price": "52,730"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,200",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,500",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,500",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "3,100",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "1.0": {
          "rap": "3,700",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "3,700",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "3,700",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "3,700",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "3,700",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "5,700",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "5,700",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "5,700",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "5,700",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "5,700",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "7,500",
          "low_price": "8,400",
          "high_price": "18,200"
        },
        "2.1": {
          "rap": "7,500",
          "low_price": "8,820",
          "high_price": "19,110"
        },
        "2.2": {
          "rap": "7,500",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.3": {
          "rap": "7,500",
          "low_price": "9,660",
          "high_price": "20,930"
        },
        "2.4": {
          "rap": "7,500",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.5": {
          "rap": "7,500",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "2.6": {
          "rap": "7,500",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.7": {
          "rap": "7,500",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.8": {
          "rap": "7,500",
          "low_price": "11,760",
          "high_price": "25,480"
        },
        "2.9": {
          "rap": "7,500",
          "low_price": "12,180",
          "high_price": "26,390"
        },
        "3.0": {
          "rap": "9,200",
          "low_price": "17,100",
          "high_price": "37,050"
        },
        "3.1": {
          "rap": "9,200",
          "low_price": "17,670",
          "high_price": "38,285"
        },
        "3.2": {
          "rap": "9,200",
          "low_price": "18,240",
          "high_price": "39,520"
        },
        "3.3": {
          "rap": "9,200",
          "low_price": "18,810",
          "high_price": "40,755"
        },
        "3.4": {
          "rap": "9,200",
          "low_price": "19,380",
          "high_price": "41,990"
        },
        "3.5": {
          "rap": "9,200",
          "low_price": "19,950",
          "high_price": "43,225"
        },
        "3.6": {
          "rap": "9,200",
          "low_price": "20,520",
          "high_price": "44,460"
        },
        "3.7": {
          "rap": "9,200",
          "low_price": "21,090",
          "high_price": "45,695"
        },
        "3.8": {
          "rap": "9,200",
          "low_price": "21,660",
          "high_price": "46,930"
        },
        "3.9": {
          "rap": "9,200",
          "low_price": "22,230",
          "high_price": "48,165"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,100",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,500",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,900",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "1.0": {
          "rap": "3,500",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.1": {
          "rap": "3,500",
          "low_price": "1,780",
          "high_price": "3,860"
        },
        "1.2": {
          "rap": "3,500",
          "low_price": "1,945",
          "high_price": "4,210"
        },
        "1.3": {
          "rap": "3,500",
          "low_price": "2,105",
          "high_price": "4,565"
        },
        "1.4": {
          "rap": "3,500",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.5": {
          "rap": "5,400",
          "low_price": "4,050",
          "high_price": "8,775"
        },
        "1.6": {
          "rap": "5,400",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.7": {
          "rap": "5,400",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.8": {
          "rap": "5,400",
          "low_price": "4,860",
          "high_price": "10,530"
        },
        "1.9": {
          "rap": "5,400",
          "low_price": "5,130",
          "high_price": "11,115"
        },
        "2.0": {
          "rap": "6,700",
          "low_price": "7,680",
          "high_price": "16,640"
        },
        "2.1": {
          "rap": "6,700",
          "low_price": "8,065",
          "high_price": "17,470"
        },
        "2.2": {
          "rap": "6,700",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "2.3": {
          "rap": "6,700",
          "low_price": "8,830",
          "high_price": "19,135"
        },
        "2.4": {
          "rap": "6,700",
          "low_price": "9,215",
          "high_price": "19,970"
        },
        "2.5": {
          "rap": "6,700",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "2.6": {
          "rap": "6,700",
          "low_price": "9,985",
          "high_price": "21,630"
        },
        "2.7": {
          "rap": "6,700",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "2.8": {
          "rap": "6,700",
          "low_price": "10,750",
          "high_price": "23,295"
        },
        "2.9": {
          "rap": "6,700",
          "low_price": "11,135",
          "high_price": "24,130"
        },
        "3.0": {
          "rap": "8,500",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "3.1": {
          "rap": "8,500",
          "low_price": "16,370",
          "high_price": "35,465"
        },
        "3.2": {
          "rap": "8,500",
          "low_price": "16,895",
          "high_price": "36,610"
        },
        "3.3": {
          "rap": "8,500",
          "low_price": "17,425",
          "high_price": "37,750"
        },
        "3.4": {
          "rap": "8,500",
          "low_price": "17,950",
          "high_price": "38,895"
        },
        "3.5": {
          "rap": "8,500",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "3.6": {
          "rap": "8,500",
          "low_price": "19,010",
          "high_price": "41,185"
        },
        "3.7": {
          "rap": "8,500",
          "low_price": "19,535",
          "high_price": "42,330"
        },
        "3.8": {
          "rap": "8,500",
          "low_price": "20,065",
          "high_price": "43,470"
        },
        "3.9": {
          "rap": "8,500",
          "low_price": "20,590",
          "high_price": "44,615"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,000",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,700",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "3,200",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "1.1": {
          "rap": "3,200",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.2": {
          "rap": "3,200",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.3": {
          "rap": "3,200",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.4": {
          "rap": "3,200",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.5": {
          "rap": "5,000",
          "low_price": "3,780",
          "high_price": "8,190"
        },
        "1.6": {
          "rap": "5,000",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.7": {
          "rap": "5,000",
          "low_price": "4,285",
          "high_price": "9,280"
        },
        "1.8": {
          "rap": "5,000",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.9": {
          "rap": "5,000",
          "low_price": "4,790",
          "high_price": "10,375"
        },
        "2.0": {
          "rap": "6,000",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "2.1": {
          "rap": "6,000",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.2": {
          "rap": "6,000",
          "low_price": "7,525",
          "high_price": "16,300"
        },
        "2.3": {
          "rap": "6,000",
          "low_price": "7,865",
          "high_price": "17,045"
        },
        "2.4": {
          "rap": "6,000",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "2.5": {
          "rap": "6,000",
          "low_price": "8,550",
          "high_price": "18,525"
        },
        "2.6": {
          "rap": "6,000",
          "low_price": "8,890",
          "high_price": "19,265"
        },
        "2.7": {
          "rap": "6,000",
          "low_price": "9,235",
          "high_price": "20,005"
        },
        "2.8": {
          "rap": "6,000",
          "low_price": "9,575",
          "high_price": "20,750"
        },
        "2.9": {
          "rap": "6,000",
          "low_price": "9,920",
          "high_price": "21,490"
        },
        "3.0": {
          "rap": "7,900",
          "low_price": "14,580",
          "high_price": "31,590"
        },
        "3.1": {
          "rap": "7,900",
          "low_price": "15,065",
          "high_price": "32,645"
        },
        "3.2": {
          "rap": "7,900",
          "low_price": "15,550",
          "high_price": "33,695"
        },
        "3.3": {
          "rap": "7,900",
          "low_price": "16,040",
          "high_price": "34,750"
        },
        "3.4": {
          "rap": "7,900",
          "low_price": "16,525",
          "high_price": "35,800"
        },
        "3.5": {
          "rap": "7,900",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "3.6": {
          "rap": "7,900",
          "low_price": "17,495",
          "high_price": "37,910"
        },
        "3.7": {
          "rap": "7,900",
          "low_price": "17,980",
          "high_price": "38,960"
        },
        "3.8": {
          "rap": "7,900",
          "low_price": "18,470",
          "high_price": "40,015"
        },
        "3.9": {
          "rap": "7,900",
          "low_price": "18,955",
          "high_price": "41,065"
        }
      },
      "J": {
        "0.4": {
          "rap": "900",
          "low_price": "215",
          "high_price": "470"
        },
        "0.5": {
          "rap": "1,300",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,300",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "1,900",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.8": {
          "rap": "1,900",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.9": {
          "rap": "2,300",
          "low_price": "1,025",
          "high_price": "2,225"
        },
        "1.0": {
          "rap": "2,700",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "1.1": {
          "rap": "2,700",
          "low_price": "1,450",
          "high_price": "3,145"
        },
        "1.2": {
          "rap": "2,700",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.3": {
          "rap": "2,700",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.4": {
          "rap": "2,700",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.5": {
          "rap": "4,400",
          "low_price": "3,420",
          "high_price": "7,410"
        },
        "1.6": {
          "rap": "4,400",
          "low_price": "3,650",
          "high_price": "7,905"
        },
        "1.7": {
          "rap": "4,400",
          "low_price": "3,875",
          "high_price": "8,400"
        },
        "1.8": {
          "rap": "4,400",
          "low_price": "4,105",
          "high_price": "8,890"
        },
        "1.9": {
          "rap": "4,400",
          "low_price": "4,330",
          "high_price": "9,385"
        },
        "2.0": {
          "rap": "5,400",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "2.1": {
          "rap": "5,400",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "2.2": {
          "rap": "5,400",
          "low_price": "6,730",
          "high_price": "14,585"
        },
        "2.3": {
          "rap": "5,400",
          "low_price": "7,040",
          "high_price": "15,250"
        },
        "2.4": {
          "rap": "5,400",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "2.5": {
          "rap": "5,400",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "2.6": {
          "rap": "5,400",
          "low_price": "7,955",
          "high_price": "17,240"
        },
        "2.7": {
          "rap": "5,400",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "2.8": {
          "rap": "5,400",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "2.9": {
          "rap": "5,400",
          "low_price": "8,875",
          "high_price": "19,225"
        },
        "3.0": {
          "rap": "7,100",
          "low_price": "12,780",
          "high_price": "27,690"
        },
        "3.1": {
          "rap": "7,100",
          "low_price": "13,205",
          "high_price": "28,615"
        },
        "3.2": {
          "rap": "7,100",
          "low_price": "13,630",
          "high_price": "29,535"
        },
        "3.3": {
          "rap": "7,100",
          "low_price": "14,060",
          "high_price": "30,460"
        },
        "3.4": {
          "rap": "7,100",
          "low_price": "14,485",
          "high_price": "31,380"
        },
        "3.5": {
          "rap": "7,100",
          "low_price": "14,910",
          "high_price": "32,305"
        },
        "3.6": {
          "rap": "7,100",
          "low_price": "15,335",
          "high_price": "33,230"
        },
        "3.7": {
          "rap": "7,100",
          "low_price": "15,760",
          "high_price": "34,150"
        },
        "3.8": {
          "rap": "7,100",
          "low_price": "16,190",
          "high_price": "35,075"
        },
        "3.9": {
          "rap": "7,100",
          "low_price": "16,615",
          "high_price": "35,995"
        }
      },
      "K": {
        "0.4": {
          "rap": "800",
          "low_price": "190",
          "high_price": "415"
        },
        "0.5": {
          "rap": "1,100",
          "low_price": "300",
          "high_price": "650"
        },
        "0.6": {
          "rap": "1,100",
          "low_price": "360",
          "high_price": "780"
        },
        "0.7": {
          "rap": "1,700",
          "low_price": "590",
          "high_price": "1,275"
        },
        "0.8": {
          "rap": "1,700",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.9": {
          "rap": "2,000",
          "low_price": "920",
          "high_price": "1,990"
        },
        "1.0": {
          "rap": "2,300",
          "low_price": "1,140",
          "high_price": "2,470"
        },
        "1.1": {
          "rap": "2,300",
          "low_price": "1,255",
          "high_price": "2,715"
        },
        "1.2": {
          "rap": "2,300",
          "low_price": "1,370",
          "high_price": "2,965"
        },
        "1.3": {
          "rap": "2,300",
          "low_price": "1,480",
          "high_price": "3,210"
        },
        "1.4": {
          "rap": "2,300",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "1.5": {
          "rap": "3,700",
          "low_price": "2,970",
          "high_price": "6,435"
        },
        "1.6": {
          "rap": "3,700",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.7": {
          "rap": "3,700",
          "low_price": "3,365",
          "high_price": "7,295"
        },
        "1.8": {
          "rap": "3,700",
          "low_price": "3,565",
          "high_price": "7,720"
        },
        "1.9": {
          "rap": "3,700",
          "low_price": "3,760",
          "high_price": "8,150"
        },
        "2.0": {
          "rap": "4,700",
          "low_price": "5,160",
          "high_price": "11,180"
        },
        "2.1": {
          "rap": "4,700",
          "low_price": "5,420",
          "high_price": "11,740"
        },
        "2.2": {
          "rap": "4,700",
          "low_price": "5,675",
          "high_price": "12,300"
        },
        "2.3": {
          "rap": "4,700",
          "low_price": "5,935",
          "high_price": "12,855"
        },
        "2.4": {
          "rap": "4,700",
          "low_price": "6,190",
          "high_price": "13,415"
        },
        "2.5": {
          "rap": "4,700",
          "low_price": "6,450",
          "high_price": "13,975"
        },
        "2.6": {
          "rap": "4,700",
          "low_price": "6,710",
          "high_price": "14,535"
        },
        "2.7": {
          "rap": "4,700",
          "low_price": "6,965",
          "high_price": "15,095"
        },
        "2.8": {
          "rap": "4,700",
          "low_price": "7,225",
          "high_price": "15,650"
        },
        "2.9": {
          "rap": "4,700",
          "low_price": "7,480",
          "high_price": "16,210"
        },
        "3.0": {
          "rap": "6,100",
          "low_price": "10,980",
          "high_price": "23,790"
        },
        "3.1": {
          "rap": "6,100",
          "low_price": "11,345",
          "high_price": "24,585"
        },
        "3.2": {
          "rap": "6,100",
          "low_price": "11,710",
          "high_price": "25,375"
        },
        "3.3": {
          "rap": "6,100",
          "low_price": "12,080",
          "high_price": "26,170"
        },
        "3.4": {
          "rap": "6,100",
          "low_price": "12,445",
          "high_price": "26,960"
        },
        "3.5": {
          "rap": "6,100",
          "low_price": "12,810",
          "high_price": "27,755"
        },
        "3.6": {
          "rap": "6,100",
          "low_price": "13,175",
          "high_price": "28,550"
        },
        "3.7": {
          "rap": "6,100",
          "low_price": "13,540",
          "high_price": "29,340"
        },
        "3.8": {
          "rap": "6,100",
          "low_price": "13,910",
          "high_price": "30,135"
        },
        "3.9": {
          "rap": "6,100",
          "low_price": "14,275",
          "high_price": "30,925"
        }
      }
    },
    "VS1": {
      "D": {
        "0.4": {
          "rap": "2,600",
          "low_price": "530",
          "high_price": "1,145"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,555",
          "high_price": "3,365"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,775",
          "high_price": "3,850"
        },
        "0.9": {
          "rap": "6,500",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "8,500",
          "low_price": "4,020",
          "high_price": "8,710"
        },
        "1.1": {
          "rap": "8,500",
          "low_price": "4,420",
          "high_price": "9,580"
        },
        "1.2": {
          "rap": "8,500",
          "low_price": "4,825",
          "high_price": "10,450"
        },
        "1.3": {
          "rap": "8,500",
          "low_price": "5,225",
          "high_price": "11,325"
        },
        "1.4": {
          "rap": "8,500",
          "low_price": "5,630",
          "high_price": "12,195"
        },
        "1.5": {
          "rap": "13,600",
          "low_price": "10,440",
          "high_price": "22,620"
        },
        "1.6": {
          "rap": "13,600",
          "low_price": "11,135",
          "high_price": "24,130"
        },
        "1.7": {
          "rap": "13,600",
          "low_price": "11,830",
          "high_price": "25,635"
        },
        "1.8": {
          "rap": "13,600",
          "low_price": "12,530",
          "high_price": "27,145"
        },
        "1.9": {
          "rap": "13,600",
          "low_price": "13,225",
          "high_price": "28,650"
        },
        "2.0": {
          "rap": "19,000",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.1": {
          "rap": "19,000",
          "low_price": "22,050",
          "high_price": "47,775"
        },
        "2.2": {
          "rap": "19,000",
          "low_price": "23,100",
          "high_price": "50,050"
        },
        "2.3": {
          "rap": "19,000",
          "low_price": "24,150",
          "high_price": "52,325"
        },
        "2.4": {
          "rap": "19,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.5": {
          "rap": "19,000",
          "low_price": "26,250",
          "high_price": "56,875"
        },
        "2.6": {
          "rap": "19,000",
          "low_price": "27,300",
          "high_price": "59,150"
        },
        "2.7": {
          "rap": "19,000",
          "low_price": "28,350",
          "high_price": "61,425"
        },
        "2.8": {
          "rap": "19,000",
          "low_price": "29,400",
          "high_price": "63,700"
        },
        "2.9": {
          "rap": "19,000",
          "low_price": "30,450",
          "high_price": "65,975"
        },
        "3.0": {
          "rap": "30,500",
          "low_price": "54,000",
          "high_price": "117,000"
        },
        "3.1": {
          "rap": "30,500",
          "low_price": "55,800",
          "high_price": "120,900"
        },
        "3.2": {
          "rap": "30,500",
          "low_price": "57,600",
          "high_price": "124,800"
        },
        "3.3": {
          "rap": "30,500",
          "low_price": "59,400",
          "high_price": "128,700"
        },
        "3.4": {
          "rap": "30,500",
          "low_price": "61,200",
          "high_price": "132,600"
        },
        "3.5": {
          "rap": "30,500",
          "low_price": "63,000",
          "high_price": "136,500"
        },
        "3.6": {
          "rap": "30,500",
          "low_price": "64,800",
          "high_price": "140,400"
        },
        "3.7": {
          "rap": "30,500",
          "low_price": "66,600",
          "high_price": "144,300"
        },
        "3.8": {
          "rap": "30,500",
          "low_price": "68,400",
          "high_price": "148,200"
        },
        "3.9": {
          "rap": "30,500",
          "low_price": "70,200",
          "high_price": "152,100"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,400",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "750",
          "high_price": "1,625"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.7": {
          "rap": "4,800",
          "low_price": "1,470",
          "high_price": "3,185"
        },
        "0.8": {
          "rap": "4,800",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.9": {
          "rap": "6,000",
          "low_price": "2,645",
          "high_price": "5,735"
        },
        "1.0": {
          "rap": "8,000",
          "low_price": "3,720",
          "high_price": "8,060"
        },
        "1.1": {
          "rap": "8,000",
          "low_price": "4,090",
          "high_price": "8,865"
        },
        "1.2": {
          "rap": "8,000",
          "low_price": "4,465",
          "high_price": "9,670"
        },
        "1.3": {
          "rap": "8,000",
          "low_price": "4,835",
          "high_price": "10,480"
        },
        "1.4": {
          "rap": "8,000",
          "low_price": "5,210",
          "high_price": "11,285"
        },
        "1.5": {
          "rap": "12,800",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "1.6": {
          "rap": "12,800",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "1.7": {
          "rap": "12,800",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "1.8": {
          "rap": "12,800",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "1.9": {
          "rap": "12,800",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "2.0": {
          "rap": "18,000",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "18,000",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "18,000",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "18,000",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "18,000",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "18,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "18,000",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "18,000",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "18,000",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "18,000",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "28,000",
          "low_price": "49,500",
          "high_price": "107,250"
        },
        "3.1": {
          "rap": "28,000",
          "low_price": "51,150",
          "high_price": "110,825"
        },
        "3.2": {
          "rap": "28,000",
          "low_price": "52,800",
          "high_price": "114,400"
        },
        "3.3": {
          "rap": "28,000",
          "low_price": "54,450",
          "high_price": "117,975"
        },
        "3.4": {
          "rap": "28,000",
          "low_price": "56,100",
          "high_price": "121,550"
        },
        "3.5": {
          "rap": "28,000",
          "low_price": "57,750",
          "high_price": "125,125"
        },
        "3.6": {
          "rap": "28,000",
          "low_price": "59,400",
          "high_price": "128,700"
        },
        "3.7": {
          "rap": "28,000",
          "low_price": "61,050",
          "high_price": "132,275"
        },
        "3.8": {
          "rap": "28,000",
          "low_price": "62,700",
          "high_price": "135,850"
        },
        "3.9": {
          "rap": "28,000",
          "low_price": "64,350",
          "high_price": "139,425"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,300",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,900",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "2,900",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "4,600",
          "low_price": "1,385",
          "high_price": "3,005"
        },
        "0.8": {
          "rap": "4,600",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "0.9": {
          "rap": "5,700",
          "low_price": "2,485",
          "high_price": "5,380"
        },
        "1.0": {
          "rap": "7,500",
          "low_price": "3,480",
          "high_price": "7,540"
        },
        "1.1": {
          "rap": "7,500",
          "low_price": "3,830",
          "high_price": "8,295"
        },
        "1.2": {
          "rap": "7,500",
          "low_price": "4,175",
          "high_price": "9,050"
        },
        "1.3": {
          "rap": "7,500",
          "low_price": "4,525",
          "high_price": "9,800"
        },
        "1.4": {
          "rap": "7,500",
          "low_price": "4,870",
          "high_price": "10,555"
        },
        "1.5": {
          "rap": "12,200",
          "low_price": "9,180",
          "high_price": "19,890"
        },
        "1.6": {
          "rap": "12,200",
          "low_price": "9,790",
          "high_price": "21,215"
        },
        "1.7": {
          "rap": "12,200",
          "low_price": "10,405",
          "high_price": "22,540"
        },
        "1.8": {
          "rap": "12,200",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "1.9": {
          "rap": "12,200",
          "low_price": "11,630",
          "high_price": "25,195"
        },
        "2.0": {
          "rap": "17,000",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.1": {
          "rap": "17,000",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "2.2": {
          "rap": "17,000",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.3": {
          "rap": "17,000",
          "low_price": "20,700",
          "high_price": "44,850"
        },
        "2.4": {
          "rap": "17,000",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "2.5": {
          "rap": "17,000",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "2.6": {
          "rap": "17,000",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.7": {
          "rap": "17,000",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "2.8": {
          "rap": "17,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.9": {
          "rap": "17,000",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.0": {
          "rap": "25,000",
          "low_price": "45,000",
          "high_price": "97,500"
        },
        "3.1": {
          "rap": "25,000",
          "low_price": "46,500",
          "high_price": "100,750"
        },
        "3.2": {
          "rap": "25,000",
          "low_price": "48,000",
          "high_price": "104,000"
        },
        "3.3": {
          "rap": "25,000",
          "low_price": "49,500",
          "high_price": "107,250"
        },
        "3.4": {
          "rap": "25,000",
          "low_price": "51,000",
          "high_price": "110,500"
        },
        "3.5": {
          "rap": "25,000",
          "low_price": "52,500",
          "high_price": "113,750"
        },
        "3.6": {
          "rap": "25,000",
          "low_price": "54,000",
          "high_price": "117,000"
        },
        "3.7": {
          "rap": "25,000",
          "low_price": "55,500",
          "high_price": "120,250"
        },
        "3.8": {
          "rap": "25,000",
          "low_price": "57,000",
          "high_price": "123,500"
        },
        "3.9": {
          "rap": "25,000",
          "low_price": "58,500",
          "high_price": "126,750"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,200",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "2,700",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,700",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,300",
          "low_price": "1,300",
          "high_price": "2,820"
        },
        "0.8": {
          "rap": "4,300",
          "low_price": "1,490",
          "high_price": "3,225"
        },
        "0.9": {
          "rap": "5,400",
          "low_price": "2,320",
          "high_price": "5,030"
        },
        "1.0": {
          "rap": "7,000",
          "low_price": "3,240",
          "high_price": "7,020"
        },
        "1.1": {
          "rap": "7,000",
          "low_price": "3,565",
          "high_price": "7,720"
        },
        "1.2": {
          "rap": "7,000",
          "low_price": "3,890",
          "high_price": "8,425"
        },
        "1.3": {
          "rap": "7,000",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.4": {
          "rap": "7,000",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.5": {
          "rap": "11,200",
          "low_price": "8,370",
          "high_price": "18,135"
        },
        "1.6": {
          "rap": "11,200",
          "low_price": "8,930",
          "high_price": "19,345"
        },
        "1.7": {
          "rap": "11,200",
          "low_price": "9,485",
          "high_price": "20,555"
        },
        "1.8": {
          "rap": "11,200",
          "low_price": "10,045",
          "high_price": "21,760"
        },
        "1.9": {
          "rap": "11,200",
          "low_price": "10,600",
          "high_price": "22,970"
        },
        "2.0": {
          "rap": "15,500",
          "low_price": "16,800",
          "high_price": "36,400"
        },
        "2.1": {
          "rap": "15,500",
          "low_price": "17,640",
          "high_price": "38,220"
        },
        "2.2": {
          "rap": "15,500",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "2.3": {
          "rap": "15,500",
          "low_price": "19,320",
          "high_price": "41,860"
        },
        "2.4": {
          "rap": "15,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.5": {
          "rap": "15,500",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.6": {
          "rap": "15,500",
          "low_price": "21,840",
          "high_price": "47,320"
        },
        "2.7": {
          "rap": "15,500",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.8": {
          "rap": "15,500",
          "low_price": "23,520",
          "high_price": "50,960"
        },
        "2.9": {
          "rap": "15,500",
          "low_price": "24,360",
          "high_price": "52,780"
        },
        "3.0": {
          "rap": "22,500",
          "low_price": "40,500",
          "high_price": "87,750"
        },
        "3.1": {
          "rap": "22,500",
          "low_price": "41,850",
          "high_price": "90,675"
        },
        "3.2": {
          "rap": "22,500",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.3": {
          "rap": "22,500",
          "low_price": "44,550",
          "high_price": "96,525"
        },
        "3.4": {
          "rap": "22,500",
          "low_price": "45,900",
          "high_price": "99,450"
        },
        "3.5": {
          "rap": "22,500",
          "low_price": "47,250",
          "high_price": "102,375"
        },
        "3.6": {
          "rap": "22,500",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.7": {
          "rap": "22,500",
          "low_price": "49,950",
          "high_price": "108,225"
        },
        "3.8": {
          "rap": "22,500",
          "low_price": "51,300",
          "high_price": "111,150"
        },
        "3.9": {
          "rap": "22,500",
          "low_price": "52,650",
          "high_price": "114,075"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,000",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "2,500",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "2,500",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "3,900",
          "low_price": "1,175",
          "high_price": "2,550"
        },
        "0.8": {
          "rap": "3,900",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.9": {
          "rap": "4,900",
          "low_price": "2,105",
          "high_price": "4,565"
        },
        "1.0": {
          "rap": "6,000",
          "low_price": "2,760",
          "high_price": "5,980"
        },
        "1.1": {
          "rap": "6,000",
          "low_price": "3,035",
          "high_price": "6,580"
        },
        "1.2": {
          "rap": "6,000",
          "low_price": "3,310",
          "high_price": "7,175"
        },
        "1.3": {
          "rap": "6,000",
          "low_price": "3,590",
          "high_price": "7,775"
        },
        "1.4": {
          "rap": "6,000",
          "low_price": "3,865",
          "high_price": "8,370"
        },
        "1.5": {
          "rap": "9,500",
          "low_price": "7,110",
          "high_price": "15,405"
        },
        "1.6": {
          "rap": "9,500",
          "low_price": "7,585",
          "high_price": "16,430"
        },
        "1.7": {
          "rap": "9,500",
          "low_price": "8,060",
          "high_price": "17,460"
        },
        "1.8": {
          "rap": "9,500",
          "low_price": "8,530",
          "high_price": "18,485"
        },
        "1.9": {
          "rap": "9,500",
          "low_price": "9,005",
          "high_price": "19,515"
        },
        "2.0": {
          "rap": "13,000",
          "low_price": "13,800",
          "high_price": "29,900"
        },
        "2.1": {
          "rap": "13,000",
          "low_price": "14,490",
          "high_price": "31,395"
        },
        "2.2": {
          "rap": "13,000",
          "low_price": "15,180",
          "high_price": "32,890"
        },
        "2.3": {
          "rap": "13,000",
          "low_price": "15,870",
          "high_price": "34,385"
        },
        "2.4": {
          "rap": "13,000",
          "low_price": "16,560",
          "high_price": "35,880"
        },
        "2.5": {
          "rap": "13,000",
          "low_price": "17,250",
          "high_price": "37,375"
        },
        "2.6": {
          "rap": "13,000",
          "low_price": "17,940",
          "high_price": "38,870"
        },
        "2.7": {
          "rap": "13,000",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.8": {
          "rap": "13,000",
          "low_price": "19,320",
          "high_price": "41,860"
        },
        "2.9": {
          "rap": "13,000",
          "low_price": "20,010",
          "high_price": "43,355"
        },
        "3.0": {
          "rap": "20,000",
          "low_price": "35,100",
          "high_price": "76,050"
        },
        "3.1": {
          "rap": "20,000",
          "low_price": "36,270",
          "high_price": "78,585"
        },
        "3.2": {
          "rap": "20,000",
          "low_price": "37,440",
          "high_price": "81,120"
        },
        "3.3": {
          "rap": "20,000",
          "low_price": "38,610",
          "high_price": "83,655"
        },
        "3.4": {
          "rap": "20,000",
          "low_price": "39,780",
          "high_price": "86,190"
        },
        "3.5": {
          "rap": "20,000",
          "low_price": "40,950",
          "high_price": "88,725"
        },
        "3.6": {
          "rap": "20,000",
          "low_price": "42,120",
          "high_price": "91,260"
        },
        "3.7": {
          "rap": "20,000",
          "low_price": "43,290",
          "high_price": "93,795"
        },
        "3.8": {
          "rap": "20,000",
          "low_price": "44,460",
          "high_price": "96,330"
        },
        "3.9": {
          "rap": "20,000",
          "low_price": "45,630",
          "high_price": "98,865"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,800",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "2,300",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "2,300",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,200",
          "low_price": "1,050",
          "high_price": "2,275"
        },
        "0.8": {
          "rap": "3,200",
          "low_price": "1,200",
          "high_price": "2,600"
        },
        "0.9": {
          "rap": "4,200",
          "low_price": "1,835",
          "high_price": "3,980"
        },
        "1.0": {
          "rap": "5,200",
          "low_price": "2,340",
          "high_price": "5,070"
        },
        "1.1": {
          "rap": "5,200",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.2": {
          "rap": "5,200",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.3": {
          "rap": "5,200",
          "low_price": "3,040",
          "high_price": "6,590"
        },
        "1.4": {
          "rap": "5,200",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.5": {
          "rap": "7,900",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "1.6": {
          "rap": "7,900",
          "low_price": "6,530",
          "high_price": "14,145"
        },
        "1.7": {
          "rap": "7,900",
          "low_price": "6,935",
          "high_price": "15,030"
        },
        "1.8": {
          "rap": "7,900",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "1.9": {
          "rap": "7,900",
          "low_price": "7,750",
          "high_price": "16,795"
        },
        "2.0": {
          "rap": "10,300",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "2.1": {
          "rap": "10,300",
          "low_price": "11,970",
          "high_price": "25,935"
        },
        "2.2": {
          "rap": "10,300",
          "low_price": "12,540",
          "high_price": "27,170"
        },
        "2.3": {
          "rap": "10,300",
          "low_price": "13,110",
          "high_price": "28,405"
        },
        "2.4": {
          "rap": "10,300",
          "low_price": "13,680",
          "high_price": "29,640"
        },
        "2.5": {
          "rap": "10,300",
          "low_price": "14,250",
          "high_price": "30,875"
        },
        "2.6": {
          "rap": "10,300",
          "low_price": "14,820",
          "high_price": "32,110"
        },
        "2.7": {
          "rap": "10,300",
          "low_price": "15,390",
          "high_price": "33,345"
        },
        "2.8": {
          "rap": "10,300",
          "low_price": "15,960",
          "high_price": "34,580"
        },
        "2.9": {
          "rap": "10,300",
          "low_price": "16,530",
          "high_price": "35,815"
        },
        "3.0": {
          "rap": "17,000",
          "low_price": "29,700",
          "high_price": "64,350"
        },
        "3.1": {
          "rap": "17,000",
          "low_price": "30,690",
          "high_price": "66,495"
        },
        "3.2": {
          "rap": "17,000",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "3.3": {
          "rap": "17,000",
          "low_price": "32,670",
          "high_price": "70,785"
        },
        "3.4": {
          "rap": "17,000",
          "low_price": "33,660",
          "high_price": "72,930"
        },
        "3.5": {
          "rap": "17,000",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "3.6": {
          "rap": "17,000",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "3.7": {
          "rap": "17,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.8": {
          "rap": "17,000",
          "low_price": "37,620",
          "high_price": "81,510"
        },
        "3.9": {
          "rap": "17,000",
          "low_price": "38,610",
          "high_price": "83,655"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,500",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,700",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "2,700",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "4,200",
          "low_price": "2,040",
          "high_price": "4,420"
        },
        "1.1": {
          "rap": "4,200",
          "low_price": "2,245",
          "high_price": "4,860"
        },
        "1.2": {
          "rap": "4,200",
          "low_price": "2,450",
          "high_price": "5,305"
        },
        "1.3": {
          "rap": "4,200",
          "low_price": "2,650",
          "high_price": "5,745"
        },
        "1.4": {
          "rap": "4,200",
          "low_price": "2,855",
          "high_price": "6,190"
        },
        "1.5": {
          "rap": "6,300",
          "low_price": "4,950",
          "high_price": "10,725"
        },
        "1.6": {
          "rap": "6,300",
          "low_price": "5,280",
          "high_price": "11,440"
        },
        "1.7": {
          "rap": "6,300",
          "low_price": "5,610",
          "high_price": "12,155"
        },
        "1.8": {
          "rap": "6,300",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "1.9": {
          "rap": "6,300",
          "low_price": "6,270",
          "high_price": "13,585"
        },
        "2.0": {
          "rap": "8,300",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.1": {
          "rap": "8,300",
          "low_price": "9,700",
          "high_price": "21,020"
        },
        "2.2": {
          "rap": "8,300",
          "low_price": "10,165",
          "high_price": "22,020"
        },
        "2.3": {
          "rap": "8,300",
          "low_price": "10,625",
          "high_price": "23,025"
        },
        "2.4": {
          "rap": "8,300",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.5": {
          "rap": "8,300",
          "low_price": "11,550",
          "high_price": "25,025"
        },
        "2.6": {
          "rap": "8,300",
          "low_price": "12,010",
          "high_price": "26,025"
        },
        "2.7": {
          "rap": "8,300",
          "low_price": "12,475",
          "high_price": "27,025"
        },
        "2.8": {
          "rap": "8,300",
          "low_price": "12,935",
          "high_price": "28,030"
        },
        "2.9": {
          "rap": "8,300",
          "low_price": "13,400",
          "high_price": "29,030"
        },
        "3.0": {
          "rap": "13,100",
          "low_price": "22,860",
          "high_price": "49,530"
        },
        "3.1": {
          "rap": "13,100",
          "low_price": "23,620",
          "high_price": "51,180"
        },
        "3.2": {
          "rap": "13,100",
          "low_price": "24,385",
          "high_price": "52,830"
        },
        "3.3": {
          "rap": "13,100",
          "low_price": "25,145",
          "high_price": "54,485"
        },
        "3.4": {
          "rap": "13,100",
          "low_price": "25,910",
          "high_price": "56,135"
        },
        "3.5": {
          "rap": "13,100",
          "low_price": "26,670",
          "high_price": "57,785"
        },
        "3.6": {
          "rap": "13,100",
          "low_price": "27,430",
          "high_price": "59,435"
        },
        "3.7": {
          "rap": "13,100",
          "low_price": "28,195",
          "high_price": "61,085"
        },
        "3.8": {
          "rap": "13,100",
          "low_price": "28,955",
          "high_price": "62,740"
        },
        "3.9": {
          "rap": "13,100",
          "low_price": "29,720",
          "high_price": "64,390"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,200",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,200",
          "low_price": "800",
          "high_price": "1,730"
        },
        "0.8": {
          "rap": "2,200",
          "low_price": "910",
          "high_price": "1,975"
        },
        "0.9": {
          "rap": "2,800",
          "low_price": "1,350",
          "high_price": "2,925"
        },
        "1.0": {
          "rap": "3,300",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "1.1": {
          "rap": "3,300",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.2": {
          "rap": "3,300",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.3": {
          "rap": "3,300",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.4": {
          "rap": "3,300",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "1.5": {
          "rap": "5,100",
          "low_price": "3,870",
          "high_price": "8,385"
        },
        "1.6": {
          "rap": "5,100",
          "low_price": "4,130",
          "high_price": "8,945"
        },
        "1.7": {
          "rap": "5,100",
          "low_price": "4,385",
          "high_price": "9,505"
        },
        "1.8": {
          "rap": "5,100",
          "low_price": "4,645",
          "high_price": "10,060"
        },
        "1.9": {
          "rap": "5,100",
          "low_price": "4,900",
          "high_price": "10,620"
        },
        "2.0": {
          "rap": "6,800",
          "low_price": "7,200",
          "high_price": "15,600"
        },
        "2.1": {
          "rap": "6,800",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.2": {
          "rap": "6,800",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.3": {
          "rap": "6,800",
          "low_price": "8,280",
          "high_price": "17,940"
        },
        "2.4": {
          "rap": "6,800",
          "low_price": "8,640",
          "high_price": "18,720"
        },
        "2.5": {
          "rap": "6,800",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "2.6": {
          "rap": "6,800",
          "low_price": "9,360",
          "high_price": "20,280"
        },
        "2.7": {
          "rap": "6,800",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "2.8": {
          "rap": "6,800",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.9": {
          "rap": "6,800",
          "low_price": "10,440",
          "high_price": "22,620"
        },
        "3.0": {
          "rap": "10,000",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "3.1": {
          "rap": "10,000",
          "low_price": "18,600",
          "high_price": "40,300"
        },
        "3.2": {
          "rap": "10,000",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "3.3": {
          "rap": "10,000",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "3.4": {
          "rap": "10,000",
          "low_price": "20,400",
          "high_price": "44,200"
        },
        "3.5": {
          "rap": "10,000",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "3.6": {
          "rap": "10,000",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "3.7": {
          "rap": "10,000",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "3.8": {
          "rap": "10,000",
          "low_price": "22,800",
          "high_price": "49,400"
        },
        "3.9": {
          "rap": "10,000",
          "low_price": "23,400",
          "high_price": "50,700"
        }
      }
    },
    "VS2": {
      "D": {
        "0.4": {
          "rap": "2,300",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "4,600",
          "low_price": "1,430",
          "high_price": "3,095"
        },
        "0.8": {
          "rap": "4,600",
          "low_price": "1,630",
          "high_price": "3,535"
        },
        "0.9": {
          "rap": "5,900",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.0": {
          "rap": "7,500",
          "low_price": "3,420",
          "high_price": "7,410"
        },
        "1.1": {
          "rap": "7,500",
          "low_price": "3,760",
          "high_price": "8,150"
        },
        "1.2": {
          "rap": "7,500",
          "low_price": "4,105",
          "high_price": "8,890"
        },
        "1.3": {
          "rap": "7,500",
          "low_price": "4,445",
          "high_price": "9,635"
        },
        "1.4": {
          "rap": "7,500",
          "low_price": "4,790",
          "high_price": "10,375"
        },
        "1.5": {
          "rap": "12,400",
          "low_price": "8,910",
          "high_price": "19,305"
        },
        "1.6": {
          "rap": "12,400",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "1.7": {
          "rap": "12,400",
          "low_price": "10,100",
          "high_price": "21,880"
        },
        "1.8": {
          "rap": "12,400",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "1.9": {
          "rap": "12,400",
          "low_price": "11,285",
          "high_price": "24,455"
        },
        "2.0": {
          "rap": "17,500",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "17,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "17,500",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "17,500",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "17,500",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "17,500",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "17,500",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "17,500",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "17,500",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "17,500",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "27,000",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.1": {
          "rap": "27,000",
          "low_price": "50,220",
          "high_price": "108,810"
        },
        "3.2": {
          "rap": "27,000",
          "low_price": "51,840",
          "high_price": "112,320"
        },
        "3.3": {
          "rap": "27,000",
          "low_price": "53,460",
          "high_price": "115,830"
        },
        "3.4": {
          "rap": "27,000",
          "low_price": "55,080",
          "high_price": "119,340"
        },
        "3.5": {
          "rap": "27,000",
          "low_price": "56,700",
          "high_price": "122,850"
        },
        "3.6": {
          "rap": "27,000",
          "low_price": "58,320",
          "high_price": "126,360"
        },
        "3.7": {
          "rap": "27,000",
          "low_price": "59,940",
          "high_price": "129,870"
        },
        "3.8": {
          "rap": "27,000",
          "low_price": "61,560",
          "high_price": "133,380"
        },
        "3.9": {
          "rap": "27,000",
          "low_price": "63,180",
          "high_price": "136,890"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,200",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,800",
          "low_price": "690",
          "high_price": "1,495"
        },
        "0.6": {
          "rap": "2,800",
          "low_price": "830",
          "high_price": "1,795"
        },
        "0.7": {
          "rap": "4,400",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.8": {
          "rap": "4,400",
          "low_price": "1,535",
          "high_price": "3,330"
        },
        "0.9": {
          "rap": "5,600",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.0": {
          "rap": "7,200",
          "low_price": "3,240",
          "high_price": "7,020"
        },
        "1.1": {
          "rap": "7,200",
          "low_price": "3,565",
          "high_price": "7,720"
        },
        "1.2": {
          "rap": "7,200",
          "low_price": "3,890",
          "high_price": "8,425"
        },
        "1.3": {
          "rap": "7,200",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.4": {
          "rap": "7,200",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.5": {
          "rap": "11,800",
          "low_price": "8,370",
          "high_price": "18,135"
        },
        "1.6": {
          "rap": "11,800",
          "low_price": "8,930",
          "high_price": "19,345"
        },
        "1.7": {
          "rap": "11,800",
          "low_price": "9,485",
          "high_price": "20,555"
        },
        "1.8": {
          "rap": "11,800",
          "low_price": "10,045",
          "high_price": "21,760"
        },
        "1.9": {
          "rap": "11,800",
          "low_price": "10,600",
          "high_price": "22,970"
        },
        "2.0": {
          "rap": "16,500",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.1": {
          "rap": "16,500",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "2.2": {
          "rap": "16,500",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.3": {
          "rap": "16,500",
          "low_price": "20,700",
          "high_price": "44,850"
        },
        "2.4": {
          "rap": "16,500",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "2.5": {
          "rap": "16,500",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "2.6": {
          "rap": "16,500",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.7": {
          "rap": "16,500",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "2.8": {
          "rap": "16,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.9": {
          "rap": "16,500",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.0": {
          "rap": "24,500",
          "low_price": "45,000",
          "high_price": "97,500"
        },
        "3.1": {
          "rap": "24,500",
          "low_price": "46,500",
          "high_price": "100,750"
        },
        "3.2": {
          "rap": "24,500",
          "low_price": "48,000",
          "high_price": "104,000"
        },
        "3.3": {
          "rap": "24,500",
          "low_price": "49,500",
          "high_price": "107,250"
        },
        "3.4": {
          "rap": "24,500",
          "low_price": "51,000",
          "high_price": "110,500"
        },
        "3.5": {
          "rap": "24,500",
          "low_price": "52,500",
          "high_price": "113,750"
        },
        "3.6": {
          "rap": "24,500",
          "low_price": "54,000",
          "high_price": "117,000"
        },
        "3.7": {
          "rap": "24,500",
          "low_price": "55,500",
          "high_price": "120,250"
        },
        "3.8": {
          "rap": "24,500",
          "low_price": "57,000",
          "high_price": "123,500"
        },
        "3.9": {
          "rap": "24,500",
          "low_price": "58,500",
          "high_price": "126,750"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,100",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "2,700",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,700",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,200",
          "low_price": "1,260",
          "high_price": "2,730"
        },
        "0.8": {
          "rap": "4,200",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "0.9": {
          "rap": "5,400",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.0": {
          "rap": "6,900",
          "low_price": "3,060",
          "high_price": "6,630"
        },
        "1.1": {
          "rap": "6,900",
          "low_price": "3,365",
          "high_price": "7,295"
        },
        "1.2": {
          "rap": "6,900",
          "low_price": "3,670",
          "high_price": "7,955"
        },
        "1.3": {
          "rap": "6,900",
          "low_price": "3,980",
          "high_price": "8,620"
        },
        "1.4": {
          "rap": "6,900",
          "low_price": "4,285",
          "high_price": "9,280"
        },
        "1.5": {
          "rap": "11,200",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "1.6": {
          "rap": "11,200",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "1.7": {
          "rap": "11,200",
          "low_price": "8,975",
          "high_price": "19,450"
        },
        "1.8": {
          "rap": "11,200",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "1.9": {
          "rap": "11,200",
          "low_price": "10,030",
          "high_price": "21,735"
        },
        "2.0": {
          "rap": "15,500",
          "low_price": "16,800",
          "high_price": "36,400"
        },
        "2.1": {
          "rap": "15,500",
          "low_price": "17,640",
          "high_price": "38,220"
        },
        "2.2": {
          "rap": "15,500",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "2.3": {
          "rap": "15,500",
          "low_price": "19,320",
          "high_price": "41,860"
        },
        "2.4": {
          "rap": "15,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.5": {
          "rap": "15,500",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.6": {
          "rap": "15,500",
          "low_price": "21,840",
          "high_price": "47,320"
        },
        "2.7": {
          "rap": "15,500",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.8": {
          "rap": "15,500",
          "low_price": "23,520",
          "high_price": "50,960"
        },
        "2.9": {
          "rap": "15,500",
          "low_price": "24,360",
          "high_price": "52,780"
        },
        "3.0": {
          "rap": "22,500",
          "low_price": "41,400",
          "high_price": "89,700"
        },
        "3.1": {
          "rap": "22,500",
          "low_price": "42,780",
          "high_price": "92,690"
        },
        "3.2": {
          "rap": "22,500",
          "low_price": "44,160",
          "high_price": "95,680"
        },
        "3.3": {
          "rap": "22,500",
          "low_price": "45,540",
          "high_price": "98,670"
        },
        "3.4": {
          "rap": "22,500",
          "low_price": "46,920",
          "high_price": "101,660"
        },
        "3.5": {
          "rap": "22,500",
          "low_price": "48,300",
          "high_price": "104,650"
        },
        "3.6": {
          "rap": "22,500",
          "low_price": "49,680",
          "high_price": "107,640"
        },
        "3.7": {
          "rap": "22,500",
          "low_price": "51,060",
          "high_price": "110,630"
        },
        "3.8": {
          "rap": "22,500",
          "low_price": "52,440",
          "high_price": "113,620"
        },
        "3.9": {
          "rap": "22,500",
          "low_price": "53,820",
          "high_price": "116,610"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,000",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "2,600",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.6": {
          "rap": "2,600",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.7": {
          "rap": "3,900",
          "low_price": "1,175",
          "high_price": "2,550"
        },
        "0.8": {
          "rap": "3,900",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.9": {
          "rap": "5,100",
          "low_price": "2,050",
          "high_price": "4,445"
        },
        "1.0": {
          "rap": "6,600",
          "low_price": "2,880",
          "high_price": "6,240"
        },
        "1.1": {
          "rap": "6,600",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.2": {
          "rap": "6,600",
          "low_price": "3,455",
          "high_price": "7,490"
        },
        "1.3": {
          "rap": "6,600",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.4": {
          "rap": "6,600",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.5": {
          "rap": "10,400",
          "low_price": "7,380",
          "high_price": "15,990"
        },
        "1.6": {
          "rap": "10,400",
          "low_price": "7,870",
          "high_price": "17,055"
        },
        "1.7": {
          "rap": "10,400",
          "low_price": "8,365",
          "high_price": "18,120"
        },
        "1.8": {
          "rap": "10,400",
          "low_price": "8,855",
          "high_price": "19,190"
        },
        "1.9": {
          "rap": "10,400",
          "low_price": "9,350",
          "high_price": "20,255"
        },
        "2.0": {
          "rap": "14,500",
          "low_price": "15,600",
          "high_price": "33,800"
        },
        "2.1": {
          "rap": "14,500",
          "low_price": "16,380",
          "high_price": "35,490"
        },
        "2.2": {
          "rap": "14,500",
          "low_price": "17,160",
          "high_price": "37,180"
        },
        "2.3": {
          "rap": "14,500",
          "low_price": "17,940",
          "high_price": "38,870"
        },
        "2.4": {
          "rap": "14,500",
          "low_price": "18,720",
          "high_price": "40,560"
        },
        "2.5": {
          "rap": "14,500",
          "low_price": "19,500",
          "high_price": "42,250"
        },
        "2.6": {
          "rap": "14,500",
          "low_price": "20,280",
          "high_price": "43,940"
        },
        "2.7": {
          "rap": "14,500",
          "low_price": "21,060",
          "high_price": "45,630"
        },
        "2.8": {
          "rap": "14,500",
          "low_price": "21,840",
          "high_price": "47,320"
        },
        "2.9": {
          "rap": "14,500",
          "low_price": "22,620",
          "high_price": "49,010"
        },
        "3.0": {
          "rap": "20,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.1": {
          "rap": "20,500",
          "low_price": "39,060",
          "high_price": "84,630"
        },
        "3.2": {
          "rap": "20,500",
          "low_price": "40,320",
          "high_price": "87,360"
        },
        "3.3": {
          "rap": "20,500",
          "low_price": "41,580",
          "high_price": "90,090"
        },
        "3.4": {
          "rap": "20,500",
          "low_price": "42,840",
          "high_price": "92,820"
        },
        "3.5": {
          "rap": "20,500",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.6": {
          "rap": "20,500",
          "low_price": "45,360",
          "high_price": "98,280"
        },
        "3.7": {
          "rap": "20,500",
          "low_price": "46,620",
          "high_price": "101,010"
        },
        "3.8": {
          "rap": "20,500",
          "low_price": "47,880",
          "high_price": "103,740"
        },
        "3.9": {
          "rap": "20,500",
          "low_price": "49,140",
          "high_price": "106,470"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,800",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,400",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,400",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,500",
          "low_price": "1,050",
          "high_price": "2,275"
        },
        "0.8": {
          "rap": "3,500",
          "low_price": "1,200",
          "high_price": "2,600"
        },
        "0.9": {
          "rap": "4,600",
          "low_price": "1,890",
          "high_price": "4,095"
        },
        "1.0": {
          "rap": "5,700",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.1": {
          "rap": "5,700",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.2": {
          "rap": "5,700",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.3": {
          "rap": "5,700",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.4": {
          "rap": "5,700",
          "low_price": "3,530",
          "high_price": "7,645"
        },
        "1.5": {
          "rap": "9,100",
          "low_price": "6,390",
          "high_price": "13,845"
        },
        "1.6": {
          "rap": "9,100",
          "low_price": "6,815",
          "high_price": "14,770"
        },
        "1.7": {
          "rap": "9,100",
          "low_price": "7,240",
          "high_price": "15,690"
        },
        "1.8": {
          "rap": "9,100",
          "low_price": "7,670",
          "high_price": "16,615"
        },
        "1.9": {
          "rap": "9,100",
          "low_price": "8,095",
          "high_price": "17,535"
        },
        "2.0": {
          "rap": "12,000",
          "low_price": "13,200",
          "high_price": "28,600"
        },
        "2.1": {
          "rap": "12,000",
          "low_price": "13,860",
          "high_price": "30,030"
        },
        "2.2": {
          "rap": "12,000",
          "low_price": "14,520",
          "high_price": "31,460"
        },
        "2.3": {
          "rap": "12,000",
          "low_price": "15,180",
          "high_price": "32,890"
        },
        "2.4": {
          "rap": "12,000",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "2.5": {
          "rap": "12,000",
          "low_price": "16,500",
          "high_price": "35,750"
        },
        "2.6": {
          "rap": "12,000",
          "low_price": "17,160",
          "high_price": "37,180"
        },
        "2.7": {
          "rap": "12,000",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.8": {
          "rap": "12,000",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "2.9": {
          "rap": "12,000",
          "low_price": "19,140",
          "high_price": "41,470"
        },
        "3.0": {
          "rap": "18,000",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.1": {
          "rap": "18,000",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.2": {
          "rap": "18,000",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.3": {
          "rap": "18,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.4": {
          "rap": "18,000",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.5": {
          "rap": "18,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.6": {
          "rap": "18,000",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.7": {
          "rap": "18,000",
          "low_price": "41,070",
          "high_price": "88,985"
        },
        "3.8": {
          "rap": "18,000",
          "low_price": "42,180",
          "high_price": "91,390"
        },
        "3.9": {
          "rap": "18,000",
          "low_price": "43,290",
          "high_price": "93,795"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,600",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,200",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "2,200",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "3,900",
          "low_price": "1,675",
          "high_price": "3,625"
        },
        "1.0": {
          "rap": "4,900",
          "low_price": "2,220",
          "high_price": "4,810"
        },
        "1.1": {
          "rap": "4,900",
          "low_price": "2,440",
          "high_price": "5,290"
        },
        "1.2": {
          "rap": "4,900",
          "low_price": "2,665",
          "high_price": "5,770"
        },
        "1.3": {
          "rap": "4,900",
          "low_price": "2,885",
          "high_price": "6,255"
        },
        "1.4": {
          "rap": "4,900",
          "low_price": "3,110",
          "high_price": "6,735"
        },
        "1.5": {
          "rap": "7,600",
          "low_price": "5,670",
          "high_price": "12,285"
        },
        "1.6": {
          "rap": "7,600",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.7": {
          "rap": "7,600",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "1.8": {
          "rap": "7,600",
          "low_price": "6,805",
          "high_price": "14,740"
        },
        "1.9": {
          "rap": "7,600",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.0": {
          "rap": "9,700",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "2.1": {
          "rap": "9,700",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.2": {
          "rap": "9,700",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "2.3": {
          "rap": "9,700",
          "low_price": "12,420",
          "high_price": "26,910"
        },
        "2.4": {
          "rap": "9,700",
          "low_price": "12,960",
          "high_price": "28,080"
        },
        "2.5": {
          "rap": "9,700",
          "low_price": "13,500",
          "high_price": "29,250"
        },
        "2.6": {
          "rap": "9,700",
          "low_price": "14,040",
          "high_price": "30,420"
        },
        "2.7": {
          "rap": "9,700",
          "low_price": "14,580",
          "high_price": "31,590"
        },
        "2.8": {
          "rap": "9,700",
          "low_price": "15,120",
          "high_price": "32,760"
        },
        "2.9": {
          "rap": "9,700",
          "low_price": "15,660",
          "high_price": "33,930"
        },
        "3.0": {
          "rap": "15,500",
          "low_price": "27,900",
          "high_price": "60,450"
        },
        "3.1": {
          "rap": "15,500",
          "low_price": "28,830",
          "high_price": "62,465"
        },
        "3.2": {
          "rap": "15,500",
          "low_price": "29,760",
          "high_price": "64,480"
        },
        "3.3": {
          "rap": "15,500",
          "low_price": "30,690",
          "high_price": "66,495"
        },
        "3.4": {
          "rap": "15,500",
          "low_price": "31,620",
          "high_price": "68,510"
        },
        "3.5": {
          "rap": "15,500",
          "low_price": "32,550",
          "high_price": "70,525"
        },
        "3.6": {
          "rap": "15,500",
          "low_price": "33,480",
          "high_price": "72,540"
        },
        "3.7": {
          "rap": "15,500",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.8": {
          "rap": "15,500",
          "low_price": "35,340",
          "high_price": "76,570"
        },
        "3.9": {
          "rap": "15,500",
          "low_price": "36,270",
          "high_price": "78,585"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,500",
          "low_price": "800",
          "high_price": "1,730"
        },
        "0.8": {
          "rap": "2,500",
          "low_price": "910",
          "high_price": "1,975"
        },
        "0.9": {
          "rap": "3,300",
          "low_price": "1,460",
          "high_price": "3,160"
        },
        "1.0": {
          "rap": "4,000",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "1.1": {
          "rap": "4,000",
          "low_price": "2,110",
          "high_price": "4,575"
        },
        "1.2": {
          "rap": "4,000",
          "low_price": "2,305",
          "high_price": "4,990"
        },
        "1.3": {
          "rap": "4,000",
          "low_price": "2,495",
          "high_price": "5,410"
        },
        "1.4": {
          "rap": "4,000",
          "low_price": "2,690",
          "high_price": "5,825"
        },
        "1.5": {
          "rap": "6,100",
          "low_price": "4,680",
          "high_price": "10,140"
        },
        "1.6": {
          "rap": "6,100",
          "low_price": "4,990",
          "high_price": "10,815"
        },
        "1.7": {
          "rap": "6,100",
          "low_price": "5,305",
          "high_price": "11,490"
        },
        "1.8": {
          "rap": "6,100",
          "low_price": "5,615",
          "high_price": "12,170"
        },
        "1.9": {
          "rap": "6,100",
          "low_price": "5,930",
          "high_price": "12,845"
        },
        "2.0": {
          "rap": "8,000",
          "low_price": "8,880",
          "high_price": "19,240"
        },
        "2.1": {
          "rap": "8,000",
          "low_price": "9,325",
          "high_price": "20,200"
        },
        "2.2": {
          "rap": "8,000",
          "low_price": "9,770",
          "high_price": "21,165"
        },
        "2.3": {
          "rap": "8,000",
          "low_price": "10,210",
          "high_price": "22,125"
        },
        "2.4": {
          "rap": "8,000",
          "low_price": "10,655",
          "high_price": "23,090"
        },
        "2.5": {
          "rap": "8,000",
          "low_price": "11,100",
          "high_price": "24,050"
        },
        "2.6": {
          "rap": "8,000",
          "low_price": "11,545",
          "high_price": "25,010"
        },
        "2.7": {
          "rap": "8,000",
          "low_price": "11,990",
          "high_price": "25,975"
        },
        "2.8": {
          "rap": "8,000",
          "low_price": "12,430",
          "high_price": "26,935"
        },
        "2.9": {
          "rap": "8,000",
          "low_price": "12,875",
          "high_price": "27,900"
        },
        "3.0": {
          "rap": "12,100",
          "low_price": "21,780",
          "high_price": "47,190"
        },
        "3.1": {
          "rap": "12,100",
          "low_price": "22,505",
          "high_price": "48,765"
        },
        "3.2": {
          "rap": "12,100",
          "low_price": "23,230",
          "high_price": "50,335"
        },
        "3.3": {
          "rap": "12,100",
          "low_price": "23,960",
          "high_price": "51,910"
        },
        "3.4": {
          "rap": "12,100",
          "low_price": "24,685",
          "high_price": "53,480"
        },
        "3.5": {
          "rap": "12,100",
          "low_price": "25,410",
          "high_price": "55,055"
        },
        "3.6": {
          "rap": "12,100",
          "low_price": "26,135",
          "high_price": "56,630"
        },
        "3.7": {
          "rap": "12,100",
          "low_price": "26,860",
          "high_price": "58,200"
        },
        "3.8": {
          "rap": "12,100",
          "low_price": "27,590",
          "high_price": "59,775"
        },
        "3.9": {
          "rap": "12,100",
          "low_price": "28,315",
          "high_price": "61,345"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,100",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,500",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "1,500",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "2,700",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "3,200",
          "low_price": "1,560",
          "high_price": "3,380"
        },
        "1.1": {
          "rap": "3,200",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.2": {
          "rap": "3,200",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.3": {
          "rap": "3,200",
          "low_price": "2,030",
          "high_price": "4,395"
        },
        "1.4": {
          "rap": "3,200",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.5": {
          "rap": "4,900",
          "low_price": "3,690",
          "high_price": "7,995"
        },
        "1.6": {
          "rap": "4,900",
          "low_price": "3,935",
          "high_price": "8,530"
        },
        "1.7": {
          "rap": "4,900",
          "low_price": "4,180",
          "high_price": "9,060"
        },
        "1.8": {
          "rap": "4,900",
          "low_price": "4,430",
          "high_price": "9,595"
        },
        "1.9": {
          "rap": "4,900",
          "low_price": "4,675",
          "high_price": "10,125"
        },
        "2.0": {
          "rap": "6,600",
          "low_price": "6,960",
          "high_price": "15,080"
        },
        "2.1": {
          "rap": "6,600",
          "low_price": "7,310",
          "high_price": "15,835"
        },
        "2.2": {
          "rap": "6,600",
          "low_price": "7,655",
          "high_price": "16,590"
        },
        "2.3": {
          "rap": "6,600",
          "low_price": "8,005",
          "high_price": "17,340"
        },
        "2.4": {
          "rap": "6,600",
          "low_price": "8,350",
          "high_price": "18,095"
        },
        "2.5": {
          "rap": "6,600",
          "low_price": "8,700",
          "high_price": "18,850"
        },
        "2.6": {
          "rap": "6,600",
          "low_price": "9,050",
          "high_price": "19,605"
        },
        "2.7": {
          "rap": "6,600",
          "low_price": "9,395",
          "high_price": "20,360"
        },
        "2.8": {
          "rap": "6,600",
          "low_price": "9,745",
          "high_price": "21,110"
        },
        "2.9": {
          "rap": "6,600",
          "low_price": "10,090",
          "high_price": "21,865"
        },
        "3.0": {
          "rap": "9,400",
          "low_price": "16,920",
          "high_price": "36,660"
        },
        "3.1": {
          "rap": "9,400",
          "low_price": "17,485",
          "high_price": "37,880"
        },
        "3.2": {
          "rap": "9,400",
          "low_price": "18,050",
          "high_price": "39,105"
        },
        "3.3": {
          "rap": "9,400",
          "low_price": "18,610",
          "high_price": "40,325"
        },
        "3.4": {
          "rap": "9,400",
          "low_price": "19,175",
          "high_price": "41,550"
        },
        "3.5": {
          "rap": "9,400",
          "low_price": "19,740",
          "high_price": "42,770"
        },
        "3.6": {
          "rap": "9,400",
          "low_price": "20,305",
          "high_price": "43,990"
        },
        "3.7": {
          "rap": "9,400",
          "low_price": "20,870",
          "high_price": "45,215"
        },
        "3.8": {
          "rap": "9,400",
          "low_price": "21,430",
          "high_price": "46,435"
        },
        "3.9": {
          "rap": "9,400",
          "low_price": "21,995",
          "high_price": "47,660"
        }
      }
    },
    "VVS1": {
      "D": {
        "0.4": {
          "rap": "3,000",
          "low_price": "625",
          "high_price": "1,350"
        },
        "0.5": {
          "rap": "3,600",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.6": {
          "rap": "3,600",
          "low_price": "1,080",
          "high_price": "2,340"
        },
        "0.7": {
          "rap": "5,600",
          "low_price": "1,805",
          "high_price": "3,915"
        },
        "0.8": {
          "rap": "5,600",
          "low_price": "2,065",
          "high_price": "4,470"
        },
        "0.9": {
          "rap": "7,800",
          "low_price": "3,400",
          "high_price": "7,370"
        },
        "1.0": {
          "rap": "10,400",
          "low_price": "4,920",
          "high_price": "10,660"
        },
        "1.1": {
          "rap": "10,400",
          "low_price": "5,410",
          "high_price": "11,725"
        },
        "1.2": {
          "rap": "10,400",
          "low_price": "5,905",
          "high_price": "12,790"
        },
        "1.3": {
          "rap": "10,400",
          "low_price": "6,395",
          "high_price": "13,860"
        },
        "1.4": {
          "rap": "10,400",
          "low_price": "6,890",
          "high_price": "14,925"
        },
        "1.5": {
          "rap": "16,400",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "1.6": {
          "rap": "16,400",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "1.7": {
          "rap": "16,400",
          "low_price": "13,465",
          "high_price": "29,170"
        },
        "1.8": {
          "rap": "16,400",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "1.9": {
          "rap": "16,400",
          "low_price": "15,050",
          "high_price": "32,605"
        },
        "2.0": {
          "rap": "23,500",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.1": {
          "rap": "23,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.2": {
          "rap": "23,500",
          "low_price": "26,400",
          "high_price": "57,200"
        },
        "2.3": {
          "rap": "23,500",
          "low_price": "27,600",
          "high_price": "59,800"
        },
        "2.4": {
          "rap": "23,500",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "2.5": {
          "rap": "23,500",
          "low_price": "30,000",
          "high_price": "65,000"
        },
        "2.6": {
          "rap": "23,500",
          "low_price": "31,200",
          "high_price": "67,600"
        },
        "2.7": {
          "rap": "23,500",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "2.8": {
          "rap": "23,500",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "2.9": {
          "rap": "23,500",
          "low_price": "34,800",
          "high_price": "75,400"
        },
        "3.0": {
          "rap": "36,500",
          "low_price": "63,900",
          "high_price": "138,450"
        },
        "3.1": {
          "rap": "36,500",
          "low_price": "66,030",
          "high_price": "143,065"
        },
        "3.2": {
          "rap": "36,500",
          "low_price": "68,160",
          "high_price": "147,680"
        },
        "3.3": {
          "rap": "36,500",
          "low_price": "70,290",
          "high_price": "152,295"
        },
        "3.4": {
          "rap": "36,500",
          "low_price": "72,420",
          "high_price": "156,910"
        },
        "3.5": {
          "rap": "36,500",
          "low_price": "74,550",
          "high_price": "161,525"
        },
        "3.6": {
          "rap": "36,500",
          "low_price": "76,680",
          "high_price": "166,140"
        },
        "3.7": {
          "rap": "36,500",
          "low_price": "78,810",
          "high_price": "170,755"
        },
        "3.8": {
          "rap": "36,500",
          "low_price": "80,940",
          "high_price": "175,370"
        },
        "3.9": {
          "rap": "36,500",
          "low_price": "83,070",
          "high_price": "179,985"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,800",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.5": {
          "rap": "3,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.6": {
          "rap": "3,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.7": {
          "rap": "5,300",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.8": {
          "rap": "5,300",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "0.9": {
          "rap": "7,100",
          "low_price": "3,080",
          "high_price": "6,670"
        },
        "1.0": {
          "rap": "9,400",
          "low_price": "4,500",
          "high_price": "9,750"
        },
        "1.1": {
          "rap": "9,400",
          "low_price": "4,950",
          "high_price": "10,725"
        },
        "1.2": {
          "rap": "9,400",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "1.3": {
          "rap": "9,400",
          "low_price": "5,850",
          "high_price": "12,675"
        },
        "1.4": {
          "rap": "9,400",
          "low_price": "6,300",
          "high_price": "13,650"
        },
        "1.5": {
          "rap": "14,900",
          "low_price": "11,160",
          "high_price": "24,180"
        },
        "1.6": {
          "rap": "14,900",
          "low_price": "11,905",
          "high_price": "25,790"
        },
        "1.7": {
          "rap": "14,900",
          "low_price": "12,650",
          "high_price": "27,405"
        },
        "1.8": {
          "rap": "14,900",
          "low_price": "13,390",
          "high_price": "29,015"
        },
        "1.9": {
          "rap": "14,900",
          "low_price": "14,135",
          "high_price": "30,630"
        },
        "2.0": {
          "rap": "21,000",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "2.1": {
          "rap": "21,000",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "2.2": {
          "rap": "21,000",
          "low_price": "24,420",
          "high_price": "52,910"
        },
        "2.3": {
          "rap": "21,000",
          "low_price": "25,530",
          "high_price": "55,315"
        },
        "2.4": {
          "rap": "21,000",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "2.5": {
          "rap": "21,000",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "2.6": {
          "rap": "21,000",
          "low_price": "28,860",
          "high_price": "62,530"
        },
        "2.7": {
          "rap": "21,000",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "2.8": {
          "rap": "21,000",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "2.9": {
          "rap": "21,000",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.0": {
          "rap": "33,500",
          "low_price": "58,500",
          "high_price": "126,750"
        },
        "3.1": {
          "rap": "33,500",
          "low_price": "60,450",
          "high_price": "130,975"
        },
        "3.2": {
          "rap": "33,500",
          "low_price": "62,400",
          "high_price": "135,200"
        },
        "3.3": {
          "rap": "33,500",
          "low_price": "64,350",
          "high_price": "139,425"
        },
        "3.4": {
          "rap": "33,500",
          "low_price": "66,300",
          "high_price": "143,650"
        },
        "3.5": {
          "rap": "33,500",
          "low_price": "68,250",
          "high_price": "147,875"
        },
        "3.6": {
          "rap": "33,500",
          "low_price": "70,200",
          "high_price": "152,100"
        },
        "3.7": {
          "rap": "33,500",
          "low_price": "72,150",
          "high_price": "156,325"
        },
        "3.8": {
          "rap": "33,500",
          "low_price": "74,100",
          "high_price": "160,550"
        },
        "3.9": {
          "rap": "33,500",
          "low_price": "76,050",
          "high_price": "164,775"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,700",
          "low_price": "550",
          "high_price": "1,195"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,825",
          "high_price": "3,950"
        },
        "0.9": {
          "rap": "6,400",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "8,500",
          "low_price": "4,080",
          "high_price": "8,840"
        },
        "1.1": {
          "rap": "8,500",
          "low_price": "4,490",
          "high_price": "9,725"
        },
        "1.2": {
          "rap": "8,500",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.3": {
          "rap": "8,500",
          "low_price": "5,305",
          "high_price": "11,490"
        },
        "1.4": {
          "rap": "8,500",
          "low_price": "5,710",
          "high_price": "12,375"
        },
        "1.5": {
          "rap": "13,400",
          "low_price": "10,350",
          "high_price": "22,425"
        },
        "1.6": {
          "rap": "13,400",
          "low_price": "11,040",
          "high_price": "23,920"
        },
        "1.7": {
          "rap": "13,400",
          "low_price": "11,730",
          "high_price": "25,415"
        },
        "1.8": {
          "rap": "13,400",
          "low_price": "12,420",
          "high_price": "26,910"
        },
        "1.9": {
          "rap": "13,400",
          "low_price": "13,110",
          "high_price": "28,405"
        },
        "2.0": {
          "rap": "19,000",
          "low_price": "20,400",
          "high_price": "44,200"
        },
        "2.1": {
          "rap": "19,000",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "2.2": {
          "rap": "19,000",
          "low_price": "22,440",
          "high_price": "48,620"
        },
        "2.3": {
          "rap": "19,000",
          "low_price": "23,460",
          "high_price": "50,830"
        },
        "2.4": {
          "rap": "19,000",
          "low_price": "24,480",
          "high_price": "53,040"
        },
        "2.5": {
          "rap": "19,000",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "2.6": {
          "rap": "19,000",
          "low_price": "26,520",
          "high_price": "57,460"
        },
        "2.7": {
          "rap": "19,000",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "2.8": {
          "rap": "19,000",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "2.9": {
          "rap": "19,000",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.0": {
          "rap": "30,500",
          "low_price": "53,100",
          "high_price": "115,050"
        },
        "3.1": {
          "rap": "30,500",
          "low_price": "54,870",
          "high_price": "118,885"
        },
        "3.2": {
          "rap": "30,500",
          "low_price": "56,640",
          "high_price": "122,720"
        },
        "3.3": {
          "rap": "30,500",
          "low_price": "58,410",
          "high_price": "126,555"
        },
        "3.4": {
          "rap": "30,500",
          "low_price": "60,180",
          "high_price": "130,390"
        },
        "3.5": {
          "rap": "30,500",
          "low_price": "61,950",
          "high_price": "134,225"
        },
        "3.6": {
          "rap": "30,500",
          "low_price": "63,720",
          "high_price": "138,060"
        },
        "3.7": {
          "rap": "30,500",
          "low_price": "65,490",
          "high_price": "141,895"
        },
        "3.8": {
          "rap": "30,500",
          "low_price": "67,260",
          "high_price": "145,730"
        },
        "3.9": {
          "rap": "30,500",
          "low_price": "69,030",
          "high_price": "149,565"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "4,700",
          "low_price": "1,470",
          "high_price": "3,185"
        },
        "0.8": {
          "rap": "4,700",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.9": {
          "rap": "5,900",
          "low_price": "2,645",
          "high_price": "5,735"
        },
        "1.0": {
          "rap": "7,700",
          "low_price": "3,720",
          "high_price": "8,060"
        },
        "1.1": {
          "rap": "7,700",
          "low_price": "4,090",
          "high_price": "8,865"
        },
        "1.2": {
          "rap": "7,700",
          "low_price": "4,465",
          "high_price": "9,670"
        },
        "1.3": {
          "rap": "7,700",
          "low_price": "4,835",
          "high_price": "10,480"
        },
        "1.4": {
          "rap": "7,700",
          "low_price": "5,210",
          "high_price": "11,285"
        },
        "1.5": {
          "rap": "12,200",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "1.6": {
          "rap": "12,200",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "1.7": {
          "rap": "12,200",
          "low_price": "10,710",
          "high_price": "23,205"
        },
        "1.8": {
          "rap": "12,200",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "1.9": {
          "rap": "12,200",
          "low_price": "11,970",
          "high_price": "25,935"
        },
        "2.0": {
          "rap": "17,500",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "17,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "17,500",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "17,500",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "17,500",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "17,500",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "17,500",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "17,500",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "17,500",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "17,500",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "27,500",
          "low_price": "47,700",
          "high_price": "103,350"
        },
        "3.1": {
          "rap": "27,500",
          "low_price": "49,290",
          "high_price": "106,795"
        },
        "3.2": {
          "rap": "27,500",
          "low_price": "50,880",
          "high_price": "110,240"
        },
        "3.3": {
          "rap": "27,500",
          "low_price": "52,470",
          "high_price": "113,685"
        },
        "3.4": {
          "rap": "27,500",
          "low_price": "54,060",
          "high_price": "117,130"
        },
        "3.5": {
          "rap": "27,500",
          "low_price": "55,650",
          "high_price": "120,575"
        },
        "3.6": {
          "rap": "27,500",
          "low_price": "57,240",
          "high_price": "124,020"
        },
        "3.7": {
          "rap": "27,500",
          "low_price": "58,830",
          "high_price": "127,465"
        },
        "3.8": {
          "rap": "27,500",
          "low_price": "60,420",
          "high_price": "130,910"
        },
        "3.9": {
          "rap": "27,500",
          "low_price": "62,010",
          "high_price": "134,355"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,300",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,800",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,800",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,300",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.8": {
          "rap": "4,300",
          "low_price": "1,535",
          "high_price": "3,330"
        },
        "0.9": {
          "rap": "5,400",
          "low_price": "2,430",
          "high_price": "5,265"
        },
        "1.0": {
          "rap": "6,600",
          "low_price": "3,120",
          "high_price": "6,760"
        },
        "1.1": {
          "rap": "6,600",
          "low_price": "3,430",
          "high_price": "7,435"
        },
        "1.2": {
          "rap": "6,600",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.3": {
          "rap": "6,600",
          "low_price": "4,055",
          "high_price": "8,790"
        },
        "1.4": {
          "rap": "6,600",
          "low_price": "4,370",
          "high_price": "9,465"
        },
        "1.5": {
          "rap": "10,300",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "1.6": {
          "rap": "10,300",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "1.7": {
          "rap": "10,300",
          "low_price": "8,975",
          "high_price": "19,450"
        },
        "1.8": {
          "rap": "10,300",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "1.9": {
          "rap": "10,300",
          "low_price": "10,030",
          "high_price": "21,735"
        },
        "2.0": {
          "rap": "14,000",
          "low_price": "15,000",
          "high_price": "32,500"
        },
        "2.1": {
          "rap": "14,000",
          "low_price": "15,750",
          "high_price": "34,125"
        },
        "2.2": {
          "rap": "14,000",
          "low_price": "16,500",
          "high_price": "35,750"
        },
        "2.3": {
          "rap": "14,000",
          "low_price": "17,250",
          "high_price": "37,375"
        },
        "2.4": {
          "rap": "14,000",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.5": {
          "rap": "14,000",
          "low_price": "18,750",
          "high_price": "40,625"
        },
        "2.6": {
          "rap": "14,000",
          "low_price": "19,500",
          "high_price": "42,250"
        },
        "2.7": {
          "rap": "14,000",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.8": {
          "rap": "14,000",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.9": {
          "rap": "14,000",
          "low_price": "21,750",
          "high_price": "47,125"
        },
        "3.0": {
          "rap": "23,000",
          "low_price": "40,500",
          "high_price": "87,750"
        },
        "3.1": {
          "rap": "23,000",
          "low_price": "41,850",
          "high_price": "90,675"
        },
        "3.2": {
          "rap": "23,000",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.3": {
          "rap": "23,000",
          "low_price": "44,550",
          "high_price": "96,525"
        },
        "3.4": {
          "rap": "23,000",
          "low_price": "45,900",
          "high_price": "99,450"
        },
        "3.5": {
          "rap": "23,000",
          "low_price": "47,250",
          "high_price": "102,375"
        },
        "3.6": {
          "rap": "23,000",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.7": {
          "rap": "23,000",
          "low_price": "49,950",
          "high_price": "108,225"
        },
        "3.8": {
          "rap": "23,000",
          "low_price": "51,300",
          "high_price": "111,150"
        },
        "3.9": {
          "rap": "23,000",
          "low_price": "52,650",
          "high_price": "114,075"
        }
      },
      "I": {
        "0.4": {
          "rap": "2,000",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "2,500",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "2,500",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "3,600",
          "low_price": "1,220",
          "high_price": "2,640"
        },
        "0.8": {
          "rap": "3,600",
          "low_price": "1,390",
          "high_price": "3,015"
        },
        "0.9": {
          "rap": "4,600",
          "low_price": "2,105",
          "high_price": "4,565"
        },
        "1.0": {
          "rap": "5,600",
          "low_price": "2,640",
          "high_price": "5,720"
        },
        "1.1": {
          "rap": "5,600",
          "low_price": "2,905",
          "high_price": "6,290"
        },
        "1.2": {
          "rap": "5,600",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.3": {
          "rap": "5,600",
          "low_price": "3,430",
          "high_price": "7,435"
        },
        "1.4": {
          "rap": "5,600",
          "low_price": "3,695",
          "high_price": "8,010"
        },
        "1.5": {
          "rap": "8,500",
          "low_price": "6,750",
          "high_price": "14,625"
        },
        "1.6": {
          "rap": "8,500",
          "low_price": "7,200",
          "high_price": "15,600"
        },
        "1.7": {
          "rap": "8,500",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "1.8": {
          "rap": "8,500",
          "low_price": "8,100",
          "high_price": "17,550"
        },
        "1.9": {
          "rap": "8,500",
          "low_price": "8,550",
          "high_price": "18,525"
        },
        "2.0": {
          "rap": "11,200",
          "low_price": "12,480",
          "high_price": "27,040"
        },
        "2.1": {
          "rap": "11,200",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.2": {
          "rap": "11,200",
          "low_price": "13,730",
          "high_price": "29,745"
        },
        "2.3": {
          "rap": "11,200",
          "low_price": "14,350",
          "high_price": "31,095"
        },
        "2.4": {
          "rap": "11,200",
          "low_price": "14,975",
          "high_price": "32,450"
        },
        "2.5": {
          "rap": "11,200",
          "low_price": "15,600",
          "high_price": "33,800"
        },
        "2.6": {
          "rap": "11,200",
          "low_price": "16,225",
          "high_price": "35,150"
        },
        "2.7": {
          "rap": "11,200",
          "low_price": "16,850",
          "high_price": "36,505"
        },
        "2.8": {
          "rap": "11,200",
          "low_price": "17,470",
          "high_price": "37,855"
        },
        "2.9": {
          "rap": "11,200",
          "low_price": "18,095",
          "high_price": "39,210"
        },
        "3.0": {
          "rap": "19,000",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.1": {
          "rap": "19,000",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.2": {
          "rap": "19,000",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.3": {
          "rap": "19,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.4": {
          "rap": "19,000",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.5": {
          "rap": "19,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.6": {
          "rap": "19,000",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.7": {
          "rap": "19,000",
          "low_price": "41,070",
          "high_price": "88,985"
        },
        "3.8": {
          "rap": "19,000",
          "low_price": "42,180",
          "high_price": "91,390"
        },
        "3.9": {
          "rap": "19,000",
          "low_price": "43,290",
          "high_price": "93,795"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,700",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "2,900",
          "low_price": "1,050",
          "high_price": "2,275"
        },
        "0.8": {
          "rap": "2,900",
          "low_price": "1,200",
          "high_price": "2,600"
        },
        "0.9": {
          "rap": "3,700",
          "low_price": "1,835",
          "high_price": "3,980"
        },
        "1.0": {
          "rap": "4,600",
          "low_price": "2,280",
          "high_price": "4,940"
        },
        "1.1": {
          "rap": "4,600",
          "low_price": "2,510",
          "high_price": "5,435"
        },
        "1.2": {
          "rap": "4,600",
          "low_price": "2,735",
          "high_price": "5,930"
        },
        "1.3": {
          "rap": "4,600",
          "low_price": "2,965",
          "high_price": "6,420"
        },
        "1.4": {
          "rap": "4,600",
          "low_price": "3,190",
          "high_price": "6,915"
        },
        "1.5": {
          "rap": "6,900",
          "low_price": "5,490",
          "high_price": "11,895"
        },
        "1.6": {
          "rap": "6,900",
          "low_price": "5,855",
          "high_price": "12,690"
        },
        "1.7": {
          "rap": "6,900",
          "low_price": "6,220",
          "high_price": "13,480"
        },
        "1.8": {
          "rap": "6,900",
          "low_price": "6,590",
          "high_price": "14,275"
        },
        "1.9": {
          "rap": "6,900",
          "low_price": "6,955",
          "high_price": "15,065"
        },
        "2.0": {
          "rap": "9,000",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.1": {
          "rap": "9,000",
          "low_price": "10,585",
          "high_price": "22,930"
        },
        "2.2": {
          "rap": "9,000",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.3": {
          "rap": "9,000",
          "low_price": "11,590",
          "high_price": "25,115"
        },
        "2.4": {
          "rap": "9,000",
          "low_price": "12,095",
          "high_price": "26,210"
        },
        "2.5": {
          "rap": "9,000",
          "low_price": "12,600",
          "high_price": "27,300"
        },
        "2.6": {
          "rap": "9,000",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.7": {
          "rap": "9,000",
          "low_price": "13,610",
          "high_price": "29,485"
        },
        "2.8": {
          "rap": "9,000",
          "low_price": "14,110",
          "high_price": "30,575"
        },
        "2.9": {
          "rap": "9,000",
          "low_price": "14,615",
          "high_price": "31,670"
        },
        "3.0": {
          "rap": "14,600",
          "low_price": "25,560",
          "high_price": "55,380"
        },
        "3.1": {
          "rap": "14,600",
          "low_price": "26,410",
          "high_price": "57,225"
        },
        "3.2": {
          "rap": "14,600",
          "low_price": "27,265",
          "high_price": "59,070"
        },
        "3.3": {
          "rap": "14,600",
          "low_price": "28,115",
          "high_price": "60,920"
        },
        "3.4": {
          "rap": "14,600",
          "low_price": "28,970",
          "high_price": "62,765"
        },
        "3.5": {
          "rap": "14,600",
          "low_price": "29,820",
          "high_price": "64,610"
        },
        "3.6": {
          "rap": "14,600",
          "low_price": "30,670",
          "high_price": "66,455"
        },
        "3.7": {
          "rap": "14,600",
          "low_price": "31,525",
          "high_price": "68,300"
        },
        "3.8": {
          "rap": "14,600",
          "low_price": "32,375",
          "high_price": "70,150"
        },
        "3.9": {
          "rap": "14,600",
          "low_price": "33,230",
          "high_price": "71,995"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,400",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "2,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "3,000",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "1.0": {
          "rap": "3,700",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "1.1": {
          "rap": "3,700",
          "low_price": "2,110",
          "high_price": "4,575"
        },
        "1.2": {
          "rap": "3,700",
          "low_price": "2,305",
          "high_price": "4,990"
        },
        "1.3": {
          "rap": "3,700",
          "low_price": "2,495",
          "high_price": "5,410"
        },
        "1.4": {
          "rap": "3,700",
          "low_price": "2,690",
          "high_price": "5,825"
        },
        "1.5": {
          "rap": "5,500",
          "low_price": "4,230",
          "high_price": "9,165"
        },
        "1.6": {
          "rap": "5,500",
          "low_price": "4,510",
          "high_price": "9,775"
        },
        "1.7": {
          "rap": "5,500",
          "low_price": "4,795",
          "high_price": "10,385"
        },
        "1.8": {
          "rap": "5,500",
          "low_price": "5,075",
          "high_price": "11,000"
        },
        "1.9": {
          "rap": "5,500",
          "low_price": "5,360",
          "high_price": "11,610"
        },
        "2.0": {
          "rap": "7,300",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.1": {
          "rap": "7,300",
          "low_price": "8,315",
          "high_price": "18,020"
        },
        "2.2": {
          "rap": "7,300",
          "low_price": "8,710",
          "high_price": "18,875"
        },
        "2.3": {
          "rap": "7,300",
          "low_price": "9,110",
          "high_price": "19,735"
        },
        "2.4": {
          "rap": "7,300",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "2.5": {
          "rap": "7,300",
          "low_price": "9,900",
          "high_price": "21,450"
        },
        "2.6": {
          "rap": "7,300",
          "low_price": "10,295",
          "high_price": "22,310"
        },
        "2.7": {
          "rap": "7,300",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "2.8": {
          "rap": "7,300",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.9": {
          "rap": "7,300",
          "low_price": "11,485",
          "high_price": "24,880"
        },
        "3.0": {
          "rap": "11,400",
          "low_price": "19,980",
          "high_price": "43,290"
        },
        "3.1": {
          "rap": "11,400",
          "low_price": "20,645",
          "high_price": "44,735"
        },
        "3.2": {
          "rap": "11,400",
          "low_price": "21,310",
          "high_price": "46,175"
        },
        "3.3": {
          "rap": "11,400",
          "low_price": "21,980",
          "high_price": "47,620"
        },
        "3.4": {
          "rap": "11,400",
          "low_price": "22,645",
          "high_price": "49,060"
        },
        "3.5": {
          "rap": "11,400",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "3.6": {
          "rap": "11,400",
          "low_price": "23,975",
          "high_price": "51,950"
        },
        "3.7": {
          "rap": "11,400",
          "low_price": "24,640",
          "high_price": "53,390"
        },
        "3.8": {
          "rap": "11,400",
          "low_price": "25,310",
          "high_price": "54,835"
        },
        "3.9": {
          "rap": "11,400",
          "low_price": "25,975",
          "high_price": "56,275"
        }
      }
    },
    "VVS2": {
      "D": {
        "0.4": {
          "rap": "2,800",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.5": {
          "rap": "3,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.6": {
          "rap": "3,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.7": {
          "rap": "5,300",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.8": {
          "rap": "5,300",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "0.9": {
          "rap": "7,100",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.0": {
          "rap": "9,400",
          "low_price": "4,560",
          "high_price": "9,880"
        },
        "1.1": {
          "rap": "9,400",
          "low_price": "5,015",
          "high_price": "10,870"
        },
        "1.2": {
          "rap": "9,400",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "1.3": {
          "rap": "9,400",
          "low_price": "5,930",
          "high_price": "12,845"
        },
        "1.4": {
          "rap": "9,400",
          "low_price": "6,385",
          "high_price": "13,830"
        },
        "1.5": {
          "rap": "15,000",
          "low_price": "11,250",
          "high_price": "24,375"
        },
        "1.6": {
          "rap": "15,000",
          "low_price": "12,000",
          "high_price": "26,000"
        },
        "1.7": {
          "rap": "15,000",
          "low_price": "12,750",
          "high_price": "27,625"
        },
        "1.8": {
          "rap": "15,000",
          "low_price": "13,500",
          "high_price": "29,250"
        },
        "1.9": {
          "rap": "15,000",
          "low_price": "14,250",
          "high_price": "30,875"
        },
        "2.0": {
          "rap": "21,000",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "2.1": {
          "rap": "21,000",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "2.2": {
          "rap": "21,000",
          "low_price": "24,420",
          "high_price": "52,910"
        },
        "2.3": {
          "rap": "21,000",
          "low_price": "25,530",
          "high_price": "55,315"
        },
        "2.4": {
          "rap": "21,000",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "2.5": {
          "rap": "21,000",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "2.6": {
          "rap": "21,000",
          "low_price": "28,860",
          "high_price": "62,530"
        },
        "2.7": {
          "rap": "21,000",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "2.8": {
          "rap": "21,000",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "2.9": {
          "rap": "21,000",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.0": {
          "rap": "33,500",
          "low_price": "58,500",
          "high_price": "126,750"
        },
        "3.1": {
          "rap": "33,500",
          "low_price": "60,450",
          "high_price": "130,975"
        },
        "3.2": {
          "rap": "33,500",
          "low_price": "62,400",
          "high_price": "135,200"
        },
        "3.3": {
          "rap": "33,500",
          "low_price": "64,350",
          "high_price": "139,425"
        },
        "3.4": {
          "rap": "33,500",
          "low_price": "66,300",
          "high_price": "143,650"
        },
        "3.5": {
          "rap": "33,500",
          "low_price": "68,250",
          "high_price": "147,875"
        },
        "3.6": {
          "rap": "33,500",
          "low_price": "70,200",
          "high_price": "152,100"
        },
        "3.7": {
          "rap": "33,500",
          "low_price": "72,150",
          "high_price": "156,325"
        },
        "3.8": {
          "rap": "33,500",
          "low_price": "74,100",
          "high_price": "160,550"
        },
        "3.9": {
          "rap": "33,500",
          "low_price": "76,050",
          "high_price": "164,775"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,600",
          "low_price": "530",
          "high_price": "1,145"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,825",
          "high_price": "3,950"
        },
        "0.9": {
          "rap": "6,500",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "8,700",
          "low_price": "4,140",
          "high_price": "8,970"
        },
        "1.1": {
          "rap": "8,700",
          "low_price": "4,555",
          "high_price": "9,865"
        },
        "1.2": {
          "rap": "8,700",
          "low_price": "4,970",
          "high_price": "10,765"
        },
        "1.3": {
          "rap": "8,700",
          "low_price": "5,380",
          "high_price": "11,660"
        },
        "1.4": {
          "rap": "8,700",
          "low_price": "5,795",
          "high_price": "12,560"
        },
        "1.5": {
          "rap": "13,600",
          "low_price": "10,440",
          "high_price": "22,620"
        },
        "1.6": {
          "rap": "13,600",
          "low_price": "11,135",
          "high_price": "24,130"
        },
        "1.7": {
          "rap": "13,600",
          "low_price": "11,830",
          "high_price": "25,635"
        },
        "1.8": {
          "rap": "13,600",
          "low_price": "12,530",
          "high_price": "27,145"
        },
        "1.9": {
          "rap": "13,600",
          "low_price": "13,225",
          "high_price": "28,650"
        },
        "2.0": {
          "rap": "19,500",
          "low_price": "20,400",
          "high_price": "44,200"
        },
        "2.1": {
          "rap": "19,500",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "2.2": {
          "rap": "19,500",
          "low_price": "22,440",
          "high_price": "48,620"
        },
        "2.3": {
          "rap": "19,500",
          "low_price": "23,460",
          "high_price": "50,830"
        },
        "2.4": {
          "rap": "19,500",
          "low_price": "24,480",
          "high_price": "53,040"
        },
        "2.5": {
          "rap": "19,500",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "2.6": {
          "rap": "19,500",
          "low_price": "26,520",
          "high_price": "57,460"
        },
        "2.7": {
          "rap": "19,500",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "2.8": {
          "rap": "19,500",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "2.9": {
          "rap": "19,500",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.0": {
          "rap": "30,500",
          "low_price": "53,100",
          "high_price": "115,050"
        },
        "3.1": {
          "rap": "30,500",
          "low_price": "54,870",
          "high_price": "118,885"
        },
        "3.2": {
          "rap": "30,500",
          "low_price": "56,640",
          "high_price": "122,720"
        },
        "3.3": {
          "rap": "30,500",
          "low_price": "58,410",
          "high_price": "126,555"
        },
        "3.4": {
          "rap": "30,500",
          "low_price": "60,180",
          "high_price": "130,390"
        },
        "3.5": {
          "rap": "30,500",
          "low_price": "61,950",
          "high_price": "134,225"
        },
        "3.6": {
          "rap": "30,500",
          "low_price": "63,720",
          "high_price": "138,060"
        },
        "3.7": {
          "rap": "30,500",
          "low_price": "65,490",
          "high_price": "141,895"
        },
        "3.8": {
          "rap": "30,500",
          "low_price": "67,260",
          "high_price": "145,730"
        },
        "3.9": {
          "rap": "30,500",
          "low_price": "69,030",
          "high_price": "149,565"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "750",
          "high_price": "1,625"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.7": {
          "rap": "4,800",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "0.8": {
          "rap": "4,800",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "0.9": {
          "rap": "6,000",
          "low_price": "2,645",
          "high_price": "5,735"
        },
        "1.0": {
          "rap": "8,000",
          "low_price": "3,840",
          "high_price": "8,320"
        },
        "1.1": {
          "rap": "8,000",
          "low_price": "4,225",
          "high_price": "9,150"
        },
        "1.2": {
          "rap": "8,000",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.3": {
          "rap": "8,000",
          "low_price": "4,990",
          "high_price": "10,815"
        },
        "1.4": {
          "rap": "8,000",
          "low_price": "5,375",
          "high_price": "11,650"
        },
        "1.5": {
          "rap": "12,700",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "1.6": {
          "rap": "12,700",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "1.7": {
          "rap": "12,700",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "1.8": {
          "rap": "12,700",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "1.9": {
          "rap": "12,700",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "2.0": {
          "rap": "18,000",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "18,000",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "18,000",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "18,000",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "18,000",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "18,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "18,000",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "18,000",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "18,000",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "18,000",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "28,000",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.1": {
          "rap": "28,000",
          "low_price": "50,220",
          "high_price": "108,810"
        },
        "3.2": {
          "rap": "28,000",
          "low_price": "51,840",
          "high_price": "112,320"
        },
        "3.3": {
          "rap": "28,000",
          "low_price": "53,460",
          "high_price": "115,830"
        },
        "3.4": {
          "rap": "28,000",
          "low_price": "55,080",
          "high_price": "119,340"
        },
        "3.5": {
          "rap": "28,000",
          "low_price": "56,700",
          "high_price": "122,850"
        },
        "3.6": {
          "rap": "28,000",
          "low_price": "58,320",
          "high_price": "126,360"
        },
        "3.7": {
          "rap": "28,000",
          "low_price": "59,940",
          "high_price": "129,870"
        },
        "3.8": {
          "rap": "28,000",
          "low_price": "61,560",
          "high_price": "133,380"
        },
        "3.9": {
          "rap": "28,000",
          "low_price": "63,180",
          "high_price": "136,890"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,300",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,800",
          "low_price": "690",
          "high_price": "1,495"
        },
        "0.6": {
          "rap": "2,800",
          "low_price": "830",
          "high_price": "1,795"
        },
        "0.7": {
          "rap": "4,500",
          "low_price": "1,385",
          "high_price": "3,005"
        },
        "0.8": {
          "rap": "4,500",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "0.9": {
          "rap": "5,600",
          "low_price": "2,485",
          "high_price": "5,380"
        },
        "1.0": {
          "rap": "7,300",
          "low_price": "3,480",
          "high_price": "7,540"
        },
        "1.1": {
          "rap": "7,300",
          "low_price": "3,830",
          "high_price": "8,295"
        },
        "1.2": {
          "rap": "7,300",
          "low_price": "4,175",
          "high_price": "9,050"
        },
        "1.3": {
          "rap": "7,300",
          "low_price": "4,525",
          "high_price": "9,800"
        },
        "1.4": {
          "rap": "7,300",
          "low_price": "4,870",
          "high_price": "10,555"
        },
        "1.5": {
          "rap": "11,700",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "1.6": {
          "rap": "11,700",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "1.7": {
          "rap": "11,700",
          "low_price": "10,200",
          "high_price": "22,100"
        },
        "1.8": {
          "rap": "11,700",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "1.9": {
          "rap": "11,700",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "2.0": {
          "rap": "16,500",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.1": {
          "rap": "16,500",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "2.2": {
          "rap": "16,500",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.3": {
          "rap": "16,500",
          "low_price": "20,700",
          "high_price": "44,850"
        },
        "2.4": {
          "rap": "16,500",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "2.5": {
          "rap": "16,500",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "2.6": {
          "rap": "16,500",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.7": {
          "rap": "16,500",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "2.8": {
          "rap": "16,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.9": {
          "rap": "16,500",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.0": {
          "rap": "25,000",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.1": {
          "rap": "25,000",
          "low_price": "45,570",
          "high_price": "98,735"
        },
        "3.2": {
          "rap": "25,000",
          "low_price": "47,040",
          "high_price": "101,920"
        },
        "3.3": {
          "rap": "25,000",
          "low_price": "48,510",
          "high_price": "105,105"
        },
        "3.4": {
          "rap": "25,000",
          "low_price": "49,980",
          "high_price": "108,290"
        },
        "3.5": {
          "rap": "25,000",
          "low_price": "51,450",
          "high_price": "111,475"
        },
        "3.6": {
          "rap": "25,000",
          "low_price": "52,920",
          "high_price": "114,660"
        },
        "3.7": {
          "rap": "25,000",
          "low_price": "54,390",
          "high_price": "117,845"
        },
        "3.8": {
          "rap": "25,000",
          "low_price": "55,860",
          "high_price": "121,030"
        },
        "3.9": {
          "rap": "25,000",
          "low_price": "57,330",
          "high_price": "124,215"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,100",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "2,600",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.6": {
          "rap": "2,600",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.7": {
          "rap": "4,100",
          "low_price": "1,260",
          "high_price": "2,730"
        },
        "0.8": {
          "rap": "4,100",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "0.9": {
          "rap": "5,200",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.0": {
          "rap": "6,300",
          "low_price": "2,940",
          "high_price": "6,370"
        },
        "1.1": {
          "rap": "6,300",
          "low_price": "3,235",
          "high_price": "7,005"
        },
        "1.2": {
          "rap": "6,300",
          "low_price": "3,530",
          "high_price": "7,645"
        },
        "1.3": {
          "rap": "6,300",
          "low_price": "3,820",
          "high_price": "8,280"
        },
        "1.4": {
          "rap": "6,300",
          "low_price": "4,115",
          "high_price": "8,920"
        },
        "1.5": {
          "rap": "9,900",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "1.6": {
          "rap": "9,900",
          "low_price": "8,065",
          "high_price": "17,470"
        },
        "1.7": {
          "rap": "9,900",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "1.8": {
          "rap": "9,900",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "1.9": {
          "rap": "9,900",
          "low_price": "9,575",
          "high_price": "20,750"
        },
        "2.0": {
          "rap": "13,500",
          "low_price": "14,400",
          "high_price": "31,200"
        },
        "2.1": {
          "rap": "13,500",
          "low_price": "15,120",
          "high_price": "32,760"
        },
        "2.2": {
          "rap": "13,500",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "2.3": {
          "rap": "13,500",
          "low_price": "16,560",
          "high_price": "35,880"
        },
        "2.4": {
          "rap": "13,500",
          "low_price": "17,280",
          "high_price": "37,440"
        },
        "2.5": {
          "rap": "13,500",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.6": {
          "rap": "13,500",
          "low_price": "18,720",
          "high_price": "40,560"
        },
        "2.7": {
          "rap": "13,500",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.8": {
          "rap": "13,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.9": {
          "rap": "13,500",
          "low_price": "20,880",
          "high_price": "45,240"
        },
        "3.0": {
          "rap": "21,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.1": {
          "rap": "21,500",
          "low_price": "39,060",
          "high_price": "84,630"
        },
        "3.2": {
          "rap": "21,500",
          "low_price": "40,320",
          "high_price": "87,360"
        },
        "3.3": {
          "rap": "21,500",
          "low_price": "41,580",
          "high_price": "90,090"
        },
        "3.4": {
          "rap": "21,500",
          "low_price": "42,840",
          "high_price": "92,820"
        },
        "3.5": {
          "rap": "21,500",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.6": {
          "rap": "21,500",
          "low_price": "45,360",
          "high_price": "98,280"
        },
        "3.7": {
          "rap": "21,500",
          "low_price": "46,620",
          "high_price": "101,010"
        },
        "3.8": {
          "rap": "21,500",
          "low_price": "47,880",
          "high_price": "103,740"
        },
        "3.9": {
          "rap": "21,500",
          "low_price": "49,140",
          "high_price": "106,470"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,900",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,400",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,400",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,400",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "0.8": {
          "rap": "3,400",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "0.9": {
          "rap": "4,400",
          "low_price": "2,000",
          "high_price": "4,330"
        },
        "1.0": {
          "rap": "5,400",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.1": {
          "rap": "5,400",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.2": {
          "rap": "5,400",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.3": {
          "rap": "5,400",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.4": {
          "rap": "5,400",
          "low_price": "3,530",
          "high_price": "7,645"
        },
        "1.5": {
          "rap": "8,200",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "1.6": {
          "rap": "8,200",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "1.7": {
          "rap": "8,200",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "1.8": {
          "rap": "8,200",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "1.9": {
          "rap": "8,200",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "2.0": {
          "rap": "10,700",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "2.1": {
          "rap": "10,700",
          "low_price": "12,475",
          "high_price": "27,025"
        },
        "2.2": {
          "rap": "10,700",
          "low_price": "13,070",
          "high_price": "28,315"
        },
        "2.3": {
          "rap": "10,700",
          "low_price": "13,660",
          "high_price": "29,600"
        },
        "2.4": {
          "rap": "10,700",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.5": {
          "rap": "10,700",
          "low_price": "14,850",
          "high_price": "32,175"
        },
        "2.6": {
          "rap": "10,700",
          "low_price": "15,445",
          "high_price": "33,460"
        },
        "2.7": {
          "rap": "10,700",
          "low_price": "16,040",
          "high_price": "34,750"
        },
        "2.8": {
          "rap": "10,700",
          "low_price": "16,630",
          "high_price": "36,035"
        },
        "2.9": {
          "rap": "10,700",
          "low_price": "17,225",
          "high_price": "37,325"
        },
        "3.0": {
          "rap": "18,000",
          "low_price": "31,500",
          "high_price": "68,250"
        },
        "3.1": {
          "rap": "18,000",
          "low_price": "32,550",
          "high_price": "70,525"
        },
        "3.2": {
          "rap": "18,000",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "3.3": {
          "rap": "18,000",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "3.4": {
          "rap": "18,000",
          "low_price": "35,700",
          "high_price": "77,350"
        },
        "3.5": {
          "rap": "18,000",
          "low_price": "36,750",
          "high_price": "79,625"
        },
        "3.6": {
          "rap": "18,000",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.7": {
          "rap": "18,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.8": {
          "rap": "18,000",
          "low_price": "39,900",
          "high_price": "86,450"
        },
        "3.9": {
          "rap": "18,000",
          "low_price": "40,950",
          "high_price": "88,725"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,600",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,000",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "2,000",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "2,800",
          "low_price": "965",
          "high_price": "2,095"
        },
        "0.8": {
          "rap": "2,800",
          "low_price": "1,105",
          "high_price": "2,390"
        },
        "0.9": {
          "rap": "3,600",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.0": {
          "rap": "4,400",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.1": {
          "rap": "4,400",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.2": {
          "rap": "4,400",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.3": {
          "rap": "4,400",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.4": {
          "rap": "4,400",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.5": {
          "rap": "6,600",
          "low_price": "5,220",
          "high_price": "11,310"
        },
        "1.6": {
          "rap": "6,600",
          "low_price": "5,570",
          "high_price": "12,065"
        },
        "1.7": {
          "rap": "6,600",
          "low_price": "5,915",
          "high_price": "12,820"
        },
        "1.8": {
          "rap": "6,600",
          "low_price": "6,265",
          "high_price": "13,570"
        },
        "1.9": {
          "rap": "6,600",
          "low_price": "6,610",
          "high_price": "14,325"
        },
        "2.0": {
          "rap": "8,700",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "2.1": {
          "rap": "8,700",
          "low_price": "10,205",
          "high_price": "22,115"
        },
        "2.2": {
          "rap": "8,700",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "2.3": {
          "rap": "8,700",
          "low_price": "11,180",
          "high_price": "24,220"
        },
        "2.4": {
          "rap": "8,700",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "2.5": {
          "rap": "8,700",
          "low_price": "12,150",
          "high_price": "26,325"
        },
        "2.6": {
          "rap": "8,700",
          "low_price": "12,635",
          "high_price": "27,380"
        },
        "2.7": {
          "rap": "8,700",
          "low_price": "13,120",
          "high_price": "28,430"
        },
        "2.8": {
          "rap": "8,700",
          "low_price": "13,610",
          "high_price": "29,485"
        },
        "2.9": {
          "rap": "8,700",
          "low_price": "14,095",
          "high_price": "30,535"
        },
        "3.0": {
          "rap": "13,900",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "3.1": {
          "rap": "13,900",
          "low_price": "25,110",
          "high_price": "54,405"
        },
        "3.2": {
          "rap": "13,900",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "3.3": {
          "rap": "13,900",
          "low_price": "26,730",
          "high_price": "57,915"
        },
        "3.4": {
          "rap": "13,900",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "3.5": {
          "rap": "13,900",
          "low_price": "28,350",
          "high_price": "61,425"
        },
        "3.6": {
          "rap": "13,900",
          "low_price": "29,160",
          "high_price": "63,180"
        },
        "3.7": {
          "rap": "13,900",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "3.8": {
          "rap": "13,900",
          "low_price": "30,780",
          "high_price": "66,690"
        },
        "3.9": {
          "rap": "13,900",
          "low_price": "31,590",
          "high_price": "68,445"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,300",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "2,900",
          "low_price": "1,405",
          "high_price": "3,040"
        },
        "1.0": {
          "rap": "3,500",
          "low_price": "1,800",
          "high_price": "3,900"
        },
        "1.1": {
          "rap": "3,500",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.2": {
          "rap": "3,500",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.3": {
          "rap": "3,500",
          "low_price": "2,340",
          "high_price": "5,070"
        },
        "1.4": {
          "rap": "3,500",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.5": {
          "rap": "5,300",
          "low_price": "4,050",
          "high_price": "8,775"
        },
        "1.6": {
          "rap": "5,300",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.7": {
          "rap": "5,300",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.8": {
          "rap": "5,300",
          "low_price": "4,860",
          "high_price": "10,530"
        },
        "1.9": {
          "rap": "5,300",
          "low_price": "5,130",
          "high_price": "11,115"
        },
        "2.0": {
          "rap": "7,100",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.1": {
          "rap": "7,100",
          "low_price": "7,940",
          "high_price": "17,200"
        },
        "2.2": {
          "rap": "7,100",
          "low_price": "8,315",
          "high_price": "18,020"
        },
        "2.3": {
          "rap": "7,100",
          "low_price": "8,695",
          "high_price": "18,835"
        },
        "2.4": {
          "rap": "7,100",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "2.5": {
          "rap": "7,100",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "2.6": {
          "rap": "7,100",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "2.7": {
          "rap": "7,100",
          "low_price": "10,205",
          "high_price": "22,115"
        },
        "2.8": {
          "rap": "7,100",
          "low_price": "10,585",
          "high_price": "22,930"
        },
        "2.9": {
          "rap": "7,100",
          "low_price": "10,960",
          "high_price": "23,750"
        },
        "3.0": {
          "rap": "10,800",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "3.1": {
          "rap": "10,800",
          "low_price": "19,530",
          "high_price": "42,315"
        },
        "3.2": {
          "rap": "10,800",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "3.3": {
          "rap": "10,800",
          "low_price": "20,790",
          "high_price": "45,045"
        },
        "3.4": {
          "rap": "10,800",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "3.5": {
          "rap": "10,800",
          "low_price": "22,050",
          "high_price": "47,775"
        },
        "3.6": {
          "rap": "10,800",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "3.7": {
          "rap": "10,800",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "3.8": {
          "rap": "10,800",
          "low_price": "23,940",
          "high_price": "51,870"
        },
        "3.9": {
          "rap": "10,800",
          "low_price": "24,570",
          "high_price": "53,235"
        }
      }
    }
  },
  "Cushion": {
    "I1": {
      "D": {
        "0.4": {
          "rap": "1,200",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "2,400",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "2,700",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "1.0": {
          "rap": "3,300",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "3,300",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "3,300",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "3,300",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "3,300",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "5,300",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.6": {
          "rap": "5,300",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.7": {
          "rap": "5,300",
          "low_price": "5,200",
          "high_price": "11,270"
        },
        "1.8": {
          "rap": "5,300",
          "low_price": "5,510",
          "high_price": "11,935"
        },
        "1.9": {
          "rap": "5,300",
          "low_price": "5,815",
          "high_price": "12,595"
        },
        "2.0": {
          "rap": "6,900",
          "low_price": "8,280",
          "high_price": "17,940"
        },
        "2.1": {
          "rap": "6,900",
          "low_price": "8,695",
          "high_price": "18,835"
        },
        "2.2": {
          "rap": "6,900",
          "low_price": "9,110",
          "high_price": "19,735"
        },
        "2.3": {
          "rap": "6,900",
          "low_price": "9,520",
          "high_price": "20,630"
        },
        "2.4": {
          "rap": "6,900",
          "low_price": "9,935",
          "high_price": "21,530"
        },
        "2.5": {
          "rap": "6,900",
          "low_price": "10,350",
          "high_price": "22,425"
        },
        "2.6": {
          "rap": "6,900",
          "low_price": "10,765",
          "high_price": "23,320"
        },
        "2.7": {
          "rap": "6,900",
          "low_price": "11,180",
          "high_price": "24,220"
        },
        "2.8": {
          "rap": "6,900",
          "low_price": "11,590",
          "high_price": "25,115"
        },
        "2.9": {
          "rap": "6,900",
          "low_price": "12,005",
          "high_price": "26,015"
        },
        "3.0": {
          "rap": "8,600",
          "low_price": "15,480",
          "high_price": "33,540"
        },
        "3.1": {
          "rap": "8,600",
          "low_price": "15,995",
          "high_price": "34,660"
        },
        "3.2": {
          "rap": "8,600",
          "low_price": "16,510",
          "high_price": "35,775"
        },
        "3.3": {
          "rap": "8,600",
          "low_price": "17,030",
          "high_price": "36,895"
        },
        "3.4": {
          "rap": "8,600",
          "low_price": "17,545",
          "high_price": "38,010"
        },
        "3.5": {
          "rap": "8,600",
          "low_price": "18,060",
          "high_price": "39,130"
        },
        "3.6": {
          "rap": "8,600",
          "low_price": "18,575",
          "high_price": "40,250"
        },
        "3.7": {
          "rap": "8,600",
          "low_price": "19,090",
          "high_price": "41,365"
        },
        "3.8": {
          "rap": "8,600",
          "low_price": "19,610",
          "high_price": "42,485"
        },
        "3.9": {
          "rap": "8,600",
          "low_price": "20,125",
          "high_price": "43,600"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,100",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "2,600",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "3,200",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "3,200",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "3,200",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "3,200",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "3,200",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "5,000",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "5,000",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "5,000",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "5,000",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "5,000",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "6,400",
          "low_price": "7,680",
          "high_price": "16,640"
        },
        "2.1": {
          "rap": "6,400",
          "low_price": "8,065",
          "high_price": "17,470"
        },
        "2.2": {
          "rap": "6,400",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "2.3": {
          "rap": "6,400",
          "low_price": "8,830",
          "high_price": "19,135"
        },
        "2.4": {
          "rap": "6,400",
          "low_price": "9,215",
          "high_price": "19,970"
        },
        "2.5": {
          "rap": "6,400",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "2.6": {
          "rap": "6,400",
          "low_price": "9,985",
          "high_price": "21,630"
        },
        "2.7": {
          "rap": "6,400",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "2.8": {
          "rap": "6,400",
          "low_price": "10,750",
          "high_price": "23,295"
        },
        "2.9": {
          "rap": "6,400",
          "low_price": "11,135",
          "high_price": "24,130"
        },
        "3.0": {
          "rap": "8,000",
          "low_price": "14,400",
          "high_price": "31,200"
        },
        "3.1": {
          "rap": "8,000",
          "low_price": "14,880",
          "high_price": "32,240"
        },
        "3.2": {
          "rap": "8,000",
          "low_price": "15,360",
          "high_price": "33,280"
        },
        "3.3": {
          "rap": "8,000",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "3.4": {
          "rap": "8,000",
          "low_price": "16,320",
          "high_price": "35,360"
        },
        "3.5": {
          "rap": "8,000",
          "low_price": "16,800",
          "high_price": "36,400"
        },
        "3.6": {
          "rap": "8,000",
          "low_price": "17,280",
          "high_price": "37,440"
        },
        "3.7": {
          "rap": "8,000",
          "low_price": "17,760",
          "high_price": "38,480"
        },
        "3.8": {
          "rap": "8,000",
          "low_price": "18,240",
          "high_price": "39,520"
        },
        "3.9": {
          "rap": "8,000",
          "low_price": "18,720",
          "high_price": "40,560"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,000",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,500",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,200",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,200",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,500",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "1.0": {
          "rap": "3,100",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "1.1": {
          "rap": "3,100",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.2": {
          "rap": "3,100",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.3": {
          "rap": "3,100",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.4": {
          "rap": "3,100",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "1.5": {
          "rap": "4,700",
          "low_price": "4,050",
          "high_price": "8,775"
        },
        "1.6": {
          "rap": "4,700",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.7": {
          "rap": "4,700",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.8": {
          "rap": "4,700",
          "low_price": "4,860",
          "high_price": "10,530"
        },
        "1.9": {
          "rap": "4,700",
          "low_price": "5,130",
          "high_price": "11,115"
        },
        "2.0": {
          "rap": "5,900",
          "low_price": "7,080",
          "high_price": "15,340"
        },
        "2.1": {
          "rap": "5,900",
          "low_price": "7,435",
          "high_price": "16,105"
        },
        "2.2": {
          "rap": "5,900",
          "low_price": "7,790",
          "high_price": "16,875"
        },
        "2.3": {
          "rap": "5,900",
          "low_price": "8,140",
          "high_price": "17,640"
        },
        "2.4": {
          "rap": "5,900",
          "low_price": "8,495",
          "high_price": "18,410"
        },
        "2.5": {
          "rap": "5,900",
          "low_price": "8,850",
          "high_price": "19,175"
        },
        "2.6": {
          "rap": "5,900",
          "low_price": "9,205",
          "high_price": "19,940"
        },
        "2.7": {
          "rap": "5,900",
          "low_price": "9,560",
          "high_price": "20,710"
        },
        "2.8": {
          "rap": "5,900",
          "low_price": "9,910",
          "high_price": "21,475"
        },
        "2.9": {
          "rap": "5,900",
          "low_price": "10,265",
          "high_price": "22,245"
        },
        "3.0": {
          "rap": "7,400",
          "low_price": "13,320",
          "high_price": "28,860"
        },
        "3.1": {
          "rap": "7,400",
          "low_price": "13,765",
          "high_price": "29,820"
        },
        "3.2": {
          "rap": "7,400",
          "low_price": "14,210",
          "high_price": "30,785"
        },
        "3.3": {
          "rap": "7,400",
          "low_price": "14,650",
          "high_price": "31,745"
        },
        "3.4": {
          "rap": "7,400",
          "low_price": "15,095",
          "high_price": "32,710"
        },
        "3.5": {
          "rap": "7,400",
          "low_price": "15,540",
          "high_price": "33,670"
        },
        "3.6": {
          "rap": "7,400",
          "low_price": "15,985",
          "high_price": "34,630"
        },
        "3.7": {
          "rap": "7,400",
          "low_price": "16,430",
          "high_price": "35,595"
        },
        "3.8": {
          "rap": "7,400",
          "low_price": "16,870",
          "high_price": "36,555"
        },
        "3.9": {
          "rap": "7,400",
          "low_price": "17,315",
          "high_price": "37,520"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,000",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,400",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "2,900",
          "low_price": "1,560",
          "high_price": "3,380"
        },
        "1.1": {
          "rap": "2,900",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.2": {
          "rap": "2,900",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.3": {
          "rap": "2,900",
          "low_price": "2,030",
          "high_price": "4,395"
        },
        "1.4": {
          "rap": "2,900",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.5": {
          "rap": "4,400",
          "low_price": "3,780",
          "high_price": "8,190"
        },
        "1.6": {
          "rap": "4,400",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.7": {
          "rap": "4,400",
          "low_price": "4,285",
          "high_price": "9,280"
        },
        "1.8": {
          "rap": "4,400",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.9": {
          "rap": "4,400",
          "low_price": "4,790",
          "high_price": "10,375"
        },
        "2.0": {
          "rap": "5,500",
          "low_price": "6,600",
          "high_price": "14,300"
        },
        "2.1": {
          "rap": "5,500",
          "low_price": "6,930",
          "high_price": "15,015"
        },
        "2.2": {
          "rap": "5,500",
          "low_price": "7,260",
          "high_price": "15,730"
        },
        "2.3": {
          "rap": "5,500",
          "low_price": "7,590",
          "high_price": "16,445"
        },
        "2.4": {
          "rap": "5,500",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.5": {
          "rap": "5,500",
          "low_price": "8,250",
          "high_price": "17,875"
        },
        "2.6": {
          "rap": "5,500",
          "low_price": "8,580",
          "high_price": "18,590"
        },
        "2.7": {
          "rap": "5,500",
          "low_price": "8,910",
          "high_price": "19,305"
        },
        "2.8": {
          "rap": "5,500",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.9": {
          "rap": "5,500",
          "low_price": "9,570",
          "high_price": "20,735"
        },
        "3.0": {
          "rap": "6,700",
          "low_price": "12,060",
          "high_price": "26,130"
        },
        "3.1": {
          "rap": "6,700",
          "low_price": "12,460",
          "high_price": "27,000"
        },
        "3.2": {
          "rap": "6,700",
          "low_price": "12,865",
          "high_price": "27,870"
        },
        "3.3": {
          "rap": "6,700",
          "low_price": "13,265",
          "high_price": "28,745"
        },
        "3.4": {
          "rap": "6,700",
          "low_price": "13,670",
          "high_price": "29,615"
        },
        "3.5": {
          "rap": "6,700",
          "low_price": "14,070",
          "high_price": "30,485"
        },
        "3.6": {
          "rap": "6,700",
          "low_price": "14,470",
          "high_price": "31,355"
        },
        "3.7": {
          "rap": "6,700",
          "low_price": "14,875",
          "high_price": "32,225"
        },
        "3.8": {
          "rap": "6,700",
          "low_price": "15,275",
          "high_price": "33,100"
        },
        "3.9": {
          "rap": "6,700",
          "low_price": "15,680",
          "high_price": "33,970"
        }
      },
      "H": {
        "0.4": {
          "rap": "900",
          "low_price": "215",
          "high_price": "470"
        },
        "0.5": {
          "rap": "1,300",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,300",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "2,000",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.8": {
          "rap": "2,000",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.9": {
          "rap": "2,300",
          "low_price": "1,080",
          "high_price": "2,340"
        },
        "1.0": {
          "rap": "2,700",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "1.1": {
          "rap": "2,700",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.2": {
          "rap": "2,700",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.3": {
          "rap": "2,700",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.4": {
          "rap": "2,700",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.5": {
          "rap": "4,100",
          "low_price": "3,510",
          "high_price": "7,605"
        },
        "1.6": {
          "rap": "4,100",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.7": {
          "rap": "4,100",
          "low_price": "3,980",
          "high_price": "8,620"
        },
        "1.8": {
          "rap": "4,100",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.9": {
          "rap": "4,100",
          "low_price": "4,445",
          "high_price": "9,635"
        },
        "2.0": {
          "rap": "5,100",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "2.1": {
          "rap": "5,100",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "2.2": {
          "rap": "5,100",
          "low_price": "6,730",
          "high_price": "14,585"
        },
        "2.3": {
          "rap": "5,100",
          "low_price": "7,040",
          "high_price": "15,250"
        },
        "2.4": {
          "rap": "5,100",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "2.5": {
          "rap": "5,100",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "2.6": {
          "rap": "5,100",
          "low_price": "7,955",
          "high_price": "17,240"
        },
        "2.7": {
          "rap": "5,100",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "2.8": {
          "rap": "5,100",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "2.9": {
          "rap": "5,100",
          "low_price": "8,875",
          "high_price": "19,225"
        },
        "3.0": {
          "rap": "6,200",
          "low_price": "11,160",
          "high_price": "24,180"
        },
        "3.1": {
          "rap": "6,200",
          "low_price": "11,530",
          "high_price": "24,985"
        },
        "3.2": {
          "rap": "6,200",
          "low_price": "11,905",
          "high_price": "25,790"
        },
        "3.3": {
          "rap": "6,200",
          "low_price": "12,275",
          "high_price": "26,600"
        },
        "3.4": {
          "rap": "6,200",
          "low_price": "12,650",
          "high_price": "27,405"
        },
        "3.5": {
          "rap": "6,200",
          "low_price": "13,020",
          "high_price": "28,210"
        },
        "3.6": {
          "rap": "6,200",
          "low_price": "13,390",
          "high_price": "29,015"
        },
        "3.7": {
          "rap": "6,200",
          "low_price": "13,765",
          "high_price": "29,820"
        },
        "3.8": {
          "rap": "6,200",
          "low_price": "14,135",
          "high_price": "30,630"
        },
        "3.9": {
          "rap": "6,200",
          "low_price": "14,510",
          "high_price": "31,435"
        }
      },
      "I": {
        "0.4": {
          "rap": "800",
          "low_price": "190",
          "high_price": "415"
        },
        "0.5": {
          "rap": "1,200",
          "low_price": "330",
          "high_price": "715"
        },
        "0.6": {
          "rap": "1,200",
          "low_price": "395",
          "high_price": "860"
        },
        "0.7": {
          "rap": "1,800",
          "low_price": "590",
          "high_price": "1,275"
        },
        "0.8": {
          "rap": "1,800",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.9": {
          "rap": "2,100",
          "low_price": "1,025",
          "high_price": "2,225"
        },
        "1.0": {
          "rap": "2,500",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "1.1": {
          "rap": "2,500",
          "low_price": "1,450",
          "high_price": "3,145"
        },
        "1.2": {
          "rap": "2,500",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.3": {
          "rap": "2,500",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.4": {
          "rap": "2,500",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.5": {
          "rap": "3,800",
          "low_price": "3,240",
          "high_price": "7,020"
        },
        "1.6": {
          "rap": "3,800",
          "low_price": "3,455",
          "high_price": "7,490"
        },
        "1.7": {
          "rap": "3,800",
          "low_price": "3,670",
          "high_price": "7,955"
        },
        "1.8": {
          "rap": "3,800",
          "low_price": "3,890",
          "high_price": "8,425"
        },
        "1.9": {
          "rap": "3,800",
          "low_price": "4,105",
          "high_price": "8,890"
        },
        "2.0": {
          "rap": "4,800",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "2.1": {
          "rap": "4,800",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "2.2": {
          "rap": "4,800",
          "low_price": "6,335",
          "high_price": "13,730"
        },
        "2.3": {
          "rap": "4,800",
          "low_price": "6,625",
          "high_price": "14,350"
        },
        "2.4": {
          "rap": "4,800",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "2.5": {
          "rap": "4,800",
          "low_price": "7,200",
          "high_price": "15,600"
        },
        "2.6": {
          "rap": "4,800",
          "low_price": "7,490",
          "high_price": "16,225"
        },
        "2.7": {
          "rap": "4,800",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "2.8": {
          "rap": "4,800",
          "low_price": "8,065",
          "high_price": "17,470"
        },
        "2.9": {
          "rap": "4,800",
          "low_price": "8,350",
          "high_price": "18,095"
        },
        "3.0": {
          "rap": "5,700",
          "low_price": "10,260",
          "high_price": "22,230"
        },
        "3.1": {
          "rap": "5,700",
          "low_price": "10,600",
          "high_price": "22,970"
        },
        "3.2": {
          "rap": "5,700",
          "low_price": "10,945",
          "high_price": "23,710"
        },
        "3.3": {
          "rap": "5,700",
          "low_price": "11,285",
          "high_price": "24,455"
        },
        "3.4": {
          "rap": "5,700",
          "low_price": "11,630",
          "high_price": "25,195"
        },
        "3.5": {
          "rap": "5,700",
          "low_price": "11,970",
          "high_price": "25,935"
        },
        "3.6": {
          "rap": "5,700",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "3.7": {
          "rap": "5,700",
          "low_price": "12,655",
          "high_price": "27,415"
        },
        "3.8": {
          "rap": "5,700",
          "low_price": "12,995",
          "high_price": "28,160"
        },
        "3.9": {
          "rap": "5,700",
          "low_price": "13,340",
          "high_price": "28,900"
        }
      },
      "J": {
        "0.4": {
          "rap": "700",
          "low_price": "170",
          "high_price": "365"
        },
        "0.5": {
          "rap": "1,100",
          "low_price": "300",
          "high_price": "650"
        },
        "0.6": {
          "rap": "1,100",
          "low_price": "360",
          "high_price": "780"
        },
        "0.7": {
          "rap": "1,500",
          "low_price": "545",
          "high_price": "1,185"
        },
        "0.8": {
          "rap": "1,500",
          "low_price": "625",
          "high_price": "1,350"
        },
        "0.9": {
          "rap": "1,900",
          "low_price": "920",
          "high_price": "1,990"
        },
        "1.0": {
          "rap": "2,200",
          "low_price": "1,140",
          "high_price": "2,470"
        },
        "1.1": {
          "rap": "2,200",
          "low_price": "1,255",
          "high_price": "2,715"
        },
        "1.2": {
          "rap": "2,200",
          "low_price": "1,370",
          "high_price": "2,965"
        },
        "1.3": {
          "rap": "2,200",
          "low_price": "1,480",
          "high_price": "3,210"
        },
        "1.4": {
          "rap": "2,200",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "1.5": {
          "rap": "3,500",
          "low_price": "2,970",
          "high_price": "6,435"
        },
        "1.6": {
          "rap": "3,500",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.7": {
          "rap": "3,500",
          "low_price": "3,365",
          "high_price": "7,295"
        },
        "1.8": {
          "rap": "3,500",
          "low_price": "3,565",
          "high_price": "7,720"
        },
        "1.9": {
          "rap": "3,500",
          "low_price": "3,760",
          "high_price": "8,150"
        },
        "2.0": {
          "rap": "4,500",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "2.1": {
          "rap": "4,500",
          "low_price": "5,670",
          "high_price": "12,285"
        },
        "2.2": {
          "rap": "4,500",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "2.3": {
          "rap": "4,500",
          "low_price": "6,210",
          "high_price": "13,455"
        },
        "2.4": {
          "rap": "4,500",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "2.5": {
          "rap": "4,500",
          "low_price": "6,750",
          "high_price": "14,625"
        },
        "2.6": {
          "rap": "4,500",
          "low_price": "7,020",
          "high_price": "15,210"
        },
        "2.7": {
          "rap": "4,500",
          "low_price": "7,290",
          "high_price": "15,795"
        },
        "2.8": {
          "rap": "4,500",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.9": {
          "rap": "4,500",
          "low_price": "7,830",
          "high_price": "16,965"
        },
        "3.0": {
          "rap": "5,400",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "3.1": {
          "rap": "5,400",
          "low_price": "10,045",
          "high_price": "21,760"
        },
        "3.2": {
          "rap": "5,400",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "3.3": {
          "rap": "5,400",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "3.4": {
          "rap": "5,400",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "3.5": {
          "rap": "5,400",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "3.6": {
          "rap": "5,400",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "3.7": {
          "rap": "5,400",
          "low_price": "11,990",
          "high_price": "25,975"
        },
        "3.8": {
          "rap": "5,400",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "3.9": {
          "rap": "5,400",
          "low_price": "12,635",
          "high_price": "27,380"
        }
      },
      "K": {
        "0.4": {
          "rap": "700",
          "low_price": "170",
          "high_price": "365"
        },
        "0.5": {
          "rap": "900",
          "low_price": "270",
          "high_price": "585"
        },
        "0.6": {
          "rap": "900",
          "low_price": "325",
          "high_price": "700"
        },
        "0.7": {
          "rap": "1,400",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.8": {
          "rap": "1,400",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.9": {
          "rap": "1,600",
          "low_price": "810",
          "high_price": "1,755"
        },
        "1.0": {
          "rap": "1,900",
          "low_price": "1,020",
          "high_price": "2,210"
        },
        "1.1": {
          "rap": "1,900",
          "low_price": "1,120",
          "high_price": "2,430"
        },
        "1.2": {
          "rap": "1,900",
          "low_price": "1,225",
          "high_price": "2,650"
        },
        "1.3": {
          "rap": "1,900",
          "low_price": "1,325",
          "high_price": "2,875"
        },
        "1.4": {
          "rap": "1,900",
          "low_price": "1,430",
          "high_price": "3,095"
        },
        "1.5": {
          "rap": "3,200",
          "low_price": "2,610",
          "high_price": "5,655"
        },
        "1.6": {
          "rap": "3,200",
          "low_price": "2,785",
          "high_price": "6,030"
        },
        "1.7": {
          "rap": "3,200",
          "low_price": "2,960",
          "high_price": "6,410"
        },
        "1.8": {
          "rap": "3,200",
          "low_price": "3,130",
          "high_price": "6,785"
        },
        "1.9": {
          "rap": "3,200",
          "low_price": "3,305",
          "high_price": "7,165"
        },
        "2.0": {
          "rap": "3,900",
          "low_price": "4,440",
          "high_price": "9,620"
        },
        "2.1": {
          "rap": "3,900",
          "low_price": "4,660",
          "high_price": "10,100"
        },
        "2.2": {
          "rap": "3,900",
          "low_price": "4,885",
          "high_price": "10,580"
        },
        "2.3": {
          "rap": "3,900",
          "low_price": "5,105",
          "high_price": "11,065"
        },
        "2.4": {
          "rap": "3,900",
          "low_price": "5,330",
          "high_price": "11,545"
        },
        "2.5": {
          "rap": "3,900",
          "low_price": "5,550",
          "high_price": "12,025"
        },
        "2.6": {
          "rap": "3,900",
          "low_price": "5,770",
          "high_price": "12,505"
        },
        "2.7": {
          "rap": "3,900",
          "low_price": "5,995",
          "high_price": "12,985"
        },
        "2.8": {
          "rap": "3,900",
          "low_price": "6,215",
          "high_price": "13,470"
        },
        "2.9": {
          "rap": "3,900",
          "low_price": "6,440",
          "high_price": "13,950"
        },
        "3.0": {
          "rap": "5,000",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "3.1": {
          "rap": "5,000",
          "low_price": "9,300",
          "high_price": "20,150"
        },
        "3.2": {
          "rap": "5,000",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "3.3": {
          "rap": "5,000",
          "low_price": "9,900",
          "high_price": "21,450"
        },
        "3.4": {
          "rap": "5,000",
          "low_price": "10,200",
          "high_price": "22,100"
        },
        "3.5": {
          "rap": "5,000",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "3.6": {
          "rap": "5,000",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "3.7": {
          "rap": "5,000",
          "low_price": "11,100",
          "high_price": "24,050"
        },
        "3.8": {
          "rap": "5,000",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "3.9": {
          "rap": "5,000",
          "low_price": "11,700",
          "high_price": "25,350"
        }
      }
    },
    "IF": {
      "D": {
        "0.4": {
          "rap": "3,300",
          "low_price": "695",
          "high_price": "1,510"
        },
        "0.5": {
          "rap": "4,100",
          "low_price": "990",
          "high_price": "2,145"
        },
        "0.6": {
          "rap": "4,100",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "0.7": {
          "rap": "6,200",
          "low_price": "1,975",
          "high_price": "4,275"
        },
        "0.8": {
          "rap": "6,200",
          "low_price": "2,255",
          "high_price": "4,890"
        },
        "0.9": {
          "rap": "9,200",
          "low_price": "3,620",
          "high_price": "7,840"
        },
        "1.0": {
          "rap": "12,500",
          "low_price": "5,580",
          "high_price": "12,090"
        },
        "1.1": {
          "rap": "12,500",
          "low_price": "6,140",
          "high_price": "13,300"
        },
        "1.2": {
          "rap": "12,500",
          "low_price": "6,695",
          "high_price": "14,510"
        },
        "1.3": {
          "rap": "12,500",
          "low_price": "7,255",
          "high_price": "15,715"
        },
        "1.4": {
          "rap": "12,500",
          "low_price": "7,810",
          "high_price": "16,925"
        },
        "1.5": {
          "rap": "18,200",
          "low_price": "12,690",
          "high_price": "27,495"
        },
        "1.6": {
          "rap": "18,200",
          "low_price": "13,535",
          "high_price": "29,330"
        },
        "1.7": {
          "rap": "18,200",
          "low_price": "14,380",
          "high_price": "31,160"
        },
        "1.8": {
          "rap": "18,200",
          "low_price": "15,230",
          "high_price": "32,995"
        },
        "1.9": {
          "rap": "18,200",
          "low_price": "16,075",
          "high_price": "34,825"
        },
        "2.0": {
          "rap": "25,500",
          "low_price": "25,800",
          "high_price": "55,900"
        },
        "2.1": {
          "rap": "25,500",
          "low_price": "27,090",
          "high_price": "58,695"
        },
        "2.2": {
          "rap": "25,500",
          "low_price": "28,380",
          "high_price": "61,490"
        },
        "2.3": {
          "rap": "25,500",
          "low_price": "29,670",
          "high_price": "64,285"
        },
        "2.4": {
          "rap": "25,500",
          "low_price": "30,960",
          "high_price": "67,080"
        },
        "2.5": {
          "rap": "25,500",
          "low_price": "32,250",
          "high_price": "69,875"
        },
        "2.6": {
          "rap": "25,500",
          "low_price": "33,540",
          "high_price": "72,670"
        },
        "2.7": {
          "rap": "25,500",
          "low_price": "34,830",
          "high_price": "75,465"
        },
        "2.8": {
          "rap": "25,500",
          "low_price": "36,120",
          "high_price": "78,260"
        },
        "2.9": {
          "rap": "25,500",
          "low_price": "37,410",
          "high_price": "81,055"
        },
        "3.0": {
          "rap": "46,000",
          "low_price": "75,600",
          "high_price": "163,800"
        },
        "3.1": {
          "rap": "46,000",
          "low_price": "78,120",
          "high_price": "169,260"
        },
        "3.2": {
          "rap": "46,000",
          "low_price": "80,640",
          "high_price": "174,720"
        },
        "3.3": {
          "rap": "46,000",
          "low_price": "83,160",
          "high_price": "180,180"
        },
        "3.4": {
          "rap": "46,000",
          "low_price": "85,680",
          "high_price": "185,640"
        },
        "3.5": {
          "rap": "46,000",
          "low_price": "88,200",
          "high_price": "191,100"
        },
        "3.6": {
          "rap": "46,000",
          "low_price": "90,720",
          "high_price": "196,560"
        },
        "3.7": {
          "rap": "46,000",
          "low_price": "93,240",
          "high_price": "202,020"
        },
        "3.8": {
          "rap": "46,000",
          "low_price": "95,760",
          "high_price": "207,480"
        },
        "3.9": {
          "rap": "46,000",
          "low_price": "98,280",
          "high_price": "212,940"
        }
      },
      "E": {
        "0.4": {
          "rap": "3,100",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.5": {
          "rap": "3,600",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.6": {
          "rap": "3,600",
          "low_price": "1,080",
          "high_price": "2,340"
        },
        "0.7": {
          "rap": "5,600",
          "low_price": "1,805",
          "high_price": "3,915"
        },
        "0.8": {
          "rap": "5,600",
          "low_price": "2,065",
          "high_price": "4,470"
        },
        "0.9": {
          "rap": "7,700",
          "low_price": "3,350",
          "high_price": "7,255"
        },
        "1.0": {
          "rap": "10,400",
          "low_price": "4,920",
          "high_price": "10,660"
        },
        "1.1": {
          "rap": "10,400",
          "low_price": "5,410",
          "high_price": "11,725"
        },
        "1.2": {
          "rap": "10,400",
          "low_price": "5,905",
          "high_price": "12,790"
        },
        "1.3": {
          "rap": "10,400",
          "low_price": "6,395",
          "high_price": "13,860"
        },
        "1.4": {
          "rap": "10,400",
          "low_price": "6,890",
          "high_price": "14,925"
        },
        "1.5": {
          "rap": "16,400",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "1.6": {
          "rap": "16,400",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "1.7": {
          "rap": "16,400",
          "low_price": "13,465",
          "high_price": "29,170"
        },
        "1.8": {
          "rap": "16,400",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "1.9": {
          "rap": "16,400",
          "low_price": "15,050",
          "high_price": "32,605"
        },
        "2.0": {
          "rap": "23,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.1": {
          "rap": "23,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.2": {
          "rap": "23,000",
          "low_price": "26,400",
          "high_price": "57,200"
        },
        "2.3": {
          "rap": "23,000",
          "low_price": "27,600",
          "high_price": "59,800"
        },
        "2.4": {
          "rap": "23,000",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "2.5": {
          "rap": "23,000",
          "low_price": "30,000",
          "high_price": "65,000"
        },
        "2.6": {
          "rap": "23,000",
          "low_price": "31,200",
          "high_price": "67,600"
        },
        "2.7": {
          "rap": "23,000",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "2.8": {
          "rap": "23,000",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "2.9": {
          "rap": "23,000",
          "low_price": "34,800",
          "high_price": "75,400"
        },
        "3.0": {
          "rap": "37,500",
          "low_price": "65,700",
          "high_price": "142,350"
        },
        "3.1": {
          "rap": "37,500",
          "low_price": "67,890",
          "high_price": "147,095"
        },
        "3.2": {
          "rap": "37,500",
          "low_price": "70,080",
          "high_price": "151,840"
        },
        "3.3": {
          "rap": "37,500",
          "low_price": "72,270",
          "high_price": "156,585"
        },
        "3.4": {
          "rap": "37,500",
          "low_price": "74,460",
          "high_price": "161,330"
        },
        "3.5": {
          "rap": "37,500",
          "low_price": "76,650",
          "high_price": "166,075"
        },
        "3.6": {
          "rap": "37,500",
          "low_price": "78,840",
          "high_price": "170,820"
        },
        "3.7": {
          "rap": "37,500",
          "low_price": "81,030",
          "high_price": "175,565"
        },
        "3.8": {
          "rap": "37,500",
          "low_price": "83,220",
          "high_price": "180,310"
        },
        "3.9": {
          "rap": "37,500",
          "low_price": "85,410",
          "high_price": "185,055"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,900",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.5": {
          "rap": "3,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.6": {
          "rap": "3,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.7": {
          "rap": "5,300",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.8": {
          "rap": "5,300",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "0.9": {
          "rap": "6,900",
          "low_price": "2,970",
          "high_price": "6,435"
        },
        "1.0": {
          "rap": "9,400",
          "low_price": "4,440",
          "high_price": "9,620"
        },
        "1.1": {
          "rap": "9,400",
          "low_price": "4,885",
          "high_price": "10,580"
        },
        "1.2": {
          "rap": "9,400",
          "low_price": "5,330",
          "high_price": "11,545"
        },
        "1.3": {
          "rap": "9,400",
          "low_price": "5,770",
          "high_price": "12,505"
        },
        "1.4": {
          "rap": "9,400",
          "low_price": "6,215",
          "high_price": "13,470"
        },
        "1.5": {
          "rap": "14,300",
          "low_price": "11,070",
          "high_price": "23,985"
        },
        "1.6": {
          "rap": "14,300",
          "low_price": "11,810",
          "high_price": "25,585"
        },
        "1.7": {
          "rap": "14,300",
          "low_price": "12,545",
          "high_price": "27,185"
        },
        "1.8": {
          "rap": "14,300",
          "low_price": "13,285",
          "high_price": "28,780"
        },
        "1.9": {
          "rap": "14,300",
          "low_price": "14,020",
          "high_price": "30,380"
        },
        "2.0": {
          "rap": "20,500",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "2.1": {
          "rap": "20,500",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "2.2": {
          "rap": "20,500",
          "low_price": "24,420",
          "high_price": "52,910"
        },
        "2.3": {
          "rap": "20,500",
          "low_price": "25,530",
          "high_price": "55,315"
        },
        "2.4": {
          "rap": "20,500",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "2.5": {
          "rap": "20,500",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "2.6": {
          "rap": "20,500",
          "low_price": "28,860",
          "high_price": "62,530"
        },
        "2.7": {
          "rap": "20,500",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "2.8": {
          "rap": "20,500",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "2.9": {
          "rap": "20,500",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.0": {
          "rap": "33,500",
          "low_price": "58,500",
          "high_price": "126,750"
        },
        "3.1": {
          "rap": "33,500",
          "low_price": "60,450",
          "high_price": "130,975"
        },
        "3.2": {
          "rap": "33,500",
          "low_price": "62,400",
          "high_price": "135,200"
        },
        "3.3": {
          "rap": "33,500",
          "low_price": "64,350",
          "high_price": "139,425"
        },
        "3.4": {
          "rap": "33,500",
          "low_price": "66,300",
          "high_price": "143,650"
        },
        "3.5": {
          "rap": "33,500",
          "low_price": "68,250",
          "high_price": "147,875"
        },
        "3.6": {
          "rap": "33,500",
          "low_price": "70,200",
          "high_price": "152,100"
        },
        "3.7": {
          "rap": "33,500",
          "low_price": "72,150",
          "high_price": "156,325"
        },
        "3.8": {
          "rap": "33,500",
          "low_price": "74,100",
          "high_price": "160,550"
        },
        "3.9": {
          "rap": "33,500",
          "low_price": "76,050",
          "high_price": "164,775"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,700",
          "low_price": "550",
          "high_price": "1,195"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,555",
          "high_price": "3,365"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,775",
          "high_price": "3,850"
        },
        "0.9": {
          "rap": "6,200",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "8,100",
          "low_price": "3,960",
          "high_price": "8,580"
        },
        "1.1": {
          "rap": "8,100",
          "low_price": "4,355",
          "high_price": "9,440"
        },
        "1.2": {
          "rap": "8,100",
          "low_price": "4,750",
          "high_price": "10,295"
        },
        "1.3": {
          "rap": "8,100",
          "low_price": "5,150",
          "high_price": "11,155"
        },
        "1.4": {
          "rap": "8,100",
          "low_price": "5,545",
          "high_price": "12,010"
        },
        "1.5": {
          "rap": "12,700",
          "low_price": "9,810",
          "high_price": "21,255"
        },
        "1.6": {
          "rap": "12,700",
          "low_price": "10,465",
          "high_price": "22,670"
        },
        "1.7": {
          "rap": "12,700",
          "low_price": "11,120",
          "high_price": "24,090"
        },
        "1.8": {
          "rap": "12,700",
          "low_price": "11,770",
          "high_price": "25,505"
        },
        "1.9": {
          "rap": "12,700",
          "low_price": "12,425",
          "high_price": "26,925"
        },
        "2.0": {
          "rap": "18,500",
          "low_price": "20,400",
          "high_price": "44,200"
        },
        "2.1": {
          "rap": "18,500",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "2.2": {
          "rap": "18,500",
          "low_price": "22,440",
          "high_price": "48,620"
        },
        "2.3": {
          "rap": "18,500",
          "low_price": "23,460",
          "high_price": "50,830"
        },
        "2.4": {
          "rap": "18,500",
          "low_price": "24,480",
          "high_price": "53,040"
        },
        "2.5": {
          "rap": "18,500",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "2.6": {
          "rap": "18,500",
          "low_price": "26,520",
          "high_price": "57,460"
        },
        "2.7": {
          "rap": "18,500",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "2.8": {
          "rap": "18,500",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "2.9": {
          "rap": "18,500",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.0": {
          "rap": "30,000",
          "low_price": "52,200",
          "high_price": "113,100"
        },
        "3.1": {
          "rap": "30,000",
          "low_price": "53,940",
          "high_price": "116,870"
        },
        "3.2": {
          "rap": "30,000",
          "low_price": "55,680",
          "high_price": "120,640"
        },
        "3.3": {
          "rap": "30,000",
          "low_price": "57,420",
          "high_price": "124,410"
        },
        "3.4": {
          "rap": "30,000",
          "low_price": "59,160",
          "high_price": "128,180"
        },
        "3.5": {
          "rap": "30,000",
          "low_price": "60,900",
          "high_price": "131,950"
        },
        "3.6": {
          "rap": "30,000",
          "low_price": "62,640",
          "high_price": "135,720"
        },
        "3.7": {
          "rap": "30,000",
          "low_price": "64,380",
          "high_price": "139,490"
        },
        "3.8": {
          "rap": "30,000",
          "low_price": "66,120",
          "high_price": "143,260"
        },
        "3.9": {
          "rap": "30,000",
          "low_price": "67,860",
          "high_price": "147,030"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,400",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.5": {
          "rap": "2,900",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "2,900",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "4,600",
          "low_price": "1,430",
          "high_price": "3,095"
        },
        "0.8": {
          "rap": "4,600",
          "low_price": "1,630",
          "high_price": "3,535"
        },
        "0.9": {
          "rap": "5,600",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.0": {
          "rap": "6,900",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "1.1": {
          "rap": "6,900",
          "low_price": "3,695",
          "high_price": "8,010"
        },
        "1.2": {
          "rap": "6,900",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.3": {
          "rap": "6,900",
          "low_price": "4,370",
          "high_price": "9,465"
        },
        "1.4": {
          "rap": "6,900",
          "low_price": "4,705",
          "high_price": "10,190"
        },
        "1.5": {
          "rap": "10,700",
          "low_price": "8,280",
          "high_price": "17,940"
        },
        "1.6": {
          "rap": "10,700",
          "low_price": "8,830",
          "high_price": "19,135"
        },
        "1.7": {
          "rap": "10,700",
          "low_price": "9,385",
          "high_price": "20,330"
        },
        "1.8": {
          "rap": "10,700",
          "low_price": "9,935",
          "high_price": "21,530"
        },
        "1.9": {
          "rap": "10,700",
          "low_price": "10,490",
          "high_price": "22,725"
        },
        "2.0": {
          "rap": "15,000",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.1": {
          "rap": "15,000",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "2.2": {
          "rap": "15,000",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.3": {
          "rap": "15,000",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.4": {
          "rap": "15,000",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.5": {
          "rap": "15,000",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.6": {
          "rap": "15,000",
          "low_price": "21,060",
          "high_price": "45,630"
        },
        "2.7": {
          "rap": "15,000",
          "low_price": "21,870",
          "high_price": "47,385"
        },
        "2.8": {
          "rap": "15,000",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.9": {
          "rap": "15,000",
          "low_price": "23,490",
          "high_price": "50,895"
        },
        "3.0": {
          "rap": "24,500",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.1": {
          "rap": "24,500",
          "low_price": "44,640",
          "high_price": "96,720"
        },
        "3.2": {
          "rap": "24,500",
          "low_price": "46,080",
          "high_price": "99,840"
        },
        "3.3": {
          "rap": "24,500",
          "low_price": "47,520",
          "high_price": "102,960"
        },
        "3.4": {
          "rap": "24,500",
          "low_price": "48,960",
          "high_price": "106,080"
        },
        "3.5": {
          "rap": "24,500",
          "low_price": "50,400",
          "high_price": "109,200"
        },
        "3.6": {
          "rap": "24,500",
          "low_price": "51,840",
          "high_price": "112,320"
        },
        "3.7": {
          "rap": "24,500",
          "low_price": "53,280",
          "high_price": "115,440"
        },
        "3.8": {
          "rap": "24,500",
          "low_price": "54,720",
          "high_price": "118,560"
        },
        "3.9": {
          "rap": "24,500",
          "low_price": "56,160",
          "high_price": "121,680"
        }
      },
      "I": {
        "0.4": {
          "rap": "2,100",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,600",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,600",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "3,800",
          "low_price": "1,300",
          "high_price": "2,820"
        },
        "0.8": {
          "rap": "3,800",
          "low_price": "1,490",
          "high_price": "3,225"
        },
        "0.9": {
          "rap": "4,800",
          "low_price": "2,215",
          "high_price": "4,795"
        },
        "1.0": {
          "rap": "5,900",
          "low_price": "2,820",
          "high_price": "6,110"
        },
        "1.1": {
          "rap": "5,900",
          "low_price": "3,100",
          "high_price": "6,720"
        },
        "1.2": {
          "rap": "5,900",
          "low_price": "3,385",
          "high_price": "7,330"
        },
        "1.3": {
          "rap": "5,900",
          "low_price": "3,665",
          "high_price": "7,945"
        },
        "1.4": {
          "rap": "5,900",
          "low_price": "3,950",
          "high_price": "8,555"
        },
        "1.5": {
          "rap": "8,900",
          "low_price": "7,110",
          "high_price": "15,405"
        },
        "1.6": {
          "rap": "8,900",
          "low_price": "7,585",
          "high_price": "16,430"
        },
        "1.7": {
          "rap": "8,900",
          "low_price": "8,060",
          "high_price": "17,460"
        },
        "1.8": {
          "rap": "8,900",
          "low_price": "8,530",
          "high_price": "18,485"
        },
        "1.9": {
          "rap": "8,900",
          "low_price": "9,005",
          "high_price": "19,515"
        },
        "2.0": {
          "rap": "11,800",
          "low_price": "12,960",
          "high_price": "28,080"
        },
        "2.1": {
          "rap": "11,800",
          "low_price": "13,610",
          "high_price": "29,485"
        },
        "2.2": {
          "rap": "11,800",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.3": {
          "rap": "11,800",
          "low_price": "14,905",
          "high_price": "32,290"
        },
        "2.4": {
          "rap": "11,800",
          "low_price": "15,550",
          "high_price": "33,695"
        },
        "2.5": {
          "rap": "11,800",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.6": {
          "rap": "11,800",
          "low_price": "16,850",
          "high_price": "36,505"
        },
        "2.7": {
          "rap": "11,800",
          "low_price": "17,495",
          "high_price": "37,910"
        },
        "2.8": {
          "rap": "11,800",
          "low_price": "18,145",
          "high_price": "39,310"
        },
        "2.9": {
          "rap": "11,800",
          "low_price": "18,790",
          "high_price": "40,715"
        },
        "3.0": {
          "rap": "20,000",
          "low_price": "35,100",
          "high_price": "76,050"
        },
        "3.1": {
          "rap": "20,000",
          "low_price": "36,270",
          "high_price": "78,585"
        },
        "3.2": {
          "rap": "20,000",
          "low_price": "37,440",
          "high_price": "81,120"
        },
        "3.3": {
          "rap": "20,000",
          "low_price": "38,610",
          "high_price": "83,655"
        },
        "3.4": {
          "rap": "20,000",
          "low_price": "39,780",
          "high_price": "86,190"
        },
        "3.5": {
          "rap": "20,000",
          "low_price": "40,950",
          "high_price": "88,725"
        },
        "3.6": {
          "rap": "20,000",
          "low_price": "42,120",
          "high_price": "91,260"
        },
        "3.7": {
          "rap": "20,000",
          "low_price": "43,290",
          "high_price": "93,795"
        },
        "3.8": {
          "rap": "20,000",
          "low_price": "44,460",
          "high_price": "96,330"
        },
        "3.9": {
          "rap": "20,000",
          "low_price": "45,630",
          "high_price": "98,865"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,800",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,200",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,200",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "1,090",
          "high_price": "2,365"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "1,250",
          "high_price": "2,705"
        },
        "0.9": {
          "rap": "3,900",
          "low_price": "1,945",
          "high_price": "4,210"
        },
        "1.0": {
          "rap": "4,800",
          "low_price": "2,400",
          "high_price": "5,200"
        },
        "1.1": {
          "rap": "4,800",
          "low_price": "2,640",
          "high_price": "5,720"
        },
        "1.2": {
          "rap": "4,800",
          "low_price": "2,880",
          "high_price": "6,240"
        },
        "1.3": {
          "rap": "4,800",
          "low_price": "3,120",
          "high_price": "6,760"
        },
        "1.4": {
          "rap": "4,800",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "1.5": {
          "rap": "7,200",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "1.6": {
          "rap": "7,200",
          "low_price": "6,145",
          "high_price": "13,310"
        },
        "1.7": {
          "rap": "7,200",
          "low_price": "6,530",
          "high_price": "14,145"
        },
        "1.8": {
          "rap": "7,200",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "1.9": {
          "rap": "7,200",
          "low_price": "7,295",
          "high_price": "15,810"
        },
        "2.0": {
          "rap": "9,400",
          "low_price": "10,560",
          "high_price": "22,880"
        },
        "2.1": {
          "rap": "9,400",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.2": {
          "rap": "9,400",
          "low_price": "11,615",
          "high_price": "25,170"
        },
        "2.3": {
          "rap": "9,400",
          "low_price": "12,145",
          "high_price": "26,310"
        },
        "2.4": {
          "rap": "9,400",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "2.5": {
          "rap": "9,400",
          "low_price": "13,200",
          "high_price": "28,600"
        },
        "2.6": {
          "rap": "9,400",
          "low_price": "13,730",
          "high_price": "29,745"
        },
        "2.7": {
          "rap": "9,400",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.8": {
          "rap": "9,400",
          "low_price": "14,785",
          "high_price": "32,030"
        },
        "2.9": {
          "rap": "9,400",
          "low_price": "15,310",
          "high_price": "33,175"
        },
        "3.0": {
          "rap": "15,900",
          "low_price": "27,720",
          "high_price": "60,060"
        },
        "3.1": {
          "rap": "15,900",
          "low_price": "28,645",
          "high_price": "62,060"
        },
        "3.2": {
          "rap": "15,900",
          "low_price": "29,570",
          "high_price": "64,065"
        },
        "3.3": {
          "rap": "15,900",
          "low_price": "30,490",
          "high_price": "66,065"
        },
        "3.4": {
          "rap": "15,900",
          "low_price": "31,415",
          "high_price": "68,070"
        },
        "3.5": {
          "rap": "15,900",
          "low_price": "32,340",
          "high_price": "70,070"
        },
        "3.6": {
          "rap": "15,900",
          "low_price": "33,265",
          "high_price": "72,070"
        },
        "3.7": {
          "rap": "15,900",
          "low_price": "34,190",
          "high_price": "74,075"
        },
        "3.8": {
          "rap": "15,900",
          "low_price": "35,110",
          "high_price": "76,075"
        },
        "3.9": {
          "rap": "15,900",
          "low_price": "36,035",
          "high_price": "78,080"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,500",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "2,500",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "2,500",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "3,200",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "3,900",
          "low_price": "2,040",
          "high_price": "4,420"
        },
        "1.1": {
          "rap": "3,900",
          "low_price": "2,245",
          "high_price": "4,860"
        },
        "1.2": {
          "rap": "3,900",
          "low_price": "2,450",
          "high_price": "5,305"
        },
        "1.3": {
          "rap": "3,900",
          "low_price": "2,650",
          "high_price": "5,745"
        },
        "1.4": {
          "rap": "3,900",
          "low_price": "2,855",
          "high_price": "6,190"
        },
        "1.5": {
          "rap": "5,700",
          "low_price": "4,410",
          "high_price": "9,555"
        },
        "1.6": {
          "rap": "5,700",
          "low_price": "4,705",
          "high_price": "10,190"
        },
        "1.7": {
          "rap": "5,700",
          "low_price": "5,000",
          "high_price": "10,830"
        },
        "1.8": {
          "rap": "5,700",
          "low_price": "5,290",
          "high_price": "11,465"
        },
        "1.9": {
          "rap": "5,700",
          "low_price": "5,585",
          "high_price": "12,105"
        },
        "2.0": {
          "rap": "7,600",
          "low_price": "8,400",
          "high_price": "18,200"
        },
        "2.1": {
          "rap": "7,600",
          "low_price": "8,820",
          "high_price": "19,110"
        },
        "2.2": {
          "rap": "7,600",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.3": {
          "rap": "7,600",
          "low_price": "9,660",
          "high_price": "20,930"
        },
        "2.4": {
          "rap": "7,600",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.5": {
          "rap": "7,600",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "2.6": {
          "rap": "7,600",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.7": {
          "rap": "7,600",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.8": {
          "rap": "7,600",
          "low_price": "11,760",
          "high_price": "25,480"
        },
        "2.9": {
          "rap": "7,600",
          "low_price": "12,180",
          "high_price": "26,390"
        },
        "3.0": {
          "rap": "12,300",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "3.1": {
          "rap": "12,300",
          "low_price": "22,135",
          "high_price": "47,955"
        },
        "3.2": {
          "rap": "12,300",
          "low_price": "22,850",
          "high_price": "49,505"
        },
        "3.3": {
          "rap": "12,300",
          "low_price": "23,560",
          "high_price": "51,050"
        },
        "3.4": {
          "rap": "12,300",
          "low_price": "24,275",
          "high_price": "52,600"
        },
        "3.5": {
          "rap": "12,300",
          "low_price": "24,990",
          "high_price": "54,145"
        },
        "3.6": {
          "rap": "12,300",
          "low_price": "25,705",
          "high_price": "55,690"
        },
        "3.7": {
          "rap": "12,300",
          "low_price": "26,420",
          "high_price": "57,240"
        },
        "3.8": {
          "rap": "12,300",
          "low_price": "27,130",
          "high_price": "58,785"
        },
        "3.9": {
          "rap": "12,300",
          "low_price": "27,845",
          "high_price": "60,335"
        }
      }
    },
    "SI1": {
      "D": {
        "0.4": {
          "rap": "2,000",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "2,500",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,500",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,000",
          "low_price": "1,175",
          "high_price": "2,550"
        },
        "0.8": {
          "rap": "4,000",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.9": {
          "rap": "5,000",
          "low_price": "2,000",
          "high_price": "4,330"
        },
        "1.0": {
          "rap": "6,300",
          "low_price": "2,760",
          "high_price": "5,980"
        },
        "1.1": {
          "rap": "6,300",
          "low_price": "3,035",
          "high_price": "6,580"
        },
        "1.2": {
          "rap": "6,300",
          "low_price": "3,310",
          "high_price": "7,175"
        },
        "1.3": {
          "rap": "6,300",
          "low_price": "3,590",
          "high_price": "7,775"
        },
        "1.4": {
          "rap": "6,300",
          "low_price": "3,865",
          "high_price": "8,370"
        },
        "1.5": {
          "rap": "11,000",
          "low_price": "7,290",
          "high_price": "15,795"
        },
        "1.6": {
          "rap": "11,000",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "1.7": {
          "rap": "11,000",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "1.8": {
          "rap": "11,000",
          "low_price": "8,750",
          "high_price": "18,955"
        },
        "1.9": {
          "rap": "11,000",
          "low_price": "9,235",
          "high_price": "20,005"
        },
        "2.0": {
          "rap": "15,100",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.1": {
          "rap": "15,100",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "2.2": {
          "rap": "15,100",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.3": {
          "rap": "15,100",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.4": {
          "rap": "15,100",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.5": {
          "rap": "15,100",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.6": {
          "rap": "15,100",
          "low_price": "21,060",
          "high_price": "45,630"
        },
        "2.7": {
          "rap": "15,100",
          "low_price": "21,870",
          "high_price": "47,385"
        },
        "2.8": {
          "rap": "15,100",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.9": {
          "rap": "15,100",
          "low_price": "23,490",
          "high_price": "50,895"
        },
        "3.0": {
          "rap": "23,000",
          "low_price": "41,400",
          "high_price": "89,700"
        },
        "3.1": {
          "rap": "23,000",
          "low_price": "42,780",
          "high_price": "92,690"
        },
        "3.2": {
          "rap": "23,000",
          "low_price": "44,160",
          "high_price": "95,680"
        },
        "3.3": {
          "rap": "23,000",
          "low_price": "45,540",
          "high_price": "98,670"
        },
        "3.4": {
          "rap": "23,000",
          "low_price": "46,920",
          "high_price": "101,660"
        },
        "3.5": {
          "rap": "23,000",
          "low_price": "48,300",
          "high_price": "104,650"
        },
        "3.6": {
          "rap": "23,000",
          "low_price": "49,680",
          "high_price": "107,640"
        },
        "3.7": {
          "rap": "23,000",
          "low_price": "51,060",
          "high_price": "110,630"
        },
        "3.8": {
          "rap": "23,000",
          "low_price": "52,440",
          "high_price": "113,620"
        },
        "3.9": {
          "rap": "23,000",
          "low_price": "53,820",
          "high_price": "116,610"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,900",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "2,300",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.6": {
          "rap": "2,300",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.7": {
          "rap": "3,800",
          "low_price": "1,090",
          "high_price": "2,365"
        },
        "0.8": {
          "rap": "3,800",
          "low_price": "1,250",
          "high_price": "2,705"
        },
        "0.9": {
          "rap": "4,800",
          "low_price": "1,890",
          "high_price": "4,095"
        },
        "1.0": {
          "rap": "6,000",
          "low_price": "2,580",
          "high_price": "5,590"
        },
        "1.1": {
          "rap": "6,000",
          "low_price": "2,840",
          "high_price": "6,150"
        },
        "1.2": {
          "rap": "6,000",
          "low_price": "3,095",
          "high_price": "6,710"
        },
        "1.3": {
          "rap": "6,000",
          "low_price": "3,355",
          "high_price": "7,265"
        },
        "1.4": {
          "rap": "6,000",
          "low_price": "3,610",
          "high_price": "7,825"
        },
        "1.5": {
          "rap": "10,500",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "1.6": {
          "rap": "10,500",
          "low_price": "7,295",
          "high_price": "15,810"
        },
        "1.7": {
          "rap": "10,500",
          "low_price": "7,750",
          "high_price": "16,795"
        },
        "1.8": {
          "rap": "10,500",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "1.9": {
          "rap": "10,500",
          "low_price": "8,665",
          "high_price": "18,770"
        },
        "2.0": {
          "rap": "14,100",
          "low_price": "15,000",
          "high_price": "32,500"
        },
        "2.1": {
          "rap": "14,100",
          "low_price": "15,750",
          "high_price": "34,125"
        },
        "2.2": {
          "rap": "14,100",
          "low_price": "16,500",
          "high_price": "35,750"
        },
        "2.3": {
          "rap": "14,100",
          "low_price": "17,250",
          "high_price": "37,375"
        },
        "2.4": {
          "rap": "14,100",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.5": {
          "rap": "14,100",
          "low_price": "18,750",
          "high_price": "40,625"
        },
        "2.6": {
          "rap": "14,100",
          "low_price": "19,500",
          "high_price": "42,250"
        },
        "2.7": {
          "rap": "14,100",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.8": {
          "rap": "14,100",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.9": {
          "rap": "14,100",
          "low_price": "21,750",
          "high_price": "47,125"
        },
        "3.0": {
          "rap": "21,500",
          "low_price": "38,700",
          "high_price": "83,850"
        },
        "3.1": {
          "rap": "21,500",
          "low_price": "39,990",
          "high_price": "86,645"
        },
        "3.2": {
          "rap": "21,500",
          "low_price": "41,280",
          "high_price": "89,440"
        },
        "3.3": {
          "rap": "21,500",
          "low_price": "42,570",
          "high_price": "92,235"
        },
        "3.4": {
          "rap": "21,500",
          "low_price": "43,860",
          "high_price": "95,030"
        },
        "3.5": {
          "rap": "21,500",
          "low_price": "45,150",
          "high_price": "97,825"
        },
        "3.6": {
          "rap": "21,500",
          "low_price": "46,440",
          "high_price": "100,620"
        },
        "3.7": {
          "rap": "21,500",
          "low_price": "47,730",
          "high_price": "103,415"
        },
        "3.8": {
          "rap": "21,500",
          "low_price": "49,020",
          "high_price": "106,210"
        },
        "3.9": {
          "rap": "21,500",
          "low_price": "50,310",
          "high_price": "109,005"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,800",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,200",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "2,200",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "3,600",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.8": {
          "rap": "3,600",
          "low_price": "1,150",
          "high_price": "2,495"
        },
        "0.9": {
          "rap": "4,600",
          "low_price": "1,780",
          "high_price": "3,860"
        },
        "1.0": {
          "rap": "5,700",
          "low_price": "2,400",
          "high_price": "5,200"
        },
        "1.1": {
          "rap": "5,700",
          "low_price": "2,640",
          "high_price": "5,720"
        },
        "1.2": {
          "rap": "5,700",
          "low_price": "2,880",
          "high_price": "6,240"
        },
        "1.3": {
          "rap": "5,700",
          "low_price": "3,120",
          "high_price": "6,760"
        },
        "1.4": {
          "rap": "5,700",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "1.5": {
          "rap": "9,900",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "1.6": {
          "rap": "9,900",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "1.7": {
          "rap": "9,900",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "1.8": {
          "rap": "9,900",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "1.9": {
          "rap": "9,900",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "2.0": {
          "rap": "13,200",
          "low_price": "14,040",
          "high_price": "30,420"
        },
        "2.1": {
          "rap": "13,200",
          "low_price": "14,740",
          "high_price": "31,940"
        },
        "2.2": {
          "rap": "13,200",
          "low_price": "15,445",
          "high_price": "33,460"
        },
        "2.3": {
          "rap": "13,200",
          "low_price": "16,145",
          "high_price": "34,985"
        },
        "2.4": {
          "rap": "13,200",
          "low_price": "16,850",
          "high_price": "36,505"
        },
        "2.5": {
          "rap": "13,200",
          "low_price": "17,550",
          "high_price": "38,025"
        },
        "2.6": {
          "rap": "13,200",
          "low_price": "18,250",
          "high_price": "39,545"
        },
        "2.7": {
          "rap": "13,200",
          "low_price": "18,955",
          "high_price": "41,065"
        },
        "2.8": {
          "rap": "13,200",
          "low_price": "19,655",
          "high_price": "42,590"
        },
        "2.9": {
          "rap": "13,200",
          "low_price": "20,360",
          "high_price": "44,110"
        },
        "3.0": {
          "rap": "19,500",
          "low_price": "36,000",
          "high_price": "78,000"
        },
        "3.1": {
          "rap": "19,500",
          "low_price": "37,200",
          "high_price": "80,600"
        },
        "3.2": {
          "rap": "19,500",
          "low_price": "38,400",
          "high_price": "83,200"
        },
        "3.3": {
          "rap": "19,500",
          "low_price": "39,600",
          "high_price": "85,800"
        },
        "3.4": {
          "rap": "19,500",
          "low_price": "40,800",
          "high_price": "88,400"
        },
        "3.5": {
          "rap": "19,500",
          "low_price": "42,000",
          "high_price": "91,000"
        },
        "3.6": {
          "rap": "19,500",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.7": {
          "rap": "19,500",
          "low_price": "44,400",
          "high_price": "96,200"
        },
        "3.8": {
          "rap": "19,500",
          "low_price": "45,600",
          "high_price": "98,800"
        },
        "3.9": {
          "rap": "19,500",
          "low_price": "46,800",
          "high_price": "101,400"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,700",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,300",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,300",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "4,400",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.0": {
          "rap": "5,400",
          "low_price": "2,280",
          "high_price": "4,940"
        },
        "1.1": {
          "rap": "5,400",
          "low_price": "2,510",
          "high_price": "5,435"
        },
        "1.2": {
          "rap": "5,400",
          "low_price": "2,735",
          "high_price": "5,930"
        },
        "1.3": {
          "rap": "5,400",
          "low_price": "2,965",
          "high_price": "6,420"
        },
        "1.4": {
          "rap": "5,400",
          "low_price": "3,190",
          "high_price": "6,915"
        },
        "1.5": {
          "rap": "9,200",
          "low_price": "6,030",
          "high_price": "13,065"
        },
        "1.6": {
          "rap": "9,200",
          "low_price": "6,430",
          "high_price": "13,935"
        },
        "1.7": {
          "rap": "9,200",
          "low_price": "6,835",
          "high_price": "14,805"
        },
        "1.8": {
          "rap": "9,200",
          "low_price": "7,235",
          "high_price": "15,680"
        },
        "1.9": {
          "rap": "9,200",
          "low_price": "7,640",
          "high_price": "16,550"
        },
        "2.0": {
          "rap": "12,200",
          "low_price": "12,840",
          "high_price": "27,820"
        },
        "2.1": {
          "rap": "12,200",
          "low_price": "13,480",
          "high_price": "29,210"
        },
        "2.2": {
          "rap": "12,200",
          "low_price": "14,125",
          "high_price": "30,600"
        },
        "2.3": {
          "rap": "12,200",
          "low_price": "14,765",
          "high_price": "31,995"
        },
        "2.4": {
          "rap": "12,200",
          "low_price": "15,410",
          "high_price": "33,385"
        },
        "2.5": {
          "rap": "12,200",
          "low_price": "16,050",
          "high_price": "34,775"
        },
        "2.6": {
          "rap": "12,200",
          "low_price": "16,690",
          "high_price": "36,165"
        },
        "2.7": {
          "rap": "12,200",
          "low_price": "17,335",
          "high_price": "37,555"
        },
        "2.8": {
          "rap": "12,200",
          "low_price": "17,975",
          "high_price": "38,950"
        },
        "2.9": {
          "rap": "12,200",
          "low_price": "18,620",
          "high_price": "40,340"
        },
        "3.0": {
          "rap": "18,000",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.1": {
          "rap": "18,000",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.2": {
          "rap": "18,000",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.3": {
          "rap": "18,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.4": {
          "rap": "18,000",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.5": {
          "rap": "18,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.6": {
          "rap": "18,000",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.7": {
          "rap": "18,000",
          "low_price": "41,070",
          "high_price": "88,985"
        },
        "3.8": {
          "rap": "18,000",
          "low_price": "42,180",
          "high_price": "91,390"
        },
        "3.9": {
          "rap": "18,000",
          "low_price": "43,290",
          "high_price": "93,795"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,600",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,000",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "2,000",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "4,000",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "5,000",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.1": {
          "rap": "5,000",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.2": {
          "rap": "5,000",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.3": {
          "rap": "5,000",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.4": {
          "rap": "5,000",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.5": {
          "rap": "8,500",
          "low_price": "5,580",
          "high_price": "12,090"
        },
        "1.6": {
          "rap": "8,500",
          "low_price": "5,950",
          "high_price": "12,895"
        },
        "1.7": {
          "rap": "8,500",
          "low_price": "6,325",
          "high_price": "13,700"
        },
        "1.8": {
          "rap": "8,500",
          "low_price": "6,695",
          "high_price": "14,510"
        },
        "1.9": {
          "rap": "8,500",
          "low_price": "7,070",
          "high_price": "15,315"
        },
        "2.0": {
          "rap": "11,100",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "2.1": {
          "rap": "11,100",
          "low_price": "12,475",
          "high_price": "27,025"
        },
        "2.2": {
          "rap": "11,100",
          "low_price": "13,070",
          "high_price": "28,315"
        },
        "2.3": {
          "rap": "11,100",
          "low_price": "13,660",
          "high_price": "29,600"
        },
        "2.4": {
          "rap": "11,100",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.5": {
          "rap": "11,100",
          "low_price": "14,850",
          "high_price": "32,175"
        },
        "2.6": {
          "rap": "11,100",
          "low_price": "15,445",
          "high_price": "33,460"
        },
        "2.7": {
          "rap": "11,100",
          "low_price": "16,040",
          "high_price": "34,750"
        },
        "2.8": {
          "rap": "11,100",
          "low_price": "16,630",
          "high_price": "36,035"
        },
        "2.9": {
          "rap": "11,100",
          "low_price": "17,225",
          "high_price": "37,325"
        },
        "3.0": {
          "rap": "16,000",
          "low_price": "29,700",
          "high_price": "64,350"
        },
        "3.1": {
          "rap": "16,000",
          "low_price": "30,690",
          "high_price": "66,495"
        },
        "3.2": {
          "rap": "16,000",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "3.3": {
          "rap": "16,000",
          "low_price": "32,670",
          "high_price": "70,785"
        },
        "3.4": {
          "rap": "16,000",
          "low_price": "33,660",
          "high_price": "72,930"
        },
        "3.5": {
          "rap": "16,000",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "3.6": {
          "rap": "16,000",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "3.7": {
          "rap": "16,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.8": {
          "rap": "16,000",
          "low_price": "37,620",
          "high_price": "81,510"
        },
        "3.9": {
          "rap": "16,000",
          "low_price": "38,610",
          "high_price": "83,655"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,700",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "2,700",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,460",
          "high_price": "3,160"
        },
        "1.0": {
          "rap": "4,400",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "1.1": {
          "rap": "4,400",
          "low_price": "2,110",
          "high_price": "4,575"
        },
        "1.2": {
          "rap": "4,400",
          "low_price": "2,305",
          "high_price": "4,990"
        },
        "1.3": {
          "rap": "4,400",
          "low_price": "2,495",
          "high_price": "5,410"
        },
        "1.4": {
          "rap": "4,400",
          "low_price": "2,690",
          "high_price": "5,825"
        },
        "1.5": {
          "rap": "7,300",
          "low_price": "5,040",
          "high_price": "10,920"
        },
        "1.6": {
          "rap": "7,300",
          "low_price": "5,375",
          "high_price": "11,650"
        },
        "1.7": {
          "rap": "7,300",
          "low_price": "5,710",
          "high_price": "12,375"
        },
        "1.8": {
          "rap": "7,300",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.9": {
          "rap": "7,300",
          "low_price": "6,385",
          "high_price": "13,830"
        },
        "2.0": {
          "rap": "9,300",
          "low_price": "10,200",
          "high_price": "22,100"
        },
        "2.1": {
          "rap": "9,300",
          "low_price": "10,710",
          "high_price": "23,205"
        },
        "2.2": {
          "rap": "9,300",
          "low_price": "11,220",
          "high_price": "24,310"
        },
        "2.3": {
          "rap": "9,300",
          "low_price": "11,730",
          "high_price": "25,415"
        },
        "2.4": {
          "rap": "9,300",
          "low_price": "12,240",
          "high_price": "26,520"
        },
        "2.5": {
          "rap": "9,300",
          "low_price": "12,750",
          "high_price": "27,625"
        },
        "2.6": {
          "rap": "9,300",
          "low_price": "13,260",
          "high_price": "28,730"
        },
        "2.7": {
          "rap": "9,300",
          "low_price": "13,770",
          "high_price": "29,835"
        },
        "2.8": {
          "rap": "9,300",
          "low_price": "14,280",
          "high_price": "30,940"
        },
        "2.9": {
          "rap": "9,300",
          "low_price": "14,790",
          "high_price": "32,045"
        },
        "3.0": {
          "rap": "14,000",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.1": {
          "rap": "14,000",
          "low_price": "26,970",
          "high_price": "58,435"
        },
        "3.2": {
          "rap": "14,000",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.3": {
          "rap": "14,000",
          "low_price": "28,710",
          "high_price": "62,205"
        },
        "3.4": {
          "rap": "14,000",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.5": {
          "rap": "14,000",
          "low_price": "30,450",
          "high_price": "65,975"
        },
        "3.6": {
          "rap": "14,000",
          "low_price": "31,320",
          "high_price": "67,860"
        },
        "3.7": {
          "rap": "14,000",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.8": {
          "rap": "14,000",
          "low_price": "33,060",
          "high_price": "71,630"
        },
        "3.9": {
          "rap": "14,000",
          "low_price": "33,930",
          "high_price": "73,515"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,200",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "3,000",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "1.0": {
          "rap": "3,600",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "3,600",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "3,600",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "3,600",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "3,600",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "5,800",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "5,800",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "5,800",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "5,800",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "5,800",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "7,700",
          "low_price": "8,400",
          "high_price": "18,200"
        },
        "2.1": {
          "rap": "7,700",
          "low_price": "8,820",
          "high_price": "19,110"
        },
        "2.2": {
          "rap": "7,700",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.3": {
          "rap": "7,700",
          "low_price": "9,660",
          "high_price": "20,930"
        },
        "2.4": {
          "rap": "7,700",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.5": {
          "rap": "7,700",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "2.6": {
          "rap": "7,700",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.7": {
          "rap": "7,700",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.8": {
          "rap": "7,700",
          "low_price": "11,760",
          "high_price": "25,480"
        },
        "2.9": {
          "rap": "7,700",
          "low_price": "12,180",
          "high_price": "26,390"
        },
        "3.0": {
          "rap": "11,100",
          "low_price": "19,980",
          "high_price": "43,290"
        },
        "3.1": {
          "rap": "11,100",
          "low_price": "20,645",
          "high_price": "44,735"
        },
        "3.2": {
          "rap": "11,100",
          "low_price": "21,310",
          "high_price": "46,175"
        },
        "3.3": {
          "rap": "11,100",
          "low_price": "21,980",
          "high_price": "47,620"
        },
        "3.4": {
          "rap": "11,100",
          "low_price": "22,645",
          "high_price": "49,060"
        },
        "3.5": {
          "rap": "11,100",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "3.6": {
          "rap": "11,100",
          "low_price": "23,975",
          "high_price": "51,950"
        },
        "3.7": {
          "rap": "11,100",
          "low_price": "24,640",
          "high_price": "53,390"
        },
        "3.8": {
          "rap": "11,100",
          "low_price": "25,310",
          "high_price": "54,835"
        },
        "3.9": {
          "rap": "11,100",
          "low_price": "25,975",
          "high_price": "56,275"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,000",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "2,000",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,000",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,500",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "2,900",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "1.1": {
          "rap": "2,900",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.2": {
          "rap": "2,900",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.3": {
          "rap": "2,900",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.4": {
          "rap": "2,900",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.5": {
          "rap": "4,700",
          "low_price": "3,510",
          "high_price": "7,605"
        },
        "1.6": {
          "rap": "4,700",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.7": {
          "rap": "4,700",
          "low_price": "3,980",
          "high_price": "8,620"
        },
        "1.8": {
          "rap": "4,700",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.9": {
          "rap": "4,700",
          "low_price": "4,445",
          "high_price": "9,635"
        },
        "2.0": {
          "rap": "6,300",
          "low_price": "6,600",
          "high_price": "14,300"
        },
        "2.1": {
          "rap": "6,300",
          "low_price": "6,930",
          "high_price": "15,015"
        },
        "2.2": {
          "rap": "6,300",
          "low_price": "7,260",
          "high_price": "15,730"
        },
        "2.3": {
          "rap": "6,300",
          "low_price": "7,590",
          "high_price": "16,445"
        },
        "2.4": {
          "rap": "6,300",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.5": {
          "rap": "6,300",
          "low_price": "8,250",
          "high_price": "17,875"
        },
        "2.6": {
          "rap": "6,300",
          "low_price": "8,580",
          "high_price": "18,590"
        },
        "2.7": {
          "rap": "6,300",
          "low_price": "8,910",
          "high_price": "19,305"
        },
        "2.8": {
          "rap": "6,300",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.9": {
          "rap": "6,300",
          "low_price": "9,570",
          "high_price": "20,735"
        },
        "3.0": {
          "rap": "8,800",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "3.1": {
          "rap": "8,800",
          "low_price": "16,370",
          "high_price": "35,465"
        },
        "3.2": {
          "rap": "8,800",
          "low_price": "16,895",
          "high_price": "36,610"
        },
        "3.3": {
          "rap": "8,800",
          "low_price": "17,425",
          "high_price": "37,750"
        },
        "3.4": {
          "rap": "8,800",
          "low_price": "17,950",
          "high_price": "38,895"
        },
        "3.5": {
          "rap": "8,800",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "3.6": {
          "rap": "8,800",
          "low_price": "19,010",
          "high_price": "41,185"
        },
        "3.7": {
          "rap": "8,800",
          "low_price": "19,535",
          "high_price": "42,330"
        },
        "3.8": {
          "rap": "8,800",
          "low_price": "20,065",
          "high_price": "43,470"
        },
        "3.9": {
          "rap": "8,800",
          "low_price": "20,590",
          "high_price": "44,615"
        }
      }
    },
    "SI2": {
      "D": {
        "0.4": {
          "rap": "1,700",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "3,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.8": {
          "rap": "3,400",
          "low_price": "1,150",
          "high_price": "2,495"
        },
        "0.9": {
          "rap": "4,400",
          "low_price": "1,780",
          "high_price": "3,860"
        },
        "1.0": {
          "rap": "5,300",
          "low_price": "2,340",
          "high_price": "5,070"
        },
        "1.1": {
          "rap": "5,300",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.2": {
          "rap": "5,300",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.3": {
          "rap": "5,300",
          "low_price": "3,040",
          "high_price": "6,590"
        },
        "1.4": {
          "rap": "5,300",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.5": {
          "rap": "9,100",
          "low_price": "6,030",
          "high_price": "13,065"
        },
        "1.6": {
          "rap": "9,100",
          "low_price": "6,430",
          "high_price": "13,935"
        },
        "1.7": {
          "rap": "9,100",
          "low_price": "6,835",
          "high_price": "14,805"
        },
        "1.8": {
          "rap": "9,100",
          "low_price": "7,235",
          "high_price": "15,680"
        },
        "1.9": {
          "rap": "9,100",
          "low_price": "7,640",
          "high_price": "16,550"
        },
        "2.0": {
          "rap": "12,100",
          "low_price": "12,360",
          "high_price": "26,780"
        },
        "2.1": {
          "rap": "12,100",
          "low_price": "12,980",
          "high_price": "28,120"
        },
        "2.2": {
          "rap": "12,100",
          "low_price": "13,595",
          "high_price": "29,460"
        },
        "2.3": {
          "rap": "12,100",
          "low_price": "14,215",
          "high_price": "30,795"
        },
        "2.4": {
          "rap": "12,100",
          "low_price": "14,830",
          "high_price": "32,135"
        },
        "2.5": {
          "rap": "12,100",
          "low_price": "15,450",
          "high_price": "33,475"
        },
        "2.6": {
          "rap": "12,100",
          "low_price": "16,070",
          "high_price": "34,815"
        },
        "2.7": {
          "rap": "12,100",
          "low_price": "16,685",
          "high_price": "36,155"
        },
        "2.8": {
          "rap": "12,100",
          "low_price": "17,305",
          "high_price": "37,490"
        },
        "2.9": {
          "rap": "12,100",
          "low_price": "17,920",
          "high_price": "38,830"
        },
        "3.0": {
          "rap": "17,500",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "3.1": {
          "rap": "17,500",
          "low_price": "33,480",
          "high_price": "72,540"
        },
        "3.2": {
          "rap": "17,500",
          "low_price": "34,560",
          "high_price": "74,880"
        },
        "3.3": {
          "rap": "17,500",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "3.4": {
          "rap": "17,500",
          "low_price": "36,720",
          "high_price": "79,560"
        },
        "3.5": {
          "rap": "17,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.6": {
          "rap": "17,500",
          "low_price": "38,880",
          "high_price": "84,240"
        },
        "3.7": {
          "rap": "17,500",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.8": {
          "rap": "17,500",
          "low_price": "41,040",
          "high_price": "88,920"
        },
        "3.9": {
          "rap": "17,500",
          "low_price": "42,120",
          "high_price": "91,260"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,600",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,200",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,200",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "4,200",
          "low_price": "1,675",
          "high_price": "3,625"
        },
        "1.0": {
          "rap": "5,100",
          "low_price": "2,220",
          "high_price": "4,810"
        },
        "1.1": {
          "rap": "5,100",
          "low_price": "2,440",
          "high_price": "5,290"
        },
        "1.2": {
          "rap": "5,100",
          "low_price": "2,665",
          "high_price": "5,770"
        },
        "1.3": {
          "rap": "5,100",
          "low_price": "2,885",
          "high_price": "6,255"
        },
        "1.4": {
          "rap": "5,100",
          "low_price": "3,110",
          "high_price": "6,735"
        },
        "1.5": {
          "rap": "8,600",
          "low_price": "5,670",
          "high_price": "12,285"
        },
        "1.6": {
          "rap": "8,600",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.7": {
          "rap": "8,600",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "1.8": {
          "rap": "8,600",
          "low_price": "6,805",
          "high_price": "14,740"
        },
        "1.9": {
          "rap": "8,600",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.0": {
          "rap": "11,400",
          "low_price": "11,520",
          "high_price": "24,960"
        },
        "2.1": {
          "rap": "11,400",
          "low_price": "12,095",
          "high_price": "26,210"
        },
        "2.2": {
          "rap": "11,400",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "2.3": {
          "rap": "11,400",
          "low_price": "13,250",
          "high_price": "28,705"
        },
        "2.4": {
          "rap": "11,400",
          "low_price": "13,825",
          "high_price": "29,950"
        },
        "2.5": {
          "rap": "11,400",
          "low_price": "14,400",
          "high_price": "31,200"
        },
        "2.6": {
          "rap": "11,400",
          "low_price": "14,975",
          "high_price": "32,450"
        },
        "2.7": {
          "rap": "11,400",
          "low_price": "15,550",
          "high_price": "33,695"
        },
        "2.8": {
          "rap": "11,400",
          "low_price": "16,130",
          "high_price": "34,945"
        },
        "2.9": {
          "rap": "11,400",
          "low_price": "16,705",
          "high_price": "36,190"
        },
        "3.0": {
          "rap": "16,500",
          "low_price": "30,600",
          "high_price": "66,300"
        },
        "3.1": {
          "rap": "16,500",
          "low_price": "31,620",
          "high_price": "68,510"
        },
        "3.2": {
          "rap": "16,500",
          "low_price": "32,640",
          "high_price": "70,720"
        },
        "3.3": {
          "rap": "16,500",
          "low_price": "33,660",
          "high_price": "72,930"
        },
        "3.4": {
          "rap": "16,500",
          "low_price": "34,680",
          "high_price": "75,140"
        },
        "3.5": {
          "rap": "16,500",
          "low_price": "35,700",
          "high_price": "77,350"
        },
        "3.6": {
          "rap": "16,500",
          "low_price": "36,720",
          "high_price": "79,560"
        },
        "3.7": {
          "rap": "16,500",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.8": {
          "rap": "16,500",
          "low_price": "38,760",
          "high_price": "83,980"
        },
        "3.9": {
          "rap": "16,500",
          "low_price": "39,780",
          "high_price": "86,190"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,500",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "4,000",
          "low_price": "1,565",
          "high_price": "3,395"
        },
        "1.0": {
          "rap": "4,900",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "1.1": {
          "rap": "4,900",
          "low_price": "2,310",
          "high_price": "5,005"
        },
        "1.2": {
          "rap": "4,900",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.3": {
          "rap": "4,900",
          "low_price": "2,730",
          "high_price": "5,915"
        },
        "1.4": {
          "rap": "4,900",
          "low_price": "2,940",
          "high_price": "6,370"
        },
        "1.5": {
          "rap": "8,200",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "1.6": {
          "rap": "8,200",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "1.7": {
          "rap": "8,200",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "1.8": {
          "rap": "8,200",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "1.9": {
          "rap": "8,200",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "2.0": {
          "rap": "10,800",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.1": {
          "rap": "10,800",
          "low_price": "11,465",
          "high_price": "24,845"
        },
        "2.2": {
          "rap": "10,800",
          "low_price": "12,010",
          "high_price": "26,025"
        },
        "2.3": {
          "rap": "10,800",
          "low_price": "12,560",
          "high_price": "27,210"
        },
        "2.4": {
          "rap": "10,800",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.5": {
          "rap": "10,800",
          "low_price": "13,650",
          "high_price": "29,575"
        },
        "2.6": {
          "rap": "10,800",
          "low_price": "14,195",
          "high_price": "30,760"
        },
        "2.7": {
          "rap": "10,800",
          "low_price": "14,740",
          "high_price": "31,940"
        },
        "2.8": {
          "rap": "10,800",
          "low_price": "15,290",
          "high_price": "33,125"
        },
        "2.9": {
          "rap": "10,800",
          "low_price": "15,835",
          "high_price": "34,305"
        },
        "3.0": {
          "rap": "15,500",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "3.1": {
          "rap": "15,500",
          "low_price": "29,760",
          "high_price": "64,480"
        },
        "3.2": {
          "rap": "15,500",
          "low_price": "30,720",
          "high_price": "66,560"
        },
        "3.3": {
          "rap": "15,500",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "3.4": {
          "rap": "15,500",
          "low_price": "32,640",
          "high_price": "70,720"
        },
        "3.5": {
          "rap": "15,500",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "3.6": {
          "rap": "15,500",
          "low_price": "34,560",
          "high_price": "74,880"
        },
        "3.7": {
          "rap": "15,500",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.8": {
          "rap": "15,500",
          "low_price": "36,480",
          "high_price": "79,040"
        },
        "3.9": {
          "rap": "15,500",
          "low_price": "37,440",
          "high_price": "81,120"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,800",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,800",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "3,800",
          "low_price": "1,460",
          "high_price": "3,160"
        },
        "1.0": {
          "rap": "4,700",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.1": {
          "rap": "4,700",
          "low_price": "2,180",
          "high_price": "4,720"
        },
        "1.2": {
          "rap": "4,700",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.3": {
          "rap": "4,700",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.4": {
          "rap": "4,700",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.5": {
          "rap": "7,800",
          "low_price": "5,040",
          "high_price": "10,920"
        },
        "1.6": {
          "rap": "7,800",
          "low_price": "5,375",
          "high_price": "11,650"
        },
        "1.7": {
          "rap": "7,800",
          "low_price": "5,710",
          "high_price": "12,375"
        },
        "1.8": {
          "rap": "7,800",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.9": {
          "rap": "7,800",
          "low_price": "6,385",
          "high_price": "13,830"
        },
        "2.0": {
          "rap": "10,300",
          "low_price": "10,320",
          "high_price": "22,360"
        },
        "2.1": {
          "rap": "10,300",
          "low_price": "10,835",
          "high_price": "23,480"
        },
        "2.2": {
          "rap": "10,300",
          "low_price": "11,350",
          "high_price": "24,595"
        },
        "2.3": {
          "rap": "10,300",
          "low_price": "11,870",
          "high_price": "25,715"
        },
        "2.4": {
          "rap": "10,300",
          "low_price": "12,385",
          "high_price": "26,830"
        },
        "2.5": {
          "rap": "10,300",
          "low_price": "12,900",
          "high_price": "27,950"
        },
        "2.6": {
          "rap": "10,300",
          "low_price": "13,415",
          "high_price": "29,070"
        },
        "2.7": {
          "rap": "10,300",
          "low_price": "13,930",
          "high_price": "30,185"
        },
        "2.8": {
          "rap": "10,300",
          "low_price": "14,450",
          "high_price": "31,305"
        },
        "2.9": {
          "rap": "10,300",
          "low_price": "14,965",
          "high_price": "32,420"
        },
        "3.0": {
          "rap": "14,500",
          "low_price": "27,000",
          "high_price": "58,500"
        },
        "3.1": {
          "rap": "14,500",
          "low_price": "27,900",
          "high_price": "60,450"
        },
        "3.2": {
          "rap": "14,500",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "3.3": {
          "rap": "14,500",
          "low_price": "29,700",
          "high_price": "64,350"
        },
        "3.4": {
          "rap": "14,500",
          "low_price": "30,600",
          "high_price": "66,300"
        },
        "3.5": {
          "rap": "14,500",
          "low_price": "31,500",
          "high_price": "68,250"
        },
        "3.6": {
          "rap": "14,500",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "3.7": {
          "rap": "14,500",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.8": {
          "rap": "14,500",
          "low_price": "34,200",
          "high_price": "74,100"
        },
        "3.9": {
          "rap": "14,500",
          "low_price": "35,100",
          "high_price": "76,050"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,300",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,600",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,600",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,350",
          "high_price": "2,925"
        },
        "1.0": {
          "rap": "4,400",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "4,400",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "4,400",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "4,400",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "4,400",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "7,400",
          "low_price": "4,680",
          "high_price": "10,140"
        },
        "1.6": {
          "rap": "7,400",
          "low_price": "4,990",
          "high_price": "10,815"
        },
        "1.7": {
          "rap": "7,400",
          "low_price": "5,305",
          "high_price": "11,490"
        },
        "1.8": {
          "rap": "7,400",
          "low_price": "5,615",
          "high_price": "12,170"
        },
        "1.9": {
          "rap": "7,400",
          "low_price": "5,930",
          "high_price": "12,845"
        },
        "2.0": {
          "rap": "9,600",
          "low_price": "9,840",
          "high_price": "21,320"
        },
        "2.1": {
          "rap": "9,600",
          "low_price": "10,330",
          "high_price": "22,385"
        },
        "2.2": {
          "rap": "9,600",
          "low_price": "10,825",
          "high_price": "23,450"
        },
        "2.3": {
          "rap": "9,600",
          "low_price": "11,315",
          "high_price": "24,520"
        },
        "2.4": {
          "rap": "9,600",
          "low_price": "11,810",
          "high_price": "25,585"
        },
        "2.5": {
          "rap": "9,600",
          "low_price": "12,300",
          "high_price": "26,650"
        },
        "2.6": {
          "rap": "9,600",
          "low_price": "12,790",
          "high_price": "27,715"
        },
        "2.7": {
          "rap": "9,600",
          "low_price": "13,285",
          "high_price": "28,780"
        },
        "2.8": {
          "rap": "9,600",
          "low_price": "13,775",
          "high_price": "29,850"
        },
        "2.9": {
          "rap": "9,600",
          "low_price": "14,270",
          "high_price": "30,915"
        },
        "3.0": {
          "rap": "13,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "3.1": {
          "rap": "13,500",
          "low_price": "26,040",
          "high_price": "56,420"
        },
        "3.2": {
          "rap": "13,500",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "3.3": {
          "rap": "13,500",
          "low_price": "27,720",
          "high_price": "60,060"
        },
        "3.4": {
          "rap": "13,500",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "3.5": {
          "rap": "13,500",
          "low_price": "29,400",
          "high_price": "63,700"
        },
        "3.6": {
          "rap": "13,500",
          "low_price": "30,240",
          "high_price": "65,520"
        },
        "3.7": {
          "rap": "13,500",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "3.8": {
          "rap": "13,500",
          "low_price": "31,920",
          "high_price": "69,160"
        },
        "3.9": {
          "rap": "13,500",
          "low_price": "32,760",
          "high_price": "70,980"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,200",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,500",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,400",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,400",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "3,200",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "4,000",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "1.1": {
          "rap": "4,000",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.2": {
          "rap": "4,000",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.3": {
          "rap": "4,000",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.4": {
          "rap": "4,000",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "1.5": {
          "rap": "6,700",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "6,700",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "6,700",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "6,700",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "6,700",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "8,900",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "2.1": {
          "rap": "8,900",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "2.2": {
          "rap": "8,900",
          "low_price": "9,900",
          "high_price": "21,450"
        },
        "2.3": {
          "rap": "8,900",
          "low_price": "10,350",
          "high_price": "22,425"
        },
        "2.4": {
          "rap": "8,900",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "2.5": {
          "rap": "8,900",
          "low_price": "11,250",
          "high_price": "24,375"
        },
        "2.6": {
          "rap": "8,900",
          "low_price": "11,700",
          "high_price": "25,350"
        },
        "2.7": {
          "rap": "8,900",
          "low_price": "12,150",
          "high_price": "26,325"
        },
        "2.8": {
          "rap": "8,900",
          "low_price": "12,600",
          "high_price": "27,300"
        },
        "2.9": {
          "rap": "8,900",
          "low_price": "13,050",
          "high_price": "28,275"
        },
        "3.0": {
          "rap": "12,000",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "3.1": {
          "rap": "12,000",
          "low_price": "23,250",
          "high_price": "50,375"
        },
        "3.2": {
          "rap": "12,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "3.3": {
          "rap": "12,000",
          "low_price": "24,750",
          "high_price": "53,625"
        },
        "3.4": {
          "rap": "12,000",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "3.5": {
          "rap": "12,000",
          "low_price": "26,250",
          "high_price": "56,875"
        },
        "3.6": {
          "rap": "12,000",
          "low_price": "27,000",
          "high_price": "58,500"
        },
        "3.7": {
          "rap": "12,000",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "3.8": {
          "rap": "12,000",
          "low_price": "28,500",
          "high_price": "61,750"
        },
        "3.9": {
          "rap": "12,000",
          "low_price": "29,250",
          "high_price": "63,375"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,100",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,700",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "3,300",
          "low_price": "1,500",
          "high_price": "3,250"
        },
        "1.1": {
          "rap": "3,300",
          "low_price": "1,650",
          "high_price": "3,575"
        },
        "1.2": {
          "rap": "3,300",
          "low_price": "1,800",
          "high_price": "3,900"
        },
        "1.3": {
          "rap": "3,300",
          "low_price": "1,950",
          "high_price": "4,225"
        },
        "1.4": {
          "rap": "3,300",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "1.5": {
          "rap": "5,500",
          "low_price": "3,960",
          "high_price": "8,580"
        },
        "1.6": {
          "rap": "5,500",
          "low_price": "4,225",
          "high_price": "9,150"
        },
        "1.7": {
          "rap": "5,500",
          "low_price": "4,490",
          "high_price": "9,725"
        },
        "1.8": {
          "rap": "5,500",
          "low_price": "4,750",
          "high_price": "10,295"
        },
        "1.9": {
          "rap": "5,500",
          "low_price": "5,015",
          "high_price": "10,870"
        },
        "2.0": {
          "rap": "7,400",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.1": {
          "rap": "7,400",
          "low_price": "7,940",
          "high_price": "17,200"
        },
        "2.2": {
          "rap": "7,400",
          "low_price": "8,315",
          "high_price": "18,020"
        },
        "2.3": {
          "rap": "7,400",
          "low_price": "8,695",
          "high_price": "18,835"
        },
        "2.4": {
          "rap": "7,400",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "2.5": {
          "rap": "7,400",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "2.6": {
          "rap": "7,400",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "2.7": {
          "rap": "7,400",
          "low_price": "10,205",
          "high_price": "22,115"
        },
        "2.8": {
          "rap": "7,400",
          "low_price": "10,585",
          "high_price": "22,930"
        },
        "2.9": {
          "rap": "7,400",
          "low_price": "10,960",
          "high_price": "23,750"
        },
        "3.0": {
          "rap": "10,200",
          "low_price": "18,360",
          "high_price": "39,780"
        },
        "3.1": {
          "rap": "10,200",
          "low_price": "18,970",
          "high_price": "41,105"
        },
        "3.2": {
          "rap": "10,200",
          "low_price": "19,585",
          "high_price": "42,430"
        },
        "3.3": {
          "rap": "10,200",
          "low_price": "20,195",
          "high_price": "43,760"
        },
        "3.4": {
          "rap": "10,200",
          "low_price": "20,810",
          "high_price": "45,085"
        },
        "3.5": {
          "rap": "10,200",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "3.6": {
          "rap": "10,200",
          "low_price": "22,030",
          "high_price": "47,735"
        },
        "3.7": {
          "rap": "10,200",
          "low_price": "22,645",
          "high_price": "49,060"
        },
        "3.8": {
          "rap": "10,200",
          "low_price": "23,255",
          "high_price": "50,390"
        },
        "3.9": {
          "rap": "10,200",
          "low_price": "23,870",
          "high_price": "51,715"
        }
      },
      "K": {
        "0.4": {
          "rap": "900",
          "low_price": "215",
          "high_price": "470"
        },
        "0.5": {
          "rap": "1,300",
          "low_price": "330",
          "high_price": "715"
        },
        "0.6": {
          "rap": "1,300",
          "low_price": "395",
          "high_price": "860"
        },
        "0.7": {
          "rap": "1,900",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.8": {
          "rap": "1,900",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.9": {
          "rap": "2,300",
          "low_price": "1,025",
          "high_price": "2,225"
        },
        "1.0": {
          "rap": "2,700",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "1.1": {
          "rap": "2,700",
          "low_price": "1,450",
          "high_price": "3,145"
        },
        "1.2": {
          "rap": "2,700",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.3": {
          "rap": "2,700",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.4": {
          "rap": "2,700",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.5": {
          "rap": "4,400",
          "low_price": "3,330",
          "high_price": "7,215"
        },
        "1.6": {
          "rap": "4,400",
          "low_price": "3,550",
          "high_price": "7,695"
        },
        "1.7": {
          "rap": "4,400",
          "low_price": "3,775",
          "high_price": "8,175"
        },
        "1.8": {
          "rap": "4,400",
          "low_price": "3,995",
          "high_price": "8,660"
        },
        "1.9": {
          "rap": "4,400",
          "low_price": "4,220",
          "high_price": "9,140"
        },
        "2.0": {
          "rap": "6,000",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "2.1": {
          "rap": "6,000",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "2.2": {
          "rap": "6,000",
          "low_price": "6,730",
          "high_price": "14,585"
        },
        "2.3": {
          "rap": "6,000",
          "low_price": "7,040",
          "high_price": "15,250"
        },
        "2.4": {
          "rap": "6,000",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "2.5": {
          "rap": "6,000",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "2.6": {
          "rap": "6,000",
          "low_price": "7,955",
          "high_price": "17,240"
        },
        "2.7": {
          "rap": "6,000",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "2.8": {
          "rap": "6,000",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "2.9": {
          "rap": "6,000",
          "low_price": "8,875",
          "high_price": "19,225"
        },
        "3.0": {
          "rap": "8,200",
          "low_price": "14,760",
          "high_price": "31,980"
        },
        "3.1": {
          "rap": "8,200",
          "low_price": "15,250",
          "high_price": "33,045"
        },
        "3.2": {
          "rap": "8,200",
          "low_price": "15,745",
          "high_price": "34,110"
        },
        "3.3": {
          "rap": "8,200",
          "low_price": "16,235",
          "high_price": "35,180"
        },
        "3.4": {
          "rap": "8,200",
          "low_price": "16,730",
          "high_price": "36,245"
        },
        "3.5": {
          "rap": "8,200",
          "low_price": "17,220",
          "high_price": "37,310"
        },
        "3.6": {
          "rap": "8,200",
          "low_price": "17,710",
          "high_price": "38,375"
        },
        "3.7": {
          "rap": "8,200",
          "low_price": "18,205",
          "high_price": "39,440"
        },
        "3.8": {
          "rap": "8,200",
          "low_price": "18,695",
          "high_price": "40,510"
        },
        "3.9": {
          "rap": "8,200",
          "low_price": "19,190",
          "high_price": "41,575"
        }
      }
    },
    "SI3": {
      "D": {
        "0.4": {
          "rap": "1,500",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,100",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,100",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "3,700",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "4,300",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "1.1": {
          "rap": "4,300",
          "low_price": "2,310",
          "high_price": "5,005"
        },
        "1.2": {
          "rap": "4,300",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.3": {
          "rap": "4,300",
          "low_price": "2,730",
          "high_price": "5,915"
        },
        "1.4": {
          "rap": "4,300",
          "low_price": "2,940",
          "high_price": "6,370"
        },
        "1.5": {
          "rap": "7,100",
          "low_price": "5,310",
          "high_price": "11,505"
        },
        "1.6": {
          "rap": "7,100",
          "low_price": "5,665",
          "high_price": "12,270"
        },
        "1.7": {
          "rap": "7,100",
          "low_price": "6,020",
          "high_price": "13,040"
        },
        "1.8": {
          "rap": "7,100",
          "low_price": "6,370",
          "high_price": "13,805"
        },
        "1.9": {
          "rap": "7,100",
          "low_price": "6,725",
          "high_price": "14,575"
        },
        "2.0": {
          "rap": "8,800",
          "low_price": "9,840",
          "high_price": "21,320"
        },
        "2.1": {
          "rap": "8,800",
          "low_price": "10,330",
          "high_price": "22,385"
        },
        "2.2": {
          "rap": "8,800",
          "low_price": "10,825",
          "high_price": "23,450"
        },
        "2.3": {
          "rap": "8,800",
          "low_price": "11,315",
          "high_price": "24,520"
        },
        "2.4": {
          "rap": "8,800",
          "low_price": "11,810",
          "high_price": "25,585"
        },
        "2.5": {
          "rap": "8,800",
          "low_price": "12,300",
          "high_price": "26,650"
        },
        "2.6": {
          "rap": "8,800",
          "low_price": "12,790",
          "high_price": "27,715"
        },
        "2.7": {
          "rap": "8,800",
          "low_price": "13,285",
          "high_price": "28,780"
        },
        "2.8": {
          "rap": "8,800",
          "low_price": "13,775",
          "high_price": "29,850"
        },
        "2.9": {
          "rap": "8,800",
          "low_price": "14,270",
          "high_price": "30,915"
        },
        "3.0": {
          "rap": "11,800",
          "low_price": "21,960",
          "high_price": "47,580"
        },
        "3.1": {
          "rap": "11,800",
          "low_price": "22,690",
          "high_price": "49,165"
        },
        "3.2": {
          "rap": "11,800",
          "low_price": "23,425",
          "high_price": "50,750"
        },
        "3.3": {
          "rap": "11,800",
          "low_price": "24,155",
          "high_price": "52,340"
        },
        "3.4": {
          "rap": "11,800",
          "low_price": "24,890",
          "high_price": "53,925"
        },
        "3.5": {
          "rap": "11,800",
          "low_price": "25,620",
          "high_price": "55,510"
        },
        "3.6": {
          "rap": "11,800",
          "low_price": "26,350",
          "high_price": "57,095"
        },
        "3.7": {
          "rap": "11,800",
          "low_price": "27,085",
          "high_price": "58,680"
        },
        "3.8": {
          "rap": "11,800",
          "low_price": "27,815",
          "high_price": "60,270"
        },
        "3.9": {
          "rap": "11,800",
          "low_price": "28,550",
          "high_price": "61,855"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "2,900",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "2,900",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "1.0": {
          "rap": "4,100",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.1": {
          "rap": "4,100",
          "low_price": "2,180",
          "high_price": "4,720"
        },
        "1.2": {
          "rap": "4,100",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.3": {
          "rap": "4,100",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.4": {
          "rap": "4,100",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.5": {
          "rap": "6,600",
          "low_price": "4,950",
          "high_price": "10,725"
        },
        "1.6": {
          "rap": "6,600",
          "low_price": "5,280",
          "high_price": "11,440"
        },
        "1.7": {
          "rap": "6,600",
          "low_price": "5,610",
          "high_price": "12,155"
        },
        "1.8": {
          "rap": "6,600",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "1.9": {
          "rap": "6,600",
          "low_price": "6,270",
          "high_price": "13,585"
        },
        "2.0": {
          "rap": "8,400",
          "low_price": "9,360",
          "high_price": "20,280"
        },
        "2.1": {
          "rap": "8,400",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "2.2": {
          "rap": "8,400",
          "low_price": "10,295",
          "high_price": "22,310"
        },
        "2.3": {
          "rap": "8,400",
          "low_price": "10,765",
          "high_price": "23,320"
        },
        "2.4": {
          "rap": "8,400",
          "low_price": "11,230",
          "high_price": "24,335"
        },
        "2.5": {
          "rap": "8,400",
          "low_price": "11,700",
          "high_price": "25,350"
        },
        "2.6": {
          "rap": "8,400",
          "low_price": "12,170",
          "high_price": "26,365"
        },
        "2.7": {
          "rap": "8,400",
          "low_price": "12,635",
          "high_price": "27,380"
        },
        "2.8": {
          "rap": "8,400",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.9": {
          "rap": "8,400",
          "low_price": "13,570",
          "high_price": "29,405"
        },
        "3.0": {
          "rap": "10,900",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "3.1": {
          "rap": "10,900",
          "low_price": "20,830",
          "high_price": "45,135"
        },
        "3.2": {
          "rap": "10,900",
          "low_price": "21,505",
          "high_price": "46,590"
        },
        "3.3": {
          "rap": "10,900",
          "low_price": "22,175",
          "high_price": "48,050"
        },
        "3.4": {
          "rap": "10,900",
          "low_price": "22,850",
          "high_price": "49,505"
        },
        "3.5": {
          "rap": "10,900",
          "low_price": "23,520",
          "high_price": "50,960"
        },
        "3.6": {
          "rap": "10,900",
          "low_price": "24,190",
          "high_price": "52,415"
        },
        "3.7": {
          "rap": "10,900",
          "low_price": "24,865",
          "high_price": "53,870"
        },
        "3.8": {
          "rap": "10,900",
          "low_price": "25,535",
          "high_price": "55,330"
        },
        "3.9": {
          "rap": "10,900",
          "low_price": "26,210",
          "high_price": "56,785"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,300",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,700",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,700",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "3,300",
          "low_price": "1,405",
          "high_price": "3,040"
        },
        "1.0": {
          "rap": "3,900",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "3,900",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "3,900",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "3,900",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "3,900",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "6,100",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.6": {
          "rap": "6,100",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.7": {
          "rap": "6,100",
          "low_price": "5,200",
          "high_price": "11,270"
        },
        "1.8": {
          "rap": "6,100",
          "low_price": "5,510",
          "high_price": "11,935"
        },
        "1.9": {
          "rap": "6,100",
          "low_price": "5,815",
          "high_price": "12,595"
        },
        "2.0": {
          "rap": "8,000",
          "low_price": "8,880",
          "high_price": "19,240"
        },
        "2.1": {
          "rap": "8,000",
          "low_price": "9,325",
          "high_price": "20,200"
        },
        "2.2": {
          "rap": "8,000",
          "low_price": "9,770",
          "high_price": "21,165"
        },
        "2.3": {
          "rap": "8,000",
          "low_price": "10,210",
          "high_price": "22,125"
        },
        "2.4": {
          "rap": "8,000",
          "low_price": "10,655",
          "high_price": "23,090"
        },
        "2.5": {
          "rap": "8,000",
          "low_price": "11,100",
          "high_price": "24,050"
        },
        "2.6": {
          "rap": "8,000",
          "low_price": "11,545",
          "high_price": "25,010"
        },
        "2.7": {
          "rap": "8,000",
          "low_price": "11,990",
          "high_price": "25,975"
        },
        "2.8": {
          "rap": "8,000",
          "low_price": "12,430",
          "high_price": "26,935"
        },
        "2.9": {
          "rap": "8,000",
          "low_price": "12,875",
          "high_price": "27,900"
        },
        "3.0": {
          "rap": "10,100",
          "low_price": "18,720",
          "high_price": "40,560"
        },
        "3.1": {
          "rap": "10,100",
          "low_price": "19,345",
          "high_price": "41,910"
        },
        "3.2": {
          "rap": "10,100",
          "low_price": "19,970",
          "high_price": "43,265"
        },
        "3.3": {
          "rap": "10,100",
          "low_price": "20,590",
          "high_price": "44,615"
        },
        "3.4": {
          "rap": "10,100",
          "low_price": "21,215",
          "high_price": "45,970"
        },
        "3.5": {
          "rap": "10,100",
          "low_price": "21,840",
          "high_price": "47,320"
        },
        "3.6": {
          "rap": "10,100",
          "low_price": "22,465",
          "high_price": "48,670"
        },
        "3.7": {
          "rap": "10,100",
          "low_price": "23,090",
          "high_price": "50,025"
        },
        "3.8": {
          "rap": "10,100",
          "low_price": "23,710",
          "high_price": "51,375"
        },
        "3.9": {
          "rap": "10,100",
          "low_price": "24,335",
          "high_price": "52,730"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,200",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,500",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,500",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "3,100",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "1.0": {
          "rap": "3,700",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "3,700",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "3,700",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "3,700",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "3,700",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "5,700",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "5,700",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "5,700",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "5,700",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "5,700",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "7,500",
          "low_price": "8,400",
          "high_price": "18,200"
        },
        "2.1": {
          "rap": "7,500",
          "low_price": "8,820",
          "high_price": "19,110"
        },
        "2.2": {
          "rap": "7,500",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.3": {
          "rap": "7,500",
          "low_price": "9,660",
          "high_price": "20,930"
        },
        "2.4": {
          "rap": "7,500",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.5": {
          "rap": "7,500",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "2.6": {
          "rap": "7,500",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.7": {
          "rap": "7,500",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.8": {
          "rap": "7,500",
          "low_price": "11,760",
          "high_price": "25,480"
        },
        "2.9": {
          "rap": "7,500",
          "low_price": "12,180",
          "high_price": "26,390"
        },
        "3.0": {
          "rap": "9,200",
          "low_price": "17,100",
          "high_price": "37,050"
        },
        "3.1": {
          "rap": "9,200",
          "low_price": "17,670",
          "high_price": "38,285"
        },
        "3.2": {
          "rap": "9,200",
          "low_price": "18,240",
          "high_price": "39,520"
        },
        "3.3": {
          "rap": "9,200",
          "low_price": "18,810",
          "high_price": "40,755"
        },
        "3.4": {
          "rap": "9,200",
          "low_price": "19,380",
          "high_price": "41,990"
        },
        "3.5": {
          "rap": "9,200",
          "low_price": "19,950",
          "high_price": "43,225"
        },
        "3.6": {
          "rap": "9,200",
          "low_price": "20,520",
          "high_price": "44,460"
        },
        "3.7": {
          "rap": "9,200",
          "low_price": "21,090",
          "high_price": "45,695"
        },
        "3.8": {
          "rap": "9,200",
          "low_price": "21,660",
          "high_price": "46,930"
        },
        "3.9": {
          "rap": "9,200",
          "low_price": "22,230",
          "high_price": "48,165"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,100",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,500",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,900",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "1.0": {
          "rap": "3,500",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.1": {
          "rap": "3,500",
          "low_price": "1,780",
          "high_price": "3,860"
        },
        "1.2": {
          "rap": "3,500",
          "low_price": "1,945",
          "high_price": "4,210"
        },
        "1.3": {
          "rap": "3,500",
          "low_price": "2,105",
          "high_price": "4,565"
        },
        "1.4": {
          "rap": "3,500",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.5": {
          "rap": "5,400",
          "low_price": "4,050",
          "high_price": "8,775"
        },
        "1.6": {
          "rap": "5,400",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.7": {
          "rap": "5,400",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.8": {
          "rap": "5,400",
          "low_price": "4,860",
          "high_price": "10,530"
        },
        "1.9": {
          "rap": "5,400",
          "low_price": "5,130",
          "high_price": "11,115"
        },
        "2.0": {
          "rap": "6,700",
          "low_price": "7,680",
          "high_price": "16,640"
        },
        "2.1": {
          "rap": "6,700",
          "low_price": "8,065",
          "high_price": "17,470"
        },
        "2.2": {
          "rap": "6,700",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "2.3": {
          "rap": "6,700",
          "low_price": "8,830",
          "high_price": "19,135"
        },
        "2.4": {
          "rap": "6,700",
          "low_price": "9,215",
          "high_price": "19,970"
        },
        "2.5": {
          "rap": "6,700",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "2.6": {
          "rap": "6,700",
          "low_price": "9,985",
          "high_price": "21,630"
        },
        "2.7": {
          "rap": "6,700",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "2.8": {
          "rap": "6,700",
          "low_price": "10,750",
          "high_price": "23,295"
        },
        "2.9": {
          "rap": "6,700",
          "low_price": "11,135",
          "high_price": "24,130"
        },
        "3.0": {
          "rap": "8,500",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "3.1": {
          "rap": "8,500",
          "low_price": "16,370",
          "high_price": "35,465"
        },
        "3.2": {
          "rap": "8,500",
          "low_price": "16,895",
          "high_price": "36,610"
        },
        "3.3": {
          "rap": "8,500",
          "low_price": "17,425",
          "high_price": "37,750"
        },
        "3.4": {
          "rap": "8,500",
          "low_price": "17,950",
          "high_price": "38,895"
        },
        "3.5": {
          "rap": "8,500",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "3.6": {
          "rap": "8,500",
          "low_price": "19,010",
          "high_price": "41,185"
        },
        "3.7": {
          "rap": "8,500",
          "low_price": "19,535",
          "high_price": "42,330"
        },
        "3.8": {
          "rap": "8,500",
          "low_price": "20,065",
          "high_price": "43,470"
        },
        "3.9": {
          "rap": "8,500",
          "low_price": "20,590",
          "high_price": "44,615"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,000",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,700",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "3,200",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "1.1": {
          "rap": "3,200",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.2": {
          "rap": "3,200",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.3": {
          "rap": "3,200",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.4": {
          "rap": "3,200",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.5": {
          "rap": "5,000",
          "low_price": "3,780",
          "high_price": "8,190"
        },
        "1.6": {
          "rap": "5,000",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.7": {
          "rap": "5,000",
          "low_price": "4,285",
          "high_price": "9,280"
        },
        "1.8": {
          "rap": "5,000",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.9": {
          "rap": "5,000",
          "low_price": "4,790",
          "high_price": "10,375"
        },
        "2.0": {
          "rap": "6,000",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "2.1": {
          "rap": "6,000",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.2": {
          "rap": "6,000",
          "low_price": "7,525",
          "high_price": "16,300"
        },
        "2.3": {
          "rap": "6,000",
          "low_price": "7,865",
          "high_price": "17,045"
        },
        "2.4": {
          "rap": "6,000",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "2.5": {
          "rap": "6,000",
          "low_price": "8,550",
          "high_price": "18,525"
        },
        "2.6": {
          "rap": "6,000",
          "low_price": "8,890",
          "high_price": "19,265"
        },
        "2.7": {
          "rap": "6,000",
          "low_price": "9,235",
          "high_price": "20,005"
        },
        "2.8": {
          "rap": "6,000",
          "low_price": "9,575",
          "high_price": "20,750"
        },
        "2.9": {
          "rap": "6,000",
          "low_price": "9,920",
          "high_price": "21,490"
        },
        "3.0": {
          "rap": "7,900",
          "low_price": "14,580",
          "high_price": "31,590"
        },
        "3.1": {
          "rap": "7,900",
          "low_price": "15,065",
          "high_price": "32,645"
        },
        "3.2": {
          "rap": "7,900",
          "low_price": "15,550",
          "high_price": "33,695"
        },
        "3.3": {
          "rap": "7,900",
          "low_price": "16,040",
          "high_price": "34,750"
        },
        "3.4": {
          "rap": "7,900",
          "low_price": "16,525",
          "high_price": "35,800"
        },
        "3.5": {
          "rap": "7,900",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "3.6": {
          "rap": "7,900",
          "low_price": "17,495",
          "high_price": "37,910"
        },
        "3.7": {
          "rap": "7,900",
          "low_price": "17,980",
          "high_price": "38,960"
        },
        "3.8": {
          "rap": "7,900",
          "low_price": "18,470",
          "high_price": "40,015"
        },
        "3.9": {
          "rap": "7,900",
          "low_price": "18,955",
          "high_price": "41,065"
        }
      },
      "J": {
        "0.4": {
          "rap": "900",
          "low_price": "215",
          "high_price": "470"
        },
        "0.5": {
          "rap": "1,300",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,300",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "1,900",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.8": {
          "rap": "1,900",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.9": {
          "rap": "2,300",
          "low_price": "1,025",
          "high_price": "2,225"
        },
        "1.0": {
          "rap": "2,700",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "1.1": {
          "rap": "2,700",
          "low_price": "1,450",
          "high_price": "3,145"
        },
        "1.2": {
          "rap": "2,700",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.3": {
          "rap": "2,700",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.4": {
          "rap": "2,700",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.5": {
          "rap": "4,400",
          "low_price": "3,420",
          "high_price": "7,410"
        },
        "1.6": {
          "rap": "4,400",
          "low_price": "3,650",
          "high_price": "7,905"
        },
        "1.7": {
          "rap": "4,400",
          "low_price": "3,875",
          "high_price": "8,400"
        },
        "1.8": {
          "rap": "4,400",
          "low_price": "4,105",
          "high_price": "8,890"
        },
        "1.9": {
          "rap": "4,400",
          "low_price": "4,330",
          "high_price": "9,385"
        },
        "2.0": {
          "rap": "5,400",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "2.1": {
          "rap": "5,400",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "2.2": {
          "rap": "5,400",
          "low_price": "6,730",
          "high_price": "14,585"
        },
        "2.3": {
          "rap": "5,400",
          "low_price": "7,040",
          "high_price": "15,250"
        },
        "2.4": {
          "rap": "5,400",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "2.5": {
          "rap": "5,400",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "2.6": {
          "rap": "5,400",
          "low_price": "7,955",
          "high_price": "17,240"
        },
        "2.7": {
          "rap": "5,400",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "2.8": {
          "rap": "5,400",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "2.9": {
          "rap": "5,400",
          "low_price": "8,875",
          "high_price": "19,225"
        },
        "3.0": {
          "rap": "7,100",
          "low_price": "12,780",
          "high_price": "27,690"
        },
        "3.1": {
          "rap": "7,100",
          "low_price": "13,205",
          "high_price": "28,615"
        },
        "3.2": {
          "rap": "7,100",
          "low_price": "13,630",
          "high_price": "29,535"
        },
        "3.3": {
          "rap": "7,100",
          "low_price": "14,060",
          "high_price": "30,460"
        },
        "3.4": {
          "rap": "7,100",
          "low_price": "14,485",
          "high_price": "31,380"
        },
        "3.5": {
          "rap": "7,100",
          "low_price": "14,910",
          "high_price": "32,305"
        },
        "3.6": {
          "rap": "7,100",
          "low_price": "15,335",
          "high_price": "33,230"
        },
        "3.7": {
          "rap": "7,100",
          "low_price": "15,760",
          "high_price": "34,150"
        },
        "3.8": {
          "rap": "7,100",
          "low_price": "16,190",
          "high_price": "35,075"
        },
        "3.9": {
          "rap": "7,100",
          "low_price": "16,615",
          "high_price": "35,995"
        }
      },
      "K": {
        "0.4": {
          "rap": "800",
          "low_price": "190",
          "high_price": "415"
        },
        "0.5": {
          "rap": "1,100",
          "low_price": "300",
          "high_price": "650"
        },
        "0.6": {
          "rap": "1,100",
          "low_price": "360",
          "high_price": "780"
        },
        "0.7": {
          "rap": "1,700",
          "low_price": "590",
          "high_price": "1,275"
        },
        "0.8": {
          "rap": "1,700",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.9": {
          "rap": "2,000",
          "low_price": "920",
          "high_price": "1,990"
        },
        "1.0": {
          "rap": "2,300",
          "low_price": "1,140",
          "high_price": "2,470"
        },
        "1.1": {
          "rap": "2,300",
          "low_price": "1,255",
          "high_price": "2,715"
        },
        "1.2": {
          "rap": "2,300",
          "low_price": "1,370",
          "high_price": "2,965"
        },
        "1.3": {
          "rap": "2,300",
          "low_price": "1,480",
          "high_price": "3,210"
        },
        "1.4": {
          "rap": "2,300",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "1.5": {
          "rap": "3,700",
          "low_price": "2,970",
          "high_price": "6,435"
        },
        "1.6": {
          "rap": "3,700",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.7": {
          "rap": "3,700",
          "low_price": "3,365",
          "high_price": "7,295"
        },
        "1.8": {
          "rap": "3,700",
          "low_price": "3,565",
          "high_price": "7,720"
        },
        "1.9": {
          "rap": "3,700",
          "low_price": "3,760",
          "high_price": "8,150"
        },
        "2.0": {
          "rap": "4,700",
          "low_price": "5,160",
          "high_price": "11,180"
        },
        "2.1": {
          "rap": "4,700",
          "low_price": "5,420",
          "high_price": "11,740"
        },
        "2.2": {
          "rap": "4,700",
          "low_price": "5,675",
          "high_price": "12,300"
        },
        "2.3": {
          "rap": "4,700",
          "low_price": "5,935",
          "high_price": "12,855"
        },
        "2.4": {
          "rap": "4,700",
          "low_price": "6,190",
          "high_price": "13,415"
        },
        "2.5": {
          "rap": "4,700",
          "low_price": "6,450",
          "high_price": "13,975"
        },
        "2.6": {
          "rap": "4,700",
          "low_price": "6,710",
          "high_price": "14,535"
        },
        "2.7": {
          "rap": "4,700",
          "low_price": "6,965",
          "high_price": "15,095"
        },
        "2.8": {
          "rap": "4,700",
          "low_price": "7,225",
          "high_price": "15,650"
        },
        "2.9": {
          "rap": "4,700",
          "low_price": "7,480",
          "high_price": "16,210"
        },
        "3.0": {
          "rap": "6,100",
          "low_price": "10,980",
          "high_price": "23,790"
        },
        "3.1": {
          "rap": "6,100",
          "low_price": "11,345",
          "high_price": "24,585"
        },
        "3.2": {
          "rap": "6,100",
          "low_price": "11,710",
          "high_price": "25,375"
        },
        "3.3": {
          "rap": "6,100",
          "low_price": "12,080",
          "high_price": "26,170"
        },
        "3.4": {
          "rap": "6,100",
          "low_price": "12,445",
          "high_price": "26,960"
        },
        "3.5": {
          "rap": "6,100",
          "low_price": "12,810",
          "high_price": "27,755"
        },
        "3.6": {
          "rap": "6,100",
          "low_price": "13,175",
          "high_price": "28,550"
        },
        "3.7": {
          "rap": "6,100",
          "low_price": "13,540",
          "high_price": "29,340"
        },
        "3.8": {
          "rap": "6,100",
          "low_price": "13,910",
          "high_price": "30,135"
        },
        "3.9": {
          "rap": "6,100",
          "low_price": "14,275",
          "high_price": "30,925"
        }
      }
    },
    "VS1": {
      "D": {
        "0.4": {
          "rap": "2,600",
          "low_price": "530",
          "high_price": "1,145"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,555",
          "high_price": "3,365"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,775",
          "high_price": "3,850"
        },
        "0.9": {
          "rap": "6,500",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "8,500",
          "low_price": "4,020",
          "high_price": "8,710"
        },
        "1.1": {
          "rap": "8,500",
          "low_price": "4,420",
          "high_price": "9,580"
        },
        "1.2": {
          "rap": "8,500",
          "low_price": "4,825",
          "high_price": "10,450"
        },
        "1.3": {
          "rap": "8,500",
          "low_price": "5,225",
          "high_price": "11,325"
        },
        "1.4": {
          "rap": "8,500",
          "low_price": "5,630",
          "high_price": "12,195"
        },
        "1.5": {
          "rap": "13,600",
          "low_price": "10,440",
          "high_price": "22,620"
        },
        "1.6": {
          "rap": "13,600",
          "low_price": "11,135",
          "high_price": "24,130"
        },
        "1.7": {
          "rap": "13,600",
          "low_price": "11,830",
          "high_price": "25,635"
        },
        "1.8": {
          "rap": "13,600",
          "low_price": "12,530",
          "high_price": "27,145"
        },
        "1.9": {
          "rap": "13,600",
          "low_price": "13,225",
          "high_price": "28,650"
        },
        "2.0": {
          "rap": "19,000",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.1": {
          "rap": "19,000",
          "low_price": "22,050",
          "high_price": "47,775"
        },
        "2.2": {
          "rap": "19,000",
          "low_price": "23,100",
          "high_price": "50,050"
        },
        "2.3": {
          "rap": "19,000",
          "low_price": "24,150",
          "high_price": "52,325"
        },
        "2.4": {
          "rap": "19,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.5": {
          "rap": "19,000",
          "low_price": "26,250",
          "high_price": "56,875"
        },
        "2.6": {
          "rap": "19,000",
          "low_price": "27,300",
          "high_price": "59,150"
        },
        "2.7": {
          "rap": "19,000",
          "low_price": "28,350",
          "high_price": "61,425"
        },
        "2.8": {
          "rap": "19,000",
          "low_price": "29,400",
          "high_price": "63,700"
        },
        "2.9": {
          "rap": "19,000",
          "low_price": "30,450",
          "high_price": "65,975"
        },
        "3.0": {
          "rap": "30,500",
          "low_price": "54,000",
          "high_price": "117,000"
        },
        "3.1": {
          "rap": "30,500",
          "low_price": "55,800",
          "high_price": "120,900"
        },
        "3.2": {
          "rap": "30,500",
          "low_price": "57,600",
          "high_price": "124,800"
        },
        "3.3": {
          "rap": "30,500",
          "low_price": "59,400",
          "high_price": "128,700"
        },
        "3.4": {
          "rap": "30,500",
          "low_price": "61,200",
          "high_price": "132,600"
        },
        "3.5": {
          "rap": "30,500",
          "low_price": "63,000",
          "high_price": "136,500"
        },
        "3.6": {
          "rap": "30,500",
          "low_price": "64,800",
          "high_price": "140,400"
        },
        "3.7": {
          "rap": "30,500",
          "low_price": "66,600",
          "high_price": "144,300"
        },
        "3.8": {
          "rap": "30,500",
          "low_price": "68,400",
          "high_price": "148,200"
        },
        "3.9": {
          "rap": "30,500",
          "low_price": "70,200",
          "high_price": "152,100"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,400",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "750",
          "high_price": "1,625"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.7": {
          "rap": "4,800",
          "low_price": "1,470",
          "high_price": "3,185"
        },
        "0.8": {
          "rap": "4,800",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.9": {
          "rap": "6,000",
          "low_price": "2,645",
          "high_price": "5,735"
        },
        "1.0": {
          "rap": "8,000",
          "low_price": "3,720",
          "high_price": "8,060"
        },
        "1.1": {
          "rap": "8,000",
          "low_price": "4,090",
          "high_price": "8,865"
        },
        "1.2": {
          "rap": "8,000",
          "low_price": "4,465",
          "high_price": "9,670"
        },
        "1.3": {
          "rap": "8,000",
          "low_price": "4,835",
          "high_price": "10,480"
        },
        "1.4": {
          "rap": "8,000",
          "low_price": "5,210",
          "high_price": "11,285"
        },
        "1.5": {
          "rap": "12,800",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "1.6": {
          "rap": "12,800",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "1.7": {
          "rap": "12,800",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "1.8": {
          "rap": "12,800",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "1.9": {
          "rap": "12,800",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "2.0": {
          "rap": "18,000",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "18,000",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "18,000",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "18,000",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "18,000",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "18,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "18,000",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "18,000",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "18,000",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "18,000",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "28,000",
          "low_price": "49,500",
          "high_price": "107,250"
        },
        "3.1": {
          "rap": "28,000",
          "low_price": "51,150",
          "high_price": "110,825"
        },
        "3.2": {
          "rap": "28,000",
          "low_price": "52,800",
          "high_price": "114,400"
        },
        "3.3": {
          "rap": "28,000",
          "low_price": "54,450",
          "high_price": "117,975"
        },
        "3.4": {
          "rap": "28,000",
          "low_price": "56,100",
          "high_price": "121,550"
        },
        "3.5": {
          "rap": "28,000",
          "low_price": "57,750",
          "high_price": "125,125"
        },
        "3.6": {
          "rap": "28,000",
          "low_price": "59,400",
          "high_price": "128,700"
        },
        "3.7": {
          "rap": "28,000",
          "low_price": "61,050",
          "high_price": "132,275"
        },
        "3.8": {
          "rap": "28,000",
          "low_price": "62,700",
          "high_price": "135,850"
        },
        "3.9": {
          "rap": "28,000",
          "low_price": "64,350",
          "high_price": "139,425"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,300",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,900",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "2,900",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "4,600",
          "low_price": "1,385",
          "high_price": "3,005"
        },
        "0.8": {
          "rap": "4,600",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "0.9": {
          "rap": "5,700",
          "low_price": "2,485",
          "high_price": "5,380"
        },
        "1.0": {
          "rap": "7,500",
          "low_price": "3,480",
          "high_price": "7,540"
        },
        "1.1": {
          "rap": "7,500",
          "low_price": "3,830",
          "high_price": "8,295"
        },
        "1.2": {
          "rap": "7,500",
          "low_price": "4,175",
          "high_price": "9,050"
        },
        "1.3": {
          "rap": "7,500",
          "low_price": "4,525",
          "high_price": "9,800"
        },
        "1.4": {
          "rap": "7,500",
          "low_price": "4,870",
          "high_price": "10,555"
        },
        "1.5": {
          "rap": "12,200",
          "low_price": "9,180",
          "high_price": "19,890"
        },
        "1.6": {
          "rap": "12,200",
          "low_price": "9,790",
          "high_price": "21,215"
        },
        "1.7": {
          "rap": "12,200",
          "low_price": "10,405",
          "high_price": "22,540"
        },
        "1.8": {
          "rap": "12,200",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "1.9": {
          "rap": "12,200",
          "low_price": "11,630",
          "high_price": "25,195"
        },
        "2.0": {
          "rap": "17,000",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.1": {
          "rap": "17,000",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "2.2": {
          "rap": "17,000",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.3": {
          "rap": "17,000",
          "low_price": "20,700",
          "high_price": "44,850"
        },
        "2.4": {
          "rap": "17,000",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "2.5": {
          "rap": "17,000",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "2.6": {
          "rap": "17,000",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.7": {
          "rap": "17,000",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "2.8": {
          "rap": "17,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.9": {
          "rap": "17,000",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.0": {
          "rap": "25,000",
          "low_price": "45,000",
          "high_price": "97,500"
        },
        "3.1": {
          "rap": "25,000",
          "low_price": "46,500",
          "high_price": "100,750"
        },
        "3.2": {
          "rap": "25,000",
          "low_price": "48,000",
          "high_price": "104,000"
        },
        "3.3": {
          "rap": "25,000",
          "low_price": "49,500",
          "high_price": "107,250"
        },
        "3.4": {
          "rap": "25,000",
          "low_price": "51,000",
          "high_price": "110,500"
        },
        "3.5": {
          "rap": "25,000",
          "low_price": "52,500",
          "high_price": "113,750"
        },
        "3.6": {
          "rap": "25,000",
          "low_price": "54,000",
          "high_price": "117,000"
        },
        "3.7": {
          "rap": "25,000",
          "low_price": "55,500",
          "high_price": "120,250"
        },
        "3.8": {
          "rap": "25,000",
          "low_price": "57,000",
          "high_price": "123,500"
        },
        "3.9": {
          "rap": "25,000",
          "low_price": "58,500",
          "high_price": "126,750"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,200",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "2,700",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,700",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,300",
          "low_price": "1,300",
          "high_price": "2,820"
        },
        "0.8": {
          "rap": "4,300",
          "low_price": "1,490",
          "high_price": "3,225"
        },
        "0.9": {
          "rap": "5,400",
          "low_price": "2,320",
          "high_price": "5,030"
        },
        "1.0": {
          "rap": "7,000",
          "low_price": "3,240",
          "high_price": "7,020"
        },
        "1.1": {
          "rap": "7,000",
          "low_price": "3,565",
          "high_price": "7,720"
        },
        "1.2": {
          "rap": "7,000",
          "low_price": "3,890",
          "high_price": "8,425"
        },
        "1.3": {
          "rap": "7,000",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.4": {
          "rap": "7,000",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.5": {
          "rap": "11,200",
          "low_price": "8,370",
          "high_price": "18,135"
        },
        "1.6": {
          "rap": "11,200",
          "low_price": "8,930",
          "high_price": "19,345"
        },
        "1.7": {
          "rap": "11,200",
          "low_price": "9,485",
          "high_price": "20,555"
        },
        "1.8": {
          "rap": "11,200",
          "low_price": "10,045",
          "high_price": "21,760"
        },
        "1.9": {
          "rap": "11,200",
          "low_price": "10,600",
          "high_price": "22,970"
        },
        "2.0": {
          "rap": "15,500",
          "low_price": "16,800",
          "high_price": "36,400"
        },
        "2.1": {
          "rap": "15,500",
          "low_price": "17,640",
          "high_price": "38,220"
        },
        "2.2": {
          "rap": "15,500",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "2.3": {
          "rap": "15,500",
          "low_price": "19,320",
          "high_price": "41,860"
        },
        "2.4": {
          "rap": "15,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.5": {
          "rap": "15,500",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.6": {
          "rap": "15,500",
          "low_price": "21,840",
          "high_price": "47,320"
        },
        "2.7": {
          "rap": "15,500",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.8": {
          "rap": "15,500",
          "low_price": "23,520",
          "high_price": "50,960"
        },
        "2.9": {
          "rap": "15,500",
          "low_price": "24,360",
          "high_price": "52,780"
        },
        "3.0": {
          "rap": "22,500",
          "low_price": "40,500",
          "high_price": "87,750"
        },
        "3.1": {
          "rap": "22,500",
          "low_price": "41,850",
          "high_price": "90,675"
        },
        "3.2": {
          "rap": "22,500",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.3": {
          "rap": "22,500",
          "low_price": "44,550",
          "high_price": "96,525"
        },
        "3.4": {
          "rap": "22,500",
          "low_price": "45,900",
          "high_price": "99,450"
        },
        "3.5": {
          "rap": "22,500",
          "low_price": "47,250",
          "high_price": "102,375"
        },
        "3.6": {
          "rap": "22,500",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.7": {
          "rap": "22,500",
          "low_price": "49,950",
          "high_price": "108,225"
        },
        "3.8": {
          "rap": "22,500",
          "low_price": "51,300",
          "high_price": "111,150"
        },
        "3.9": {
          "rap": "22,500",
          "low_price": "52,650",
          "high_price": "114,075"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,000",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "2,500",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "2,500",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "3,900",
          "low_price": "1,175",
          "high_price": "2,550"
        },
        "0.8": {
          "rap": "3,900",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.9": {
          "rap": "4,900",
          "low_price": "2,105",
          "high_price": "4,565"
        },
        "1.0": {
          "rap": "6,000",
          "low_price": "2,760",
          "high_price": "5,980"
        },
        "1.1": {
          "rap": "6,000",
          "low_price": "3,035",
          "high_price": "6,580"
        },
        "1.2": {
          "rap": "6,000",
          "low_price": "3,310",
          "high_price": "7,175"
        },
        "1.3": {
          "rap": "6,000",
          "low_price": "3,590",
          "high_price": "7,775"
        },
        "1.4": {
          "rap": "6,000",
          "low_price": "3,865",
          "high_price": "8,370"
        },
        "1.5": {
          "rap": "9,500",
          "low_price": "7,110",
          "high_price": "15,405"
        },
        "1.6": {
          "rap": "9,500",
          "low_price": "7,585",
          "high_price": "16,430"
        },
        "1.7": {
          "rap": "9,500",
          "low_price": "8,060",
          "high_price": "17,460"
        },
        "1.8": {
          "rap": "9,500",
          "low_price": "8,530",
          "high_price": "18,485"
        },
        "1.9": {
          "rap": "9,500",
          "low_price": "9,005",
          "high_price": "19,515"
        },
        "2.0": {
          "rap": "13,000",
          "low_price": "13,800",
          "high_price": "29,900"
        },
        "2.1": {
          "rap": "13,000",
          "low_price": "14,490",
          "high_price": "31,395"
        },
        "2.2": {
          "rap": "13,000",
          "low_price": "15,180",
          "high_price": "32,890"
        },
        "2.3": {
          "rap": "13,000",
          "low_price": "15,870",
          "high_price": "34,385"
        },
        "2.4": {
          "rap": "13,000",
          "low_price": "16,560",
          "high_price": "35,880"
        },
        "2.5": {
          "rap": "13,000",
          "low_price": "17,250",
          "high_price": "37,375"
        },
        "2.6": {
          "rap": "13,000",
          "low_price": "17,940",
          "high_price": "38,870"
        },
        "2.7": {
          "rap": "13,000",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.8": {
          "rap": "13,000",
          "low_price": "19,320",
          "high_price": "41,860"
        },
        "2.9": {
          "rap": "13,000",
          "low_price": "20,010",
          "high_price": "43,355"
        },
        "3.0": {
          "rap": "20,000",
          "low_price": "35,100",
          "high_price": "76,050"
        },
        "3.1": {
          "rap": "20,000",
          "low_price": "36,270",
          "high_price": "78,585"
        },
        "3.2": {
          "rap": "20,000",
          "low_price": "37,440",
          "high_price": "81,120"
        },
        "3.3": {
          "rap": "20,000",
          "low_price": "38,610",
          "high_price": "83,655"
        },
        "3.4": {
          "rap": "20,000",
          "low_price": "39,780",
          "high_price": "86,190"
        },
        "3.5": {
          "rap": "20,000",
          "low_price": "40,950",
          "high_price": "88,725"
        },
        "3.6": {
          "rap": "20,000",
          "low_price": "42,120",
          "high_price": "91,260"
        },
        "3.7": {
          "rap": "20,000",
          "low_price": "43,290",
          "high_price": "93,795"
        },
        "3.8": {
          "rap": "20,000",
          "low_price": "44,460",
          "high_price": "96,330"
        },
        "3.9": {
          "rap": "20,000",
          "low_price": "45,630",
          "high_price": "98,865"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,800",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "2,300",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "2,300",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,200",
          "low_price": "1,050",
          "high_price": "2,275"
        },
        "0.8": {
          "rap": "3,200",
          "low_price": "1,200",
          "high_price": "2,600"
        },
        "0.9": {
          "rap": "4,200",
          "low_price": "1,835",
          "high_price": "3,980"
        },
        "1.0": {
          "rap": "5,200",
          "low_price": "2,340",
          "high_price": "5,070"
        },
        "1.1": {
          "rap": "5,200",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.2": {
          "rap": "5,200",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.3": {
          "rap": "5,200",
          "low_price": "3,040",
          "high_price": "6,590"
        },
        "1.4": {
          "rap": "5,200",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.5": {
          "rap": "7,900",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "1.6": {
          "rap": "7,900",
          "low_price": "6,530",
          "high_price": "14,145"
        },
        "1.7": {
          "rap": "7,900",
          "low_price": "6,935",
          "high_price": "15,030"
        },
        "1.8": {
          "rap": "7,900",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "1.9": {
          "rap": "7,900",
          "low_price": "7,750",
          "high_price": "16,795"
        },
        "2.0": {
          "rap": "10,300",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "2.1": {
          "rap": "10,300",
          "low_price": "11,970",
          "high_price": "25,935"
        },
        "2.2": {
          "rap": "10,300",
          "low_price": "12,540",
          "high_price": "27,170"
        },
        "2.3": {
          "rap": "10,300",
          "low_price": "13,110",
          "high_price": "28,405"
        },
        "2.4": {
          "rap": "10,300",
          "low_price": "13,680",
          "high_price": "29,640"
        },
        "2.5": {
          "rap": "10,300",
          "low_price": "14,250",
          "high_price": "30,875"
        },
        "2.6": {
          "rap": "10,300",
          "low_price": "14,820",
          "high_price": "32,110"
        },
        "2.7": {
          "rap": "10,300",
          "low_price": "15,390",
          "high_price": "33,345"
        },
        "2.8": {
          "rap": "10,300",
          "low_price": "15,960",
          "high_price": "34,580"
        },
        "2.9": {
          "rap": "10,300",
          "low_price": "16,530",
          "high_price": "35,815"
        },
        "3.0": {
          "rap": "17,000",
          "low_price": "29,700",
          "high_price": "64,350"
        },
        "3.1": {
          "rap": "17,000",
          "low_price": "30,690",
          "high_price": "66,495"
        },
        "3.2": {
          "rap": "17,000",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "3.3": {
          "rap": "17,000",
          "low_price": "32,670",
          "high_price": "70,785"
        },
        "3.4": {
          "rap": "17,000",
          "low_price": "33,660",
          "high_price": "72,930"
        },
        "3.5": {
          "rap": "17,000",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "3.6": {
          "rap": "17,000",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "3.7": {
          "rap": "17,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.8": {
          "rap": "17,000",
          "low_price": "37,620",
          "high_price": "81,510"
        },
        "3.9": {
          "rap": "17,000",
          "low_price": "38,610",
          "high_price": "83,655"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,500",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,700",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "2,700",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "4,200",
          "low_price": "2,040",
          "high_price": "4,420"
        },
        "1.1": {
          "rap": "4,200",
          "low_price": "2,245",
          "high_price": "4,860"
        },
        "1.2": {
          "rap": "4,200",
          "low_price": "2,450",
          "high_price": "5,305"
        },
        "1.3": {
          "rap": "4,200",
          "low_price": "2,650",
          "high_price": "5,745"
        },
        "1.4": {
          "rap": "4,200",
          "low_price": "2,855",
          "high_price": "6,190"
        },
        "1.5": {
          "rap": "6,300",
          "low_price": "4,950",
          "high_price": "10,725"
        },
        "1.6": {
          "rap": "6,300",
          "low_price": "5,280",
          "high_price": "11,440"
        },
        "1.7": {
          "rap": "6,300",
          "low_price": "5,610",
          "high_price": "12,155"
        },
        "1.8": {
          "rap": "6,300",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "1.9": {
          "rap": "6,300",
          "low_price": "6,270",
          "high_price": "13,585"
        },
        "2.0": {
          "rap": "8,300",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.1": {
          "rap": "8,300",
          "low_price": "9,700",
          "high_price": "21,020"
        },
        "2.2": {
          "rap": "8,300",
          "low_price": "10,165",
          "high_price": "22,020"
        },
        "2.3": {
          "rap": "8,300",
          "low_price": "10,625",
          "high_price": "23,025"
        },
        "2.4": {
          "rap": "8,300",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.5": {
          "rap": "8,300",
          "low_price": "11,550",
          "high_price": "25,025"
        },
        "2.6": {
          "rap": "8,300",
          "low_price": "12,010",
          "high_price": "26,025"
        },
        "2.7": {
          "rap": "8,300",
          "low_price": "12,475",
          "high_price": "27,025"
        },
        "2.8": {
          "rap": "8,300",
          "low_price": "12,935",
          "high_price": "28,030"
        },
        "2.9": {
          "rap": "8,300",
          "low_price": "13,400",
          "high_price": "29,030"
        },
        "3.0": {
          "rap": "13,100",
          "low_price": "22,860",
          "high_price": "49,530"
        },
        "3.1": {
          "rap": "13,100",
          "low_price": "23,620",
          "high_price": "51,180"
        },
        "3.2": {
          "rap": "13,100",
          "low_price": "24,385",
          "high_price": "52,830"
        },
        "3.3": {
          "rap": "13,100",
          "low_price": "25,145",
          "high_price": "54,485"
        },
        "3.4": {
          "rap": "13,100",
          "low_price": "25,910",
          "high_price": "56,135"
        },
        "3.5": {
          "rap": "13,100",
          "low_price": "26,670",
          "high_price": "57,785"
        },
        "3.6": {
          "rap": "13,100",
          "low_price": "27,430",
          "high_price": "59,435"
        },
        "3.7": {
          "rap": "13,100",
          "low_price": "28,195",
          "high_price": "61,085"
        },
        "3.8": {
          "rap": "13,100",
          "low_price": "28,955",
          "high_price": "62,740"
        },
        "3.9": {
          "rap": "13,100",
          "low_price": "29,720",
          "high_price": "64,390"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,200",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,200",
          "low_price": "800",
          "high_price": "1,730"
        },
        "0.8": {
          "rap": "2,200",
          "low_price": "910",
          "high_price": "1,975"
        },
        "0.9": {
          "rap": "2,800",
          "low_price": "1,350",
          "high_price": "2,925"
        },
        "1.0": {
          "rap": "3,300",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "1.1": {
          "rap": "3,300",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.2": {
          "rap": "3,300",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.3": {
          "rap": "3,300",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.4": {
          "rap": "3,300",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "1.5": {
          "rap": "5,100",
          "low_price": "3,870",
          "high_price": "8,385"
        },
        "1.6": {
          "rap": "5,100",
          "low_price": "4,130",
          "high_price": "8,945"
        },
        "1.7": {
          "rap": "5,100",
          "low_price": "4,385",
          "high_price": "9,505"
        },
        "1.8": {
          "rap": "5,100",
          "low_price": "4,645",
          "high_price": "10,060"
        },
        "1.9": {
          "rap": "5,100",
          "low_price": "4,900",
          "high_price": "10,620"
        },
        "2.0": {
          "rap": "6,800",
          "low_price": "7,200",
          "high_price": "15,600"
        },
        "2.1": {
          "rap": "6,800",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.2": {
          "rap": "6,800",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.3": {
          "rap": "6,800",
          "low_price": "8,280",
          "high_price": "17,940"
        },
        "2.4": {
          "rap": "6,800",
          "low_price": "8,640",
          "high_price": "18,720"
        },
        "2.5": {
          "rap": "6,800",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "2.6": {
          "rap": "6,800",
          "low_price": "9,360",
          "high_price": "20,280"
        },
        "2.7": {
          "rap": "6,800",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "2.8": {
          "rap": "6,800",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.9": {
          "rap": "6,800",
          "low_price": "10,440",
          "high_price": "22,620"
        },
        "3.0": {
          "rap": "10,000",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "3.1": {
          "rap": "10,000",
          "low_price": "18,600",
          "high_price": "40,300"
        },
        "3.2": {
          "rap": "10,000",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "3.3": {
          "rap": "10,000",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "3.4": {
          "rap": "10,000",
          "low_price": "20,400",
          "high_price": "44,200"
        },
        "3.5": {
          "rap": "10,000",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "3.6": {
          "rap": "10,000",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "3.7": {
          "rap": "10,000",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "3.8": {
          "rap": "10,000",
          "low_price": "22,800",
          "high_price": "49,400"
        },
        "3.9": {
          "rap": "10,000",
          "low_price": "23,400",
          "high_price": "50,700"
        }
      }
    },
    "VS2": {
      "D": {
        "0.4": {
          "rap": "2,300",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "4,600",
          "low_price": "1,430",
          "high_price": "3,095"
        },
        "0.8": {
          "rap": "4,600",
          "low_price": "1,630",
          "high_price": "3,535"
        },
        "0.9": {
          "rap": "5,900",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.0": {
          "rap": "7,500",
          "low_price": "3,420",
          "high_price": "7,410"
        },
        "1.1": {
          "rap": "7,500",
          "low_price": "3,760",
          "high_price": "8,150"
        },
        "1.2": {
          "rap": "7,500",
          "low_price": "4,105",
          "high_price": "8,890"
        },
        "1.3": {
          "rap": "7,500",
          "low_price": "4,445",
          "high_price": "9,635"
        },
        "1.4": {
          "rap": "7,500",
          "low_price": "4,790",
          "high_price": "10,375"
        },
        "1.5": {
          "rap": "12,400",
          "low_price": "8,910",
          "high_price": "19,305"
        },
        "1.6": {
          "rap": "12,400",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "1.7": {
          "rap": "12,400",
          "low_price": "10,100",
          "high_price": "21,880"
        },
        "1.8": {
          "rap": "12,400",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "1.9": {
          "rap": "12,400",
          "low_price": "11,285",
          "high_price": "24,455"
        },
        "2.0": {
          "rap": "17,500",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "17,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "17,500",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "17,500",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "17,500",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "17,500",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "17,500",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "17,500",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "17,500",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "17,500",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "27,000",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.1": {
          "rap": "27,000",
          "low_price": "50,220",
          "high_price": "108,810"
        },
        "3.2": {
          "rap": "27,000",
          "low_price": "51,840",
          "high_price": "112,320"
        },
        "3.3": {
          "rap": "27,000",
          "low_price": "53,460",
          "high_price": "115,830"
        },
        "3.4": {
          "rap": "27,000",
          "low_price": "55,080",
          "high_price": "119,340"
        },
        "3.5": {
          "rap": "27,000",
          "low_price": "56,700",
          "high_price": "122,850"
        },
        "3.6": {
          "rap": "27,000",
          "low_price": "58,320",
          "high_price": "126,360"
        },
        "3.7": {
          "rap": "27,000",
          "low_price": "59,940",
          "high_price": "129,870"
        },
        "3.8": {
          "rap": "27,000",
          "low_price": "61,560",
          "high_price": "133,380"
        },
        "3.9": {
          "rap": "27,000",
          "low_price": "63,180",
          "high_price": "136,890"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,200",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,800",
          "low_price": "690",
          "high_price": "1,495"
        },
        "0.6": {
          "rap": "2,800",
          "low_price": "830",
          "high_price": "1,795"
        },
        "0.7": {
          "rap": "4,400",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.8": {
          "rap": "4,400",
          "low_price": "1,535",
          "high_price": "3,330"
        },
        "0.9": {
          "rap": "5,600",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.0": {
          "rap": "7,200",
          "low_price": "3,240",
          "high_price": "7,020"
        },
        "1.1": {
          "rap": "7,200",
          "low_price": "3,565",
          "high_price": "7,720"
        },
        "1.2": {
          "rap": "7,200",
          "low_price": "3,890",
          "high_price": "8,425"
        },
        "1.3": {
          "rap": "7,200",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.4": {
          "rap": "7,200",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.5": {
          "rap": "11,800",
          "low_price": "8,370",
          "high_price": "18,135"
        },
        "1.6": {
          "rap": "11,800",
          "low_price": "8,930",
          "high_price": "19,345"
        },
        "1.7": {
          "rap": "11,800",
          "low_price": "9,485",
          "high_price": "20,555"
        },
        "1.8": {
          "rap": "11,800",
          "low_price": "10,045",
          "high_price": "21,760"
        },
        "1.9": {
          "rap": "11,800",
          "low_price": "10,600",
          "high_price": "22,970"
        },
        "2.0": {
          "rap": "16,500",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.1": {
          "rap": "16,500",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "2.2": {
          "rap": "16,500",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.3": {
          "rap": "16,500",
          "low_price": "20,700",
          "high_price": "44,850"
        },
        "2.4": {
          "rap": "16,500",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "2.5": {
          "rap": "16,500",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "2.6": {
          "rap": "16,500",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.7": {
          "rap": "16,500",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "2.8": {
          "rap": "16,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.9": {
          "rap": "16,500",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.0": {
          "rap": "24,500",
          "low_price": "45,000",
          "high_price": "97,500"
        },
        "3.1": {
          "rap": "24,500",
          "low_price": "46,500",
          "high_price": "100,750"
        },
        "3.2": {
          "rap": "24,500",
          "low_price": "48,000",
          "high_price": "104,000"
        },
        "3.3": {
          "rap": "24,500",
          "low_price": "49,500",
          "high_price": "107,250"
        },
        "3.4": {
          "rap": "24,500",
          "low_price": "51,000",
          "high_price": "110,500"
        },
        "3.5": {
          "rap": "24,500",
          "low_price": "52,500",
          "high_price": "113,750"
        },
        "3.6": {
          "rap": "24,500",
          "low_price": "54,000",
          "high_price": "117,000"
        },
        "3.7": {
          "rap": "24,500",
          "low_price": "55,500",
          "high_price": "120,250"
        },
        "3.8": {
          "rap": "24,500",
          "low_price": "57,000",
          "high_price": "123,500"
        },
        "3.9": {
          "rap": "24,500",
          "low_price": "58,500",
          "high_price": "126,750"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,100",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "2,700",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,700",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,200",
          "low_price": "1,260",
          "high_price": "2,730"
        },
        "0.8": {
          "rap": "4,200",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "0.9": {
          "rap": "5,400",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.0": {
          "rap": "6,900",
          "low_price": "3,060",
          "high_price": "6,630"
        },
        "1.1": {
          "rap": "6,900",
          "low_price": "3,365",
          "high_price": "7,295"
        },
        "1.2": {
          "rap": "6,900",
          "low_price": "3,670",
          "high_price": "7,955"
        },
        "1.3": {
          "rap": "6,900",
          "low_price": "3,980",
          "high_price": "8,620"
        },
        "1.4": {
          "rap": "6,900",
          "low_price": "4,285",
          "high_price": "9,280"
        },
        "1.5": {
          "rap": "11,200",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "1.6": {
          "rap": "11,200",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "1.7": {
          "rap": "11,200",
          "low_price": "8,975",
          "high_price": "19,450"
        },
        "1.8": {
          "rap": "11,200",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "1.9": {
          "rap": "11,200",
          "low_price": "10,030",
          "high_price": "21,735"
        },
        "2.0": {
          "rap": "15,500",
          "low_price": "16,800",
          "high_price": "36,400"
        },
        "2.1": {
          "rap": "15,500",
          "low_price": "17,640",
          "high_price": "38,220"
        },
        "2.2": {
          "rap": "15,500",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "2.3": {
          "rap": "15,500",
          "low_price": "19,320",
          "high_price": "41,860"
        },
        "2.4": {
          "rap": "15,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.5": {
          "rap": "15,500",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.6": {
          "rap": "15,500",
          "low_price": "21,840",
          "high_price": "47,320"
        },
        "2.7": {
          "rap": "15,500",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.8": {
          "rap": "15,500",
          "low_price": "23,520",
          "high_price": "50,960"
        },
        "2.9": {
          "rap": "15,500",
          "low_price": "24,360",
          "high_price": "52,780"
        },
        "3.0": {
          "rap": "22,500",
          "low_price": "41,400",
          "high_price": "89,700"
        },
        "3.1": {
          "rap": "22,500",
          "low_price": "42,780",
          "high_price": "92,690"
        },
        "3.2": {
          "rap": "22,500",
          "low_price": "44,160",
          "high_price": "95,680"
        },
        "3.3": {
          "rap": "22,500",
          "low_price": "45,540",
          "high_price": "98,670"
        },
        "3.4": {
          "rap": "22,500",
          "low_price": "46,920",
          "high_price": "101,660"
        },
        "3.5": {
          "rap": "22,500",
          "low_price": "48,300",
          "high_price": "104,650"
        },
        "3.6": {
          "rap": "22,500",
          "low_price": "49,680",
          "high_price": "107,640"
        },
        "3.7": {
          "rap": "22,500",
          "low_price": "51,060",
          "high_price": "110,630"
        },
        "3.8": {
          "rap": "22,500",
          "low_price": "52,440",
          "high_price": "113,620"
        },
        "3.9": {
          "rap": "22,500",
          "low_price": "53,820",
          "high_price": "116,610"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,000",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "2,600",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.6": {
          "rap": "2,600",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.7": {
          "rap": "3,900",
          "low_price": "1,175",
          "high_price": "2,550"
        },
        "0.8": {
          "rap": "3,900",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.9": {
          "rap": "5,100",
          "low_price": "2,050",
          "high_price": "4,445"
        },
        "1.0": {
          "rap": "6,600",
          "low_price": "2,880",
          "high_price": "6,240"
        },
        "1.1": {
          "rap": "6,600",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.2": {
          "rap": "6,600",
          "low_price": "3,455",
          "high_price": "7,490"
        },
        "1.3": {
          "rap": "6,600",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.4": {
          "rap": "6,600",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.5": {
          "rap": "10,400",
          "low_price": "7,380",
          "high_price": "15,990"
        },
        "1.6": {
          "rap": "10,400",
          "low_price": "7,870",
          "high_price": "17,055"
        },
        "1.7": {
          "rap": "10,400",
          "low_price": "8,365",
          "high_price": "18,120"
        },
        "1.8": {
          "rap": "10,400",
          "low_price": "8,855",
          "high_price": "19,190"
        },
        "1.9": {
          "rap": "10,400",
          "low_price": "9,350",
          "high_price": "20,255"
        },
        "2.0": {
          "rap": "14,500",
          "low_price": "15,600",
          "high_price": "33,800"
        },
        "2.1": {
          "rap": "14,500",
          "low_price": "16,380",
          "high_price": "35,490"
        },
        "2.2": {
          "rap": "14,500",
          "low_price": "17,160",
          "high_price": "37,180"
        },
        "2.3": {
          "rap": "14,500",
          "low_price": "17,940",
          "high_price": "38,870"
        },
        "2.4": {
          "rap": "14,500",
          "low_price": "18,720",
          "high_price": "40,560"
        },
        "2.5": {
          "rap": "14,500",
          "low_price": "19,500",
          "high_price": "42,250"
        },
        "2.6": {
          "rap": "14,500",
          "low_price": "20,280",
          "high_price": "43,940"
        },
        "2.7": {
          "rap": "14,500",
          "low_price": "21,060",
          "high_price": "45,630"
        },
        "2.8": {
          "rap": "14,500",
          "low_price": "21,840",
          "high_price": "47,320"
        },
        "2.9": {
          "rap": "14,500",
          "low_price": "22,620",
          "high_price": "49,010"
        },
        "3.0": {
          "rap": "20,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.1": {
          "rap": "20,500",
          "low_price": "39,060",
          "high_price": "84,630"
        },
        "3.2": {
          "rap": "20,500",
          "low_price": "40,320",
          "high_price": "87,360"
        },
        "3.3": {
          "rap": "20,500",
          "low_price": "41,580",
          "high_price": "90,090"
        },
        "3.4": {
          "rap": "20,500",
          "low_price": "42,840",
          "high_price": "92,820"
        },
        "3.5": {
          "rap": "20,500",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.6": {
          "rap": "20,500",
          "low_price": "45,360",
          "high_price": "98,280"
        },
        "3.7": {
          "rap": "20,500",
          "low_price": "46,620",
          "high_price": "101,010"
        },
        "3.8": {
          "rap": "20,500",
          "low_price": "47,880",
          "high_price": "103,740"
        },
        "3.9": {
          "rap": "20,500",
          "low_price": "49,140",
          "high_price": "106,470"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,800",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,400",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,400",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,500",
          "low_price": "1,050",
          "high_price": "2,275"
        },
        "0.8": {
          "rap": "3,500",
          "low_price": "1,200",
          "high_price": "2,600"
        },
        "0.9": {
          "rap": "4,600",
          "low_price": "1,890",
          "high_price": "4,095"
        },
        "1.0": {
          "rap": "5,700",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.1": {
          "rap": "5,700",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.2": {
          "rap": "5,700",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.3": {
          "rap": "5,700",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.4": {
          "rap": "5,700",
          "low_price": "3,530",
          "high_price": "7,645"
        },
        "1.5": {
          "rap": "9,100",
          "low_price": "6,390",
          "high_price": "13,845"
        },
        "1.6": {
          "rap": "9,100",
          "low_price": "6,815",
          "high_price": "14,770"
        },
        "1.7": {
          "rap": "9,100",
          "low_price": "7,240",
          "high_price": "15,690"
        },
        "1.8": {
          "rap": "9,100",
          "low_price": "7,670",
          "high_price": "16,615"
        },
        "1.9": {
          "rap": "9,100",
          "low_price": "8,095",
          "high_price": "17,535"
        },
        "2.0": {
          "rap": "12,000",
          "low_price": "13,200",
          "high_price": "28,600"
        },
        "2.1": {
          "rap": "12,000",
          "low_price": "13,860",
          "high_price": "30,030"
        },
        "2.2": {
          "rap": "12,000",
          "low_price": "14,520",
          "high_price": "31,460"
        },
        "2.3": {
          "rap": "12,000",
          "low_price": "15,180",
          "high_price": "32,890"
        },
        "2.4": {
          "rap": "12,000",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "2.5": {
          "rap": "12,000",
          "low_price": "16,500",
          "high_price": "35,750"
        },
        "2.6": {
          "rap": "12,000",
          "low_price": "17,160",
          "high_price": "37,180"
        },
        "2.7": {
          "rap": "12,000",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.8": {
          "rap": "12,000",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "2.9": {
          "rap": "12,000",
          "low_price": "19,140",
          "high_price": "41,470"
        },
        "3.0": {
          "rap": "18,000",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.1": {
          "rap": "18,000",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.2": {
          "rap": "18,000",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.3": {
          "rap": "18,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.4": {
          "rap": "18,000",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.5": {
          "rap": "18,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.6": {
          "rap": "18,000",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.7": {
          "rap": "18,000",
          "low_price": "41,070",
          "high_price": "88,985"
        },
        "3.8": {
          "rap": "18,000",
          "low_price": "42,180",
          "high_price": "91,390"
        },
        "3.9": {
          "rap": "18,000",
          "low_price": "43,290",
          "high_price": "93,795"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,600",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,200",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "2,200",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "3,900",
          "low_price": "1,675",
          "high_price": "3,625"
        },
        "1.0": {
          "rap": "4,900",
          "low_price": "2,220",
          "high_price": "4,810"
        },
        "1.1": {
          "rap": "4,900",
          "low_price": "2,440",
          "high_price": "5,290"
        },
        "1.2": {
          "rap": "4,900",
          "low_price": "2,665",
          "high_price": "5,770"
        },
        "1.3": {
          "rap": "4,900",
          "low_price": "2,885",
          "high_price": "6,255"
        },
        "1.4": {
          "rap": "4,900",
          "low_price": "3,110",
          "high_price": "6,735"
        },
        "1.5": {
          "rap": "7,600",
          "low_price": "5,670",
          "high_price": "12,285"
        },
        "1.6": {
          "rap": "7,600",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.7": {
          "rap": "7,600",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "1.8": {
          "rap": "7,600",
          "low_price": "6,805",
          "high_price": "14,740"
        },
        "1.9": {
          "rap": "7,600",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.0": {
          "rap": "9,700",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "2.1": {
          "rap": "9,700",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.2": {
          "rap": "9,700",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "2.3": {
          "rap": "9,700",
          "low_price": "12,420",
          "high_price": "26,910"
        },
        "2.4": {
          "rap": "9,700",
          "low_price": "12,960",
          "high_price": "28,080"
        },
        "2.5": {
          "rap": "9,700",
          "low_price": "13,500",
          "high_price": "29,250"
        },
        "2.6": {
          "rap": "9,700",
          "low_price": "14,040",
          "high_price": "30,420"
        },
        "2.7": {
          "rap": "9,700",
          "low_price": "14,580",
          "high_price": "31,590"
        },
        "2.8": {
          "rap": "9,700",
          "low_price": "15,120",
          "high_price": "32,760"
        },
        "2.9": {
          "rap": "9,700",
          "low_price": "15,660",
          "high_price": "33,930"
        },
        "3.0": {
          "rap": "15,500",
          "low_price": "27,900",
          "high_price": "60,450"
        },
        "3.1": {
          "rap": "15,500",
          "low_price": "28,830",
          "high_price": "62,465"
        },
        "3.2": {
          "rap": "15,500",
          "low_price": "29,760",
          "high_price": "64,480"
        },
        "3.3": {
          "rap": "15,500",
          "low_price": "30,690",
          "high_price": "66,495"
        },
        "3.4": {
          "rap": "15,500",
          "low_price": "31,620",
          "high_price": "68,510"
        },
        "3.5": {
          "rap": "15,500",
          "low_price": "32,550",
          "high_price": "70,525"
        },
        "3.6": {
          "rap": "15,500",
          "low_price": "33,480",
          "high_price": "72,540"
        },
        "3.7": {
          "rap": "15,500",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.8": {
          "rap": "15,500",
          "low_price": "35,340",
          "high_price": "76,570"
        },
        "3.9": {
          "rap": "15,500",
          "low_price": "36,270",
          "high_price": "78,585"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,500",
          "low_price": "800",
          "high_price": "1,730"
        },
        "0.8": {
          "rap": "2,500",
          "low_price": "910",
          "high_price": "1,975"
        },
        "0.9": {
          "rap": "3,300",
          "low_price": "1,460",
          "high_price": "3,160"
        },
        "1.0": {
          "rap": "4,000",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "1.1": {
          "rap": "4,000",
          "low_price": "2,110",
          "high_price": "4,575"
        },
        "1.2": {
          "rap": "4,000",
          "low_price": "2,305",
          "high_price": "4,990"
        },
        "1.3": {
          "rap": "4,000",
          "low_price": "2,495",
          "high_price": "5,410"
        },
        "1.4": {
          "rap": "4,000",
          "low_price": "2,690",
          "high_price": "5,825"
        },
        "1.5": {
          "rap": "6,100",
          "low_price": "4,680",
          "high_price": "10,140"
        },
        "1.6": {
          "rap": "6,100",
          "low_price": "4,990",
          "high_price": "10,815"
        },
        "1.7": {
          "rap": "6,100",
          "low_price": "5,305",
          "high_price": "11,490"
        },
        "1.8": {
          "rap": "6,100",
          "low_price": "5,615",
          "high_price": "12,170"
        },
        "1.9": {
          "rap": "6,100",
          "low_price": "5,930",
          "high_price": "12,845"
        },
        "2.0": {
          "rap": "8,000",
          "low_price": "8,880",
          "high_price": "19,240"
        },
        "2.1": {
          "rap": "8,000",
          "low_price": "9,325",
          "high_price": "20,200"
        },
        "2.2": {
          "rap": "8,000",
          "low_price": "9,770",
          "high_price": "21,165"
        },
        "2.3": {
          "rap": "8,000",
          "low_price": "10,210",
          "high_price": "22,125"
        },
        "2.4": {
          "rap": "8,000",
          "low_price": "10,655",
          "high_price": "23,090"
        },
        "2.5": {
          "rap": "8,000",
          "low_price": "11,100",
          "high_price": "24,050"
        },
        "2.6": {
          "rap": "8,000",
          "low_price": "11,545",
          "high_price": "25,010"
        },
        "2.7": {
          "rap": "8,000",
          "low_price": "11,990",
          "high_price": "25,975"
        },
        "2.8": {
          "rap": "8,000",
          "low_price": "12,430",
          "high_price": "26,935"
        },
        "2.9": {
          "rap": "8,000",
          "low_price": "12,875",
          "high_price": "27,900"
        },
        "3.0": {
          "rap": "12,100",
          "low_price": "21,780",
          "high_price": "47,190"
        },
        "3.1": {
          "rap": "12,100",
          "low_price": "22,505",
          "high_price": "48,765"
        },
        "3.2": {
          "rap": "12,100",
          "low_price": "23,230",
          "high_price": "50,335"
        },
        "3.3": {
          "rap": "12,100",
          "low_price": "23,960",
          "high_price": "51,910"
        },
        "3.4": {
          "rap": "12,100",
          "low_price": "24,685",
          "high_price": "53,480"
        },
        "3.5": {
          "rap": "12,100",
          "low_price": "25,410",
          "high_price": "55,055"
        },
        "3.6": {
          "rap": "12,100",
          "low_price": "26,135",
          "high_price": "56,630"
        },
        "3.7": {
          "rap": "12,100",
          "low_price": "26,860",
          "high_price": "58,200"
        },
        "3.8": {
          "rap": "12,100",
          "low_price": "27,590",
          "high_price": "59,775"
        },
        "3.9": {
          "rap": "12,100",
          "low_price": "28,315",
          "high_price": "61,345"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,100",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,500",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "1,500",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "2,700",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "3,200",
          "low_price": "1,560",
          "high_price": "3,380"
        },
        "1.1": {
          "rap": "3,200",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.2": {
          "rap": "3,200",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.3": {
          "rap": "3,200",
          "low_price": "2,030",
          "high_price": "4,395"
        },
        "1.4": {
          "rap": "3,200",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.5": {
          "rap": "4,900",
          "low_price": "3,690",
          "high_price": "7,995"
        },
        "1.6": {
          "rap": "4,900",
          "low_price": "3,935",
          "high_price": "8,530"
        },
        "1.7": {
          "rap": "4,900",
          "low_price": "4,180",
          "high_price": "9,060"
        },
        "1.8": {
          "rap": "4,900",
          "low_price": "4,430",
          "high_price": "9,595"
        },
        "1.9": {
          "rap": "4,900",
          "low_price": "4,675",
          "high_price": "10,125"
        },
        "2.0": {
          "rap": "6,600",
          "low_price": "6,960",
          "high_price": "15,080"
        },
        "2.1": {
          "rap": "6,600",
          "low_price": "7,310",
          "high_price": "15,835"
        },
        "2.2": {
          "rap": "6,600",
          "low_price": "7,655",
          "high_price": "16,590"
        },
        "2.3": {
          "rap": "6,600",
          "low_price": "8,005",
          "high_price": "17,340"
        },
        "2.4": {
          "rap": "6,600",
          "low_price": "8,350",
          "high_price": "18,095"
        },
        "2.5": {
          "rap": "6,600",
          "low_price": "8,700",
          "high_price": "18,850"
        },
        "2.6": {
          "rap": "6,600",
          "low_price": "9,050",
          "high_price": "19,605"
        },
        "2.7": {
          "rap": "6,600",
          "low_price": "9,395",
          "high_price": "20,360"
        },
        "2.8": {
          "rap": "6,600",
          "low_price": "9,745",
          "high_price": "21,110"
        },
        "2.9": {
          "rap": "6,600",
          "low_price": "10,090",
          "high_price": "21,865"
        },
        "3.0": {
          "rap": "9,400",
          "low_price": "16,920",
          "high_price": "36,660"
        },
        "3.1": {
          "rap": "9,400",
          "low_price": "17,485",
          "high_price": "37,880"
        },
        "3.2": {
          "rap": "9,400",
          "low_price": "18,050",
          "high_price": "39,105"
        },
        "3.3": {
          "rap": "9,400",
          "low_price": "18,610",
          "high_price": "40,325"
        },
        "3.4": {
          "rap": "9,400",
          "low_price": "19,175",
          "high_price": "41,550"
        },
        "3.5": {
          "rap": "9,400",
          "low_price": "19,740",
          "high_price": "42,770"
        },
        "3.6": {
          "rap": "9,400",
          "low_price": "20,305",
          "high_price": "43,990"
        },
        "3.7": {
          "rap": "9,400",
          "low_price": "20,870",
          "high_price": "45,215"
        },
        "3.8": {
          "rap": "9,400",
          "low_price": "21,430",
          "high_price": "46,435"
        },
        "3.9": {
          "rap": "9,400",
          "low_price": "21,995",
          "high_price": "47,660"
        }
      }
    },
    "VVS1": {
      "D": {
        "0.4": {
          "rap": "3,000",
          "low_price": "625",
          "high_price": "1,350"
        },
        "0.5": {
          "rap": "3,600",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.6": {
          "rap": "3,600",
          "low_price": "1,080",
          "high_price": "2,340"
        },
        "0.7": {
          "rap": "5,600",
          "low_price": "1,805",
          "high_price": "3,915"
        },
        "0.8": {
          "rap": "5,600",
          "low_price": "2,065",
          "high_price": "4,470"
        },
        "0.9": {
          "rap": "7,800",
          "low_price": "3,400",
          "high_price": "7,370"
        },
        "1.0": {
          "rap": "10,400",
          "low_price": "4,920",
          "high_price": "10,660"
        },
        "1.1": {
          "rap": "10,400",
          "low_price": "5,410",
          "high_price": "11,725"
        },
        "1.2": {
          "rap": "10,400",
          "low_price": "5,905",
          "high_price": "12,790"
        },
        "1.3": {
          "rap": "10,400",
          "low_price": "6,395",
          "high_price": "13,860"
        },
        "1.4": {
          "rap": "10,400",
          "low_price": "6,890",
          "high_price": "14,925"
        },
        "1.5": {
          "rap": "16,400",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "1.6": {
          "rap": "16,400",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "1.7": {
          "rap": "16,400",
          "low_price": "13,465",
          "high_price": "29,170"
        },
        "1.8": {
          "rap": "16,400",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "1.9": {
          "rap": "16,400",
          "low_price": "15,050",
          "high_price": "32,605"
        },
        "2.0": {
          "rap": "23,500",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.1": {
          "rap": "23,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.2": {
          "rap": "23,500",
          "low_price": "26,400",
          "high_price": "57,200"
        },
        "2.3": {
          "rap": "23,500",
          "low_price": "27,600",
          "high_price": "59,800"
        },
        "2.4": {
          "rap": "23,500",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "2.5": {
          "rap": "23,500",
          "low_price": "30,000",
          "high_price": "65,000"
        },
        "2.6": {
          "rap": "23,500",
          "low_price": "31,200",
          "high_price": "67,600"
        },
        "2.7": {
          "rap": "23,500",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "2.8": {
          "rap": "23,500",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "2.9": {
          "rap": "23,500",
          "low_price": "34,800",
          "high_price": "75,400"
        },
        "3.0": {
          "rap": "36,500",
          "low_price": "63,900",
          "high_price": "138,450"
        },
        "3.1": {
          "rap": "36,500",
          "low_price": "66,030",
          "high_price": "143,065"
        },
        "3.2": {
          "rap": "36,500",
          "low_price": "68,160",
          "high_price": "147,680"
        },
        "3.3": {
          "rap": "36,500",
          "low_price": "70,290",
          "high_price": "152,295"
        },
        "3.4": {
          "rap": "36,500",
          "low_price": "72,420",
          "high_price": "156,910"
        },
        "3.5": {
          "rap": "36,500",
          "low_price": "74,550",
          "high_price": "161,525"
        },
        "3.6": {
          "rap": "36,500",
          "low_price": "76,680",
          "high_price": "166,140"
        },
        "3.7": {
          "rap": "36,500",
          "low_price": "78,810",
          "high_price": "170,755"
        },
        "3.8": {
          "rap": "36,500",
          "low_price": "80,940",
          "high_price": "175,370"
        },
        "3.9": {
          "rap": "36,500",
          "low_price": "83,070",
          "high_price": "179,985"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,800",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.5": {
          "rap": "3,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.6": {
          "rap": "3,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.7": {
          "rap": "5,300",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.8": {
          "rap": "5,300",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "0.9": {
          "rap": "7,100",
          "low_price": "3,080",
          "high_price": "6,670"
        },
        "1.0": {
          "rap": "9,400",
          "low_price": "4,500",
          "high_price": "9,750"
        },
        "1.1": {
          "rap": "9,400",
          "low_price": "4,950",
          "high_price": "10,725"
        },
        "1.2": {
          "rap": "9,400",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "1.3": {
          "rap": "9,400",
          "low_price": "5,850",
          "high_price": "12,675"
        },
        "1.4": {
          "rap": "9,400",
          "low_price": "6,300",
          "high_price": "13,650"
        },
        "1.5": {
          "rap": "14,900",
          "low_price": "11,160",
          "high_price": "24,180"
        },
        "1.6": {
          "rap": "14,900",
          "low_price": "11,905",
          "high_price": "25,790"
        },
        "1.7": {
          "rap": "14,900",
          "low_price": "12,650",
          "high_price": "27,405"
        },
        "1.8": {
          "rap": "14,900",
          "low_price": "13,390",
          "high_price": "29,015"
        },
        "1.9": {
          "rap": "14,900",
          "low_price": "14,135",
          "high_price": "30,630"
        },
        "2.0": {
          "rap": "21,000",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "2.1": {
          "rap": "21,000",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "2.2": {
          "rap": "21,000",
          "low_price": "24,420",
          "high_price": "52,910"
        },
        "2.3": {
          "rap": "21,000",
          "low_price": "25,530",
          "high_price": "55,315"
        },
        "2.4": {
          "rap": "21,000",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "2.5": {
          "rap": "21,000",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "2.6": {
          "rap": "21,000",
          "low_price": "28,860",
          "high_price": "62,530"
        },
        "2.7": {
          "rap": "21,000",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "2.8": {
          "rap": "21,000",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "2.9": {
          "rap": "21,000",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.0": {
          "rap": "33,500",
          "low_price": "58,500",
          "high_price": "126,750"
        },
        "3.1": {
          "rap": "33,500",
          "low_price": "60,450",
          "high_price": "130,975"
        },
        "3.2": {
          "rap": "33,500",
          "low_price": "62,400",
          "high_price": "135,200"
        },
        "3.3": {
          "rap": "33,500",
          "low_price": "64,350",
          "high_price": "139,425"
        },
        "3.4": {
          "rap": "33,500",
          "low_price": "66,300",
          "high_price": "143,650"
        },
        "3.5": {
          "rap": "33,500",
          "low_price": "68,250",
          "high_price": "147,875"
        },
        "3.6": {
          "rap": "33,500",
          "low_price": "70,200",
          "high_price": "152,100"
        },
        "3.7": {
          "rap": "33,500",
          "low_price": "72,150",
          "high_price": "156,325"
        },
        "3.8": {
          "rap": "33,500",
          "low_price": "74,100",
          "high_price": "160,550"
        },
        "3.9": {
          "rap": "33,500",
          "low_price": "76,050",
          "high_price": "164,775"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,700",
          "low_price": "550",
          "high_price": "1,195"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,825",
          "high_price": "3,950"
        },
        "0.9": {
          "rap": "6,400",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "8,500",
          "low_price": "4,080",
          "high_price": "8,840"
        },
        "1.1": {
          "rap": "8,500",
          "low_price": "4,490",
          "high_price": "9,725"
        },
        "1.2": {
          "rap": "8,500",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.3": {
          "rap": "8,500",
          "low_price": "5,305",
          "high_price": "11,490"
        },
        "1.4": {
          "rap": "8,500",
          "low_price": "5,710",
          "high_price": "12,375"
        },
        "1.5": {
          "rap": "13,400",
          "low_price": "10,350",
          "high_price": "22,425"
        },
        "1.6": {
          "rap": "13,400",
          "low_price": "11,040",
          "high_price": "23,920"
        },
        "1.7": {
          "rap": "13,400",
          "low_price": "11,730",
          "high_price": "25,415"
        },
        "1.8": {
          "rap": "13,400",
          "low_price": "12,420",
          "high_price": "26,910"
        },
        "1.9": {
          "rap": "13,400",
          "low_price": "13,110",
          "high_price": "28,405"
        },
        "2.0": {
          "rap": "19,000",
          "low_price": "20,400",
          "high_price": "44,200"
        },
        "2.1": {
          "rap": "19,000",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "2.2": {
          "rap": "19,000",
          "low_price": "22,440",
          "high_price": "48,620"
        },
        "2.3": {
          "rap": "19,000",
          "low_price": "23,460",
          "high_price": "50,830"
        },
        "2.4": {
          "rap": "19,000",
          "low_price": "24,480",
          "high_price": "53,040"
        },
        "2.5": {
          "rap": "19,000",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "2.6": {
          "rap": "19,000",
          "low_price": "26,520",
          "high_price": "57,460"
        },
        "2.7": {
          "rap": "19,000",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "2.8": {
          "rap": "19,000",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "2.9": {
          "rap": "19,000",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.0": {
          "rap": "30,500",
          "low_price": "53,100",
          "high_price": "115,050"
        },
        "3.1": {
          "rap": "30,500",
          "low_price": "54,870",
          "high_price": "118,885"
        },
        "3.2": {
          "rap": "30,500",
          "low_price": "56,640",
          "high_price": "122,720"
        },
        "3.3": {
          "rap": "30,500",
          "low_price": "58,410",
          "high_price": "126,555"
        },
        "3.4": {
          "rap": "30,500",
          "low_price": "60,180",
          "high_price": "130,390"
        },
        "3.5": {
          "rap": "30,500",
          "low_price": "61,950",
          "high_price": "134,225"
        },
        "3.6": {
          "rap": "30,500",
          "low_price": "63,720",
          "high_price": "138,060"
        },
        "3.7": {
          "rap": "30,500",
          "low_price": "65,490",
          "high_price": "141,895"
        },
        "3.8": {
          "rap": "30,500",
          "low_price": "67,260",
          "high_price": "145,730"
        },
        "3.9": {
          "rap": "30,500",
          "low_price": "69,030",
          "high_price": "149,565"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "4,700",
          "low_price": "1,470",
          "high_price": "3,185"
        },
        "0.8": {
          "rap": "4,700",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.9": {
          "rap": "5,900",
          "low_price": "2,645",
          "high_price": "5,735"
        },
        "1.0": {
          "rap": "7,700",
          "low_price": "3,720",
          "high_price": "8,060"
        },
        "1.1": {
          "rap": "7,700",
          "low_price": "4,090",
          "high_price": "8,865"
        },
        "1.2": {
          "rap": "7,700",
          "low_price": "4,465",
          "high_price": "9,670"
        },
        "1.3": {
          "rap": "7,700",
          "low_price": "4,835",
          "high_price": "10,480"
        },
        "1.4": {
          "rap": "7,700",
          "low_price": "5,210",
          "high_price": "11,285"
        },
        "1.5": {
          "rap": "12,200",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "1.6": {
          "rap": "12,200",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "1.7": {
          "rap": "12,200",
          "low_price": "10,710",
          "high_price": "23,205"
        },
        "1.8": {
          "rap": "12,200",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "1.9": {
          "rap": "12,200",
          "low_price": "11,970",
          "high_price": "25,935"
        },
        "2.0": {
          "rap": "17,500",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "17,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "17,500",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "17,500",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "17,500",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "17,500",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "17,500",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "17,500",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "17,500",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "17,500",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "27,500",
          "low_price": "47,700",
          "high_price": "103,350"
        },
        "3.1": {
          "rap": "27,500",
          "low_price": "49,290",
          "high_price": "106,795"
        },
        "3.2": {
          "rap": "27,500",
          "low_price": "50,880",
          "high_price": "110,240"
        },
        "3.3": {
          "rap": "27,500",
          "low_price": "52,470",
          "high_price": "113,685"
        },
        "3.4": {
          "rap": "27,500",
          "low_price": "54,060",
          "high_price": "117,130"
        },
        "3.5": {
          "rap": "27,500",
          "low_price": "55,650",
          "high_price": "120,575"
        },
        "3.6": {
          "rap": "27,500",
          "low_price": "57,240",
          "high_price": "124,020"
        },
        "3.7": {
          "rap": "27,500",
          "low_price": "58,830",
          "high_price": "127,465"
        },
        "3.8": {
          "rap": "27,500",
          "low_price": "60,420",
          "high_price": "130,910"
        },
        "3.9": {
          "rap": "27,500",
          "low_price": "62,010",
          "high_price": "134,355"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,300",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,800",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,800",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,300",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.8": {
          "rap": "4,300",
          "low_price": "1,535",
          "high_price": "3,330"
        },
        "0.9": {
          "rap": "5,400",
          "low_price": "2,430",
          "high_price": "5,265"
        },
        "1.0": {
          "rap": "6,600",
          "low_price": "3,120",
          "high_price": "6,760"
        },
        "1.1": {
          "rap": "6,600",
          "low_price": "3,430",
          "high_price": "7,435"
        },
        "1.2": {
          "rap": "6,600",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.3": {
          "rap": "6,600",
          "low_price": "4,055",
          "high_price": "8,790"
        },
        "1.4": {
          "rap": "6,600",
          "low_price": "4,370",
          "high_price": "9,465"
        },
        "1.5": {
          "rap": "10,300",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "1.6": {
          "rap": "10,300",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "1.7": {
          "rap": "10,300",
          "low_price": "8,975",
          "high_price": "19,450"
        },
        "1.8": {
          "rap": "10,300",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "1.9": {
          "rap": "10,300",
          "low_price": "10,030",
          "high_price": "21,735"
        },
        "2.0": {
          "rap": "14,000",
          "low_price": "15,000",
          "high_price": "32,500"
        },
        "2.1": {
          "rap": "14,000",
          "low_price": "15,750",
          "high_price": "34,125"
        },
        "2.2": {
          "rap": "14,000",
          "low_price": "16,500",
          "high_price": "35,750"
        },
        "2.3": {
          "rap": "14,000",
          "low_price": "17,250",
          "high_price": "37,375"
        },
        "2.4": {
          "rap": "14,000",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.5": {
          "rap": "14,000",
          "low_price": "18,750",
          "high_price": "40,625"
        },
        "2.6": {
          "rap": "14,000",
          "low_price": "19,500",
          "high_price": "42,250"
        },
        "2.7": {
          "rap": "14,000",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.8": {
          "rap": "14,000",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.9": {
          "rap": "14,000",
          "low_price": "21,750",
          "high_price": "47,125"
        },
        "3.0": {
          "rap": "23,000",
          "low_price": "40,500",
          "high_price": "87,750"
        },
        "3.1": {
          "rap": "23,000",
          "low_price": "41,850",
          "high_price": "90,675"
        },
        "3.2": {
          "rap": "23,000",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.3": {
          "rap": "23,000",
          "low_price": "44,550",
          "high_price": "96,525"
        },
        "3.4": {
          "rap": "23,000",
          "low_price": "45,900",
          "high_price": "99,450"
        },
        "3.5": {
          "rap": "23,000",
          "low_price": "47,250",
          "high_price": "102,375"
        },
        "3.6": {
          "rap": "23,000",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.7": {
          "rap": "23,000",
          "low_price": "49,950",
          "high_price": "108,225"
        },
        "3.8": {
          "rap": "23,000",
          "low_price": "51,300",
          "high_price": "111,150"
        },
        "3.9": {
          "rap": "23,000",
          "low_price": "52,650",
          "high_price": "114,075"
        }
      },
      "I": {
        "0.4": {
          "rap": "2,000",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "2,500",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "2,500",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "3,600",
          "low_price": "1,220",
          "high_price": "2,640"
        },
        "0.8": {
          "rap": "3,600",
          "low_price": "1,390",
          "high_price": "3,015"
        },
        "0.9": {
          "rap": "4,600",
          "low_price": "2,105",
          "high_price": "4,565"
        },
        "1.0": {
          "rap": "5,600",
          "low_price": "2,640",
          "high_price": "5,720"
        },
        "1.1": {
          "rap": "5,600",
          "low_price": "2,905",
          "high_price": "6,290"
        },
        "1.2": {
          "rap": "5,600",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.3": {
          "rap": "5,600",
          "low_price": "3,430",
          "high_price": "7,435"
        },
        "1.4": {
          "rap": "5,600",
          "low_price": "3,695",
          "high_price": "8,010"
        },
        "1.5": {
          "rap": "8,500",
          "low_price": "6,750",
          "high_price": "14,625"
        },
        "1.6": {
          "rap": "8,500",
          "low_price": "7,200",
          "high_price": "15,600"
        },
        "1.7": {
          "rap": "8,500",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "1.8": {
          "rap": "8,500",
          "low_price": "8,100",
          "high_price": "17,550"
        },
        "1.9": {
          "rap": "8,500",
          "low_price": "8,550",
          "high_price": "18,525"
        },
        "2.0": {
          "rap": "11,200",
          "low_price": "12,480",
          "high_price": "27,040"
        },
        "2.1": {
          "rap": "11,200",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.2": {
          "rap": "11,200",
          "low_price": "13,730",
          "high_price": "29,745"
        },
        "2.3": {
          "rap": "11,200",
          "low_price": "14,350",
          "high_price": "31,095"
        },
        "2.4": {
          "rap": "11,200",
          "low_price": "14,975",
          "high_price": "32,450"
        },
        "2.5": {
          "rap": "11,200",
          "low_price": "15,600",
          "high_price": "33,800"
        },
        "2.6": {
          "rap": "11,200",
          "low_price": "16,225",
          "high_price": "35,150"
        },
        "2.7": {
          "rap": "11,200",
          "low_price": "16,850",
          "high_price": "36,505"
        },
        "2.8": {
          "rap": "11,200",
          "low_price": "17,470",
          "high_price": "37,855"
        },
        "2.9": {
          "rap": "11,200",
          "low_price": "18,095",
          "high_price": "39,210"
        },
        "3.0": {
          "rap": "19,000",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.1": {
          "rap": "19,000",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.2": {
          "rap": "19,000",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.3": {
          "rap": "19,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.4": {
          "rap": "19,000",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.5": {
          "rap": "19,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.6": {
          "rap": "19,000",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.7": {
          "rap": "19,000",
          "low_price": "41,070",
          "high_price": "88,985"
        },
        "3.8": {
          "rap": "19,000",
          "low_price": "42,180",
          "high_price": "91,390"
        },
        "3.9": {
          "rap": "19,000",
          "low_price": "43,290",
          "high_price": "93,795"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,700",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "2,900",
          "low_price": "1,050",
          "high_price": "2,275"
        },
        "0.8": {
          "rap": "2,900",
          "low_price": "1,200",
          "high_price": "2,600"
        },
        "0.9": {
          "rap": "3,700",
          "low_price": "1,835",
          "high_price": "3,980"
        },
        "1.0": {
          "rap": "4,600",
          "low_price": "2,280",
          "high_price": "4,940"
        },
        "1.1": {
          "rap": "4,600",
          "low_price": "2,510",
          "high_price": "5,435"
        },
        "1.2": {
          "rap": "4,600",
          "low_price": "2,735",
          "high_price": "5,930"
        },
        "1.3": {
          "rap": "4,600",
          "low_price": "2,965",
          "high_price": "6,420"
        },
        "1.4": {
          "rap": "4,600",
          "low_price": "3,190",
          "high_price": "6,915"
        },
        "1.5": {
          "rap": "6,900",
          "low_price": "5,490",
          "high_price": "11,895"
        },
        "1.6": {
          "rap": "6,900",
          "low_price": "5,855",
          "high_price": "12,690"
        },
        "1.7": {
          "rap": "6,900",
          "low_price": "6,220",
          "high_price": "13,480"
        },
        "1.8": {
          "rap": "6,900",
          "low_price": "6,590",
          "high_price": "14,275"
        },
        "1.9": {
          "rap": "6,900",
          "low_price": "6,955",
          "high_price": "15,065"
        },
        "2.0": {
          "rap": "9,000",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.1": {
          "rap": "9,000",
          "low_price": "10,585",
          "high_price": "22,930"
        },
        "2.2": {
          "rap": "9,000",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.3": {
          "rap": "9,000",
          "low_price": "11,590",
          "high_price": "25,115"
        },
        "2.4": {
          "rap": "9,000",
          "low_price": "12,095",
          "high_price": "26,210"
        },
        "2.5": {
          "rap": "9,000",
          "low_price": "12,600",
          "high_price": "27,300"
        },
        "2.6": {
          "rap": "9,000",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.7": {
          "rap": "9,000",
          "low_price": "13,610",
          "high_price": "29,485"
        },
        "2.8": {
          "rap": "9,000",
          "low_price": "14,110",
          "high_price": "30,575"
        },
        "2.9": {
          "rap": "9,000",
          "low_price": "14,615",
          "high_price": "31,670"
        },
        "3.0": {
          "rap": "14,600",
          "low_price": "25,560",
          "high_price": "55,380"
        },
        "3.1": {
          "rap": "14,600",
          "low_price": "26,410",
          "high_price": "57,225"
        },
        "3.2": {
          "rap": "14,600",
          "low_price": "27,265",
          "high_price": "59,070"
        },
        "3.3": {
          "rap": "14,600",
          "low_price": "28,115",
          "high_price": "60,920"
        },
        "3.4": {
          "rap": "14,600",
          "low_price": "28,970",
          "high_price": "62,765"
        },
        "3.5": {
          "rap": "14,600",
          "low_price": "29,820",
          "high_price": "64,610"
        },
        "3.6": {
          "rap": "14,600",
          "low_price": "30,670",
          "high_price": "66,455"
        },
        "3.7": {
          "rap": "14,600",
          "low_price": "31,525",
          "high_price": "68,300"
        },
        "3.8": {
          "rap": "14,600",
          "low_price": "32,375",
          "high_price": "70,150"
        },
        "3.9": {
          "rap": "14,600",
          "low_price": "33,230",
          "high_price": "71,995"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,400",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "2,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "3,000",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "1.0": {
          "rap": "3,700",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "1.1": {
          "rap": "3,700",
          "low_price": "2,110",
          "high_price": "4,575"
        },
        "1.2": {
          "rap": "3,700",
          "low_price": "2,305",
          "high_price": "4,990"
        },
        "1.3": {
          "rap": "3,700",
          "low_price": "2,495",
          "high_price": "5,410"
        },
        "1.4": {
          "rap": "3,700",
          "low_price": "2,690",
          "high_price": "5,825"
        },
        "1.5": {
          "rap": "5,500",
          "low_price": "4,230",
          "high_price": "9,165"
        },
        "1.6": {
          "rap": "5,500",
          "low_price": "4,510",
          "high_price": "9,775"
        },
        "1.7": {
          "rap": "5,500",
          "low_price": "4,795",
          "high_price": "10,385"
        },
        "1.8": {
          "rap": "5,500",
          "low_price": "5,075",
          "high_price": "11,000"
        },
        "1.9": {
          "rap": "5,500",
          "low_price": "5,360",
          "high_price": "11,610"
        },
        "2.0": {
          "rap": "7,300",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.1": {
          "rap": "7,300",
          "low_price": "8,315",
          "high_price": "18,020"
        },
        "2.2": {
          "rap": "7,300",
          "low_price": "8,710",
          "high_price": "18,875"
        },
        "2.3": {
          "rap": "7,300",
          "low_price": "9,110",
          "high_price": "19,735"
        },
        "2.4": {
          "rap": "7,300",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "2.5": {
          "rap": "7,300",
          "low_price": "9,900",
          "high_price": "21,450"
        },
        "2.6": {
          "rap": "7,300",
          "low_price": "10,295",
          "high_price": "22,310"
        },
        "2.7": {
          "rap": "7,300",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "2.8": {
          "rap": "7,300",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.9": {
          "rap": "7,300",
          "low_price": "11,485",
          "high_price": "24,880"
        },
        "3.0": {
          "rap": "11,400",
          "low_price": "19,980",
          "high_price": "43,290"
        },
        "3.1": {
          "rap": "11,400",
          "low_price": "20,645",
          "high_price": "44,735"
        },
        "3.2": {
          "rap": "11,400",
          "low_price": "21,310",
          "high_price": "46,175"
        },
        "3.3": {
          "rap": "11,400",
          "low_price": "21,980",
          "high_price": "47,620"
        },
        "3.4": {
          "rap": "11,400",
          "low_price": "22,645",
          "high_price": "49,060"
        },
        "3.5": {
          "rap": "11,400",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "3.6": {
          "rap": "11,400",
          "low_price": "23,975",
          "high_price": "51,950"
        },
        "3.7": {
          "rap": "11,400",
          "low_price": "24,640",
          "high_price": "53,390"
        },
        "3.8": {
          "rap": "11,400",
          "low_price": "25,310",
          "high_price": "54,835"
        },
        "3.9": {
          "rap": "11,400",
          "low_price": "25,975",
          "high_price": "56,275"
        }
      }
    },
    "VVS2": {
      "D": {
        "0.4": {
          "rap": "2,800",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.5": {
          "rap": "3,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.6": {
          "rap": "3,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.7": {
          "rap": "5,300",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.8": {
          "rap": "5,300",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "0.9": {
          "rap": "7,100",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.0": {
          "rap": "9,400",
          "low_price": "4,560",
          "high_price": "9,880"
        },
        "1.1": {
          "rap": "9,400",
          "low_price": "5,015",
          "high_price": "10,870"
        },
        "1.2": {
          "rap": "9,400",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "1.3": {
          "rap": "9,400",
          "low_price": "5,930",
          "high_price": "12,845"
        },
        "1.4": {
          "rap": "9,400",
          "low_price": "6,385",
          "high_price": "13,830"
        },
        "1.5": {
          "rap": "15,000",
          "low_price": "11,250",
          "high_price": "24,375"
        },
        "1.6": {
          "rap": "15,000",
          "low_price": "12,000",
          "high_price": "26,000"
        },
        "1.7": {
          "rap": "15,000",
          "low_price": "12,750",
          "high_price": "27,625"
        },
        "1.8": {
          "rap": "15,000",
          "low_price": "13,500",
          "high_price": "29,250"
        },
        "1.9": {
          "rap": "15,000",
          "low_price": "14,250",
          "high_price": "30,875"
        },
        "2.0": {
          "rap": "21,000",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "2.1": {
          "rap": "21,000",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "2.2": {
          "rap": "21,000",
          "low_price": "24,420",
          "high_price": "52,910"
        },
        "2.3": {
          "rap": "21,000",
          "low_price": "25,530",
          "high_price": "55,315"
        },
        "2.4": {
          "rap": "21,000",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "2.5": {
          "rap": "21,000",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "2.6": {
          "rap": "21,000",
          "low_price": "28,860",
          "high_price": "62,530"
        },
        "2.7": {
          "rap": "21,000",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "2.8": {
          "rap": "21,000",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "2.9": {
          "rap": "21,000",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.0": {
          "rap": "33,500",
          "low_price": "58,500",
          "high_price": "126,750"
        },
        "3.1": {
          "rap": "33,500",
          "low_price": "60,450",
          "high_price": "130,975"
        },
        "3.2": {
          "rap": "33,500",
          "low_price": "62,400",
          "high_price": "135,200"
        },
        "3.3": {
          "rap": "33,500",
          "low_price": "64,350",
          "high_price": "139,425"
        },
        "3.4": {
          "rap": "33,500",
          "low_price": "66,300",
          "high_price": "143,650"
        },
        "3.5": {
          "rap": "33,500",
          "low_price": "68,250",
          "high_price": "147,875"
        },
        "3.6": {
          "rap": "33,500",
          "low_price": "70,200",
          "high_price": "152,100"
        },
        "3.7": {
          "rap": "33,500",
          "low_price": "72,150",
          "high_price": "156,325"
        },
        "3.8": {
          "rap": "33,500",
          "low_price": "74,100",
          "high_price": "160,550"
        },
        "3.9": {
          "rap": "33,500",
          "low_price": "76,050",
          "high_price": "164,775"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,600",
          "low_price": "530",
          "high_price": "1,145"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,825",
          "high_price": "3,950"
        },
        "0.9": {
          "rap": "6,500",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "8,700",
          "low_price": "4,140",
          "high_price": "8,970"
        },
        "1.1": {
          "rap": "8,700",
          "low_price": "4,555",
          "high_price": "9,865"
        },
        "1.2": {
          "rap": "8,700",
          "low_price": "4,970",
          "high_price": "10,765"
        },
        "1.3": {
          "rap": "8,700",
          "low_price": "5,380",
          "high_price": "11,660"
        },
        "1.4": {
          "rap": "8,700",
          "low_price": "5,795",
          "high_price": "12,560"
        },
        "1.5": {
          "rap": "13,600",
          "low_price": "10,440",
          "high_price": "22,620"
        },
        "1.6": {
          "rap": "13,600",
          "low_price": "11,135",
          "high_price": "24,130"
        },
        "1.7": {
          "rap": "13,600",
          "low_price": "11,830",
          "high_price": "25,635"
        },
        "1.8": {
          "rap": "13,600",
          "low_price": "12,530",
          "high_price": "27,145"
        },
        "1.9": {
          "rap": "13,600",
          "low_price": "13,225",
          "high_price": "28,650"
        },
        "2.0": {
          "rap": "19,500",
          "low_price": "20,400",
          "high_price": "44,200"
        },
        "2.1": {
          "rap": "19,500",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "2.2": {
          "rap": "19,500",
          "low_price": "22,440",
          "high_price": "48,620"
        },
        "2.3": {
          "rap": "19,500",
          "low_price": "23,460",
          "high_price": "50,830"
        },
        "2.4": {
          "rap": "19,500",
          "low_price": "24,480",
          "high_price": "53,040"
        },
        "2.5": {
          "rap": "19,500",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "2.6": {
          "rap": "19,500",
          "low_price": "26,520",
          "high_price": "57,460"
        },
        "2.7": {
          "rap": "19,500",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "2.8": {
          "rap": "19,500",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "2.9": {
          "rap": "19,500",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.0": {
          "rap": "30,500",
          "low_price": "53,100",
          "high_price": "115,050"
        },
        "3.1": {
          "rap": "30,500",
          "low_price": "54,870",
          "high_price": "118,885"
        },
        "3.2": {
          "rap": "30,500",
          "low_price": "56,640",
          "high_price": "122,720"
        },
        "3.3": {
          "rap": "30,500",
          "low_price": "58,410",
          "high_price": "126,555"
        },
        "3.4": {
          "rap": "30,500",
          "low_price": "60,180",
          "high_price": "130,390"
        },
        "3.5": {
          "rap": "30,500",
          "low_price": "61,950",
          "high_price": "134,225"
        },
        "3.6": {
          "rap": "30,500",
          "low_price": "63,720",
          "high_price": "138,060"
        },
        "3.7": {
          "rap": "30,500",
          "low_price": "65,490",
          "high_price": "141,895"
        },
        "3.8": {
          "rap": "30,500",
          "low_price": "67,260",
          "high_price": "145,730"
        },
        "3.9": {
          "rap": "30,500",
          "low_price": "69,030",
          "high_price": "149,565"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "750",
          "high_price": "1,625"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.7": {
          "rap": "4,800",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "0.8": {
          "rap": "4,800",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "0.9": {
          "rap": "6,000",
          "low_price": "2,645",
          "high_price": "5,735"
        },
        "1.0": {
          "rap": "8,000",
          "low_price": "3,840",
          "high_price": "8,320"
        },
        "1.1": {
          "rap": "8,000",
          "low_price": "4,225",
          "high_price": "9,150"
        },
        "1.2": {
          "rap": "8,000",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.3": {
          "rap": "8,000",
          "low_price": "4,990",
          "high_price": "10,815"
        },
        "1.4": {
          "rap": "8,000",
          "low_price": "5,375",
          "high_price": "11,650"
        },
        "1.5": {
          "rap": "12,700",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "1.6": {
          "rap": "12,700",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "1.7": {
          "rap": "12,700",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "1.8": {
          "rap": "12,700",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "1.9": {
          "rap": "12,700",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "2.0": {
          "rap": "18,000",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "18,000",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "18,000",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "18,000",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "18,000",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "18,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "18,000",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "18,000",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "18,000",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "18,000",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "28,000",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.1": {
          "rap": "28,000",
          "low_price": "50,220",
          "high_price": "108,810"
        },
        "3.2": {
          "rap": "28,000",
          "low_price": "51,840",
          "high_price": "112,320"
        },
        "3.3": {
          "rap": "28,000",
          "low_price": "53,460",
          "high_price": "115,830"
        },
        "3.4": {
          "rap": "28,000",
          "low_price": "55,080",
          "high_price": "119,340"
        },
        "3.5": {
          "rap": "28,000",
          "low_price": "56,700",
          "high_price": "122,850"
        },
        "3.6": {
          "rap": "28,000",
          "low_price": "58,320",
          "high_price": "126,360"
        },
        "3.7": {
          "rap": "28,000",
          "low_price": "59,940",
          "high_price": "129,870"
        },
        "3.8": {
          "rap": "28,000",
          "low_price": "61,560",
          "high_price": "133,380"
        },
        "3.9": {
          "rap": "28,000",
          "low_price": "63,180",
          "high_price": "136,890"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,300",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,800",
          "low_price": "690",
          "high_price": "1,495"
        },
        "0.6": {
          "rap": "2,800",
          "low_price": "830",
          "high_price": "1,795"
        },
        "0.7": {
          "rap": "4,500",
          "low_price": "1,385",
          "high_price": "3,005"
        },
        "0.8": {
          "rap": "4,500",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "0.9": {
          "rap": "5,600",
          "low_price": "2,485",
          "high_price": "5,380"
        },
        "1.0": {
          "rap": "7,300",
          "low_price": "3,480",
          "high_price": "7,540"
        },
        "1.1": {
          "rap": "7,300",
          "low_price": "3,830",
          "high_price": "8,295"
        },
        "1.2": {
          "rap": "7,300",
          "low_price": "4,175",
          "high_price": "9,050"
        },
        "1.3": {
          "rap": "7,300",
          "low_price": "4,525",
          "high_price": "9,800"
        },
        "1.4": {
          "rap": "7,300",
          "low_price": "4,870",
          "high_price": "10,555"
        },
        "1.5": {
          "rap": "11,700",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "1.6": {
          "rap": "11,700",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "1.7": {
          "rap": "11,700",
          "low_price": "10,200",
          "high_price": "22,100"
        },
        "1.8": {
          "rap": "11,700",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "1.9": {
          "rap": "11,700",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "2.0": {
          "rap": "16,500",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.1": {
          "rap": "16,500",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "2.2": {
          "rap": "16,500",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.3": {
          "rap": "16,500",
          "low_price": "20,700",
          "high_price": "44,850"
        },
        "2.4": {
          "rap": "16,500",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "2.5": {
          "rap": "16,500",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "2.6": {
          "rap": "16,500",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.7": {
          "rap": "16,500",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "2.8": {
          "rap": "16,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.9": {
          "rap": "16,500",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.0": {
          "rap": "25,000",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.1": {
          "rap": "25,000",
          "low_price": "45,570",
          "high_price": "98,735"
        },
        "3.2": {
          "rap": "25,000",
          "low_price": "47,040",
          "high_price": "101,920"
        },
        "3.3": {
          "rap": "25,000",
          "low_price": "48,510",
          "high_price": "105,105"
        },
        "3.4": {
          "rap": "25,000",
          "low_price": "49,980",
          "high_price": "108,290"
        },
        "3.5": {
          "rap": "25,000",
          "low_price": "51,450",
          "high_price": "111,475"
        },
        "3.6": {
          "rap": "25,000",
          "low_price": "52,920",
          "high_price": "114,660"
        },
        "3.7": {
          "rap": "25,000",
          "low_price": "54,390",
          "high_price": "117,845"
        },
        "3.8": {
          "rap": "25,000",
          "low_price": "55,860",
          "high_price": "121,030"
        },
        "3.9": {
          "rap": "25,000",
          "low_price": "57,330",
          "high_price": "124,215"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,100",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "2,600",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.6": {
          "rap": "2,600",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.7": {
          "rap": "4,100",
          "low_price": "1,260",
          "high_price": "2,730"
        },
        "0.8": {
          "rap": "4,100",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "0.9": {
          "rap": "5,200",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.0": {
          "rap": "6,300",
          "low_price": "2,940",
          "high_price": "6,370"
        },
        "1.1": {
          "rap": "6,300",
          "low_price": "3,235",
          "high_price": "7,005"
        },
        "1.2": {
          "rap": "6,300",
          "low_price": "3,530",
          "high_price": "7,645"
        },
        "1.3": {
          "rap": "6,300",
          "low_price": "3,820",
          "high_price": "8,280"
        },
        "1.4": {
          "rap": "6,300",
          "low_price": "4,115",
          "high_price": "8,920"
        },
        "1.5": {
          "rap": "9,900",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "1.6": {
          "rap": "9,900",
          "low_price": "8,065",
          "high_price": "17,470"
        },
        "1.7": {
          "rap": "9,900",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "1.8": {
          "rap": "9,900",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "1.9": {
          "rap": "9,900",
          "low_price": "9,575",
          "high_price": "20,750"
        },
        "2.0": {
          "rap": "13,500",
          "low_price": "14,400",
          "high_price": "31,200"
        },
        "2.1": {
          "rap": "13,500",
          "low_price": "15,120",
          "high_price": "32,760"
        },
        "2.2": {
          "rap": "13,500",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "2.3": {
          "rap": "13,500",
          "low_price": "16,560",
          "high_price": "35,880"
        },
        "2.4": {
          "rap": "13,500",
          "low_price": "17,280",
          "high_price": "37,440"
        },
        "2.5": {
          "rap": "13,500",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.6": {
          "rap": "13,500",
          "low_price": "18,720",
          "high_price": "40,560"
        },
        "2.7": {
          "rap": "13,500",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.8": {
          "rap": "13,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.9": {
          "rap": "13,500",
          "low_price": "20,880",
          "high_price": "45,240"
        },
        "3.0": {
          "rap": "21,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.1": {
          "rap": "21,500",
          "low_price": "39,060",
          "high_price": "84,630"
        },
        "3.2": {
          "rap": "21,500",
          "low_price": "40,320",
          "high_price": "87,360"
        },
        "3.3": {
          "rap": "21,500",
          "low_price": "41,580",
          "high_price": "90,090"
        },
        "3.4": {
          "rap": "21,500",
          "low_price": "42,840",
          "high_price": "92,820"
        },
        "3.5": {
          "rap": "21,500",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.6": {
          "rap": "21,500",
          "low_price": "45,360",
          "high_price": "98,280"
        },
        "3.7": {
          "rap": "21,500",
          "low_price": "46,620",
          "high_price": "101,010"
        },
        "3.8": {
          "rap": "21,500",
          "low_price": "47,880",
          "high_price": "103,740"
        },
        "3.9": {
          "rap": "21,500",
          "low_price": "49,140",
          "high_price": "106,470"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,900",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,400",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,400",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,400",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "0.8": {
          "rap": "3,400",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "0.9": {
          "rap": "4,400",
          "low_price": "2,000",
          "high_price": "4,330"
        },
        "1.0": {
          "rap": "5,400",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.1": {
          "rap": "5,400",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.2": {
          "rap": "5,400",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.3": {
          "rap": "5,400",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.4": {
          "rap": "5,400",
          "low_price": "3,530",
          "high_price": "7,645"
        },
        "1.5": {
          "rap": "8,200",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "1.6": {
          "rap": "8,200",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "1.7": {
          "rap": "8,200",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "1.8": {
          "rap": "8,200",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "1.9": {
          "rap": "8,200",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "2.0": {
          "rap": "10,700",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "2.1": {
          "rap": "10,700",
          "low_price": "12,475",
          "high_price": "27,025"
        },
        "2.2": {
          "rap": "10,700",
          "low_price": "13,070",
          "high_price": "28,315"
        },
        "2.3": {
          "rap": "10,700",
          "low_price": "13,660",
          "high_price": "29,600"
        },
        "2.4": {
          "rap": "10,700",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.5": {
          "rap": "10,700",
          "low_price": "14,850",
          "high_price": "32,175"
        },
        "2.6": {
          "rap": "10,700",
          "low_price": "15,445",
          "high_price": "33,460"
        },
        "2.7": {
          "rap": "10,700",
          "low_price": "16,040",
          "high_price": "34,750"
        },
        "2.8": {
          "rap": "10,700",
          "low_price": "16,630",
          "high_price": "36,035"
        },
        "2.9": {
          "rap": "10,700",
          "low_price": "17,225",
          "high_price": "37,325"
        },
        "3.0": {
          "rap": "18,000",
          "low_price": "31,500",
          "high_price": "68,250"
        },
        "3.1": {
          "rap": "18,000",
          "low_price": "32,550",
          "high_price": "70,525"
        },
        "3.2": {
          "rap": "18,000",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "3.3": {
          "rap": "18,000",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "3.4": {
          "rap": "18,000",
          "low_price": "35,700",
          "high_price": "77,350"
        },
        "3.5": {
          "rap": "18,000",
          "low_price": "36,750",
          "high_price": "79,625"
        },
        "3.6": {
          "rap": "18,000",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.7": {
          "rap": "18,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.8": {
          "rap": "18,000",
          "low_price": "39,900",
          "high_price": "86,450"
        },
        "3.9": {
          "rap": "18,000",
          "low_price": "40,950",
          "high_price": "88,725"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,600",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,000",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "2,000",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "2,800",
          "low_price": "965",
          "high_price": "2,095"
        },
        "0.8": {
          "rap": "2,800",
          "low_price": "1,105",
          "high_price": "2,390"
        },
        "0.9": {
          "rap": "3,600",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.0": {
          "rap": "4,400",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.1": {
          "rap": "4,400",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.2": {
          "rap": "4,400",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.3": {
          "rap": "4,400",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.4": {
          "rap": "4,400",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.5": {
          "rap": "6,600",
          "low_price": "5,220",
          "high_price": "11,310"
        },
        "1.6": {
          "rap": "6,600",
          "low_price": "5,570",
          "high_price": "12,065"
        },
        "1.7": {
          "rap": "6,600",
          "low_price": "5,915",
          "high_price": "12,820"
        },
        "1.8": {
          "rap": "6,600",
          "low_price": "6,265",
          "high_price": "13,570"
        },
        "1.9": {
          "rap": "6,600",
          "low_price": "6,610",
          "high_price": "14,325"
        },
        "2.0": {
          "rap": "8,700",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "2.1": {
          "rap": "8,700",
          "low_price": "10,205",
          "high_price": "22,115"
        },
        "2.2": {
          "rap": "8,700",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "2.3": {
          "rap": "8,700",
          "low_price": "11,180",
          "high_price": "24,220"
        },
        "2.4": {
          "rap": "8,700",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "2.5": {
          "rap": "8,700",
          "low_price": "12,150",
          "high_price": "26,325"
        },
        "2.6": {
          "rap": "8,700",
          "low_price": "12,635",
          "high_price": "27,380"
        },
        "2.7": {
          "rap": "8,700",
          "low_price": "13,120",
          "high_price": "28,430"
        },
        "2.8": {
          "rap": "8,700",
          "low_price": "13,610",
          "high_price": "29,485"
        },
        "2.9": {
          "rap": "8,700",
          "low_price": "14,095",
          "high_price": "30,535"
        },
        "3.0": {
          "rap": "13,900",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "3.1": {
          "rap": "13,900",
          "low_price": "25,110",
          "high_price": "54,405"
        },
        "3.2": {
          "rap": "13,900",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "3.3": {
          "rap": "13,900",
          "low_price": "26,730",
          "high_price": "57,915"
        },
        "3.4": {
          "rap": "13,900",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "3.5": {
          "rap": "13,900",
          "low_price": "28,350",
          "high_price": "61,425"
        },
        "3.6": {
          "rap": "13,900",
          "low_price": "29,160",
          "high_price": "63,180"
        },
        "3.7": {
          "rap": "13,900",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "3.8": {
          "rap": "13,900",
          "low_price": "30,780",
          "high_price": "66,690"
        },
        "3.9": {
          "rap": "13,900",
          "low_price": "31,590",
          "high_price": "68,445"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,300",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "2,900",
          "low_price": "1,405",
          "high_price": "3,040"
        },
        "1.0": {
          "rap": "3,500",
          "low_price": "1,800",
          "high_price": "3,900"
        },
        "1.1": {
          "rap": "3,500",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.2": {
          "rap": "3,500",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.3": {
          "rap": "3,500",
          "low_price": "2,340",
          "high_price": "5,070"
        },
        "1.4": {
          "rap": "3,500",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.5": {
          "rap": "5,300",
          "low_price": "4,050",
          "high_price": "8,775"
        },
        "1.6": {
          "rap": "5,300",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.7": {
          "rap": "5,300",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.8": {
          "rap": "5,300",
          "low_price": "4,860",
          "high_price": "10,530"
        },
        "1.9": {
          "rap": "5,300",
          "low_price": "5,130",
          "high_price": "11,115"
        },
        "2.0": {
          "rap": "7,100",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.1": {
          "rap": "7,100",
          "low_price": "7,940",
          "high_price": "17,200"
        },
        "2.2": {
          "rap": "7,100",
          "low_price": "8,315",
          "high_price": "18,020"
        },
        "2.3": {
          "rap": "7,100",
          "low_price": "8,695",
          "high_price": "18,835"
        },
        "2.4": {
          "rap": "7,100",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "2.5": {
          "rap": "7,100",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "2.6": {
          "rap": "7,100",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "2.7": {
          "rap": "7,100",
          "low_price": "10,205",
          "high_price": "22,115"
        },
        "2.8": {
          "rap": "7,100",
          "low_price": "10,585",
          "high_price": "22,930"
        },
        "2.9": {
          "rap": "7,100",
          "low_price": "10,960",
          "high_price": "23,750"
        },
        "3.0": {
          "rap": "10,800",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "3.1": {
          "rap": "10,800",
          "low_price": "19,530",
          "high_price": "42,315"
        },
        "3.2": {
          "rap": "10,800",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "3.3": {
          "rap": "10,800",
          "low_price": "20,790",
          "high_price": "45,045"
        },
        "3.4": {
          "rap": "10,800",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "3.5": {
          "rap": "10,800",
          "low_price": "22,050",
          "high_price": "47,775"
        },
        "3.6": {
          "rap": "10,800",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "3.7": {
          "rap": "10,800",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "3.8": {
          "rap": "10,800",
          "low_price": "23,940",
          "high_price": "51,870"
        },
        "3.9": {
          "rap": "10,800",
          "low_price": "24,570",
          "high_price": "53,235"
        }
      }
    }
  },
  "Oval": {
    "I1": {
      "D": {
        "0.4": {
          "rap": "1,200",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "2,400",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "2,700",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "1.0": {
          "rap": "3,300",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "3,300",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "3,300",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "3,300",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "3,300",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "5,300",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.6": {
          "rap": "5,300",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.7": {
          "rap": "5,300",
          "low_price": "5,200",
          "high_price": "11,270"
        },
        "1.8": {
          "rap": "5,300",
          "low_price": "5,510",
          "high_price": "11,935"
        },
        "1.9": {
          "rap": "5,300",
          "low_price": "5,815",
          "high_price": "12,595"
        },
        "2.0": {
          "rap": "6,900",
          "low_price": "8,280",
          "high_price": "17,940"
        },
        "2.1": {
          "rap": "6,900",
          "low_price": "8,695",
          "high_price": "18,835"
        },
        "2.2": {
          "rap": "6,900",
          "low_price": "9,110",
          "high_price": "19,735"
        },
        "2.3": {
          "rap": "6,900",
          "low_price": "9,520",
          "high_price": "20,630"
        },
        "2.4": {
          "rap": "6,900",
          "low_price": "9,935",
          "high_price": "21,530"
        },
        "2.5": {
          "rap": "6,900",
          "low_price": "10,350",
          "high_price": "22,425"
        },
        "2.6": {
          "rap": "6,900",
          "low_price": "10,765",
          "high_price": "23,320"
        },
        "2.7": {
          "rap": "6,900",
          "low_price": "11,180",
          "high_price": "24,220"
        },
        "2.8": {
          "rap": "6,900",
          "low_price": "11,590",
          "high_price": "25,115"
        },
        "2.9": {
          "rap": "6,900",
          "low_price": "12,005",
          "high_price": "26,015"
        },
        "3.0": {
          "rap": "8,600",
          "low_price": "15,480",
          "high_price": "33,540"
        },
        "3.1": {
          "rap": "8,600",
          "low_price": "15,995",
          "high_price": "34,660"
        },
        "3.2": {
          "rap": "8,600",
          "low_price": "16,510",
          "high_price": "35,775"
        },
        "3.3": {
          "rap": "8,600",
          "low_price": "17,030",
          "high_price": "36,895"
        },
        "3.4": {
          "rap": "8,600",
          "low_price": "17,545",
          "high_price": "38,010"
        },
        "3.5": {
          "rap": "8,600",
          "low_price": "18,060",
          "high_price": "39,130"
        },
        "3.6": {
          "rap": "8,600",
          "low_price": "18,575",
          "high_price": "40,250"
        },
        "3.7": {
          "rap": "8,600",
          "low_price": "19,090",
          "high_price": "41,365"
        },
        "3.8": {
          "rap": "8,600",
          "low_price": "19,610",
          "high_price": "42,485"
        },
        "3.9": {
          "rap": "8,600",
          "low_price": "20,125",
          "high_price": "43,600"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,100",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "2,600",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "3,200",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "3,200",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "3,200",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "3,200",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "3,200",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "5,000",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "5,000",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "5,000",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "5,000",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "5,000",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "6,400",
          "low_price": "7,680",
          "high_price": "16,640"
        },
        "2.1": {
          "rap": "6,400",
          "low_price": "8,065",
          "high_price": "17,470"
        },
        "2.2": {
          "rap": "6,400",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "2.3": {
          "rap": "6,400",
          "low_price": "8,830",
          "high_price": "19,135"
        },
        "2.4": {
          "rap": "6,400",
          "low_price": "9,215",
          "high_price": "19,970"
        },
        "2.5": {
          "rap": "6,400",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "2.6": {
          "rap": "6,400",
          "low_price": "9,985",
          "high_price": "21,630"
        },
        "2.7": {
          "rap": "6,400",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "2.8": {
          "rap": "6,400",
          "low_price": "10,750",
          "high_price": "23,295"
        },
        "2.9": {
          "rap": "6,400",
          "low_price": "11,135",
          "high_price": "24,130"
        },
        "3.0": {
          "rap": "8,000",
          "low_price": "14,400",
          "high_price": "31,200"
        },
        "3.1": {
          "rap": "8,000",
          "low_price": "14,880",
          "high_price": "32,240"
        },
        "3.2": {
          "rap": "8,000",
          "low_price": "15,360",
          "high_price": "33,280"
        },
        "3.3": {
          "rap": "8,000",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "3.4": {
          "rap": "8,000",
          "low_price": "16,320",
          "high_price": "35,360"
        },
        "3.5": {
          "rap": "8,000",
          "low_price": "16,800",
          "high_price": "36,400"
        },
        "3.6": {
          "rap": "8,000",
          "low_price": "17,280",
          "high_price": "37,440"
        },
        "3.7": {
          "rap": "8,000",
          "low_price": "17,760",
          "high_price": "38,480"
        },
        "3.8": {
          "rap": "8,000",
          "low_price": "18,240",
          "high_price": "39,520"
        },
        "3.9": {
          "rap": "8,000",
          "low_price": "18,720",
          "high_price": "40,560"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,000",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,500",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,200",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,200",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,500",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "1.0": {
          "rap": "3,100",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "1.1": {
          "rap": "3,100",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.2": {
          "rap": "3,100",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.3": {
          "rap": "3,100",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.4": {
          "rap": "3,100",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "1.5": {
          "rap": "4,700",
          "low_price": "4,050",
          "high_price": "8,775"
        },
        "1.6": {
          "rap": "4,700",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.7": {
          "rap": "4,700",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.8": {
          "rap": "4,700",
          "low_price": "4,860",
          "high_price": "10,530"
        },
        "1.9": {
          "rap": "4,700",
          "low_price": "5,130",
          "high_price": "11,115"
        },
        "2.0": {
          "rap": "5,900",
          "low_price": "7,080",
          "high_price": "15,340"
        },
        "2.1": {
          "rap": "5,900",
          "low_price": "7,435",
          "high_price": "16,105"
        },
        "2.2": {
          "rap": "5,900",
          "low_price": "7,790",
          "high_price": "16,875"
        },
        "2.3": {
          "rap": "5,900",
          "low_price": "8,140",
          "high_price": "17,640"
        },
        "2.4": {
          "rap": "5,900",
          "low_price": "8,495",
          "high_price": "18,410"
        },
        "2.5": {
          "rap": "5,900",
          "low_price": "8,850",
          "high_price": "19,175"
        },
        "2.6": {
          "rap": "5,900",
          "low_price": "9,205",
          "high_price": "19,940"
        },
        "2.7": {
          "rap": "5,900",
          "low_price": "9,560",
          "high_price": "20,710"
        },
        "2.8": {
          "rap": "5,900",
          "low_price": "9,910",
          "high_price": "21,475"
        },
        "2.9": {
          "rap": "5,900",
          "low_price": "10,265",
          "high_price": "22,245"
        },
        "3.0": {
          "rap": "7,400",
          "low_price": "13,320",
          "high_price": "28,860"
        },
        "3.1": {
          "rap": "7,400",
          "low_price": "13,765",
          "high_price": "29,820"
        },
        "3.2": {
          "rap": "7,400",
          "low_price": "14,210",
          "high_price": "30,785"
        },
        "3.3": {
          "rap": "7,400",
          "low_price": "14,650",
          "high_price": "31,745"
        },
        "3.4": {
          "rap": "7,400",
          "low_price": "15,095",
          "high_price": "32,710"
        },
        "3.5": {
          "rap": "7,400",
          "low_price": "15,540",
          "high_price": "33,670"
        },
        "3.6": {
          "rap": "7,400",
          "low_price": "15,985",
          "high_price": "34,630"
        },
        "3.7": {
          "rap": "7,400",
          "low_price": "16,430",
          "high_price": "35,595"
        },
        "3.8": {
          "rap": "7,400",
          "low_price": "16,870",
          "high_price": "36,555"
        },
        "3.9": {
          "rap": "7,400",
          "low_price": "17,315",
          "high_price": "37,520"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,000",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,400",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "2,900",
          "low_price": "1,560",
          "high_price": "3,380"
        },
        "1.1": {
          "rap": "2,900",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.2": {
          "rap": "2,900",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.3": {
          "rap": "2,900",
          "low_price": "2,030",
          "high_price": "4,395"
        },
        "1.4": {
          "rap": "2,900",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.5": {
          "rap": "4,400",
          "low_price": "3,780",
          "high_price": "8,190"
        },
        "1.6": {
          "rap": "4,400",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.7": {
          "rap": "4,400",
          "low_price": "4,285",
          "high_price": "9,280"
        },
        "1.8": {
          "rap": "4,400",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.9": {
          "rap": "4,400",
          "low_price": "4,790",
          "high_price": "10,375"
        },
        "2.0": {
          "rap": "5,500",
          "low_price": "6,600",
          "high_price": "14,300"
        },
        "2.1": {
          "rap": "5,500",
          "low_price": "6,930",
          "high_price": "15,015"
        },
        "2.2": {
          "rap": "5,500",
          "low_price": "7,260",
          "high_price": "15,730"
        },
        "2.3": {
          "rap": "5,500",
          "low_price": "7,590",
          "high_price": "16,445"
        },
        "2.4": {
          "rap": "5,500",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.5": {
          "rap": "5,500",
          "low_price": "8,250",
          "high_price": "17,875"
        },
        "2.6": {
          "rap": "5,500",
          "low_price": "8,580",
          "high_price": "18,590"
        },
        "2.7": {
          "rap": "5,500",
          "low_price": "8,910",
          "high_price": "19,305"
        },
        "2.8": {
          "rap": "5,500",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.9": {
          "rap": "5,500",
          "low_price": "9,570",
          "high_price": "20,735"
        },
        "3.0": {
          "rap": "6,700",
          "low_price": "12,060",
          "high_price": "26,130"
        },
        "3.1": {
          "rap": "6,700",
          "low_price": "12,460",
          "high_price": "27,000"
        },
        "3.2": {
          "rap": "6,700",
          "low_price": "12,865",
          "high_price": "27,870"
        },
        "3.3": {
          "rap": "6,700",
          "low_price": "13,265",
          "high_price": "28,745"
        },
        "3.4": {
          "rap": "6,700",
          "low_price": "13,670",
          "high_price": "29,615"
        },
        "3.5": {
          "rap": "6,700",
          "low_price": "14,070",
          "high_price": "30,485"
        },
        "3.6": {
          "rap": "6,700",
          "low_price": "14,470",
          "high_price": "31,355"
        },
        "3.7": {
          "rap": "6,700",
          "low_price": "14,875",
          "high_price": "32,225"
        },
        "3.8": {
          "rap": "6,700",
          "low_price": "15,275",
          "high_price": "33,100"
        },
        "3.9": {
          "rap": "6,700",
          "low_price": "15,680",
          "high_price": "33,970"
        }
      },
      "H": {
        "0.4": {
          "rap": "900",
          "low_price": "215",
          "high_price": "470"
        },
        "0.5": {
          "rap": "1,300",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,300",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "2,000",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.8": {
          "rap": "2,000",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.9": {
          "rap": "2,300",
          "low_price": "1,080",
          "high_price": "2,340"
        },
        "1.0": {
          "rap": "2,700",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "1.1": {
          "rap": "2,700",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.2": {
          "rap": "2,700",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.3": {
          "rap": "2,700",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.4": {
          "rap": "2,700",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.5": {
          "rap": "4,100",
          "low_price": "3,510",
          "high_price": "7,605"
        },
        "1.6": {
          "rap": "4,100",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.7": {
          "rap": "4,100",
          "low_price": "3,980",
          "high_price": "8,620"
        },
        "1.8": {
          "rap": "4,100",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.9": {
          "rap": "4,100",
          "low_price": "4,445",
          "high_price": "9,635"
        },
        "2.0": {
          "rap": "5,100",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "2.1": {
          "rap": "5,100",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "2.2": {
          "rap": "5,100",
          "low_price": "6,730",
          "high_price": "14,585"
        },
        "2.3": {
          "rap": "5,100",
          "low_price": "7,040",
          "high_price": "15,250"
        },
        "2.4": {
          "rap": "5,100",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "2.5": {
          "rap": "5,100",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "2.6": {
          "rap": "5,100",
          "low_price": "7,955",
          "high_price": "17,240"
        },
        "2.7": {
          "rap": "5,100",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "2.8": {
          "rap": "5,100",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "2.9": {
          "rap": "5,100",
          "low_price": "8,875",
          "high_price": "19,225"
        },
        "3.0": {
          "rap": "6,200",
          "low_price": "11,160",
          "high_price": "24,180"
        },
        "3.1": {
          "rap": "6,200",
          "low_price": "11,530",
          "high_price": "24,985"
        },
        "3.2": {
          "rap": "6,200",
          "low_price": "11,905",
          "high_price": "25,790"
        },
        "3.3": {
          "rap": "6,200",
          "low_price": "12,275",
          "high_price": "26,600"
        },
        "3.4": {
          "rap": "6,200",
          "low_price": "12,650",
          "high_price": "27,405"
        },
        "3.5": {
          "rap": "6,200",
          "low_price": "13,020",
          "high_price": "28,210"
        },
        "3.6": {
          "rap": "6,200",
          "low_price": "13,390",
          "high_price": "29,015"
        },
        "3.7": {
          "rap": "6,200",
          "low_price": "13,765",
          "high_price": "29,820"
        },
        "3.8": {
          "rap": "6,200",
          "low_price": "14,135",
          "high_price": "30,630"
        },
        "3.9": {
          "rap": "6,200",
          "low_price": "14,510",
          "high_price": "31,435"
        }
      },
      "I": {
        "0.4": {
          "rap": "800",
          "low_price": "190",
          "high_price": "415"
        },
        "0.5": {
          "rap": "1,200",
          "low_price": "330",
          "high_price": "715"
        },
        "0.6": {
          "rap": "1,200",
          "low_price": "395",
          "high_price": "860"
        },
        "0.7": {
          "rap": "1,800",
          "low_price": "590",
          "high_price": "1,275"
        },
        "0.8": {
          "rap": "1,800",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.9": {
          "rap": "2,100",
          "low_price": "1,025",
          "high_price": "2,225"
        },
        "1.0": {
          "rap": "2,500",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "1.1": {
          "rap": "2,500",
          "low_price": "1,450",
          "high_price": "3,145"
        },
        "1.2": {
          "rap": "2,500",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.3": {
          "rap": "2,500",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.4": {
          "rap": "2,500",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.5": {
          "rap": "3,800",
          "low_price": "3,240",
          "high_price": "7,020"
        },
        "1.6": {
          "rap": "3,800",
          "low_price": "3,455",
          "high_price": "7,490"
        },
        "1.7": {
          "rap": "3,800",
          "low_price": "3,670",
          "high_price": "7,955"
        },
        "1.8": {
          "rap": "3,800",
          "low_price": "3,890",
          "high_price": "8,425"
        },
        "1.9": {
          "rap": "3,800",
          "low_price": "4,105",
          "high_price": "8,890"
        },
        "2.0": {
          "rap": "4,800",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "2.1": {
          "rap": "4,800",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "2.2": {
          "rap": "4,800",
          "low_price": "6,335",
          "high_price": "13,730"
        },
        "2.3": {
          "rap": "4,800",
          "low_price": "6,625",
          "high_price": "14,350"
        },
        "2.4": {
          "rap": "4,800",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "2.5": {
          "rap": "4,800",
          "low_price": "7,200",
          "high_price": "15,600"
        },
        "2.6": {
          "rap": "4,800",
          "low_price": "7,490",
          "high_price": "16,225"
        },
        "2.7": {
          "rap": "4,800",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "2.8": {
          "rap": "4,800",
          "low_price": "8,065",
          "high_price": "17,470"
        },
        "2.9": {
          "rap": "4,800",
          "low_price": "8,350",
          "high_price": "18,095"
        },
        "3.0": {
          "rap": "5,700",
          "low_price": "10,260",
          "high_price": "22,230"
        },
        "3.1": {
          "rap": "5,700",
          "low_price": "10,600",
          "high_price": "22,970"
        },
        "3.2": {
          "rap": "5,700",
          "low_price": "10,945",
          "high_price": "23,710"
        },
        "3.3": {
          "rap": "5,700",
          "low_price": "11,285",
          "high_price": "24,455"
        },
        "3.4": {
          "rap": "5,700",
          "low_price": "11,630",
          "high_price": "25,195"
        },
        "3.5": {
          "rap": "5,700",
          "low_price": "11,970",
          "high_price": "25,935"
        },
        "3.6": {
          "rap": "5,700",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "3.7": {
          "rap": "5,700",
          "low_price": "12,655",
          "high_price": "27,415"
        },
        "3.8": {
          "rap": "5,700",
          "low_price": "12,995",
          "high_price": "28,160"
        },
        "3.9": {
          "rap": "5,700",
          "low_price": "13,340",
          "high_price": "28,900"
        }
      },
      "J": {
        "0.4": {
          "rap": "700",
          "low_price": "170",
          "high_price": "365"
        },
        "0.5": {
          "rap": "1,100",
          "low_price": "300",
          "high_price": "650"
        },
        "0.6": {
          "rap": "1,100",
          "low_price": "360",
          "high_price": "780"
        },
        "0.7": {
          "rap": "1,500",
          "low_price": "545",
          "high_price": "1,185"
        },
        "0.8": {
          "rap": "1,500",
          "low_price": "625",
          "high_price": "1,350"
        },
        "0.9": {
          "rap": "1,900",
          "low_price": "920",
          "high_price": "1,990"
        },
        "1.0": {
          "rap": "2,200",
          "low_price": "1,140",
          "high_price": "2,470"
        },
        "1.1": {
          "rap": "2,200",
          "low_price": "1,255",
          "high_price": "2,715"
        },
        "1.2": {
          "rap": "2,200",
          "low_price": "1,370",
          "high_price": "2,965"
        },
        "1.3": {
          "rap": "2,200",
          "low_price": "1,480",
          "high_price": "3,210"
        },
        "1.4": {
          "rap": "2,200",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "1.5": {
          "rap": "3,500",
          "low_price": "2,970",
          "high_price": "6,435"
        },
        "1.6": {
          "rap": "3,500",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.7": {
          "rap": "3,500",
          "low_price": "3,365",
          "high_price": "7,295"
        },
        "1.8": {
          "rap": "3,500",
          "low_price": "3,565",
          "high_price": "7,720"
        },
        "1.9": {
          "rap": "3,500",
          "low_price": "3,760",
          "high_price": "8,150"
        },
        "2.0": {
          "rap": "4,500",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "2.1": {
          "rap": "4,500",
          "low_price": "5,670",
          "high_price": "12,285"
        },
        "2.2": {
          "rap": "4,500",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "2.3": {
          "rap": "4,500",
          "low_price": "6,210",
          "high_price": "13,455"
        },
        "2.4": {
          "rap": "4,500",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "2.5": {
          "rap": "4,500",
          "low_price": "6,750",
          "high_price": "14,625"
        },
        "2.6": {
          "rap": "4,500",
          "low_price": "7,020",
          "high_price": "15,210"
        },
        "2.7": {
          "rap": "4,500",
          "low_price": "7,290",
          "high_price": "15,795"
        },
        "2.8": {
          "rap": "4,500",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.9": {
          "rap": "4,500",
          "low_price": "7,830",
          "high_price": "16,965"
        },
        "3.0": {
          "rap": "5,400",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "3.1": {
          "rap": "5,400",
          "low_price": "10,045",
          "high_price": "21,760"
        },
        "3.2": {
          "rap": "5,400",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "3.3": {
          "rap": "5,400",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "3.4": {
          "rap": "5,400",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "3.5": {
          "rap": "5,400",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "3.6": {
          "rap": "5,400",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "3.7": {
          "rap": "5,400",
          "low_price": "11,990",
          "high_price": "25,975"
        },
        "3.8": {
          "rap": "5,400",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "3.9": {
          "rap": "5,400",
          "low_price": "12,635",
          "high_price": "27,380"
        }
      },
      "K": {
        "0.4": {
          "rap": "700",
          "low_price": "170",
          "high_price": "365"
        },
        "0.5": {
          "rap": "900",
          "low_price": "270",
          "high_price": "585"
        },
        "0.6": {
          "rap": "900",
          "low_price": "325",
          "high_price": "700"
        },
        "0.7": {
          "rap": "1,400",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.8": {
          "rap": "1,400",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.9": {
          "rap": "1,600",
          "low_price": "810",
          "high_price": "1,755"
        },
        "1.0": {
          "rap": "1,900",
          "low_price": "1,020",
          "high_price": "2,210"
        },
        "1.1": {
          "rap": "1,900",
          "low_price": "1,120",
          "high_price": "2,430"
        },
        "1.2": {
          "rap": "1,900",
          "low_price": "1,225",
          "high_price": "2,650"
        },
        "1.3": {
          "rap": "1,900",
          "low_price": "1,325",
          "high_price": "2,875"
        },
        "1.4": {
          "rap": "1,900",
          "low_price": "1,430",
          "high_price": "3,095"
        },
        "1.5": {
          "rap": "3,200",
          "low_price": "2,610",
          "high_price": "5,655"
        },
        "1.6": {
          "rap": "3,200",
          "low_price": "2,785",
          "high_price": "6,030"
        },
        "1.7": {
          "rap": "3,200",
          "low_price": "2,960",
          "high_price": "6,410"
        },
        "1.8": {
          "rap": "3,200",
          "low_price": "3,130",
          "high_price": "6,785"
        },
        "1.9": {
          "rap": "3,200",
          "low_price": "3,305",
          "high_price": "7,165"
        },
        "2.0": {
          "rap": "3,900",
          "low_price": "4,440",
          "high_price": "9,620"
        },
        "2.1": {
          "rap": "3,900",
          "low_price": "4,660",
          "high_price": "10,100"
        },
        "2.2": {
          "rap": "3,900",
          "low_price": "4,885",
          "high_price": "10,580"
        },
        "2.3": {
          "rap": "3,900",
          "low_price": "5,105",
          "high_price": "11,065"
        },
        "2.4": {
          "rap": "3,900",
          "low_price": "5,330",
          "high_price": "11,545"
        },
        "2.5": {
          "rap": "3,900",
          "low_price": "5,550",
          "high_price": "12,025"
        },
        "2.6": {
          "rap": "3,900",
          "low_price": "5,770",
          "high_price": "12,505"
        },
        "2.7": {
          "rap": "3,900",
          "low_price": "5,995",
          "high_price": "12,985"
        },
        "2.8": {
          "rap": "3,900",
          "low_price": "6,215",
          "high_price": "13,470"
        },
        "2.9": {
          "rap": "3,900",
          "low_price": "6,440",
          "high_price": "13,950"
        },
        "3.0": {
          "rap": "5,000",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "3.1": {
          "rap": "5,000",
          "low_price": "9,300",
          "high_price": "20,150"
        },
        "3.2": {
          "rap": "5,000",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "3.3": {
          "rap": "5,000",
          "low_price": "9,900",
          "high_price": "21,450"
        },
        "3.4": {
          "rap": "5,000",
          "low_price": "10,200",
          "high_price": "22,100"
        },
        "3.5": {
          "rap": "5,000",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "3.6": {
          "rap": "5,000",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "3.7": {
          "rap": "5,000",
          "low_price": "11,100",
          "high_price": "24,050"
        },
        "3.8": {
          "rap": "5,000",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "3.9": {
          "rap": "5,000",
          "low_price": "11,700",
          "high_price": "25,350"
        }
      }
    },
    "IF": {
      "D": {
        "0.4": {
          "rap": "3,300",
          "low_price": "695",
          "high_price": "1,510"
        },
        "0.5": {
          "rap": "4,100",
          "low_price": "990",
          "high_price": "2,145"
        },
        "0.6": {
          "rap": "4,100",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "0.7": {
          "rap": "6,200",
          "low_price": "1,975",
          "high_price": "4,275"
        },
        "0.8": {
          "rap": "6,200",
          "low_price": "2,255",
          "high_price": "4,890"
        },
        "0.9": {
          "rap": "9,200",
          "low_price": "3,620",
          "high_price": "7,840"
        },
        "1.0": {
          "rap": "12,500",
          "low_price": "5,580",
          "high_price": "12,090"
        },
        "1.1": {
          "rap": "12,500",
          "low_price": "6,140",
          "high_price": "13,300"
        },
        "1.2": {
          "rap": "12,500",
          "low_price": "6,695",
          "high_price": "14,510"
        },
        "1.3": {
          "rap": "12,500",
          "low_price": "7,255",
          "high_price": "15,715"
        },
        "1.4": {
          "rap": "12,500",
          "low_price": "7,810",
          "high_price": "16,925"
        },
        "1.5": {
          "rap": "18,200",
          "low_price": "12,690",
          "high_price": "27,495"
        },
        "1.6": {
          "rap": "18,200",
          "low_price": "13,535",
          "high_price": "29,330"
        },
        "1.7": {
          "rap": "18,200",
          "low_price": "14,380",
          "high_price": "31,160"
        },
        "1.8": {
          "rap": "18,200",
          "low_price": "15,230",
          "high_price": "32,995"
        },
        "1.9": {
          "rap": "18,200",
          "low_price": "16,075",
          "high_price": "34,825"
        },
        "2.0": {
          "rap": "25,500",
          "low_price": "25,800",
          "high_price": "55,900"
        },
        "2.1": {
          "rap": "25,500",
          "low_price": "27,090",
          "high_price": "58,695"
        },
        "2.2": {
          "rap": "25,500",
          "low_price": "28,380",
          "high_price": "61,490"
        },
        "2.3": {
          "rap": "25,500",
          "low_price": "29,670",
          "high_price": "64,285"
        },
        "2.4": {
          "rap": "25,500",
          "low_price": "30,960",
          "high_price": "67,080"
        },
        "2.5": {
          "rap": "25,500",
          "low_price": "32,250",
          "high_price": "69,875"
        },
        "2.6": {
          "rap": "25,500",
          "low_price": "33,540",
          "high_price": "72,670"
        },
        "2.7": {
          "rap": "25,500",
          "low_price": "34,830",
          "high_price": "75,465"
        },
        "2.8": {
          "rap": "25,500",
          "low_price": "36,120",
          "high_price": "78,260"
        },
        "2.9": {
          "rap": "25,500",
          "low_price": "37,410",
          "high_price": "81,055"
        },
        "3.0": {
          "rap": "46,000",
          "low_price": "75,600",
          "high_price": "163,800"
        },
        "3.1": {
          "rap": "46,000",
          "low_price": "78,120",
          "high_price": "169,260"
        },
        "3.2": {
          "rap": "46,000",
          "low_price": "80,640",
          "high_price": "174,720"
        },
        "3.3": {
          "rap": "46,000",
          "low_price": "83,160",
          "high_price": "180,180"
        },
        "3.4": {
          "rap": "46,000",
          "low_price": "85,680",
          "high_price": "185,640"
        },
        "3.5": {
          "rap": "46,000",
          "low_price": "88,200",
          "high_price": "191,100"
        },
        "3.6": {
          "rap": "46,000",
          "low_price": "90,720",
          "high_price": "196,560"
        },
        "3.7": {
          "rap": "46,000",
          "low_price": "93,240",
          "high_price": "202,020"
        },
        "3.8": {
          "rap": "46,000",
          "low_price": "95,760",
          "high_price": "207,480"
        },
        "3.9": {
          "rap": "46,000",
          "low_price": "98,280",
          "high_price": "212,940"
        }
      },
      "E": {
        "0.4": {
          "rap": "3,100",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.5": {
          "rap": "3,600",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.6": {
          "rap": "3,600",
          "low_price": "1,080",
          "high_price": "2,340"
        },
        "0.7": {
          "rap": "5,600",
          "low_price": "1,805",
          "high_price": "3,915"
        },
        "0.8": {
          "rap": "5,600",
          "low_price": "2,065",
          "high_price": "4,470"
        },
        "0.9": {
          "rap": "7,700",
          "low_price": "3,350",
          "high_price": "7,255"
        },
        "1.0": {
          "rap": "10,400",
          "low_price": "4,920",
          "high_price": "10,660"
        },
        "1.1": {
          "rap": "10,400",
          "low_price": "5,410",
          "high_price": "11,725"
        },
        "1.2": {
          "rap": "10,400",
          "low_price": "5,905",
          "high_price": "12,790"
        },
        "1.3": {
          "rap": "10,400",
          "low_price": "6,395",
          "high_price": "13,860"
        },
        "1.4": {
          "rap": "10,400",
          "low_price": "6,890",
          "high_price": "14,925"
        },
        "1.5": {
          "rap": "16,400",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "1.6": {
          "rap": "16,400",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "1.7": {
          "rap": "16,400",
          "low_price": "13,465",
          "high_price": "29,170"
        },
        "1.8": {
          "rap": "16,400",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "1.9": {
          "rap": "16,400",
          "low_price": "15,050",
          "high_price": "32,605"
        },
        "2.0": {
          "rap": "23,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.1": {
          "rap": "23,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.2": {
          "rap": "23,000",
          "low_price": "26,400",
          "high_price": "57,200"
        },
        "2.3": {
          "rap": "23,000",
          "low_price": "27,600",
          "high_price": "59,800"
        },
        "2.4": {
          "rap": "23,000",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "2.5": {
          "rap": "23,000",
          "low_price": "30,000",
          "high_price": "65,000"
        },
        "2.6": {
          "rap": "23,000",
          "low_price": "31,200",
          "high_price": "67,600"
        },
        "2.7": {
          "rap": "23,000",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "2.8": {
          "rap": "23,000",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "2.9": {
          "rap": "23,000",
          "low_price": "34,800",
          "high_price": "75,400"
        },
        "3.0": {
          "rap": "37,500",
          "low_price": "65,700",
          "high_price": "142,350"
        },
        "3.1": {
          "rap": "37,500",
          "low_price": "67,890",
          "high_price": "147,095"
        },
        "3.2": {
          "rap": "37,500",
          "low_price": "70,080",
          "high_price": "151,840"
        },
        "3.3": {
          "rap": "37,500",
          "low_price": "72,270",
          "high_price": "156,585"
        },
        "3.4": {
          "rap": "37,500",
          "low_price": "74,460",
          "high_price": "161,330"
        },
        "3.5": {
          "rap": "37,500",
          "low_price": "76,650",
          "high_price": "166,075"
        },
        "3.6": {
          "rap": "37,500",
          "low_price": "78,840",
          "high_price": "170,820"
        },
        "3.7": {
          "rap": "37,500",
          "low_price": "81,030",
          "high_price": "175,565"
        },
        "3.8": {
          "rap": "37,500",
          "low_price": "83,220",
          "high_price": "180,310"
        },
        "3.9": {
          "rap": "37,500",
          "low_price": "85,410",
          "high_price": "185,055"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,900",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.5": {
          "rap": "3,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.6": {
          "rap": "3,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.7": {
          "rap": "5,300",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.8": {
          "rap": "5,300",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "0.9": {
          "rap": "6,900",
          "low_price": "2,970",
          "high_price": "6,435"
        },
        "1.0": {
          "rap": "9,400",
          "low_price": "4,440",
          "high_price": "9,620"
        },
        "1.1": {
          "rap": "9,400",
          "low_price": "4,885",
          "high_price": "10,580"
        },
        "1.2": {
          "rap": "9,400",
          "low_price": "5,330",
          "high_price": "11,545"
        },
        "1.3": {
          "rap": "9,400",
          "low_price": "5,770",
          "high_price": "12,505"
        },
        "1.4": {
          "rap": "9,400",
          "low_price": "6,215",
          "high_price": "13,470"
        },
        "1.5": {
          "rap": "14,300",
          "low_price": "11,070",
          "high_price": "23,985"
        },
        "1.6": {
          "rap": "14,300",
          "low_price": "11,810",
          "high_price": "25,585"
        },
        "1.7": {
          "rap": "14,300",
          "low_price": "12,545",
          "high_price": "27,185"
        },
        "1.8": {
          "rap": "14,300",
          "low_price": "13,285",
          "high_price": "28,780"
        },
        "1.9": {
          "rap": "14,300",
          "low_price": "14,020",
          "high_price": "30,380"
        },
        "2.0": {
          "rap": "20,500",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "2.1": {
          "rap": "20,500",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "2.2": {
          "rap": "20,500",
          "low_price": "24,420",
          "high_price": "52,910"
        },
        "2.3": {
          "rap": "20,500",
          "low_price": "25,530",
          "high_price": "55,315"
        },
        "2.4": {
          "rap": "20,500",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "2.5": {
          "rap": "20,500",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "2.6": {
          "rap": "20,500",
          "low_price": "28,860",
          "high_price": "62,530"
        },
        "2.7": {
          "rap": "20,500",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "2.8": {
          "rap": "20,500",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "2.9": {
          "rap": "20,500",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.0": {
          "rap": "33,500",
          "low_price": "58,500",
          "high_price": "126,750"
        },
        "3.1": {
          "rap": "33,500",
          "low_price": "60,450",
          "high_price": "130,975"
        },
        "3.2": {
          "rap": "33,500",
          "low_price": "62,400",
          "high_price": "135,200"
        },
        "3.3": {
          "rap": "33,500",
          "low_price": "64,350",
          "high_price": "139,425"
        },
        "3.4": {
          "rap": "33,500",
          "low_price": "66,300",
          "high_price": "143,650"
        },
        "3.5": {
          "rap": "33,500",
          "low_price": "68,250",
          "high_price": "147,875"
        },
        "3.6": {
          "rap": "33,500",
          "low_price": "70,200",
          "high_price": "152,100"
        },
        "3.7": {
          "rap": "33,500",
          "low_price": "72,150",
          "high_price": "156,325"
        },
        "3.8": {
          "rap": "33,500",
          "low_price": "74,100",
          "high_price": "160,550"
        },
        "3.9": {
          "rap": "33,500",
          "low_price": "76,050",
          "high_price": "164,775"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,700",
          "low_price": "550",
          "high_price": "1,195"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,555",
          "high_price": "3,365"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,775",
          "high_price": "3,850"
        },
        "0.9": {
          "rap": "6,200",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "8,100",
          "low_price": "3,960",
          "high_price": "8,580"
        },
        "1.1": {
          "rap": "8,100",
          "low_price": "4,355",
          "high_price": "9,440"
        },
        "1.2": {
          "rap": "8,100",
          "low_price": "4,750",
          "high_price": "10,295"
        },
        "1.3": {
          "rap": "8,100",
          "low_price": "5,150",
          "high_price": "11,155"
        },
        "1.4": {
          "rap": "8,100",
          "low_price": "5,545",
          "high_price": "12,010"
        },
        "1.5": {
          "rap": "12,700",
          "low_price": "9,810",
          "high_price": "21,255"
        },
        "1.6": {
          "rap": "12,700",
          "low_price": "10,465",
          "high_price": "22,670"
        },
        "1.7": {
          "rap": "12,700",
          "low_price": "11,120",
          "high_price": "24,090"
        },
        "1.8": {
          "rap": "12,700",
          "low_price": "11,770",
          "high_price": "25,505"
        },
        "1.9": {
          "rap": "12,700",
          "low_price": "12,425",
          "high_price": "26,925"
        },
        "2.0": {
          "rap": "18,500",
          "low_price": "20,400",
          "high_price": "44,200"
        },
        "2.1": {
          "rap": "18,500",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "2.2": {
          "rap": "18,500",
          "low_price": "22,440",
          "high_price": "48,620"
        },
        "2.3": {
          "rap": "18,500",
          "low_price": "23,460",
          "high_price": "50,830"
        },
        "2.4": {
          "rap": "18,500",
          "low_price": "24,480",
          "high_price": "53,040"
        },
        "2.5": {
          "rap": "18,500",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "2.6": {
          "rap": "18,500",
          "low_price": "26,520",
          "high_price": "57,460"
        },
        "2.7": {
          "rap": "18,500",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "2.8": {
          "rap": "18,500",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "2.9": {
          "rap": "18,500",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.0": {
          "rap": "30,000",
          "low_price": "52,200",
          "high_price": "113,100"
        },
        "3.1": {
          "rap": "30,000",
          "low_price": "53,940",
          "high_price": "116,870"
        },
        "3.2": {
          "rap": "30,000",
          "low_price": "55,680",
          "high_price": "120,640"
        },
        "3.3": {
          "rap": "30,000",
          "low_price": "57,420",
          "high_price": "124,410"
        },
        "3.4": {
          "rap": "30,000",
          "low_price": "59,160",
          "high_price": "128,180"
        },
        "3.5": {
          "rap": "30,000",
          "low_price": "60,900",
          "high_price": "131,950"
        },
        "3.6": {
          "rap": "30,000",
          "low_price": "62,640",
          "high_price": "135,720"
        },
        "3.7": {
          "rap": "30,000",
          "low_price": "64,380",
          "high_price": "139,490"
        },
        "3.8": {
          "rap": "30,000",
          "low_price": "66,120",
          "high_price": "143,260"
        },
        "3.9": {
          "rap": "30,000",
          "low_price": "67,860",
          "high_price": "147,030"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,400",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.5": {
          "rap": "2,900",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "2,900",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "4,600",
          "low_price": "1,430",
          "high_price": "3,095"
        },
        "0.8": {
          "rap": "4,600",
          "low_price": "1,630",
          "high_price": "3,535"
        },
        "0.9": {
          "rap": "5,600",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.0": {
          "rap": "6,900",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "1.1": {
          "rap": "6,900",
          "low_price": "3,695",
          "high_price": "8,010"
        },
        "1.2": {
          "rap": "6,900",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.3": {
          "rap": "6,900",
          "low_price": "4,370",
          "high_price": "9,465"
        },
        "1.4": {
          "rap": "6,900",
          "low_price": "4,705",
          "high_price": "10,190"
        },
        "1.5": {
          "rap": "10,700",
          "low_price": "8,280",
          "high_price": "17,940"
        },
        "1.6": {
          "rap": "10,700",
          "low_price": "8,830",
          "high_price": "19,135"
        },
        "1.7": {
          "rap": "10,700",
          "low_price": "9,385",
          "high_price": "20,330"
        },
        "1.8": {
          "rap": "10,700",
          "low_price": "9,935",
          "high_price": "21,530"
        },
        "1.9": {
          "rap": "10,700",
          "low_price": "10,490",
          "high_price": "22,725"
        },
        "2.0": {
          "rap": "15,000",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.1": {
          "rap": "15,000",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "2.2": {
          "rap": "15,000",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.3": {
          "rap": "15,000",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.4": {
          "rap": "15,000",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.5": {
          "rap": "15,000",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.6": {
          "rap": "15,000",
          "low_price": "21,060",
          "high_price": "45,630"
        },
        "2.7": {
          "rap": "15,000",
          "low_price": "21,870",
          "high_price": "47,385"
        },
        "2.8": {
          "rap": "15,000",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.9": {
          "rap": "15,000",
          "low_price": "23,490",
          "high_price": "50,895"
        },
        "3.0": {
          "rap": "24,500",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.1": {
          "rap": "24,500",
          "low_price": "44,640",
          "high_price": "96,720"
        },
        "3.2": {
          "rap": "24,500",
          "low_price": "46,080",
          "high_price": "99,840"
        },
        "3.3": {
          "rap": "24,500",
          "low_price": "47,520",
          "high_price": "102,960"
        },
        "3.4": {
          "rap": "24,500",
          "low_price": "48,960",
          "high_price": "106,080"
        },
        "3.5": {
          "rap": "24,500",
          "low_price": "50,400",
          "high_price": "109,200"
        },
        "3.6": {
          "rap": "24,500",
          "low_price": "51,840",
          "high_price": "112,320"
        },
        "3.7": {
          "rap": "24,500",
          "low_price": "53,280",
          "high_price": "115,440"
        },
        "3.8": {
          "rap": "24,500",
          "low_price": "54,720",
          "high_price": "118,560"
        },
        "3.9": {
          "rap": "24,500",
          "low_price": "56,160",
          "high_price": "121,680"
        }
      },
      "I": {
        "0.4": {
          "rap": "2,100",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,600",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,600",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "3,800",
          "low_price": "1,300",
          "high_price": "2,820"
        },
        "0.8": {
          "rap": "3,800",
          "low_price": "1,490",
          "high_price": "3,225"
        },
        "0.9": {
          "rap": "4,800",
          "low_price": "2,215",
          "high_price": "4,795"
        },
        "1.0": {
          "rap": "5,900",
          "low_price": "2,820",
          "high_price": "6,110"
        },
        "1.1": {
          "rap": "5,900",
          "low_price": "3,100",
          "high_price": "6,720"
        },
        "1.2": {
          "rap": "5,900",
          "low_price": "3,385",
          "high_price": "7,330"
        },
        "1.3": {
          "rap": "5,900",
          "low_price": "3,665",
          "high_price": "7,945"
        },
        "1.4": {
          "rap": "5,900",
          "low_price": "3,950",
          "high_price": "8,555"
        },
        "1.5": {
          "rap": "8,900",
          "low_price": "7,110",
          "high_price": "15,405"
        },
        "1.6": {
          "rap": "8,900",
          "low_price": "7,585",
          "high_price": "16,430"
        },
        "1.7": {
          "rap": "8,900",
          "low_price": "8,060",
          "high_price": "17,460"
        },
        "1.8": {
          "rap": "8,900",
          "low_price": "8,530",
          "high_price": "18,485"
        },
        "1.9": {
          "rap": "8,900",
          "low_price": "9,005",
          "high_price": "19,515"
        },
        "2.0": {
          "rap": "11,800",
          "low_price": "12,960",
          "high_price": "28,080"
        },
        "2.1": {
          "rap": "11,800",
          "low_price": "13,610",
          "high_price": "29,485"
        },
        "2.2": {
          "rap": "11,800",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.3": {
          "rap": "11,800",
          "low_price": "14,905",
          "high_price": "32,290"
        },
        "2.4": {
          "rap": "11,800",
          "low_price": "15,550",
          "high_price": "33,695"
        },
        "2.5": {
          "rap": "11,800",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.6": {
          "rap": "11,800",
          "low_price": "16,850",
          "high_price": "36,505"
        },
        "2.7": {
          "rap": "11,800",
          "low_price": "17,495",
          "high_price": "37,910"
        },
        "2.8": {
          "rap": "11,800",
          "low_price": "18,145",
          "high_price": "39,310"
        },
        "2.9": {
          "rap": "11,800",
          "low_price": "18,790",
          "high_price": "40,715"
        },
        "3.0": {
          "rap": "20,000",
          "low_price": "35,100",
          "high_price": "76,050"
        },
        "3.1": {
          "rap": "20,000",
          "low_price": "36,270",
          "high_price": "78,585"
        },
        "3.2": {
          "rap": "20,000",
          "low_price": "37,440",
          "high_price": "81,120"
        },
        "3.3": {
          "rap": "20,000",
          "low_price": "38,610",
          "high_price": "83,655"
        },
        "3.4": {
          "rap": "20,000",
          "low_price": "39,780",
          "high_price": "86,190"
        },
        "3.5": {
          "rap": "20,000",
          "low_price": "40,950",
          "high_price": "88,725"
        },
        "3.6": {
          "rap": "20,000",
          "low_price": "42,120",
          "high_price": "91,260"
        },
        "3.7": {
          "rap": "20,000",
          "low_price": "43,290",
          "high_price": "93,795"
        },
        "3.8": {
          "rap": "20,000",
          "low_price": "44,460",
          "high_price": "96,330"
        },
        "3.9": {
          "rap": "20,000",
          "low_price": "45,630",
          "high_price": "98,865"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,800",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,200",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,200",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "1,090",
          "high_price": "2,365"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "1,250",
          "high_price": "2,705"
        },
        "0.9": {
          "rap": "3,900",
          "low_price": "1,945",
          "high_price": "4,210"
        },
        "1.0": {
          "rap": "4,800",
          "low_price": "2,400",
          "high_price": "5,200"
        },
        "1.1": {
          "rap": "4,800",
          "low_price": "2,640",
          "high_price": "5,720"
        },
        "1.2": {
          "rap": "4,800",
          "low_price": "2,880",
          "high_price": "6,240"
        },
        "1.3": {
          "rap": "4,800",
          "low_price": "3,120",
          "high_price": "6,760"
        },
        "1.4": {
          "rap": "4,800",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "1.5": {
          "rap": "7,200",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "1.6": {
          "rap": "7,200",
          "low_price": "6,145",
          "high_price": "13,310"
        },
        "1.7": {
          "rap": "7,200",
          "low_price": "6,530",
          "high_price": "14,145"
        },
        "1.8": {
          "rap": "7,200",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "1.9": {
          "rap": "7,200",
          "low_price": "7,295",
          "high_price": "15,810"
        },
        "2.0": {
          "rap": "9,400",
          "low_price": "10,560",
          "high_price": "22,880"
        },
        "2.1": {
          "rap": "9,400",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.2": {
          "rap": "9,400",
          "low_price": "11,615",
          "high_price": "25,170"
        },
        "2.3": {
          "rap": "9,400",
          "low_price": "12,145",
          "high_price": "26,310"
        },
        "2.4": {
          "rap": "9,400",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "2.5": {
          "rap": "9,400",
          "low_price": "13,200",
          "high_price": "28,600"
        },
        "2.6": {
          "rap": "9,400",
          "low_price": "13,730",
          "high_price": "29,745"
        },
        "2.7": {
          "rap": "9,400",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.8": {
          "rap": "9,400",
          "low_price": "14,785",
          "high_price": "32,030"
        },
        "2.9": {
          "rap": "9,400",
          "low_price": "15,310",
          "high_price": "33,175"
        },
        "3.0": {
          "rap": "15,900",
          "low_price": "27,720",
          "high_price": "60,060"
        },
        "3.1": {
          "rap": "15,900",
          "low_price": "28,645",
          "high_price": "62,060"
        },
        "3.2": {
          "rap": "15,900",
          "low_price": "29,570",
          "high_price": "64,065"
        },
        "3.3": {
          "rap": "15,900",
          "low_price": "30,490",
          "high_price": "66,065"
        },
        "3.4": {
          "rap": "15,900",
          "low_price": "31,415",
          "high_price": "68,070"
        },
        "3.5": {
          "rap": "15,900",
          "low_price": "32,340",
          "high_price": "70,070"
        },
        "3.6": {
          "rap": "15,900",
          "low_price": "33,265",
          "high_price": "72,070"
        },
        "3.7": {
          "rap": "15,900",
          "low_price": "34,190",
          "high_price": "74,075"
        },
        "3.8": {
          "rap": "15,900",
          "low_price": "35,110",
          "high_price": "76,075"
        },
        "3.9": {
          "rap": "15,900",
          "low_price": "36,035",
          "high_price": "78,080"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,500",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "2,500",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "2,500",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "3,200",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "3,900",
          "low_price": "2,040",
          "high_price": "4,420"
        },
        "1.1": {
          "rap": "3,900",
          "low_price": "2,245",
          "high_price": "4,860"
        },
        "1.2": {
          "rap": "3,900",
          "low_price": "2,450",
          "high_price": "5,305"
        },
        "1.3": {
          "rap": "3,900",
          "low_price": "2,650",
          "high_price": "5,745"
        },
        "1.4": {
          "rap": "3,900",
          "low_price": "2,855",
          "high_price": "6,190"
        },
        "1.5": {
          "rap": "5,700",
          "low_price": "4,410",
          "high_price": "9,555"
        },
        "1.6": {
          "rap": "5,700",
          "low_price": "4,705",
          "high_price": "10,190"
        },
        "1.7": {
          "rap": "5,700",
          "low_price": "5,000",
          "high_price": "10,830"
        },
        "1.8": {
          "rap": "5,700",
          "low_price": "5,290",
          "high_price": "11,465"
        },
        "1.9": {
          "rap": "5,700",
          "low_price": "5,585",
          "high_price": "12,105"
        },
        "2.0": {
          "rap": "7,600",
          "low_price": "8,400",
          "high_price": "18,200"
        },
        "2.1": {
          "rap": "7,600",
          "low_price": "8,820",
          "high_price": "19,110"
        },
        "2.2": {
          "rap": "7,600",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.3": {
          "rap": "7,600",
          "low_price": "9,660",
          "high_price": "20,930"
        },
        "2.4": {
          "rap": "7,600",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.5": {
          "rap": "7,600",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "2.6": {
          "rap": "7,600",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.7": {
          "rap": "7,600",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.8": {
          "rap": "7,600",
          "low_price": "11,760",
          "high_price": "25,480"
        },
        "2.9": {
          "rap": "7,600",
          "low_price": "12,180",
          "high_price": "26,390"
        },
        "3.0": {
          "rap": "12,300",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "3.1": {
          "rap": "12,300",
          "low_price": "22,135",
          "high_price": "47,955"
        },
        "3.2": {
          "rap": "12,300",
          "low_price": "22,850",
          "high_price": "49,505"
        },
        "3.3": {
          "rap": "12,300",
          "low_price": "23,560",
          "high_price": "51,050"
        },
        "3.4": {
          "rap": "12,300",
          "low_price": "24,275",
          "high_price": "52,600"
        },
        "3.5": {
          "rap": "12,300",
          "low_price": "24,990",
          "high_price": "54,145"
        },
        "3.6": {
          "rap": "12,300",
          "low_price": "25,705",
          "high_price": "55,690"
        },
        "3.7": {
          "rap": "12,300",
          "low_price": "26,420",
          "high_price": "57,240"
        },
        "3.8": {
          "rap": "12,300",
          "low_price": "27,130",
          "high_price": "58,785"
        },
        "3.9": {
          "rap": "12,300",
          "low_price": "27,845",
          "high_price": "60,335"
        }
      }
    },
    "SI1": {
      "D": {
        "0.4": {
          "rap": "2,000",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "2,500",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,500",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,000",
          "low_price": "1,175",
          "high_price": "2,550"
        },
        "0.8": {
          "rap": "4,000",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.9": {
          "rap": "5,000",
          "low_price": "2,000",
          "high_price": "4,330"
        },
        "1.0": {
          "rap": "6,300",
          "low_price": "2,760",
          "high_price": "5,980"
        },
        "1.1": {
          "rap": "6,300",
          "low_price": "3,035",
          "high_price": "6,580"
        },
        "1.2": {
          "rap": "6,300",
          "low_price": "3,310",
          "high_price": "7,175"
        },
        "1.3": {
          "rap": "6,300",
          "low_price": "3,590",
          "high_price": "7,775"
        },
        "1.4": {
          "rap": "6,300",
          "low_price": "3,865",
          "high_price": "8,370"
        },
        "1.5": {
          "rap": "11,000",
          "low_price": "7,290",
          "high_price": "15,795"
        },
        "1.6": {
          "rap": "11,000",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "1.7": {
          "rap": "11,000",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "1.8": {
          "rap": "11,000",
          "low_price": "8,750",
          "high_price": "18,955"
        },
        "1.9": {
          "rap": "11,000",
          "low_price": "9,235",
          "high_price": "20,005"
        },
        "2.0": {
          "rap": "15,100",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.1": {
          "rap": "15,100",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "2.2": {
          "rap": "15,100",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.3": {
          "rap": "15,100",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.4": {
          "rap": "15,100",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.5": {
          "rap": "15,100",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.6": {
          "rap": "15,100",
          "low_price": "21,060",
          "high_price": "45,630"
        },
        "2.7": {
          "rap": "15,100",
          "low_price": "21,870",
          "high_price": "47,385"
        },
        "2.8": {
          "rap": "15,100",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.9": {
          "rap": "15,100",
          "low_price": "23,490",
          "high_price": "50,895"
        },
        "3.0": {
          "rap": "23,000",
          "low_price": "41,400",
          "high_price": "89,700"
        },
        "3.1": {
          "rap": "23,000",
          "low_price": "42,780",
          "high_price": "92,690"
        },
        "3.2": {
          "rap": "23,000",
          "low_price": "44,160",
          "high_price": "95,680"
        },
        "3.3": {
          "rap": "23,000",
          "low_price": "45,540",
          "high_price": "98,670"
        },
        "3.4": {
          "rap": "23,000",
          "low_price": "46,920",
          "high_price": "101,660"
        },
        "3.5": {
          "rap": "23,000",
          "low_price": "48,300",
          "high_price": "104,650"
        },
        "3.6": {
          "rap": "23,000",
          "low_price": "49,680",
          "high_price": "107,640"
        },
        "3.7": {
          "rap": "23,000",
          "low_price": "51,060",
          "high_price": "110,630"
        },
        "3.8": {
          "rap": "23,000",
          "low_price": "52,440",
          "high_price": "113,620"
        },
        "3.9": {
          "rap": "23,000",
          "low_price": "53,820",
          "high_price": "116,610"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,900",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "2,300",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.6": {
          "rap": "2,300",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.7": {
          "rap": "3,800",
          "low_price": "1,090",
          "high_price": "2,365"
        },
        "0.8": {
          "rap": "3,800",
          "low_price": "1,250",
          "high_price": "2,705"
        },
        "0.9": {
          "rap": "4,800",
          "low_price": "1,890",
          "high_price": "4,095"
        },
        "1.0": {
          "rap": "6,000",
          "low_price": "2,580",
          "high_price": "5,590"
        },
        "1.1": {
          "rap": "6,000",
          "low_price": "2,840",
          "high_price": "6,150"
        },
        "1.2": {
          "rap": "6,000",
          "low_price": "3,095",
          "high_price": "6,710"
        },
        "1.3": {
          "rap": "6,000",
          "low_price": "3,355",
          "high_price": "7,265"
        },
        "1.4": {
          "rap": "6,000",
          "low_price": "3,610",
          "high_price": "7,825"
        },
        "1.5": {
          "rap": "10,500",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "1.6": {
          "rap": "10,500",
          "low_price": "7,295",
          "high_price": "15,810"
        },
        "1.7": {
          "rap": "10,500",
          "low_price": "7,750",
          "high_price": "16,795"
        },
        "1.8": {
          "rap": "10,500",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "1.9": {
          "rap": "10,500",
          "low_price": "8,665",
          "high_price": "18,770"
        },
        "2.0": {
          "rap": "14,100",
          "low_price": "15,000",
          "high_price": "32,500"
        },
        "2.1": {
          "rap": "14,100",
          "low_price": "15,750",
          "high_price": "34,125"
        },
        "2.2": {
          "rap": "14,100",
          "low_price": "16,500",
          "high_price": "35,750"
        },
        "2.3": {
          "rap": "14,100",
          "low_price": "17,250",
          "high_price": "37,375"
        },
        "2.4": {
          "rap": "14,100",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.5": {
          "rap": "14,100",
          "low_price": "18,750",
          "high_price": "40,625"
        },
        "2.6": {
          "rap": "14,100",
          "low_price": "19,500",
          "high_price": "42,250"
        },
        "2.7": {
          "rap": "14,100",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.8": {
          "rap": "14,100",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.9": {
          "rap": "14,100",
          "low_price": "21,750",
          "high_price": "47,125"
        },
        "3.0": {
          "rap": "21,500",
          "low_price": "38,700",
          "high_price": "83,850"
        },
        "3.1": {
          "rap": "21,500",
          "low_price": "39,990",
          "high_price": "86,645"
        },
        "3.2": {
          "rap": "21,500",
          "low_price": "41,280",
          "high_price": "89,440"
        },
        "3.3": {
          "rap": "21,500",
          "low_price": "42,570",
          "high_price": "92,235"
        },
        "3.4": {
          "rap": "21,500",
          "low_price": "43,860",
          "high_price": "95,030"
        },
        "3.5": {
          "rap": "21,500",
          "low_price": "45,150",
          "high_price": "97,825"
        },
        "3.6": {
          "rap": "21,500",
          "low_price": "46,440",
          "high_price": "100,620"
        },
        "3.7": {
          "rap": "21,500",
          "low_price": "47,730",
          "high_price": "103,415"
        },
        "3.8": {
          "rap": "21,500",
          "low_price": "49,020",
          "high_price": "106,210"
        },
        "3.9": {
          "rap": "21,500",
          "low_price": "50,310",
          "high_price": "109,005"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,800",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,200",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "2,200",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "3,600",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.8": {
          "rap": "3,600",
          "low_price": "1,150",
          "high_price": "2,495"
        },
        "0.9": {
          "rap": "4,600",
          "low_price": "1,780",
          "high_price": "3,860"
        },
        "1.0": {
          "rap": "5,700",
          "low_price": "2,400",
          "high_price": "5,200"
        },
        "1.1": {
          "rap": "5,700",
          "low_price": "2,640",
          "high_price": "5,720"
        },
        "1.2": {
          "rap": "5,700",
          "low_price": "2,880",
          "high_price": "6,240"
        },
        "1.3": {
          "rap": "5,700",
          "low_price": "3,120",
          "high_price": "6,760"
        },
        "1.4": {
          "rap": "5,700",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "1.5": {
          "rap": "9,900",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "1.6": {
          "rap": "9,900",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "1.7": {
          "rap": "9,900",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "1.8": {
          "rap": "9,900",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "1.9": {
          "rap": "9,900",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "2.0": {
          "rap": "13,200",
          "low_price": "14,040",
          "high_price": "30,420"
        },
        "2.1": {
          "rap": "13,200",
          "low_price": "14,740",
          "high_price": "31,940"
        },
        "2.2": {
          "rap": "13,200",
          "low_price": "15,445",
          "high_price": "33,460"
        },
        "2.3": {
          "rap": "13,200",
          "low_price": "16,145",
          "high_price": "34,985"
        },
        "2.4": {
          "rap": "13,200",
          "low_price": "16,850",
          "high_price": "36,505"
        },
        "2.5": {
          "rap": "13,200",
          "low_price": "17,550",
          "high_price": "38,025"
        },
        "2.6": {
          "rap": "13,200",
          "low_price": "18,250",
          "high_price": "39,545"
        },
        "2.7": {
          "rap": "13,200",
          "low_price": "18,955",
          "high_price": "41,065"
        },
        "2.8": {
          "rap": "13,200",
          "low_price": "19,655",
          "high_price": "42,590"
        },
        "2.9": {
          "rap": "13,200",
          "low_price": "20,360",
          "high_price": "44,110"
        },
        "3.0": {
          "rap": "19,500",
          "low_price": "36,000",
          "high_price": "78,000"
        },
        "3.1": {
          "rap": "19,500",
          "low_price": "37,200",
          "high_price": "80,600"
        },
        "3.2": {
          "rap": "19,500",
          "low_price": "38,400",
          "high_price": "83,200"
        },
        "3.3": {
          "rap": "19,500",
          "low_price": "39,600",
          "high_price": "85,800"
        },
        "3.4": {
          "rap": "19,500",
          "low_price": "40,800",
          "high_price": "88,400"
        },
        "3.5": {
          "rap": "19,500",
          "low_price": "42,000",
          "high_price": "91,000"
        },
        "3.6": {
          "rap": "19,500",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.7": {
          "rap": "19,500",
          "low_price": "44,400",
          "high_price": "96,200"
        },
        "3.8": {
          "rap": "19,500",
          "low_price": "45,600",
          "high_price": "98,800"
        },
        "3.9": {
          "rap": "19,500",
          "low_price": "46,800",
          "high_price": "101,400"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,700",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,300",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,300",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "4,400",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.0": {
          "rap": "5,400",
          "low_price": "2,280",
          "high_price": "4,940"
        },
        "1.1": {
          "rap": "5,400",
          "low_price": "2,510",
          "high_price": "5,435"
        },
        "1.2": {
          "rap": "5,400",
          "low_price": "2,735",
          "high_price": "5,930"
        },
        "1.3": {
          "rap": "5,400",
          "low_price": "2,965",
          "high_price": "6,420"
        },
        "1.4": {
          "rap": "5,400",
          "low_price": "3,190",
          "high_price": "6,915"
        },
        "1.5": {
          "rap": "9,200",
          "low_price": "6,030",
          "high_price": "13,065"
        },
        "1.6": {
          "rap": "9,200",
          "low_price": "6,430",
          "high_price": "13,935"
        },
        "1.7": {
          "rap": "9,200",
          "low_price": "6,835",
          "high_price": "14,805"
        },
        "1.8": {
          "rap": "9,200",
          "low_price": "7,235",
          "high_price": "15,680"
        },
        "1.9": {
          "rap": "9,200",
          "low_price": "7,640",
          "high_price": "16,550"
        },
        "2.0": {
          "rap": "12,200",
          "low_price": "12,840",
          "high_price": "27,820"
        },
        "2.1": {
          "rap": "12,200",
          "low_price": "13,480",
          "high_price": "29,210"
        },
        "2.2": {
          "rap": "12,200",
          "low_price": "14,125",
          "high_price": "30,600"
        },
        "2.3": {
          "rap": "12,200",
          "low_price": "14,765",
          "high_price": "31,995"
        },
        "2.4": {
          "rap": "12,200",
          "low_price": "15,410",
          "high_price": "33,385"
        },
        "2.5": {
          "rap": "12,200",
          "low_price": "16,050",
          "high_price": "34,775"
        },
        "2.6": {
          "rap": "12,200",
          "low_price": "16,690",
          "high_price": "36,165"
        },
        "2.7": {
          "rap": "12,200",
          "low_price": "17,335",
          "high_price": "37,555"
        },
        "2.8": {
          "rap": "12,200",
          "low_price": "17,975",
          "high_price": "38,950"
        },
        "2.9": {
          "rap": "12,200",
          "low_price": "18,620",
          "high_price": "40,340"
        },
        "3.0": {
          "rap": "18,000",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.1": {
          "rap": "18,000",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.2": {
          "rap": "18,000",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.3": {
          "rap": "18,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.4": {
          "rap": "18,000",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.5": {
          "rap": "18,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.6": {
          "rap": "18,000",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.7": {
          "rap": "18,000",
          "low_price": "41,070",
          "high_price": "88,985"
        },
        "3.8": {
          "rap": "18,000",
          "low_price": "42,180",
          "high_price": "91,390"
        },
        "3.9": {
          "rap": "18,000",
          "low_price": "43,290",
          "high_price": "93,795"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,600",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,000",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "2,000",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "4,000",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "5,000",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.1": {
          "rap": "5,000",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.2": {
          "rap": "5,000",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.3": {
          "rap": "5,000",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.4": {
          "rap": "5,000",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.5": {
          "rap": "8,500",
          "low_price": "5,580",
          "high_price": "12,090"
        },
        "1.6": {
          "rap": "8,500",
          "low_price": "5,950",
          "high_price": "12,895"
        },
        "1.7": {
          "rap": "8,500",
          "low_price": "6,325",
          "high_price": "13,700"
        },
        "1.8": {
          "rap": "8,500",
          "low_price": "6,695",
          "high_price": "14,510"
        },
        "1.9": {
          "rap": "8,500",
          "low_price": "7,070",
          "high_price": "15,315"
        },
        "2.0": {
          "rap": "11,100",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "2.1": {
          "rap": "11,100",
          "low_price": "12,475",
          "high_price": "27,025"
        },
        "2.2": {
          "rap": "11,100",
          "low_price": "13,070",
          "high_price": "28,315"
        },
        "2.3": {
          "rap": "11,100",
          "low_price": "13,660",
          "high_price": "29,600"
        },
        "2.4": {
          "rap": "11,100",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.5": {
          "rap": "11,100",
          "low_price": "14,850",
          "high_price": "32,175"
        },
        "2.6": {
          "rap": "11,100",
          "low_price": "15,445",
          "high_price": "33,460"
        },
        "2.7": {
          "rap": "11,100",
          "low_price": "16,040",
          "high_price": "34,750"
        },
        "2.8": {
          "rap": "11,100",
          "low_price": "16,630",
          "high_price": "36,035"
        },
        "2.9": {
          "rap": "11,100",
          "low_price": "17,225",
          "high_price": "37,325"
        },
        "3.0": {
          "rap": "16,000",
          "low_price": "29,700",
          "high_price": "64,350"
        },
        "3.1": {
          "rap": "16,000",
          "low_price": "30,690",
          "high_price": "66,495"
        },
        "3.2": {
          "rap": "16,000",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "3.3": {
          "rap": "16,000",
          "low_price": "32,670",
          "high_price": "70,785"
        },
        "3.4": {
          "rap": "16,000",
          "low_price": "33,660",
          "high_price": "72,930"
        },
        "3.5": {
          "rap": "16,000",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "3.6": {
          "rap": "16,000",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "3.7": {
          "rap": "16,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.8": {
          "rap": "16,000",
          "low_price": "37,620",
          "high_price": "81,510"
        },
        "3.9": {
          "rap": "16,000",
          "low_price": "38,610",
          "high_price": "83,655"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,700",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "2,700",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,460",
          "high_price": "3,160"
        },
        "1.0": {
          "rap": "4,400",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "1.1": {
          "rap": "4,400",
          "low_price": "2,110",
          "high_price": "4,575"
        },
        "1.2": {
          "rap": "4,400",
          "low_price": "2,305",
          "high_price": "4,990"
        },
        "1.3": {
          "rap": "4,400",
          "low_price": "2,495",
          "high_price": "5,410"
        },
        "1.4": {
          "rap": "4,400",
          "low_price": "2,690",
          "high_price": "5,825"
        },
        "1.5": {
          "rap": "7,300",
          "low_price": "5,040",
          "high_price": "10,920"
        },
        "1.6": {
          "rap": "7,300",
          "low_price": "5,375",
          "high_price": "11,650"
        },
        "1.7": {
          "rap": "7,300",
          "low_price": "5,710",
          "high_price": "12,375"
        },
        "1.8": {
          "rap": "7,300",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.9": {
          "rap": "7,300",
          "low_price": "6,385",
          "high_price": "13,830"
        },
        "2.0": {
          "rap": "9,300",
          "low_price": "10,200",
          "high_price": "22,100"
        },
        "2.1": {
          "rap": "9,300",
          "low_price": "10,710",
          "high_price": "23,205"
        },
        "2.2": {
          "rap": "9,300",
          "low_price": "11,220",
          "high_price": "24,310"
        },
        "2.3": {
          "rap": "9,300",
          "low_price": "11,730",
          "high_price": "25,415"
        },
        "2.4": {
          "rap": "9,300",
          "low_price": "12,240",
          "high_price": "26,520"
        },
        "2.5": {
          "rap": "9,300",
          "low_price": "12,750",
          "high_price": "27,625"
        },
        "2.6": {
          "rap": "9,300",
          "low_price": "13,260",
          "high_price": "28,730"
        },
        "2.7": {
          "rap": "9,300",
          "low_price": "13,770",
          "high_price": "29,835"
        },
        "2.8": {
          "rap": "9,300",
          "low_price": "14,280",
          "high_price": "30,940"
        },
        "2.9": {
          "rap": "9,300",
          "low_price": "14,790",
          "high_price": "32,045"
        },
        "3.0": {
          "rap": "14,000",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.1": {
          "rap": "14,000",
          "low_price": "26,970",
          "high_price": "58,435"
        },
        "3.2": {
          "rap": "14,000",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.3": {
          "rap": "14,000",
          "low_price": "28,710",
          "high_price": "62,205"
        },
        "3.4": {
          "rap": "14,000",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.5": {
          "rap": "14,000",
          "low_price": "30,450",
          "high_price": "65,975"
        },
        "3.6": {
          "rap": "14,000",
          "low_price": "31,320",
          "high_price": "67,860"
        },
        "3.7": {
          "rap": "14,000",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.8": {
          "rap": "14,000",
          "low_price": "33,060",
          "high_price": "71,630"
        },
        "3.9": {
          "rap": "14,000",
          "low_price": "33,930",
          "high_price": "73,515"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,200",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "3,000",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "1.0": {
          "rap": "3,600",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "3,600",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "3,600",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "3,600",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "3,600",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "5,800",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "5,800",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "5,800",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "5,800",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "5,800",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "7,700",
          "low_price": "8,400",
          "high_price": "18,200"
        },
        "2.1": {
          "rap": "7,700",
          "low_price": "8,820",
          "high_price": "19,110"
        },
        "2.2": {
          "rap": "7,700",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.3": {
          "rap": "7,700",
          "low_price": "9,660",
          "high_price": "20,930"
        },
        "2.4": {
          "rap": "7,700",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.5": {
          "rap": "7,700",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "2.6": {
          "rap": "7,700",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.7": {
          "rap": "7,700",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.8": {
          "rap": "7,700",
          "low_price": "11,760",
          "high_price": "25,480"
        },
        "2.9": {
          "rap": "7,700",
          "low_price": "12,180",
          "high_price": "26,390"
        },
        "3.0": {
          "rap": "11,100",
          "low_price": "19,980",
          "high_price": "43,290"
        },
        "3.1": {
          "rap": "11,100",
          "low_price": "20,645",
          "high_price": "44,735"
        },
        "3.2": {
          "rap": "11,100",
          "low_price": "21,310",
          "high_price": "46,175"
        },
        "3.3": {
          "rap": "11,100",
          "low_price": "21,980",
          "high_price": "47,620"
        },
        "3.4": {
          "rap": "11,100",
          "low_price": "22,645",
          "high_price": "49,060"
        },
        "3.5": {
          "rap": "11,100",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "3.6": {
          "rap": "11,100",
          "low_price": "23,975",
          "high_price": "51,950"
        },
        "3.7": {
          "rap": "11,100",
          "low_price": "24,640",
          "high_price": "53,390"
        },
        "3.8": {
          "rap": "11,100",
          "low_price": "25,310",
          "high_price": "54,835"
        },
        "3.9": {
          "rap": "11,100",
          "low_price": "25,975",
          "high_price": "56,275"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,000",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "2,000",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,000",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,500",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "2,900",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "1.1": {
          "rap": "2,900",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.2": {
          "rap": "2,900",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.3": {
          "rap": "2,900",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.4": {
          "rap": "2,900",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.5": {
          "rap": "4,700",
          "low_price": "3,510",
          "high_price": "7,605"
        },
        "1.6": {
          "rap": "4,700",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.7": {
          "rap": "4,700",
          "low_price": "3,980",
          "high_price": "8,620"
        },
        "1.8": {
          "rap": "4,700",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.9": {
          "rap": "4,700",
          "low_price": "4,445",
          "high_price": "9,635"
        },
        "2.0": {
          "rap": "6,300",
          "low_price": "6,600",
          "high_price": "14,300"
        },
        "2.1": {
          "rap": "6,300",
          "low_price": "6,930",
          "high_price": "15,015"
        },
        "2.2": {
          "rap": "6,300",
          "low_price": "7,260",
          "high_price": "15,730"
        },
        "2.3": {
          "rap": "6,300",
          "low_price": "7,590",
          "high_price": "16,445"
        },
        "2.4": {
          "rap": "6,300",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.5": {
          "rap": "6,300",
          "low_price": "8,250",
          "high_price": "17,875"
        },
        "2.6": {
          "rap": "6,300",
          "low_price": "8,580",
          "high_price": "18,590"
        },
        "2.7": {
          "rap": "6,300",
          "low_price": "8,910",
          "high_price": "19,305"
        },
        "2.8": {
          "rap": "6,300",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.9": {
          "rap": "6,300",
          "low_price": "9,570",
          "high_price": "20,735"
        },
        "3.0": {
          "rap": "8,800",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "3.1": {
          "rap": "8,800",
          "low_price": "16,370",
          "high_price": "35,465"
        },
        "3.2": {
          "rap": "8,800",
          "low_price": "16,895",
          "high_price": "36,610"
        },
        "3.3": {
          "rap": "8,800",
          "low_price": "17,425",
          "high_price": "37,750"
        },
        "3.4": {
          "rap": "8,800",
          "low_price": "17,950",
          "high_price": "38,895"
        },
        "3.5": {
          "rap": "8,800",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "3.6": {
          "rap": "8,800",
          "low_price": "19,010",
          "high_price": "41,185"
        },
        "3.7": {
          "rap": "8,800",
          "low_price": "19,535",
          "high_price": "42,330"
        },
        "3.8": {
          "rap": "8,800",
          "low_price": "20,065",
          "high_price": "43,470"
        },
        "3.9": {
          "rap": "8,800",
          "low_price": "20,590",
          "high_price": "44,615"
        }
      }
    },
    "SI2": {
      "D": {
        "0.4": {
          "rap": "1,700",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "3,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.8": {
          "rap": "3,400",
          "low_price": "1,150",
          "high_price": "2,495"
        },
        "0.9": {
          "rap": "4,400",
          "low_price": "1,780",
          "high_price": "3,860"
        },
        "1.0": {
          "rap": "5,300",
          "low_price": "2,340",
          "high_price": "5,070"
        },
        "1.1": {
          "rap": "5,300",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.2": {
          "rap": "5,300",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.3": {
          "rap": "5,300",
          "low_price": "3,040",
          "high_price": "6,590"
        },
        "1.4": {
          "rap": "5,300",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.5": {
          "rap": "9,100",
          "low_price": "6,030",
          "high_price": "13,065"
        },
        "1.6": {
          "rap": "9,100",
          "low_price": "6,430",
          "high_price": "13,935"
        },
        "1.7": {
          "rap": "9,100",
          "low_price": "6,835",
          "high_price": "14,805"
        },
        "1.8": {
          "rap": "9,100",
          "low_price": "7,235",
          "high_price": "15,680"
        },
        "1.9": {
          "rap": "9,100",
          "low_price": "7,640",
          "high_price": "16,550"
        },
        "2.0": {
          "rap": "12,100",
          "low_price": "12,360",
          "high_price": "26,780"
        },
        "2.1": {
          "rap": "12,100",
          "low_price": "12,980",
          "high_price": "28,120"
        },
        "2.2": {
          "rap": "12,100",
          "low_price": "13,595",
          "high_price": "29,460"
        },
        "2.3": {
          "rap": "12,100",
          "low_price": "14,215",
          "high_price": "30,795"
        },
        "2.4": {
          "rap": "12,100",
          "low_price": "14,830",
          "high_price": "32,135"
        },
        "2.5": {
          "rap": "12,100",
          "low_price": "15,450",
          "high_price": "33,475"
        },
        "2.6": {
          "rap": "12,100",
          "low_price": "16,070",
          "high_price": "34,815"
        },
        "2.7": {
          "rap": "12,100",
          "low_price": "16,685",
          "high_price": "36,155"
        },
        "2.8": {
          "rap": "12,100",
          "low_price": "17,305",
          "high_price": "37,490"
        },
        "2.9": {
          "rap": "12,100",
          "low_price": "17,920",
          "high_price": "38,830"
        },
        "3.0": {
          "rap": "17,500",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "3.1": {
          "rap": "17,500",
          "low_price": "33,480",
          "high_price": "72,540"
        },
        "3.2": {
          "rap": "17,500",
          "low_price": "34,560",
          "high_price": "74,880"
        },
        "3.3": {
          "rap": "17,500",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "3.4": {
          "rap": "17,500",
          "low_price": "36,720",
          "high_price": "79,560"
        },
        "3.5": {
          "rap": "17,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.6": {
          "rap": "17,500",
          "low_price": "38,880",
          "high_price": "84,240"
        },
        "3.7": {
          "rap": "17,500",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.8": {
          "rap": "17,500",
          "low_price": "41,040",
          "high_price": "88,920"
        },
        "3.9": {
          "rap": "17,500",
          "low_price": "42,120",
          "high_price": "91,260"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,600",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,200",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,200",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "4,200",
          "low_price": "1,675",
          "high_price": "3,625"
        },
        "1.0": {
          "rap": "5,100",
          "low_price": "2,220",
          "high_price": "4,810"
        },
        "1.1": {
          "rap": "5,100",
          "low_price": "2,440",
          "high_price": "5,290"
        },
        "1.2": {
          "rap": "5,100",
          "low_price": "2,665",
          "high_price": "5,770"
        },
        "1.3": {
          "rap": "5,100",
          "low_price": "2,885",
          "high_price": "6,255"
        },
        "1.4": {
          "rap": "5,100",
          "low_price": "3,110",
          "high_price": "6,735"
        },
        "1.5": {
          "rap": "8,600",
          "low_price": "5,670",
          "high_price": "12,285"
        },
        "1.6": {
          "rap": "8,600",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.7": {
          "rap": "8,600",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "1.8": {
          "rap": "8,600",
          "low_price": "6,805",
          "high_price": "14,740"
        },
        "1.9": {
          "rap": "8,600",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.0": {
          "rap": "11,400",
          "low_price": "11,520",
          "high_price": "24,960"
        },
        "2.1": {
          "rap": "11,400",
          "low_price": "12,095",
          "high_price": "26,210"
        },
        "2.2": {
          "rap": "11,400",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "2.3": {
          "rap": "11,400",
          "low_price": "13,250",
          "high_price": "28,705"
        },
        "2.4": {
          "rap": "11,400",
          "low_price": "13,825",
          "high_price": "29,950"
        },
        "2.5": {
          "rap": "11,400",
          "low_price": "14,400",
          "high_price": "31,200"
        },
        "2.6": {
          "rap": "11,400",
          "low_price": "14,975",
          "high_price": "32,450"
        },
        "2.7": {
          "rap": "11,400",
          "low_price": "15,550",
          "high_price": "33,695"
        },
        "2.8": {
          "rap": "11,400",
          "low_price": "16,130",
          "high_price": "34,945"
        },
        "2.9": {
          "rap": "11,400",
          "low_price": "16,705",
          "high_price": "36,190"
        },
        "3.0": {
          "rap": "16,500",
          "low_price": "30,600",
          "high_price": "66,300"
        },
        "3.1": {
          "rap": "16,500",
          "low_price": "31,620",
          "high_price": "68,510"
        },
        "3.2": {
          "rap": "16,500",
          "low_price": "32,640",
          "high_price": "70,720"
        },
        "3.3": {
          "rap": "16,500",
          "low_price": "33,660",
          "high_price": "72,930"
        },
        "3.4": {
          "rap": "16,500",
          "low_price": "34,680",
          "high_price": "75,140"
        },
        "3.5": {
          "rap": "16,500",
          "low_price": "35,700",
          "high_price": "77,350"
        },
        "3.6": {
          "rap": "16,500",
          "low_price": "36,720",
          "high_price": "79,560"
        },
        "3.7": {
          "rap": "16,500",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.8": {
          "rap": "16,500",
          "low_price": "38,760",
          "high_price": "83,980"
        },
        "3.9": {
          "rap": "16,500",
          "low_price": "39,780",
          "high_price": "86,190"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,500",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "4,000",
          "low_price": "1,565",
          "high_price": "3,395"
        },
        "1.0": {
          "rap": "4,900",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "1.1": {
          "rap": "4,900",
          "low_price": "2,310",
          "high_price": "5,005"
        },
        "1.2": {
          "rap": "4,900",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.3": {
          "rap": "4,900",
          "low_price": "2,730",
          "high_price": "5,915"
        },
        "1.4": {
          "rap": "4,900",
          "low_price": "2,940",
          "high_price": "6,370"
        },
        "1.5": {
          "rap": "8,200",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "1.6": {
          "rap": "8,200",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "1.7": {
          "rap": "8,200",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "1.8": {
          "rap": "8,200",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "1.9": {
          "rap": "8,200",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "2.0": {
          "rap": "10,800",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.1": {
          "rap": "10,800",
          "low_price": "11,465",
          "high_price": "24,845"
        },
        "2.2": {
          "rap": "10,800",
          "low_price": "12,010",
          "high_price": "26,025"
        },
        "2.3": {
          "rap": "10,800",
          "low_price": "12,560",
          "high_price": "27,210"
        },
        "2.4": {
          "rap": "10,800",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.5": {
          "rap": "10,800",
          "low_price": "13,650",
          "high_price": "29,575"
        },
        "2.6": {
          "rap": "10,800",
          "low_price": "14,195",
          "high_price": "30,760"
        },
        "2.7": {
          "rap": "10,800",
          "low_price": "14,740",
          "high_price": "31,940"
        },
        "2.8": {
          "rap": "10,800",
          "low_price": "15,290",
          "high_price": "33,125"
        },
        "2.9": {
          "rap": "10,800",
          "low_price": "15,835",
          "high_price": "34,305"
        },
        "3.0": {
          "rap": "15,500",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "3.1": {
          "rap": "15,500",
          "low_price": "29,760",
          "high_price": "64,480"
        },
        "3.2": {
          "rap": "15,500",
          "low_price": "30,720",
          "high_price": "66,560"
        },
        "3.3": {
          "rap": "15,500",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "3.4": {
          "rap": "15,500",
          "low_price": "32,640",
          "high_price": "70,720"
        },
        "3.5": {
          "rap": "15,500",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "3.6": {
          "rap": "15,500",
          "low_price": "34,560",
          "high_price": "74,880"
        },
        "3.7": {
          "rap": "15,500",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.8": {
          "rap": "15,500",
          "low_price": "36,480",
          "high_price": "79,040"
        },
        "3.9": {
          "rap": "15,500",
          "low_price": "37,440",
          "high_price": "81,120"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,800",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,800",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "3,800",
          "low_price": "1,460",
          "high_price": "3,160"
        },
        "1.0": {
          "rap": "4,700",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.1": {
          "rap": "4,700",
          "low_price": "2,180",
          "high_price": "4,720"
        },
        "1.2": {
          "rap": "4,700",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.3": {
          "rap": "4,700",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.4": {
          "rap": "4,700",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.5": {
          "rap": "7,800",
          "low_price": "5,040",
          "high_price": "10,920"
        },
        "1.6": {
          "rap": "7,800",
          "low_price": "5,375",
          "high_price": "11,650"
        },
        "1.7": {
          "rap": "7,800",
          "low_price": "5,710",
          "high_price": "12,375"
        },
        "1.8": {
          "rap": "7,800",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.9": {
          "rap": "7,800",
          "low_price": "6,385",
          "high_price": "13,830"
        },
        "2.0": {
          "rap": "10,300",
          "low_price": "10,320",
          "high_price": "22,360"
        },
        "2.1": {
          "rap": "10,300",
          "low_price": "10,835",
          "high_price": "23,480"
        },
        "2.2": {
          "rap": "10,300",
          "low_price": "11,350",
          "high_price": "24,595"
        },
        "2.3": {
          "rap": "10,300",
          "low_price": "11,870",
          "high_price": "25,715"
        },
        "2.4": {
          "rap": "10,300",
          "low_price": "12,385",
          "high_price": "26,830"
        },
        "2.5": {
          "rap": "10,300",
          "low_price": "12,900",
          "high_price": "27,950"
        },
        "2.6": {
          "rap": "10,300",
          "low_price": "13,415",
          "high_price": "29,070"
        },
        "2.7": {
          "rap": "10,300",
          "low_price": "13,930",
          "high_price": "30,185"
        },
        "2.8": {
          "rap": "10,300",
          "low_price": "14,450",
          "high_price": "31,305"
        },
        "2.9": {
          "rap": "10,300",
          "low_price": "14,965",
          "high_price": "32,420"
        },
        "3.0": {
          "rap": "14,500",
          "low_price": "27,000",
          "high_price": "58,500"
        },
        "3.1": {
          "rap": "14,500",
          "low_price": "27,900",
          "high_price": "60,450"
        },
        "3.2": {
          "rap": "14,500",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "3.3": {
          "rap": "14,500",
          "low_price": "29,700",
          "high_price": "64,350"
        },
        "3.4": {
          "rap": "14,500",
          "low_price": "30,600",
          "high_price": "66,300"
        },
        "3.5": {
          "rap": "14,500",
          "low_price": "31,500",
          "high_price": "68,250"
        },
        "3.6": {
          "rap": "14,500",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "3.7": {
          "rap": "14,500",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.8": {
          "rap": "14,500",
          "low_price": "34,200",
          "high_price": "74,100"
        },
        "3.9": {
          "rap": "14,500",
          "low_price": "35,100",
          "high_price": "76,050"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,300",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,600",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,600",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,350",
          "high_price": "2,925"
        },
        "1.0": {
          "rap": "4,400",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "4,400",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "4,400",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "4,400",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "4,400",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "7,400",
          "low_price": "4,680",
          "high_price": "10,140"
        },
        "1.6": {
          "rap": "7,400",
          "low_price": "4,990",
          "high_price": "10,815"
        },
        "1.7": {
          "rap": "7,400",
          "low_price": "5,305",
          "high_price": "11,490"
        },
        "1.8": {
          "rap": "7,400",
          "low_price": "5,615",
          "high_price": "12,170"
        },
        "1.9": {
          "rap": "7,400",
          "low_price": "5,930",
          "high_price": "12,845"
        },
        "2.0": {
          "rap": "9,600",
          "low_price": "9,840",
          "high_price": "21,320"
        },
        "2.1": {
          "rap": "9,600",
          "low_price": "10,330",
          "high_price": "22,385"
        },
        "2.2": {
          "rap": "9,600",
          "low_price": "10,825",
          "high_price": "23,450"
        },
        "2.3": {
          "rap": "9,600",
          "low_price": "11,315",
          "high_price": "24,520"
        },
        "2.4": {
          "rap": "9,600",
          "low_price": "11,810",
          "high_price": "25,585"
        },
        "2.5": {
          "rap": "9,600",
          "low_price": "12,300",
          "high_price": "26,650"
        },
        "2.6": {
          "rap": "9,600",
          "low_price": "12,790",
          "high_price": "27,715"
        },
        "2.7": {
          "rap": "9,600",
          "low_price": "13,285",
          "high_price": "28,780"
        },
        "2.8": {
          "rap": "9,600",
          "low_price": "13,775",
          "high_price": "29,850"
        },
        "2.9": {
          "rap": "9,600",
          "low_price": "14,270",
          "high_price": "30,915"
        },
        "3.0": {
          "rap": "13,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "3.1": {
          "rap": "13,500",
          "low_price": "26,040",
          "high_price": "56,420"
        },
        "3.2": {
          "rap": "13,500",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "3.3": {
          "rap": "13,500",
          "low_price": "27,720",
          "high_price": "60,060"
        },
        "3.4": {
          "rap": "13,500",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "3.5": {
          "rap": "13,500",
          "low_price": "29,400",
          "high_price": "63,700"
        },
        "3.6": {
          "rap": "13,500",
          "low_price": "30,240",
          "high_price": "65,520"
        },
        "3.7": {
          "rap": "13,500",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "3.8": {
          "rap": "13,500",
          "low_price": "31,920",
          "high_price": "69,160"
        },
        "3.9": {
          "rap": "13,500",
          "low_price": "32,760",
          "high_price": "70,980"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,200",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,500",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,400",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,400",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "3,200",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "4,000",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "1.1": {
          "rap": "4,000",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.2": {
          "rap": "4,000",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.3": {
          "rap": "4,000",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.4": {
          "rap": "4,000",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "1.5": {
          "rap": "6,700",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "6,700",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "6,700",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "6,700",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "6,700",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "8,900",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "2.1": {
          "rap": "8,900",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "2.2": {
          "rap": "8,900",
          "low_price": "9,900",
          "high_price": "21,450"
        },
        "2.3": {
          "rap": "8,900",
          "low_price": "10,350",
          "high_price": "22,425"
        },
        "2.4": {
          "rap": "8,900",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "2.5": {
          "rap": "8,900",
          "low_price": "11,250",
          "high_price": "24,375"
        },
        "2.6": {
          "rap": "8,900",
          "low_price": "11,700",
          "high_price": "25,350"
        },
        "2.7": {
          "rap": "8,900",
          "low_price": "12,150",
          "high_price": "26,325"
        },
        "2.8": {
          "rap": "8,900",
          "low_price": "12,600",
          "high_price": "27,300"
        },
        "2.9": {
          "rap": "8,900",
          "low_price": "13,050",
          "high_price": "28,275"
        },
        "3.0": {
          "rap": "12,000",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "3.1": {
          "rap": "12,000",
          "low_price": "23,250",
          "high_price": "50,375"
        },
        "3.2": {
          "rap": "12,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "3.3": {
          "rap": "12,000",
          "low_price": "24,750",
          "high_price": "53,625"
        },
        "3.4": {
          "rap": "12,000",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "3.5": {
          "rap": "12,000",
          "low_price": "26,250",
          "high_price": "56,875"
        },
        "3.6": {
          "rap": "12,000",
          "low_price": "27,000",
          "high_price": "58,500"
        },
        "3.7": {
          "rap": "12,000",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "3.8": {
          "rap": "12,000",
          "low_price": "28,500",
          "high_price": "61,750"
        },
        "3.9": {
          "rap": "12,000",
          "low_price": "29,250",
          "high_price": "63,375"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,100",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,700",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "3,300",
          "low_price": "1,500",
          "high_price": "3,250"
        },
        "1.1": {
          "rap": "3,300",
          "low_price": "1,650",
          "high_price": "3,575"
        },
        "1.2": {
          "rap": "3,300",
          "low_price": "1,800",
          "high_price": "3,900"
        },
        "1.3": {
          "rap": "3,300",
          "low_price": "1,950",
          "high_price": "4,225"
        },
        "1.4": {
          "rap": "3,300",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "1.5": {
          "rap": "5,500",
          "low_price": "3,960",
          "high_price": "8,580"
        },
        "1.6": {
          "rap": "5,500",
          "low_price": "4,225",
          "high_price": "9,150"
        },
        "1.7": {
          "rap": "5,500",
          "low_price": "4,490",
          "high_price": "9,725"
        },
        "1.8": {
          "rap": "5,500",
          "low_price": "4,750",
          "high_price": "10,295"
        },
        "1.9": {
          "rap": "5,500",
          "low_price": "5,015",
          "high_price": "10,870"
        },
        "2.0": {
          "rap": "7,400",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.1": {
          "rap": "7,400",
          "low_price": "7,940",
          "high_price": "17,200"
        },
        "2.2": {
          "rap": "7,400",
          "low_price": "8,315",
          "high_price": "18,020"
        },
        "2.3": {
          "rap": "7,400",
          "low_price": "8,695",
          "high_price": "18,835"
        },
        "2.4": {
          "rap": "7,400",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "2.5": {
          "rap": "7,400",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "2.6": {
          "rap": "7,400",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "2.7": {
          "rap": "7,400",
          "low_price": "10,205",
          "high_price": "22,115"
        },
        "2.8": {
          "rap": "7,400",
          "low_price": "10,585",
          "high_price": "22,930"
        },
        "2.9": {
          "rap": "7,400",
          "low_price": "10,960",
          "high_price": "23,750"
        },
        "3.0": {
          "rap": "10,200",
          "low_price": "18,360",
          "high_price": "39,780"
        },
        "3.1": {
          "rap": "10,200",
          "low_price": "18,970",
          "high_price": "41,105"
        },
        "3.2": {
          "rap": "10,200",
          "low_price": "19,585",
          "high_price": "42,430"
        },
        "3.3": {
          "rap": "10,200",
          "low_price": "20,195",
          "high_price": "43,760"
        },
        "3.4": {
          "rap": "10,200",
          "low_price": "20,810",
          "high_price": "45,085"
        },
        "3.5": {
          "rap": "10,200",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "3.6": {
          "rap": "10,200",
          "low_price": "22,030",
          "high_price": "47,735"
        },
        "3.7": {
          "rap": "10,200",
          "low_price": "22,645",
          "high_price": "49,060"
        },
        "3.8": {
          "rap": "10,200",
          "low_price": "23,255",
          "high_price": "50,390"
        },
        "3.9": {
          "rap": "10,200",
          "low_price": "23,870",
          "high_price": "51,715"
        }
      },
      "K": {
        "0.4": {
          "rap": "900",
          "low_price": "215",
          "high_price": "470"
        },
        "0.5": {
          "rap": "1,300",
          "low_price": "330",
          "high_price": "715"
        },
        "0.6": {
          "rap": "1,300",
          "low_price": "395",
          "high_price": "860"
        },
        "0.7": {
          "rap": "1,900",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.8": {
          "rap": "1,900",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.9": {
          "rap": "2,300",
          "low_price": "1,025",
          "high_price": "2,225"
        },
        "1.0": {
          "rap": "2,700",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "1.1": {
          "rap": "2,700",
          "low_price": "1,450",
          "high_price": "3,145"
        },
        "1.2": {
          "rap": "2,700",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.3": {
          "rap": "2,700",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.4": {
          "rap": "2,700",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.5": {
          "rap": "4,400",
          "low_price": "3,330",
          "high_price": "7,215"
        },
        "1.6": {
          "rap": "4,400",
          "low_price": "3,550",
          "high_price": "7,695"
        },
        "1.7": {
          "rap": "4,400",
          "low_price": "3,775",
          "high_price": "8,175"
        },
        "1.8": {
          "rap": "4,400",
          "low_price": "3,995",
          "high_price": "8,660"
        },
        "1.9": {
          "rap": "4,400",
          "low_price": "4,220",
          "high_price": "9,140"
        },
        "2.0": {
          "rap": "6,000",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "2.1": {
          "rap": "6,000",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "2.2": {
          "rap": "6,000",
          "low_price": "6,730",
          "high_price": "14,585"
        },
        "2.3": {
          "rap": "6,000",
          "low_price": "7,040",
          "high_price": "15,250"
        },
        "2.4": {
          "rap": "6,000",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "2.5": {
          "rap": "6,000",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "2.6": {
          "rap": "6,000",
          "low_price": "7,955",
          "high_price": "17,240"
        },
        "2.7": {
          "rap": "6,000",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "2.8": {
          "rap": "6,000",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "2.9": {
          "rap": "6,000",
          "low_price": "8,875",
          "high_price": "19,225"
        },
        "3.0": {
          "rap": "8,200",
          "low_price": "14,760",
          "high_price": "31,980"
        },
        "3.1": {
          "rap": "8,200",
          "low_price": "15,250",
          "high_price": "33,045"
        },
        "3.2": {
          "rap": "8,200",
          "low_price": "15,745",
          "high_price": "34,110"
        },
        "3.3": {
          "rap": "8,200",
          "low_price": "16,235",
          "high_price": "35,180"
        },
        "3.4": {
          "rap": "8,200",
          "low_price": "16,730",
          "high_price": "36,245"
        },
        "3.5": {
          "rap": "8,200",
          "low_price": "17,220",
          "high_price": "37,310"
        },
        "3.6": {
          "rap": "8,200",
          "low_price": "17,710",
          "high_price": "38,375"
        },
        "3.7": {
          "rap": "8,200",
          "low_price": "18,205",
          "high_price": "39,440"
        },
        "3.8": {
          "rap": "8,200",
          "low_price": "18,695",
          "high_price": "40,510"
        },
        "3.9": {
          "rap": "8,200",
          "low_price": "19,190",
          "high_price": "41,575"
        }
      }
    },
    "SI3": {
      "D": {
        "0.4": {
          "rap": "1,500",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,100",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,100",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "3,700",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "4,300",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "1.1": {
          "rap": "4,300",
          "low_price": "2,310",
          "high_price": "5,005"
        },
        "1.2": {
          "rap": "4,300",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.3": {
          "rap": "4,300",
          "low_price": "2,730",
          "high_price": "5,915"
        },
        "1.4": {
          "rap": "4,300",
          "low_price": "2,940",
          "high_price": "6,370"
        },
        "1.5": {
          "rap": "7,100",
          "low_price": "5,310",
          "high_price": "11,505"
        },
        "1.6": {
          "rap": "7,100",
          "low_price": "5,665",
          "high_price": "12,270"
        },
        "1.7": {
          "rap": "7,100",
          "low_price": "6,020",
          "high_price": "13,040"
        },
        "1.8": {
          "rap": "7,100",
          "low_price": "6,370",
          "high_price": "13,805"
        },
        "1.9": {
          "rap": "7,100",
          "low_price": "6,725",
          "high_price": "14,575"
        },
        "2.0": {
          "rap": "8,800",
          "low_price": "9,840",
          "high_price": "21,320"
        },
        "2.1": {
          "rap": "8,800",
          "low_price": "10,330",
          "high_price": "22,385"
        },
        "2.2": {
          "rap": "8,800",
          "low_price": "10,825",
          "high_price": "23,450"
        },
        "2.3": {
          "rap": "8,800",
          "low_price": "11,315",
          "high_price": "24,520"
        },
        "2.4": {
          "rap": "8,800",
          "low_price": "11,810",
          "high_price": "25,585"
        },
        "2.5": {
          "rap": "8,800",
          "low_price": "12,300",
          "high_price": "26,650"
        },
        "2.6": {
          "rap": "8,800",
          "low_price": "12,790",
          "high_price": "27,715"
        },
        "2.7": {
          "rap": "8,800",
          "low_price": "13,285",
          "high_price": "28,780"
        },
        "2.8": {
          "rap": "8,800",
          "low_price": "13,775",
          "high_price": "29,850"
        },
        "2.9": {
          "rap": "8,800",
          "low_price": "14,270",
          "high_price": "30,915"
        },
        "3.0": {
          "rap": "11,800",
          "low_price": "21,960",
          "high_price": "47,580"
        },
        "3.1": {
          "rap": "11,800",
          "low_price": "22,690",
          "high_price": "49,165"
        },
        "3.2": {
          "rap": "11,800",
          "low_price": "23,425",
          "high_price": "50,750"
        },
        "3.3": {
          "rap": "11,800",
          "low_price": "24,155",
          "high_price": "52,340"
        },
        "3.4": {
          "rap": "11,800",
          "low_price": "24,890",
          "high_price": "53,925"
        },
        "3.5": {
          "rap": "11,800",
          "low_price": "25,620",
          "high_price": "55,510"
        },
        "3.6": {
          "rap": "11,800",
          "low_price": "26,350",
          "high_price": "57,095"
        },
        "3.7": {
          "rap": "11,800",
          "low_price": "27,085",
          "high_price": "58,680"
        },
        "3.8": {
          "rap": "11,800",
          "low_price": "27,815",
          "high_price": "60,270"
        },
        "3.9": {
          "rap": "11,800",
          "low_price": "28,550",
          "high_price": "61,855"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "2,900",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "2,900",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "1.0": {
          "rap": "4,100",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.1": {
          "rap": "4,100",
          "low_price": "2,180",
          "high_price": "4,720"
        },
        "1.2": {
          "rap": "4,100",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.3": {
          "rap": "4,100",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.4": {
          "rap": "4,100",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.5": {
          "rap": "6,600",
          "low_price": "4,950",
          "high_price": "10,725"
        },
        "1.6": {
          "rap": "6,600",
          "low_price": "5,280",
          "high_price": "11,440"
        },
        "1.7": {
          "rap": "6,600",
          "low_price": "5,610",
          "high_price": "12,155"
        },
        "1.8": {
          "rap": "6,600",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "1.9": {
          "rap": "6,600",
          "low_price": "6,270",
          "high_price": "13,585"
        },
        "2.0": {
          "rap": "8,400",
          "low_price": "9,360",
          "high_price": "20,280"
        },
        "2.1": {
          "rap": "8,400",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "2.2": {
          "rap": "8,400",
          "low_price": "10,295",
          "high_price": "22,310"
        },
        "2.3": {
          "rap": "8,400",
          "low_price": "10,765",
          "high_price": "23,320"
        },
        "2.4": {
          "rap": "8,400",
          "low_price": "11,230",
          "high_price": "24,335"
        },
        "2.5": {
          "rap": "8,400",
          "low_price": "11,700",
          "high_price": "25,350"
        },
        "2.6": {
          "rap": "8,400",
          "low_price": "12,170",
          "high_price": "26,365"
        },
        "2.7": {
          "rap": "8,400",
          "low_price": "12,635",
          "high_price": "27,380"
        },
        "2.8": {
          "rap": "8,400",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.9": {
          "rap": "8,400",
          "low_price": "13,570",
          "high_price": "29,405"
        },
        "3.0": {
          "rap": "10,900",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "3.1": {
          "rap": "10,900",
          "low_price": "20,830",
          "high_price": "45,135"
        },
        "3.2": {
          "rap": "10,900",
          "low_price": "21,505",
          "high_price": "46,590"
        },
        "3.3": {
          "rap": "10,900",
          "low_price": "22,175",
          "high_price": "48,050"
        },
        "3.4": {
          "rap": "10,900",
          "low_price": "22,850",
          "high_price": "49,505"
        },
        "3.5": {
          "rap": "10,900",
          "low_price": "23,520",
          "high_price": "50,960"
        },
        "3.6": {
          "rap": "10,900",
          "low_price": "24,190",
          "high_price": "52,415"
        },
        "3.7": {
          "rap": "10,900",
          "low_price": "24,865",
          "high_price": "53,870"
        },
        "3.8": {
          "rap": "10,900",
          "low_price": "25,535",
          "high_price": "55,330"
        },
        "3.9": {
          "rap": "10,900",
          "low_price": "26,210",
          "high_price": "56,785"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,300",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,700",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,700",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "3,300",
          "low_price": "1,405",
          "high_price": "3,040"
        },
        "1.0": {
          "rap": "3,900",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "3,900",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "3,900",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "3,900",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "3,900",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "6,100",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.6": {
          "rap": "6,100",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.7": {
          "rap": "6,100",
          "low_price": "5,200",
          "high_price": "11,270"
        },
        "1.8": {
          "rap": "6,100",
          "low_price": "5,510",
          "high_price": "11,935"
        },
        "1.9": {
          "rap": "6,100",
          "low_price": "5,815",
          "high_price": "12,595"
        },
        "2.0": {
          "rap": "8,000",
          "low_price": "8,880",
          "high_price": "19,240"
        },
        "2.1": {
          "rap": "8,000",
          "low_price": "9,325",
          "high_price": "20,200"
        },
        "2.2": {
          "rap": "8,000",
          "low_price": "9,770",
          "high_price": "21,165"
        },
        "2.3": {
          "rap": "8,000",
          "low_price": "10,210",
          "high_price": "22,125"
        },
        "2.4": {
          "rap": "8,000",
          "low_price": "10,655",
          "high_price": "23,090"
        },
        "2.5": {
          "rap": "8,000",
          "low_price": "11,100",
          "high_price": "24,050"
        },
        "2.6": {
          "rap": "8,000",
          "low_price": "11,545",
          "high_price": "25,010"
        },
        "2.7": {
          "rap": "8,000",
          "low_price": "11,990",
          "high_price": "25,975"
        },
        "2.8": {
          "rap": "8,000",
          "low_price": "12,430",
          "high_price": "26,935"
        },
        "2.9": {
          "rap": "8,000",
          "low_price": "12,875",
          "high_price": "27,900"
        },
        "3.0": {
          "rap": "10,100",
          "low_price": "18,720",
          "high_price": "40,560"
        },
        "3.1": {
          "rap": "10,100",
          "low_price": "19,345",
          "high_price": "41,910"
        },
        "3.2": {
          "rap": "10,100",
          "low_price": "19,970",
          "high_price": "43,265"
        },
        "3.3": {
          "rap": "10,100",
          "low_price": "20,590",
          "high_price": "44,615"
        },
        "3.4": {
          "rap": "10,100",
          "low_price": "21,215",
          "high_price": "45,970"
        },
        "3.5": {
          "rap": "10,100",
          "low_price": "21,840",
          "high_price": "47,320"
        },
        "3.6": {
          "rap": "10,100",
          "low_price": "22,465",
          "high_price": "48,670"
        },
        "3.7": {
          "rap": "10,100",
          "low_price": "23,090",
          "high_price": "50,025"
        },
        "3.8": {
          "rap": "10,100",
          "low_price": "23,710",
          "high_price": "51,375"
        },
        "3.9": {
          "rap": "10,100",
          "low_price": "24,335",
          "high_price": "52,730"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,200",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,500",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,500",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "3,100",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "1.0": {
          "rap": "3,700",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "3,700",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "3,700",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "3,700",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "3,700",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "5,700",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "5,700",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "5,700",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "5,700",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "5,700",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "7,500",
          "low_price": "8,400",
          "high_price": "18,200"
        },
        "2.1": {
          "rap": "7,500",
          "low_price": "8,820",
          "high_price": "19,110"
        },
        "2.2": {
          "rap": "7,500",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.3": {
          "rap": "7,500",
          "low_price": "9,660",
          "high_price": "20,930"
        },
        "2.4": {
          "rap": "7,500",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.5": {
          "rap": "7,500",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "2.6": {
          "rap": "7,500",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.7": {
          "rap": "7,500",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.8": {
          "rap": "7,500",
          "low_price": "11,760",
          "high_price": "25,480"
        },
        "2.9": {
          "rap": "7,500",
          "low_price": "12,180",
          "high_price": "26,390"
        },
        "3.0": {
          "rap": "9,200",
          "low_price": "17,100",
          "high_price": "37,050"
        },
        "3.1": {
          "rap": "9,200",
          "low_price": "17,670",
          "high_price": "38,285"
        },
        "3.2": {
          "rap": "9,200",
          "low_price": "18,240",
          "high_price": "39,520"
        },
        "3.3": {
          "rap": "9,200",
          "low_price": "18,810",
          "high_price": "40,755"
        },
        "3.4": {
          "rap": "9,200",
          "low_price": "19,380",
          "high_price": "41,990"
        },
        "3.5": {
          "rap": "9,200",
          "low_price": "19,950",
          "high_price": "43,225"
        },
        "3.6": {
          "rap": "9,200",
          "low_price": "20,520",
          "high_price": "44,460"
        },
        "3.7": {
          "rap": "9,200",
          "low_price": "21,090",
          "high_price": "45,695"
        },
        "3.8": {
          "rap": "9,200",
          "low_price": "21,660",
          "high_price": "46,930"
        },
        "3.9": {
          "rap": "9,200",
          "low_price": "22,230",
          "high_price": "48,165"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,100",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,500",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,900",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "1.0": {
          "rap": "3,500",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.1": {
          "rap": "3,500",
          "low_price": "1,780",
          "high_price": "3,860"
        },
        "1.2": {
          "rap": "3,500",
          "low_price": "1,945",
          "high_price": "4,210"
        },
        "1.3": {
          "rap": "3,500",
          "low_price": "2,105",
          "high_price": "4,565"
        },
        "1.4": {
          "rap": "3,500",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.5": {
          "rap": "5,400",
          "low_price": "4,050",
          "high_price": "8,775"
        },
        "1.6": {
          "rap": "5,400",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.7": {
          "rap": "5,400",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.8": {
          "rap": "5,400",
          "low_price": "4,860",
          "high_price": "10,530"
        },
        "1.9": {
          "rap": "5,400",
          "low_price": "5,130",
          "high_price": "11,115"
        },
        "2.0": {
          "rap": "6,700",
          "low_price": "7,680",
          "high_price": "16,640"
        },
        "2.1": {
          "rap": "6,700",
          "low_price": "8,065",
          "high_price": "17,470"
        },
        "2.2": {
          "rap": "6,700",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "2.3": {
          "rap": "6,700",
          "low_price": "8,830",
          "high_price": "19,135"
        },
        "2.4": {
          "rap": "6,700",
          "low_price": "9,215",
          "high_price": "19,970"
        },
        "2.5": {
          "rap": "6,700",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "2.6": {
          "rap": "6,700",
          "low_price": "9,985",
          "high_price": "21,630"
        },
        "2.7": {
          "rap": "6,700",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "2.8": {
          "rap": "6,700",
          "low_price": "10,750",
          "high_price": "23,295"
        },
        "2.9": {
          "rap": "6,700",
          "low_price": "11,135",
          "high_price": "24,130"
        },
        "3.0": {
          "rap": "8,500",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "3.1": {
          "rap": "8,500",
          "low_price": "16,370",
          "high_price": "35,465"
        },
        "3.2": {
          "rap": "8,500",
          "low_price": "16,895",
          "high_price": "36,610"
        },
        "3.3": {
          "rap": "8,500",
          "low_price": "17,425",
          "high_price": "37,750"
        },
        "3.4": {
          "rap": "8,500",
          "low_price": "17,950",
          "high_price": "38,895"
        },
        "3.5": {
          "rap": "8,500",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "3.6": {
          "rap": "8,500",
          "low_price": "19,010",
          "high_price": "41,185"
        },
        "3.7": {
          "rap": "8,500",
          "low_price": "19,535",
          "high_price": "42,330"
        },
        "3.8": {
          "rap": "8,500",
          "low_price": "20,065",
          "high_price": "43,470"
        },
        "3.9": {
          "rap": "8,500",
          "low_price": "20,590",
          "high_price": "44,615"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,000",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "2,700",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "3,200",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "1.1": {
          "rap": "3,200",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.2": {
          "rap": "3,200",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.3": {
          "rap": "3,200",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.4": {
          "rap": "3,200",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.5": {
          "rap": "5,000",
          "low_price": "3,780",
          "high_price": "8,190"
        },
        "1.6": {
          "rap": "5,000",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.7": {
          "rap": "5,000",
          "low_price": "4,285",
          "high_price": "9,280"
        },
        "1.8": {
          "rap": "5,000",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.9": {
          "rap": "5,000",
          "low_price": "4,790",
          "high_price": "10,375"
        },
        "2.0": {
          "rap": "6,000",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "2.1": {
          "rap": "6,000",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.2": {
          "rap": "6,000",
          "low_price": "7,525",
          "high_price": "16,300"
        },
        "2.3": {
          "rap": "6,000",
          "low_price": "7,865",
          "high_price": "17,045"
        },
        "2.4": {
          "rap": "6,000",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "2.5": {
          "rap": "6,000",
          "low_price": "8,550",
          "high_price": "18,525"
        },
        "2.6": {
          "rap": "6,000",
          "low_price": "8,890",
          "high_price": "19,265"
        },
        "2.7": {
          "rap": "6,000",
          "low_price": "9,235",
          "high_price": "20,005"
        },
        "2.8": {
          "rap": "6,000",
          "low_price": "9,575",
          "high_price": "20,750"
        },
        "2.9": {
          "rap": "6,000",
          "low_price": "9,920",
          "high_price": "21,490"
        },
        "3.0": {
          "rap": "7,900",
          "low_price": "14,580",
          "high_price": "31,590"
        },
        "3.1": {
          "rap": "7,900",
          "low_price": "15,065",
          "high_price": "32,645"
        },
        "3.2": {
          "rap": "7,900",
          "low_price": "15,550",
          "high_price": "33,695"
        },
        "3.3": {
          "rap": "7,900",
          "low_price": "16,040",
          "high_price": "34,750"
        },
        "3.4": {
          "rap": "7,900",
          "low_price": "16,525",
          "high_price": "35,800"
        },
        "3.5": {
          "rap": "7,900",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "3.6": {
          "rap": "7,900",
          "low_price": "17,495",
          "high_price": "37,910"
        },
        "3.7": {
          "rap": "7,900",
          "low_price": "17,980",
          "high_price": "38,960"
        },
        "3.8": {
          "rap": "7,900",
          "low_price": "18,470",
          "high_price": "40,015"
        },
        "3.9": {
          "rap": "7,900",
          "low_price": "18,955",
          "high_price": "41,065"
        }
      },
      "J": {
        "0.4": {
          "rap": "900",
          "low_price": "215",
          "high_price": "470"
        },
        "0.5": {
          "rap": "1,300",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,300",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "1,900",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.8": {
          "rap": "1,900",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.9": {
          "rap": "2,300",
          "low_price": "1,025",
          "high_price": "2,225"
        },
        "1.0": {
          "rap": "2,700",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "1.1": {
          "rap": "2,700",
          "low_price": "1,450",
          "high_price": "3,145"
        },
        "1.2": {
          "rap": "2,700",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.3": {
          "rap": "2,700",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.4": {
          "rap": "2,700",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.5": {
          "rap": "4,400",
          "low_price": "3,420",
          "high_price": "7,410"
        },
        "1.6": {
          "rap": "4,400",
          "low_price": "3,650",
          "high_price": "7,905"
        },
        "1.7": {
          "rap": "4,400",
          "low_price": "3,875",
          "high_price": "8,400"
        },
        "1.8": {
          "rap": "4,400",
          "low_price": "4,105",
          "high_price": "8,890"
        },
        "1.9": {
          "rap": "4,400",
          "low_price": "4,330",
          "high_price": "9,385"
        },
        "2.0": {
          "rap": "5,400",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "2.1": {
          "rap": "5,400",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "2.2": {
          "rap": "5,400",
          "low_price": "6,730",
          "high_price": "14,585"
        },
        "2.3": {
          "rap": "5,400",
          "low_price": "7,040",
          "high_price": "15,250"
        },
        "2.4": {
          "rap": "5,400",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "2.5": {
          "rap": "5,400",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "2.6": {
          "rap": "5,400",
          "low_price": "7,955",
          "high_price": "17,240"
        },
        "2.7": {
          "rap": "5,400",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "2.8": {
          "rap": "5,400",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "2.9": {
          "rap": "5,400",
          "low_price": "8,875",
          "high_price": "19,225"
        },
        "3.0": {
          "rap": "7,100",
          "low_price": "12,780",
          "high_price": "27,690"
        },
        "3.1": {
          "rap": "7,100",
          "low_price": "13,205",
          "high_price": "28,615"
        },
        "3.2": {
          "rap": "7,100",
          "low_price": "13,630",
          "high_price": "29,535"
        },
        "3.3": {
          "rap": "7,100",
          "low_price": "14,060",
          "high_price": "30,460"
        },
        "3.4": {
          "rap": "7,100",
          "low_price": "14,485",
          "high_price": "31,380"
        },
        "3.5": {
          "rap": "7,100",
          "low_price": "14,910",
          "high_price": "32,305"
        },
        "3.6": {
          "rap": "7,100",
          "low_price": "15,335",
          "high_price": "33,230"
        },
        "3.7": {
          "rap": "7,100",
          "low_price": "15,760",
          "high_price": "34,150"
        },
        "3.8": {
          "rap": "7,100",
          "low_price": "16,190",
          "high_price": "35,075"
        },
        "3.9": {
          "rap": "7,100",
          "low_price": "16,615",
          "high_price": "35,995"
        }
      },
      "K": {
        "0.4": {
          "rap": "800",
          "low_price": "190",
          "high_price": "415"
        },
        "0.5": {
          "rap": "1,100",
          "low_price": "300",
          "high_price": "650"
        },
        "0.6": {
          "rap": "1,100",
          "low_price": "360",
          "high_price": "780"
        },
        "0.7": {
          "rap": "1,700",
          "low_price": "590",
          "high_price": "1,275"
        },
        "0.8": {
          "rap": "1,700",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.9": {
          "rap": "2,000",
          "low_price": "920",
          "high_price": "1,990"
        },
        "1.0": {
          "rap": "2,300",
          "low_price": "1,140",
          "high_price": "2,470"
        },
        "1.1": {
          "rap": "2,300",
          "low_price": "1,255",
          "high_price": "2,715"
        },
        "1.2": {
          "rap": "2,300",
          "low_price": "1,370",
          "high_price": "2,965"
        },
        "1.3": {
          "rap": "2,300",
          "low_price": "1,480",
          "high_price": "3,210"
        },
        "1.4": {
          "rap": "2,300",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "1.5": {
          "rap": "3,700",
          "low_price": "2,970",
          "high_price": "6,435"
        },
        "1.6": {
          "rap": "3,700",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.7": {
          "rap": "3,700",
          "low_price": "3,365",
          "high_price": "7,295"
        },
        "1.8": {
          "rap": "3,700",
          "low_price": "3,565",
          "high_price": "7,720"
        },
        "1.9": {
          "rap": "3,700",
          "low_price": "3,760",
          "high_price": "8,150"
        },
        "2.0": {
          "rap": "4,700",
          "low_price": "5,160",
          "high_price": "11,180"
        },
        "2.1": {
          "rap": "4,700",
          "low_price": "5,420",
          "high_price": "11,740"
        },
        "2.2": {
          "rap": "4,700",
          "low_price": "5,675",
          "high_price": "12,300"
        },
        "2.3": {
          "rap": "4,700",
          "low_price": "5,935",
          "high_price": "12,855"
        },
        "2.4": {
          "rap": "4,700",
          "low_price": "6,190",
          "high_price": "13,415"
        },
        "2.5": {
          "rap": "4,700",
          "low_price": "6,450",
          "high_price": "13,975"
        },
        "2.6": {
          "rap": "4,700",
          "low_price": "6,710",
          "high_price": "14,535"
        },
        "2.7": {
          "rap": "4,700",
          "low_price": "6,965",
          "high_price": "15,095"
        },
        "2.8": {
          "rap": "4,700",
          "low_price": "7,225",
          "high_price": "15,650"
        },
        "2.9": {
          "rap": "4,700",
          "low_price": "7,480",
          "high_price": "16,210"
        },
        "3.0": {
          "rap": "6,100",
          "low_price": "10,980",
          "high_price": "23,790"
        },
        "3.1": {
          "rap": "6,100",
          "low_price": "11,345",
          "high_price": "24,585"
        },
        "3.2": {
          "rap": "6,100",
          "low_price": "11,710",
          "high_price": "25,375"
        },
        "3.3": {
          "rap": "6,100",
          "low_price": "12,080",
          "high_price": "26,170"
        },
        "3.4": {
          "rap": "6,100",
          "low_price": "12,445",
          "high_price": "26,960"
        },
        "3.5": {
          "rap": "6,100",
          "low_price": "12,810",
          "high_price": "27,755"
        },
        "3.6": {
          "rap": "6,100",
          "low_price": "13,175",
          "high_price": "28,550"
        },
        "3.7": {
          "rap": "6,100",
          "low_price": "13,540",
          "high_price": "29,340"
        },
        "3.8": {
          "rap": "6,100",
          "low_price": "13,910",
          "high_price": "30,135"
        },
        "3.9": {
          "rap": "6,100",
          "low_price": "14,275",
          "high_price": "30,925"
        }
      }
    },
    "VS1": {
      "D": {
        "0.4": {
          "rap": "2,600",
          "low_price": "530",
          "high_price": "1,145"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,555",
          "high_price": "3,365"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,775",
          "high_price": "3,850"
        },
        "0.9": {
          "rap": "6,500",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "8,500",
          "low_price": "4,020",
          "high_price": "8,710"
        },
        "1.1": {
          "rap": "8,500",
          "low_price": "4,420",
          "high_price": "9,580"
        },
        "1.2": {
          "rap": "8,500",
          "low_price": "4,825",
          "high_price": "10,450"
        },
        "1.3": {
          "rap": "8,500",
          "low_price": "5,225",
          "high_price": "11,325"
        },
        "1.4": {
          "rap": "8,500",
          "low_price": "5,630",
          "high_price": "12,195"
        },
        "1.5": {
          "rap": "13,600",
          "low_price": "10,440",
          "high_price": "22,620"
        },
        "1.6": {
          "rap": "13,600",
          "low_price": "11,135",
          "high_price": "24,130"
        },
        "1.7": {
          "rap": "13,600",
          "low_price": "11,830",
          "high_price": "25,635"
        },
        "1.8": {
          "rap": "13,600",
          "low_price": "12,530",
          "high_price": "27,145"
        },
        "1.9": {
          "rap": "13,600",
          "low_price": "13,225",
          "high_price": "28,650"
        },
        "2.0": {
          "rap": "19,000",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.1": {
          "rap": "19,000",
          "low_price": "22,050",
          "high_price": "47,775"
        },
        "2.2": {
          "rap": "19,000",
          "low_price": "23,100",
          "high_price": "50,050"
        },
        "2.3": {
          "rap": "19,000",
          "low_price": "24,150",
          "high_price": "52,325"
        },
        "2.4": {
          "rap": "19,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.5": {
          "rap": "19,000",
          "low_price": "26,250",
          "high_price": "56,875"
        },
        "2.6": {
          "rap": "19,000",
          "low_price": "27,300",
          "high_price": "59,150"
        },
        "2.7": {
          "rap": "19,000",
          "low_price": "28,350",
          "high_price": "61,425"
        },
        "2.8": {
          "rap": "19,000",
          "low_price": "29,400",
          "high_price": "63,700"
        },
        "2.9": {
          "rap": "19,000",
          "low_price": "30,450",
          "high_price": "65,975"
        },
        "3.0": {
          "rap": "30,500",
          "low_price": "54,000",
          "high_price": "117,000"
        },
        "3.1": {
          "rap": "30,500",
          "low_price": "55,800",
          "high_price": "120,900"
        },
        "3.2": {
          "rap": "30,500",
          "low_price": "57,600",
          "high_price": "124,800"
        },
        "3.3": {
          "rap": "30,500",
          "low_price": "59,400",
          "high_price": "128,700"
        },
        "3.4": {
          "rap": "30,500",
          "low_price": "61,200",
          "high_price": "132,600"
        },
        "3.5": {
          "rap": "30,500",
          "low_price": "63,000",
          "high_price": "136,500"
        },
        "3.6": {
          "rap": "30,500",
          "low_price": "64,800",
          "high_price": "140,400"
        },
        "3.7": {
          "rap": "30,500",
          "low_price": "66,600",
          "high_price": "144,300"
        },
        "3.8": {
          "rap": "30,500",
          "low_price": "68,400",
          "high_price": "148,200"
        },
        "3.9": {
          "rap": "30,500",
          "low_price": "70,200",
          "high_price": "152,100"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,400",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "750",
          "high_price": "1,625"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.7": {
          "rap": "4,800",
          "low_price": "1,470",
          "high_price": "3,185"
        },
        "0.8": {
          "rap": "4,800",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.9": {
          "rap": "6,000",
          "low_price": "2,645",
          "high_price": "5,735"
        },
        "1.0": {
          "rap": "8,000",
          "low_price": "3,720",
          "high_price": "8,060"
        },
        "1.1": {
          "rap": "8,000",
          "low_price": "4,090",
          "high_price": "8,865"
        },
        "1.2": {
          "rap": "8,000",
          "low_price": "4,465",
          "high_price": "9,670"
        },
        "1.3": {
          "rap": "8,000",
          "low_price": "4,835",
          "high_price": "10,480"
        },
        "1.4": {
          "rap": "8,000",
          "low_price": "5,210",
          "high_price": "11,285"
        },
        "1.5": {
          "rap": "12,800",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "1.6": {
          "rap": "12,800",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "1.7": {
          "rap": "12,800",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "1.8": {
          "rap": "12,800",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "1.9": {
          "rap": "12,800",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "2.0": {
          "rap": "18,000",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "18,000",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "18,000",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "18,000",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "18,000",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "18,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "18,000",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "18,000",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "18,000",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "18,000",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "28,000",
          "low_price": "49,500",
          "high_price": "107,250"
        },
        "3.1": {
          "rap": "28,000",
          "low_price": "51,150",
          "high_price": "110,825"
        },
        "3.2": {
          "rap": "28,000",
          "low_price": "52,800",
          "high_price": "114,400"
        },
        "3.3": {
          "rap": "28,000",
          "low_price": "54,450",
          "high_price": "117,975"
        },
        "3.4": {
          "rap": "28,000",
          "low_price": "56,100",
          "high_price": "121,550"
        },
        "3.5": {
          "rap": "28,000",
          "low_price": "57,750",
          "high_price": "125,125"
        },
        "3.6": {
          "rap": "28,000",
          "low_price": "59,400",
          "high_price": "128,700"
        },
        "3.7": {
          "rap": "28,000",
          "low_price": "61,050",
          "high_price": "132,275"
        },
        "3.8": {
          "rap": "28,000",
          "low_price": "62,700",
          "high_price": "135,850"
        },
        "3.9": {
          "rap": "28,000",
          "low_price": "64,350",
          "high_price": "139,425"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,300",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,900",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "2,900",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "4,600",
          "low_price": "1,385",
          "high_price": "3,005"
        },
        "0.8": {
          "rap": "4,600",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "0.9": {
          "rap": "5,700",
          "low_price": "2,485",
          "high_price": "5,380"
        },
        "1.0": {
          "rap": "7,500",
          "low_price": "3,480",
          "high_price": "7,540"
        },
        "1.1": {
          "rap": "7,500",
          "low_price": "3,830",
          "high_price": "8,295"
        },
        "1.2": {
          "rap": "7,500",
          "low_price": "4,175",
          "high_price": "9,050"
        },
        "1.3": {
          "rap": "7,500",
          "low_price": "4,525",
          "high_price": "9,800"
        },
        "1.4": {
          "rap": "7,500",
          "low_price": "4,870",
          "high_price": "10,555"
        },
        "1.5": {
          "rap": "12,200",
          "low_price": "9,180",
          "high_price": "19,890"
        },
        "1.6": {
          "rap": "12,200",
          "low_price": "9,790",
          "high_price": "21,215"
        },
        "1.7": {
          "rap": "12,200",
          "low_price": "10,405",
          "high_price": "22,540"
        },
        "1.8": {
          "rap": "12,200",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "1.9": {
          "rap": "12,200",
          "low_price": "11,630",
          "high_price": "25,195"
        },
        "2.0": {
          "rap": "17,000",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.1": {
          "rap": "17,000",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "2.2": {
          "rap": "17,000",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.3": {
          "rap": "17,000",
          "low_price": "20,700",
          "high_price": "44,850"
        },
        "2.4": {
          "rap": "17,000",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "2.5": {
          "rap": "17,000",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "2.6": {
          "rap": "17,000",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.7": {
          "rap": "17,000",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "2.8": {
          "rap": "17,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.9": {
          "rap": "17,000",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.0": {
          "rap": "25,000",
          "low_price": "45,000",
          "high_price": "97,500"
        },
        "3.1": {
          "rap": "25,000",
          "low_price": "46,500",
          "high_price": "100,750"
        },
        "3.2": {
          "rap": "25,000",
          "low_price": "48,000",
          "high_price": "104,000"
        },
        "3.3": {
          "rap": "25,000",
          "low_price": "49,500",
          "high_price": "107,250"
        },
        "3.4": {
          "rap": "25,000",
          "low_price": "51,000",
          "high_price": "110,500"
        },
        "3.5": {
          "rap": "25,000",
          "low_price": "52,500",
          "high_price": "113,750"
        },
        "3.6": {
          "rap": "25,000",
          "low_price": "54,000",
          "high_price": "117,000"
        },
        "3.7": {
          "rap": "25,000",
          "low_price": "55,500",
          "high_price": "120,250"
        },
        "3.8": {
          "rap": "25,000",
          "low_price": "57,000",
          "high_price": "123,500"
        },
        "3.9": {
          "rap": "25,000",
          "low_price": "58,500",
          "high_price": "126,750"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,200",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "2,700",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,700",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,300",
          "low_price": "1,300",
          "high_price": "2,820"
        },
        "0.8": {
          "rap": "4,300",
          "low_price": "1,490",
          "high_price": "3,225"
        },
        "0.9": {
          "rap": "5,400",
          "low_price": "2,320",
          "high_price": "5,030"
        },
        "1.0": {
          "rap": "7,000",
          "low_price": "3,240",
          "high_price": "7,020"
        },
        "1.1": {
          "rap": "7,000",
          "low_price": "3,565",
          "high_price": "7,720"
        },
        "1.2": {
          "rap": "7,000",
          "low_price": "3,890",
          "high_price": "8,425"
        },
        "1.3": {
          "rap": "7,000",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.4": {
          "rap": "7,000",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.5": {
          "rap": "11,200",
          "low_price": "8,370",
          "high_price": "18,135"
        },
        "1.6": {
          "rap": "11,200",
          "low_price": "8,930",
          "high_price": "19,345"
        },
        "1.7": {
          "rap": "11,200",
          "low_price": "9,485",
          "high_price": "20,555"
        },
        "1.8": {
          "rap": "11,200",
          "low_price": "10,045",
          "high_price": "21,760"
        },
        "1.9": {
          "rap": "11,200",
          "low_price": "10,600",
          "high_price": "22,970"
        },
        "2.0": {
          "rap": "15,500",
          "low_price": "16,800",
          "high_price": "36,400"
        },
        "2.1": {
          "rap": "15,500",
          "low_price": "17,640",
          "high_price": "38,220"
        },
        "2.2": {
          "rap": "15,500",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "2.3": {
          "rap": "15,500",
          "low_price": "19,320",
          "high_price": "41,860"
        },
        "2.4": {
          "rap": "15,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.5": {
          "rap": "15,500",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.6": {
          "rap": "15,500",
          "low_price": "21,840",
          "high_price": "47,320"
        },
        "2.7": {
          "rap": "15,500",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.8": {
          "rap": "15,500",
          "low_price": "23,520",
          "high_price": "50,960"
        },
        "2.9": {
          "rap": "15,500",
          "low_price": "24,360",
          "high_price": "52,780"
        },
        "3.0": {
          "rap": "22,500",
          "low_price": "40,500",
          "high_price": "87,750"
        },
        "3.1": {
          "rap": "22,500",
          "low_price": "41,850",
          "high_price": "90,675"
        },
        "3.2": {
          "rap": "22,500",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.3": {
          "rap": "22,500",
          "low_price": "44,550",
          "high_price": "96,525"
        },
        "3.4": {
          "rap": "22,500",
          "low_price": "45,900",
          "high_price": "99,450"
        },
        "3.5": {
          "rap": "22,500",
          "low_price": "47,250",
          "high_price": "102,375"
        },
        "3.6": {
          "rap": "22,500",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.7": {
          "rap": "22,500",
          "low_price": "49,950",
          "high_price": "108,225"
        },
        "3.8": {
          "rap": "22,500",
          "low_price": "51,300",
          "high_price": "111,150"
        },
        "3.9": {
          "rap": "22,500",
          "low_price": "52,650",
          "high_price": "114,075"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,000",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "2,500",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "2,500",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "3,900",
          "low_price": "1,175",
          "high_price": "2,550"
        },
        "0.8": {
          "rap": "3,900",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.9": {
          "rap": "4,900",
          "low_price": "2,105",
          "high_price": "4,565"
        },
        "1.0": {
          "rap": "6,000",
          "low_price": "2,760",
          "high_price": "5,980"
        },
        "1.1": {
          "rap": "6,000",
          "low_price": "3,035",
          "high_price": "6,580"
        },
        "1.2": {
          "rap": "6,000",
          "low_price": "3,310",
          "high_price": "7,175"
        },
        "1.3": {
          "rap": "6,000",
          "low_price": "3,590",
          "high_price": "7,775"
        },
        "1.4": {
          "rap": "6,000",
          "low_price": "3,865",
          "high_price": "8,370"
        },
        "1.5": {
          "rap": "9,500",
          "low_price": "7,110",
          "high_price": "15,405"
        },
        "1.6": {
          "rap": "9,500",
          "low_price": "7,585",
          "high_price": "16,430"
        },
        "1.7": {
          "rap": "9,500",
          "low_price": "8,060",
          "high_price": "17,460"
        },
        "1.8": {
          "rap": "9,500",
          "low_price": "8,530",
          "high_price": "18,485"
        },
        "1.9": {
          "rap": "9,500",
          "low_price": "9,005",
          "high_price": "19,515"
        },
        "2.0": {
          "rap": "13,000",
          "low_price": "13,800",
          "high_price": "29,900"
        },
        "2.1": {
          "rap": "13,000",
          "low_price": "14,490",
          "high_price": "31,395"
        },
        "2.2": {
          "rap": "13,000",
          "low_price": "15,180",
          "high_price": "32,890"
        },
        "2.3": {
          "rap": "13,000",
          "low_price": "15,870",
          "high_price": "34,385"
        },
        "2.4": {
          "rap": "13,000",
          "low_price": "16,560",
          "high_price": "35,880"
        },
        "2.5": {
          "rap": "13,000",
          "low_price": "17,250",
          "high_price": "37,375"
        },
        "2.6": {
          "rap": "13,000",
          "low_price": "17,940",
          "high_price": "38,870"
        },
        "2.7": {
          "rap": "13,000",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.8": {
          "rap": "13,000",
          "low_price": "19,320",
          "high_price": "41,860"
        },
        "2.9": {
          "rap": "13,000",
          "low_price": "20,010",
          "high_price": "43,355"
        },
        "3.0": {
          "rap": "20,000",
          "low_price": "35,100",
          "high_price": "76,050"
        },
        "3.1": {
          "rap": "20,000",
          "low_price": "36,270",
          "high_price": "78,585"
        },
        "3.2": {
          "rap": "20,000",
          "low_price": "37,440",
          "high_price": "81,120"
        },
        "3.3": {
          "rap": "20,000",
          "low_price": "38,610",
          "high_price": "83,655"
        },
        "3.4": {
          "rap": "20,000",
          "low_price": "39,780",
          "high_price": "86,190"
        },
        "3.5": {
          "rap": "20,000",
          "low_price": "40,950",
          "high_price": "88,725"
        },
        "3.6": {
          "rap": "20,000",
          "low_price": "42,120",
          "high_price": "91,260"
        },
        "3.7": {
          "rap": "20,000",
          "low_price": "43,290",
          "high_price": "93,795"
        },
        "3.8": {
          "rap": "20,000",
          "low_price": "44,460",
          "high_price": "96,330"
        },
        "3.9": {
          "rap": "20,000",
          "low_price": "45,630",
          "high_price": "98,865"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,800",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "2,300",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "2,300",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,200",
          "low_price": "1,050",
          "high_price": "2,275"
        },
        "0.8": {
          "rap": "3,200",
          "low_price": "1,200",
          "high_price": "2,600"
        },
        "0.9": {
          "rap": "4,200",
          "low_price": "1,835",
          "high_price": "3,980"
        },
        "1.0": {
          "rap": "5,200",
          "low_price": "2,340",
          "high_price": "5,070"
        },
        "1.1": {
          "rap": "5,200",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.2": {
          "rap": "5,200",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.3": {
          "rap": "5,200",
          "low_price": "3,040",
          "high_price": "6,590"
        },
        "1.4": {
          "rap": "5,200",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.5": {
          "rap": "7,900",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "1.6": {
          "rap": "7,900",
          "low_price": "6,530",
          "high_price": "14,145"
        },
        "1.7": {
          "rap": "7,900",
          "low_price": "6,935",
          "high_price": "15,030"
        },
        "1.8": {
          "rap": "7,900",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "1.9": {
          "rap": "7,900",
          "low_price": "7,750",
          "high_price": "16,795"
        },
        "2.0": {
          "rap": "10,300",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "2.1": {
          "rap": "10,300",
          "low_price": "11,970",
          "high_price": "25,935"
        },
        "2.2": {
          "rap": "10,300",
          "low_price": "12,540",
          "high_price": "27,170"
        },
        "2.3": {
          "rap": "10,300",
          "low_price": "13,110",
          "high_price": "28,405"
        },
        "2.4": {
          "rap": "10,300",
          "low_price": "13,680",
          "high_price": "29,640"
        },
        "2.5": {
          "rap": "10,300",
          "low_price": "14,250",
          "high_price": "30,875"
        },
        "2.6": {
          "rap": "10,300",
          "low_price": "14,820",
          "high_price": "32,110"
        },
        "2.7": {
          "rap": "10,300",
          "low_price": "15,390",
          "high_price": "33,345"
        },
        "2.8": {
          "rap": "10,300",
          "low_price": "15,960",
          "high_price": "34,580"
        },
        "2.9": {
          "rap": "10,300",
          "low_price": "16,530",
          "high_price": "35,815"
        },
        "3.0": {
          "rap": "17,000",
          "low_price": "29,700",
          "high_price": "64,350"
        },
        "3.1": {
          "rap": "17,000",
          "low_price": "30,690",
          "high_price": "66,495"
        },
        "3.2": {
          "rap": "17,000",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "3.3": {
          "rap": "17,000",
          "low_price": "32,670",
          "high_price": "70,785"
        },
        "3.4": {
          "rap": "17,000",
          "low_price": "33,660",
          "high_price": "72,930"
        },
        "3.5": {
          "rap": "17,000",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "3.6": {
          "rap": "17,000",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "3.7": {
          "rap": "17,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.8": {
          "rap": "17,000",
          "low_price": "37,620",
          "high_price": "81,510"
        },
        "3.9": {
          "rap": "17,000",
          "low_price": "38,610",
          "high_price": "83,655"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,500",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,700",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "2,700",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "4,200",
          "low_price": "2,040",
          "high_price": "4,420"
        },
        "1.1": {
          "rap": "4,200",
          "low_price": "2,245",
          "high_price": "4,860"
        },
        "1.2": {
          "rap": "4,200",
          "low_price": "2,450",
          "high_price": "5,305"
        },
        "1.3": {
          "rap": "4,200",
          "low_price": "2,650",
          "high_price": "5,745"
        },
        "1.4": {
          "rap": "4,200",
          "low_price": "2,855",
          "high_price": "6,190"
        },
        "1.5": {
          "rap": "6,300",
          "low_price": "4,950",
          "high_price": "10,725"
        },
        "1.6": {
          "rap": "6,300",
          "low_price": "5,280",
          "high_price": "11,440"
        },
        "1.7": {
          "rap": "6,300",
          "low_price": "5,610",
          "high_price": "12,155"
        },
        "1.8": {
          "rap": "6,300",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "1.9": {
          "rap": "6,300",
          "low_price": "6,270",
          "high_price": "13,585"
        },
        "2.0": {
          "rap": "8,300",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.1": {
          "rap": "8,300",
          "low_price": "9,700",
          "high_price": "21,020"
        },
        "2.2": {
          "rap": "8,300",
          "low_price": "10,165",
          "high_price": "22,020"
        },
        "2.3": {
          "rap": "8,300",
          "low_price": "10,625",
          "high_price": "23,025"
        },
        "2.4": {
          "rap": "8,300",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.5": {
          "rap": "8,300",
          "low_price": "11,550",
          "high_price": "25,025"
        },
        "2.6": {
          "rap": "8,300",
          "low_price": "12,010",
          "high_price": "26,025"
        },
        "2.7": {
          "rap": "8,300",
          "low_price": "12,475",
          "high_price": "27,025"
        },
        "2.8": {
          "rap": "8,300",
          "low_price": "12,935",
          "high_price": "28,030"
        },
        "2.9": {
          "rap": "8,300",
          "low_price": "13,400",
          "high_price": "29,030"
        },
        "3.0": {
          "rap": "13,100",
          "low_price": "22,860",
          "high_price": "49,530"
        },
        "3.1": {
          "rap": "13,100",
          "low_price": "23,620",
          "high_price": "51,180"
        },
        "3.2": {
          "rap": "13,100",
          "low_price": "24,385",
          "high_price": "52,830"
        },
        "3.3": {
          "rap": "13,100",
          "low_price": "25,145",
          "high_price": "54,485"
        },
        "3.4": {
          "rap": "13,100",
          "low_price": "25,910",
          "high_price": "56,135"
        },
        "3.5": {
          "rap": "13,100",
          "low_price": "26,670",
          "high_price": "57,785"
        },
        "3.6": {
          "rap": "13,100",
          "low_price": "27,430",
          "high_price": "59,435"
        },
        "3.7": {
          "rap": "13,100",
          "low_price": "28,195",
          "high_price": "61,085"
        },
        "3.8": {
          "rap": "13,100",
          "low_price": "28,955",
          "high_price": "62,740"
        },
        "3.9": {
          "rap": "13,100",
          "low_price": "29,720",
          "high_price": "64,390"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,200",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,200",
          "low_price": "800",
          "high_price": "1,730"
        },
        "0.8": {
          "rap": "2,200",
          "low_price": "910",
          "high_price": "1,975"
        },
        "0.9": {
          "rap": "2,800",
          "low_price": "1,350",
          "high_price": "2,925"
        },
        "1.0": {
          "rap": "3,300",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "1.1": {
          "rap": "3,300",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.2": {
          "rap": "3,300",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.3": {
          "rap": "3,300",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.4": {
          "rap": "3,300",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "1.5": {
          "rap": "5,100",
          "low_price": "3,870",
          "high_price": "8,385"
        },
        "1.6": {
          "rap": "5,100",
          "low_price": "4,130",
          "high_price": "8,945"
        },
        "1.7": {
          "rap": "5,100",
          "low_price": "4,385",
          "high_price": "9,505"
        },
        "1.8": {
          "rap": "5,100",
          "low_price": "4,645",
          "high_price": "10,060"
        },
        "1.9": {
          "rap": "5,100",
          "low_price": "4,900",
          "high_price": "10,620"
        },
        "2.0": {
          "rap": "6,800",
          "low_price": "7,200",
          "high_price": "15,600"
        },
        "2.1": {
          "rap": "6,800",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.2": {
          "rap": "6,800",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.3": {
          "rap": "6,800",
          "low_price": "8,280",
          "high_price": "17,940"
        },
        "2.4": {
          "rap": "6,800",
          "low_price": "8,640",
          "high_price": "18,720"
        },
        "2.5": {
          "rap": "6,800",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "2.6": {
          "rap": "6,800",
          "low_price": "9,360",
          "high_price": "20,280"
        },
        "2.7": {
          "rap": "6,800",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "2.8": {
          "rap": "6,800",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.9": {
          "rap": "6,800",
          "low_price": "10,440",
          "high_price": "22,620"
        },
        "3.0": {
          "rap": "10,000",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "3.1": {
          "rap": "10,000",
          "low_price": "18,600",
          "high_price": "40,300"
        },
        "3.2": {
          "rap": "10,000",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "3.3": {
          "rap": "10,000",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "3.4": {
          "rap": "10,000",
          "low_price": "20,400",
          "high_price": "44,200"
        },
        "3.5": {
          "rap": "10,000",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "3.6": {
          "rap": "10,000",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "3.7": {
          "rap": "10,000",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "3.8": {
          "rap": "10,000",
          "low_price": "22,800",
          "high_price": "49,400"
        },
        "3.9": {
          "rap": "10,000",
          "low_price": "23,400",
          "high_price": "50,700"
        }
      }
    },
    "VS2": {
      "D": {
        "0.4": {
          "rap": "2,300",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "4,600",
          "low_price": "1,430",
          "high_price": "3,095"
        },
        "0.8": {
          "rap": "4,600",
          "low_price": "1,630",
          "high_price": "3,535"
        },
        "0.9": {
          "rap": "5,900",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.0": {
          "rap": "7,500",
          "low_price": "3,420",
          "high_price": "7,410"
        },
        "1.1": {
          "rap": "7,500",
          "low_price": "3,760",
          "high_price": "8,150"
        },
        "1.2": {
          "rap": "7,500",
          "low_price": "4,105",
          "high_price": "8,890"
        },
        "1.3": {
          "rap": "7,500",
          "low_price": "4,445",
          "high_price": "9,635"
        },
        "1.4": {
          "rap": "7,500",
          "low_price": "4,790",
          "high_price": "10,375"
        },
        "1.5": {
          "rap": "12,400",
          "low_price": "8,910",
          "high_price": "19,305"
        },
        "1.6": {
          "rap": "12,400",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "1.7": {
          "rap": "12,400",
          "low_price": "10,100",
          "high_price": "21,880"
        },
        "1.8": {
          "rap": "12,400",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "1.9": {
          "rap": "12,400",
          "low_price": "11,285",
          "high_price": "24,455"
        },
        "2.0": {
          "rap": "17,500",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "17,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "17,500",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "17,500",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "17,500",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "17,500",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "17,500",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "17,500",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "17,500",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "17,500",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "27,000",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.1": {
          "rap": "27,000",
          "low_price": "50,220",
          "high_price": "108,810"
        },
        "3.2": {
          "rap": "27,000",
          "low_price": "51,840",
          "high_price": "112,320"
        },
        "3.3": {
          "rap": "27,000",
          "low_price": "53,460",
          "high_price": "115,830"
        },
        "3.4": {
          "rap": "27,000",
          "low_price": "55,080",
          "high_price": "119,340"
        },
        "3.5": {
          "rap": "27,000",
          "low_price": "56,700",
          "high_price": "122,850"
        },
        "3.6": {
          "rap": "27,000",
          "low_price": "58,320",
          "high_price": "126,360"
        },
        "3.7": {
          "rap": "27,000",
          "low_price": "59,940",
          "high_price": "129,870"
        },
        "3.8": {
          "rap": "27,000",
          "low_price": "61,560",
          "high_price": "133,380"
        },
        "3.9": {
          "rap": "27,000",
          "low_price": "63,180",
          "high_price": "136,890"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,200",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,800",
          "low_price": "690",
          "high_price": "1,495"
        },
        "0.6": {
          "rap": "2,800",
          "low_price": "830",
          "high_price": "1,795"
        },
        "0.7": {
          "rap": "4,400",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.8": {
          "rap": "4,400",
          "low_price": "1,535",
          "high_price": "3,330"
        },
        "0.9": {
          "rap": "5,600",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.0": {
          "rap": "7,200",
          "low_price": "3,240",
          "high_price": "7,020"
        },
        "1.1": {
          "rap": "7,200",
          "low_price": "3,565",
          "high_price": "7,720"
        },
        "1.2": {
          "rap": "7,200",
          "low_price": "3,890",
          "high_price": "8,425"
        },
        "1.3": {
          "rap": "7,200",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.4": {
          "rap": "7,200",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.5": {
          "rap": "11,800",
          "low_price": "8,370",
          "high_price": "18,135"
        },
        "1.6": {
          "rap": "11,800",
          "low_price": "8,930",
          "high_price": "19,345"
        },
        "1.7": {
          "rap": "11,800",
          "low_price": "9,485",
          "high_price": "20,555"
        },
        "1.8": {
          "rap": "11,800",
          "low_price": "10,045",
          "high_price": "21,760"
        },
        "1.9": {
          "rap": "11,800",
          "low_price": "10,600",
          "high_price": "22,970"
        },
        "2.0": {
          "rap": "16,500",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.1": {
          "rap": "16,500",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "2.2": {
          "rap": "16,500",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.3": {
          "rap": "16,500",
          "low_price": "20,700",
          "high_price": "44,850"
        },
        "2.4": {
          "rap": "16,500",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "2.5": {
          "rap": "16,500",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "2.6": {
          "rap": "16,500",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.7": {
          "rap": "16,500",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "2.8": {
          "rap": "16,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.9": {
          "rap": "16,500",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.0": {
          "rap": "24,500",
          "low_price": "45,000",
          "high_price": "97,500"
        },
        "3.1": {
          "rap": "24,500",
          "low_price": "46,500",
          "high_price": "100,750"
        },
        "3.2": {
          "rap": "24,500",
          "low_price": "48,000",
          "high_price": "104,000"
        },
        "3.3": {
          "rap": "24,500",
          "low_price": "49,500",
          "high_price": "107,250"
        },
        "3.4": {
          "rap": "24,500",
          "low_price": "51,000",
          "high_price": "110,500"
        },
        "3.5": {
          "rap": "24,500",
          "low_price": "52,500",
          "high_price": "113,750"
        },
        "3.6": {
          "rap": "24,500",
          "low_price": "54,000",
          "high_price": "117,000"
        },
        "3.7": {
          "rap": "24,500",
          "low_price": "55,500",
          "high_price": "120,250"
        },
        "3.8": {
          "rap": "24,500",
          "low_price": "57,000",
          "high_price": "123,500"
        },
        "3.9": {
          "rap": "24,500",
          "low_price": "58,500",
          "high_price": "126,750"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,100",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "2,700",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,700",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,200",
          "low_price": "1,260",
          "high_price": "2,730"
        },
        "0.8": {
          "rap": "4,200",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "0.9": {
          "rap": "5,400",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.0": {
          "rap": "6,900",
          "low_price": "3,060",
          "high_price": "6,630"
        },
        "1.1": {
          "rap": "6,900",
          "low_price": "3,365",
          "high_price": "7,295"
        },
        "1.2": {
          "rap": "6,900",
          "low_price": "3,670",
          "high_price": "7,955"
        },
        "1.3": {
          "rap": "6,900",
          "low_price": "3,980",
          "high_price": "8,620"
        },
        "1.4": {
          "rap": "6,900",
          "low_price": "4,285",
          "high_price": "9,280"
        },
        "1.5": {
          "rap": "11,200",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "1.6": {
          "rap": "11,200",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "1.7": {
          "rap": "11,200",
          "low_price": "8,975",
          "high_price": "19,450"
        },
        "1.8": {
          "rap": "11,200",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "1.9": {
          "rap": "11,200",
          "low_price": "10,030",
          "high_price": "21,735"
        },
        "2.0": {
          "rap": "15,500",
          "low_price": "16,800",
          "high_price": "36,400"
        },
        "2.1": {
          "rap": "15,500",
          "low_price": "17,640",
          "high_price": "38,220"
        },
        "2.2": {
          "rap": "15,500",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "2.3": {
          "rap": "15,500",
          "low_price": "19,320",
          "high_price": "41,860"
        },
        "2.4": {
          "rap": "15,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.5": {
          "rap": "15,500",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.6": {
          "rap": "15,500",
          "low_price": "21,840",
          "high_price": "47,320"
        },
        "2.7": {
          "rap": "15,500",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.8": {
          "rap": "15,500",
          "low_price": "23,520",
          "high_price": "50,960"
        },
        "2.9": {
          "rap": "15,500",
          "low_price": "24,360",
          "high_price": "52,780"
        },
        "3.0": {
          "rap": "22,500",
          "low_price": "41,400",
          "high_price": "89,700"
        },
        "3.1": {
          "rap": "22,500",
          "low_price": "42,780",
          "high_price": "92,690"
        },
        "3.2": {
          "rap": "22,500",
          "low_price": "44,160",
          "high_price": "95,680"
        },
        "3.3": {
          "rap": "22,500",
          "low_price": "45,540",
          "high_price": "98,670"
        },
        "3.4": {
          "rap": "22,500",
          "low_price": "46,920",
          "high_price": "101,660"
        },
        "3.5": {
          "rap": "22,500",
          "low_price": "48,300",
          "high_price": "104,650"
        },
        "3.6": {
          "rap": "22,500",
          "low_price": "49,680",
          "high_price": "107,640"
        },
        "3.7": {
          "rap": "22,500",
          "low_price": "51,060",
          "high_price": "110,630"
        },
        "3.8": {
          "rap": "22,500",
          "low_price": "52,440",
          "high_price": "113,620"
        },
        "3.9": {
          "rap": "22,500",
          "low_price": "53,820",
          "high_price": "116,610"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,000",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "2,600",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.6": {
          "rap": "2,600",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.7": {
          "rap": "3,900",
          "low_price": "1,175",
          "high_price": "2,550"
        },
        "0.8": {
          "rap": "3,900",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.9": {
          "rap": "5,100",
          "low_price": "2,050",
          "high_price": "4,445"
        },
        "1.0": {
          "rap": "6,600",
          "low_price": "2,880",
          "high_price": "6,240"
        },
        "1.1": {
          "rap": "6,600",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.2": {
          "rap": "6,600",
          "low_price": "3,455",
          "high_price": "7,490"
        },
        "1.3": {
          "rap": "6,600",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.4": {
          "rap": "6,600",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.5": {
          "rap": "10,400",
          "low_price": "7,380",
          "high_price": "15,990"
        },
        "1.6": {
          "rap": "10,400",
          "low_price": "7,870",
          "high_price": "17,055"
        },
        "1.7": {
          "rap": "10,400",
          "low_price": "8,365",
          "high_price": "18,120"
        },
        "1.8": {
          "rap": "10,400",
          "low_price": "8,855",
          "high_price": "19,190"
        },
        "1.9": {
          "rap": "10,400",
          "low_price": "9,350",
          "high_price": "20,255"
        },
        "2.0": {
          "rap": "14,500",
          "low_price": "15,600",
          "high_price": "33,800"
        },
        "2.1": {
          "rap": "14,500",
          "low_price": "16,380",
          "high_price": "35,490"
        },
        "2.2": {
          "rap": "14,500",
          "low_price": "17,160",
          "high_price": "37,180"
        },
        "2.3": {
          "rap": "14,500",
          "low_price": "17,940",
          "high_price": "38,870"
        },
        "2.4": {
          "rap": "14,500",
          "low_price": "18,720",
          "high_price": "40,560"
        },
        "2.5": {
          "rap": "14,500",
          "low_price": "19,500",
          "high_price": "42,250"
        },
        "2.6": {
          "rap": "14,500",
          "low_price": "20,280",
          "high_price": "43,940"
        },
        "2.7": {
          "rap": "14,500",
          "low_price": "21,060",
          "high_price": "45,630"
        },
        "2.8": {
          "rap": "14,500",
          "low_price": "21,840",
          "high_price": "47,320"
        },
        "2.9": {
          "rap": "14,500",
          "low_price": "22,620",
          "high_price": "49,010"
        },
        "3.0": {
          "rap": "20,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.1": {
          "rap": "20,500",
          "low_price": "39,060",
          "high_price": "84,630"
        },
        "3.2": {
          "rap": "20,500",
          "low_price": "40,320",
          "high_price": "87,360"
        },
        "3.3": {
          "rap": "20,500",
          "low_price": "41,580",
          "high_price": "90,090"
        },
        "3.4": {
          "rap": "20,500",
          "low_price": "42,840",
          "high_price": "92,820"
        },
        "3.5": {
          "rap": "20,500",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.6": {
          "rap": "20,500",
          "low_price": "45,360",
          "high_price": "98,280"
        },
        "3.7": {
          "rap": "20,500",
          "low_price": "46,620",
          "high_price": "101,010"
        },
        "3.8": {
          "rap": "20,500",
          "low_price": "47,880",
          "high_price": "103,740"
        },
        "3.9": {
          "rap": "20,500",
          "low_price": "49,140",
          "high_price": "106,470"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,800",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,400",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,400",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,500",
          "low_price": "1,050",
          "high_price": "2,275"
        },
        "0.8": {
          "rap": "3,500",
          "low_price": "1,200",
          "high_price": "2,600"
        },
        "0.9": {
          "rap": "4,600",
          "low_price": "1,890",
          "high_price": "4,095"
        },
        "1.0": {
          "rap": "5,700",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.1": {
          "rap": "5,700",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.2": {
          "rap": "5,700",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.3": {
          "rap": "5,700",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.4": {
          "rap": "5,700",
          "low_price": "3,530",
          "high_price": "7,645"
        },
        "1.5": {
          "rap": "9,100",
          "low_price": "6,390",
          "high_price": "13,845"
        },
        "1.6": {
          "rap": "9,100",
          "low_price": "6,815",
          "high_price": "14,770"
        },
        "1.7": {
          "rap": "9,100",
          "low_price": "7,240",
          "high_price": "15,690"
        },
        "1.8": {
          "rap": "9,100",
          "low_price": "7,670",
          "high_price": "16,615"
        },
        "1.9": {
          "rap": "9,100",
          "low_price": "8,095",
          "high_price": "17,535"
        },
        "2.0": {
          "rap": "12,000",
          "low_price": "13,200",
          "high_price": "28,600"
        },
        "2.1": {
          "rap": "12,000",
          "low_price": "13,860",
          "high_price": "30,030"
        },
        "2.2": {
          "rap": "12,000",
          "low_price": "14,520",
          "high_price": "31,460"
        },
        "2.3": {
          "rap": "12,000",
          "low_price": "15,180",
          "high_price": "32,890"
        },
        "2.4": {
          "rap": "12,000",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "2.5": {
          "rap": "12,000",
          "low_price": "16,500",
          "high_price": "35,750"
        },
        "2.6": {
          "rap": "12,000",
          "low_price": "17,160",
          "high_price": "37,180"
        },
        "2.7": {
          "rap": "12,000",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.8": {
          "rap": "12,000",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "2.9": {
          "rap": "12,000",
          "low_price": "19,140",
          "high_price": "41,470"
        },
        "3.0": {
          "rap": "18,000",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.1": {
          "rap": "18,000",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.2": {
          "rap": "18,000",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.3": {
          "rap": "18,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.4": {
          "rap": "18,000",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.5": {
          "rap": "18,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.6": {
          "rap": "18,000",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.7": {
          "rap": "18,000",
          "low_price": "41,070",
          "high_price": "88,985"
        },
        "3.8": {
          "rap": "18,000",
          "low_price": "42,180",
          "high_price": "91,390"
        },
        "3.9": {
          "rap": "18,000",
          "low_price": "43,290",
          "high_price": "93,795"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,600",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,200",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "2,200",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "3,900",
          "low_price": "1,675",
          "high_price": "3,625"
        },
        "1.0": {
          "rap": "4,900",
          "low_price": "2,220",
          "high_price": "4,810"
        },
        "1.1": {
          "rap": "4,900",
          "low_price": "2,440",
          "high_price": "5,290"
        },
        "1.2": {
          "rap": "4,900",
          "low_price": "2,665",
          "high_price": "5,770"
        },
        "1.3": {
          "rap": "4,900",
          "low_price": "2,885",
          "high_price": "6,255"
        },
        "1.4": {
          "rap": "4,900",
          "low_price": "3,110",
          "high_price": "6,735"
        },
        "1.5": {
          "rap": "7,600",
          "low_price": "5,670",
          "high_price": "12,285"
        },
        "1.6": {
          "rap": "7,600",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.7": {
          "rap": "7,600",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "1.8": {
          "rap": "7,600",
          "low_price": "6,805",
          "high_price": "14,740"
        },
        "1.9": {
          "rap": "7,600",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.0": {
          "rap": "9,700",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "2.1": {
          "rap": "9,700",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.2": {
          "rap": "9,700",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "2.3": {
          "rap": "9,700",
          "low_price": "12,420",
          "high_price": "26,910"
        },
        "2.4": {
          "rap": "9,700",
          "low_price": "12,960",
          "high_price": "28,080"
        },
        "2.5": {
          "rap": "9,700",
          "low_price": "13,500",
          "high_price": "29,250"
        },
        "2.6": {
          "rap": "9,700",
          "low_price": "14,040",
          "high_price": "30,420"
        },
        "2.7": {
          "rap": "9,700",
          "low_price": "14,580",
          "high_price": "31,590"
        },
        "2.8": {
          "rap": "9,700",
          "low_price": "15,120",
          "high_price": "32,760"
        },
        "2.9": {
          "rap": "9,700",
          "low_price": "15,660",
          "high_price": "33,930"
        },
        "3.0": {
          "rap": "15,500",
          "low_price": "27,900",
          "high_price": "60,450"
        },
        "3.1": {
          "rap": "15,500",
          "low_price": "28,830",
          "high_price": "62,465"
        },
        "3.2": {
          "rap": "15,500",
          "low_price": "29,760",
          "high_price": "64,480"
        },
        "3.3": {
          "rap": "15,500",
          "low_price": "30,690",
          "high_price": "66,495"
        },
        "3.4": {
          "rap": "15,500",
          "low_price": "31,620",
          "high_price": "68,510"
        },
        "3.5": {
          "rap": "15,500",
          "low_price": "32,550",
          "high_price": "70,525"
        },
        "3.6": {
          "rap": "15,500",
          "low_price": "33,480",
          "high_price": "72,540"
        },
        "3.7": {
          "rap": "15,500",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.8": {
          "rap": "15,500",
          "low_price": "35,340",
          "high_price": "76,570"
        },
        "3.9": {
          "rap": "15,500",
          "low_price": "36,270",
          "high_price": "78,585"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,500",
          "low_price": "800",
          "high_price": "1,730"
        },
        "0.8": {
          "rap": "2,500",
          "low_price": "910",
          "high_price": "1,975"
        },
        "0.9": {
          "rap": "3,300",
          "low_price": "1,460",
          "high_price": "3,160"
        },
        "1.0": {
          "rap": "4,000",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "1.1": {
          "rap": "4,000",
          "low_price": "2,110",
          "high_price": "4,575"
        },
        "1.2": {
          "rap": "4,000",
          "low_price": "2,305",
          "high_price": "4,990"
        },
        "1.3": {
          "rap": "4,000",
          "low_price": "2,495",
          "high_price": "5,410"
        },
        "1.4": {
          "rap": "4,000",
          "low_price": "2,690",
          "high_price": "5,825"
        },
        "1.5": {
          "rap": "6,100",
          "low_price": "4,680",
          "high_price": "10,140"
        },
        "1.6": {
          "rap": "6,100",
          "low_price": "4,990",
          "high_price": "10,815"
        },
        "1.7": {
          "rap": "6,100",
          "low_price": "5,305",
          "high_price": "11,490"
        },
        "1.8": {
          "rap": "6,100",
          "low_price": "5,615",
          "high_price": "12,170"
        },
        "1.9": {
          "rap": "6,100",
          "low_price": "5,930",
          "high_price": "12,845"
        },
        "2.0": {
          "rap": "8,000",
          "low_price": "8,880",
          "high_price": "19,240"
        },
        "2.1": {
          "rap": "8,000",
          "low_price": "9,325",
          "high_price": "20,200"
        },
        "2.2": {
          "rap": "8,000",
          "low_price": "9,770",
          "high_price": "21,165"
        },
        "2.3": {
          "rap": "8,000",
          "low_price": "10,210",
          "high_price": "22,125"
        },
        "2.4": {
          "rap": "8,000",
          "low_price": "10,655",
          "high_price": "23,090"
        },
        "2.5": {
          "rap": "8,000",
          "low_price": "11,100",
          "high_price": "24,050"
        },
        "2.6": {
          "rap": "8,000",
          "low_price": "11,545",
          "high_price": "25,010"
        },
        "2.7": {
          "rap": "8,000",
          "low_price": "11,990",
          "high_price": "25,975"
        },
        "2.8": {
          "rap": "8,000",
          "low_price": "12,430",
          "high_price": "26,935"
        },
        "2.9": {
          "rap": "8,000",
          "low_price": "12,875",
          "high_price": "27,900"
        },
        "3.0": {
          "rap": "12,100",
          "low_price": "21,780",
          "high_price": "47,190"
        },
        "3.1": {
          "rap": "12,100",
          "low_price": "22,505",
          "high_price": "48,765"
        },
        "3.2": {
          "rap": "12,100",
          "low_price": "23,230",
          "high_price": "50,335"
        },
        "3.3": {
          "rap": "12,100",
          "low_price": "23,960",
          "high_price": "51,910"
        },
        "3.4": {
          "rap": "12,100",
          "low_price": "24,685",
          "high_price": "53,480"
        },
        "3.5": {
          "rap": "12,100",
          "low_price": "25,410",
          "high_price": "55,055"
        },
        "3.6": {
          "rap": "12,100",
          "low_price": "26,135",
          "high_price": "56,630"
        },
        "3.7": {
          "rap": "12,100",
          "low_price": "26,860",
          "high_price": "58,200"
        },
        "3.8": {
          "rap": "12,100",
          "low_price": "27,590",
          "high_price": "59,775"
        },
        "3.9": {
          "rap": "12,100",
          "low_price": "28,315",
          "high_price": "61,345"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,100",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,500",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "1,500",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "2,700",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "3,200",
          "low_price": "1,560",
          "high_price": "3,380"
        },
        "1.1": {
          "rap": "3,200",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.2": {
          "rap": "3,200",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.3": {
          "rap": "3,200",
          "low_price": "2,030",
          "high_price": "4,395"
        },
        "1.4": {
          "rap": "3,200",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.5": {
          "rap": "4,900",
          "low_price": "3,690",
          "high_price": "7,995"
        },
        "1.6": {
          "rap": "4,900",
          "low_price": "3,935",
          "high_price": "8,530"
        },
        "1.7": {
          "rap": "4,900",
          "low_price": "4,180",
          "high_price": "9,060"
        },
        "1.8": {
          "rap": "4,900",
          "low_price": "4,430",
          "high_price": "9,595"
        },
        "1.9": {
          "rap": "4,900",
          "low_price": "4,675",
          "high_price": "10,125"
        },
        "2.0": {
          "rap": "6,600",
          "low_price": "6,960",
          "high_price": "15,080"
        },
        "2.1": {
          "rap": "6,600",
          "low_price": "7,310",
          "high_price": "15,835"
        },
        "2.2": {
          "rap": "6,600",
          "low_price": "7,655",
          "high_price": "16,590"
        },
        "2.3": {
          "rap": "6,600",
          "low_price": "8,005",
          "high_price": "17,340"
        },
        "2.4": {
          "rap": "6,600",
          "low_price": "8,350",
          "high_price": "18,095"
        },
        "2.5": {
          "rap": "6,600",
          "low_price": "8,700",
          "high_price": "18,850"
        },
        "2.6": {
          "rap": "6,600",
          "low_price": "9,050",
          "high_price": "19,605"
        },
        "2.7": {
          "rap": "6,600",
          "low_price": "9,395",
          "high_price": "20,360"
        },
        "2.8": {
          "rap": "6,600",
          "low_price": "9,745",
          "high_price": "21,110"
        },
        "2.9": {
          "rap": "6,600",
          "low_price": "10,090",
          "high_price": "21,865"
        },
        "3.0": {
          "rap": "9,400",
          "low_price": "16,920",
          "high_price": "36,660"
        },
        "3.1": {
          "rap": "9,400",
          "low_price": "17,485",
          "high_price": "37,880"
        },
        "3.2": {
          "rap": "9,400",
          "low_price": "18,050",
          "high_price": "39,105"
        },
        "3.3": {
          "rap": "9,400",
          "low_price": "18,610",
          "high_price": "40,325"
        },
        "3.4": {
          "rap": "9,400",
          "low_price": "19,175",
          "high_price": "41,550"
        },
        "3.5": {
          "rap": "9,400",
          "low_price": "19,740",
          "high_price": "42,770"
        },
        "3.6": {
          "rap": "9,400",
          "low_price": "20,305",
          "high_price": "43,990"
        },
        "3.7": {
          "rap": "9,400",
          "low_price": "20,870",
          "high_price": "45,215"
        },
        "3.8": {
          "rap": "9,400",
          "low_price": "21,430",
          "high_price": "46,435"
        },
        "3.9": {
          "rap": "9,400",
          "low_price": "21,995",
          "high_price": "47,660"
        }
      }
    },
    "VVS1": {
      "D": {
        "0.4": {
          "rap": "3,000",
          "low_price": "625",
          "high_price": "1,350"
        },
        "0.5": {
          "rap": "3,600",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.6": {
          "rap": "3,600",
          "low_price": "1,080",
          "high_price": "2,340"
        },
        "0.7": {
          "rap": "5,600",
          "low_price": "1,805",
          "high_price": "3,915"
        },
        "0.8": {
          "rap": "5,600",
          "low_price": "2,065",
          "high_price": "4,470"
        },
        "0.9": {
          "rap": "7,800",
          "low_price": "3,400",
          "high_price": "7,370"
        },
        "1.0": {
          "rap": "10,400",
          "low_price": "4,920",
          "high_price": "10,660"
        },
        "1.1": {
          "rap": "10,400",
          "low_price": "5,410",
          "high_price": "11,725"
        },
        "1.2": {
          "rap": "10,400",
          "low_price": "5,905",
          "high_price": "12,790"
        },
        "1.3": {
          "rap": "10,400",
          "low_price": "6,395",
          "high_price": "13,860"
        },
        "1.4": {
          "rap": "10,400",
          "low_price": "6,890",
          "high_price": "14,925"
        },
        "1.5": {
          "rap": "16,400",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "1.6": {
          "rap": "16,400",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "1.7": {
          "rap": "16,400",
          "low_price": "13,465",
          "high_price": "29,170"
        },
        "1.8": {
          "rap": "16,400",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "1.9": {
          "rap": "16,400",
          "low_price": "15,050",
          "high_price": "32,605"
        },
        "2.0": {
          "rap": "23,500",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.1": {
          "rap": "23,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.2": {
          "rap": "23,500",
          "low_price": "26,400",
          "high_price": "57,200"
        },
        "2.3": {
          "rap": "23,500",
          "low_price": "27,600",
          "high_price": "59,800"
        },
        "2.4": {
          "rap": "23,500",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "2.5": {
          "rap": "23,500",
          "low_price": "30,000",
          "high_price": "65,000"
        },
        "2.6": {
          "rap": "23,500",
          "low_price": "31,200",
          "high_price": "67,600"
        },
        "2.7": {
          "rap": "23,500",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "2.8": {
          "rap": "23,500",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "2.9": {
          "rap": "23,500",
          "low_price": "34,800",
          "high_price": "75,400"
        },
        "3.0": {
          "rap": "36,500",
          "low_price": "63,900",
          "high_price": "138,450"
        },
        "3.1": {
          "rap": "36,500",
          "low_price": "66,030",
          "high_price": "143,065"
        },
        "3.2": {
          "rap": "36,500",
          "low_price": "68,160",
          "high_price": "147,680"
        },
        "3.3": {
          "rap": "36,500",
          "low_price": "70,290",
          "high_price": "152,295"
        },
        "3.4": {
          "rap": "36,500",
          "low_price": "72,420",
          "high_price": "156,910"
        },
        "3.5": {
          "rap": "36,500",
          "low_price": "74,550",
          "high_price": "161,525"
        },
        "3.6": {
          "rap": "36,500",
          "low_price": "76,680",
          "high_price": "166,140"
        },
        "3.7": {
          "rap": "36,500",
          "low_price": "78,810",
          "high_price": "170,755"
        },
        "3.8": {
          "rap": "36,500",
          "low_price": "80,940",
          "high_price": "175,370"
        },
        "3.9": {
          "rap": "36,500",
          "low_price": "83,070",
          "high_price": "179,985"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,800",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.5": {
          "rap": "3,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.6": {
          "rap": "3,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.7": {
          "rap": "5,300",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.8": {
          "rap": "5,300",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "0.9": {
          "rap": "7,100",
          "low_price": "3,080",
          "high_price": "6,670"
        },
        "1.0": {
          "rap": "9,400",
          "low_price": "4,500",
          "high_price": "9,750"
        },
        "1.1": {
          "rap": "9,400",
          "low_price": "4,950",
          "high_price": "10,725"
        },
        "1.2": {
          "rap": "9,400",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "1.3": {
          "rap": "9,400",
          "low_price": "5,850",
          "high_price": "12,675"
        },
        "1.4": {
          "rap": "9,400",
          "low_price": "6,300",
          "high_price": "13,650"
        },
        "1.5": {
          "rap": "14,900",
          "low_price": "11,160",
          "high_price": "24,180"
        },
        "1.6": {
          "rap": "14,900",
          "low_price": "11,905",
          "high_price": "25,790"
        },
        "1.7": {
          "rap": "14,900",
          "low_price": "12,650",
          "high_price": "27,405"
        },
        "1.8": {
          "rap": "14,900",
          "low_price": "13,390",
          "high_price": "29,015"
        },
        "1.9": {
          "rap": "14,900",
          "low_price": "14,135",
          "high_price": "30,630"
        },
        "2.0": {
          "rap": "21,000",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "2.1": {
          "rap": "21,000",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "2.2": {
          "rap": "21,000",
          "low_price": "24,420",
          "high_price": "52,910"
        },
        "2.3": {
          "rap": "21,000",
          "low_price": "25,530",
          "high_price": "55,315"
        },
        "2.4": {
          "rap": "21,000",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "2.5": {
          "rap": "21,000",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "2.6": {
          "rap": "21,000",
          "low_price": "28,860",
          "high_price": "62,530"
        },
        "2.7": {
          "rap": "21,000",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "2.8": {
          "rap": "21,000",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "2.9": {
          "rap": "21,000",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.0": {
          "rap": "33,500",
          "low_price": "58,500",
          "high_price": "126,750"
        },
        "3.1": {
          "rap": "33,500",
          "low_price": "60,450",
          "high_price": "130,975"
        },
        "3.2": {
          "rap": "33,500",
          "low_price": "62,400",
          "high_price": "135,200"
        },
        "3.3": {
          "rap": "33,500",
          "low_price": "64,350",
          "high_price": "139,425"
        },
        "3.4": {
          "rap": "33,500",
          "low_price": "66,300",
          "high_price": "143,650"
        },
        "3.5": {
          "rap": "33,500",
          "low_price": "68,250",
          "high_price": "147,875"
        },
        "3.6": {
          "rap": "33,500",
          "low_price": "70,200",
          "high_price": "152,100"
        },
        "3.7": {
          "rap": "33,500",
          "low_price": "72,150",
          "high_price": "156,325"
        },
        "3.8": {
          "rap": "33,500",
          "low_price": "74,100",
          "high_price": "160,550"
        },
        "3.9": {
          "rap": "33,500",
          "low_price": "76,050",
          "high_price": "164,775"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,700",
          "low_price": "550",
          "high_price": "1,195"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,825",
          "high_price": "3,950"
        },
        "0.9": {
          "rap": "6,400",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "8,500",
          "low_price": "4,080",
          "high_price": "8,840"
        },
        "1.1": {
          "rap": "8,500",
          "low_price": "4,490",
          "high_price": "9,725"
        },
        "1.2": {
          "rap": "8,500",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.3": {
          "rap": "8,500",
          "low_price": "5,305",
          "high_price": "11,490"
        },
        "1.4": {
          "rap": "8,500",
          "low_price": "5,710",
          "high_price": "12,375"
        },
        "1.5": {
          "rap": "13,400",
          "low_price": "10,350",
          "high_price": "22,425"
        },
        "1.6": {
          "rap": "13,400",
          "low_price": "11,040",
          "high_price": "23,920"
        },
        "1.7": {
          "rap": "13,400",
          "low_price": "11,730",
          "high_price": "25,415"
        },
        "1.8": {
          "rap": "13,400",
          "low_price": "12,420",
          "high_price": "26,910"
        },
        "1.9": {
          "rap": "13,400",
          "low_price": "13,110",
          "high_price": "28,405"
        },
        "2.0": {
          "rap": "19,000",
          "low_price": "20,400",
          "high_price": "44,200"
        },
        "2.1": {
          "rap": "19,000",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "2.2": {
          "rap": "19,000",
          "low_price": "22,440",
          "high_price": "48,620"
        },
        "2.3": {
          "rap": "19,000",
          "low_price": "23,460",
          "high_price": "50,830"
        },
        "2.4": {
          "rap": "19,000",
          "low_price": "24,480",
          "high_price": "53,040"
        },
        "2.5": {
          "rap": "19,000",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "2.6": {
          "rap": "19,000",
          "low_price": "26,520",
          "high_price": "57,460"
        },
        "2.7": {
          "rap": "19,000",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "2.8": {
          "rap": "19,000",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "2.9": {
          "rap": "19,000",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.0": {
          "rap": "30,500",
          "low_price": "53,100",
          "high_price": "115,050"
        },
        "3.1": {
          "rap": "30,500",
          "low_price": "54,870",
          "high_price": "118,885"
        },
        "3.2": {
          "rap": "30,500",
          "low_price": "56,640",
          "high_price": "122,720"
        },
        "3.3": {
          "rap": "30,500",
          "low_price": "58,410",
          "high_price": "126,555"
        },
        "3.4": {
          "rap": "30,500",
          "low_price": "60,180",
          "high_price": "130,390"
        },
        "3.5": {
          "rap": "30,500",
          "low_price": "61,950",
          "high_price": "134,225"
        },
        "3.6": {
          "rap": "30,500",
          "low_price": "63,720",
          "high_price": "138,060"
        },
        "3.7": {
          "rap": "30,500",
          "low_price": "65,490",
          "high_price": "141,895"
        },
        "3.8": {
          "rap": "30,500",
          "low_price": "67,260",
          "high_price": "145,730"
        },
        "3.9": {
          "rap": "30,500",
          "low_price": "69,030",
          "high_price": "149,565"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "4,700",
          "low_price": "1,470",
          "high_price": "3,185"
        },
        "0.8": {
          "rap": "4,700",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.9": {
          "rap": "5,900",
          "low_price": "2,645",
          "high_price": "5,735"
        },
        "1.0": {
          "rap": "7,700",
          "low_price": "3,720",
          "high_price": "8,060"
        },
        "1.1": {
          "rap": "7,700",
          "low_price": "4,090",
          "high_price": "8,865"
        },
        "1.2": {
          "rap": "7,700",
          "low_price": "4,465",
          "high_price": "9,670"
        },
        "1.3": {
          "rap": "7,700",
          "low_price": "4,835",
          "high_price": "10,480"
        },
        "1.4": {
          "rap": "7,700",
          "low_price": "5,210",
          "high_price": "11,285"
        },
        "1.5": {
          "rap": "12,200",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "1.6": {
          "rap": "12,200",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "1.7": {
          "rap": "12,200",
          "low_price": "10,710",
          "high_price": "23,205"
        },
        "1.8": {
          "rap": "12,200",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "1.9": {
          "rap": "12,200",
          "low_price": "11,970",
          "high_price": "25,935"
        },
        "2.0": {
          "rap": "17,500",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "17,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "17,500",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "17,500",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "17,500",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "17,500",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "17,500",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "17,500",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "17,500",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "17,500",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "27,500",
          "low_price": "47,700",
          "high_price": "103,350"
        },
        "3.1": {
          "rap": "27,500",
          "low_price": "49,290",
          "high_price": "106,795"
        },
        "3.2": {
          "rap": "27,500",
          "low_price": "50,880",
          "high_price": "110,240"
        },
        "3.3": {
          "rap": "27,500",
          "low_price": "52,470",
          "high_price": "113,685"
        },
        "3.4": {
          "rap": "27,500",
          "low_price": "54,060",
          "high_price": "117,130"
        },
        "3.5": {
          "rap": "27,500",
          "low_price": "55,650",
          "high_price": "120,575"
        },
        "3.6": {
          "rap": "27,500",
          "low_price": "57,240",
          "high_price": "124,020"
        },
        "3.7": {
          "rap": "27,500",
          "low_price": "58,830",
          "high_price": "127,465"
        },
        "3.8": {
          "rap": "27,500",
          "low_price": "60,420",
          "high_price": "130,910"
        },
        "3.9": {
          "rap": "27,500",
          "low_price": "62,010",
          "high_price": "134,355"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,300",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,800",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "2,800",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,300",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.8": {
          "rap": "4,300",
          "low_price": "1,535",
          "high_price": "3,330"
        },
        "0.9": {
          "rap": "5,400",
          "low_price": "2,430",
          "high_price": "5,265"
        },
        "1.0": {
          "rap": "6,600",
          "low_price": "3,120",
          "high_price": "6,760"
        },
        "1.1": {
          "rap": "6,600",
          "low_price": "3,430",
          "high_price": "7,435"
        },
        "1.2": {
          "rap": "6,600",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.3": {
          "rap": "6,600",
          "low_price": "4,055",
          "high_price": "8,790"
        },
        "1.4": {
          "rap": "6,600",
          "low_price": "4,370",
          "high_price": "9,465"
        },
        "1.5": {
          "rap": "10,300",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "1.6": {
          "rap": "10,300",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "1.7": {
          "rap": "10,300",
          "low_price": "8,975",
          "high_price": "19,450"
        },
        "1.8": {
          "rap": "10,300",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "1.9": {
          "rap": "10,300",
          "low_price": "10,030",
          "high_price": "21,735"
        },
        "2.0": {
          "rap": "14,000",
          "low_price": "15,000",
          "high_price": "32,500"
        },
        "2.1": {
          "rap": "14,000",
          "low_price": "15,750",
          "high_price": "34,125"
        },
        "2.2": {
          "rap": "14,000",
          "low_price": "16,500",
          "high_price": "35,750"
        },
        "2.3": {
          "rap": "14,000",
          "low_price": "17,250",
          "high_price": "37,375"
        },
        "2.4": {
          "rap": "14,000",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.5": {
          "rap": "14,000",
          "low_price": "18,750",
          "high_price": "40,625"
        },
        "2.6": {
          "rap": "14,000",
          "low_price": "19,500",
          "high_price": "42,250"
        },
        "2.7": {
          "rap": "14,000",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.8": {
          "rap": "14,000",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.9": {
          "rap": "14,000",
          "low_price": "21,750",
          "high_price": "47,125"
        },
        "3.0": {
          "rap": "23,000",
          "low_price": "40,500",
          "high_price": "87,750"
        },
        "3.1": {
          "rap": "23,000",
          "low_price": "41,850",
          "high_price": "90,675"
        },
        "3.2": {
          "rap": "23,000",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.3": {
          "rap": "23,000",
          "low_price": "44,550",
          "high_price": "96,525"
        },
        "3.4": {
          "rap": "23,000",
          "low_price": "45,900",
          "high_price": "99,450"
        },
        "3.5": {
          "rap": "23,000",
          "low_price": "47,250",
          "high_price": "102,375"
        },
        "3.6": {
          "rap": "23,000",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.7": {
          "rap": "23,000",
          "low_price": "49,950",
          "high_price": "108,225"
        },
        "3.8": {
          "rap": "23,000",
          "low_price": "51,300",
          "high_price": "111,150"
        },
        "3.9": {
          "rap": "23,000",
          "low_price": "52,650",
          "high_price": "114,075"
        }
      },
      "I": {
        "0.4": {
          "rap": "2,000",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "2,500",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "2,500",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "3,600",
          "low_price": "1,220",
          "high_price": "2,640"
        },
        "0.8": {
          "rap": "3,600",
          "low_price": "1,390",
          "high_price": "3,015"
        },
        "0.9": {
          "rap": "4,600",
          "low_price": "2,105",
          "high_price": "4,565"
        },
        "1.0": {
          "rap": "5,600",
          "low_price": "2,640",
          "high_price": "5,720"
        },
        "1.1": {
          "rap": "5,600",
          "low_price": "2,905",
          "high_price": "6,290"
        },
        "1.2": {
          "rap": "5,600",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.3": {
          "rap": "5,600",
          "low_price": "3,430",
          "high_price": "7,435"
        },
        "1.4": {
          "rap": "5,600",
          "low_price": "3,695",
          "high_price": "8,010"
        },
        "1.5": {
          "rap": "8,500",
          "low_price": "6,750",
          "high_price": "14,625"
        },
        "1.6": {
          "rap": "8,500",
          "low_price": "7,200",
          "high_price": "15,600"
        },
        "1.7": {
          "rap": "8,500",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "1.8": {
          "rap": "8,500",
          "low_price": "8,100",
          "high_price": "17,550"
        },
        "1.9": {
          "rap": "8,500",
          "low_price": "8,550",
          "high_price": "18,525"
        },
        "2.0": {
          "rap": "11,200",
          "low_price": "12,480",
          "high_price": "27,040"
        },
        "2.1": {
          "rap": "11,200",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.2": {
          "rap": "11,200",
          "low_price": "13,730",
          "high_price": "29,745"
        },
        "2.3": {
          "rap": "11,200",
          "low_price": "14,350",
          "high_price": "31,095"
        },
        "2.4": {
          "rap": "11,200",
          "low_price": "14,975",
          "high_price": "32,450"
        },
        "2.5": {
          "rap": "11,200",
          "low_price": "15,600",
          "high_price": "33,800"
        },
        "2.6": {
          "rap": "11,200",
          "low_price": "16,225",
          "high_price": "35,150"
        },
        "2.7": {
          "rap": "11,200",
          "low_price": "16,850",
          "high_price": "36,505"
        },
        "2.8": {
          "rap": "11,200",
          "low_price": "17,470",
          "high_price": "37,855"
        },
        "2.9": {
          "rap": "11,200",
          "low_price": "18,095",
          "high_price": "39,210"
        },
        "3.0": {
          "rap": "19,000",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.1": {
          "rap": "19,000",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.2": {
          "rap": "19,000",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.3": {
          "rap": "19,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.4": {
          "rap": "19,000",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.5": {
          "rap": "19,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.6": {
          "rap": "19,000",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.7": {
          "rap": "19,000",
          "low_price": "41,070",
          "high_price": "88,985"
        },
        "3.8": {
          "rap": "19,000",
          "low_price": "42,180",
          "high_price": "91,390"
        },
        "3.9": {
          "rap": "19,000",
          "low_price": "43,290",
          "high_price": "93,795"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,700",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "2,900",
          "low_price": "1,050",
          "high_price": "2,275"
        },
        "0.8": {
          "rap": "2,900",
          "low_price": "1,200",
          "high_price": "2,600"
        },
        "0.9": {
          "rap": "3,700",
          "low_price": "1,835",
          "high_price": "3,980"
        },
        "1.0": {
          "rap": "4,600",
          "low_price": "2,280",
          "high_price": "4,940"
        },
        "1.1": {
          "rap": "4,600",
          "low_price": "2,510",
          "high_price": "5,435"
        },
        "1.2": {
          "rap": "4,600",
          "low_price": "2,735",
          "high_price": "5,930"
        },
        "1.3": {
          "rap": "4,600",
          "low_price": "2,965",
          "high_price": "6,420"
        },
        "1.4": {
          "rap": "4,600",
          "low_price": "3,190",
          "high_price": "6,915"
        },
        "1.5": {
          "rap": "6,900",
          "low_price": "5,490",
          "high_price": "11,895"
        },
        "1.6": {
          "rap": "6,900",
          "low_price": "5,855",
          "high_price": "12,690"
        },
        "1.7": {
          "rap": "6,900",
          "low_price": "6,220",
          "high_price": "13,480"
        },
        "1.8": {
          "rap": "6,900",
          "low_price": "6,590",
          "high_price": "14,275"
        },
        "1.9": {
          "rap": "6,900",
          "low_price": "6,955",
          "high_price": "15,065"
        },
        "2.0": {
          "rap": "9,000",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.1": {
          "rap": "9,000",
          "low_price": "10,585",
          "high_price": "22,930"
        },
        "2.2": {
          "rap": "9,000",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.3": {
          "rap": "9,000",
          "low_price": "11,590",
          "high_price": "25,115"
        },
        "2.4": {
          "rap": "9,000",
          "low_price": "12,095",
          "high_price": "26,210"
        },
        "2.5": {
          "rap": "9,000",
          "low_price": "12,600",
          "high_price": "27,300"
        },
        "2.6": {
          "rap": "9,000",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.7": {
          "rap": "9,000",
          "low_price": "13,610",
          "high_price": "29,485"
        },
        "2.8": {
          "rap": "9,000",
          "low_price": "14,110",
          "high_price": "30,575"
        },
        "2.9": {
          "rap": "9,000",
          "low_price": "14,615",
          "high_price": "31,670"
        },
        "3.0": {
          "rap": "14,600",
          "low_price": "25,560",
          "high_price": "55,380"
        },
        "3.1": {
          "rap": "14,600",
          "low_price": "26,410",
          "high_price": "57,225"
        },
        "3.2": {
          "rap": "14,600",
          "low_price": "27,265",
          "high_price": "59,070"
        },
        "3.3": {
          "rap": "14,600",
          "low_price": "28,115",
          "high_price": "60,920"
        },
        "3.4": {
          "rap": "14,600",
          "low_price": "28,970",
          "high_price": "62,765"
        },
        "3.5": {
          "rap": "14,600",
          "low_price": "29,820",
          "high_price": "64,610"
        },
        "3.6": {
          "rap": "14,600",
          "low_price": "30,670",
          "high_price": "66,455"
        },
        "3.7": {
          "rap": "14,600",
          "low_price": "31,525",
          "high_price": "68,300"
        },
        "3.8": {
          "rap": "14,600",
          "low_price": "32,375",
          "high_price": "70,150"
        },
        "3.9": {
          "rap": "14,600",
          "low_price": "33,230",
          "high_price": "71,995"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,400",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "2,400",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "2,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "3,000",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "1.0": {
          "rap": "3,700",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "1.1": {
          "rap": "3,700",
          "low_price": "2,110",
          "high_price": "4,575"
        },
        "1.2": {
          "rap": "3,700",
          "low_price": "2,305",
          "high_price": "4,990"
        },
        "1.3": {
          "rap": "3,700",
          "low_price": "2,495",
          "high_price": "5,410"
        },
        "1.4": {
          "rap": "3,700",
          "low_price": "2,690",
          "high_price": "5,825"
        },
        "1.5": {
          "rap": "5,500",
          "low_price": "4,230",
          "high_price": "9,165"
        },
        "1.6": {
          "rap": "5,500",
          "low_price": "4,510",
          "high_price": "9,775"
        },
        "1.7": {
          "rap": "5,500",
          "low_price": "4,795",
          "high_price": "10,385"
        },
        "1.8": {
          "rap": "5,500",
          "low_price": "5,075",
          "high_price": "11,000"
        },
        "1.9": {
          "rap": "5,500",
          "low_price": "5,360",
          "high_price": "11,610"
        },
        "2.0": {
          "rap": "7,300",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.1": {
          "rap": "7,300",
          "low_price": "8,315",
          "high_price": "18,020"
        },
        "2.2": {
          "rap": "7,300",
          "low_price": "8,710",
          "high_price": "18,875"
        },
        "2.3": {
          "rap": "7,300",
          "low_price": "9,110",
          "high_price": "19,735"
        },
        "2.4": {
          "rap": "7,300",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "2.5": {
          "rap": "7,300",
          "low_price": "9,900",
          "high_price": "21,450"
        },
        "2.6": {
          "rap": "7,300",
          "low_price": "10,295",
          "high_price": "22,310"
        },
        "2.7": {
          "rap": "7,300",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "2.8": {
          "rap": "7,300",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.9": {
          "rap": "7,300",
          "low_price": "11,485",
          "high_price": "24,880"
        },
        "3.0": {
          "rap": "11,400",
          "low_price": "19,980",
          "high_price": "43,290"
        },
        "3.1": {
          "rap": "11,400",
          "low_price": "20,645",
          "high_price": "44,735"
        },
        "3.2": {
          "rap": "11,400",
          "low_price": "21,310",
          "high_price": "46,175"
        },
        "3.3": {
          "rap": "11,400",
          "low_price": "21,980",
          "high_price": "47,620"
        },
        "3.4": {
          "rap": "11,400",
          "low_price": "22,645",
          "high_price": "49,060"
        },
        "3.5": {
          "rap": "11,400",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "3.6": {
          "rap": "11,400",
          "low_price": "23,975",
          "high_price": "51,950"
        },
        "3.7": {
          "rap": "11,400",
          "low_price": "24,640",
          "high_price": "53,390"
        },
        "3.8": {
          "rap": "11,400",
          "low_price": "25,310",
          "high_price": "54,835"
        },
        "3.9": {
          "rap": "11,400",
          "low_price": "25,975",
          "high_price": "56,275"
        }
      }
    },
    "VVS2": {
      "D": {
        "0.4": {
          "rap": "2,800",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.5": {
          "rap": "3,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.6": {
          "rap": "3,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.7": {
          "rap": "5,300",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "0.8": {
          "rap": "5,300",
          "low_price": "1,920",
          "high_price": "4,160"
        },
        "0.9": {
          "rap": "7,100",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.0": {
          "rap": "9,400",
          "low_price": "4,560",
          "high_price": "9,880"
        },
        "1.1": {
          "rap": "9,400",
          "low_price": "5,015",
          "high_price": "10,870"
        },
        "1.2": {
          "rap": "9,400",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "1.3": {
          "rap": "9,400",
          "low_price": "5,930",
          "high_price": "12,845"
        },
        "1.4": {
          "rap": "9,400",
          "low_price": "6,385",
          "high_price": "13,830"
        },
        "1.5": {
          "rap": "15,000",
          "low_price": "11,250",
          "high_price": "24,375"
        },
        "1.6": {
          "rap": "15,000",
          "low_price": "12,000",
          "high_price": "26,000"
        },
        "1.7": {
          "rap": "15,000",
          "low_price": "12,750",
          "high_price": "27,625"
        },
        "1.8": {
          "rap": "15,000",
          "low_price": "13,500",
          "high_price": "29,250"
        },
        "1.9": {
          "rap": "15,000",
          "low_price": "14,250",
          "high_price": "30,875"
        },
        "2.0": {
          "rap": "21,000",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "2.1": {
          "rap": "21,000",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "2.2": {
          "rap": "21,000",
          "low_price": "24,420",
          "high_price": "52,910"
        },
        "2.3": {
          "rap": "21,000",
          "low_price": "25,530",
          "high_price": "55,315"
        },
        "2.4": {
          "rap": "21,000",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "2.5": {
          "rap": "21,000",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "2.6": {
          "rap": "21,000",
          "low_price": "28,860",
          "high_price": "62,530"
        },
        "2.7": {
          "rap": "21,000",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "2.8": {
          "rap": "21,000",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "2.9": {
          "rap": "21,000",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.0": {
          "rap": "33,500",
          "low_price": "58,500",
          "high_price": "126,750"
        },
        "3.1": {
          "rap": "33,500",
          "low_price": "60,450",
          "high_price": "130,975"
        },
        "3.2": {
          "rap": "33,500",
          "low_price": "62,400",
          "high_price": "135,200"
        },
        "3.3": {
          "rap": "33,500",
          "low_price": "64,350",
          "high_price": "139,425"
        },
        "3.4": {
          "rap": "33,500",
          "low_price": "66,300",
          "high_price": "143,650"
        },
        "3.5": {
          "rap": "33,500",
          "low_price": "68,250",
          "high_price": "147,875"
        },
        "3.6": {
          "rap": "33,500",
          "low_price": "70,200",
          "high_price": "152,100"
        },
        "3.7": {
          "rap": "33,500",
          "low_price": "72,150",
          "high_price": "156,325"
        },
        "3.8": {
          "rap": "33,500",
          "low_price": "74,100",
          "high_price": "160,550"
        },
        "3.9": {
          "rap": "33,500",
          "low_price": "76,050",
          "high_price": "164,775"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,600",
          "low_price": "530",
          "high_price": "1,145"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,825",
          "high_price": "3,950"
        },
        "0.9": {
          "rap": "6,500",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "8,700",
          "low_price": "4,140",
          "high_price": "8,970"
        },
        "1.1": {
          "rap": "8,700",
          "low_price": "4,555",
          "high_price": "9,865"
        },
        "1.2": {
          "rap": "8,700",
          "low_price": "4,970",
          "high_price": "10,765"
        },
        "1.3": {
          "rap": "8,700",
          "low_price": "5,380",
          "high_price": "11,660"
        },
        "1.4": {
          "rap": "8,700",
          "low_price": "5,795",
          "high_price": "12,560"
        },
        "1.5": {
          "rap": "13,600",
          "low_price": "10,440",
          "high_price": "22,620"
        },
        "1.6": {
          "rap": "13,600",
          "low_price": "11,135",
          "high_price": "24,130"
        },
        "1.7": {
          "rap": "13,600",
          "low_price": "11,830",
          "high_price": "25,635"
        },
        "1.8": {
          "rap": "13,600",
          "low_price": "12,530",
          "high_price": "27,145"
        },
        "1.9": {
          "rap": "13,600",
          "low_price": "13,225",
          "high_price": "28,650"
        },
        "2.0": {
          "rap": "19,500",
          "low_price": "20,400",
          "high_price": "44,200"
        },
        "2.1": {
          "rap": "19,500",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "2.2": {
          "rap": "19,500",
          "low_price": "22,440",
          "high_price": "48,620"
        },
        "2.3": {
          "rap": "19,500",
          "low_price": "23,460",
          "high_price": "50,830"
        },
        "2.4": {
          "rap": "19,500",
          "low_price": "24,480",
          "high_price": "53,040"
        },
        "2.5": {
          "rap": "19,500",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "2.6": {
          "rap": "19,500",
          "low_price": "26,520",
          "high_price": "57,460"
        },
        "2.7": {
          "rap": "19,500",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "2.8": {
          "rap": "19,500",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "2.9": {
          "rap": "19,500",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.0": {
          "rap": "30,500",
          "low_price": "53,100",
          "high_price": "115,050"
        },
        "3.1": {
          "rap": "30,500",
          "low_price": "54,870",
          "high_price": "118,885"
        },
        "3.2": {
          "rap": "30,500",
          "low_price": "56,640",
          "high_price": "122,720"
        },
        "3.3": {
          "rap": "30,500",
          "low_price": "58,410",
          "high_price": "126,555"
        },
        "3.4": {
          "rap": "30,500",
          "low_price": "60,180",
          "high_price": "130,390"
        },
        "3.5": {
          "rap": "30,500",
          "low_price": "61,950",
          "high_price": "134,225"
        },
        "3.6": {
          "rap": "30,500",
          "low_price": "63,720",
          "high_price": "138,060"
        },
        "3.7": {
          "rap": "30,500",
          "low_price": "65,490",
          "high_price": "141,895"
        },
        "3.8": {
          "rap": "30,500",
          "low_price": "67,260",
          "high_price": "145,730"
        },
        "3.9": {
          "rap": "30,500",
          "low_price": "69,030",
          "high_price": "149,565"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,500",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "750",
          "high_price": "1,625"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.7": {
          "rap": "4,800",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "0.8": {
          "rap": "4,800",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "0.9": {
          "rap": "6,000",
          "low_price": "2,645",
          "high_price": "5,735"
        },
        "1.0": {
          "rap": "8,000",
          "low_price": "3,840",
          "high_price": "8,320"
        },
        "1.1": {
          "rap": "8,000",
          "low_price": "4,225",
          "high_price": "9,150"
        },
        "1.2": {
          "rap": "8,000",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.3": {
          "rap": "8,000",
          "low_price": "4,990",
          "high_price": "10,815"
        },
        "1.4": {
          "rap": "8,000",
          "low_price": "5,375",
          "high_price": "11,650"
        },
        "1.5": {
          "rap": "12,700",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "1.6": {
          "rap": "12,700",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "1.7": {
          "rap": "12,700",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "1.8": {
          "rap": "12,700",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "1.9": {
          "rap": "12,700",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "2.0": {
          "rap": "18,000",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "18,000",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "18,000",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "18,000",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "18,000",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "18,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "18,000",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "18,000",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "18,000",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "18,000",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "28,000",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.1": {
          "rap": "28,000",
          "low_price": "50,220",
          "high_price": "108,810"
        },
        "3.2": {
          "rap": "28,000",
          "low_price": "51,840",
          "high_price": "112,320"
        },
        "3.3": {
          "rap": "28,000",
          "low_price": "53,460",
          "high_price": "115,830"
        },
        "3.4": {
          "rap": "28,000",
          "low_price": "55,080",
          "high_price": "119,340"
        },
        "3.5": {
          "rap": "28,000",
          "low_price": "56,700",
          "high_price": "122,850"
        },
        "3.6": {
          "rap": "28,000",
          "low_price": "58,320",
          "high_price": "126,360"
        },
        "3.7": {
          "rap": "28,000",
          "low_price": "59,940",
          "high_price": "129,870"
        },
        "3.8": {
          "rap": "28,000",
          "low_price": "61,560",
          "high_price": "133,380"
        },
        "3.9": {
          "rap": "28,000",
          "low_price": "63,180",
          "high_price": "136,890"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,300",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "2,800",
          "low_price": "690",
          "high_price": "1,495"
        },
        "0.6": {
          "rap": "2,800",
          "low_price": "830",
          "high_price": "1,795"
        },
        "0.7": {
          "rap": "4,500",
          "low_price": "1,385",
          "high_price": "3,005"
        },
        "0.8": {
          "rap": "4,500",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "0.9": {
          "rap": "5,600",
          "low_price": "2,485",
          "high_price": "5,380"
        },
        "1.0": {
          "rap": "7,300",
          "low_price": "3,480",
          "high_price": "7,540"
        },
        "1.1": {
          "rap": "7,300",
          "low_price": "3,830",
          "high_price": "8,295"
        },
        "1.2": {
          "rap": "7,300",
          "low_price": "4,175",
          "high_price": "9,050"
        },
        "1.3": {
          "rap": "7,300",
          "low_price": "4,525",
          "high_price": "9,800"
        },
        "1.4": {
          "rap": "7,300",
          "low_price": "4,870",
          "high_price": "10,555"
        },
        "1.5": {
          "rap": "11,700",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "1.6": {
          "rap": "11,700",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "1.7": {
          "rap": "11,700",
          "low_price": "10,200",
          "high_price": "22,100"
        },
        "1.8": {
          "rap": "11,700",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "1.9": {
          "rap": "11,700",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "2.0": {
          "rap": "16,500",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.1": {
          "rap": "16,500",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "2.2": {
          "rap": "16,500",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.3": {
          "rap": "16,500",
          "low_price": "20,700",
          "high_price": "44,850"
        },
        "2.4": {
          "rap": "16,500",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "2.5": {
          "rap": "16,500",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "2.6": {
          "rap": "16,500",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.7": {
          "rap": "16,500",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "2.8": {
          "rap": "16,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.9": {
          "rap": "16,500",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.0": {
          "rap": "25,000",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.1": {
          "rap": "25,000",
          "low_price": "45,570",
          "high_price": "98,735"
        },
        "3.2": {
          "rap": "25,000",
          "low_price": "47,040",
          "high_price": "101,920"
        },
        "3.3": {
          "rap": "25,000",
          "low_price": "48,510",
          "high_price": "105,105"
        },
        "3.4": {
          "rap": "25,000",
          "low_price": "49,980",
          "high_price": "108,290"
        },
        "3.5": {
          "rap": "25,000",
          "low_price": "51,450",
          "high_price": "111,475"
        },
        "3.6": {
          "rap": "25,000",
          "low_price": "52,920",
          "high_price": "114,660"
        },
        "3.7": {
          "rap": "25,000",
          "low_price": "54,390",
          "high_price": "117,845"
        },
        "3.8": {
          "rap": "25,000",
          "low_price": "55,860",
          "high_price": "121,030"
        },
        "3.9": {
          "rap": "25,000",
          "low_price": "57,330",
          "high_price": "124,215"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,100",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "2,600",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.6": {
          "rap": "2,600",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.7": {
          "rap": "4,100",
          "low_price": "1,260",
          "high_price": "2,730"
        },
        "0.8": {
          "rap": "4,100",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "0.9": {
          "rap": "5,200",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.0": {
          "rap": "6,300",
          "low_price": "2,940",
          "high_price": "6,370"
        },
        "1.1": {
          "rap": "6,300",
          "low_price": "3,235",
          "high_price": "7,005"
        },
        "1.2": {
          "rap": "6,300",
          "low_price": "3,530",
          "high_price": "7,645"
        },
        "1.3": {
          "rap": "6,300",
          "low_price": "3,820",
          "high_price": "8,280"
        },
        "1.4": {
          "rap": "6,300",
          "low_price": "4,115",
          "high_price": "8,920"
        },
        "1.5": {
          "rap": "9,900",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "1.6": {
          "rap": "9,900",
          "low_price": "8,065",
          "high_price": "17,470"
        },
        "1.7": {
          "rap": "9,900",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "1.8": {
          "rap": "9,900",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "1.9": {
          "rap": "9,900",
          "low_price": "9,575",
          "high_price": "20,750"
        },
        "2.0": {
          "rap": "13,500",
          "low_price": "14,400",
          "high_price": "31,200"
        },
        "2.1": {
          "rap": "13,500",
          "low_price": "15,120",
          "high_price": "32,760"
        },
        "2.2": {
          "rap": "13,500",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "2.3": {
          "rap": "13,500",
          "low_price": "16,560",
          "high_price": "35,880"
        },
        "2.4": {
          "rap": "13,500",
          "low_price": "17,280",
          "high_price": "37,440"
        },
        "2.5": {
          "rap": "13,500",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.6": {
          "rap": "13,500",
          "low_price": "18,720",
          "high_price": "40,560"
        },
        "2.7": {
          "rap": "13,500",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.8": {
          "rap": "13,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.9": {
          "rap": "13,500",
          "low_price": "20,880",
          "high_price": "45,240"
        },
        "3.0": {
          "rap": "21,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.1": {
          "rap": "21,500",
          "low_price": "39,060",
          "high_price": "84,630"
        },
        "3.2": {
          "rap": "21,500",
          "low_price": "40,320",
          "high_price": "87,360"
        },
        "3.3": {
          "rap": "21,500",
          "low_price": "41,580",
          "high_price": "90,090"
        },
        "3.4": {
          "rap": "21,500",
          "low_price": "42,840",
          "high_price": "92,820"
        },
        "3.5": {
          "rap": "21,500",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.6": {
          "rap": "21,500",
          "low_price": "45,360",
          "high_price": "98,280"
        },
        "3.7": {
          "rap": "21,500",
          "low_price": "46,620",
          "high_price": "101,010"
        },
        "3.8": {
          "rap": "21,500",
          "low_price": "47,880",
          "high_price": "103,740"
        },
        "3.9": {
          "rap": "21,500",
          "low_price": "49,140",
          "high_price": "106,470"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,900",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,400",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,400",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,400",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "0.8": {
          "rap": "3,400",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "0.9": {
          "rap": "4,400",
          "low_price": "2,000",
          "high_price": "4,330"
        },
        "1.0": {
          "rap": "5,400",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.1": {
          "rap": "5,400",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.2": {
          "rap": "5,400",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.3": {
          "rap": "5,400",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.4": {
          "rap": "5,400",
          "low_price": "3,530",
          "high_price": "7,645"
        },
        "1.5": {
          "rap": "8,200",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "1.6": {
          "rap": "8,200",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "1.7": {
          "rap": "8,200",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "1.8": {
          "rap": "8,200",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "1.9": {
          "rap": "8,200",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "2.0": {
          "rap": "10,700",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "2.1": {
          "rap": "10,700",
          "low_price": "12,475",
          "high_price": "27,025"
        },
        "2.2": {
          "rap": "10,700",
          "low_price": "13,070",
          "high_price": "28,315"
        },
        "2.3": {
          "rap": "10,700",
          "low_price": "13,660",
          "high_price": "29,600"
        },
        "2.4": {
          "rap": "10,700",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.5": {
          "rap": "10,700",
          "low_price": "14,850",
          "high_price": "32,175"
        },
        "2.6": {
          "rap": "10,700",
          "low_price": "15,445",
          "high_price": "33,460"
        },
        "2.7": {
          "rap": "10,700",
          "low_price": "16,040",
          "high_price": "34,750"
        },
        "2.8": {
          "rap": "10,700",
          "low_price": "16,630",
          "high_price": "36,035"
        },
        "2.9": {
          "rap": "10,700",
          "low_price": "17,225",
          "high_price": "37,325"
        },
        "3.0": {
          "rap": "18,000",
          "low_price": "31,500",
          "high_price": "68,250"
        },
        "3.1": {
          "rap": "18,000",
          "low_price": "32,550",
          "high_price": "70,525"
        },
        "3.2": {
          "rap": "18,000",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "3.3": {
          "rap": "18,000",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "3.4": {
          "rap": "18,000",
          "low_price": "35,700",
          "high_price": "77,350"
        },
        "3.5": {
          "rap": "18,000",
          "low_price": "36,750",
          "high_price": "79,625"
        },
        "3.6": {
          "rap": "18,000",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.7": {
          "rap": "18,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.8": {
          "rap": "18,000",
          "low_price": "39,900",
          "high_price": "86,450"
        },
        "3.9": {
          "rap": "18,000",
          "low_price": "40,950",
          "high_price": "88,725"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,600",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,000",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "2,000",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "2,800",
          "low_price": "965",
          "high_price": "2,095"
        },
        "0.8": {
          "rap": "2,800",
          "low_price": "1,105",
          "high_price": "2,390"
        },
        "0.9": {
          "rap": "3,600",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.0": {
          "rap": "4,400",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.1": {
          "rap": "4,400",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.2": {
          "rap": "4,400",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.3": {
          "rap": "4,400",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.4": {
          "rap": "4,400",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.5": {
          "rap": "6,600",
          "low_price": "5,220",
          "high_price": "11,310"
        },
        "1.6": {
          "rap": "6,600",
          "low_price": "5,570",
          "high_price": "12,065"
        },
        "1.7": {
          "rap": "6,600",
          "low_price": "5,915",
          "high_price": "12,820"
        },
        "1.8": {
          "rap": "6,600",
          "low_price": "6,265",
          "high_price": "13,570"
        },
        "1.9": {
          "rap": "6,600",
          "low_price": "6,610",
          "high_price": "14,325"
        },
        "2.0": {
          "rap": "8,700",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "2.1": {
          "rap": "8,700",
          "low_price": "10,205",
          "high_price": "22,115"
        },
        "2.2": {
          "rap": "8,700",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "2.3": {
          "rap": "8,700",
          "low_price": "11,180",
          "high_price": "24,220"
        },
        "2.4": {
          "rap": "8,700",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "2.5": {
          "rap": "8,700",
          "low_price": "12,150",
          "high_price": "26,325"
        },
        "2.6": {
          "rap": "8,700",
          "low_price": "12,635",
          "high_price": "27,380"
        },
        "2.7": {
          "rap": "8,700",
          "low_price": "13,120",
          "high_price": "28,430"
        },
        "2.8": {
          "rap": "8,700",
          "low_price": "13,610",
          "high_price": "29,485"
        },
        "2.9": {
          "rap": "8,700",
          "low_price": "14,095",
          "high_price": "30,535"
        },
        "3.0": {
          "rap": "13,900",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "3.1": {
          "rap": "13,900",
          "low_price": "25,110",
          "high_price": "54,405"
        },
        "3.2": {
          "rap": "13,900",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "3.3": {
          "rap": "13,900",
          "low_price": "26,730",
          "high_price": "57,915"
        },
        "3.4": {
          "rap": "13,900",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "3.5": {
          "rap": "13,900",
          "low_price": "28,350",
          "high_price": "61,425"
        },
        "3.6": {
          "rap": "13,900",
          "low_price": "29,160",
          "high_price": "63,180"
        },
        "3.7": {
          "rap": "13,900",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "3.8": {
          "rap": "13,900",
          "low_price": "30,780",
          "high_price": "66,690"
        },
        "3.9": {
          "rap": "13,900",
          "low_price": "31,590",
          "high_price": "68,445"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,300",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "2,900",
          "low_price": "1,405",
          "high_price": "3,040"
        },
        "1.0": {
          "rap": "3,500",
          "low_price": "1,800",
          "high_price": "3,900"
        },
        "1.1": {
          "rap": "3,500",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.2": {
          "rap": "3,500",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.3": {
          "rap": "3,500",
          "low_price": "2,340",
          "high_price": "5,070"
        },
        "1.4": {
          "rap": "3,500",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.5": {
          "rap": "5,300",
          "low_price": "4,050",
          "high_price": "8,775"
        },
        "1.6": {
          "rap": "5,300",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.7": {
          "rap": "5,300",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.8": {
          "rap": "5,300",
          "low_price": "4,860",
          "high_price": "10,530"
        },
        "1.9": {
          "rap": "5,300",
          "low_price": "5,130",
          "high_price": "11,115"
        },
        "2.0": {
          "rap": "7,100",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.1": {
          "rap": "7,100",
          "low_price": "7,940",
          "high_price": "17,200"
        },
        "2.2": {
          "rap": "7,100",
          "low_price": "8,315",
          "high_price": "18,020"
        },
        "2.3": {
          "rap": "7,100",
          "low_price": "8,695",
          "high_price": "18,835"
        },
        "2.4": {
          "rap": "7,100",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "2.5": {
          "rap": "7,100",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "2.6": {
          "rap": "7,100",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "2.7": {
          "rap": "7,100",
          "low_price": "10,205",
          "high_price": "22,115"
        },
        "2.8": {
          "rap": "7,100",
          "low_price": "10,585",
          "high_price": "22,930"
        },
        "2.9": {
          "rap": "7,100",
          "low_price": "10,960",
          "high_price": "23,750"
        },
        "3.0": {
          "rap": "10,800",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "3.1": {
          "rap": "10,800",
          "low_price": "19,530",
          "high_price": "42,315"
        },
        "3.2": {
          "rap": "10,800",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "3.3": {
          "rap": "10,800",
          "low_price": "20,790",
          "high_price": "45,045"
        },
        "3.4": {
          "rap": "10,800",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "3.5": {
          "rap": "10,800",
          "low_price": "22,050",
          "high_price": "47,775"
        },
        "3.6": {
          "rap": "10,800",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "3.7": {
          "rap": "10,800",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "3.8": {
          "rap": "10,800",
          "low_price": "23,940",
          "high_price": "51,870"
        },
        "3.9": {
          "rap": "10,800",
          "low_price": "24,570",
          "high_price": "53,235"
        }
      }
    }
  },
  "Round": {
    "I1": {
      "D": {
        "0.4": {
          "rap": "1,800",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,200",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "2,200",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "2,800",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "2,800",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "3,800",
          "low_price": "1,460",
          "high_price": "3,160"
        },
        "1.0": {
          "rap": "5,100",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.1": {
          "rap": "5,100",
          "low_price": "2,180",
          "high_price": "4,720"
        },
        "1.2": {
          "rap": "5,100",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.3": {
          "rap": "5,100",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.4": {
          "rap": "5,100",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.5": {
          "rap": "7,500",
          "low_price": "4,950",
          "high_price": "10,725"
        },
        "1.6": {
          "rap": "7,500",
          "low_price": "5,280",
          "high_price": "11,440"
        },
        "1.7": {
          "rap": "7,500",
          "low_price": "5,610",
          "high_price": "12,155"
        },
        "1.8": {
          "rap": "7,500",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "1.9": {
          "rap": "7,500",
          "low_price": "6,270",
          "high_price": "13,585"
        },
        "2.0": {
          "rap": "9,400",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "2.1": {
          "rap": "9,400",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.2": {
          "rap": "9,400",
          "low_price": "10,560",
          "high_price": "22,880"
        },
        "2.3": {
          "rap": "9,400",
          "low_price": "11,040",
          "high_price": "23,920"
        },
        "2.4": {
          "rap": "9,400",
          "low_price": "11,520",
          "high_price": "24,960"
        },
        "2.5": {
          "rap": "9,400",
          "low_price": "12,000",
          "high_price": "26,000"
        },
        "2.6": {
          "rap": "9,400",
          "low_price": "12,480",
          "high_price": "27,040"
        },
        "2.7": {
          "rap": "9,400",
          "low_price": "12,960",
          "high_price": "28,080"
        },
        "2.8": {
          "rap": "9,400",
          "low_price": "13,440",
          "high_price": "29,120"
        },
        "2.9": {
          "rap": "9,400",
          "low_price": "13,920",
          "high_price": "30,160"
        },
        "3.0": {
          "rap": "10,700",
          "low_price": "18,540",
          "high_price": "40,170"
        },
        "3.1": {
          "rap": "10,700",
          "low_price": "19,160",
          "high_price": "41,510"
        },
        "3.2": {
          "rap": "10,700",
          "low_price": "19,775",
          "high_price": "42,850"
        },
        "3.3": {
          "rap": "10,700",
          "low_price": "20,395",
          "high_price": "44,185"
        },
        "3.4": {
          "rap": "10,700",
          "low_price": "21,010",
          "high_price": "45,525"
        },
        "3.5": {
          "rap": "10,700",
          "low_price": "21,630",
          "high_price": "46,865"
        },
        "3.6": {
          "rap": "10,700",
          "low_price": "22,250",
          "high_price": "48,205"
        },
        "3.7": {
          "rap": "10,700",
          "low_price": "22,865",
          "high_price": "49,545"
        },
        "3.8": {
          "rap": "10,700",
          "low_price": "23,485",
          "high_price": "50,880"
        },
        "3.9": {
          "rap": "10,700",
          "low_price": "24,100",
          "high_price": "52,220"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,700",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,700",
          "low_price": "800",
          "high_price": "1,730"
        },
        "0.8": {
          "rap": "2,700",
          "low_price": "910",
          "high_price": "1,975"
        },
        "0.9": {
          "rap": "3,700",
          "low_price": "1,350",
          "high_price": "2,925"
        },
        "1.0": {
          "rap": "4,800",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "4,800",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "4,800",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "4,800",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "4,800",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "7,000",
          "low_price": "4,680",
          "high_price": "10,140"
        },
        "1.6": {
          "rap": "7,000",
          "low_price": "4,990",
          "high_price": "10,815"
        },
        "1.7": {
          "rap": "7,000",
          "low_price": "5,305",
          "high_price": "11,490"
        },
        "1.8": {
          "rap": "7,000",
          "low_price": "5,615",
          "high_price": "12,170"
        },
        "1.9": {
          "rap": "7,000",
          "low_price": "5,930",
          "high_price": "12,845"
        },
        "2.0": {
          "rap": "9,000",
          "low_price": "9,120",
          "high_price": "19,760"
        },
        "2.1": {
          "rap": "9,000",
          "low_price": "9,575",
          "high_price": "20,750"
        },
        "2.2": {
          "rap": "9,000",
          "low_price": "10,030",
          "high_price": "21,735"
        },
        "2.3": {
          "rap": "9,000",
          "low_price": "10,490",
          "high_price": "22,725"
        },
        "2.4": {
          "rap": "9,000",
          "low_price": "10,945",
          "high_price": "23,710"
        },
        "2.5": {
          "rap": "9,000",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "2.6": {
          "rap": "9,000",
          "low_price": "11,855",
          "high_price": "25,690"
        },
        "2.7": {
          "rap": "9,000",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "2.8": {
          "rap": "9,000",
          "low_price": "12,770",
          "high_price": "27,665"
        },
        "2.9": {
          "rap": "9,000",
          "low_price": "13,225",
          "high_price": "28,650"
        },
        "3.0": {
          "rap": "10,200",
          "low_price": "17,640",
          "high_price": "38,220"
        },
        "3.1": {
          "rap": "10,200",
          "low_price": "18,230",
          "high_price": "39,495"
        },
        "3.2": {
          "rap": "10,200",
          "low_price": "18,815",
          "high_price": "40,770"
        },
        "3.3": {
          "rap": "10,200",
          "low_price": "19,405",
          "high_price": "42,040"
        },
        "3.4": {
          "rap": "10,200",
          "low_price": "19,990",
          "high_price": "43,315"
        },
        "3.5": {
          "rap": "10,200",
          "low_price": "20,580",
          "high_price": "44,590"
        },
        "3.6": {
          "rap": "10,200",
          "low_price": "21,170",
          "high_price": "45,865"
        },
        "3.7": {
          "rap": "10,200",
          "low_price": "21,755",
          "high_price": "47,140"
        },
        "3.8": {
          "rap": "10,200",
          "low_price": "22,345",
          "high_price": "48,410"
        },
        "3.9": {
          "rap": "10,200",
          "low_price": "22,930",
          "high_price": "49,685"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,600",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "2,000",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "2,000",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,500",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,500",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "3,600",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "4,500",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "4,500",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "4,500",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "4,500",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "4,500",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "6,700",
          "low_price": "4,410",
          "high_price": "9,555"
        },
        "1.6": {
          "rap": "6,700",
          "low_price": "4,705",
          "high_price": "10,190"
        },
        "1.7": {
          "rap": "6,700",
          "low_price": "5,000",
          "high_price": "10,830"
        },
        "1.8": {
          "rap": "6,700",
          "low_price": "5,290",
          "high_price": "11,465"
        },
        "1.9": {
          "rap": "6,700",
          "low_price": "5,585",
          "high_price": "12,105"
        },
        "2.0": {
          "rap": "8,500",
          "low_price": "8,640",
          "high_price": "18,720"
        },
        "2.1": {
          "rap": "8,500",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "2.2": {
          "rap": "8,500",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "2.3": {
          "rap": "8,500",
          "low_price": "9,935",
          "high_price": "21,530"
        },
        "2.4": {
          "rap": "8,500",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "2.5": {
          "rap": "8,500",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "2.6": {
          "rap": "8,500",
          "low_price": "11,230",
          "high_price": "24,335"
        },
        "2.7": {
          "rap": "8,500",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "2.8": {
          "rap": "8,500",
          "low_price": "12,095",
          "high_price": "26,210"
        },
        "2.9": {
          "rap": "8,500",
          "low_price": "12,530",
          "high_price": "27,145"
        },
        "3.0": {
          "rap": "9,700",
          "low_price": "16,740",
          "high_price": "36,270"
        },
        "3.1": {
          "rap": "9,700",
          "low_price": "17,300",
          "high_price": "37,480"
        },
        "3.2": {
          "rap": "9,700",
          "low_price": "17,855",
          "high_price": "38,690"
        },
        "3.3": {
          "rap": "9,700",
          "low_price": "18,415",
          "high_price": "39,895"
        },
        "3.4": {
          "rap": "9,700",
          "low_price": "18,970",
          "high_price": "41,105"
        },
        "3.5": {
          "rap": "9,700",
          "low_price": "19,530",
          "high_price": "42,315"
        },
        "3.6": {
          "rap": "9,700",
          "low_price": "20,090",
          "high_price": "43,525"
        },
        "3.7": {
          "rap": "9,700",
          "low_price": "20,645",
          "high_price": "44,735"
        },
        "3.8": {
          "rap": "9,700",
          "low_price": "21,205",
          "high_price": "45,940"
        },
        "3.9": {
          "rap": "9,700",
          "low_price": "21,760",
          "high_price": "47,150"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,500",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "2,400",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,400",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "1.0": {
          "rap": "4,300",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.1": {
          "rap": "4,300",
          "low_price": "1,780",
          "high_price": "3,860"
        },
        "1.2": {
          "rap": "4,300",
          "low_price": "1,945",
          "high_price": "4,210"
        },
        "1.3": {
          "rap": "4,300",
          "low_price": "2,105",
          "high_price": "4,565"
        },
        "1.4": {
          "rap": "4,300",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.5": {
          "rap": "6,400",
          "low_price": "4,140",
          "high_price": "8,970"
        },
        "1.6": {
          "rap": "6,400",
          "low_price": "4,415",
          "high_price": "9,570"
        },
        "1.7": {
          "rap": "6,400",
          "low_price": "4,690",
          "high_price": "10,165"
        },
        "1.8": {
          "rap": "6,400",
          "low_price": "4,970",
          "high_price": "10,765"
        },
        "1.9": {
          "rap": "6,400",
          "low_price": "5,245",
          "high_price": "11,360"
        },
        "2.0": {
          "rap": "8,200",
          "low_price": "8,160",
          "high_price": "17,680"
        },
        "2.1": {
          "rap": "8,200",
          "low_price": "8,570",
          "high_price": "18,565"
        },
        "2.2": {
          "rap": "8,200",
          "low_price": "8,975",
          "high_price": "19,450"
        },
        "2.3": {
          "rap": "8,200",
          "low_price": "9,385",
          "high_price": "20,330"
        },
        "2.4": {
          "rap": "8,200",
          "low_price": "9,790",
          "high_price": "21,215"
        },
        "2.5": {
          "rap": "8,200",
          "low_price": "10,200",
          "high_price": "22,100"
        },
        "2.6": {
          "rap": "8,200",
          "low_price": "10,610",
          "high_price": "22,985"
        },
        "2.7": {
          "rap": "8,200",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "2.8": {
          "rap": "8,200",
          "low_price": "11,425",
          "high_price": "24,750"
        },
        "2.9": {
          "rap": "8,200",
          "low_price": "11,830",
          "high_price": "25,635"
        },
        "3.0": {
          "rap": "9,100",
          "low_price": "15,660",
          "high_price": "33,930"
        },
        "3.1": {
          "rap": "9,100",
          "low_price": "16,180",
          "high_price": "35,060"
        },
        "3.2": {
          "rap": "9,100",
          "low_price": "16,705",
          "high_price": "36,190"
        },
        "3.3": {
          "rap": "9,100",
          "low_price": "17,225",
          "high_price": "37,325"
        },
        "3.4": {
          "rap": "9,100",
          "low_price": "17,750",
          "high_price": "38,455"
        },
        "3.5": {
          "rap": "9,100",
          "low_price": "18,270",
          "high_price": "39,585"
        },
        "3.6": {
          "rap": "9,100",
          "low_price": "18,790",
          "high_price": "40,715"
        },
        "3.7": {
          "rap": "9,100",
          "low_price": "19,315",
          "high_price": "41,845"
        },
        "3.8": {
          "rap": "9,100",
          "low_price": "19,835",
          "high_price": "42,980"
        },
        "3.9": {
          "rap": "9,100",
          "low_price": "20,360",
          "high_price": "44,110"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,400",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "330",
          "high_price": "715"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "395",
          "high_price": "860"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "3,300",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "1.0": {
          "rap": "4,000",
          "low_price": "1,560",
          "high_price": "3,380"
        },
        "1.1": {
          "rap": "4,000",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.2": {
          "rap": "4,000",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.3": {
          "rap": "4,000",
          "low_price": "2,030",
          "high_price": "4,395"
        },
        "1.4": {
          "rap": "4,000",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.5": {
          "rap": "6,000",
          "low_price": "3,780",
          "high_price": "8,190"
        },
        "1.6": {
          "rap": "6,000",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.7": {
          "rap": "6,000",
          "low_price": "4,285",
          "high_price": "9,280"
        },
        "1.8": {
          "rap": "6,000",
          "low_price": "4,535",
          "high_price": "9,830"
        },
        "1.9": {
          "rap": "6,000",
          "low_price": "4,790",
          "high_price": "10,375"
        },
        "2.0": {
          "rap": "7,800",
          "low_price": "7,800",
          "high_price": "16,900"
        },
        "2.1": {
          "rap": "7,800",
          "low_price": "8,190",
          "high_price": "17,745"
        },
        "2.2": {
          "rap": "7,800",
          "low_price": "8,580",
          "high_price": "18,590"
        },
        "2.3": {
          "rap": "7,800",
          "low_price": "8,970",
          "high_price": "19,435"
        },
        "2.4": {
          "rap": "7,800",
          "low_price": "9,360",
          "high_price": "20,280"
        },
        "2.5": {
          "rap": "7,800",
          "low_price": "9,750",
          "high_price": "21,125"
        },
        "2.6": {
          "rap": "7,800",
          "low_price": "10,140",
          "high_price": "21,970"
        },
        "2.7": {
          "rap": "7,800",
          "low_price": "10,530",
          "high_price": "22,815"
        },
        "2.8": {
          "rap": "7,800",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.9": {
          "rap": "7,800",
          "low_price": "11,310",
          "high_price": "24,505"
        },
        "3.0": {
          "rap": "8,600",
          "low_price": "14,760",
          "high_price": "31,980"
        },
        "3.1": {
          "rap": "8,600",
          "low_price": "15,250",
          "high_price": "33,045"
        },
        "3.2": {
          "rap": "8,600",
          "low_price": "15,745",
          "high_price": "34,110"
        },
        "3.3": {
          "rap": "8,600",
          "low_price": "16,235",
          "high_price": "35,180"
        },
        "3.4": {
          "rap": "8,600",
          "low_price": "16,730",
          "high_price": "36,245"
        },
        "3.5": {
          "rap": "8,600",
          "low_price": "17,220",
          "high_price": "37,310"
        },
        "3.6": {
          "rap": "8,600",
          "low_price": "17,710",
          "high_price": "38,375"
        },
        "3.7": {
          "rap": "8,600",
          "low_price": "18,205",
          "high_price": "39,440"
        },
        "3.8": {
          "rap": "8,600",
          "low_price": "18,695",
          "high_price": "40,510"
        },
        "3.9": {
          "rap": "8,600",
          "low_price": "19,190",
          "high_price": "41,575"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,200",
          "low_price": "215",
          "high_price": "470"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "300",
          "high_price": "650"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "360",
          "high_price": "780"
        },
        "0.7": {
          "rap": "2,100",
          "low_price": "590",
          "high_price": "1,275"
        },
        "0.8": {
          "rap": "2,100",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.9": {
          "rap": "3,000",
          "low_price": "1,080",
          "high_price": "2,340"
        },
        "1.0": {
          "rap": "3,700",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "1.1": {
          "rap": "3,700",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.2": {
          "rap": "3,700",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.3": {
          "rap": "3,700",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.4": {
          "rap": "3,700",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.5": {
          "rap": "5,500",
          "low_price": "3,510",
          "high_price": "7,605"
        },
        "1.6": {
          "rap": "5,500",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.7": {
          "rap": "5,500",
          "low_price": "3,980",
          "high_price": "8,620"
        },
        "1.8": {
          "rap": "5,500",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.9": {
          "rap": "5,500",
          "low_price": "4,445",
          "high_price": "9,635"
        },
        "2.0": {
          "rap": "7,200",
          "low_price": "7,320",
          "high_price": "15,860"
        },
        "2.1": {
          "rap": "7,200",
          "low_price": "7,685",
          "high_price": "16,655"
        },
        "2.2": {
          "rap": "7,200",
          "low_price": "8,050",
          "high_price": "17,445"
        },
        "2.3": {
          "rap": "7,200",
          "low_price": "8,420",
          "high_price": "18,240"
        },
        "2.4": {
          "rap": "7,200",
          "low_price": "8,785",
          "high_price": "19,030"
        },
        "2.5": {
          "rap": "7,200",
          "low_price": "9,150",
          "high_price": "19,825"
        },
        "2.6": {
          "rap": "7,200",
          "low_price": "9,515",
          "high_price": "20,620"
        },
        "2.7": {
          "rap": "7,200",
          "low_price": "9,880",
          "high_price": "21,410"
        },
        "2.8": {
          "rap": "7,200",
          "low_price": "10,250",
          "high_price": "22,205"
        },
        "2.9": {
          "rap": "7,200",
          "low_price": "10,615",
          "high_price": "22,995"
        },
        "3.0": {
          "rap": "8,000",
          "low_price": "13,860",
          "high_price": "30,030"
        },
        "3.1": {
          "rap": "8,000",
          "low_price": "14,320",
          "high_price": "31,030"
        },
        "3.2": {
          "rap": "8,000",
          "low_price": "14,785",
          "high_price": "32,030"
        },
        "3.3": {
          "rap": "8,000",
          "low_price": "15,245",
          "high_price": "33,035"
        },
        "3.4": {
          "rap": "8,000",
          "low_price": "15,710",
          "high_price": "34,035"
        },
        "3.5": {
          "rap": "8,000",
          "low_price": "16,170",
          "high_price": "35,035"
        },
        "3.6": {
          "rap": "8,000",
          "low_price": "16,630",
          "high_price": "36,035"
        },
        "3.7": {
          "rap": "8,000",
          "low_price": "17,095",
          "high_price": "37,035"
        },
        "3.8": {
          "rap": "8,000",
          "low_price": "17,555",
          "high_price": "38,040"
        },
        "3.9": {
          "rap": "8,000",
          "low_price": "18,020",
          "high_price": "39,040"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,100",
          "low_price": "215",
          "high_price": "470"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "300",
          "high_price": "650"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "360",
          "high_price": "780"
        },
        "0.7": {
          "rap": "2,000",
          "low_price": "545",
          "high_price": "1,185"
        },
        "0.8": {
          "rap": "2,000",
          "low_price": "625",
          "high_price": "1,350"
        },
        "0.9": {
          "rap": "2,600",
          "low_price": "1,025",
          "high_price": "2,225"
        },
        "1.0": {
          "rap": "3,400",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "1.1": {
          "rap": "3,400",
          "low_price": "1,450",
          "high_price": "3,145"
        },
        "1.2": {
          "rap": "3,400",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.3": {
          "rap": "3,400",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.4": {
          "rap": "3,400",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.5": {
          "rap": "4,900",
          "low_price": "3,150",
          "high_price": "6,825"
        },
        "1.6": {
          "rap": "4,900",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "1.7": {
          "rap": "4,900",
          "low_price": "3,570",
          "high_price": "7,735"
        },
        "1.8": {
          "rap": "4,900",
          "low_price": "3,780",
          "high_price": "8,190"
        },
        "1.9": {
          "rap": "4,900",
          "low_price": "3,990",
          "high_price": "8,645"
        },
        "2.0": {
          "rap": "6,600",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "2.1": {
          "rap": "6,600",
          "low_price": "6,805",
          "high_price": "14,740"
        },
        "2.2": {
          "rap": "6,600",
          "low_price": "7,130",
          "high_price": "15,445"
        },
        "2.3": {
          "rap": "6,600",
          "low_price": "7,450",
          "high_price": "16,145"
        },
        "2.4": {
          "rap": "6,600",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "2.5": {
          "rap": "6,600",
          "low_price": "8,100",
          "high_price": "17,550"
        },
        "2.6": {
          "rap": "6,600",
          "low_price": "8,425",
          "high_price": "18,250"
        },
        "2.7": {
          "rap": "6,600",
          "low_price": "8,750",
          "high_price": "18,955"
        },
        "2.8": {
          "rap": "6,600",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "2.9": {
          "rap": "6,600",
          "low_price": "9,395",
          "high_price": "20,360"
        },
        "3.0": {
          "rap": "7,100",
          "low_price": "12,780",
          "high_price": "27,690"
        },
        "3.1": {
          "rap": "7,100",
          "low_price": "13,205",
          "high_price": "28,615"
        },
        "3.2": {
          "rap": "7,100",
          "low_price": "13,630",
          "high_price": "29,535"
        },
        "3.3": {
          "rap": "7,100",
          "low_price": "14,060",
          "high_price": "30,460"
        },
        "3.4": {
          "rap": "7,100",
          "low_price": "14,485",
          "high_price": "31,380"
        },
        "3.5": {
          "rap": "7,100",
          "low_price": "14,910",
          "high_price": "32,305"
        },
        "3.6": {
          "rap": "7,100",
          "low_price": "15,335",
          "high_price": "33,230"
        },
        "3.7": {
          "rap": "7,100",
          "low_price": "15,760",
          "high_price": "34,150"
        },
        "3.8": {
          "rap": "7,100",
          "low_price": "16,190",
          "high_price": "35,075"
        },
        "3.9": {
          "rap": "7,100",
          "low_price": "16,615",
          "high_price": "35,995"
        }
      },
      "K": {
        "0.4": {
          "rap": "900",
          "low_price": "190",
          "high_price": "415"
        },
        "0.5": {
          "rap": "1,200",
          "low_price": "270",
          "high_price": "585"
        },
        "0.6": {
          "rap": "1,200",
          "low_price": "325",
          "high_price": "700"
        },
        "0.7": {
          "rap": "1,700",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.8": {
          "rap": "1,700",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.9": {
          "rap": "2,300",
          "low_price": "920",
          "high_price": "1,990"
        },
        "1.0": {
          "rap": "3,200",
          "low_price": "1,260",
          "high_price": "2,730"
        },
        "1.1": {
          "rap": "3,200",
          "low_price": "1,385",
          "high_price": "3,005"
        },
        "1.2": {
          "rap": "3,200",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "1.3": {
          "rap": "3,200",
          "low_price": "1,640",
          "high_price": "3,550"
        },
        "1.4": {
          "rap": "3,200",
          "low_price": "1,765",
          "high_price": "3,820"
        },
        "1.5": {
          "rap": "4,500",
          "low_price": "2,790",
          "high_price": "6,045"
        },
        "1.6": {
          "rap": "4,500",
          "low_price": "2,975",
          "high_price": "6,450"
        },
        "1.7": {
          "rap": "4,500",
          "low_price": "3,160",
          "high_price": "6,850"
        },
        "1.8": {
          "rap": "4,500",
          "low_price": "3,350",
          "high_price": "7,255"
        },
        "1.9": {
          "rap": "4,500",
          "low_price": "3,535",
          "high_price": "7,655"
        },
        "2.0": {
          "rap": "5,800",
          "low_price": "5,640",
          "high_price": "12,220"
        },
        "2.1": {
          "rap": "5,800",
          "low_price": "5,920",
          "high_price": "12,830"
        },
        "2.2": {
          "rap": "5,800",
          "low_price": "6,205",
          "high_price": "13,440"
        },
        "2.3": {
          "rap": "5,800",
          "low_price": "6,485",
          "high_price": "14,055"
        },
        "2.4": {
          "rap": "5,800",
          "low_price": "6,770",
          "high_price": "14,665"
        },
        "2.5": {
          "rap": "5,800",
          "low_price": "7,050",
          "high_price": "15,275"
        },
        "2.6": {
          "rap": "5,800",
          "low_price": "7,330",
          "high_price": "15,885"
        },
        "2.7": {
          "rap": "5,800",
          "low_price": "7,615",
          "high_price": "16,495"
        },
        "2.8": {
          "rap": "5,800",
          "low_price": "7,895",
          "high_price": "17,110"
        },
        "2.9": {
          "rap": "5,800",
          "low_price": "8,180",
          "high_price": "17,720"
        },
        "3.0": {
          "rap": "6,200",
          "low_price": "11,160",
          "high_price": "24,180"
        },
        "3.1": {
          "rap": "6,200",
          "low_price": "11,530",
          "high_price": "24,985"
        },
        "3.2": {
          "rap": "6,200",
          "low_price": "11,905",
          "high_price": "25,790"
        },
        "3.3": {
          "rap": "6,200",
          "low_price": "12,275",
          "high_price": "26,600"
        },
        "3.4": {
          "rap": "6,200",
          "low_price": "12,650",
          "high_price": "27,405"
        },
        "3.5": {
          "rap": "6,200",
          "low_price": "13,020",
          "high_price": "28,210"
        },
        "3.6": {
          "rap": "6,200",
          "low_price": "13,390",
          "high_price": "29,015"
        },
        "3.7": {
          "rap": "6,200",
          "low_price": "13,765",
          "high_price": "29,820"
        },
        "3.8": {
          "rap": "6,200",
          "low_price": "14,135",
          "high_price": "30,630"
        },
        "3.9": {
          "rap": "6,200",
          "low_price": "14,510",
          "high_price": "31,435"
        }
      }
    },
    "IF": {
      "D": {
        "0.4": {
          "rap": "4,700",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.5": {
          "rap": "7,200",
          "low_price": "1,650",
          "high_price": "3,575"
        },
        "0.6": {
          "rap": "7,200",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "0.7": {
          "rap": "9,900",
          "low_price": "2,940",
          "high_price": "6,370"
        },
        "0.8": {
          "rap": "9,900",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "0.9": {
          "rap": "14,300",
          "low_price": "5,615",
          "high_price": "12,170"
        },
        "1.0": {
          "rap": "22,000",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "1.1": {
          "rap": "22,000",
          "low_price": "10,560",
          "high_price": "22,880"
        },
        "1.2": {
          "rap": "22,000",
          "low_price": "11,520",
          "high_price": "24,960"
        },
        "1.3": {
          "rap": "22,000",
          "low_price": "12,480",
          "high_price": "27,040"
        },
        "1.4": {
          "rap": "22,000",
          "low_price": "13,440",
          "high_price": "29,120"
        },
        "1.5": {
          "rap": "27,500",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "1.6": {
          "rap": "27,500",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "1.7": {
          "rap": "27,500",
          "low_price": "21,420",
          "high_price": "46,410"
        },
        "1.8": {
          "rap": "27,500",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "1.9": {
          "rap": "27,500",
          "low_price": "23,940",
          "high_price": "51,870"
        },
        "2.0": {
          "rap": "44,500",
          "low_price": "39,600",
          "high_price": "85,800"
        },
        "2.1": {
          "rap": "44,500",
          "low_price": "41,580",
          "high_price": "90,090"
        },
        "2.2": {
          "rap": "44,500",
          "low_price": "43,560",
          "high_price": "94,380"
        },
        "2.3": {
          "rap": "44,500",
          "low_price": "45,540",
          "high_price": "98,670"
        },
        "2.4": {
          "rap": "44,500",
          "low_price": "47,520",
          "high_price": "102,960"
        },
        "2.5": {
          "rap": "44,500",
          "low_price": "49,500",
          "high_price": "107,250"
        },
        "2.6": {
          "rap": "44,500",
          "low_price": "51,480",
          "high_price": "111,540"
        },
        "2.7": {
          "rap": "44,500",
          "low_price": "53,460",
          "high_price": "115,830"
        },
        "2.8": {
          "rap": "44,500",
          "low_price": "55,440",
          "high_price": "120,120"
        },
        "2.9": {
          "rap": "44,500",
          "low_price": "57,420",
          "high_price": "124,410"
        },
        "3.0": {
          "rap": "70,000",
          "low_price": "99,000",
          "high_price": "214,500"
        },
        "3.1": {
          "rap": "70,000",
          "low_price": "102,300",
          "high_price": "221,650"
        },
        "3.2": {
          "rap": "70,000",
          "low_price": "105,600",
          "high_price": "228,800"
        },
        "3.3": {
          "rap": "70,000",
          "low_price": "108,900",
          "high_price": "235,950"
        },
        "3.4": {
          "rap": "70,000",
          "low_price": "112,200",
          "high_price": "243,100"
        },
        "3.5": {
          "rap": "70,000",
          "low_price": "115,500",
          "high_price": "250,250"
        },
        "3.6": {
          "rap": "70,000",
          "low_price": "118,800",
          "high_price": "257,400"
        },
        "3.7": {
          "rap": "70,000",
          "low_price": "122,100",
          "high_price": "264,550"
        },
        "3.8": {
          "rap": "70,000",
          "low_price": "125,400",
          "high_price": "271,700"
        },
        "3.9": {
          "rap": "70,000",
          "low_price": "128,700",
          "high_price": "278,850"
        }
      },
      "E": {
        "0.4": {
          "rap": "4,000",
          "low_price": "695",
          "high_price": "1,510"
        },
        "0.5": {
          "rap": "5,800",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "0.6": {
          "rap": "5,800",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "0.7": {
          "rap": "7,800",
          "low_price": "2,395",
          "high_price": "5,185"
        },
        "0.8": {
          "rap": "7,800",
          "low_price": "2,735",
          "high_price": "5,930"
        },
        "0.9": {
          "rap": "12,600",
          "low_price": "4,860",
          "high_price": "10,530"
        },
        "1.0": {
          "rap": "16,800",
          "low_price": "7,500",
          "high_price": "16,250"
        },
        "1.1": {
          "rap": "16,800",
          "low_price": "8,250",
          "high_price": "17,875"
        },
        "1.2": {
          "rap": "16,800",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "1.3": {
          "rap": "16,800",
          "low_price": "9,750",
          "high_price": "21,125"
        },
        "1.4": {
          "rap": "16,800",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "1.5": {
          "rap": "24,200",
          "low_price": "16,920",
          "high_price": "36,660"
        },
        "1.6": {
          "rap": "24,200",
          "low_price": "18,050",
          "high_price": "39,105"
        },
        "1.7": {
          "rap": "24,200",
          "low_price": "19,175",
          "high_price": "41,550"
        },
        "1.8": {
          "rap": "24,200",
          "low_price": "20,305",
          "high_price": "43,990"
        },
        "1.9": {
          "rap": "24,200",
          "low_price": "21,430",
          "high_price": "46,435"
        },
        "2.0": {
          "rap": "36,500",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "2.1": {
          "rap": "36,500",
          "low_price": "34,020",
          "high_price": "73,710"
        },
        "2.2": {
          "rap": "36,500",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "2.3": {
          "rap": "36,500",
          "low_price": "37,260",
          "high_price": "80,730"
        },
        "2.4": {
          "rap": "36,500",
          "low_price": "38,880",
          "high_price": "84,240"
        },
        "2.5": {
          "rap": "36,500",
          "low_price": "40,500",
          "high_price": "87,750"
        },
        "2.6": {
          "rap": "36,500",
          "low_price": "42,120",
          "high_price": "91,260"
        },
        "2.7": {
          "rap": "36,500",
          "low_price": "43,740",
          "high_price": "94,770"
        },
        "2.8": {
          "rap": "36,500",
          "low_price": "45,360",
          "high_price": "98,280"
        },
        "2.9": {
          "rap": "36,500",
          "low_price": "46,980",
          "high_price": "101,790"
        },
        "3.0": {
          "rap": "56,500",
          "low_price": "81,000",
          "high_price": "175,500"
        },
        "3.1": {
          "rap": "56,500",
          "low_price": "83,700",
          "high_price": "181,350"
        },
        "3.2": {
          "rap": "56,500",
          "low_price": "86,400",
          "high_price": "187,200"
        },
        "3.3": {
          "rap": "56,500",
          "low_price": "89,100",
          "high_price": "193,050"
        },
        "3.4": {
          "rap": "56,500",
          "low_price": "91,800",
          "high_price": "198,900"
        },
        "3.5": {
          "rap": "56,500",
          "low_price": "94,500",
          "high_price": "204,750"
        },
        "3.6": {
          "rap": "56,500",
          "low_price": "97,200",
          "high_price": "210,600"
        },
        "3.7": {
          "rap": "56,500",
          "low_price": "99,900",
          "high_price": "216,450"
        },
        "3.8": {
          "rap": "56,500",
          "low_price": "102,600",
          "high_price": "222,300"
        },
        "3.9": {
          "rap": "56,500",
          "low_price": "105,300",
          "high_price": "228,150"
        }
      },
      "F": {
        "0.4": {
          "rap": "3,700",
          "low_price": "625",
          "high_price": "1,350"
        },
        "0.5": {
          "rap": "5,100",
          "low_price": "1,140",
          "high_price": "2,470"
        },
        "0.6": {
          "rap": "5,100",
          "low_price": "1,370",
          "high_price": "2,965"
        },
        "0.7": {
          "rap": "7,200",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "0.8": {
          "rap": "7,200",
          "low_price": "2,400",
          "high_price": "5,200"
        },
        "0.9": {
          "rap": "11,500",
          "low_price": "4,430",
          "high_price": "9,595"
        },
        "1.0": {
          "rap": "14,900",
          "low_price": "6,420",
          "high_price": "13,910"
        },
        "1.1": {
          "rap": "14,900",
          "low_price": "7,060",
          "high_price": "15,300"
        },
        "1.2": {
          "rap": "14,900",
          "low_price": "7,705",
          "high_price": "16,690"
        },
        "1.3": {
          "rap": "14,900",
          "low_price": "8,345",
          "high_price": "18,085"
        },
        "1.4": {
          "rap": "14,900",
          "low_price": "8,990",
          "high_price": "19,475"
        },
        "1.5": {
          "rap": "21,300",
          "low_price": "14,760",
          "high_price": "31,980"
        },
        "1.6": {
          "rap": "21,300",
          "low_price": "15,745",
          "high_price": "34,110"
        },
        "1.7": {
          "rap": "21,300",
          "low_price": "16,730",
          "high_price": "36,245"
        },
        "1.8": {
          "rap": "21,300",
          "low_price": "17,710",
          "high_price": "38,375"
        },
        "1.9": {
          "rap": "21,300",
          "low_price": "18,695",
          "high_price": "40,510"
        },
        "2.0": {
          "rap": "31,000",
          "low_price": "29,400",
          "high_price": "63,700"
        },
        "2.1": {
          "rap": "31,000",
          "low_price": "30,870",
          "high_price": "66,885"
        },
        "2.2": {
          "rap": "31,000",
          "low_price": "32,340",
          "high_price": "70,070"
        },
        "2.3": {
          "rap": "31,000",
          "low_price": "33,810",
          "high_price": "73,255"
        },
        "2.4": {
          "rap": "31,000",
          "low_price": "35,280",
          "high_price": "76,440"
        },
        "2.5": {
          "rap": "31,000",
          "low_price": "36,750",
          "high_price": "79,625"
        },
        "2.6": {
          "rap": "31,000",
          "low_price": "38,220",
          "high_price": "82,810"
        },
        "2.7": {
          "rap": "31,000",
          "low_price": "39,690",
          "high_price": "85,995"
        },
        "2.8": {
          "rap": "31,000",
          "low_price": "41,160",
          "high_price": "89,180"
        },
        "2.9": {
          "rap": "31,000",
          "low_price": "42,630",
          "high_price": "92,365"
        },
        "3.0": {
          "rap": "47,500",
          "low_price": "72,900",
          "high_price": "157,950"
        },
        "3.1": {
          "rap": "47,500",
          "low_price": "75,330",
          "high_price": "163,215"
        },
        "3.2": {
          "rap": "47,500",
          "low_price": "77,760",
          "high_price": "168,480"
        },
        "3.3": {
          "rap": "47,500",
          "low_price": "80,190",
          "high_price": "173,745"
        },
        "3.4": {
          "rap": "47,500",
          "low_price": "82,620",
          "high_price": "179,010"
        },
        "3.5": {
          "rap": "47,500",
          "low_price": "85,050",
          "high_price": "184,275"
        },
        "3.6": {
          "rap": "47,500",
          "low_price": "87,480",
          "high_price": "189,540"
        },
        "3.7": {
          "rap": "47,500",
          "low_price": "89,910",
          "high_price": "194,805"
        },
        "3.8": {
          "rap": "47,500",
          "low_price": "92,340",
          "high_price": "200,070"
        },
        "3.9": {
          "rap": "47,500",
          "low_price": "94,770",
          "high_price": "205,335"
        }
      },
      "G": {
        "0.4": {
          "rap": "3,300",
          "low_price": "550",
          "high_price": "1,195"
        },
        "0.5": {
          "rap": "4,400",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.6": {
          "rap": "4,400",
          "low_price": "1,150",
          "high_price": "2,495"
        },
        "0.7": {
          "rap": "6,300",
          "low_price": "1,765",
          "high_price": "3,820"
        },
        "0.8": {
          "rap": "6,300",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "0.9": {
          "rap": "9,900",
          "low_price": "3,510",
          "high_price": "7,605"
        },
        "1.0": {
          "rap": "12,600",
          "low_price": "4,920",
          "high_price": "10,660"
        },
        "1.1": {
          "rap": "12,600",
          "low_price": "5,410",
          "high_price": "11,725"
        },
        "1.2": {
          "rap": "12,600",
          "low_price": "5,905",
          "high_price": "12,790"
        },
        "1.3": {
          "rap": "12,600",
          "low_price": "6,395",
          "high_price": "13,860"
        },
        "1.4": {
          "rap": "12,600",
          "low_price": "6,890",
          "high_price": "14,925"
        },
        "1.5": {
          "rap": "17,700",
          "low_price": "12,240",
          "high_price": "26,520"
        },
        "1.6": {
          "rap": "17,700",
          "low_price": "13,055",
          "high_price": "28,290"
        },
        "1.7": {
          "rap": "17,700",
          "low_price": "13,870",
          "high_price": "30,055"
        },
        "1.8": {
          "rap": "17,700",
          "low_price": "14,690",
          "high_price": "31,825"
        },
        "1.9": {
          "rap": "17,700",
          "low_price": "15,505",
          "high_price": "33,590"
        },
        "2.0": {
          "rap": "26,000",
          "low_price": "24,600",
          "high_price": "53,300"
        },
        "2.1": {
          "rap": "26,000",
          "low_price": "25,830",
          "high_price": "55,965"
        },
        "2.2": {
          "rap": "26,000",
          "low_price": "27,060",
          "high_price": "58,630"
        },
        "2.3": {
          "rap": "26,000",
          "low_price": "28,290",
          "high_price": "61,295"
        },
        "2.4": {
          "rap": "26,000",
          "low_price": "29,520",
          "high_price": "63,960"
        },
        "2.5": {
          "rap": "26,000",
          "low_price": "30,750",
          "high_price": "66,625"
        },
        "2.6": {
          "rap": "26,000",
          "low_price": "31,980",
          "high_price": "69,290"
        },
        "2.7": {
          "rap": "26,000",
          "low_price": "33,210",
          "high_price": "71,955"
        },
        "2.8": {
          "rap": "26,000",
          "low_price": "34,440",
          "high_price": "74,620"
        },
        "2.9": {
          "rap": "26,000",
          "low_price": "35,670",
          "high_price": "77,285"
        },
        "3.0": {
          "rap": "39,000",
          "low_price": "60,300",
          "high_price": "130,650"
        },
        "3.1": {
          "rap": "39,000",
          "low_price": "62,310",
          "high_price": "135,005"
        },
        "3.2": {
          "rap": "39,000",
          "low_price": "64,320",
          "high_price": "139,360"
        },
        "3.3": {
          "rap": "39,000",
          "low_price": "66,330",
          "high_price": "143,715"
        },
        "3.4": {
          "rap": "39,000",
          "low_price": "68,340",
          "high_price": "148,070"
        },
        "3.5": {
          "rap": "39,000",
          "low_price": "70,350",
          "high_price": "152,425"
        },
        "3.6": {
          "rap": "39,000",
          "low_price": "72,360",
          "high_price": "156,780"
        },
        "3.7": {
          "rap": "39,000",
          "low_price": "74,370",
          "high_price": "161,135"
        },
        "3.8": {
          "rap": "39,000",
          "low_price": "76,380",
          "high_price": "165,490"
        },
        "3.9": {
          "rap": "39,000",
          "low_price": "78,390",
          "high_price": "169,845"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,800",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.5": {
          "rap": "3,900",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "3,900",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,400",
          "low_price": "1,430",
          "high_price": "3,095"
        },
        "0.8": {
          "rap": "5,400",
          "low_price": "1,630",
          "high_price": "3,535"
        },
        "0.9": {
          "rap": "8,200",
          "low_price": "2,700",
          "high_price": "5,850"
        },
        "1.0": {
          "rap": "10,600",
          "low_price": "3,660",
          "high_price": "7,930"
        },
        "1.1": {
          "rap": "10,600",
          "low_price": "4,025",
          "high_price": "8,725"
        },
        "1.2": {
          "rap": "10,600",
          "low_price": "4,390",
          "high_price": "9,515"
        },
        "1.3": {
          "rap": "10,600",
          "low_price": "4,760",
          "high_price": "10,310"
        },
        "1.4": {
          "rap": "10,600",
          "low_price": "5,125",
          "high_price": "11,100"
        },
        "1.5": {
          "rap": "14,500",
          "low_price": "9,720",
          "high_price": "21,060"
        },
        "1.6": {
          "rap": "14,500",
          "low_price": "10,370",
          "high_price": "22,465"
        },
        "1.7": {
          "rap": "14,500",
          "low_price": "11,015",
          "high_price": "23,870"
        },
        "1.8": {
          "rap": "14,500",
          "low_price": "11,665",
          "high_price": "25,270"
        },
        "1.9": {
          "rap": "14,500",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "2.0": {
          "rap": "21,500",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.1": {
          "rap": "21,500",
          "low_price": "20,790",
          "high_price": "45,045"
        },
        "2.2": {
          "rap": "21,500",
          "low_price": "21,780",
          "high_price": "47,190"
        },
        "2.3": {
          "rap": "21,500",
          "low_price": "22,770",
          "high_price": "49,335"
        },
        "2.4": {
          "rap": "21,500",
          "low_price": "23,760",
          "high_price": "51,480"
        },
        "2.5": {
          "rap": "21,500",
          "low_price": "24,750",
          "high_price": "53,625"
        },
        "2.6": {
          "rap": "21,500",
          "low_price": "25,740",
          "high_price": "55,770"
        },
        "2.7": {
          "rap": "21,500",
          "low_price": "26,730",
          "high_price": "57,915"
        },
        "2.8": {
          "rap": "21,500",
          "low_price": "27,720",
          "high_price": "60,060"
        },
        "2.9": {
          "rap": "21,500",
          "low_price": "28,710",
          "high_price": "62,205"
        },
        "3.0": {
          "rap": "31,000",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.1": {
          "rap": "31,000",
          "low_price": "50,220",
          "high_price": "108,810"
        },
        "3.2": {
          "rap": "31,000",
          "low_price": "51,840",
          "high_price": "112,320"
        },
        "3.3": {
          "rap": "31,000",
          "low_price": "53,460",
          "high_price": "115,830"
        },
        "3.4": {
          "rap": "31,000",
          "low_price": "55,080",
          "high_price": "119,340"
        },
        "3.5": {
          "rap": "31,000",
          "low_price": "56,700",
          "high_price": "122,850"
        },
        "3.6": {
          "rap": "31,000",
          "low_price": "58,320",
          "high_price": "126,360"
        },
        "3.7": {
          "rap": "31,000",
          "low_price": "59,940",
          "high_price": "129,870"
        },
        "3.8": {
          "rap": "31,000",
          "low_price": "61,560",
          "high_price": "133,380"
        },
        "3.9": {
          "rap": "31,000",
          "low_price": "63,180",
          "high_price": "136,890"
        }
      },
      "I": {
        "0.4": {
          "rap": "2,400",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "3,300",
          "low_price": "690",
          "high_price": "1,495"
        },
        "0.6": {
          "rap": "3,300",
          "low_price": "830",
          "high_price": "1,795"
        },
        "0.7": {
          "rap": "4,500",
          "low_price": "1,220",
          "high_price": "2,640"
        },
        "0.8": {
          "rap": "4,500",
          "low_price": "1,390",
          "high_price": "3,015"
        },
        "0.9": {
          "rap": "6,900",
          "low_price": "2,430",
          "high_price": "5,265"
        },
        "1.0": {
          "rap": "8,700",
          "low_price": "3,120",
          "high_price": "6,760"
        },
        "1.1": {
          "rap": "8,700",
          "low_price": "3,430",
          "high_price": "7,435"
        },
        "1.2": {
          "rap": "8,700",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.3": {
          "rap": "8,700",
          "low_price": "4,055",
          "high_price": "8,790"
        },
        "1.4": {
          "rap": "8,700",
          "low_price": "4,370",
          "high_price": "9,465"
        },
        "1.5": {
          "rap": "12,000",
          "low_price": "7,830",
          "high_price": "16,965"
        },
        "1.6": {
          "rap": "12,000",
          "low_price": "8,350",
          "high_price": "18,095"
        },
        "1.7": {
          "rap": "12,000",
          "low_price": "8,875",
          "high_price": "19,225"
        },
        "1.8": {
          "rap": "12,000",
          "low_price": "9,395",
          "high_price": "20,360"
        },
        "1.9": {
          "rap": "12,000",
          "low_price": "9,920",
          "high_price": "21,490"
        },
        "2.0": {
          "rap": "17,500",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.1": {
          "rap": "17,500",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "2.2": {
          "rap": "17,500",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.3": {
          "rap": "17,500",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.4": {
          "rap": "17,500",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.5": {
          "rap": "17,500",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.6": {
          "rap": "17,500",
          "low_price": "21,060",
          "high_price": "45,630"
        },
        "2.7": {
          "rap": "17,500",
          "low_price": "21,870",
          "high_price": "47,385"
        },
        "2.8": {
          "rap": "17,500",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.9": {
          "rap": "17,500",
          "low_price": "23,490",
          "high_price": "50,895"
        },
        "3.0": {
          "rap": "25,000",
          "low_price": "39,600",
          "high_price": "85,800"
        },
        "3.1": {
          "rap": "25,000",
          "low_price": "40,920",
          "high_price": "88,660"
        },
        "3.2": {
          "rap": "25,000",
          "low_price": "42,240",
          "high_price": "91,520"
        },
        "3.3": {
          "rap": "25,000",
          "low_price": "43,560",
          "high_price": "94,380"
        },
        "3.4": {
          "rap": "25,000",
          "low_price": "44,880",
          "high_price": "97,240"
        },
        "3.5": {
          "rap": "25,000",
          "low_price": "46,200",
          "high_price": "100,100"
        },
        "3.6": {
          "rap": "25,000",
          "low_price": "47,520",
          "high_price": "102,960"
        },
        "3.7": {
          "rap": "25,000",
          "low_price": "48,840",
          "high_price": "105,820"
        },
        "3.8": {
          "rap": "25,000",
          "low_price": "50,160",
          "high_price": "108,680"
        },
        "3.9": {
          "rap": "25,000",
          "low_price": "51,480",
          "high_price": "111,540"
        }
      },
      "J": {
        "0.4": {
          "rap": "2,100",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,700",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "2,700",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "3,800",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.8": {
          "rap": "3,800",
          "low_price": "1,150",
          "high_price": "2,495"
        },
        "0.9": {
          "rap": "5,800",
          "low_price": "2,000",
          "high_price": "4,330"
        },
        "1.0": {
          "rap": "7,100",
          "low_price": "2,580",
          "high_price": "5,590"
        },
        "1.1": {
          "rap": "7,100",
          "low_price": "2,840",
          "high_price": "6,150"
        },
        "1.2": {
          "rap": "7,100",
          "low_price": "3,095",
          "high_price": "6,710"
        },
        "1.3": {
          "rap": "7,100",
          "low_price": "3,355",
          "high_price": "7,265"
        },
        "1.4": {
          "rap": "7,100",
          "low_price": "3,610",
          "high_price": "7,825"
        },
        "1.5": {
          "rap": "10,000",
          "low_price": "6,660",
          "high_price": "14,430"
        },
        "1.6": {
          "rap": "10,000",
          "low_price": "7,105",
          "high_price": "15,390"
        },
        "1.7": {
          "rap": "10,000",
          "low_price": "7,550",
          "high_price": "16,355"
        },
        "1.8": {
          "rap": "10,000",
          "low_price": "7,990",
          "high_price": "17,315"
        },
        "1.9": {
          "rap": "10,000",
          "low_price": "8,435",
          "high_price": "18,280"
        },
        "2.0": {
          "rap": "14,500",
          "low_price": "13,080",
          "high_price": "28,340"
        },
        "2.1": {
          "rap": "14,500",
          "low_price": "13,735",
          "high_price": "29,755"
        },
        "2.2": {
          "rap": "14,500",
          "low_price": "14,390",
          "high_price": "31,175"
        },
        "2.3": {
          "rap": "14,500",
          "low_price": "15,040",
          "high_price": "32,590"
        },
        "2.4": {
          "rap": "14,500",
          "low_price": "15,695",
          "high_price": "34,010"
        },
        "2.5": {
          "rap": "14,500",
          "low_price": "16,350",
          "high_price": "35,425"
        },
        "2.6": {
          "rap": "14,500",
          "low_price": "17,005",
          "high_price": "36,840"
        },
        "2.7": {
          "rap": "14,500",
          "low_price": "17,660",
          "high_price": "38,260"
        },
        "2.8": {
          "rap": "14,500",
          "low_price": "18,310",
          "high_price": "39,675"
        },
        "2.9": {
          "rap": "14,500",
          "low_price": "18,965",
          "high_price": "41,095"
        },
        "3.0": {
          "rap": "20,000",
          "low_price": "31,500",
          "high_price": "68,250"
        },
        "3.1": {
          "rap": "20,000",
          "low_price": "32,550",
          "high_price": "70,525"
        },
        "3.2": {
          "rap": "20,000",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "3.3": {
          "rap": "20,000",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "3.4": {
          "rap": "20,000",
          "low_price": "35,700",
          "high_price": "77,350"
        },
        "3.5": {
          "rap": "20,000",
          "low_price": "36,750",
          "high_price": "79,625"
        },
        "3.6": {
          "rap": "20,000",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.7": {
          "rap": "20,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.8": {
          "rap": "20,000",
          "low_price": "39,900",
          "high_price": "86,450"
        },
        "3.9": {
          "rap": "20,000",
          "low_price": "40,950",
          "high_price": "88,725"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,900",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,300",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "2,300",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "3,200",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,200",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "4,800",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.0": {
          "rap": "5,900",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.1": {
          "rap": "5,900",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.2": {
          "rap": "5,900",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.3": {
          "rap": "5,900",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.4": {
          "rap": "5,900",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.5": {
          "rap": "8,400",
          "low_price": "5,670",
          "high_price": "12,285"
        },
        "1.6": {
          "rap": "8,400",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.7": {
          "rap": "8,400",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "1.8": {
          "rap": "8,400",
          "low_price": "6,805",
          "high_price": "14,740"
        },
        "1.9": {
          "rap": "8,400",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.0": {
          "rap": "12,100",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.1": {
          "rap": "12,100",
          "low_price": "11,465",
          "high_price": "24,845"
        },
        "2.2": {
          "rap": "12,100",
          "low_price": "12,010",
          "high_price": "26,025"
        },
        "2.3": {
          "rap": "12,100",
          "low_price": "12,560",
          "high_price": "27,210"
        },
        "2.4": {
          "rap": "12,100",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.5": {
          "rap": "12,100",
          "low_price": "13,650",
          "high_price": "29,575"
        },
        "2.6": {
          "rap": "12,100",
          "low_price": "14,195",
          "high_price": "30,760"
        },
        "2.7": {
          "rap": "12,100",
          "low_price": "14,740",
          "high_price": "31,940"
        },
        "2.8": {
          "rap": "12,100",
          "low_price": "15,290",
          "high_price": "33,125"
        },
        "2.9": {
          "rap": "12,100",
          "low_price": "15,835",
          "high_price": "34,305"
        },
        "3.0": {
          "rap": "16,000",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.1": {
          "rap": "16,000",
          "low_price": "26,970",
          "high_price": "58,435"
        },
        "3.2": {
          "rap": "16,000",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.3": {
          "rap": "16,000",
          "low_price": "28,710",
          "high_price": "62,205"
        },
        "3.4": {
          "rap": "16,000",
          "low_price": "29,580",
          "high_price": "64,090"
        },
        "3.5": {
          "rap": "16,000",
          "low_price": "30,450",
          "high_price": "65,975"
        },
        "3.6": {
          "rap": "16,000",
          "low_price": "31,320",
          "high_price": "67,860"
        },
        "3.7": {
          "rap": "16,000",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.8": {
          "rap": "16,000",
          "low_price": "33,060",
          "high_price": "71,630"
        },
        "3.9": {
          "rap": "16,000",
          "low_price": "33,930",
          "high_price": "73,515"
        }
      }
    },
    "SI1": {
      "D": {
        "0.4": {
          "rap": "2,300",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "3,400",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "3,400",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,600",
          "low_price": "1,220",
          "high_price": "2,640"
        },
        "0.8": {
          "rap": "4,600",
          "low_price": "1,390",
          "high_price": "3,015"
        },
        "0.9": {
          "rap": "6,600",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.0": {
          "rap": "8,500",
          "low_price": "3,120",
          "high_price": "6,760"
        },
        "1.1": {
          "rap": "8,500",
          "low_price": "3,430",
          "high_price": "7,435"
        },
        "1.2": {
          "rap": "8,500",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.3": {
          "rap": "8,500",
          "low_price": "4,055",
          "high_price": "8,790"
        },
        "1.4": {
          "rap": "8,500",
          "low_price": "4,370",
          "high_price": "9,465"
        },
        "1.5": {
          "rap": "12,800",
          "low_price": "8,370",
          "high_price": "18,135"
        },
        "1.6": {
          "rap": "12,800",
          "low_price": "8,930",
          "high_price": "19,345"
        },
        "1.7": {
          "rap": "12,800",
          "low_price": "9,485",
          "high_price": "20,555"
        },
        "1.8": {
          "rap": "12,800",
          "low_price": "10,045",
          "high_price": "21,760"
        },
        "1.9": {
          "rap": "12,800",
          "low_price": "10,600",
          "high_price": "22,970"
        },
        "2.0": {
          "rap": "18,000",
          "low_price": "16,920",
          "high_price": "36,660"
        },
        "2.1": {
          "rap": "18,000",
          "low_price": "17,765",
          "high_price": "38,495"
        },
        "2.2": {
          "rap": "18,000",
          "low_price": "18,610",
          "high_price": "40,325"
        },
        "2.3": {
          "rap": "18,000",
          "low_price": "19,460",
          "high_price": "42,160"
        },
        "2.4": {
          "rap": "18,000",
          "low_price": "20,305",
          "high_price": "43,990"
        },
        "2.5": {
          "rap": "18,000",
          "low_price": "21,150",
          "high_price": "45,825"
        },
        "2.6": {
          "rap": "18,000",
          "low_price": "21,995",
          "high_price": "47,660"
        },
        "2.7": {
          "rap": "18,000",
          "low_price": "22,840",
          "high_price": "49,490"
        },
        "2.8": {
          "rap": "18,000",
          "low_price": "23,690",
          "high_price": "51,325"
        },
        "2.9": {
          "rap": "18,000",
          "low_price": "24,535",
          "high_price": "53,155"
        },
        "3.0": {
          "rap": "27,000",
          "low_price": "42,300",
          "high_price": "91,650"
        },
        "3.1": {
          "rap": "27,000",
          "low_price": "43,710",
          "high_price": "94,705"
        },
        "3.2": {
          "rap": "27,000",
          "low_price": "45,120",
          "high_price": "97,760"
        },
        "3.3": {
          "rap": "27,000",
          "low_price": "46,530",
          "high_price": "100,815"
        },
        "3.4": {
          "rap": "27,000",
          "low_price": "47,940",
          "high_price": "103,870"
        },
        "3.5": {
          "rap": "27,000",
          "low_price": "49,350",
          "high_price": "106,925"
        },
        "3.6": {
          "rap": "27,000",
          "low_price": "50,760",
          "high_price": "109,980"
        },
        "3.7": {
          "rap": "27,000",
          "low_price": "52,170",
          "high_price": "113,035"
        },
        "3.8": {
          "rap": "27,000",
          "low_price": "53,580",
          "high_price": "116,090"
        },
        "3.9": {
          "rap": "27,000",
          "low_price": "54,990",
          "high_price": "119,145"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,200",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "4,300",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "0.8": {
          "rap": "4,300",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "0.9": {
          "rap": "6,200",
          "low_price": "1,945",
          "high_price": "4,210"
        },
        "1.0": {
          "rap": "8,000",
          "low_price": "2,880",
          "high_price": "6,240"
        },
        "1.1": {
          "rap": "8,000",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.2": {
          "rap": "8,000",
          "low_price": "3,455",
          "high_price": "7,490"
        },
        "1.3": {
          "rap": "8,000",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.4": {
          "rap": "8,000",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.5": {
          "rap": "12,000",
          "low_price": "7,740",
          "high_price": "16,770"
        },
        "1.6": {
          "rap": "12,000",
          "low_price": "8,255",
          "high_price": "17,890"
        },
        "1.7": {
          "rap": "12,000",
          "low_price": "8,770",
          "high_price": "19,005"
        },
        "1.8": {
          "rap": "12,000",
          "low_price": "9,290",
          "high_price": "20,125"
        },
        "1.9": {
          "rap": "12,000",
          "low_price": "9,805",
          "high_price": "21,240"
        },
        "2.0": {
          "rap": "17,000",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "2.1": {
          "rap": "17,000",
          "low_price": "16,630",
          "high_price": "36,035"
        },
        "2.2": {
          "rap": "17,000",
          "low_price": "17,425",
          "high_price": "37,750"
        },
        "2.3": {
          "rap": "17,000",
          "low_price": "18,215",
          "high_price": "39,470"
        },
        "2.4": {
          "rap": "17,000",
          "low_price": "19,010",
          "high_price": "41,185"
        },
        "2.5": {
          "rap": "17,000",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.6": {
          "rap": "17,000",
          "low_price": "20,590",
          "high_price": "44,615"
        },
        "2.7": {
          "rap": "17,000",
          "low_price": "21,385",
          "high_price": "46,330"
        },
        "2.8": {
          "rap": "17,000",
          "low_price": "22,175",
          "high_price": "48,050"
        },
        "2.9": {
          "rap": "17,000",
          "low_price": "22,970",
          "high_price": "49,765"
        },
        "3.0": {
          "rap": "24,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.1": {
          "rap": "24,500",
          "low_price": "39,060",
          "high_price": "84,630"
        },
        "3.2": {
          "rap": "24,500",
          "low_price": "40,320",
          "high_price": "87,360"
        },
        "3.3": {
          "rap": "24,500",
          "low_price": "41,580",
          "high_price": "90,090"
        },
        "3.4": {
          "rap": "24,500",
          "low_price": "42,840",
          "high_price": "92,820"
        },
        "3.5": {
          "rap": "24,500",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.6": {
          "rap": "24,500",
          "low_price": "45,360",
          "high_price": "98,280"
        },
        "3.7": {
          "rap": "24,500",
          "low_price": "46,620",
          "high_price": "101,010"
        },
        "3.8": {
          "rap": "24,500",
          "low_price": "47,880",
          "high_price": "103,740"
        },
        "3.9": {
          "rap": "24,500",
          "low_price": "49,140",
          "high_price": "106,470"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,100",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "3,100",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "3,100",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "4,000",
          "low_price": "1,050",
          "high_price": "2,275"
        },
        "0.8": {
          "rap": "4,000",
          "low_price": "1,200",
          "high_price": "2,600"
        },
        "0.9": {
          "rap": "5,800",
          "low_price": "1,835",
          "high_price": "3,980"
        },
        "1.0": {
          "rap": "7,500",
          "low_price": "2,700",
          "high_price": "5,850"
        },
        "1.1": {
          "rap": "7,500",
          "low_price": "2,970",
          "high_price": "6,435"
        },
        "1.2": {
          "rap": "7,500",
          "low_price": "3,240",
          "high_price": "7,020"
        },
        "1.3": {
          "rap": "7,500",
          "low_price": "3,510",
          "high_price": "7,605"
        },
        "1.4": {
          "rap": "7,500",
          "low_price": "3,780",
          "high_price": "8,190"
        },
        "1.5": {
          "rap": "11,300",
          "low_price": "7,290",
          "high_price": "15,795"
        },
        "1.6": {
          "rap": "11,300",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "1.7": {
          "rap": "11,300",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "1.8": {
          "rap": "11,300",
          "low_price": "8,750",
          "high_price": "18,955"
        },
        "1.9": {
          "rap": "11,300",
          "low_price": "9,235",
          "high_price": "20,005"
        },
        "2.0": {
          "rap": "15,800",
          "low_price": "14,760",
          "high_price": "31,980"
        },
        "2.1": {
          "rap": "15,800",
          "low_price": "15,500",
          "high_price": "33,580"
        },
        "2.2": {
          "rap": "15,800",
          "low_price": "16,235",
          "high_price": "35,180"
        },
        "2.3": {
          "rap": "15,800",
          "low_price": "16,975",
          "high_price": "36,775"
        },
        "2.4": {
          "rap": "15,800",
          "low_price": "17,710",
          "high_price": "38,375"
        },
        "2.5": {
          "rap": "15,800",
          "low_price": "18,450",
          "high_price": "39,975"
        },
        "2.6": {
          "rap": "15,800",
          "low_price": "19,190",
          "high_price": "41,575"
        },
        "2.7": {
          "rap": "15,800",
          "low_price": "19,925",
          "high_price": "43,175"
        },
        "2.8": {
          "rap": "15,800",
          "low_price": "20,665",
          "high_price": "44,770"
        },
        "2.9": {
          "rap": "15,800",
          "low_price": "21,400",
          "high_price": "46,370"
        },
        "3.0": {
          "rap": "22,500",
          "low_price": "35,100",
          "high_price": "76,050"
        },
        "3.1": {
          "rap": "22,500",
          "low_price": "36,270",
          "high_price": "78,585"
        },
        "3.2": {
          "rap": "22,500",
          "low_price": "37,440",
          "high_price": "81,120"
        },
        "3.3": {
          "rap": "22,500",
          "low_price": "38,610",
          "high_price": "83,655"
        },
        "3.4": {
          "rap": "22,500",
          "low_price": "39,780",
          "high_price": "86,190"
        },
        "3.5": {
          "rap": "22,500",
          "low_price": "40,950",
          "high_price": "88,725"
        },
        "3.6": {
          "rap": "22,500",
          "low_price": "42,120",
          "high_price": "91,260"
        },
        "3.7": {
          "rap": "22,500",
          "low_price": "43,290",
          "high_price": "93,795"
        },
        "3.8": {
          "rap": "22,500",
          "low_price": "44,460",
          "high_price": "96,330"
        },
        "3.9": {
          "rap": "22,500",
          "low_price": "45,630",
          "high_price": "98,865"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,000",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,800",
          "low_price": "965",
          "high_price": "2,095"
        },
        "0.8": {
          "rap": "3,800",
          "low_price": "1,105",
          "high_price": "2,390"
        },
        "0.9": {
          "rap": "5,400",
          "low_price": "1,675",
          "high_price": "3,625"
        },
        "1.0": {
          "rap": "7,000",
          "low_price": "2,460",
          "high_price": "5,330"
        },
        "1.1": {
          "rap": "7,000",
          "low_price": "2,705",
          "high_price": "5,865"
        },
        "1.2": {
          "rap": "7,000",
          "low_price": "2,950",
          "high_price": "6,395"
        },
        "1.3": {
          "rap": "7,000",
          "low_price": "3,200",
          "high_price": "6,930"
        },
        "1.4": {
          "rap": "7,000",
          "low_price": "3,445",
          "high_price": "7,460"
        },
        "1.5": {
          "rap": "10,600",
          "low_price": "6,750",
          "high_price": "14,625"
        },
        "1.6": {
          "rap": "10,600",
          "low_price": "7,200",
          "high_price": "15,600"
        },
        "1.7": {
          "rap": "10,600",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "1.8": {
          "rap": "10,600",
          "low_price": "8,100",
          "high_price": "17,550"
        },
        "1.9": {
          "rap": "10,600",
          "low_price": "8,550",
          "high_price": "18,525"
        },
        "2.0": {
          "rap": "14,600",
          "low_price": "13,440",
          "high_price": "29,120"
        },
        "2.1": {
          "rap": "14,600",
          "low_price": "14,110",
          "high_price": "30,575"
        },
        "2.2": {
          "rap": "14,600",
          "low_price": "14,785",
          "high_price": "32,030"
        },
        "2.3": {
          "rap": "14,600",
          "low_price": "15,455",
          "high_price": "33,490"
        },
        "2.4": {
          "rap": "14,600",
          "low_price": "16,130",
          "high_price": "34,945"
        },
        "2.5": {
          "rap": "14,600",
          "low_price": "16,800",
          "high_price": "36,400"
        },
        "2.6": {
          "rap": "14,600",
          "low_price": "17,470",
          "high_price": "37,855"
        },
        "2.7": {
          "rap": "14,600",
          "low_price": "18,145",
          "high_price": "39,310"
        },
        "2.8": {
          "rap": "14,600",
          "low_price": "18,815",
          "high_price": "40,770"
        },
        "2.9": {
          "rap": "14,600",
          "low_price": "19,490",
          "high_price": "42,225"
        },
        "3.0": {
          "rap": "20,500",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "3.1": {
          "rap": "20,500",
          "low_price": "33,480",
          "high_price": "72,540"
        },
        "3.2": {
          "rap": "20,500",
          "low_price": "34,560",
          "high_price": "74,880"
        },
        "3.3": {
          "rap": "20,500",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "3.4": {
          "rap": "20,500",
          "low_price": "36,720",
          "high_price": "79,560"
        },
        "3.5": {
          "rap": "20,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.6": {
          "rap": "20,500",
          "low_price": "38,880",
          "high_price": "84,240"
        },
        "3.7": {
          "rap": "20,500",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.8": {
          "rap": "20,500",
          "low_price": "41,040",
          "high_price": "88,920"
        },
        "3.9": {
          "rap": "20,500",
          "low_price": "42,120",
          "high_price": "91,260"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,900",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,800",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "2,800",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "3,500",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "3,500",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "5,000",
          "low_price": "1,565",
          "high_price": "3,395"
        },
        "1.0": {
          "rap": "6,500",
          "low_price": "2,280",
          "high_price": "4,940"
        },
        "1.1": {
          "rap": "6,500",
          "low_price": "2,510",
          "high_price": "5,435"
        },
        "1.2": {
          "rap": "6,500",
          "low_price": "2,735",
          "high_price": "5,930"
        },
        "1.3": {
          "rap": "6,500",
          "low_price": "2,965",
          "high_price": "6,420"
        },
        "1.4": {
          "rap": "6,500",
          "low_price": "3,190",
          "high_price": "6,915"
        },
        "1.5": {
          "rap": "10,000",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "1.6": {
          "rap": "10,000",
          "low_price": "6,335",
          "high_price": "13,730"
        },
        "1.7": {
          "rap": "10,000",
          "low_price": "6,730",
          "high_price": "14,585"
        },
        "1.8": {
          "rap": "10,000",
          "low_price": "7,130",
          "high_price": "15,445"
        },
        "1.9": {
          "rap": "10,000",
          "low_price": "7,525",
          "high_price": "16,300"
        },
        "2.0": {
          "rap": "13,500",
          "low_price": "12,480",
          "high_price": "27,040"
        },
        "2.1": {
          "rap": "13,500",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.2": {
          "rap": "13,500",
          "low_price": "13,730",
          "high_price": "29,745"
        },
        "2.3": {
          "rap": "13,500",
          "low_price": "14,350",
          "high_price": "31,095"
        },
        "2.4": {
          "rap": "13,500",
          "low_price": "14,975",
          "high_price": "32,450"
        },
        "2.5": {
          "rap": "13,500",
          "low_price": "15,600",
          "high_price": "33,800"
        },
        "2.6": {
          "rap": "13,500",
          "low_price": "16,225",
          "high_price": "35,150"
        },
        "2.7": {
          "rap": "13,500",
          "low_price": "16,850",
          "high_price": "36,505"
        },
        "2.8": {
          "rap": "13,500",
          "low_price": "17,470",
          "high_price": "37,855"
        },
        "2.9": {
          "rap": "13,500",
          "low_price": "18,095",
          "high_price": "39,210"
        },
        "3.0": {
          "rap": "18,500",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "3.1": {
          "rap": "18,500",
          "low_price": "29,760",
          "high_price": "64,480"
        },
        "3.2": {
          "rap": "18,500",
          "low_price": "30,720",
          "high_price": "66,560"
        },
        "3.3": {
          "rap": "18,500",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "3.4": {
          "rap": "18,500",
          "low_price": "32,640",
          "high_price": "70,720"
        },
        "3.5": {
          "rap": "18,500",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "3.6": {
          "rap": "18,500",
          "low_price": "34,560",
          "high_price": "74,880"
        },
        "3.7": {
          "rap": "18,500",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.8": {
          "rap": "18,500",
          "low_price": "36,480",
          "high_price": "79,040"
        },
        "3.9": {
          "rap": "18,500",
          "low_price": "37,440",
          "high_price": "81,120"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,800",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "2,400",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "2,400",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "4,600",
          "low_price": "1,405",
          "high_price": "3,040"
        },
        "1.0": {
          "rap": "5,800",
          "low_price": "2,040",
          "high_price": "4,420"
        },
        "1.1": {
          "rap": "5,800",
          "low_price": "2,245",
          "high_price": "4,860"
        },
        "1.2": {
          "rap": "5,800",
          "low_price": "2,450",
          "high_price": "5,305"
        },
        "1.3": {
          "rap": "5,800",
          "low_price": "2,650",
          "high_price": "5,745"
        },
        "1.4": {
          "rap": "5,800",
          "low_price": "2,855",
          "high_price": "6,190"
        },
        "1.5": {
          "rap": "8,700",
          "low_price": "5,040",
          "high_price": "10,920"
        },
        "1.6": {
          "rap": "8,700",
          "low_price": "5,375",
          "high_price": "11,650"
        },
        "1.7": {
          "rap": "8,700",
          "low_price": "5,710",
          "high_price": "12,375"
        },
        "1.8": {
          "rap": "8,700",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.9": {
          "rap": "8,700",
          "low_price": "6,385",
          "high_price": "13,830"
        },
        "2.0": {
          "rap": "11,700",
          "low_price": "10,320",
          "high_price": "22,360"
        },
        "2.1": {
          "rap": "11,700",
          "low_price": "10,835",
          "high_price": "23,480"
        },
        "2.2": {
          "rap": "11,700",
          "low_price": "11,350",
          "high_price": "24,595"
        },
        "2.3": {
          "rap": "11,700",
          "low_price": "11,870",
          "high_price": "25,715"
        },
        "2.4": {
          "rap": "11,700",
          "low_price": "12,385",
          "high_price": "26,830"
        },
        "2.5": {
          "rap": "11,700",
          "low_price": "12,900",
          "high_price": "27,950"
        },
        "2.6": {
          "rap": "11,700",
          "low_price": "13,415",
          "high_price": "29,070"
        },
        "2.7": {
          "rap": "11,700",
          "low_price": "13,930",
          "high_price": "30,185"
        },
        "2.8": {
          "rap": "11,700",
          "low_price": "14,450",
          "high_price": "31,305"
        },
        "2.9": {
          "rap": "11,700",
          "low_price": "14,965",
          "high_price": "32,420"
        },
        "3.0": {
          "rap": "16,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "3.1": {
          "rap": "16,500",
          "low_price": "26,040",
          "high_price": "56,420"
        },
        "3.2": {
          "rap": "16,500",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "3.3": {
          "rap": "16,500",
          "low_price": "27,720",
          "high_price": "60,060"
        },
        "3.4": {
          "rap": "16,500",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "3.5": {
          "rap": "16,500",
          "low_price": "29,400",
          "high_price": "63,700"
        },
        "3.6": {
          "rap": "16,500",
          "low_price": "30,240",
          "high_price": "65,520"
        },
        "3.7": {
          "rap": "16,500",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "3.8": {
          "rap": "16,500",
          "low_price": "31,920",
          "high_price": "69,160"
        },
        "3.9": {
          "rap": "16,500",
          "low_price": "32,760",
          "high_price": "70,980"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,600",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "2,000",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "2,000",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,600",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,600",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "4,100",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "4,900",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "1.1": {
          "rap": "4,900",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.2": {
          "rap": "4,900",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.3": {
          "rap": "4,900",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.4": {
          "rap": "4,900",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "1.5": {
          "rap": "7,300",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.6": {
          "rap": "7,300",
          "low_price": "4,610",
          "high_price": "9,985"
        },
        "1.7": {
          "rap": "7,300",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.8": {
          "rap": "7,300",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.9": {
          "rap": "7,300",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "2.0": {
          "rap": "9,900",
          "low_price": "8,280",
          "high_price": "17,940"
        },
        "2.1": {
          "rap": "9,900",
          "low_price": "8,695",
          "high_price": "18,835"
        },
        "2.2": {
          "rap": "9,900",
          "low_price": "9,110",
          "high_price": "19,735"
        },
        "2.3": {
          "rap": "9,900",
          "low_price": "9,520",
          "high_price": "20,630"
        },
        "2.4": {
          "rap": "9,900",
          "low_price": "9,935",
          "high_price": "21,530"
        },
        "2.5": {
          "rap": "9,900",
          "low_price": "10,350",
          "high_price": "22,425"
        },
        "2.6": {
          "rap": "9,900",
          "low_price": "10,765",
          "high_price": "23,320"
        },
        "2.7": {
          "rap": "9,900",
          "low_price": "11,180",
          "high_price": "24,220"
        },
        "2.8": {
          "rap": "9,900",
          "low_price": "11,590",
          "high_price": "25,115"
        },
        "2.9": {
          "rap": "9,900",
          "low_price": "12,005",
          "high_price": "26,015"
        },
        "3.0": {
          "rap": "13,500",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "3.1": {
          "rap": "13,500",
          "low_price": "22,320",
          "high_price": "48,360"
        },
        "3.2": {
          "rap": "13,500",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "3.3": {
          "rap": "13,500",
          "low_price": "23,760",
          "high_price": "51,480"
        },
        "3.4": {
          "rap": "13,500",
          "low_price": "24,480",
          "high_price": "53,040"
        },
        "3.5": {
          "rap": "13,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "3.6": {
          "rap": "13,500",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "3.7": {
          "rap": "13,500",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "3.8": {
          "rap": "13,500",
          "low_price": "27,360",
          "high_price": "59,280"
        },
        "3.9": {
          "rap": "13,500",
          "low_price": "28,080",
          "high_price": "60,840"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,400",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "2,200",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.8": {
          "rap": "2,200",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.9": {
          "rap": "3,400",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "4,100",
          "low_price": "1,500",
          "high_price": "3,250"
        },
        "1.1": {
          "rap": "4,100",
          "low_price": "1,650",
          "high_price": "3,575"
        },
        "1.2": {
          "rap": "4,100",
          "low_price": "1,800",
          "high_price": "3,900"
        },
        "1.3": {
          "rap": "4,100",
          "low_price": "1,950",
          "high_price": "4,225"
        },
        "1.4": {
          "rap": "4,100",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "1.5": {
          "rap": "6,200",
          "low_price": "3,600",
          "high_price": "7,800"
        },
        "1.6": {
          "rap": "6,200",
          "low_price": "3,840",
          "high_price": "8,320"
        },
        "1.7": {
          "rap": "6,200",
          "low_price": "4,080",
          "high_price": "8,840"
        },
        "1.8": {
          "rap": "6,200",
          "low_price": "4,320",
          "high_price": "9,360"
        },
        "1.9": {
          "rap": "6,200",
          "low_price": "4,560",
          "high_price": "9,880"
        },
        "2.0": {
          "rap": "8,100",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "2.1": {
          "rap": "8,100",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.2": {
          "rap": "8,100",
          "low_price": "7,525",
          "high_price": "16,300"
        },
        "2.3": {
          "rap": "8,100",
          "low_price": "7,865",
          "high_price": "17,045"
        },
        "2.4": {
          "rap": "8,100",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "2.5": {
          "rap": "8,100",
          "low_price": "8,550",
          "high_price": "18,525"
        },
        "2.6": {
          "rap": "8,100",
          "low_price": "8,890",
          "high_price": "19,265"
        },
        "2.7": {
          "rap": "8,100",
          "low_price": "9,235",
          "high_price": "20,005"
        },
        "2.8": {
          "rap": "8,100",
          "low_price": "9,575",
          "high_price": "20,750"
        },
        "2.9": {
          "rap": "8,100",
          "low_price": "9,920",
          "high_price": "21,490"
        },
        "3.0": {
          "rap": "11,000",
          "low_price": "18,540",
          "high_price": "40,170"
        },
        "3.1": {
          "rap": "11,000",
          "low_price": "19,160",
          "high_price": "41,510"
        },
        "3.2": {
          "rap": "11,000",
          "low_price": "19,775",
          "high_price": "42,850"
        },
        "3.3": {
          "rap": "11,000",
          "low_price": "20,395",
          "high_price": "44,185"
        },
        "3.4": {
          "rap": "11,000",
          "low_price": "21,010",
          "high_price": "45,525"
        },
        "3.5": {
          "rap": "11,000",
          "low_price": "21,630",
          "high_price": "46,865"
        },
        "3.6": {
          "rap": "11,000",
          "low_price": "22,250",
          "high_price": "48,205"
        },
        "3.7": {
          "rap": "11,000",
          "low_price": "22,865",
          "high_price": "49,545"
        },
        "3.8": {
          "rap": "11,000",
          "low_price": "23,485",
          "high_price": "50,880"
        },
        "3.9": {
          "rap": "11,000",
          "low_price": "24,100",
          "high_price": "52,220"
        }
      }
    },
    "SI2": {
      "D": {
        "0.4": {
          "rap": "2,000",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "2,700",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "2,700",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,700",
          "low_price": "1,050",
          "high_price": "2,275"
        },
        "0.8": {
          "rap": "3,700",
          "low_price": "1,200",
          "high_price": "2,600"
        },
        "0.9": {
          "rap": "5,400",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "1.0": {
          "rap": "7,000",
          "low_price": "2,460",
          "high_price": "5,330"
        },
        "1.1": {
          "rap": "7,000",
          "low_price": "2,705",
          "high_price": "5,865"
        },
        "1.2": {
          "rap": "7,000",
          "low_price": "2,950",
          "high_price": "6,395"
        },
        "1.3": {
          "rap": "7,000",
          "low_price": "3,200",
          "high_price": "6,930"
        },
        "1.4": {
          "rap": "7,000",
          "low_price": "3,445",
          "high_price": "7,460"
        },
        "1.5": {
          "rap": "10,700",
          "low_price": "6,750",
          "high_price": "14,625"
        },
        "1.6": {
          "rap": "10,700",
          "low_price": "7,200",
          "high_price": "15,600"
        },
        "1.7": {
          "rap": "10,700",
          "low_price": "7,650",
          "high_price": "16,575"
        },
        "1.8": {
          "rap": "10,700",
          "low_price": "8,100",
          "high_price": "17,550"
        },
        "1.9": {
          "rap": "10,700",
          "low_price": "8,550",
          "high_price": "18,525"
        },
        "2.0": {
          "rap": "14,700",
          "low_price": "13,560",
          "high_price": "29,380"
        },
        "2.1": {
          "rap": "14,700",
          "low_price": "14,240",
          "high_price": "30,850"
        },
        "2.2": {
          "rap": "14,700",
          "low_price": "14,915",
          "high_price": "32,320"
        },
        "2.3": {
          "rap": "14,700",
          "low_price": "15,595",
          "high_price": "33,785"
        },
        "2.4": {
          "rap": "14,700",
          "low_price": "16,270",
          "high_price": "35,255"
        },
        "2.5": {
          "rap": "14,700",
          "low_price": "16,950",
          "high_price": "36,725"
        },
        "2.6": {
          "rap": "14,700",
          "low_price": "17,630",
          "high_price": "38,195"
        },
        "2.7": {
          "rap": "14,700",
          "low_price": "18,305",
          "high_price": "39,665"
        },
        "2.8": {
          "rap": "14,700",
          "low_price": "18,985",
          "high_price": "41,130"
        },
        "2.9": {
          "rap": "14,700",
          "low_price": "19,660",
          "high_price": "42,600"
        },
        "3.0": {
          "rap": "22,000",
          "low_price": "36,000",
          "high_price": "78,000"
        },
        "3.1": {
          "rap": "22,000",
          "low_price": "37,200",
          "high_price": "80,600"
        },
        "3.2": {
          "rap": "22,000",
          "low_price": "38,400",
          "high_price": "83,200"
        },
        "3.3": {
          "rap": "22,000",
          "low_price": "39,600",
          "high_price": "85,800"
        },
        "3.4": {
          "rap": "22,000",
          "low_price": "40,800",
          "high_price": "88,400"
        },
        "3.5": {
          "rap": "22,000",
          "low_price": "42,000",
          "high_price": "91,000"
        },
        "3.6": {
          "rap": "22,000",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.7": {
          "rap": "22,000",
          "low_price": "44,400",
          "high_price": "96,200"
        },
        "3.8": {
          "rap": "22,000",
          "low_price": "45,600",
          "high_price": "98,800"
        },
        "3.9": {
          "rap": "22,000",
          "low_price": "46,800",
          "high_price": "101,400"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,900",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "2,600",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "2,600",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "3,500",
          "low_price": "965",
          "high_price": "2,095"
        },
        "0.8": {
          "rap": "3,500",
          "low_price": "1,105",
          "high_price": "2,390"
        },
        "0.9": {
          "rap": "5,000",
          "low_price": "1,565",
          "high_price": "3,395"
        },
        "1.0": {
          "rap": "6,600",
          "low_price": "2,280",
          "high_price": "4,940"
        },
        "1.1": {
          "rap": "6,600",
          "low_price": "2,510",
          "high_price": "5,435"
        },
        "1.2": {
          "rap": "6,600",
          "low_price": "2,735",
          "high_price": "5,930"
        },
        "1.3": {
          "rap": "6,600",
          "low_price": "2,965",
          "high_price": "6,420"
        },
        "1.4": {
          "rap": "6,600",
          "low_price": "3,190",
          "high_price": "6,915"
        },
        "1.5": {
          "rap": "10,000",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "1.6": {
          "rap": "10,000",
          "low_price": "6,530",
          "high_price": "14,145"
        },
        "1.7": {
          "rap": "10,000",
          "low_price": "6,935",
          "high_price": "15,030"
        },
        "1.8": {
          "rap": "10,000",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "1.9": {
          "rap": "10,000",
          "low_price": "7,750",
          "high_price": "16,795"
        },
        "2.0": {
          "rap": "13,700",
          "low_price": "12,600",
          "high_price": "27,300"
        },
        "2.1": {
          "rap": "13,700",
          "low_price": "13,230",
          "high_price": "28,665"
        },
        "2.2": {
          "rap": "13,700",
          "low_price": "13,860",
          "high_price": "30,030"
        },
        "2.3": {
          "rap": "13,700",
          "low_price": "14,490",
          "high_price": "31,395"
        },
        "2.4": {
          "rap": "13,700",
          "low_price": "15,120",
          "high_price": "32,760"
        },
        "2.5": {
          "rap": "13,700",
          "low_price": "15,750",
          "high_price": "34,125"
        },
        "2.6": {
          "rap": "13,700",
          "low_price": "16,380",
          "high_price": "35,490"
        },
        "2.7": {
          "rap": "13,700",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "2.8": {
          "rap": "13,700",
          "low_price": "17,640",
          "high_price": "38,220"
        },
        "2.9": {
          "rap": "13,700",
          "low_price": "18,270",
          "high_price": "39,585"
        },
        "3.0": {
          "rap": "20,500",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.1": {
          "rap": "20,500",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.2": {
          "rap": "20,500",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.3": {
          "rap": "20,500",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.4": {
          "rap": "20,500",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.5": {
          "rap": "20,500",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.6": {
          "rap": "20,500",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.7": {
          "rap": "20,500",
          "low_price": "41,070",
          "high_price": "88,985"
        },
        "3.8": {
          "rap": "20,500",
          "low_price": "42,180",
          "high_price": "91,390"
        },
        "3.9": {
          "rap": "20,500",
          "low_price": "43,290",
          "high_price": "93,795"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,800",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,500",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "2,500",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "3,300",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "3,300",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "4,700",
          "low_price": "1,405",
          "high_price": "3,040"
        },
        "1.0": {
          "rap": "6,200",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "1.1": {
          "rap": "6,200",
          "low_price": "2,310",
          "high_price": "5,005"
        },
        "1.2": {
          "rap": "6,200",
          "low_price": "2,520",
          "high_price": "5,460"
        },
        "1.3": {
          "rap": "6,200",
          "low_price": "2,730",
          "high_price": "5,915"
        },
        "1.4": {
          "rap": "6,200",
          "low_price": "2,940",
          "high_price": "6,370"
        },
        "1.5": {
          "rap": "9,300",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "1.6": {
          "rap": "9,300",
          "low_price": "6,145",
          "high_price": "13,310"
        },
        "1.7": {
          "rap": "9,300",
          "low_price": "6,530",
          "high_price": "14,145"
        },
        "1.8": {
          "rap": "9,300",
          "low_price": "6,910",
          "high_price": "14,975"
        },
        "1.9": {
          "rap": "9,300",
          "low_price": "7,295",
          "high_price": "15,810"
        },
        "2.0": {
          "rap": "12,800",
          "low_price": "11,760",
          "high_price": "25,480"
        },
        "2.1": {
          "rap": "12,800",
          "low_price": "12,350",
          "high_price": "26,755"
        },
        "2.2": {
          "rap": "12,800",
          "low_price": "12,935",
          "high_price": "28,030"
        },
        "2.3": {
          "rap": "12,800",
          "low_price": "13,525",
          "high_price": "29,300"
        },
        "2.4": {
          "rap": "12,800",
          "low_price": "14,110",
          "high_price": "30,575"
        },
        "2.5": {
          "rap": "12,800",
          "low_price": "14,700",
          "high_price": "31,850"
        },
        "2.6": {
          "rap": "12,800",
          "low_price": "15,290",
          "high_price": "33,125"
        },
        "2.7": {
          "rap": "12,800",
          "low_price": "15,875",
          "high_price": "34,400"
        },
        "2.8": {
          "rap": "12,800",
          "low_price": "16,465",
          "high_price": "35,670"
        },
        "2.9": {
          "rap": "12,800",
          "low_price": "17,050",
          "high_price": "36,945"
        },
        "3.0": {
          "rap": "19,000",
          "low_price": "30,600",
          "high_price": "66,300"
        },
        "3.1": {
          "rap": "19,000",
          "low_price": "31,620",
          "high_price": "68,510"
        },
        "3.2": {
          "rap": "19,000",
          "low_price": "32,640",
          "high_price": "70,720"
        },
        "3.3": {
          "rap": "19,000",
          "low_price": "33,660",
          "high_price": "72,930"
        },
        "3.4": {
          "rap": "19,000",
          "low_price": "34,680",
          "high_price": "75,140"
        },
        "3.5": {
          "rap": "19,000",
          "low_price": "35,700",
          "high_price": "77,350"
        },
        "3.6": {
          "rap": "19,000",
          "low_price": "36,720",
          "high_price": "79,560"
        },
        "3.7": {
          "rap": "19,000",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.8": {
          "rap": "19,000",
          "low_price": "38,760",
          "high_price": "83,980"
        },
        "3.9": {
          "rap": "19,000",
          "low_price": "39,780",
          "high_price": "86,190"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,700",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "2,400",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "2,400",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "3,100",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "3,100",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "4,400",
          "low_price": "1,350",
          "high_price": "2,925"
        },
        "1.0": {
          "rap": "5,800",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.1": {
          "rap": "5,800",
          "low_price": "2,180",
          "high_price": "4,720"
        },
        "1.2": {
          "rap": "5,800",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.3": {
          "rap": "5,800",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.4": {
          "rap": "5,800",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.5": {
          "rap": "8,700",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "1.6": {
          "rap": "8,700",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "1.7": {
          "rap": "8,700",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "1.8": {
          "rap": "8,700",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "1.9": {
          "rap": "8,700",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "2.0": {
          "rap": "12,000",
          "low_price": "11,040",
          "high_price": "23,920"
        },
        "2.1": {
          "rap": "12,000",
          "low_price": "11,590",
          "high_price": "25,115"
        },
        "2.2": {
          "rap": "12,000",
          "low_price": "12,145",
          "high_price": "26,310"
        },
        "2.3": {
          "rap": "12,000",
          "low_price": "12,695",
          "high_price": "27,510"
        },
        "2.4": {
          "rap": "12,000",
          "low_price": "13,250",
          "high_price": "28,705"
        },
        "2.5": {
          "rap": "12,000",
          "low_price": "13,800",
          "high_price": "29,900"
        },
        "2.6": {
          "rap": "12,000",
          "low_price": "14,350",
          "high_price": "31,095"
        },
        "2.7": {
          "rap": "12,000",
          "low_price": "14,905",
          "high_price": "32,290"
        },
        "2.8": {
          "rap": "12,000",
          "low_price": "15,455",
          "high_price": "33,490"
        },
        "2.9": {
          "rap": "12,000",
          "low_price": "16,010",
          "high_price": "34,685"
        },
        "3.0": {
          "rap": "17,000",
          "low_price": "27,900",
          "high_price": "60,450"
        },
        "3.1": {
          "rap": "17,000",
          "low_price": "28,830",
          "high_price": "62,465"
        },
        "3.2": {
          "rap": "17,000",
          "low_price": "29,760",
          "high_price": "64,480"
        },
        "3.3": {
          "rap": "17,000",
          "low_price": "30,690",
          "high_price": "66,495"
        },
        "3.4": {
          "rap": "17,000",
          "low_price": "31,620",
          "high_price": "68,510"
        },
        "3.5": {
          "rap": "17,000",
          "low_price": "32,550",
          "high_price": "70,525"
        },
        "3.6": {
          "rap": "17,000",
          "low_price": "33,480",
          "high_price": "72,540"
        },
        "3.7": {
          "rap": "17,000",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.8": {
          "rap": "17,000",
          "low_price": "35,340",
          "high_price": "76,570"
        },
        "3.9": {
          "rap": "17,000",
          "low_price": "36,270",
          "high_price": "78,585"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,600",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "2,300",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "2,300",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,900",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,900",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "4,100",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "1.0": {
          "rap": "5,400",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "5,400",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "5,400",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "5,400",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "5,400",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "8,200",
          "low_price": "4,950",
          "high_price": "10,725"
        },
        "1.6": {
          "rap": "8,200",
          "low_price": "5,280",
          "high_price": "11,440"
        },
        "1.7": {
          "rap": "8,200",
          "low_price": "5,610",
          "high_price": "12,155"
        },
        "1.8": {
          "rap": "8,200",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "1.9": {
          "rap": "8,200",
          "low_price": "6,270",
          "high_price": "13,585"
        },
        "2.0": {
          "rap": "11,300",
          "low_price": "10,320",
          "high_price": "22,360"
        },
        "2.1": {
          "rap": "11,300",
          "low_price": "10,835",
          "high_price": "23,480"
        },
        "2.2": {
          "rap": "11,300",
          "low_price": "11,350",
          "high_price": "24,595"
        },
        "2.3": {
          "rap": "11,300",
          "low_price": "11,870",
          "high_price": "25,715"
        },
        "2.4": {
          "rap": "11,300",
          "low_price": "12,385",
          "high_price": "26,830"
        },
        "2.5": {
          "rap": "11,300",
          "low_price": "12,900",
          "high_price": "27,950"
        },
        "2.6": {
          "rap": "11,300",
          "low_price": "13,415",
          "high_price": "29,070"
        },
        "2.7": {
          "rap": "11,300",
          "low_price": "13,930",
          "high_price": "30,185"
        },
        "2.8": {
          "rap": "11,300",
          "low_price": "14,450",
          "high_price": "31,305"
        },
        "2.9": {
          "rap": "11,300",
          "low_price": "14,965",
          "high_price": "32,420"
        },
        "3.0": {
          "rap": "15,200",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "3.1": {
          "rap": "15,200",
          "low_price": "25,110",
          "high_price": "54,405"
        },
        "3.2": {
          "rap": "15,200",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "3.3": {
          "rap": "15,200",
          "low_price": "26,730",
          "high_price": "57,915"
        },
        "3.4": {
          "rap": "15,200",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "3.5": {
          "rap": "15,200",
          "low_price": "28,350",
          "high_price": "61,425"
        },
        "3.6": {
          "rap": "15,200",
          "low_price": "29,160",
          "high_price": "63,180"
        },
        "3.7": {
          "rap": "15,200",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "3.8": {
          "rap": "15,200",
          "low_price": "30,780",
          "high_price": "66,690"
        },
        "3.9": {
          "rap": "15,200",
          "low_price": "31,590",
          "high_price": "68,445"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,500",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,600",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,600",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "3,800",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "1.0": {
          "rap": "5,000",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "5,000",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "5,000",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "5,000",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "5,000",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "7,700",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.6": {
          "rap": "7,700",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.7": {
          "rap": "7,700",
          "low_price": "5,200",
          "high_price": "11,270"
        },
        "1.8": {
          "rap": "7,700",
          "low_price": "5,510",
          "high_price": "11,935"
        },
        "1.9": {
          "rap": "7,700",
          "low_price": "5,815",
          "high_price": "12,595"
        },
        "2.0": {
          "rap": "10,600",
          "low_price": "9,360",
          "high_price": "20,280"
        },
        "2.1": {
          "rap": "10,600",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "2.2": {
          "rap": "10,600",
          "low_price": "10,295",
          "high_price": "22,310"
        },
        "2.3": {
          "rap": "10,600",
          "low_price": "10,765",
          "high_price": "23,320"
        },
        "2.4": {
          "rap": "10,600",
          "low_price": "11,230",
          "high_price": "24,335"
        },
        "2.5": {
          "rap": "10,600",
          "low_price": "11,700",
          "high_price": "25,350"
        },
        "2.6": {
          "rap": "10,600",
          "low_price": "12,170",
          "high_price": "26,365"
        },
        "2.7": {
          "rap": "10,600",
          "low_price": "12,635",
          "high_price": "27,380"
        },
        "2.8": {
          "rap": "10,600",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.9": {
          "rap": "10,600",
          "low_price": "13,570",
          "high_price": "29,405"
        },
        "3.0": {
          "rap": "13,800",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "3.1": {
          "rap": "13,800",
          "low_price": "22,320",
          "high_price": "48,360"
        },
        "3.2": {
          "rap": "13,800",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "3.3": {
          "rap": "13,800",
          "low_price": "23,760",
          "high_price": "51,480"
        },
        "3.4": {
          "rap": "13,800",
          "low_price": "24,480",
          "high_price": "53,040"
        },
        "3.5": {
          "rap": "13,800",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "3.6": {
          "rap": "13,800",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "3.7": {
          "rap": "13,800",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "3.8": {
          "rap": "13,800",
          "low_price": "27,360",
          "high_price": "59,280"
        },
        "3.9": {
          "rap": "13,800",
          "low_price": "28,080",
          "high_price": "60,840"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,400",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,800",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,800",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "2,300",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.8": {
          "rap": "2,300",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.9": {
          "rap": "3,400",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "4,500",
          "low_price": "1,500",
          "high_price": "3,250"
        },
        "1.1": {
          "rap": "4,500",
          "low_price": "1,650",
          "high_price": "3,575"
        },
        "1.2": {
          "rap": "4,500",
          "low_price": "1,800",
          "high_price": "3,900"
        },
        "1.3": {
          "rap": "4,500",
          "low_price": "1,950",
          "high_price": "4,225"
        },
        "1.4": {
          "rap": "4,500",
          "low_price": "2,100",
          "high_price": "4,550"
        },
        "1.5": {
          "rap": "6,800",
          "low_price": "3,870",
          "high_price": "8,385"
        },
        "1.6": {
          "rap": "6,800",
          "low_price": "4,130",
          "high_price": "8,945"
        },
        "1.7": {
          "rap": "6,800",
          "low_price": "4,385",
          "high_price": "9,505"
        },
        "1.8": {
          "rap": "6,800",
          "low_price": "4,645",
          "high_price": "10,060"
        },
        "1.9": {
          "rap": "6,800",
          "low_price": "4,900",
          "high_price": "10,620"
        },
        "2.0": {
          "rap": "9,200",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.1": {
          "rap": "9,200",
          "low_price": "7,940",
          "high_price": "17,200"
        },
        "2.2": {
          "rap": "9,200",
          "low_price": "8,315",
          "high_price": "18,020"
        },
        "2.3": {
          "rap": "9,200",
          "low_price": "8,695",
          "high_price": "18,835"
        },
        "2.4": {
          "rap": "9,200",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "2.5": {
          "rap": "9,200",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "2.6": {
          "rap": "9,200",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "2.7": {
          "rap": "9,200",
          "low_price": "10,205",
          "high_price": "22,115"
        },
        "2.8": {
          "rap": "9,200",
          "low_price": "10,585",
          "high_price": "22,930"
        },
        "2.9": {
          "rap": "9,200",
          "low_price": "10,960",
          "high_price": "23,750"
        },
        "3.0": {
          "rap": "12,200",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "3.1": {
          "rap": "12,200",
          "low_price": "20,460",
          "high_price": "44,330"
        },
        "3.2": {
          "rap": "12,200",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "3.3": {
          "rap": "12,200",
          "low_price": "21,780",
          "high_price": "47,190"
        },
        "3.4": {
          "rap": "12,200",
          "low_price": "22,440",
          "high_price": "48,620"
        },
        "3.5": {
          "rap": "12,200",
          "low_price": "23,100",
          "high_price": "50,050"
        },
        "3.6": {
          "rap": "12,200",
          "low_price": "23,760",
          "high_price": "51,480"
        },
        "3.7": {
          "rap": "12,200",
          "low_price": "24,420",
          "high_price": "52,910"
        },
        "3.8": {
          "rap": "12,200",
          "low_price": "25,080",
          "high_price": "54,340"
        },
        "3.9": {
          "rap": "12,200",
          "low_price": "25,740",
          "high_price": "55,770"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,200",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,600",
          "low_price": "330",
          "high_price": "715"
        },
        "0.6": {
          "rap": "1,600",
          "low_price": "395",
          "high_price": "860"
        },
        "0.7": {
          "rap": "2,000",
          "low_price": "590",
          "high_price": "1,275"
        },
        "0.8": {
          "rap": "2,000",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.9": {
          "rap": "2,900",
          "low_price": "1,025",
          "high_price": "2,225"
        },
        "1.0": {
          "rap": "3,800",
          "low_price": "1,380",
          "high_price": "2,990"
        },
        "1.1": {
          "rap": "3,800",
          "low_price": "1,520",
          "high_price": "3,290"
        },
        "1.2": {
          "rap": "3,800",
          "low_price": "1,655",
          "high_price": "3,590"
        },
        "1.3": {
          "rap": "3,800",
          "low_price": "1,795",
          "high_price": "3,885"
        },
        "1.4": {
          "rap": "3,800",
          "low_price": "1,930",
          "high_price": "4,185"
        },
        "1.5": {
          "rap": "5,700",
          "low_price": "3,330",
          "high_price": "7,215"
        },
        "1.6": {
          "rap": "5,700",
          "low_price": "3,550",
          "high_price": "7,695"
        },
        "1.7": {
          "rap": "5,700",
          "low_price": "3,775",
          "high_price": "8,175"
        },
        "1.8": {
          "rap": "5,700",
          "low_price": "3,995",
          "high_price": "8,660"
        },
        "1.9": {
          "rap": "5,700",
          "low_price": "4,220",
          "high_price": "9,140"
        },
        "2.0": {
          "rap": "7,500",
          "low_price": "6,360",
          "high_price": "13,780"
        },
        "2.1": {
          "rap": "7,500",
          "low_price": "6,680",
          "high_price": "14,470"
        },
        "2.2": {
          "rap": "7,500",
          "low_price": "6,995",
          "high_price": "15,160"
        },
        "2.3": {
          "rap": "7,500",
          "low_price": "7,315",
          "high_price": "15,845"
        },
        "2.4": {
          "rap": "7,500",
          "low_price": "7,630",
          "high_price": "16,535"
        },
        "2.5": {
          "rap": "7,500",
          "low_price": "7,950",
          "high_price": "17,225"
        },
        "2.6": {
          "rap": "7,500",
          "low_price": "8,270",
          "high_price": "17,915"
        },
        "2.7": {
          "rap": "7,500",
          "low_price": "8,585",
          "high_price": "18,605"
        },
        "2.8": {
          "rap": "7,500",
          "low_price": "8,905",
          "high_price": "19,290"
        },
        "2.9": {
          "rap": "7,500",
          "low_price": "9,220",
          "high_price": "19,980"
        },
        "3.0": {
          "rap": "10,000",
          "low_price": "17,460",
          "high_price": "37,830"
        },
        "3.1": {
          "rap": "10,000",
          "low_price": "18,040",
          "high_price": "39,090"
        },
        "3.2": {
          "rap": "10,000",
          "low_price": "18,625",
          "high_price": "40,350"
        },
        "3.3": {
          "rap": "10,000",
          "low_price": "19,205",
          "high_price": "41,615"
        },
        "3.4": {
          "rap": "10,000",
          "low_price": "19,790",
          "high_price": "42,875"
        },
        "3.5": {
          "rap": "10,000",
          "low_price": "20,370",
          "high_price": "44,135"
        },
        "3.6": {
          "rap": "10,000",
          "low_price": "20,950",
          "high_price": "45,395"
        },
        "3.7": {
          "rap": "10,000",
          "low_price": "21,535",
          "high_price": "46,655"
        },
        "3.8": {
          "rap": "10,000",
          "low_price": "22,115",
          "high_price": "47,920"
        },
        "3.9": {
          "rap": "10,000",
          "low_price": "22,700",
          "high_price": "49,180"
        }
      }
    },
    "SI3": {
      "D": {
        "0.4": {
          "rap": "1,900",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "2,500",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "2,500",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "3,300",
          "low_price": "965",
          "high_price": "2,095"
        },
        "0.8": {
          "rap": "3,300",
          "low_price": "1,105",
          "high_price": "2,390"
        },
        "0.9": {
          "rap": "4,700",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "1.0": {
          "rap": "6,000",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.1": {
          "rap": "6,000",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.2": {
          "rap": "6,000",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.3": {
          "rap": "6,000",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.4": {
          "rap": "6,000",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.5": {
          "rap": "9,000",
          "low_price": "5,940",
          "high_price": "12,870"
        },
        "1.6": {
          "rap": "9,000",
          "low_price": "6,335",
          "high_price": "13,730"
        },
        "1.7": {
          "rap": "9,000",
          "low_price": "6,730",
          "high_price": "14,585"
        },
        "1.8": {
          "rap": "9,000",
          "low_price": "7,130",
          "high_price": "15,445"
        },
        "1.9": {
          "rap": "9,000",
          "low_price": "7,525",
          "high_price": "16,300"
        },
        "2.0": {
          "rap": "11,400",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "2.1": {
          "rap": "11,400",
          "low_price": "11,970",
          "high_price": "25,935"
        },
        "2.2": {
          "rap": "11,400",
          "low_price": "12,540",
          "high_price": "27,170"
        },
        "2.3": {
          "rap": "11,400",
          "low_price": "13,110",
          "high_price": "28,405"
        },
        "2.4": {
          "rap": "11,400",
          "low_price": "13,680",
          "high_price": "29,640"
        },
        "2.5": {
          "rap": "11,400",
          "low_price": "14,250",
          "high_price": "30,875"
        },
        "2.6": {
          "rap": "11,400",
          "low_price": "14,820",
          "high_price": "32,110"
        },
        "2.7": {
          "rap": "11,400",
          "low_price": "15,390",
          "high_price": "33,345"
        },
        "2.8": {
          "rap": "11,400",
          "low_price": "15,960",
          "high_price": "34,580"
        },
        "2.9": {
          "rap": "11,400",
          "low_price": "16,530",
          "high_price": "35,815"
        },
        "3.0": {
          "rap": "14,500",
          "low_price": "25,020",
          "high_price": "54,210"
        },
        "3.1": {
          "rap": "14,500",
          "low_price": "25,855",
          "high_price": "56,015"
        },
        "3.2": {
          "rap": "14,500",
          "low_price": "26,690",
          "high_price": "57,825"
        },
        "3.3": {
          "rap": "14,500",
          "low_price": "27,520",
          "high_price": "59,630"
        },
        "3.4": {
          "rap": "14,500",
          "low_price": "28,355",
          "high_price": "61,440"
        },
        "3.5": {
          "rap": "14,500",
          "low_price": "29,190",
          "high_price": "63,245"
        },
        "3.6": {
          "rap": "14,500",
          "low_price": "30,025",
          "high_price": "65,050"
        },
        "3.7": {
          "rap": "14,500",
          "low_price": "30,860",
          "high_price": "66,860"
        },
        "3.8": {
          "rap": "14,500",
          "low_price": "31,690",
          "high_price": "68,665"
        },
        "3.9": {
          "rap": "14,500",
          "low_price": "32,525",
          "high_price": "70,475"
        }
      },
      "E": {
        "0.4": {
          "rap": "1,800",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,400",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "2,400",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "3,100",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "3,100",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "4,400",
          "low_price": "1,405",
          "high_price": "3,040"
        },
        "1.0": {
          "rap": "5,600",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.1": {
          "rap": "5,600",
          "low_price": "2,180",
          "high_price": "4,720"
        },
        "1.2": {
          "rap": "5,600",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.3": {
          "rap": "5,600",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.4": {
          "rap": "5,600",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.5": {
          "rap": "8,400",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "1.6": {
          "rap": "8,400",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "1.7": {
          "rap": "8,400",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "1.8": {
          "rap": "8,400",
          "low_price": "6,480",
          "high_price": "14,040"
        },
        "1.9": {
          "rap": "8,400",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "2.0": {
          "rap": "10,700",
          "low_price": "10,560",
          "high_price": "22,880"
        },
        "2.1": {
          "rap": "10,700",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.2": {
          "rap": "10,700",
          "low_price": "11,615",
          "high_price": "25,170"
        },
        "2.3": {
          "rap": "10,700",
          "low_price": "12,145",
          "high_price": "26,310"
        },
        "2.4": {
          "rap": "10,700",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "2.5": {
          "rap": "10,700",
          "low_price": "13,200",
          "high_price": "28,600"
        },
        "2.6": {
          "rap": "10,700",
          "low_price": "13,730",
          "high_price": "29,745"
        },
        "2.7": {
          "rap": "10,700",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.8": {
          "rap": "10,700",
          "low_price": "14,785",
          "high_price": "32,030"
        },
        "2.9": {
          "rap": "10,700",
          "low_price": "15,310",
          "high_price": "33,175"
        },
        "3.0": {
          "rap": "13,600",
          "low_price": "23,580",
          "high_price": "51,090"
        },
        "3.1": {
          "rap": "13,600",
          "low_price": "24,365",
          "high_price": "52,795"
        },
        "3.2": {
          "rap": "13,600",
          "low_price": "25,150",
          "high_price": "54,495"
        },
        "3.3": {
          "rap": "13,600",
          "low_price": "25,940",
          "high_price": "56,200"
        },
        "3.4": {
          "rap": "13,600",
          "low_price": "26,725",
          "high_price": "57,900"
        },
        "3.5": {
          "rap": "13,600",
          "low_price": "27,510",
          "high_price": "59,605"
        },
        "3.6": {
          "rap": "13,600",
          "low_price": "28,295",
          "high_price": "61,310"
        },
        "3.7": {
          "rap": "13,600",
          "low_price": "29,080",
          "high_price": "63,010"
        },
        "3.8": {
          "rap": "13,600",
          "low_price": "29,870",
          "high_price": "64,715"
        },
        "3.9": {
          "rap": "13,600",
          "low_price": "30,655",
          "high_price": "66,415"
        }
      },
      "F": {
        "0.4": {
          "rap": "1,700",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "2,300",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "2,300",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,900",
          "low_price": "800",
          "high_price": "1,730"
        },
        "0.8": {
          "rap": "2,900",
          "low_price": "910",
          "high_price": "1,975"
        },
        "0.9": {
          "rap": "4,200",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "1.0": {
          "rap": "5,300",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "5,300",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "5,300",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "5,300",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "5,300",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "8,000",
          "low_price": "5,130",
          "high_price": "11,115"
        },
        "1.6": {
          "rap": "8,000",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "1.7": {
          "rap": "8,000",
          "low_price": "5,815",
          "high_price": "12,595"
        },
        "1.8": {
          "rap": "8,000",
          "low_price": "6,155",
          "high_price": "13,340"
        },
        "1.9": {
          "rap": "8,000",
          "low_price": "6,500",
          "high_price": "14,080"
        },
        "2.0": {
          "rap": "10,100",
          "low_price": "9,960",
          "high_price": "21,580"
        },
        "2.1": {
          "rap": "10,100",
          "low_price": "10,460",
          "high_price": "22,660"
        },
        "2.2": {
          "rap": "10,100",
          "low_price": "10,955",
          "high_price": "23,740"
        },
        "2.3": {
          "rap": "10,100",
          "low_price": "11,455",
          "high_price": "24,815"
        },
        "2.4": {
          "rap": "10,100",
          "low_price": "11,950",
          "high_price": "25,895"
        },
        "2.5": {
          "rap": "10,100",
          "low_price": "12,450",
          "high_price": "26,975"
        },
        "2.6": {
          "rap": "10,100",
          "low_price": "12,950",
          "high_price": "28,055"
        },
        "2.7": {
          "rap": "10,100",
          "low_price": "13,445",
          "high_price": "29,135"
        },
        "2.8": {
          "rap": "10,100",
          "low_price": "13,945",
          "high_price": "30,210"
        },
        "2.9": {
          "rap": "10,100",
          "low_price": "14,440",
          "high_price": "31,290"
        },
        "3.0": {
          "rap": "12,900",
          "low_price": "22,320",
          "high_price": "48,360"
        },
        "3.1": {
          "rap": "12,900",
          "low_price": "23,065",
          "high_price": "49,970"
        },
        "3.2": {
          "rap": "12,900",
          "low_price": "23,810",
          "high_price": "51,585"
        },
        "3.3": {
          "rap": "12,900",
          "low_price": "24,550",
          "high_price": "53,195"
        },
        "3.4": {
          "rap": "12,900",
          "low_price": "25,295",
          "high_price": "54,810"
        },
        "3.5": {
          "rap": "12,900",
          "low_price": "26,040",
          "high_price": "56,420"
        },
        "3.6": {
          "rap": "12,900",
          "low_price": "26,785",
          "high_price": "58,030"
        },
        "3.7": {
          "rap": "12,900",
          "low_price": "27,530",
          "high_price": "59,645"
        },
        "3.8": {
          "rap": "12,900",
          "low_price": "28,270",
          "high_price": "61,255"
        },
        "3.9": {
          "rap": "12,900",
          "low_price": "29,015",
          "high_price": "62,870"
        }
      },
      "G": {
        "0.4": {
          "rap": "1,600",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "2,200",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "2,200",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,800",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,800",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "4,000",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "5,100",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "5,100",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "5,100",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "5,100",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "5,100",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "7,600",
          "low_price": "4,860",
          "high_price": "10,530"
        },
        "1.6": {
          "rap": "7,600",
          "low_price": "5,185",
          "high_price": "11,230"
        },
        "1.7": {
          "rap": "7,600",
          "low_price": "5,510",
          "high_price": "11,935"
        },
        "1.8": {
          "rap": "7,600",
          "low_price": "5,830",
          "high_price": "12,635"
        },
        "1.9": {
          "rap": "7,600",
          "low_price": "6,155",
          "high_price": "13,340"
        },
        "2.0": {
          "rap": "9,400",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.1": {
          "rap": "9,400",
          "low_price": "9,700",
          "high_price": "21,020"
        },
        "2.2": {
          "rap": "9,400",
          "low_price": "10,165",
          "high_price": "22,020"
        },
        "2.3": {
          "rap": "9,400",
          "low_price": "10,625",
          "high_price": "23,025"
        },
        "2.4": {
          "rap": "9,400",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.5": {
          "rap": "9,400",
          "low_price": "11,550",
          "high_price": "25,025"
        },
        "2.6": {
          "rap": "9,400",
          "low_price": "12,010",
          "high_price": "26,025"
        },
        "2.7": {
          "rap": "9,400",
          "low_price": "12,475",
          "high_price": "27,025"
        },
        "2.8": {
          "rap": "9,400",
          "low_price": "12,935",
          "high_price": "28,030"
        },
        "2.9": {
          "rap": "9,400",
          "low_price": "13,400",
          "high_price": "29,030"
        },
        "3.0": {
          "rap": "11,700",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "3.1": {
          "rap": "11,700",
          "low_price": "20,830",
          "high_price": "45,135"
        },
        "3.2": {
          "rap": "11,700",
          "low_price": "21,505",
          "high_price": "46,590"
        },
        "3.3": {
          "rap": "11,700",
          "low_price": "22,175",
          "high_price": "48,050"
        },
        "3.4": {
          "rap": "11,700",
          "low_price": "22,850",
          "high_price": "49,505"
        },
        "3.5": {
          "rap": "11,700",
          "low_price": "23,520",
          "high_price": "50,960"
        },
        "3.6": {
          "rap": "11,700",
          "low_price": "24,190",
          "high_price": "52,415"
        },
        "3.7": {
          "rap": "11,700",
          "low_price": "24,865",
          "high_price": "53,870"
        },
        "3.8": {
          "rap": "11,700",
          "low_price": "25,535",
          "high_price": "55,330"
        },
        "3.9": {
          "rap": "11,700",
          "low_price": "26,210",
          "high_price": "56,785"
        }
      },
      "H": {
        "0.4": {
          "rap": "1,500",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "2,600",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,600",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "3,700",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "4,800",
          "low_price": "1,680",
          "high_price": "3,640"
        },
        "1.1": {
          "rap": "4,800",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.2": {
          "rap": "4,800",
          "low_price": "2,015",
          "high_price": "4,370"
        },
        "1.3": {
          "rap": "4,800",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.4": {
          "rap": "4,800",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "1.5": {
          "rap": "7,200",
          "low_price": "4,500",
          "high_price": "9,750"
        },
        "1.6": {
          "rap": "7,200",
          "low_price": "4,800",
          "high_price": "10,400"
        },
        "1.7": {
          "rap": "7,200",
          "low_price": "5,100",
          "high_price": "11,050"
        },
        "1.8": {
          "rap": "7,200",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "1.9": {
          "rap": "7,200",
          "low_price": "5,700",
          "high_price": "12,350"
        },
        "2.0": {
          "rap": "8,700",
          "low_price": "8,520",
          "high_price": "18,460"
        },
        "2.1": {
          "rap": "8,700",
          "low_price": "8,945",
          "high_price": "19,385"
        },
        "2.2": {
          "rap": "8,700",
          "low_price": "9,370",
          "high_price": "20,305"
        },
        "2.3": {
          "rap": "8,700",
          "low_price": "9,800",
          "high_price": "21,230"
        },
        "2.4": {
          "rap": "8,700",
          "low_price": "10,225",
          "high_price": "22,150"
        },
        "2.5": {
          "rap": "8,700",
          "low_price": "10,650",
          "high_price": "23,075"
        },
        "2.6": {
          "rap": "8,700",
          "low_price": "11,075",
          "high_price": "24,000"
        },
        "2.7": {
          "rap": "8,700",
          "low_price": "11,500",
          "high_price": "24,920"
        },
        "2.8": {
          "rap": "8,700",
          "low_price": "11,930",
          "high_price": "25,845"
        },
        "2.9": {
          "rap": "8,700",
          "low_price": "12,355",
          "high_price": "26,765"
        },
        "3.0": {
          "rap": "10,500",
          "low_price": "18,180",
          "high_price": "39,390"
        },
        "3.1": {
          "rap": "10,500",
          "low_price": "18,785",
          "high_price": "40,705"
        },
        "3.2": {
          "rap": "10,500",
          "low_price": "19,390",
          "high_price": "42,015"
        },
        "3.3": {
          "rap": "10,500",
          "low_price": "20,000",
          "high_price": "43,330"
        },
        "3.4": {
          "rap": "10,500",
          "low_price": "20,605",
          "high_price": "44,640"
        },
        "3.5": {
          "rap": "10,500",
          "low_price": "21,210",
          "high_price": "45,955"
        },
        "3.6": {
          "rap": "10,500",
          "low_price": "21,815",
          "high_price": "47,270"
        },
        "3.7": {
          "rap": "10,500",
          "low_price": "22,420",
          "high_price": "48,580"
        },
        "3.8": {
          "rap": "10,500",
          "low_price": "23,030",
          "high_price": "49,895"
        },
        "3.9": {
          "rap": "10,500",
          "low_price": "23,635",
          "high_price": "51,205"
        }
      },
      "I": {
        "0.4": {
          "rap": "1,300",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "330",
          "high_price": "715"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "395",
          "high_price": "860"
        },
        "0.7": {
          "rap": "2,400",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.8": {
          "rap": "2,400",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.9": {
          "rap": "3,500",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "1.0": {
          "rap": "4,500",
          "low_price": "1,560",
          "high_price": "3,380"
        },
        "1.1": {
          "rap": "4,500",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.2": {
          "rap": "4,500",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "1.3": {
          "rap": "4,500",
          "low_price": "2,030",
          "high_price": "4,395"
        },
        "1.4": {
          "rap": "4,500",
          "low_price": "2,185",
          "high_price": "4,730"
        },
        "1.5": {
          "rap": "6,700",
          "low_price": "4,140",
          "high_price": "8,970"
        },
        "1.6": {
          "rap": "6,700",
          "low_price": "4,415",
          "high_price": "9,570"
        },
        "1.7": {
          "rap": "6,700",
          "low_price": "4,690",
          "high_price": "10,165"
        },
        "1.8": {
          "rap": "6,700",
          "low_price": "4,970",
          "high_price": "10,765"
        },
        "1.9": {
          "rap": "6,700",
          "low_price": "5,245",
          "high_price": "11,360"
        },
        "2.0": {
          "rap": "8,100",
          "low_price": "7,920",
          "high_price": "17,160"
        },
        "2.1": {
          "rap": "8,100",
          "low_price": "8,315",
          "high_price": "18,020"
        },
        "2.2": {
          "rap": "8,100",
          "low_price": "8,710",
          "high_price": "18,875"
        },
        "2.3": {
          "rap": "8,100",
          "low_price": "9,110",
          "high_price": "19,735"
        },
        "2.4": {
          "rap": "8,100",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "2.5": {
          "rap": "8,100",
          "low_price": "9,900",
          "high_price": "21,450"
        },
        "2.6": {
          "rap": "8,100",
          "low_price": "10,295",
          "high_price": "22,310"
        },
        "2.7": {
          "rap": "8,100",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "2.8": {
          "rap": "8,100",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.9": {
          "rap": "8,100",
          "low_price": "11,485",
          "high_price": "24,880"
        },
        "3.0": {
          "rap": "9,600",
          "low_price": "16,560",
          "high_price": "35,880"
        },
        "3.1": {
          "rap": "9,600",
          "low_price": "17,110",
          "high_price": "37,075"
        },
        "3.2": {
          "rap": "9,600",
          "low_price": "17,665",
          "high_price": "38,270"
        },
        "3.3": {
          "rap": "9,600",
          "low_price": "18,215",
          "high_price": "39,470"
        },
        "3.4": {
          "rap": "9,600",
          "low_price": "18,770",
          "high_price": "40,665"
        },
        "3.5": {
          "rap": "9,600",
          "low_price": "19,320",
          "high_price": "41,860"
        },
        "3.6": {
          "rap": "9,600",
          "low_price": "19,870",
          "high_price": "43,055"
        },
        "3.7": {
          "rap": "9,600",
          "low_price": "20,425",
          "high_price": "44,250"
        },
        "3.8": {
          "rap": "9,600",
          "low_price": "20,975",
          "high_price": "45,450"
        },
        "3.9": {
          "rap": "9,600",
          "low_price": "21,530",
          "high_price": "46,645"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,200",
          "low_price": "240",
          "high_price": "520"
        },
        "0.5": {
          "rap": "1,700",
          "low_price": "330",
          "high_price": "715"
        },
        "0.6": {
          "rap": "1,700",
          "low_price": "395",
          "high_price": "860"
        },
        "0.7": {
          "rap": "2,200",
          "low_price": "590",
          "high_price": "1,275"
        },
        "0.8": {
          "rap": "2,200",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.9": {
          "rap": "3,000",
          "low_price": "1,080",
          "high_price": "2,340"
        },
        "1.0": {
          "rap": "4,100",
          "low_price": "1,380",
          "high_price": "2,990"
        },
        "1.1": {
          "rap": "4,100",
          "low_price": "1,520",
          "high_price": "3,290"
        },
        "1.2": {
          "rap": "4,100",
          "low_price": "1,655",
          "high_price": "3,590"
        },
        "1.3": {
          "rap": "4,100",
          "low_price": "1,795",
          "high_price": "3,885"
        },
        "1.4": {
          "rap": "4,100",
          "low_price": "1,930",
          "high_price": "4,185"
        },
        "1.5": {
          "rap": "6,000",
          "low_price": "3,510",
          "high_price": "7,605"
        },
        "1.6": {
          "rap": "6,000",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.7": {
          "rap": "6,000",
          "low_price": "3,980",
          "high_price": "8,620"
        },
        "1.8": {
          "rap": "6,000",
          "low_price": "4,210",
          "high_price": "9,125"
        },
        "1.9": {
          "rap": "6,000",
          "low_price": "4,445",
          "high_price": "9,635"
        },
        "2.0": {
          "rap": "7,600",
          "low_price": "6,840",
          "high_price": "14,820"
        },
        "2.1": {
          "rap": "7,600",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.2": {
          "rap": "7,600",
          "low_price": "7,525",
          "high_price": "16,300"
        },
        "2.3": {
          "rap": "7,600",
          "low_price": "7,865",
          "high_price": "17,045"
        },
        "2.4": {
          "rap": "7,600",
          "low_price": "8,210",
          "high_price": "17,785"
        },
        "2.5": {
          "rap": "7,600",
          "low_price": "8,550",
          "high_price": "18,525"
        },
        "2.6": {
          "rap": "7,600",
          "low_price": "8,890",
          "high_price": "19,265"
        },
        "2.7": {
          "rap": "7,600",
          "low_price": "9,235",
          "high_price": "20,005"
        },
        "2.8": {
          "rap": "7,600",
          "low_price": "9,575",
          "high_price": "20,750"
        },
        "2.9": {
          "rap": "7,600",
          "low_price": "9,920",
          "high_price": "21,490"
        },
        "3.0": {
          "rap": "8,700",
          "low_price": "15,120",
          "high_price": "32,760"
        },
        "3.1": {
          "rap": "8,700",
          "low_price": "15,625",
          "high_price": "33,850"
        },
        "3.2": {
          "rap": "8,700",
          "low_price": "16,130",
          "high_price": "34,945"
        },
        "3.3": {
          "rap": "8,700",
          "low_price": "16,630",
          "high_price": "36,035"
        },
        "3.4": {
          "rap": "8,700",
          "low_price": "17,135",
          "high_price": "37,130"
        },
        "3.5": {
          "rap": "8,700",
          "low_price": "17,640",
          "high_price": "38,220"
        },
        "3.6": {
          "rap": "8,700",
          "low_price": "18,145",
          "high_price": "39,310"
        },
        "3.7": {
          "rap": "8,700",
          "low_price": "18,650",
          "high_price": "40,405"
        },
        "3.8": {
          "rap": "8,700",
          "low_price": "19,150",
          "high_price": "41,495"
        },
        "3.9": {
          "rap": "8,700",
          "low_price": "19,655",
          "high_price": "42,590"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,000",
          "low_price": "215",
          "high_price": "470"
        },
        "0.5": {
          "rap": "1,400",
          "low_price": "300",
          "high_price": "650"
        },
        "0.6": {
          "rap": "1,400",
          "low_price": "360",
          "high_price": "780"
        },
        "0.7": {
          "rap": "1,900",
          "low_price": "545",
          "high_price": "1,185"
        },
        "0.8": {
          "rap": "1,900",
          "low_price": "625",
          "high_price": "1,350"
        },
        "0.9": {
          "rap": "2,600",
          "low_price": "970",
          "high_price": "2,105"
        },
        "1.0": {
          "rap": "3,500",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "1.1": {
          "rap": "3,500",
          "low_price": "1,450",
          "high_price": "3,145"
        },
        "1.2": {
          "rap": "3,500",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "1.3": {
          "rap": "3,500",
          "low_price": "1,715",
          "high_price": "3,720"
        },
        "1.4": {
          "rap": "3,500",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "1.5": {
          "rap": "5,200",
          "low_price": "3,060",
          "high_price": "6,630"
        },
        "1.6": {
          "rap": "5,200",
          "low_price": "3,265",
          "high_price": "7,070"
        },
        "1.7": {
          "rap": "5,200",
          "low_price": "3,470",
          "high_price": "7,515"
        },
        "1.8": {
          "rap": "5,200",
          "low_price": "3,670",
          "high_price": "7,955"
        },
        "1.9": {
          "rap": "5,200",
          "low_price": "3,875",
          "high_price": "8,400"
        },
        "2.0": {
          "rap": "6,700",
          "low_price": "6,000",
          "high_price": "13,000"
        },
        "2.1": {
          "rap": "6,700",
          "low_price": "6,300",
          "high_price": "13,650"
        },
        "2.2": {
          "rap": "6,700",
          "low_price": "6,600",
          "high_price": "14,300"
        },
        "2.3": {
          "rap": "6,700",
          "low_price": "6,900",
          "high_price": "14,950"
        },
        "2.4": {
          "rap": "6,700",
          "low_price": "7,200",
          "high_price": "15,600"
        },
        "2.5": {
          "rap": "6,700",
          "low_price": "7,500",
          "high_price": "16,250"
        },
        "2.6": {
          "rap": "6,700",
          "low_price": "7,800",
          "high_price": "16,900"
        },
        "2.7": {
          "rap": "6,700",
          "low_price": "8,100",
          "high_price": "17,550"
        },
        "2.8": {
          "rap": "6,700",
          "low_price": "8,400",
          "high_price": "18,200"
        },
        "2.9": {
          "rap": "6,700",
          "low_price": "8,700",
          "high_price": "18,850"
        },
        "3.0": {
          "rap": "7,600",
          "low_price": "13,680",
          "high_price": "29,640"
        },
        "3.1": {
          "rap": "7,600",
          "low_price": "14,135",
          "high_price": "30,630"
        },
        "3.2": {
          "rap": "7,600",
          "low_price": "14,590",
          "high_price": "31,615"
        },
        "3.3": {
          "rap": "7,600",
          "low_price": "15,050",
          "high_price": "32,605"
        },
        "3.4": {
          "rap": "7,600",
          "low_price": "15,505",
          "high_price": "33,590"
        },
        "3.5": {
          "rap": "7,600",
          "low_price": "15,960",
          "high_price": "34,580"
        },
        "3.6": {
          "rap": "7,600",
          "low_price": "16,415",
          "high_price": "35,570"
        },
        "3.7": {
          "rap": "7,600",
          "low_price": "16,870",
          "high_price": "36,555"
        },
        "3.8": {
          "rap": "7,600",
          "low_price": "17,330",
          "high_price": "37,545"
        },
        "3.9": {
          "rap": "7,600",
          "low_price": "17,785",
          "high_price": "38,530"
        }
      }
    },
    "VS1": {
      "D": {
        "0.4": {
          "rap": "3,100",
          "low_price": "530",
          "high_price": "1,145"
        },
        "0.5": {
          "rap": "4,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.6": {
          "rap": "4,400",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.7": {
          "rap": "6,000",
          "low_price": "1,595",
          "high_price": "3,460"
        },
        "0.8": {
          "rap": "6,000",
          "low_price": "1,825",
          "high_price": "3,950"
        },
        "0.9": {
          "rap": "8,700",
          "low_price": "3,080",
          "high_price": "6,670"
        },
        "1.0": {
          "rap": "12,500",
          "low_price": "4,980",
          "high_price": "10,790"
        },
        "1.1": {
          "rap": "12,500",
          "low_price": "5,480",
          "high_price": "11,870"
        },
        "1.2": {
          "rap": "12,500",
          "low_price": "5,975",
          "high_price": "12,950"
        },
        "1.3": {
          "rap": "12,500",
          "low_price": "6,475",
          "high_price": "14,025"
        },
        "1.4": {
          "rap": "12,500",
          "low_price": "6,970",
          "high_price": "15,105"
        },
        "1.5": {
          "rap": "18,000",
          "low_price": "12,060",
          "high_price": "26,130"
        },
        "1.6": {
          "rap": "18,000",
          "low_price": "12,865",
          "high_price": "27,870"
        },
        "1.7": {
          "rap": "18,000",
          "low_price": "13,670",
          "high_price": "29,615"
        },
        "1.8": {
          "rap": "18,000",
          "low_price": "14,470",
          "high_price": "31,355"
        },
        "1.9": {
          "rap": "18,000",
          "low_price": "15,275",
          "high_price": "33,100"
        },
        "2.0": {
          "rap": "25,000",
          "low_price": "24,600",
          "high_price": "53,300"
        },
        "2.1": {
          "rap": "25,000",
          "low_price": "25,830",
          "high_price": "55,965"
        },
        "2.2": {
          "rap": "25,000",
          "low_price": "27,060",
          "high_price": "58,630"
        },
        "2.3": {
          "rap": "25,000",
          "low_price": "28,290",
          "high_price": "61,295"
        },
        "2.4": {
          "rap": "25,000",
          "low_price": "29,520",
          "high_price": "63,960"
        },
        "2.5": {
          "rap": "25,000",
          "low_price": "30,750",
          "high_price": "66,625"
        },
        "2.6": {
          "rap": "25,000",
          "low_price": "31,980",
          "high_price": "69,290"
        },
        "2.7": {
          "rap": "25,000",
          "low_price": "33,210",
          "high_price": "71,955"
        },
        "2.8": {
          "rap": "25,000",
          "low_price": "34,440",
          "high_price": "74,620"
        },
        "2.9": {
          "rap": "25,000",
          "low_price": "35,670",
          "high_price": "77,285"
        },
        "3.0": {
          "rap": "40,000",
          "low_price": "63,000",
          "high_price": "136,500"
        },
        "3.1": {
          "rap": "40,000",
          "low_price": "65,100",
          "high_price": "141,050"
        },
        "3.2": {
          "rap": "40,000",
          "low_price": "67,200",
          "high_price": "145,600"
        },
        "3.3": {
          "rap": "40,000",
          "low_price": "69,300",
          "high_price": "150,150"
        },
        "3.4": {
          "rap": "40,000",
          "low_price": "71,400",
          "high_price": "154,700"
        },
        "3.5": {
          "rap": "40,000",
          "low_price": "73,500",
          "high_price": "159,250"
        },
        "3.6": {
          "rap": "40,000",
          "low_price": "75,600",
          "high_price": "163,800"
        },
        "3.7": {
          "rap": "40,000",
          "low_price": "77,700",
          "high_price": "168,350"
        },
        "3.8": {
          "rap": "40,000",
          "low_price": "79,800",
          "high_price": "172,900"
        },
        "3.9": {
          "rap": "40,000",
          "low_price": "81,900",
          "high_price": "177,450"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,900",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.5": {
          "rap": "4,200",
          "low_price": "780",
          "high_price": "1,690"
        },
        "0.6": {
          "rap": "4,200",
          "low_price": "935",
          "high_price": "2,030"
        },
        "0.7": {
          "rap": "5,600",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "0.8": {
          "rap": "5,600",
          "low_price": "1,730",
          "high_price": "3,745"
        },
        "0.9": {
          "rap": "8,100",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.0": {
          "rap": "11,700",
          "low_price": "4,500",
          "high_price": "9,750"
        },
        "1.1": {
          "rap": "11,700",
          "low_price": "4,950",
          "high_price": "10,725"
        },
        "1.2": {
          "rap": "11,700",
          "low_price": "5,400",
          "high_price": "11,700"
        },
        "1.3": {
          "rap": "11,700",
          "low_price": "5,850",
          "high_price": "12,675"
        },
        "1.4": {
          "rap": "11,700",
          "low_price": "6,300",
          "high_price": "13,650"
        },
        "1.5": {
          "rap": "16,700",
          "low_price": "10,980",
          "high_price": "23,790"
        },
        "1.6": {
          "rap": "16,700",
          "low_price": "11,710",
          "high_price": "25,375"
        },
        "1.7": {
          "rap": "16,700",
          "low_price": "12,445",
          "high_price": "26,960"
        },
        "1.8": {
          "rap": "16,700",
          "low_price": "13,175",
          "high_price": "28,550"
        },
        "1.9": {
          "rap": "16,700",
          "low_price": "13,910",
          "high_price": "30,135"
        },
        "2.0": {
          "rap": "23,000",
          "low_price": "22,800",
          "high_price": "49,400"
        },
        "2.1": {
          "rap": "23,000",
          "low_price": "23,940",
          "high_price": "51,870"
        },
        "2.2": {
          "rap": "23,000",
          "low_price": "25,080",
          "high_price": "54,340"
        },
        "2.3": {
          "rap": "23,000",
          "low_price": "26,220",
          "high_price": "56,810"
        },
        "2.4": {
          "rap": "23,000",
          "low_price": "27,360",
          "high_price": "59,280"
        },
        "2.5": {
          "rap": "23,000",
          "low_price": "28,500",
          "high_price": "61,750"
        },
        "2.6": {
          "rap": "23,000",
          "low_price": "29,640",
          "high_price": "64,220"
        },
        "2.7": {
          "rap": "23,000",
          "low_price": "30,780",
          "high_price": "66,690"
        },
        "2.8": {
          "rap": "23,000",
          "low_price": "31,920",
          "high_price": "69,160"
        },
        "2.9": {
          "rap": "23,000",
          "low_price": "33,060",
          "high_price": "71,630"
        },
        "3.0": {
          "rap": "36,500",
          "low_price": "57,600",
          "high_price": "124,800"
        },
        "3.1": {
          "rap": "36,500",
          "low_price": "59,520",
          "high_price": "128,960"
        },
        "3.2": {
          "rap": "36,500",
          "low_price": "61,440",
          "high_price": "133,120"
        },
        "3.3": {
          "rap": "36,500",
          "low_price": "63,360",
          "high_price": "137,280"
        },
        "3.4": {
          "rap": "36,500",
          "low_price": "65,280",
          "high_price": "141,440"
        },
        "3.5": {
          "rap": "36,500",
          "low_price": "67,200",
          "high_price": "145,600"
        },
        "3.6": {
          "rap": "36,500",
          "low_price": "69,120",
          "high_price": "149,760"
        },
        "3.7": {
          "rap": "36,500",
          "low_price": "71,040",
          "high_price": "153,920"
        },
        "3.8": {
          "rap": "36,500",
          "low_price": "72,960",
          "high_price": "158,080"
        },
        "3.9": {
          "rap": "36,500",
          "low_price": "74,880",
          "high_price": "162,240"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,700",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "4,000",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.6": {
          "rap": "4,000",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.7": {
          "rap": "5,300",
          "low_price": "1,430",
          "high_price": "3,095"
        },
        "0.8": {
          "rap": "5,300",
          "low_price": "1,630",
          "high_price": "3,535"
        },
        "0.9": {
          "rap": "7,700",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.0": {
          "rap": "10,900",
          "low_price": "4,080",
          "high_price": "8,840"
        },
        "1.1": {
          "rap": "10,900",
          "low_price": "4,490",
          "high_price": "9,725"
        },
        "1.2": {
          "rap": "10,900",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.3": {
          "rap": "10,900",
          "low_price": "5,305",
          "high_price": "11,490"
        },
        "1.4": {
          "rap": "10,900",
          "low_price": "5,710",
          "high_price": "12,375"
        },
        "1.5": {
          "rap": "15,200",
          "low_price": "10,260",
          "high_price": "22,230"
        },
        "1.6": {
          "rap": "15,200",
          "low_price": "10,945",
          "high_price": "23,710"
        },
        "1.7": {
          "rap": "15,200",
          "low_price": "11,630",
          "high_price": "25,195"
        },
        "1.8": {
          "rap": "15,200",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "1.9": {
          "rap": "15,200",
          "low_price": "12,995",
          "high_price": "28,160"
        },
        "2.0": {
          "rap": "21,500",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.1": {
          "rap": "21,500",
          "low_price": "22,050",
          "high_price": "47,775"
        },
        "2.2": {
          "rap": "21,500",
          "low_price": "23,100",
          "high_price": "50,050"
        },
        "2.3": {
          "rap": "21,500",
          "low_price": "24,150",
          "high_price": "52,325"
        },
        "2.4": {
          "rap": "21,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.5": {
          "rap": "21,500",
          "low_price": "26,250",
          "high_price": "56,875"
        },
        "2.6": {
          "rap": "21,500",
          "low_price": "27,300",
          "high_price": "59,150"
        },
        "2.7": {
          "rap": "21,500",
          "low_price": "28,350",
          "high_price": "61,425"
        },
        "2.8": {
          "rap": "21,500",
          "low_price": "29,400",
          "high_price": "63,700"
        },
        "2.9": {
          "rap": "21,500",
          "low_price": "30,450",
          "high_price": "65,975"
        },
        "3.0": {
          "rap": "32,500",
          "low_price": "53,100",
          "high_price": "115,050"
        },
        "3.1": {
          "rap": "32,500",
          "low_price": "54,870",
          "high_price": "118,885"
        },
        "3.2": {
          "rap": "32,500",
          "low_price": "56,640",
          "high_price": "122,720"
        },
        "3.3": {
          "rap": "32,500",
          "low_price": "58,410",
          "high_price": "126,555"
        },
        "3.4": {
          "rap": "32,500",
          "low_price": "60,180",
          "high_price": "130,390"
        },
        "3.5": {
          "rap": "32,500",
          "low_price": "61,950",
          "high_price": "134,225"
        },
        "3.6": {
          "rap": "32,500",
          "low_price": "63,720",
          "high_price": "138,060"
        },
        "3.7": {
          "rap": "32,500",
          "low_price": "65,490",
          "high_price": "141,895"
        },
        "3.8": {
          "rap": "32,500",
          "low_price": "67,260",
          "high_price": "145,730"
        },
        "3.9": {
          "rap": "32,500",
          "low_price": "69,030",
          "high_price": "149,565"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,600",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "3,800",
          "low_price": "690",
          "high_price": "1,495"
        },
        "0.6": {
          "rap": "3,800",
          "low_price": "830",
          "high_price": "1,795"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,300",
          "high_price": "2,820"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,490",
          "high_price": "3,225"
        },
        "0.9": {
          "rap": "7,200",
          "low_price": "2,320",
          "high_price": "5,030"
        },
        "1.0": {
          "rap": "10,100",
          "low_price": "3,540",
          "high_price": "7,670"
        },
        "1.1": {
          "rap": "10,100",
          "low_price": "3,895",
          "high_price": "8,435"
        },
        "1.2": {
          "rap": "10,100",
          "low_price": "4,250",
          "high_price": "9,205"
        },
        "1.3": {
          "rap": "10,100",
          "low_price": "4,600",
          "high_price": "9,970"
        },
        "1.4": {
          "rap": "10,100",
          "low_price": "4,955",
          "high_price": "10,740"
        },
        "1.5": {
          "rap": "13,500",
          "low_price": "8,910",
          "high_price": "19,305"
        },
        "1.6": {
          "rap": "13,500",
          "low_price": "9,505",
          "high_price": "20,590"
        },
        "1.7": {
          "rap": "13,500",
          "low_price": "10,100",
          "high_price": "21,880"
        },
        "1.8": {
          "rap": "13,500",
          "low_price": "10,690",
          "high_price": "23,165"
        },
        "1.9": {
          "rap": "13,500",
          "low_price": "11,285",
          "high_price": "24,455"
        },
        "2.0": {
          "rap": "19,000",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.1": {
          "rap": "19,000",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "2.2": {
          "rap": "19,000",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.3": {
          "rap": "19,000",
          "low_price": "20,700",
          "high_price": "44,850"
        },
        "2.4": {
          "rap": "19,000",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "2.5": {
          "rap": "19,000",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "2.6": {
          "rap": "19,000",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.7": {
          "rap": "19,000",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "2.8": {
          "rap": "19,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.9": {
          "rap": "19,000",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.0": {
          "rap": "28,000",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.1": {
          "rap": "28,000",
          "low_price": "45,570",
          "high_price": "98,735"
        },
        "3.2": {
          "rap": "28,000",
          "low_price": "47,040",
          "high_price": "101,920"
        },
        "3.3": {
          "rap": "28,000",
          "low_price": "48,510",
          "high_price": "105,105"
        },
        "3.4": {
          "rap": "28,000",
          "low_price": "49,980",
          "high_price": "108,290"
        },
        "3.5": {
          "rap": "28,000",
          "low_price": "51,450",
          "high_price": "111,475"
        },
        "3.6": {
          "rap": "28,000",
          "low_price": "52,920",
          "high_price": "114,660"
        },
        "3.7": {
          "rap": "28,000",
          "low_price": "54,390",
          "high_price": "117,845"
        },
        "3.8": {
          "rap": "28,000",
          "low_price": "55,860",
          "high_price": "121,030"
        },
        "3.9": {
          "rap": "28,000",
          "low_price": "57,330",
          "high_price": "124,215"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,400",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "3,600",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.6": {
          "rap": "3,600",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.7": {
          "rap": "4,600",
          "low_price": "1,090",
          "high_price": "2,365"
        },
        "0.8": {
          "rap": "4,600",
          "low_price": "1,250",
          "high_price": "2,705"
        },
        "0.9": {
          "rap": "6,500",
          "low_price": "2,000",
          "high_price": "4,330"
        },
        "1.0": {
          "rap": "8,900",
          "low_price": "2,940",
          "high_price": "6,370"
        },
        "1.1": {
          "rap": "8,900",
          "low_price": "3,235",
          "high_price": "7,005"
        },
        "1.2": {
          "rap": "8,900",
          "low_price": "3,530",
          "high_price": "7,645"
        },
        "1.3": {
          "rap": "8,900",
          "low_price": "3,820",
          "high_price": "8,280"
        },
        "1.4": {
          "rap": "8,900",
          "low_price": "4,115",
          "high_price": "8,920"
        },
        "1.5": {
          "rap": "11,800",
          "low_price": "7,290",
          "high_price": "15,795"
        },
        "1.6": {
          "rap": "11,800",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "1.7": {
          "rap": "11,800",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "1.8": {
          "rap": "11,800",
          "low_price": "8,750",
          "high_price": "18,955"
        },
        "1.9": {
          "rap": "11,800",
          "low_price": "9,235",
          "high_price": "20,005"
        },
        "2.0": {
          "rap": "16,500",
          "low_price": "15,000",
          "high_price": "32,500"
        },
        "2.1": {
          "rap": "16,500",
          "low_price": "15,750",
          "high_price": "34,125"
        },
        "2.2": {
          "rap": "16,500",
          "low_price": "16,500",
          "high_price": "35,750"
        },
        "2.3": {
          "rap": "16,500",
          "low_price": "17,250",
          "high_price": "37,375"
        },
        "2.4": {
          "rap": "16,500",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.5": {
          "rap": "16,500",
          "low_price": "18,750",
          "high_price": "40,625"
        },
        "2.6": {
          "rap": "16,500",
          "low_price": "19,500",
          "high_price": "42,250"
        },
        "2.7": {
          "rap": "16,500",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.8": {
          "rap": "16,500",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.9": {
          "rap": "16,500",
          "low_price": "21,750",
          "high_price": "47,125"
        },
        "3.0": {
          "rap": "23,500",
          "low_price": "36,900",
          "high_price": "79,950"
        },
        "3.1": {
          "rap": "23,500",
          "low_price": "38,130",
          "high_price": "82,615"
        },
        "3.2": {
          "rap": "23,500",
          "low_price": "39,360",
          "high_price": "85,280"
        },
        "3.3": {
          "rap": "23,500",
          "low_price": "40,590",
          "high_price": "87,945"
        },
        "3.4": {
          "rap": "23,500",
          "low_price": "41,820",
          "high_price": "90,610"
        },
        "3.5": {
          "rap": "23,500",
          "low_price": "43,050",
          "high_price": "93,275"
        },
        "3.6": {
          "rap": "23,500",
          "low_price": "44,280",
          "high_price": "95,940"
        },
        "3.7": {
          "rap": "23,500",
          "low_price": "45,510",
          "high_price": "98,605"
        },
        "3.8": {
          "rap": "23,500",
          "low_price": "46,740",
          "high_price": "101,270"
        },
        "3.9": {
          "rap": "23,500",
          "low_price": "47,970",
          "high_price": "103,935"
        }
      },
      "I": {
        "0.4": {
          "rap": "2,100",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "3,000",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.6": {
          "rap": "3,000",
          "low_price": "650",
          "high_price": "1,405"
        },
        "0.7": {
          "rap": "3,800",
          "low_price": "965",
          "high_price": "2,095"
        },
        "0.8": {
          "rap": "3,800",
          "low_price": "1,105",
          "high_price": "2,390"
        },
        "0.9": {
          "rap": "5,700",
          "low_price": "1,780",
          "high_price": "3,860"
        },
        "1.0": {
          "rap": "7,500",
          "low_price": "2,460",
          "high_price": "5,330"
        },
        "1.1": {
          "rap": "7,500",
          "low_price": "2,705",
          "high_price": "5,865"
        },
        "1.2": {
          "rap": "7,500",
          "low_price": "2,950",
          "high_price": "6,395"
        },
        "1.3": {
          "rap": "7,500",
          "low_price": "3,200",
          "high_price": "6,930"
        },
        "1.4": {
          "rap": "7,500",
          "low_price": "3,445",
          "high_price": "7,460"
        },
        "1.5": {
          "rap": "9,900",
          "low_price": "6,120",
          "high_price": "13,260"
        },
        "1.6": {
          "rap": "9,900",
          "low_price": "6,530",
          "high_price": "14,145"
        },
        "1.7": {
          "rap": "9,900",
          "low_price": "6,935",
          "high_price": "15,030"
        },
        "1.8": {
          "rap": "9,900",
          "low_price": "7,345",
          "high_price": "15,910"
        },
        "1.9": {
          "rap": "9,900",
          "low_price": "7,750",
          "high_price": "16,795"
        },
        "2.0": {
          "rap": "13,500",
          "low_price": "12,000",
          "high_price": "26,000"
        },
        "2.1": {
          "rap": "13,500",
          "low_price": "12,600",
          "high_price": "27,300"
        },
        "2.2": {
          "rap": "13,500",
          "low_price": "13,200",
          "high_price": "28,600"
        },
        "2.3": {
          "rap": "13,500",
          "low_price": "13,800",
          "high_price": "29,900"
        },
        "2.4": {
          "rap": "13,500",
          "low_price": "14,400",
          "high_price": "31,200"
        },
        "2.5": {
          "rap": "13,500",
          "low_price": "15,000",
          "high_price": "32,500"
        },
        "2.6": {
          "rap": "13,500",
          "low_price": "15,600",
          "high_price": "33,800"
        },
        "2.7": {
          "rap": "13,500",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.8": {
          "rap": "13,500",
          "low_price": "16,800",
          "high_price": "36,400"
        },
        "2.9": {
          "rap": "13,500",
          "low_price": "17,400",
          "high_price": "37,700"
        },
        "3.0": {
          "rap": "19,500",
          "low_price": "31,500",
          "high_price": "68,250"
        },
        "3.1": {
          "rap": "19,500",
          "low_price": "32,550",
          "high_price": "70,525"
        },
        "3.2": {
          "rap": "19,500",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "3.3": {
          "rap": "19,500",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "3.4": {
          "rap": "19,500",
          "low_price": "35,700",
          "high_price": "77,350"
        },
        "3.5": {
          "rap": "19,500",
          "low_price": "36,750",
          "high_price": "79,625"
        },
        "3.6": {
          "rap": "19,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.7": {
          "rap": "19,500",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.8": {
          "rap": "19,500",
          "low_price": "39,900",
          "high_price": "86,450"
        },
        "3.9": {
          "rap": "19,500",
          "low_price": "40,950",
          "high_price": "88,725"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,800",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "2,400",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "2,400",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "3,200",
          "low_price": "800",
          "high_price": "1,730"
        },
        "0.8": {
          "rap": "3,200",
          "low_price": "910",
          "high_price": "1,975"
        },
        "0.9": {
          "rap": "4,900",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "1.0": {
          "rap": "6,000",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.1": {
          "rap": "6,000",
          "low_price": "2,180",
          "high_price": "4,720"
        },
        "1.2": {
          "rap": "6,000",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.3": {
          "rap": "6,000",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.4": {
          "rap": "6,000",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.5": {
          "rap": "8,400",
          "low_price": "5,130",
          "high_price": "11,115"
        },
        "1.6": {
          "rap": "8,400",
          "low_price": "5,470",
          "high_price": "11,855"
        },
        "1.7": {
          "rap": "8,400",
          "low_price": "5,815",
          "high_price": "12,595"
        },
        "1.8": {
          "rap": "8,400",
          "low_price": "6,155",
          "high_price": "13,340"
        },
        "1.9": {
          "rap": "8,400",
          "low_price": "6,500",
          "high_price": "14,080"
        },
        "2.0": {
          "rap": "11,200",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.1": {
          "rap": "11,200",
          "low_price": "10,585",
          "high_price": "22,930"
        },
        "2.2": {
          "rap": "11,200",
          "low_price": "11,090",
          "high_price": "24,025"
        },
        "2.3": {
          "rap": "11,200",
          "low_price": "11,590",
          "high_price": "25,115"
        },
        "2.4": {
          "rap": "11,200",
          "low_price": "12,095",
          "high_price": "26,210"
        },
        "2.5": {
          "rap": "11,200",
          "low_price": "12,600",
          "high_price": "27,300"
        },
        "2.6": {
          "rap": "11,200",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.7": {
          "rap": "11,200",
          "low_price": "13,610",
          "high_price": "29,485"
        },
        "2.8": {
          "rap": "11,200",
          "low_price": "14,110",
          "high_price": "30,575"
        },
        "2.9": {
          "rap": "11,200",
          "low_price": "14,615",
          "high_price": "31,670"
        },
        "3.0": {
          "rap": "16,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "3.1": {
          "rap": "16,000",
          "low_price": "26,040",
          "high_price": "56,420"
        },
        "3.2": {
          "rap": "16,000",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "3.3": {
          "rap": "16,000",
          "low_price": "27,720",
          "high_price": "60,060"
        },
        "3.4": {
          "rap": "16,000",
          "low_price": "28,560",
          "high_price": "61,880"
        },
        "3.5": {
          "rap": "16,000",
          "low_price": "29,400",
          "high_price": "63,700"
        },
        "3.6": {
          "rap": "16,000",
          "low_price": "30,240",
          "high_price": "65,520"
        },
        "3.7": {
          "rap": "16,000",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "3.8": {
          "rap": "16,000",
          "low_price": "31,920",
          "high_price": "69,160"
        },
        "3.9": {
          "rap": "16,000",
          "low_price": "32,760",
          "high_price": "70,980"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,600",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "2,000",
          "low_price": "390",
          "high_price": "845"
        },
        "0.6": {
          "rap": "2,000",
          "low_price": "470",
          "high_price": "1,015"
        },
        "0.7": {
          "rap": "2,600",
          "low_price": "715",
          "high_price": "1,545"
        },
        "0.8": {
          "rap": "2,600",
          "low_price": "815",
          "high_price": "1,770"
        },
        "0.9": {
          "rap": "4,000",
          "low_price": "1,350",
          "high_price": "2,925"
        },
        "1.0": {
          "rap": "4,900",
          "low_price": "1,740",
          "high_price": "3,770"
        },
        "1.1": {
          "rap": "4,900",
          "low_price": "1,915",
          "high_price": "4,145"
        },
        "1.2": {
          "rap": "4,900",
          "low_price": "2,090",
          "high_price": "4,525"
        },
        "1.3": {
          "rap": "4,900",
          "low_price": "2,260",
          "high_price": "4,900"
        },
        "1.4": {
          "rap": "4,900",
          "low_price": "2,435",
          "high_price": "5,280"
        },
        "1.5": {
          "rap": "7,000",
          "low_price": "4,230",
          "high_price": "9,165"
        },
        "1.6": {
          "rap": "7,000",
          "low_price": "4,510",
          "high_price": "9,775"
        },
        "1.7": {
          "rap": "7,000",
          "low_price": "4,795",
          "high_price": "10,385"
        },
        "1.8": {
          "rap": "7,000",
          "low_price": "5,075",
          "high_price": "11,000"
        },
        "1.9": {
          "rap": "7,000",
          "low_price": "5,360",
          "high_price": "11,610"
        },
        "2.0": {
          "rap": "9,200",
          "low_price": "8,400",
          "high_price": "18,200"
        },
        "2.1": {
          "rap": "9,200",
          "low_price": "8,820",
          "high_price": "19,110"
        },
        "2.2": {
          "rap": "9,200",
          "low_price": "9,240",
          "high_price": "20,020"
        },
        "2.3": {
          "rap": "9,200",
          "low_price": "9,660",
          "high_price": "20,930"
        },
        "2.4": {
          "rap": "9,200",
          "low_price": "10,080",
          "high_price": "21,840"
        },
        "2.5": {
          "rap": "9,200",
          "low_price": "10,500",
          "high_price": "22,750"
        },
        "2.6": {
          "rap": "9,200",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.7": {
          "rap": "9,200",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "2.8": {
          "rap": "9,200",
          "low_price": "11,760",
          "high_price": "25,480"
        },
        "2.9": {
          "rap": "9,200",
          "low_price": "12,180",
          "high_price": "26,390"
        },
        "3.0": {
          "rap": "13,000",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "3.1": {
          "rap": "13,000",
          "low_price": "22,320",
          "high_price": "48,360"
        },
        "3.2": {
          "rap": "13,000",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "3.3": {
          "rap": "13,000",
          "low_price": "23,760",
          "high_price": "51,480"
        },
        "3.4": {
          "rap": "13,000",
          "low_price": "24,480",
          "high_price": "53,040"
        },
        "3.5": {
          "rap": "13,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "3.6": {
          "rap": "13,000",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "3.7": {
          "rap": "13,000",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "3.8": {
          "rap": "13,000",
          "low_price": "27,360",
          "high_price": "59,280"
        },
        "3.9": {
          "rap": "13,000",
          "low_price": "28,080",
          "high_price": "60,840"
        }
      }
    },
    "VS2": {
      "D": {
        "0.4": {
          "rap": "2,700",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.5": {
          "rap": "4,100",
          "low_price": "750",
          "high_price": "1,625"
        },
        "0.6": {
          "rap": "4,100",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.7": {
          "rap": "5,300",
          "low_price": "1,385",
          "high_price": "3,005"
        },
        "0.8": {
          "rap": "5,300",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "0.9": {
          "rap": "7,600",
          "low_price": "2,645",
          "high_price": "5,735"
        },
        "1.0": {
          "rap": "10,700",
          "low_price": "4,140",
          "high_price": "8,970"
        },
        "1.1": {
          "rap": "10,700",
          "low_price": "4,555",
          "high_price": "9,865"
        },
        "1.2": {
          "rap": "10,700",
          "low_price": "4,970",
          "high_price": "10,765"
        },
        "1.3": {
          "rap": "10,700",
          "low_price": "5,380",
          "high_price": "11,660"
        },
        "1.4": {
          "rap": "10,700",
          "low_price": "5,795",
          "high_price": "12,560"
        },
        "1.5": {
          "rap": "15,700",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "1.6": {
          "rap": "15,700",
          "low_price": "11,520",
          "high_price": "24,960"
        },
        "1.7": {
          "rap": "15,700",
          "low_price": "12,240",
          "high_price": "26,520"
        },
        "1.8": {
          "rap": "15,700",
          "low_price": "12,960",
          "high_price": "28,080"
        },
        "1.9": {
          "rap": "15,700",
          "low_price": "13,680",
          "high_price": "29,640"
        },
        "2.0": {
          "rap": "21,500",
          "low_price": "21,000",
          "high_price": "45,500"
        },
        "2.1": {
          "rap": "21,500",
          "low_price": "22,050",
          "high_price": "47,775"
        },
        "2.2": {
          "rap": "21,500",
          "low_price": "23,100",
          "high_price": "50,050"
        },
        "2.3": {
          "rap": "21,500",
          "low_price": "24,150",
          "high_price": "52,325"
        },
        "2.4": {
          "rap": "21,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.5": {
          "rap": "21,500",
          "low_price": "26,250",
          "high_price": "56,875"
        },
        "2.6": {
          "rap": "21,500",
          "low_price": "27,300",
          "high_price": "59,150"
        },
        "2.7": {
          "rap": "21,500",
          "low_price": "28,350",
          "high_price": "61,425"
        },
        "2.8": {
          "rap": "21,500",
          "low_price": "29,400",
          "high_price": "63,700"
        },
        "2.9": {
          "rap": "21,500",
          "low_price": "30,450",
          "high_price": "65,975"
        },
        "3.0": {
          "rap": "34,000",
          "low_price": "53,100",
          "high_price": "115,050"
        },
        "3.1": {
          "rap": "34,000",
          "low_price": "54,870",
          "high_price": "118,885"
        },
        "3.2": {
          "rap": "34,000",
          "low_price": "56,640",
          "high_price": "122,720"
        },
        "3.3": {
          "rap": "34,000",
          "low_price": "58,410",
          "high_price": "126,555"
        },
        "3.4": {
          "rap": "34,000",
          "low_price": "60,180",
          "high_price": "130,390"
        },
        "3.5": {
          "rap": "34,000",
          "low_price": "61,950",
          "high_price": "134,225"
        },
        "3.6": {
          "rap": "34,000",
          "low_price": "63,720",
          "high_price": "138,060"
        },
        "3.7": {
          "rap": "34,000",
          "low_price": "65,490",
          "high_price": "141,895"
        },
        "3.8": {
          "rap": "34,000",
          "low_price": "67,260",
          "high_price": "145,730"
        },
        "3.9": {
          "rap": "34,000",
          "low_price": "69,030",
          "high_price": "149,565"
        }
      },
      "E": {
        "0.4": {
          "rap": "2,600",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "3,900",
          "low_price": "690",
          "high_price": "1,495"
        },
        "0.6": {
          "rap": "3,900",
          "low_price": "830",
          "high_price": "1,795"
        },
        "0.7": {
          "rap": "5,000",
          "low_price": "1,300",
          "high_price": "2,820"
        },
        "0.8": {
          "rap": "5,000",
          "low_price": "1,490",
          "high_price": "3,225"
        },
        "0.9": {
          "rap": "7,200",
          "low_price": "2,430",
          "high_price": "5,265"
        },
        "1.0": {
          "rap": "10,000",
          "low_price": "3,720",
          "high_price": "8,060"
        },
        "1.1": {
          "rap": "10,000",
          "low_price": "4,090",
          "high_price": "8,865"
        },
        "1.2": {
          "rap": "10,000",
          "low_price": "4,465",
          "high_price": "9,670"
        },
        "1.3": {
          "rap": "10,000",
          "low_price": "4,835",
          "high_price": "10,480"
        },
        "1.4": {
          "rap": "10,000",
          "low_price": "5,210",
          "high_price": "11,285"
        },
        "1.5": {
          "rap": "14,600",
          "low_price": "9,900",
          "high_price": "21,450"
        },
        "1.6": {
          "rap": "14,600",
          "low_price": "10,560",
          "high_price": "22,880"
        },
        "1.7": {
          "rap": "14,600",
          "low_price": "11,220",
          "high_price": "24,310"
        },
        "1.8": {
          "rap": "14,600",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "1.9": {
          "rap": "14,600",
          "low_price": "12,540",
          "high_price": "27,170"
        },
        "2.0": {
          "rap": "20,000",
          "low_price": "19,200",
          "high_price": "41,600"
        },
        "2.1": {
          "rap": "20,000",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.2": {
          "rap": "20,000",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "2.3": {
          "rap": "20,000",
          "low_price": "22,080",
          "high_price": "47,840"
        },
        "2.4": {
          "rap": "20,000",
          "low_price": "23,040",
          "high_price": "49,920"
        },
        "2.5": {
          "rap": "20,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "2.6": {
          "rap": "20,000",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "2.7": {
          "rap": "20,000",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "2.8": {
          "rap": "20,000",
          "low_price": "26,880",
          "high_price": "58,240"
        },
        "2.9": {
          "rap": "20,000",
          "low_price": "27,840",
          "high_price": "60,320"
        },
        "3.0": {
          "rap": "31,000",
          "low_price": "47,700",
          "high_price": "103,350"
        },
        "3.1": {
          "rap": "31,000",
          "low_price": "49,290",
          "high_price": "106,795"
        },
        "3.2": {
          "rap": "31,000",
          "low_price": "50,880",
          "high_price": "110,240"
        },
        "3.3": {
          "rap": "31,000",
          "low_price": "52,470",
          "high_price": "113,685"
        },
        "3.4": {
          "rap": "31,000",
          "low_price": "54,060",
          "high_price": "117,130"
        },
        "3.5": {
          "rap": "31,000",
          "low_price": "55,650",
          "high_price": "120,575"
        },
        "3.6": {
          "rap": "31,000",
          "low_price": "57,240",
          "high_price": "124,020"
        },
        "3.7": {
          "rap": "31,000",
          "low_price": "58,830",
          "high_price": "127,465"
        },
        "3.8": {
          "rap": "31,000",
          "low_price": "60,420",
          "high_price": "130,910"
        },
        "3.9": {
          "rap": "31,000",
          "low_price": "62,010",
          "high_price": "134,355"
        }
      },
      "F": {
        "0.4": {
          "rap": "2,500",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "3,700",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "3,700",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,800",
          "low_price": "1,220",
          "high_price": "2,640"
        },
        "0.8": {
          "rap": "4,800",
          "low_price": "1,390",
          "high_price": "3,015"
        },
        "0.9": {
          "rap": "6,900",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.0": {
          "rap": "9,400",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "1.1": {
          "rap": "9,400",
          "low_price": "3,695",
          "high_price": "8,010"
        },
        "1.2": {
          "rap": "9,400",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.3": {
          "rap": "9,400",
          "low_price": "4,370",
          "high_price": "9,465"
        },
        "1.4": {
          "rap": "9,400",
          "low_price": "4,705",
          "high_price": "10,190"
        },
        "1.5": {
          "rap": "13,700",
          "low_price": "9,270",
          "high_price": "20,085"
        },
        "1.6": {
          "rap": "13,700",
          "low_price": "9,890",
          "high_price": "21,425"
        },
        "1.7": {
          "rap": "13,700",
          "low_price": "10,505",
          "high_price": "22,765"
        },
        "1.8": {
          "rap": "13,700",
          "low_price": "11,125",
          "high_price": "24,100"
        },
        "1.9": {
          "rap": "13,700",
          "low_price": "11,740",
          "high_price": "25,440"
        },
        "2.0": {
          "rap": "18,500",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.1": {
          "rap": "18,500",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "2.2": {
          "rap": "18,500",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.3": {
          "rap": "18,500",
          "low_price": "20,700",
          "high_price": "44,850"
        },
        "2.4": {
          "rap": "18,500",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "2.5": {
          "rap": "18,500",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "2.6": {
          "rap": "18,500",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.7": {
          "rap": "18,500",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "2.8": {
          "rap": "18,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.9": {
          "rap": "18,500",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.0": {
          "rap": "28,500",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.1": {
          "rap": "28,500",
          "low_price": "45,570",
          "high_price": "98,735"
        },
        "3.2": {
          "rap": "28,500",
          "low_price": "47,040",
          "high_price": "101,920"
        },
        "3.3": {
          "rap": "28,500",
          "low_price": "48,510",
          "high_price": "105,105"
        },
        "3.4": {
          "rap": "28,500",
          "low_price": "49,980",
          "high_price": "108,290"
        },
        "3.5": {
          "rap": "28,500",
          "low_price": "51,450",
          "high_price": "111,475"
        },
        "3.6": {
          "rap": "28,500",
          "low_price": "52,920",
          "high_price": "114,660"
        },
        "3.7": {
          "rap": "28,500",
          "low_price": "54,390",
          "high_price": "117,845"
        },
        "3.8": {
          "rap": "28,500",
          "low_price": "55,860",
          "high_price": "121,030"
        },
        "3.9": {
          "rap": "28,500",
          "low_price": "57,330",
          "high_price": "124,215"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,400",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "3,500",
          "low_price": "630",
          "high_price": "1,365"
        },
        "0.6": {
          "rap": "3,500",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.7": {
          "rap": "4,600",
          "low_price": "1,135",
          "high_price": "2,455"
        },
        "0.8": {
          "rap": "4,600",
          "low_price": "1,295",
          "high_price": "2,810"
        },
        "0.9": {
          "rap": "6,500",
          "low_price": "2,105",
          "high_price": "4,565"
        },
        "1.0": {
          "rap": "8,800",
          "low_price": "3,060",
          "high_price": "6,630"
        },
        "1.1": {
          "rap": "8,800",
          "low_price": "3,365",
          "high_price": "7,295"
        },
        "1.2": {
          "rap": "8,800",
          "low_price": "3,670",
          "high_price": "7,955"
        },
        "1.3": {
          "rap": "8,800",
          "low_price": "3,980",
          "high_price": "8,620"
        },
        "1.4": {
          "rap": "8,800",
          "low_price": "4,285",
          "high_price": "9,280"
        },
        "1.5": {
          "rap": "12,300",
          "low_price": "8,010",
          "high_price": "17,355"
        },
        "1.6": {
          "rap": "12,300",
          "low_price": "8,545",
          "high_price": "18,510"
        },
        "1.7": {
          "rap": "12,300",
          "low_price": "9,080",
          "high_price": "19,670"
        },
        "1.8": {
          "rap": "12,300",
          "low_price": "9,610",
          "high_price": "20,825"
        },
        "1.9": {
          "rap": "12,300",
          "low_price": "10,145",
          "high_price": "21,985"
        },
        "2.0": {
          "rap": "17,000",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.1": {
          "rap": "17,000",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "2.2": {
          "rap": "17,000",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.3": {
          "rap": "17,000",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.4": {
          "rap": "17,000",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.5": {
          "rap": "17,000",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.6": {
          "rap": "17,000",
          "low_price": "21,060",
          "high_price": "45,630"
        },
        "2.7": {
          "rap": "17,000",
          "low_price": "21,870",
          "high_price": "47,385"
        },
        "2.8": {
          "rap": "17,000",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.9": {
          "rap": "17,000",
          "low_price": "23,490",
          "high_price": "50,895"
        },
        "3.0": {
          "rap": "24,500",
          "low_price": "37,800",
          "high_price": "81,900"
        },
        "3.1": {
          "rap": "24,500",
          "low_price": "39,060",
          "high_price": "84,630"
        },
        "3.2": {
          "rap": "24,500",
          "low_price": "40,320",
          "high_price": "87,360"
        },
        "3.3": {
          "rap": "24,500",
          "low_price": "41,580",
          "high_price": "90,090"
        },
        "3.4": {
          "rap": "24,500",
          "low_price": "42,840",
          "high_price": "92,820"
        },
        "3.5": {
          "rap": "24,500",
          "low_price": "44,100",
          "high_price": "95,550"
        },
        "3.6": {
          "rap": "24,500",
          "low_price": "45,360",
          "high_price": "98,280"
        },
        "3.7": {
          "rap": "24,500",
          "low_price": "46,620",
          "high_price": "101,010"
        },
        "3.8": {
          "rap": "24,500",
          "low_price": "47,880",
          "high_price": "103,740"
        },
        "3.9": {
          "rap": "24,500",
          "low_price": "49,140",
          "high_price": "106,470"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,200",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "3,300",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "3,300",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "4,200",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.8": {
          "rap": "4,200",
          "low_price": "1,150",
          "high_price": "2,495"
        },
        "0.9": {
          "rap": "6,100",
          "low_price": "1,835",
          "high_price": "3,980"
        },
        "1.0": {
          "rap": "8,100",
          "low_price": "2,760",
          "high_price": "5,980"
        },
        "1.1": {
          "rap": "8,100",
          "low_price": "3,035",
          "high_price": "6,580"
        },
        "1.2": {
          "rap": "8,100",
          "low_price": "3,310",
          "high_price": "7,175"
        },
        "1.3": {
          "rap": "8,100",
          "low_price": "3,590",
          "high_price": "7,775"
        },
        "1.4": {
          "rap": "8,100",
          "low_price": "3,865",
          "high_price": "8,370"
        },
        "1.5": {
          "rap": "11,000",
          "low_price": "6,660",
          "high_price": "14,430"
        },
        "1.6": {
          "rap": "11,000",
          "low_price": "7,105",
          "high_price": "15,390"
        },
        "1.7": {
          "rap": "11,000",
          "low_price": "7,550",
          "high_price": "16,355"
        },
        "1.8": {
          "rap": "11,000",
          "low_price": "7,990",
          "high_price": "17,315"
        },
        "1.9": {
          "rap": "11,000",
          "low_price": "8,435",
          "high_price": "18,280"
        },
        "2.0": {
          "rap": "15,000",
          "low_price": "13,800",
          "high_price": "29,900"
        },
        "2.1": {
          "rap": "15,000",
          "low_price": "14,490",
          "high_price": "31,395"
        },
        "2.2": {
          "rap": "15,000",
          "low_price": "15,180",
          "high_price": "32,890"
        },
        "2.3": {
          "rap": "15,000",
          "low_price": "15,870",
          "high_price": "34,385"
        },
        "2.4": {
          "rap": "15,000",
          "low_price": "16,560",
          "high_price": "35,880"
        },
        "2.5": {
          "rap": "15,000",
          "low_price": "17,250",
          "high_price": "37,375"
        },
        "2.6": {
          "rap": "15,000",
          "low_price": "17,940",
          "high_price": "38,870"
        },
        "2.7": {
          "rap": "15,000",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.8": {
          "rap": "15,000",
          "low_price": "19,320",
          "high_price": "41,860"
        },
        "2.9": {
          "rap": "15,000",
          "low_price": "20,010",
          "high_price": "43,355"
        },
        "3.0": {
          "rap": "21,000",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.1": {
          "rap": "21,000",
          "low_price": "34,410",
          "high_price": "74,555"
        },
        "3.2": {
          "rap": "21,000",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.3": {
          "rap": "21,000",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.4": {
          "rap": "21,000",
          "low_price": "37,740",
          "high_price": "81,770"
        },
        "3.5": {
          "rap": "21,000",
          "low_price": "38,850",
          "high_price": "84,175"
        },
        "3.6": {
          "rap": "21,000",
          "low_price": "39,960",
          "high_price": "86,580"
        },
        "3.7": {
          "rap": "21,000",
          "low_price": "41,070",
          "high_price": "88,985"
        },
        "3.8": {
          "rap": "21,000",
          "low_price": "42,180",
          "high_price": "91,390"
        },
        "3.9": {
          "rap": "21,000",
          "low_price": "43,290",
          "high_price": "93,795"
        }
      },
      "I": {
        "0.4": {
          "rap": "2,000",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "2,800",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "2,800",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "3,500",
          "low_price": "880",
          "high_price": "1,910"
        },
        "0.8": {
          "rap": "3,500",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.9": {
          "rap": "5,400",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "6,700",
          "low_price": "2,280",
          "high_price": "4,940"
        },
        "1.1": {
          "rap": "6,700",
          "low_price": "2,510",
          "high_price": "5,435"
        },
        "1.2": {
          "rap": "6,700",
          "low_price": "2,735",
          "high_price": "5,930"
        },
        "1.3": {
          "rap": "6,700",
          "low_price": "2,965",
          "high_price": "6,420"
        },
        "1.4": {
          "rap": "6,700",
          "low_price": "3,190",
          "high_price": "6,915"
        },
        "1.5": {
          "rap": "9,300",
          "low_price": "5,670",
          "high_price": "12,285"
        },
        "1.6": {
          "rap": "9,300",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.7": {
          "rap": "9,300",
          "low_price": "6,425",
          "high_price": "13,925"
        },
        "1.8": {
          "rap": "9,300",
          "low_price": "6,805",
          "high_price": "14,740"
        },
        "1.9": {
          "rap": "9,300",
          "low_price": "7,180",
          "high_price": "15,560"
        },
        "2.0": {
          "rap": "12,500",
          "low_price": "11,160",
          "high_price": "24,180"
        },
        "2.1": {
          "rap": "12,500",
          "low_price": "11,720",
          "high_price": "25,390"
        },
        "2.2": {
          "rap": "12,500",
          "low_price": "12,275",
          "high_price": "26,600"
        },
        "2.3": {
          "rap": "12,500",
          "low_price": "12,835",
          "high_price": "27,805"
        },
        "2.4": {
          "rap": "12,500",
          "low_price": "13,390",
          "high_price": "29,015"
        },
        "2.5": {
          "rap": "12,500",
          "low_price": "13,950",
          "high_price": "30,225"
        },
        "2.6": {
          "rap": "12,500",
          "low_price": "14,510",
          "high_price": "31,435"
        },
        "2.7": {
          "rap": "12,500",
          "low_price": "15,065",
          "high_price": "32,645"
        },
        "2.8": {
          "rap": "12,500",
          "low_price": "15,625",
          "high_price": "33,850"
        },
        "2.9": {
          "rap": "12,500",
          "low_price": "16,180",
          "high_price": "35,060"
        },
        "3.0": {
          "rap": "18,000",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "3.1": {
          "rap": "18,000",
          "low_price": "29,760",
          "high_price": "64,480"
        },
        "3.2": {
          "rap": "18,000",
          "low_price": "30,720",
          "high_price": "66,560"
        },
        "3.3": {
          "rap": "18,000",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "3.4": {
          "rap": "18,000",
          "low_price": "32,640",
          "high_price": "70,720"
        },
        "3.5": {
          "rap": "18,000",
          "low_price": "33,600",
          "high_price": "72,800"
        },
        "3.6": {
          "rap": "18,000",
          "low_price": "34,560",
          "high_price": "74,880"
        },
        "3.7": {
          "rap": "18,000",
          "low_price": "35,520",
          "high_price": "76,960"
        },
        "3.8": {
          "rap": "18,000",
          "low_price": "36,480",
          "high_price": "79,040"
        },
        "3.9": {
          "rap": "18,000",
          "low_price": "37,440",
          "high_price": "81,120"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,700",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "2,300",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "2,300",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,900",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,900",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "4,600",
          "low_price": "1,405",
          "high_price": "3,040"
        },
        "1.0": {
          "rap": "5,500",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "5,500",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "5,500",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "5,500",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "5,500",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "7,900",
          "low_price": "4,770",
          "high_price": "10,335"
        },
        "1.6": {
          "rap": "7,900",
          "low_price": "5,090",
          "high_price": "11,025"
        },
        "1.7": {
          "rap": "7,900",
          "low_price": "5,405",
          "high_price": "11,715"
        },
        "1.8": {
          "rap": "7,900",
          "low_price": "5,725",
          "high_price": "12,400"
        },
        "1.9": {
          "rap": "7,900",
          "low_price": "6,040",
          "high_price": "13,090"
        },
        "2.0": {
          "rap": "10,500",
          "low_price": "9,120",
          "high_price": "19,760"
        },
        "2.1": {
          "rap": "10,500",
          "low_price": "9,575",
          "high_price": "20,750"
        },
        "2.2": {
          "rap": "10,500",
          "low_price": "10,030",
          "high_price": "21,735"
        },
        "2.3": {
          "rap": "10,500",
          "low_price": "10,490",
          "high_price": "22,725"
        },
        "2.4": {
          "rap": "10,500",
          "low_price": "10,945",
          "high_price": "23,710"
        },
        "2.5": {
          "rap": "10,500",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "2.6": {
          "rap": "10,500",
          "low_price": "11,855",
          "high_price": "25,690"
        },
        "2.7": {
          "rap": "10,500",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "2.8": {
          "rap": "10,500",
          "low_price": "12,770",
          "high_price": "27,665"
        },
        "2.9": {
          "rap": "10,500",
          "low_price": "13,225",
          "high_price": "28,650"
        },
        "3.0": {
          "rap": "15,000",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "3.1": {
          "rap": "15,000",
          "low_price": "24,180",
          "high_price": "52,390"
        },
        "3.2": {
          "rap": "15,000",
          "low_price": "24,960",
          "high_price": "54,080"
        },
        "3.3": {
          "rap": "15,000",
          "low_price": "25,740",
          "high_price": "55,770"
        },
        "3.4": {
          "rap": "15,000",
          "low_price": "26,520",
          "high_price": "57,460"
        },
        "3.5": {
          "rap": "15,000",
          "low_price": "27,300",
          "high_price": "59,150"
        },
        "3.6": {
          "rap": "15,000",
          "low_price": "28,080",
          "high_price": "60,840"
        },
        "3.7": {
          "rap": "15,000",
          "low_price": "28,860",
          "high_price": "62,530"
        },
        "3.8": {
          "rap": "15,000",
          "low_price": "29,640",
          "high_price": "64,220"
        },
        "3.9": {
          "rap": "15,000",
          "low_price": "30,420",
          "high_price": "65,910"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,500",
          "low_price": "265",
          "high_price": "570"
        },
        "0.5": {
          "rap": "1,900",
          "low_price": "360",
          "high_price": "780"
        },
        "0.6": {
          "rap": "1,900",
          "low_price": "430",
          "high_price": "935"
        },
        "0.7": {
          "rap": "2,400",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.8": {
          "rap": "2,400",
          "low_price": "770",
          "high_price": "1,665"
        },
        "0.9": {
          "rap": "3,800",
          "low_price": "1,240",
          "high_price": "2,690"
        },
        "1.0": {
          "rap": "4,500",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.1": {
          "rap": "4,500",
          "low_price": "1,780",
          "high_price": "3,860"
        },
        "1.2": {
          "rap": "4,500",
          "low_price": "1,945",
          "high_price": "4,210"
        },
        "1.3": {
          "rap": "4,500",
          "low_price": "2,105",
          "high_price": "4,565"
        },
        "1.4": {
          "rap": "4,500",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.5": {
          "rap": "6,600",
          "low_price": "3,960",
          "high_price": "8,580"
        },
        "1.6": {
          "rap": "6,600",
          "low_price": "4,225",
          "high_price": "9,150"
        },
        "1.7": {
          "rap": "6,600",
          "low_price": "4,490",
          "high_price": "9,725"
        },
        "1.8": {
          "rap": "6,600",
          "low_price": "4,750",
          "high_price": "10,295"
        },
        "1.9": {
          "rap": "6,600",
          "low_price": "5,015",
          "high_price": "10,870"
        },
        "2.0": {
          "rap": "8,600",
          "low_price": "7,560",
          "high_price": "16,380"
        },
        "2.1": {
          "rap": "8,600",
          "low_price": "7,940",
          "high_price": "17,200"
        },
        "2.2": {
          "rap": "8,600",
          "low_price": "8,315",
          "high_price": "18,020"
        },
        "2.3": {
          "rap": "8,600",
          "low_price": "8,695",
          "high_price": "18,835"
        },
        "2.4": {
          "rap": "8,600",
          "low_price": "9,070",
          "high_price": "19,655"
        },
        "2.5": {
          "rap": "8,600",
          "low_price": "9,450",
          "high_price": "20,475"
        },
        "2.6": {
          "rap": "8,600",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "2.7": {
          "rap": "8,600",
          "low_price": "10,205",
          "high_price": "22,115"
        },
        "2.8": {
          "rap": "8,600",
          "low_price": "10,585",
          "high_price": "22,930"
        },
        "2.9": {
          "rap": "8,600",
          "low_price": "10,960",
          "high_price": "23,750"
        },
        "3.0": {
          "rap": "12,000",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "3.1": {
          "rap": "12,000",
          "low_price": "20,460",
          "high_price": "44,330"
        },
        "3.2": {
          "rap": "12,000",
          "low_price": "21,120",
          "high_price": "45,760"
        },
        "3.3": {
          "rap": "12,000",
          "low_price": "21,780",
          "high_price": "47,190"
        },
        "3.4": {
          "rap": "12,000",
          "low_price": "22,440",
          "high_price": "48,620"
        },
        "3.5": {
          "rap": "12,000",
          "low_price": "23,100",
          "high_price": "50,050"
        },
        "3.6": {
          "rap": "12,000",
          "low_price": "23,760",
          "high_price": "51,480"
        },
        "3.7": {
          "rap": "12,000",
          "low_price": "24,420",
          "high_price": "52,910"
        },
        "3.8": {
          "rap": "12,000",
          "low_price": "25,080",
          "high_price": "54,340"
        },
        "3.9": {
          "rap": "12,000",
          "low_price": "25,740",
          "high_price": "55,770"
        }
      }
    },
    "VVS1": {
      "D": {
        "0.4": {
          "rap": "3,900",
          "low_price": "670",
          "high_price": "1,455"
        },
        "0.5": {
          "rap": "5,900",
          "low_price": "1,320",
          "high_price": "2,860"
        },
        "0.6": {
          "rap": "5,900",
          "low_price": "1,585",
          "high_price": "3,430"
        },
        "0.7": {
          "rap": "7,900",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "0.8": {
          "rap": "7,900",
          "low_price": "2,690",
          "high_price": "5,825"
        },
        "0.9": {
          "rap": "12,600",
          "low_price": "4,805",
          "high_price": "10,415"
        },
        "1.0": {
          "rap": "17,100",
          "low_price": "7,680",
          "high_price": "16,640"
        },
        "1.1": {
          "rap": "17,100",
          "low_price": "8,450",
          "high_price": "18,305"
        },
        "1.2": {
          "rap": "17,100",
          "low_price": "9,215",
          "high_price": "19,970"
        },
        "1.3": {
          "rap": "17,100",
          "low_price": "9,985",
          "high_price": "21,630"
        },
        "1.4": {
          "rap": "17,100",
          "low_price": "10,750",
          "high_price": "23,295"
        },
        "1.5": {
          "rap": "23,100",
          "low_price": "16,830",
          "high_price": "36,465"
        },
        "1.6": {
          "rap": "23,100",
          "low_price": "17,950",
          "high_price": "38,895"
        },
        "1.7": {
          "rap": "23,100",
          "low_price": "19,075",
          "high_price": "41,325"
        },
        "1.8": {
          "rap": "23,100",
          "low_price": "20,195",
          "high_price": "43,760"
        },
        "1.9": {
          "rap": "23,100",
          "low_price": "21,320",
          "high_price": "46,190"
        },
        "2.0": {
          "rap": "35,000",
          "low_price": "33,000",
          "high_price": "71,500"
        },
        "2.1": {
          "rap": "35,000",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "2.2": {
          "rap": "35,000",
          "low_price": "36,300",
          "high_price": "78,650"
        },
        "2.3": {
          "rap": "35,000",
          "low_price": "37,950",
          "high_price": "82,225"
        },
        "2.4": {
          "rap": "35,000",
          "low_price": "39,600",
          "high_price": "85,800"
        },
        "2.5": {
          "rap": "35,000",
          "low_price": "41,250",
          "high_price": "89,375"
        },
        "2.6": {
          "rap": "35,000",
          "low_price": "42,900",
          "high_price": "92,950"
        },
        "2.7": {
          "rap": "35,000",
          "low_price": "44,550",
          "high_price": "96,525"
        },
        "2.8": {
          "rap": "35,000",
          "low_price": "46,200",
          "high_price": "100,100"
        },
        "2.9": {
          "rap": "35,000",
          "low_price": "47,850",
          "high_price": "103,675"
        },
        "3.0": {
          "rap": "56,000",
          "low_price": "82,800",
          "high_price": "179,400"
        },
        "3.1": {
          "rap": "56,000",
          "low_price": "85,560",
          "high_price": "185,380"
        },
        "3.2": {
          "rap": "56,000",
          "low_price": "88,320",
          "high_price": "191,360"
        },
        "3.3": {
          "rap": "56,000",
          "low_price": "91,080",
          "high_price": "197,340"
        },
        "3.4": {
          "rap": "56,000",
          "low_price": "93,840",
          "high_price": "203,320"
        },
        "3.5": {
          "rap": "56,000",
          "low_price": "96,600",
          "high_price": "209,300"
        },
        "3.6": {
          "rap": "56,000",
          "low_price": "99,360",
          "high_price": "215,280"
        },
        "3.7": {
          "rap": "56,000",
          "low_price": "102,120",
          "high_price": "221,260"
        },
        "3.8": {
          "rap": "56,000",
          "low_price": "104,880",
          "high_price": "227,240"
        },
        "3.9": {
          "rap": "56,000",
          "low_price": "107,640",
          "high_price": "233,220"
        }
      },
      "E": {
        "0.4": {
          "rap": "3,700",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.5": {
          "rap": "5,300",
          "low_price": "1,140",
          "high_price": "2,470"
        },
        "0.6": {
          "rap": "5,300",
          "low_price": "1,370",
          "high_price": "2,965"
        },
        "0.7": {
          "rap": "7,300",
          "low_price": "2,060",
          "high_price": "4,460"
        },
        "0.8": {
          "rap": "7,300",
          "low_price": "2,350",
          "high_price": "5,095"
        },
        "0.9": {
          "rap": "11,600",
          "low_price": "4,160",
          "high_price": "9,010"
        },
        "1.0": {
          "rap": "15,000",
          "low_price": "6,660",
          "high_price": "14,430"
        },
        "1.1": {
          "rap": "15,000",
          "low_price": "7,325",
          "high_price": "15,875"
        },
        "1.2": {
          "rap": "15,000",
          "low_price": "7,990",
          "high_price": "17,315"
        },
        "1.3": {
          "rap": "15,000",
          "low_price": "8,660",
          "high_price": "18,760"
        },
        "1.4": {
          "rap": "15,000",
          "low_price": "9,325",
          "high_price": "20,200"
        },
        "1.5": {
          "rap": "21,100",
          "low_price": "15,570",
          "high_price": "33,735"
        },
        "1.6": {
          "rap": "21,100",
          "low_price": "16,610",
          "high_price": "35,985"
        },
        "1.7": {
          "rap": "21,100",
          "low_price": "17,645",
          "high_price": "38,235"
        },
        "1.8": {
          "rap": "21,100",
          "low_price": "18,685",
          "high_price": "40,480"
        },
        "1.9": {
          "rap": "21,100",
          "low_price": "19,720",
          "high_price": "42,730"
        },
        "2.0": {
          "rap": "31,000",
          "low_price": "29,400",
          "high_price": "63,700"
        },
        "2.1": {
          "rap": "31,000",
          "low_price": "30,870",
          "high_price": "66,885"
        },
        "2.2": {
          "rap": "31,000",
          "low_price": "32,340",
          "high_price": "70,070"
        },
        "2.3": {
          "rap": "31,000",
          "low_price": "33,810",
          "high_price": "73,255"
        },
        "2.4": {
          "rap": "31,000",
          "low_price": "35,280",
          "high_price": "76,440"
        },
        "2.5": {
          "rap": "31,000",
          "low_price": "36,750",
          "high_price": "79,625"
        },
        "2.6": {
          "rap": "31,000",
          "low_price": "38,220",
          "high_price": "82,810"
        },
        "2.7": {
          "rap": "31,000",
          "low_price": "39,690",
          "high_price": "85,995"
        },
        "2.8": {
          "rap": "31,000",
          "low_price": "41,160",
          "high_price": "89,180"
        },
        "2.9": {
          "rap": "31,000",
          "low_price": "42,630",
          "high_price": "92,365"
        },
        "3.0": {
          "rap": "49,500",
          "low_price": "75,600",
          "high_price": "163,800"
        },
        "3.1": {
          "rap": "49,500",
          "low_price": "78,120",
          "high_price": "169,260"
        },
        "3.2": {
          "rap": "49,500",
          "low_price": "80,640",
          "high_price": "174,720"
        },
        "3.3": {
          "rap": "49,500",
          "low_price": "83,160",
          "high_price": "180,180"
        },
        "3.4": {
          "rap": "49,500",
          "low_price": "85,680",
          "high_price": "185,640"
        },
        "3.5": {
          "rap": "49,500",
          "low_price": "88,200",
          "high_price": "191,100"
        },
        "3.6": {
          "rap": "49,500",
          "low_price": "90,720",
          "high_price": "196,560"
        },
        "3.7": {
          "rap": "49,500",
          "low_price": "93,240",
          "high_price": "202,020"
        },
        "3.8": {
          "rap": "49,500",
          "low_price": "95,760",
          "high_price": "207,480"
        },
        "3.9": {
          "rap": "49,500",
          "low_price": "98,280",
          "high_price": "212,940"
        }
      },
      "F": {
        "0.4": {
          "rap": "3,400",
          "low_price": "550",
          "high_price": "1,195"
        },
        "0.5": {
          "rap": "4,700",
          "low_price": "990",
          "high_price": "2,145"
        },
        "0.6": {
          "rap": "4,700",
          "low_price": "1,190",
          "high_price": "2,575"
        },
        "0.7": {
          "rap": "6,800",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "0.8": {
          "rap": "6,800",
          "low_price": "2,110",
          "high_price": "4,575"
        },
        "0.9": {
          "rap": "10,700",
          "low_price": "3,835",
          "high_price": "8,305"
        },
        "1.0": {
          "rap": "13,700",
          "low_price": "5,820",
          "high_price": "12,610"
        },
        "1.1": {
          "rap": "13,700",
          "low_price": "6,400",
          "high_price": "13,870"
        },
        "1.2": {
          "rap": "13,700",
          "low_price": "6,985",
          "high_price": "15,130"
        },
        "1.3": {
          "rap": "13,700",
          "low_price": "7,565",
          "high_price": "16,395"
        },
        "1.4": {
          "rap": "13,700",
          "low_price": "8,150",
          "high_price": "17,655"
        },
        "1.5": {
          "rap": "18,800",
          "low_price": "13,770",
          "high_price": "29,835"
        },
        "1.6": {
          "rap": "18,800",
          "low_price": "14,690",
          "high_price": "31,825"
        },
        "1.7": {
          "rap": "18,800",
          "low_price": "15,605",
          "high_price": "33,815"
        },
        "1.8": {
          "rap": "18,800",
          "low_price": "16,525",
          "high_price": "35,800"
        },
        "1.9": {
          "rap": "18,800",
          "low_price": "17,440",
          "high_price": "37,790"
        },
        "2.0": {
          "rap": "27,500",
          "low_price": "26,400",
          "high_price": "57,200"
        },
        "2.1": {
          "rap": "27,500",
          "low_price": "27,720",
          "high_price": "60,060"
        },
        "2.2": {
          "rap": "27,500",
          "low_price": "29,040",
          "high_price": "62,920"
        },
        "2.3": {
          "rap": "27,500",
          "low_price": "30,360",
          "high_price": "65,780"
        },
        "2.4": {
          "rap": "27,500",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "2.5": {
          "rap": "27,500",
          "low_price": "33,000",
          "high_price": "71,500"
        },
        "2.6": {
          "rap": "27,500",
          "low_price": "34,320",
          "high_price": "74,360"
        },
        "2.7": {
          "rap": "27,500",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "2.8": {
          "rap": "27,500",
          "low_price": "36,960",
          "high_price": "80,080"
        },
        "2.9": {
          "rap": "27,500",
          "low_price": "38,280",
          "high_price": "82,940"
        },
        "3.0": {
          "rap": "42,500",
          "low_price": "67,500",
          "high_price": "146,250"
        },
        "3.1": {
          "rap": "42,500",
          "low_price": "69,750",
          "high_price": "151,125"
        },
        "3.2": {
          "rap": "42,500",
          "low_price": "72,000",
          "high_price": "156,000"
        },
        "3.3": {
          "rap": "42,500",
          "low_price": "74,250",
          "high_price": "160,875"
        },
        "3.4": {
          "rap": "42,500",
          "low_price": "76,500",
          "high_price": "165,750"
        },
        "3.5": {
          "rap": "42,500",
          "low_price": "78,750",
          "high_price": "170,625"
        },
        "3.6": {
          "rap": "42,500",
          "low_price": "81,000",
          "high_price": "175,500"
        },
        "3.7": {
          "rap": "42,500",
          "low_price": "83,250",
          "high_price": "180,375"
        },
        "3.8": {
          "rap": "42,500",
          "low_price": "85,500",
          "high_price": "185,250"
        },
        "3.9": {
          "rap": "42,500",
          "low_price": "87,750",
          "high_price": "190,125"
        }
      },
      "G": {
        "0.4": {
          "rap": "3,000",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.5": {
          "rap": "4,200",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.6": {
          "rap": "4,200",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.7": {
          "rap": "5,900",
          "low_price": "1,555",
          "high_price": "3,365"
        },
        "0.8": {
          "rap": "5,900",
          "low_price": "1,775",
          "high_price": "3,850"
        },
        "0.9": {
          "rap": "8,900",
          "low_price": "3,080",
          "high_price": "6,670"
        },
        "1.0": {
          "rap": "11,900",
          "low_price": "4,440",
          "high_price": "9,620"
        },
        "1.1": {
          "rap": "11,900",
          "low_price": "4,885",
          "high_price": "10,580"
        },
        "1.2": {
          "rap": "11,900",
          "low_price": "5,330",
          "high_price": "11,545"
        },
        "1.3": {
          "rap": "11,900",
          "low_price": "5,770",
          "high_price": "12,505"
        },
        "1.4": {
          "rap": "11,900",
          "low_price": "6,215",
          "high_price": "13,470"
        },
        "1.5": {
          "rap": "16,000",
          "low_price": "11,340",
          "high_price": "24,570"
        },
        "1.6": {
          "rap": "16,000",
          "low_price": "12,095",
          "high_price": "26,210"
        },
        "1.7": {
          "rap": "16,000",
          "low_price": "12,850",
          "high_price": "27,845"
        },
        "1.8": {
          "rap": "16,000",
          "low_price": "13,610",
          "high_price": "29,485"
        },
        "1.9": {
          "rap": "16,000",
          "low_price": "14,365",
          "high_price": "31,120"
        },
        "2.0": {
          "rap": "23,000",
          "low_price": "22,200",
          "high_price": "48,100"
        },
        "2.1": {
          "rap": "23,000",
          "low_price": "23,310",
          "high_price": "50,505"
        },
        "2.2": {
          "rap": "23,000",
          "low_price": "24,420",
          "high_price": "52,910"
        },
        "2.3": {
          "rap": "23,000",
          "low_price": "25,530",
          "high_price": "55,315"
        },
        "2.4": {
          "rap": "23,000",
          "low_price": "26,640",
          "high_price": "57,720"
        },
        "2.5": {
          "rap": "23,000",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "2.6": {
          "rap": "23,000",
          "low_price": "28,860",
          "high_price": "62,530"
        },
        "2.7": {
          "rap": "23,000",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "2.8": {
          "rap": "23,000",
          "low_price": "31,080",
          "high_price": "67,340"
        },
        "2.9": {
          "rap": "23,000",
          "low_price": "32,190",
          "high_price": "69,745"
        },
        "3.0": {
          "rap": "35,500",
          "low_price": "56,700",
          "high_price": "122,850"
        },
        "3.1": {
          "rap": "35,500",
          "low_price": "58,590",
          "high_price": "126,945"
        },
        "3.2": {
          "rap": "35,500",
          "low_price": "60,480",
          "high_price": "131,040"
        },
        "3.3": {
          "rap": "35,500",
          "low_price": "62,370",
          "high_price": "135,135"
        },
        "3.4": {
          "rap": "35,500",
          "low_price": "64,260",
          "high_price": "139,230"
        },
        "3.5": {
          "rap": "35,500",
          "low_price": "66,150",
          "high_price": "143,325"
        },
        "3.6": {
          "rap": "35,500",
          "low_price": "68,040",
          "high_price": "147,420"
        },
        "3.7": {
          "rap": "35,500",
          "low_price": "69,930",
          "high_price": "151,515"
        },
        "3.8": {
          "rap": "35,500",
          "low_price": "71,820",
          "high_price": "155,610"
        },
        "3.9": {
          "rap": "35,500",
          "low_price": "73,710",
          "high_price": "159,705"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,600",
          "low_price": "430",
          "high_price": "935"
        },
        "0.5": {
          "rap": "3,800",
          "low_price": "690",
          "high_price": "1,495"
        },
        "0.6": {
          "rap": "3,800",
          "low_price": "830",
          "high_price": "1,795"
        },
        "0.7": {
          "rap": "5,100",
          "low_price": "1,260",
          "high_price": "2,730"
        },
        "0.8": {
          "rap": "5,100",
          "low_price": "1,440",
          "high_price": "3,120"
        },
        "0.9": {
          "rap": "7,600",
          "low_price": "2,485",
          "high_price": "5,380"
        },
        "1.0": {
          "rap": "10,100",
          "low_price": "3,360",
          "high_price": "7,280"
        },
        "1.1": {
          "rap": "10,100",
          "low_price": "3,695",
          "high_price": "8,010"
        },
        "1.2": {
          "rap": "10,100",
          "low_price": "4,030",
          "high_price": "8,735"
        },
        "1.3": {
          "rap": "10,100",
          "low_price": "4,370",
          "high_price": "9,465"
        },
        "1.4": {
          "rap": "10,100",
          "low_price": "4,705",
          "high_price": "10,190"
        },
        "1.5": {
          "rap": "13,600",
          "low_price": "9,000",
          "high_price": "19,500"
        },
        "1.6": {
          "rap": "13,600",
          "low_price": "9,600",
          "high_price": "20,800"
        },
        "1.7": {
          "rap": "13,600",
          "low_price": "10,200",
          "high_price": "22,100"
        },
        "1.8": {
          "rap": "13,600",
          "low_price": "10,800",
          "high_price": "23,400"
        },
        "1.9": {
          "rap": "13,600",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "2.0": {
          "rap": "19,500",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.1": {
          "rap": "19,500",
          "low_price": "18,900",
          "high_price": "40,950"
        },
        "2.2": {
          "rap": "19,500",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.3": {
          "rap": "19,500",
          "low_price": "20,700",
          "high_price": "44,850"
        },
        "2.4": {
          "rap": "19,500",
          "low_price": "21,600",
          "high_price": "46,800"
        },
        "2.5": {
          "rap": "19,500",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "2.6": {
          "rap": "19,500",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.7": {
          "rap": "19,500",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "2.8": {
          "rap": "19,500",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.9": {
          "rap": "19,500",
          "low_price": "26,100",
          "high_price": "56,550"
        },
        "3.0": {
          "rap": "28,500",
          "low_price": "45,000",
          "high_price": "97,500"
        },
        "3.1": {
          "rap": "28,500",
          "low_price": "46,500",
          "high_price": "100,750"
        },
        "3.2": {
          "rap": "28,500",
          "low_price": "48,000",
          "high_price": "104,000"
        },
        "3.3": {
          "rap": "28,500",
          "low_price": "49,500",
          "high_price": "107,250"
        },
        "3.4": {
          "rap": "28,500",
          "low_price": "51,000",
          "high_price": "110,500"
        },
        "3.5": {
          "rap": "28,500",
          "low_price": "52,500",
          "high_price": "113,750"
        },
        "3.6": {
          "rap": "28,500",
          "low_price": "54,000",
          "high_price": "117,000"
        },
        "3.7": {
          "rap": "28,500",
          "low_price": "55,500",
          "high_price": "120,250"
        },
        "3.8": {
          "rap": "28,500",
          "low_price": "57,000",
          "high_price": "123,500"
        },
        "3.9": {
          "rap": "28,500",
          "low_price": "58,500",
          "high_price": "126,750"
        }
      },
      "I": {
        "0.4": {
          "rap": "2,300",
          "low_price": "385",
          "high_price": "830"
        },
        "0.5": {
          "rap": "3,200",
          "low_price": "600",
          "high_price": "1,300"
        },
        "0.6": {
          "rap": "3,200",
          "low_price": "720",
          "high_price": "1,560"
        },
        "0.7": {
          "rap": "4,300",
          "low_price": "1,090",
          "high_price": "2,365"
        },
        "0.8": {
          "rap": "4,300",
          "low_price": "1,250",
          "high_price": "2,705"
        },
        "0.9": {
          "rap": "6,500",
          "low_price": "2,215",
          "high_price": "4,795"
        },
        "1.0": {
          "rap": "8,300",
          "low_price": "2,820",
          "high_price": "6,110"
        },
        "1.1": {
          "rap": "8,300",
          "low_price": "3,100",
          "high_price": "6,720"
        },
        "1.2": {
          "rap": "8,300",
          "low_price": "3,385",
          "high_price": "7,330"
        },
        "1.3": {
          "rap": "8,300",
          "low_price": "3,665",
          "high_price": "7,945"
        },
        "1.4": {
          "rap": "8,300",
          "low_price": "3,950",
          "high_price": "8,555"
        },
        "1.5": {
          "rap": "11,300",
          "low_price": "7,290",
          "high_price": "15,795"
        },
        "1.6": {
          "rap": "11,300",
          "low_price": "7,775",
          "high_price": "16,850"
        },
        "1.7": {
          "rap": "11,300",
          "low_price": "8,260",
          "high_price": "17,900"
        },
        "1.8": {
          "rap": "11,300",
          "low_price": "8,750",
          "high_price": "18,955"
        },
        "1.9": {
          "rap": "11,300",
          "low_price": "9,235",
          "high_price": "20,005"
        },
        "2.0": {
          "rap": "16,000",
          "low_price": "14,400",
          "high_price": "31,200"
        },
        "2.1": {
          "rap": "16,000",
          "low_price": "15,120",
          "high_price": "32,760"
        },
        "2.2": {
          "rap": "16,000",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "2.3": {
          "rap": "16,000",
          "low_price": "16,560",
          "high_price": "35,880"
        },
        "2.4": {
          "rap": "16,000",
          "low_price": "17,280",
          "high_price": "37,440"
        },
        "2.5": {
          "rap": "16,000",
          "low_price": "18,000",
          "high_price": "39,000"
        },
        "2.6": {
          "rap": "16,000",
          "low_price": "18,720",
          "high_price": "40,560"
        },
        "2.7": {
          "rap": "16,000",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.8": {
          "rap": "16,000",
          "low_price": "20,160",
          "high_price": "43,680"
        },
        "2.9": {
          "rap": "16,000",
          "low_price": "20,880",
          "high_price": "45,240"
        },
        "3.0": {
          "rap": "23,000",
          "low_price": "36,900",
          "high_price": "79,950"
        },
        "3.1": {
          "rap": "23,000",
          "low_price": "38,130",
          "high_price": "82,615"
        },
        "3.2": {
          "rap": "23,000",
          "low_price": "39,360",
          "high_price": "85,280"
        },
        "3.3": {
          "rap": "23,000",
          "low_price": "40,590",
          "high_price": "87,945"
        },
        "3.4": {
          "rap": "23,000",
          "low_price": "41,820",
          "high_price": "90,610"
        },
        "3.5": {
          "rap": "23,000",
          "low_price": "43,050",
          "high_price": "93,275"
        },
        "3.6": {
          "rap": "23,000",
          "low_price": "44,280",
          "high_price": "95,940"
        },
        "3.7": {
          "rap": "23,000",
          "low_price": "45,510",
          "high_price": "98,605"
        },
        "3.8": {
          "rap": "23,000",
          "low_price": "46,740",
          "high_price": "101,270"
        },
        "3.9": {
          "rap": "23,000",
          "low_price": "47,970",
          "high_price": "103,935"
        }
      },
      "J": {
        "0.4": {
          "rap": "2,000",
          "low_price": "335",
          "high_price": "730"
        },
        "0.5": {
          "rap": "2,600",
          "low_price": "510",
          "high_price": "1,105"
        },
        "0.6": {
          "rap": "2,600",
          "low_price": "610",
          "high_price": "1,325"
        },
        "0.7": {
          "rap": "3,600",
          "low_price": "925",
          "high_price": "2,000"
        },
        "0.8": {
          "rap": "3,600",
          "low_price": "1,055",
          "high_price": "2,290"
        },
        "0.9": {
          "rap": "5,500",
          "low_price": "1,835",
          "high_price": "3,980"
        },
        "1.0": {
          "rap": "6,800",
          "low_price": "2,340",
          "high_price": "5,070"
        },
        "1.1": {
          "rap": "6,800",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.2": {
          "rap": "6,800",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.3": {
          "rap": "6,800",
          "low_price": "3,040",
          "high_price": "6,590"
        },
        "1.4": {
          "rap": "6,800",
          "low_price": "3,275",
          "high_price": "7,100"
        },
        "1.5": {
          "rap": "9,400",
          "low_price": "6,030",
          "high_price": "13,065"
        },
        "1.6": {
          "rap": "9,400",
          "low_price": "6,430",
          "high_price": "13,935"
        },
        "1.7": {
          "rap": "9,400",
          "low_price": "6,835",
          "high_price": "14,805"
        },
        "1.8": {
          "rap": "9,400",
          "low_price": "7,235",
          "high_price": "15,680"
        },
        "1.9": {
          "rap": "9,400",
          "low_price": "7,640",
          "high_price": "16,550"
        },
        "2.0": {
          "rap": "13,200",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "2.1": {
          "rap": "13,200",
          "low_price": "12,475",
          "high_price": "27,025"
        },
        "2.2": {
          "rap": "13,200",
          "low_price": "13,070",
          "high_price": "28,315"
        },
        "2.3": {
          "rap": "13,200",
          "low_price": "13,660",
          "high_price": "29,600"
        },
        "2.4": {
          "rap": "13,200",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "2.5": {
          "rap": "13,200",
          "low_price": "14,850",
          "high_price": "32,175"
        },
        "2.6": {
          "rap": "13,200",
          "low_price": "15,445",
          "high_price": "33,460"
        },
        "2.7": {
          "rap": "13,200",
          "low_price": "16,040",
          "high_price": "34,750"
        },
        "2.8": {
          "rap": "13,200",
          "low_price": "16,630",
          "high_price": "36,035"
        },
        "2.9": {
          "rap": "13,200",
          "low_price": "17,225",
          "high_price": "37,325"
        },
        "3.0": {
          "rap": "18,500",
          "low_price": "29,700",
          "high_price": "64,350"
        },
        "3.1": {
          "rap": "18,500",
          "low_price": "30,690",
          "high_price": "66,495"
        },
        "3.2": {
          "rap": "18,500",
          "low_price": "31,680",
          "high_price": "68,640"
        },
        "3.3": {
          "rap": "18,500",
          "low_price": "32,670",
          "high_price": "70,785"
        },
        "3.4": {
          "rap": "18,500",
          "low_price": "33,660",
          "high_price": "72,930"
        },
        "3.5": {
          "rap": "18,500",
          "low_price": "34,650",
          "high_price": "75,075"
        },
        "3.6": {
          "rap": "18,500",
          "low_price": "35,640",
          "high_price": "77,220"
        },
        "3.7": {
          "rap": "18,500",
          "low_price": "36,630",
          "high_price": "79,365"
        },
        "3.8": {
          "rap": "18,500",
          "low_price": "37,620",
          "high_price": "81,510"
        },
        "3.9": {
          "rap": "18,500",
          "low_price": "38,610",
          "high_price": "83,655"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,800",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "2,200",
          "low_price": "450",
          "high_price": "975"
        },
        "0.6": {
          "rap": "2,200",
          "low_price": "540",
          "high_price": "1,170"
        },
        "0.7": {
          "rap": "3,000",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "3,000",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "4,600",
          "low_price": "1,620",
          "high_price": "3,510"
        },
        "1.0": {
          "rap": "5,500",
          "low_price": "1,980",
          "high_price": "4,290"
        },
        "1.1": {
          "rap": "5,500",
          "low_price": "2,180",
          "high_price": "4,720"
        },
        "1.2": {
          "rap": "5,500",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.3": {
          "rap": "5,500",
          "low_price": "2,575",
          "high_price": "5,575"
        },
        "1.4": {
          "rap": "5,500",
          "low_price": "2,770",
          "high_price": "6,005"
        },
        "1.5": {
          "rap": "7,800",
          "low_price": "5,040",
          "high_price": "10,920"
        },
        "1.6": {
          "rap": "7,800",
          "low_price": "5,375",
          "high_price": "11,650"
        },
        "1.7": {
          "rap": "7,800",
          "low_price": "5,710",
          "high_price": "12,375"
        },
        "1.8": {
          "rap": "7,800",
          "low_price": "6,050",
          "high_price": "13,105"
        },
        "1.9": {
          "rap": "7,800",
          "low_price": "6,385",
          "high_price": "13,830"
        },
        "2.0": {
          "rap": "10,800",
          "low_price": "9,960",
          "high_price": "21,580"
        },
        "2.1": {
          "rap": "10,800",
          "low_price": "10,460",
          "high_price": "22,660"
        },
        "2.2": {
          "rap": "10,800",
          "low_price": "10,955",
          "high_price": "23,740"
        },
        "2.3": {
          "rap": "10,800",
          "low_price": "11,455",
          "high_price": "24,815"
        },
        "2.4": {
          "rap": "10,800",
          "low_price": "11,950",
          "high_price": "25,895"
        },
        "2.5": {
          "rap": "10,800",
          "low_price": "12,450",
          "high_price": "26,975"
        },
        "2.6": {
          "rap": "10,800",
          "low_price": "12,950",
          "high_price": "28,055"
        },
        "2.7": {
          "rap": "10,800",
          "low_price": "13,445",
          "high_price": "29,135"
        },
        "2.8": {
          "rap": "10,800",
          "low_price": "13,945",
          "high_price": "30,210"
        },
        "2.9": {
          "rap": "10,800",
          "low_price": "14,440",
          "high_price": "31,290"
        },
        "3.0": {
          "rap": "15,000",
          "low_price": "24,300",
          "high_price": "52,650"
        },
        "3.1": {
          "rap": "15,000",
          "low_price": "25,110",
          "high_price": "54,405"
        },
        "3.2": {
          "rap": "15,000",
          "low_price": "25,920",
          "high_price": "56,160"
        },
        "3.3": {
          "rap": "15,000",
          "low_price": "26,730",
          "high_price": "57,915"
        },
        "3.4": {
          "rap": "15,000",
          "low_price": "27,540",
          "high_price": "59,670"
        },
        "3.5": {
          "rap": "15,000",
          "low_price": "28,350",
          "high_price": "61,425"
        },
        "3.6": {
          "rap": "15,000",
          "low_price": "29,160",
          "high_price": "63,180"
        },
        "3.7": {
          "rap": "15,000",
          "low_price": "29,970",
          "high_price": "64,935"
        },
        "3.8": {
          "rap": "15,000",
          "low_price": "30,780",
          "high_price": "66,690"
        },
        "3.9": {
          "rap": "15,000",
          "low_price": "31,590",
          "high_price": "68,445"
        }
      }
    },
    "VVS2": {
      "D": {
        "0.4": {
          "rap": "3,500",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.5": {
          "rap": "4,800",
          "low_price": "1,020",
          "high_price": "2,210"
        },
        "0.6": {
          "rap": "4,800",
          "low_price": "1,225",
          "high_price": "2,650"
        },
        "0.7": {
          "rap": "6,800",
          "low_price": "1,850",
          "high_price": "4,005"
        },
        "0.8": {
          "rap": "6,800",
          "low_price": "2,110",
          "high_price": "4,575"
        },
        "0.9": {
          "rap": "10,400",
          "low_price": "3,620",
          "high_price": "7,840"
        },
        "1.0": {
          "rap": "14,200",
          "low_price": "5,820",
          "high_price": "12,610"
        },
        "1.1": {
          "rap": "14,200",
          "low_price": "6,400",
          "high_price": "13,870"
        },
        "1.2": {
          "rap": "14,200",
          "low_price": "6,985",
          "high_price": "15,130"
        },
        "1.3": {
          "rap": "14,200",
          "low_price": "7,565",
          "high_price": "16,395"
        },
        "1.4": {
          "rap": "14,200",
          "low_price": "8,150",
          "high_price": "17,655"
        },
        "1.5": {
          "rap": "20,100",
          "low_price": "13,860",
          "high_price": "30,030"
        },
        "1.6": {
          "rap": "20,100",
          "low_price": "14,785",
          "high_price": "32,030"
        },
        "1.7": {
          "rap": "20,100",
          "low_price": "15,710",
          "high_price": "34,035"
        },
        "1.8": {
          "rap": "20,100",
          "low_price": "16,630",
          "high_price": "36,035"
        },
        "1.9": {
          "rap": "20,100",
          "low_price": "17,555",
          "high_price": "38,040"
        },
        "2.0": {
          "rap": "29,500",
          "low_price": "28,200",
          "high_price": "61,100"
        },
        "2.1": {
          "rap": "29,500",
          "low_price": "29,610",
          "high_price": "64,155"
        },
        "2.2": {
          "rap": "29,500",
          "low_price": "31,020",
          "high_price": "67,210"
        },
        "2.3": {
          "rap": "29,500",
          "low_price": "32,430",
          "high_price": "70,265"
        },
        "2.4": {
          "rap": "29,500",
          "low_price": "33,840",
          "high_price": "73,320"
        },
        "2.5": {
          "rap": "29,500",
          "low_price": "35,250",
          "high_price": "76,375"
        },
        "2.6": {
          "rap": "29,500",
          "low_price": "36,660",
          "high_price": "79,430"
        },
        "2.7": {
          "rap": "29,500",
          "low_price": "38,070",
          "high_price": "82,485"
        },
        "2.8": {
          "rap": "29,500",
          "low_price": "39,480",
          "high_price": "85,540"
        },
        "2.9": {
          "rap": "29,500",
          "low_price": "40,890",
          "high_price": "88,595"
        },
        "3.0": {
          "rap": "48,000",
          "low_price": "73,800",
          "high_price": "159,900"
        },
        "3.1": {
          "rap": "48,000",
          "low_price": "76,260",
          "high_price": "165,230"
        },
        "3.2": {
          "rap": "48,000",
          "low_price": "78,720",
          "high_price": "170,560"
        },
        "3.3": {
          "rap": "48,000",
          "low_price": "81,180",
          "high_price": "175,890"
        },
        "3.4": {
          "rap": "48,000",
          "low_price": "83,640",
          "high_price": "181,220"
        },
        "3.5": {
          "rap": "48,000",
          "low_price": "86,100",
          "high_price": "186,550"
        },
        "3.6": {
          "rap": "48,000",
          "low_price": "88,560",
          "high_price": "191,880"
        },
        "3.7": {
          "rap": "48,000",
          "low_price": "91,020",
          "high_price": "197,210"
        },
        "3.8": {
          "rap": "48,000",
          "low_price": "93,480",
          "high_price": "202,540"
        },
        "3.9": {
          "rap": "48,000",
          "low_price": "95,940",
          "high_price": "207,870"
        }
      },
      "E": {
        "0.4": {
          "rap": "3,300",
          "low_price": "530",
          "high_price": "1,145"
        },
        "0.5": {
          "rap": "4,500",
          "low_price": "930",
          "high_price": "2,015"
        },
        "0.6": {
          "rap": "4,500",
          "low_price": "1,115",
          "high_price": "2,420"
        },
        "0.7": {
          "rap": "6,300",
          "low_price": "1,720",
          "high_price": "3,730"
        },
        "0.8": {
          "rap": "6,300",
          "low_price": "1,970",
          "high_price": "4,265"
        },
        "0.9": {
          "rap": "9,800",
          "low_price": "3,350",
          "high_price": "7,255"
        },
        "1.0": {
          "rap": "13,200",
          "low_price": "5,280",
          "high_price": "11,440"
        },
        "1.1": {
          "rap": "13,200",
          "low_price": "5,810",
          "high_price": "12,585"
        },
        "1.2": {
          "rap": "13,200",
          "low_price": "6,335",
          "high_price": "13,730"
        },
        "1.3": {
          "rap": "13,200",
          "low_price": "6,865",
          "high_price": "14,870"
        },
        "1.4": {
          "rap": "13,200",
          "low_price": "7,390",
          "high_price": "16,015"
        },
        "1.5": {
          "rap": "18,700",
          "low_price": "12,870",
          "high_price": "27,885"
        },
        "1.6": {
          "rap": "18,700",
          "low_price": "13,730",
          "high_price": "29,745"
        },
        "1.7": {
          "rap": "18,700",
          "low_price": "14,585",
          "high_price": "31,605"
        },
        "1.8": {
          "rap": "18,700",
          "low_price": "15,445",
          "high_price": "33,460"
        },
        "1.9": {
          "rap": "18,700",
          "low_price": "16,300",
          "high_price": "35,320"
        },
        "2.0": {
          "rap": "27,000",
          "low_price": "25,200",
          "high_price": "54,600"
        },
        "2.1": {
          "rap": "27,000",
          "low_price": "26,460",
          "high_price": "57,330"
        },
        "2.2": {
          "rap": "27,000",
          "low_price": "27,720",
          "high_price": "60,060"
        },
        "2.3": {
          "rap": "27,000",
          "low_price": "28,980",
          "high_price": "62,790"
        },
        "2.4": {
          "rap": "27,000",
          "low_price": "30,240",
          "high_price": "65,520"
        },
        "2.5": {
          "rap": "27,000",
          "low_price": "31,500",
          "high_price": "68,250"
        },
        "2.6": {
          "rap": "27,000",
          "low_price": "32,760",
          "high_price": "70,980"
        },
        "2.7": {
          "rap": "27,000",
          "low_price": "34,020",
          "high_price": "73,710"
        },
        "2.8": {
          "rap": "27,000",
          "low_price": "35,280",
          "high_price": "76,440"
        },
        "2.9": {
          "rap": "27,000",
          "low_price": "36,540",
          "high_price": "79,170"
        },
        "3.0": {
          "rap": "43,000",
          "low_price": "66,600",
          "high_price": "144,300"
        },
        "3.1": {
          "rap": "43,000",
          "low_price": "68,820",
          "high_price": "149,110"
        },
        "3.2": {
          "rap": "43,000",
          "low_price": "71,040",
          "high_price": "153,920"
        },
        "3.3": {
          "rap": "43,000",
          "low_price": "73,260",
          "high_price": "158,730"
        },
        "3.4": {
          "rap": "43,000",
          "low_price": "75,480",
          "high_price": "163,540"
        },
        "3.5": {
          "rap": "43,000",
          "low_price": "77,700",
          "high_price": "168,350"
        },
        "3.6": {
          "rap": "43,000",
          "low_price": "79,920",
          "high_price": "173,160"
        },
        "3.7": {
          "rap": "43,000",
          "low_price": "82,140",
          "high_price": "177,970"
        },
        "3.8": {
          "rap": "43,000",
          "low_price": "84,360",
          "high_price": "182,780"
        },
        "3.9": {
          "rap": "43,000",
          "low_price": "86,580",
          "high_price": "187,590"
        }
      },
      "F": {
        "0.4": {
          "rap": "3,100",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.5": {
          "rap": "4,200",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.6": {
          "rap": "4,200",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.7": {
          "rap": "5,900",
          "low_price": "1,640",
          "high_price": "3,550"
        },
        "0.8": {
          "rap": "5,900",
          "low_price": "1,870",
          "high_price": "4,055"
        },
        "0.9": {
          "rap": "9,200",
          "low_price": "3,080",
          "high_price": "6,670"
        },
        "1.0": {
          "rap": "12,200",
          "low_price": "4,800",
          "high_price": "10,400"
        },
        "1.1": {
          "rap": "12,200",
          "low_price": "5,280",
          "high_price": "11,440"
        },
        "1.2": {
          "rap": "12,200",
          "low_price": "5,760",
          "high_price": "12,480"
        },
        "1.3": {
          "rap": "12,200",
          "low_price": "6,240",
          "high_price": "13,520"
        },
        "1.4": {
          "rap": "12,200",
          "low_price": "6,720",
          "high_price": "14,560"
        },
        "1.5": {
          "rap": "16,800",
          "low_price": "11,880",
          "high_price": "25,740"
        },
        "1.6": {
          "rap": "16,800",
          "low_price": "12,670",
          "high_price": "27,455"
        },
        "1.7": {
          "rap": "16,800",
          "low_price": "13,465",
          "high_price": "29,170"
        },
        "1.8": {
          "rap": "16,800",
          "low_price": "14,255",
          "high_price": "30,890"
        },
        "1.9": {
          "rap": "16,800",
          "low_price": "15,050",
          "high_price": "32,605"
        },
        "2.0": {
          "rap": "24,500",
          "low_price": "23,400",
          "high_price": "50,700"
        },
        "2.1": {
          "rap": "24,500",
          "low_price": "24,570",
          "high_price": "53,235"
        },
        "2.2": {
          "rap": "24,500",
          "low_price": "25,740",
          "high_price": "55,770"
        },
        "2.3": {
          "rap": "24,500",
          "low_price": "26,910",
          "high_price": "58,305"
        },
        "2.4": {
          "rap": "24,500",
          "low_price": "28,080",
          "high_price": "60,840"
        },
        "2.5": {
          "rap": "24,500",
          "low_price": "29,250",
          "high_price": "63,375"
        },
        "2.6": {
          "rap": "24,500",
          "low_price": "30,420",
          "high_price": "65,910"
        },
        "2.7": {
          "rap": "24,500",
          "low_price": "31,590",
          "high_price": "68,445"
        },
        "2.8": {
          "rap": "24,500",
          "low_price": "32,760",
          "high_price": "70,980"
        },
        "2.9": {
          "rap": "24,500",
          "low_price": "33,930",
          "high_price": "73,515"
        },
        "3.0": {
          "rap": "37,000",
          "low_price": "60,300",
          "high_price": "130,650"
        },
        "3.1": {
          "rap": "37,000",
          "low_price": "62,310",
          "high_price": "135,005"
        },
        "3.2": {
          "rap": "37,000",
          "low_price": "64,320",
          "high_price": "139,360"
        },
        "3.3": {
          "rap": "37,000",
          "low_price": "66,330",
          "high_price": "143,715"
        },
        "3.4": {
          "rap": "37,000",
          "low_price": "68,340",
          "high_price": "148,070"
        },
        "3.5": {
          "rap": "37,000",
          "low_price": "70,350",
          "high_price": "152,425"
        },
        "3.6": {
          "rap": "37,000",
          "low_price": "72,360",
          "high_price": "156,780"
        },
        "3.7": {
          "rap": "37,000",
          "low_price": "74,370",
          "high_price": "161,135"
        },
        "3.8": {
          "rap": "37,000",
          "low_price": "76,380",
          "high_price": "165,490"
        },
        "3.9": {
          "rap": "37,000",
          "low_price": "78,390",
          "high_price": "169,845"
        }
      },
      "G": {
        "0.4": {
          "rap": "2,800",
          "low_price": "455",
          "high_price": "990"
        },
        "0.5": {
          "rap": "3,900",
          "low_price": "750",
          "high_price": "1,625"
        },
        "0.6": {
          "rap": "3,900",
          "low_price": "900",
          "high_price": "1,950"
        },
        "0.7": {
          "rap": "5,400",
          "low_price": "1,430",
          "high_price": "3,095"
        },
        "0.8": {
          "rap": "5,400",
          "low_price": "1,630",
          "high_price": "3,535"
        },
        "0.9": {
          "rap": "8,000",
          "low_price": "2,645",
          "high_price": "5,735"
        },
        "1.0": {
          "rap": "11,000",
          "low_price": "4,020",
          "high_price": "8,710"
        },
        "1.1": {
          "rap": "11,000",
          "low_price": "4,420",
          "high_price": "9,580"
        },
        "1.2": {
          "rap": "11,000",
          "low_price": "4,825",
          "high_price": "10,450"
        },
        "1.3": {
          "rap": "11,000",
          "low_price": "5,225",
          "high_price": "11,325"
        },
        "1.4": {
          "rap": "11,000",
          "low_price": "5,630",
          "high_price": "12,195"
        },
        "1.5": {
          "rap": "14,600",
          "low_price": "10,260",
          "high_price": "22,230"
        },
        "1.6": {
          "rap": "14,600",
          "low_price": "10,945",
          "high_price": "23,710"
        },
        "1.7": {
          "rap": "14,600",
          "low_price": "11,630",
          "high_price": "25,195"
        },
        "1.8": {
          "rap": "14,600",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "1.9": {
          "rap": "14,600",
          "low_price": "12,995",
          "high_price": "28,160"
        },
        "2.0": {
          "rap": "21,000",
          "low_price": "19,800",
          "high_price": "42,900"
        },
        "2.1": {
          "rap": "21,000",
          "low_price": "20,790",
          "high_price": "45,045"
        },
        "2.2": {
          "rap": "21,000",
          "low_price": "21,780",
          "high_price": "47,190"
        },
        "2.3": {
          "rap": "21,000",
          "low_price": "22,770",
          "high_price": "49,335"
        },
        "2.4": {
          "rap": "21,000",
          "low_price": "23,760",
          "high_price": "51,480"
        },
        "2.5": {
          "rap": "21,000",
          "low_price": "24,750",
          "high_price": "53,625"
        },
        "2.6": {
          "rap": "21,000",
          "low_price": "25,740",
          "high_price": "55,770"
        },
        "2.7": {
          "rap": "21,000",
          "low_price": "26,730",
          "high_price": "57,915"
        },
        "2.8": {
          "rap": "21,000",
          "low_price": "27,720",
          "high_price": "60,060"
        },
        "2.9": {
          "rap": "21,000",
          "low_price": "28,710",
          "high_price": "62,205"
        },
        "3.0": {
          "rap": "31,500",
          "low_price": "50,400",
          "high_price": "109,200"
        },
        "3.1": {
          "rap": "31,500",
          "low_price": "52,080",
          "high_price": "112,840"
        },
        "3.2": {
          "rap": "31,500",
          "low_price": "53,760",
          "high_price": "116,480"
        },
        "3.3": {
          "rap": "31,500",
          "low_price": "55,440",
          "high_price": "120,120"
        },
        "3.4": {
          "rap": "31,500",
          "low_price": "57,120",
          "high_price": "123,760"
        },
        "3.5": {
          "rap": "31,500",
          "low_price": "58,800",
          "high_price": "127,400"
        },
        "3.6": {
          "rap": "31,500",
          "low_price": "60,480",
          "high_price": "131,040"
        },
        "3.7": {
          "rap": "31,500",
          "low_price": "62,160",
          "high_price": "134,680"
        },
        "3.8": {
          "rap": "31,500",
          "low_price": "63,840",
          "high_price": "138,320"
        },
        "3.9": {
          "rap": "31,500",
          "low_price": "65,520",
          "high_price": "141,960"
        }
      },
      "H": {
        "0.4": {
          "rap": "2,500",
          "low_price": "410",
          "high_price": "885"
        },
        "0.5": {
          "rap": "3,700",
          "low_price": "660",
          "high_price": "1,430"
        },
        "0.6": {
          "rap": "3,700",
          "low_price": "790",
          "high_price": "1,715"
        },
        "0.7": {
          "rap": "4,900",
          "low_price": "1,175",
          "high_price": "2,550"
        },
        "0.8": {
          "rap": "4,900",
          "low_price": "1,345",
          "high_price": "2,910"
        },
        "0.9": {
          "rap": "7,100",
          "low_price": "2,270",
          "high_price": "4,915"
        },
        "1.0": {
          "rap": "9,500",
          "low_price": "3,120",
          "high_price": "6,760"
        },
        "1.1": {
          "rap": "9,500",
          "low_price": "3,430",
          "high_price": "7,435"
        },
        "1.2": {
          "rap": "9,500",
          "low_price": "3,745",
          "high_price": "8,110"
        },
        "1.3": {
          "rap": "9,500",
          "low_price": "4,055",
          "high_price": "8,790"
        },
        "1.4": {
          "rap": "9,500",
          "low_price": "4,370",
          "high_price": "9,465"
        },
        "1.5": {
          "rap": "12,500",
          "low_price": "8,190",
          "high_price": "17,745"
        },
        "1.6": {
          "rap": "12,500",
          "low_price": "8,735",
          "high_price": "18,930"
        },
        "1.7": {
          "rap": "12,500",
          "low_price": "9,280",
          "high_price": "20,110"
        },
        "1.8": {
          "rap": "12,500",
          "low_price": "9,830",
          "high_price": "21,295"
        },
        "1.9": {
          "rap": "12,500",
          "low_price": "10,375",
          "high_price": "22,475"
        },
        "2.0": {
          "rap": "18,000",
          "low_price": "16,200",
          "high_price": "35,100"
        },
        "2.1": {
          "rap": "18,000",
          "low_price": "17,010",
          "high_price": "36,855"
        },
        "2.2": {
          "rap": "18,000",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.3": {
          "rap": "18,000",
          "low_price": "18,630",
          "high_price": "40,365"
        },
        "2.4": {
          "rap": "18,000",
          "low_price": "19,440",
          "high_price": "42,120"
        },
        "2.5": {
          "rap": "18,000",
          "low_price": "20,250",
          "high_price": "43,875"
        },
        "2.6": {
          "rap": "18,000",
          "low_price": "21,060",
          "high_price": "45,630"
        },
        "2.7": {
          "rap": "18,000",
          "low_price": "21,870",
          "high_price": "47,385"
        },
        "2.8": {
          "rap": "18,000",
          "low_price": "22,680",
          "high_price": "49,140"
        },
        "2.9": {
          "rap": "18,000",
          "low_price": "23,490",
          "high_price": "50,895"
        },
        "3.0": {
          "rap": "25,500",
          "low_price": "40,500",
          "high_price": "87,750"
        },
        "3.1": {
          "rap": "25,500",
          "low_price": "41,850",
          "high_price": "90,675"
        },
        "3.2": {
          "rap": "25,500",
          "low_price": "43,200",
          "high_price": "93,600"
        },
        "3.3": {
          "rap": "25,500",
          "low_price": "44,550",
          "high_price": "96,525"
        },
        "3.4": {
          "rap": "25,500",
          "low_price": "45,900",
          "high_price": "99,450"
        },
        "3.5": {
          "rap": "25,500",
          "low_price": "47,250",
          "high_price": "102,375"
        },
        "3.6": {
          "rap": "25,500",
          "low_price": "48,600",
          "high_price": "105,300"
        },
        "3.7": {
          "rap": "25,500",
          "low_price": "49,950",
          "high_price": "108,225"
        },
        "3.8": {
          "rap": "25,500",
          "low_price": "51,300",
          "high_price": "111,150"
        },
        "3.9": {
          "rap": "25,500",
          "low_price": "52,650",
          "high_price": "114,075"
        }
      },
      "I": {
        "0.4": {
          "rap": "2,200",
          "low_price": "360",
          "high_price": "780"
        },
        "0.5": {
          "rap": "3,100",
          "low_price": "570",
          "high_price": "1,235"
        },
        "0.6": {
          "rap": "3,100",
          "low_price": "685",
          "high_price": "1,480"
        },
        "0.7": {
          "rap": "4,100",
          "low_price": "1,010",
          "high_price": "2,185"
        },
        "0.8": {
          "rap": "4,100",
          "low_price": "1,150",
          "high_price": "2,495"
        },
        "0.9": {
          "rap": "6,100",
          "low_price": "2,000",
          "high_price": "4,330"
        },
        "1.0": {
          "rap": "7,900",
          "low_price": "2,640",
          "high_price": "5,720"
        },
        "1.1": {
          "rap": "7,900",
          "low_price": "2,905",
          "high_price": "6,290"
        },
        "1.2": {
          "rap": "7,900",
          "low_price": "3,170",
          "high_price": "6,865"
        },
        "1.3": {
          "rap": "7,900",
          "low_price": "3,430",
          "high_price": "7,435"
        },
        "1.4": {
          "rap": "7,900",
          "low_price": "3,695",
          "high_price": "8,010"
        },
        "1.5": {
          "rap": "10,500",
          "low_price": "6,570",
          "high_price": "14,235"
        },
        "1.6": {
          "rap": "10,500",
          "low_price": "7,010",
          "high_price": "15,185"
        },
        "1.7": {
          "rap": "10,500",
          "low_price": "7,445",
          "high_price": "16,135"
        },
        "1.8": {
          "rap": "10,500",
          "low_price": "7,885",
          "high_price": "17,080"
        },
        "1.9": {
          "rap": "10,500",
          "low_price": "8,320",
          "high_price": "18,030"
        },
        "2.0": {
          "rap": "14,500",
          "low_price": "13,200",
          "high_price": "28,600"
        },
        "2.1": {
          "rap": "14,500",
          "low_price": "13,860",
          "high_price": "30,030"
        },
        "2.2": {
          "rap": "14,500",
          "low_price": "14,520",
          "high_price": "31,460"
        },
        "2.3": {
          "rap": "14,500",
          "low_price": "15,180",
          "high_price": "32,890"
        },
        "2.4": {
          "rap": "14,500",
          "low_price": "15,840",
          "high_price": "34,320"
        },
        "2.5": {
          "rap": "14,500",
          "low_price": "16,500",
          "high_price": "35,750"
        },
        "2.6": {
          "rap": "14,500",
          "low_price": "17,160",
          "high_price": "37,180"
        },
        "2.7": {
          "rap": "14,500",
          "low_price": "17,820",
          "high_price": "38,610"
        },
        "2.8": {
          "rap": "14,500",
          "low_price": "18,480",
          "high_price": "40,040"
        },
        "2.9": {
          "rap": "14,500",
          "low_price": "19,140",
          "high_price": "41,470"
        },
        "3.0": {
          "rap": "21,000",
          "low_price": "34,200",
          "high_price": "74,100"
        },
        "3.1": {
          "rap": "21,000",
          "low_price": "35,340",
          "high_price": "76,570"
        },
        "3.2": {
          "rap": "21,000",
          "low_price": "36,480",
          "high_price": "79,040"
        },
        "3.3": {
          "rap": "21,000",
          "low_price": "37,620",
          "high_price": "81,510"
        },
        "3.4": {
          "rap": "21,000",
          "low_price": "38,760",
          "high_price": "83,980"
        },
        "3.5": {
          "rap": "21,000",
          "low_price": "39,900",
          "high_price": "86,450"
        },
        "3.6": {
          "rap": "21,000",
          "low_price": "41,040",
          "high_price": "88,920"
        },
        "3.7": {
          "rap": "21,000",
          "low_price": "42,180",
          "high_price": "91,390"
        },
        "3.8": {
          "rap": "21,000",
          "low_price": "43,320",
          "high_price": "93,860"
        },
        "3.9": {
          "rap": "21,000",
          "low_price": "44,460",
          "high_price": "96,330"
        }
      },
      "J": {
        "0.4": {
          "rap": "1,900",
          "low_price": "310",
          "high_price": "675"
        },
        "0.5": {
          "rap": "2,500",
          "low_price": "480",
          "high_price": "1,040"
        },
        "0.6": {
          "rap": "2,500",
          "low_price": "575",
          "high_price": "1,250"
        },
        "0.7": {
          "rap": "3,400",
          "low_price": "840",
          "high_price": "1,820"
        },
        "0.8": {
          "rap": "3,400",
          "low_price": "960",
          "high_price": "2,080"
        },
        "0.9": {
          "rap": "5,200",
          "low_price": "1,675",
          "high_price": "3,625"
        },
        "1.0": {
          "rap": "6,400",
          "low_price": "2,160",
          "high_price": "4,680"
        },
        "1.1": {
          "rap": "6,400",
          "low_price": "2,375",
          "high_price": "5,150"
        },
        "1.2": {
          "rap": "6,400",
          "low_price": "2,590",
          "high_price": "5,615"
        },
        "1.3": {
          "rap": "6,400",
          "low_price": "2,810",
          "high_price": "6,085"
        },
        "1.4": {
          "rap": "6,400",
          "low_price": "3,025",
          "high_price": "6,550"
        },
        "1.5": {
          "rap": "8,900",
          "low_price": "5,490",
          "high_price": "11,895"
        },
        "1.6": {
          "rap": "8,900",
          "low_price": "5,855",
          "high_price": "12,690"
        },
        "1.7": {
          "rap": "8,900",
          "low_price": "6,220",
          "high_price": "13,480"
        },
        "1.8": {
          "rap": "8,900",
          "low_price": "6,590",
          "high_price": "14,275"
        },
        "1.9": {
          "rap": "8,900",
          "low_price": "6,955",
          "high_price": "15,065"
        },
        "2.0": {
          "rap": "12,000",
          "low_price": "10,920",
          "high_price": "23,660"
        },
        "2.1": {
          "rap": "12,000",
          "low_price": "11,465",
          "high_price": "24,845"
        },
        "2.2": {
          "rap": "12,000",
          "low_price": "12,010",
          "high_price": "26,025"
        },
        "2.3": {
          "rap": "12,000",
          "low_price": "12,560",
          "high_price": "27,210"
        },
        "2.4": {
          "rap": "12,000",
          "low_price": "13,105",
          "high_price": "28,390"
        },
        "2.5": {
          "rap": "12,000",
          "low_price": "13,650",
          "high_price": "29,575"
        },
        "2.6": {
          "rap": "12,000",
          "low_price": "14,195",
          "high_price": "30,760"
        },
        "2.7": {
          "rap": "12,000",
          "low_price": "14,740",
          "high_price": "31,940"
        },
        "2.8": {
          "rap": "12,000",
          "low_price": "15,290",
          "high_price": "33,125"
        },
        "2.9": {
          "rap": "12,000",
          "low_price": "15,835",
          "high_price": "34,305"
        },
        "3.0": {
          "rap": "17,000",
          "low_price": "27,000",
          "high_price": "58,500"
        },
        "3.1": {
          "rap": "17,000",
          "low_price": "27,900",
          "high_price": "60,450"
        },
        "3.2": {
          "rap": "17,000",
          "low_price": "28,800",
          "high_price": "62,400"
        },
        "3.3": {
          "rap": "17,000",
          "low_price": "29,700",
          "high_price": "64,350"
        },
        "3.4": {
          "rap": "17,000",
          "low_price": "30,600",
          "high_price": "66,300"
        },
        "3.5": {
          "rap": "17,000",
          "low_price": "31,500",
          "high_price": "68,250"
        },
        "3.6": {
          "rap": "17,000",
          "low_price": "32,400",
          "high_price": "70,200"
        },
        "3.7": {
          "rap": "17,000",
          "low_price": "33,300",
          "high_price": "72,150"
        },
        "3.8": {
          "rap": "17,000",
          "low_price": "34,200",
          "high_price": "74,100"
        },
        "3.9": {
          "rap": "17,000",
          "low_price": "35,100",
          "high_price": "76,050"
        }
      },
      "K": {
        "0.4": {
          "rap": "1,700",
          "low_price": "290",
          "high_price": "625"
        },
        "0.5": {
          "rap": "2,100",
          "low_price": "420",
          "high_price": "910"
        },
        "0.6": {
          "rap": "2,100",
          "low_price": "505",
          "high_price": "1,090"
        },
        "0.7": {
          "rap": "2,800",
          "low_price": "755",
          "high_price": "1,640"
        },
        "0.8": {
          "rap": "2,800",
          "low_price": "865",
          "high_price": "1,870"
        },
        "0.9": {
          "rap": "4,300",
          "low_price": "1,510",
          "high_price": "3,275"
        },
        "1.0": {
          "rap": "5,200",
          "low_price": "1,860",
          "high_price": "4,030"
        },
        "1.1": {
          "rap": "5,200",
          "low_price": "2,045",
          "high_price": "4,435"
        },
        "1.2": {
          "rap": "5,200",
          "low_price": "2,230",
          "high_price": "4,835"
        },
        "1.3": {
          "rap": "5,200",
          "low_price": "2,420",
          "high_price": "5,240"
        },
        "1.4": {
          "rap": "5,200",
          "low_price": "2,605",
          "high_price": "5,640"
        },
        "1.5": {
          "rap": "7,400",
          "low_price": "4,590",
          "high_price": "9,945"
        },
        "1.6": {
          "rap": "7,400",
          "low_price": "4,895",
          "high_price": "10,610"
        },
        "1.7": {
          "rap": "7,400",
          "low_price": "5,200",
          "high_price": "11,270"
        },
        "1.8": {
          "rap": "7,400",
          "low_price": "5,510",
          "high_price": "11,935"
        },
        "1.9": {
          "rap": "7,400",
          "low_price": "5,815",
          "high_price": "12,595"
        },
        "2.0": {
          "rap": "9,900",
          "low_price": "9,120",
          "high_price": "19,760"
        },
        "2.1": {
          "rap": "9,900",
          "low_price": "9,575",
          "high_price": "20,750"
        },
        "2.2": {
          "rap": "9,900",
          "low_price": "10,030",
          "high_price": "21,735"
        },
        "2.3": {
          "rap": "9,900",
          "low_price": "10,490",
          "high_price": "22,725"
        },
        "2.4": {
          "rap": "9,900",
          "low_price": "10,945",
          "high_price": "23,710"
        },
        "2.5": {
          "rap": "9,900",
          "low_price": "11,400",
          "high_price": "24,700"
        },
        "2.6": {
          "rap": "9,900",
          "low_price": "11,855",
          "high_price": "25,690"
        },
        "2.7": {
          "rap": "9,900",
          "low_price": "12,310",
          "high_price": "26,675"
        },
        "2.8": {
          "rap": "9,900",
          "low_price": "12,770",
          "high_price": "27,665"
        },
        "2.9": {
          "rap": "9,900",
          "low_price": "13,225",
          "high_price": "28,650"
        },
        "3.0": {
          "rap": "14,000",
          "low_price": "22,500",
          "high_price": "48,750"
        },
        "3.1": {
          "rap": "14,000",
          "low_price": "23,250",
          "high_price": "50,375"
        },
        "3.2": {
          "rap": "14,000",
          "low_price": "24,000",
          "high_price": "52,000"
        },
        "3.3": {
          "rap": "14,000",
          "low_price": "24,750",
          "high_price": "53,625"
        },
        "3.4": {
          "rap": "14,000",
          "low_price": "25,500",
          "high_price": "55,250"
        },
        "3.5": {
          "rap": "14,000",
          "low_price": "26,250",
          "high_price": "56,875"
        },
        "3.6": {
          "rap": "14,000",
          "low_price": "27,000",
          "high_price": "58,500"
        },
        "3.7": {
          "rap": "14,000",
          "low_price": "27,750",
          "high_price": "60,125"
        },
        "3.8": {
          "rap": "14,000",
          "low_price": "28,500",
          "high_price": "61,750"
        },
        "3.9": {
          "rap": "14,000",
          "low_price": "29,250",
          "high_price": "63,375"
        }
      }
    }
  }
}